import { getQueryStringDict, isCookieEnabled, isLocalStorageAvailable, getSourceQueryString, getSourceCookie, pickDomAttributes, truncateString, mediaQueries } from '@bgea-js/react-utilities';
import { CommunicationType, useGetBRBInfo, EntityType, AddressType, Templates, getAvailableOptions, trackEvent, isValidDate, calculateStartDate, hasRecurringPaymentType, removeCartEvent, addCartEvent, updateCheckoutEvent, addItemToCart, beginCheckoutEvent, getProjectDescription, useCreateLogging, getSiteUrl, hasPayment, shouldEnableButton, getAvailabilityChargeDates, convertOptionsToList, getAvailabilityChargeMonths, updateCartInfo, updateRecurringPayment, updateSelectedProject, handleCheckoutComponentDidMount, Language, FluentLanguageValue, DDCLANG, deepFind, useUser, useGetDmagSubscriptions, formatUSCurrency, useGetDmagNonDiscountSubscriptions, calculateDiscount, CountryRegion, RelationshipType, ResponseStatus, validateEchoPhoneNumber, trackDonationFunnel, confirmationChoiceEvent, Analytics, useGetSession, useGetPing, getErrorMessage, VogonStatus, useGetStellofyToken, validateZipPostalCode, Countries, userChoiceEvent, qualifyingGiftEvent, selectedForAskEvent, useGetCoursesDiscountPrice, useGetCoursesProducts, calculateTotalPrice, getValidDate, getFormattedStartDate, ordinalSuffix, useCreateUpgradeDonation, FormErrorScreens, FormLoading, FormProvider, PledgeAmounts, DonationCart, Name as Name$1, Checkbox, Address, InputEmail, InputPhone, TextArea, InputText, Dropdown, SubmitButton, DateCalendar, RadioGroup, EntityFields, Church, validateAcknowledgement, Currency, PaymentMethod, RecaptchaMessage, CustomMarkupSection, validateObject, CountryPostal, Country, SingleGift, Acknowledgement, InputNumber, validateNumber, validateString, Region, useFormatAddress, FileUpload, InputTime, MultiSelect } from '@bgea-js/bg-forms';
import _styled from '@emotion/styled/base';
import { QueryClient, QueryClientProvider } from 'react-query';
import { useTranslation, I18nextProvider } from 'react-i18next';
import { i18next } from '@bgea-js/translations';
import { jsxs, Fragment, jsx } from '@emotion/react/jsx-runtime';
import { useEffect, useState, useRef, useMemo } from 'react';
import { useFormikContext, FieldArray } from 'formik';
import { Heading, Block, Columns, Button, Container as Container$1, Content, Notification, Icon, Table, Form, Tag, Modal, Box, Image, Loader } from '@bgea-js/react-ui';
import { createElement } from '@emotion/react';
import { useLocalStorage } from '@bgea-js/react-hooks';
import { SpinnerIcon, CheckIcon, PlusIcon, MinusIcon } from '@bgea-js/react-icons';
import * as colors from '@bgea-js/colors';

function _iterableToArrayLimit(arr, i) {
  var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"];
  if (null != _i) {
    var _s,
      _e,
      _x,
      _r,
      _arr = [],
      _n = !0,
      _d = !1;
    try {
      if (_x = (_i = _i.call(arr)).next, 0 === i) {
        if (Object(_i) !== _i) return;
        _n = !1;
      } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0);
    } catch (err) {
      _d = !0, _e = err;
    } finally {
      try {
        if (!_n && null != _i.return && (_r = _i.return(), Object(_r) !== _r)) return;
      } finally {
        if (_d) throw _e;
      }
    }
    return _arr;
  }
}
function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);
  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    enumerableOnly && (symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    })), keys.push.apply(keys, symbols);
  }
  return keys;
}
function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = null != arguments[i] ? arguments[i] : {};
    i % 2 ? ownKeys(Object(source), !0).forEach(function (key) {
      _defineProperty(target, key, source[key]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) {
      Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
    });
  }
  return target;
}
function _regeneratorRuntime() {
  _regeneratorRuntime = function () {
    return exports;
  };
  var exports = {},
    Op = Object.prototype,
    hasOwn = Op.hasOwnProperty,
    defineProperty = Object.defineProperty || function (obj, key, desc) {
      obj[key] = desc.value;
    },
    $Symbol = "function" == typeof Symbol ? Symbol : {},
    iteratorSymbol = $Symbol.iterator || "@@iterator",
    asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator",
    toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";
  function define(obj, key, value) {
    return Object.defineProperty(obj, key, {
      value: value,
      enumerable: !0,
      configurable: !0,
      writable: !0
    }), obj[key];
  }
  try {
    define({}, "");
  } catch (err) {
    define = function (obj, key, value) {
      return obj[key] = value;
    };
  }
  function wrap(innerFn, outerFn, self, tryLocsList) {
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator,
      generator = Object.create(protoGenerator.prototype),
      context = new Context(tryLocsList || []);
    return defineProperty(generator, "_invoke", {
      value: makeInvokeMethod(innerFn, self, context)
    }), generator;
  }
  function tryCatch(fn, obj, arg) {
    try {
      return {
        type: "normal",
        arg: fn.call(obj, arg)
      };
    } catch (err) {
      return {
        type: "throw",
        arg: err
      };
    }
  }
  exports.wrap = wrap;
  var ContinueSentinel = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  var IteratorPrototype = {};
  define(IteratorPrototype, iteratorSymbol, function () {
    return this;
  });
  var getProto = Object.getPrototypeOf,
    NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype);
  var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype);
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function (method) {
      define(prototype, method, function (arg) {
        return this._invoke(method, arg);
      });
    });
  }
  function AsyncIterator(generator, PromiseImpl) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if ("throw" !== record.type) {
        var result = record.arg,
          value = result.value;
        return value && "object" == typeof value && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) {
          invoke("next", value, resolve, reject);
        }, function (err) {
          invoke("throw", err, resolve, reject);
        }) : PromiseImpl.resolve(value).then(function (unwrapped) {
          result.value = unwrapped, resolve(result);
        }, function (error) {
          return invoke("throw", error, resolve, reject);
        });
      }
      reject(record.arg);
    }
    var previousPromise;
    defineProperty(this, "_invoke", {
      value: function (method, arg) {
        function callInvokeWithMethodAndArg() {
          return new PromiseImpl(function (resolve, reject) {
            invoke(method, arg, resolve, reject);
          });
        }
        return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg();
      }
    });
  }
  function makeInvokeMethod(innerFn, self, context) {
    var state = "suspendedStart";
    return function (method, arg) {
      if ("executing" === state) throw new Error("Generator is already running");
      if ("completed" === state) {
        if ("throw" === method) throw arg;
        return {
          value: void 0,
          done: !0
        };
      }
      for (context.method = method, context.arg = arg;;) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }
        if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) {
          if ("suspendedStart" === state) throw state = "completed", context.arg;
          context.dispatchException(context.arg);
        } else "return" === context.method && context.abrupt("return", context.arg);
        state = "executing";
        var record = tryCatch(innerFn, self, context);
        if ("normal" === record.type) {
          if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue;
          return {
            value: record.arg,
            done: context.done
          };
        }
        "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg);
      }
    };
  }
  function maybeInvokeDelegate(delegate, context) {
    var methodName = context.method,
      method = delegate.iterator[methodName];
    if (undefined === method) return context.delegate = null, "throw" === methodName && delegate.iterator.return && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method) || "return" !== methodName && (context.method = "throw", context.arg = new TypeError("The iterator does not provide a '" + methodName + "' method")), ContinueSentinel;
    var record = tryCatch(method, delegate.iterator, context.arg);
    if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel;
    var info = record.arg;
    return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel);
  }
  function pushTryEntry(locs) {
    var entry = {
      tryLoc: locs[0]
    };
    1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry);
  }
  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal", delete record.arg, entry.completion = record;
  }
  function Context(tryLocsList) {
    this.tryEntries = [{
      tryLoc: "root"
    }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0);
  }
  function values(iterable) {
    if (iterable || "" === iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) return iteratorMethod.call(iterable);
      if ("function" == typeof iterable.next) return iterable;
      if (!isNaN(iterable.length)) {
        var i = -1,
          next = function next() {
            for (; ++i < iterable.length;) if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next;
            return next.value = undefined, next.done = !0, next;
          };
        return next.next = next;
      }
    }
    throw new TypeError(typeof iterable + " is not iterable");
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", {
    value: GeneratorFunctionPrototype,
    configurable: !0
  }), defineProperty(GeneratorFunctionPrototype, "constructor", {
    value: GeneratorFunction,
    configurable: !0
  }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) {
    var ctor = "function" == typeof genFun && genFun.constructor;
    return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name));
  }, exports.mark = function (genFun) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun;
  }, exports.awrap = function (arg) {
    return {
      __await: arg
    };
  }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () {
    return this;
  }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) {
    void 0 === PromiseImpl && (PromiseImpl = Promise);
    var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl);
    return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) {
      return result.done ? result.value : iter.next();
    });
  }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () {
    return this;
  }), define(Gp, "toString", function () {
    return "[object Generator]";
  }), exports.keys = function (val) {
    var object = Object(val),
      keys = [];
    for (var key in object) keys.push(key);
    return keys.reverse(), function next() {
      for (; keys.length;) {
        var key = keys.pop();
        if (key in object) return next.value = key, next.done = !1, next;
      }
      return next.done = !0, next;
    };
  }, exports.values = values, Context.prototype = {
    constructor: Context,
    reset: function (skipTempReset) {
      if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined);
    },
    stop: function () {
      this.done = !0;
      var rootRecord = this.tryEntries[0].completion;
      if ("throw" === rootRecord.type) throw rootRecord.arg;
      return this.rval;
    },
    dispatchException: function (exception) {
      if (this.done) throw exception;
      var context = this;
      function handle(loc, caught) {
        return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught;
      }
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i],
          record = entry.completion;
        if ("root" === entry.tryLoc) return handle("end");
        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc"),
            hasFinally = hasOwn.call(entry, "finallyLoc");
          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0);
          } else {
            if (!hasFinally) throw new Error("try statement without catch or finally");
            if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc);
          }
        }
      }
    },
    abrupt: function (type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }
      finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null);
      var record = finallyEntry ? finallyEntry.completion : {};
      return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record);
    },
    complete: function (record, afterLoc) {
      if ("throw" === record.type) throw record.arg;
      return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel;
    },
    finish: function (finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel;
      }
    },
    catch: function (tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if ("throw" === record.type) {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }
      throw new Error("illegal catch attempt");
    },
    delegateYield: function (iterable, resultName, nextLoc) {
      return this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      }, "next" === this.method && (this.arg = undefined), ContinueSentinel;
    }
  }, exports;
}
function _typeof(obj) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
    return typeof obj;
  } : function (obj) {
    return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
  }, _typeof(obj);
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }
  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}
function _asyncToGenerator(fn) {
  return function () {
    var self = this,
      args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);
      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }
      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }
      _next(undefined);
    });
  };
}
function _defineProperty(obj, key, value) {
  key = _toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
function _objectDestructuringEmpty(obj) {
  if (obj == null) throw new TypeError("Cannot destructure " + obj);
}
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = _objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}
function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread();
}
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return _arrayLikeToArray(arr);
}
function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}
function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}
function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _toPrimitive(input, hint) {
  if (typeof input !== "object" || input === null) return input;
  var prim = input[Symbol.toPrimitive];
  if (prim !== undefined) {
    var res = prim.call(input, hint || "default");
    if (typeof res !== "object") return res;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return (hint === "string" ? String : Number)(input);
}
function _toPropertyKey(arg) {
  var key = _toPrimitive(arg, "string");
  return typeof key === "symbol" ? key : String(key);
}

var queryClient = new QueryClient();

var _excluded$X = ["ageGroup", "eventId"];
var useAgeGroup = function useAgeGroup(_ref) {
  var _values$collector, _values$collector$ent, _values$collector$ent2, _values$collector2, _values$collector2$en, _values$collector2$en2, _values$formLogic, _values$formLogic2, _values$formLogic3, _values$formLogic6;
  var ageGroup = _ref.ageGroup,
    eventId = _ref.eventId,
    props = _objectWithoutProperties(_ref, _excluded$X);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var resetCodeArr = (values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.value) !== (props === null || props === void 0 ? void 0 : props.under18EmailCode);
  })) || [];
  var code = ((_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.code) === null || _values$collector2$en2 === void 0 ? void 0 : _values$collector2$en2.filter(function (c) {
    return c.key !== 'NAMETYPE';
  })) || [];
  var isUnder18 = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.ageGroup) === '8' || (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.ageGroup) === '9';
  var isOver18 = (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.ageGroup) === '1';
  useEffect(function () {
    var _values$formLogic4, _values$formLogic5;
    switch (parseInt((_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.ageGroup, 10)) {
      case 8:
      case 9:
        code.push({
          key: 'NAMETYPE',
          value: (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : _values$formLogic5.ageGroup
        });
        break;
    }
    var newCodes = Array.from(new Set([].concat(_toConsumableArray(resetCodeArr), _toConsumableArray(code))));
    if (isUnder18 && props !== null && props !== void 0 && props.under18EmailCode) {
      setFieldValue('collector.entity[0].code', [].concat(newCodes, [{
        key: "CRUSADE:".concat(eventId),
        value: props === null || props === void 0 ? void 0 : props.under18EmailCode
      }]));
    } else if (isOver18 && props !== null && props !== void 0 && props.under18EmailCode) {
      var _values$collector3, _values$collector3$en, _values$collector3$en2;
      var filteredNewCodes = (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.code) === null || _values$collector3$en2 === void 0 ? void 0 : _values$collector3$en2.filter(function (c) {
        return c.key !== 'NAMETYPE';
      }).filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.value) !== (props === null || props === void 0 ? void 0 : props.under18EmailCode);
      });
      setFieldValue('collector.entity[0].code', _toConsumableArray(filteredNewCodes));
    } else {
      setFieldValue("collector.entity[0].code", code);
    }
    setFieldValue("collector.entity[0].over18", isOver18);
  }, [(_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : _values$formLogic6.ageGroup]);
  useEffect(function () {
    if (ageGroup !== null && ageGroup !== void 0 && ageGroup.length) {
      setFieldValue('formLogic.ageGroup', '');
    }
  }, []);
  return {
    values: values
  };
};

/* eslint-disable @typescript-eslint/no-var-requires */
var pkg$1 = require('../../package.json');
var getFormId = function getFormId(templateName) {
  var packageVersion = pkg$1.version;
  var pkgVersion = packageVersion || "1.0.679" || '0.0.0';
  return "@bgea-js/form-templates:".concat(pkgVersion, "/").concat(templateName);
};
var setFormId = function setFormId(_ref) {
  var _values$formLogic;
  var templateName = _ref.templateName,
    setFieldValue = _ref.setFieldValue,
    values = _ref.values;
  var packageVersion = pkg$1.version;
  var pkgVersion = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.pkgVersion) || packageVersion || "1.0.679";
  var formID = "@bgea-js/form-templates:".concat(pkgVersion, "/").concat(templateName);
  setFieldValue('collector.formID', formID);
  setFieldValue('formLogic.templateName', templateName);
};

var attrLangEsValue = '1438';
var attrLangEnValue = '1437';
var kitEnProductId = 'DAVKFT24';
var kitEsProductId = 'DAVKFT24';
var communicationResearchType = CommunicationType.Resrelwvy;
var communicationReferenceType = CommunicationType.Volpasref;
var communicationLegalGuardianType = CommunicationType.Volrelwvy;
var cities = {
  TXBR: {
    label: 'Brownsville, TX – Feb. 24, 2024',
    crusadeCodeEventId: 123,
    SECodeEventId: 'TXBR'
  },
  TXMA: {
    label: 'McAllen, TX – Feb. 25, 2024',
    crusadeCodeEventId: 124,
    SECodeEventId: 'TXMA'
  },
  TXLR: {
    label: 'Laredo, TX – Feb. 27, 2024',
    crusadeCodeEventId: 125,
    SECodeEventId: 'TXLR'
  },
  TXEG: {
    label: 'Eagle Pass, TX – Feb. 28, 2024',
    crusadeCodeEventId: 133,
    SECodeEventId: 'TXEG'
  },
  TXDR: {
    label: 'Del Rio, TX – Feb. 29, 2024',
    crusadeCodeEventId: 126,
    SECodeEventId: 'TXDR'
  },
  TXPR: {
    label: 'Presidio, TX – March 2, 2024',
    crusadeCodeEventId: 132,
    SECodeEventId: 'TXPR'
  },
  TXEP: {
    label: 'El Paso, TX – March 3, 2024',
    crusadeCodeEventId: 127,
    SECodeEventId: 'TXEP'
  },
  AZTC: {
    label: 'Tucson, AZ – March 5, 2024',
    crusadeCodeEventId: 128,
    SECodeEventId: 'AZTC'
  },
  AZYM: {
    label: 'Yuma, AZ – March 7, 2024',
    crusadeCodeEventId: 130,
    SECodeEventId: 'AZYM'
  },
  CASD: {
    label: 'Chula Vista, CA – March 9, 2024',
    crusadeCodeEventId: 131,
    SECodeEventId: 'CASD'
  }
};
var citiesES = {
  TXBR: {
    label: 'Brownsville, TX - 24 de febrero de 2024',
    crusadeCodeEventId: 123,
    SECodeEventId: 'TXBR'
  },
  TXMA: {
    label: 'McAllen, TX - 25 de febrero de 2024',
    crusadeCodeEventId: 124,
    SECodeEventId: 'TXMA'
  },
  TXLR: {
    label: 'Laredo, TX - 27 de febrero de 2024',
    crusadeCodeEventId: 125,
    SECodeEventId: 'TXLR'
  },
  TXEG: {
    label: 'Eagle Pass, TX - 28 de febrero de 2024',
    crusadeCodeEventId: 133,
    SECodeEventId: 'TXEG'
  },
  TXDR: {
    label: 'Del Rio, TX - 29 de febrero de 2024',
    crusadeCodeEventId: 126,
    SECodeEventId: 'TXDR'
  },
  TXPR: {
    label: 'Presidio, TX - 2 de marzo de 2024',
    crusadeCodeEventId: 132,
    SECodeEventId: 'TXPR'
  },
  TXEP: {
    label: 'El Paso, TX - 3 de marzo de 2024',
    crusadeCodeEventId: 127,
    SECodeEventId: 'TXEP'
  },
  AZTC: {
    label: 'Tucson, AZ - 5 de marzo de 2024',
    crusadeCodeEventId: 128,
    SECodeEventId: 'AZTC'
  },
  AZYM: {
    label: 'Yuma, AZ - 7 de marzo de 2024',
    crusadeCodeEventId: 130,
    SECodeEventId: 'AZYM'
  },
  CASD: {
    label: 'Chula Vista, CA - 9 de marzo de 2024',
    crusadeCodeEventId: 131,
    SECodeEventId: 'CASD'
  }
};
var prayerTeamFormProps = {
  SESourceCode: 'BA240FFRC',
  addressVisibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'],
  cityOnly: true,
  codeKey: 'DTR',
  collectionType: 306,
  counselorApplied: '1369',
  counselorRegistered: '1327',
  counselorTrained: '1289',
  country: ['US', 'MX'],
  destination: 2,
  dtrValue: 'VM124',
  emailId: 'GodLovesYouTour',
  eventId: '118',
  fluentLanguageOptions: [{
    id: 'spanisYes',
    label: 'Yes',
    name: 'spanishGroup',
    value: 'yes'
  }, {
    id: 'spanishNo',
    label: 'No',
    name: 'spanishGroup',
    value: 'no'
  }],
  individualCrusadeCodeEventValue: '1300',
  languageOptions: [{
    id: 'langEnglish',
    label: 'English',
    name: 'languageGroup',
    value: 'english'
  }, {
    id: 'langSpanish',
    label: 'Spanish',
    name: 'languageGroup',
    value: 'spanish'
  }],
  multipleCities: false,
  multipleRoles: false,
  orgRoleCode: 'DTRVCOUN',
  showShirtSizes: false
};
var volunteerFormProps = {
  addressVisibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'],
  cityOnly: false,
  collectionType: 296,
  codeKey: 'DTR',
  country: ['US', 'MX'],
  destination: 2,
  dtrValue: 'VM124',
  emailId: 'GodLovesYouTour',
  fluentLanguageOptions: [{
    label: 'Yes',
    name: 'spanishGroup',
    id: 'spanisYes',
    value: 'yes'
  }, {
    label: 'No',
    name: 'spanishGroup',
    id: 'spanishNo',
    value: 'no'
  }],
  individualCrusadeCodeEventValue: '1300',
  languageOptions: [{
    label: 'English',
    name: 'languageGroup',
    id: 'langEnglish',
    value: 'english'
  }, {
    label: 'Spanish',
    name: 'languageGroup',
    id: 'langSpanish',
    value: 'spanish'
  }],
  lng: 'en',
  multipleCities: false,
  multipleRoles: false,
  productId: 'DAVKFT24',
  roleOnly: false,
  showShirtSizes: false,
  showRoles: false,
  SESourceCode: 'BA230FTWP'
};

var removeUnder18CommInfo = function removeUnder18CommInfo(values) {
  var _values$collector, _values$collector$com, _values$collector2, _values$collector2$co;
  var hasReferenceInfo = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$com = _values$collector.communications) === null || _values$collector$com === void 0 ? void 0 : _values$collector$com.some(function (comm) {
    return (comm === null || comm === void 0 ? void 0 : comm.communicationType) === communicationReferenceType || (comm === null || comm === void 0 ? void 0 : comm.communicationType) === communicationResearchType;
  });
  values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$co = _values$collector2.communications) === null || _values$collector2$co === void 0 ? void 0 : _values$collector2$co.forEach(function (comm, j) {
    if (comm.communicationType === 'VOLRELWVY' || comm.communicationType === 'RESRELWVY') {
      values.collector.communications.splice(j, 1);
      delete values.formLogic.under18.legalGuardianName;
      delete values.formLogic.under18.legalGuardianEmail;
      delete values.formLogic.under18.emergencyContactName;
      delete values.formLogic.under18.emergencyContactPhone;
    }
    if (j === 0 && !hasReferenceInfo) {
      delete values.collector.communications;
    }
  });
};
var handleUnder18 = function handleUnder18(_ref) {
  var _values$formLogic$und, _values$formLogic$und2, _values$formLogic$und3, _values$formLogic$und4, _values$collector3, _values$collector$com2;
  var _ref$commType = _ref.commType,
    commType = _ref$commType === void 0 ? '' : _ref$commType,
    values = _ref.values,
    setFieldValue = _ref.setFieldValue;
  var isOver18 = values.formLogic.over18 === 'yes' || (values === null || values === void 0 ? void 0 : values.formLogic.ageGroup) === '1';
  var isUnder18 = values.formLogic.over18 === 'no' || (values === null || values === void 0 ? void 0 : values.formLogic.ageGroup) === '8' || (values === null || values === void 0 ? void 0 : values.formLogic.ageGroup) === '9'; // ignore empty string
  var legalGuardianName = (_values$formLogic$und = values.formLogic.under18) === null || _values$formLogic$und === void 0 ? void 0 : _values$formLogic$und.legalGuardianName;
  var legalGuardianEmail = (_values$formLogic$und2 = values.formLogic.under18) === null || _values$formLogic$und2 === void 0 ? void 0 : _values$formLogic$und2.legalGuardianEmail;
  var emergencyContactName = (_values$formLogic$und3 = values.formLogic.under18) === null || _values$formLogic$und3 === void 0 ? void 0 : _values$formLogic$und3.emergencyContactName;
  var emergencyContactPhone = (_values$formLogic$und4 = values.formLogic.under18) === null || _values$formLogic$und4 === void 0 ? void 0 : _values$formLogic$und4.emergencyContactPhone;
  var communications = (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : _values$collector3.communications;
  var communicationType = commType || communicationLegalGuardianType;
  var resetLegalGuardianArr = ((_values$collector$com2 = values.collector.communications) === null || _values$collector$com2 === void 0 ? void 0 : _values$collector$com2.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.communicationType) !== communicationType;
  })) || [];
  if (isUnder18) {
    if (legalGuardianName && legalGuardianEmail && emergencyContactName && emergencyContactPhone) {
      setFieldValue('collector.communications', [].concat(_toConsumableArray(resetLegalGuardianArr), [{
        communicationType: communicationType,
        longComment: "".concat(legalGuardianName, " | ").concat(legalGuardianEmail, " | ").concat(emergencyContactName, " | ").concat(emergencyContactPhone)
      }]));
    }
  } else if (isOver18 && communications) {
    removeUnder18CommInfo(values);
  }
};
var handleOver18 = function handleOver18(_ref2) {
  var _values$formLogic, _values$formLogic2, _values$formLogic3, _values$collector4, _values$collector5, _values$collector5$en, _values$collector5$en2;
  var setFieldValue = _ref2.setFieldValue,
    values = _ref2.values;
  var isOver18 = values.formLogic.over18 === 'yes' || (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.ageGroup) === '1';
  var isUnder18 = values.formLogic.over18 === 'no' || (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.ageGroup) === '8' || (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.ageGroup) === '9'; // ignore empty string
  var communications = (_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : _values$collector4.communications;
  values === null || values === void 0 ? void 0 : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : (_values$collector5$en = _values$collector5.entity[0]) === null || _values$collector5$en === void 0 ? void 0 : (_values$collector5$en2 = _values$collector5$en.code) === null || _values$collector5$en2 === void 0 ? void 0 : _values$collector5$en2.forEach(function (code, i) {
    var idx = i;
    var nextindex = idx + 1;
    if (isUnder18 && (code === null || code === void 0 ? void 0 : code.key) !== 'NAMETYPE' && nextindex === values.collector.entity[0].code.length) {
      setFieldValue("collector.entity[0].over18", false);
      setFieldValue("collector.entity[0].code[".concat(nextindex, "].key"), 'NAMETYPE');
      setFieldValue("collector.entity[0].code[".concat(nextindex, "].value"), '8');
    } else if (isOver18) {
      setFieldValue("collector.entity[0].over18", true);
      if ((code === null || code === void 0 ? void 0 : code.key) === 'NAMETYPE') {
        values.collector.entity[0].code.splice(i, 1);
      }
      if (communications) {
        removeUnder18CommInfo(values);
      }
    }
  });
};

var useBRBPaylod = function useBRBPaylod(_ref) {
  var _ref$index = _ref.index,
    index = _ref$index === void 0 ? 1 : _ref$index;
  var brbQuery = useGetBRBInfo();
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    projectId = _useState2[0],
    setProjectId = _useState2[1];
  var entityInfo = {
    id: '',
    entityType: 'I',
    isPrimary: false,
    entityRelationship: [{
      relationshipType: 'Call Taker',
      path: 'entity[0]'
    }],
    firstName: 'Call',
    lastName: 'Taker',
    email: [{
      emailAddress: 'calltaker@bgea.org'
    }]
  };
  useEffect(function () {
    var _brbQuery$data, _brbQuery$data$payloa, _brbQuery$data$payloa2, _brbQuery$data3, _brbQuery$data3$paylo, _brbQuery$data3$paylo2, _brbQuery$data5, _brbQuery$data5$paylo, _brbQuery$data5$paylo2, _brbQuery$data7, _brbQuery$data7$paylo, _brbQuery$data7$paylo2, _brbQuery$data7$paylo3;
    if ((brbQuery === null || brbQuery === void 0 ? void 0 : (_brbQuery$data = brbQuery.data) === null || _brbQuery$data === void 0 ? void 0 : (_brbQuery$data$payloa = _brbQuery$data.payload) === null || _brbQuery$data$payloa === void 0 ? void 0 : (_brbQuery$data$payloa2 = _brbQuery$data$payloa.callTaker) === null || _brbQuery$data$payloa2 === void 0 ? void 0 : _brbQuery$data$payloa2.length) > 0) {
      var _brbQuery$data2, _payload$callTaker$, _payload$callTaker$2, _payload$callTaker$3, _payload$callTaker$4;
      var payload = brbQuery === null || brbQuery === void 0 ? void 0 : (_brbQuery$data2 = brbQuery.data) === null || _brbQuery$data2 === void 0 ? void 0 : _brbQuery$data2.payload;
      setFieldValue('formLogic.brbInfo', payload);
      setFieldValue("collector.entity[".concat(index, "]"), entityInfo);
      setFieldValue("collector.entity[".concat(index, "].id"), payload === null || payload === void 0 ? void 0 : (_payload$callTaker$ = payload.callTaker[0]) === null || _payload$callTaker$ === void 0 ? void 0 : _payload$callTaker$.user_id);
      setFieldValue("collector.entity[".concat(index, "].firstName"), payload === null || payload === void 0 ? void 0 : (_payload$callTaker$2 = payload.callTaker[0]) === null || _payload$callTaker$2 === void 0 ? void 0 : _payload$callTaker$2.first_name);
      setFieldValue("collector.entity[".concat(index, "].lastName"), payload === null || payload === void 0 ? void 0 : (_payload$callTaker$3 = payload.callTaker[0]) === null || _payload$callTaker$3 === void 0 ? void 0 : _payload$callTaker$3.last_name);
      setFieldValue("collector.entity[".concat(index, "].email"), [{
        emailAddress: payload === null || payload === void 0 ? void 0 : (_payload$callTaker$4 = payload.callTaker[0]) === null || _payload$callTaker$4 === void 0 ? void 0 : _payload$callTaker$4.email
      }]);
    }
    if (brbQuery !== null && brbQuery !== void 0 && (_brbQuery$data3 = brbQuery.data) !== null && _brbQuery$data3 !== void 0 && (_brbQuery$data3$paylo = _brbQuery$data3.payload) !== null && _brbQuery$data3$paylo !== void 0 && (_brbQuery$data3$paylo2 = _brbQuery$data3$paylo.campaign) !== null && _brbQuery$data3$paylo2 !== void 0 && _brbQuery$data3$paylo2.collectionType) {
      var _brbQuery$data4, _brbQuery$data4$paylo, _brbQuery$data4$paylo2;
      setFieldValue("collector.collectionType", brbQuery === null || brbQuery === void 0 ? void 0 : (_brbQuery$data4 = brbQuery.data) === null || _brbQuery$data4 === void 0 ? void 0 : (_brbQuery$data4$paylo = _brbQuery$data4.payload) === null || _brbQuery$data4$paylo === void 0 ? void 0 : (_brbQuery$data4$paylo2 = _brbQuery$data4$paylo.campaign) === null || _brbQuery$data4$paylo2 === void 0 ? void 0 : _brbQuery$data4$paylo2.collectionType);
    }
    if (brbQuery !== null && brbQuery !== void 0 && (_brbQuery$data5 = brbQuery.data) !== null && _brbQuery$data5 !== void 0 && (_brbQuery$data5$paylo = _brbQuery$data5.payload) !== null && _brbQuery$data5$paylo !== void 0 && (_brbQuery$data5$paylo2 = _brbQuery$data5$paylo.campaign) !== null && _brbQuery$data5$paylo2 !== void 0 && _brbQuery$data5$paylo2.sourceCode) {
      var _brbQuery$data6, _brbQuery$data6$paylo, _brbQuery$data6$paylo2;
      setFieldValue("collector.SESourceCode", brbQuery === null || brbQuery === void 0 ? void 0 : (_brbQuery$data6 = brbQuery.data) === null || _brbQuery$data6 === void 0 ? void 0 : (_brbQuery$data6$paylo = _brbQuery$data6.payload) === null || _brbQuery$data6$paylo === void 0 ? void 0 : (_brbQuery$data6$paylo2 = _brbQuery$data6$paylo.campaign) === null || _brbQuery$data6$paylo2 === void 0 ? void 0 : _brbQuery$data6$paylo2.sourceCode);
    }
    if ((brbQuery === null || brbQuery === void 0 ? void 0 : (_brbQuery$data7 = brbQuery.data) === null || _brbQuery$data7 === void 0 ? void 0 : (_brbQuery$data7$paylo = _brbQuery$data7.payload) === null || _brbQuery$data7$paylo === void 0 ? void 0 : (_brbQuery$data7$paylo2 = _brbQuery$data7$paylo.campaign) === null || _brbQuery$data7$paylo2 === void 0 ? void 0 : (_brbQuery$data7$paylo3 = _brbQuery$data7$paylo2.projects) === null || _brbQuery$data7$paylo3 === void 0 ? void 0 : _brbQuery$data7$paylo3.length) > 0) {
      var _brbQuery$data8, _brbQuery$data8$paylo, _brbQuery$data8$paylo2, _brbQuery$data8$paylo3, _brbQuery$data9, _brbQuery$data9$paylo, _brbQuery$data9$paylo2, _brbQuery$data9$paylo3;
      setFieldValue("collector.cart.donation.projects[0].projectId", brbQuery === null || brbQuery === void 0 ? void 0 : (_brbQuery$data8 = brbQuery.data) === null || _brbQuery$data8 === void 0 ? void 0 : (_brbQuery$data8$paylo = _brbQuery$data8.payload) === null || _brbQuery$data8$paylo === void 0 ? void 0 : (_brbQuery$data8$paylo2 = _brbQuery$data8$paylo.campaign) === null || _brbQuery$data8$paylo2 === void 0 ? void 0 : (_brbQuery$data8$paylo3 = _brbQuery$data8$paylo2.projects[0]) === null || _brbQuery$data8$paylo3 === void 0 ? void 0 : _brbQuery$data8$paylo3.project);
      setProjectId(brbQuery === null || brbQuery === void 0 ? void 0 : (_brbQuery$data9 = brbQuery.data) === null || _brbQuery$data9 === void 0 ? void 0 : (_brbQuery$data9$paylo = _brbQuery$data9.payload) === null || _brbQuery$data9$paylo === void 0 ? void 0 : (_brbQuery$data9$paylo2 = _brbQuery$data9$paylo.campaign) === null || _brbQuery$data9$paylo2 === void 0 ? void 0 : (_brbQuery$data9$paylo3 = _brbQuery$data9$paylo2.projects[0]) === null || _brbQuery$data9$paylo3 === void 0 ? void 0 : _brbQuery$data9$paylo3.project);
    }
  }, [brbQuery === null || brbQuery === void 0 ? void 0 : brbQuery.data]);
  return {
    projectId: projectId,
    values: values
  };
};

var useCallTaker = function useCallTaker(_ref) {
  var _values$formLogic, _values$formLogic$brb;
  var isDisableRecaptcha = _ref.isDisableRecaptcha;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    resetForm = _useFormikContext.resetForm,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    formChoice = _useState2[0],
    setFormChoice = _useState2[1];
  var _useState3 = useState(0),
    _useState4 = _slicedToArray(_useState3, 2),
    resetSignal = _useState4[0],
    setResetSignal = _useState4[1];
  var _useBRBPaylod = useBRBPaylod({
      index: 1
    }),
    projectId = _useBRBPaylod.projectId;
  var message = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$brb = _values$formLogic.brbInfo) === null || _values$formLogic$brb === void 0 ? void 0 : _values$formLogic$brb.message[0]) || '';
  var addressObj = {
    addressType: AddressType.Mail,
    country: 'US',
    stateProvince: '',
    cityTownRegion: '',
    zipPostalCode: '',
    streetTwo: '',
    street: ''
  };
  var handleOnCallerChoice = function handleOnCallerChoice(e, choice) {
    e.preventDefault();
    delete values.payment;
    if (choice === 'comment') {
      delete values.collector.cart;
    }
    delete values.collector.entity[2];
    values.formLogic = _objectSpread2(_objectSpread2({}, values.formLogic), {}, {
      activeMethod: '',
      isValidEmailAddress: false,
      newsletter: false,
      noAddress: false,
      noEmail: false,
      orgGift: false,
      orgName: '',
      pledge: false,
      recurringDate: '',
      recurringDonations: []
    });
    values.collector.entity[0] = {
      entityType: EntityType.I,
      isPrimary: true,
      firstName: '',
      lastName: '',
      address: [addressObj],
      email: [{
        emailAddress: ''
      }],
      phone: [{
        phoneNumber: ''
      }],
      over18: true
    };
    resetForm({
      values: _objectSpread2({}, values)
    });
    setResetSignal(function (reset) {
      return reset + 1;
    });
    setFormChoice(choice);
  };
  useEffect(function () {
    if (isDisableRecaptcha) {
      setFieldValue('formLogic.isDisableRecaptcha', true, false);
    }
  }, []);
  return {
    formChoice: formChoice,
    message: message,
    projectId: projectId,
    resetSignal: resetSignal,
    handleOnCallerChoice: handleOnCallerChoice
  };
};

var handleNewsletter = function handleNewsletter(_ref) {
  var _values$formLogic, _values$collector, _values$collector$ent, _values$formLogic2, _values$collector2, _values$collector3, _values$collector4, _values$collector4$en, _values$collector5, _values$collector5$en, _values$collector6, _values$collector6$en, _values$collector6$en2;
  var values = _ref.values,
    setFieldValue = _ref.setFieldValue;
  if (values !== null && values !== void 0 && (_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && _values$formLogic.noEmail && values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent = _values$collector.entity[0]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.email) {
    delete values.collector.entity[0].email;
  }
  if (values !== null && values !== void 0 && (_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && _values$formLogic2.newsletter) {
    setFieldValue('collector.entity[0].email[0].eSubs', {
      BRBNWSLTR: true
    });
  } else if (values !== null && values !== void 0 && (_values$collector2 = values.collector) !== null && _values$collector2 !== void 0 && _values$collector2.entity && values !== null && values !== void 0 && (_values$collector3 = values.collector) !== null && _values$collector3 !== void 0 && _values$collector3.entity[0] && values !== null && values !== void 0 && (_values$collector4 = values.collector) !== null && _values$collector4 !== void 0 && (_values$collector4$en = _values$collector4.entity[0]) !== null && _values$collector4$en !== void 0 && _values$collector4$en.email && values !== null && values !== void 0 && (_values$collector5 = values.collector) !== null && _values$collector5 !== void 0 && (_values$collector5$en = _values$collector5.entity[0]) !== null && _values$collector5$en !== void 0 && _values$collector5$en.email[0] && values !== null && values !== void 0 && (_values$collector6 = values.collector) !== null && _values$collector6 !== void 0 && (_values$collector6$en = _values$collector6.entity[0]) !== null && _values$collector6$en !== void 0 && (_values$collector6$en2 = _values$collector6$en.email[0]) !== null && _values$collector6$en2 !== void 0 && _values$collector6$en2.eSubs) {
    delete values.collector.entity[0].email[0].eSubs;
  }
};

var useCallTakerDetails = function useCallTakerDetails(_ref) {
  var _values$collector, _values$collector$car, _values$collector$car2, _values$formLogic, _values$formLogic2, _values$formLogic3, _values$formLogic4, _values$collector2, _values$collector2$en, _values$collector3, _values$collector3$en, _values$collector3$en2, _values$collector3$en3, _values$collector4, _values$collector4$ca, _values$collector4$ca2, _values$formLogic5, _values$formLogic5$co, _values$formLogic5$co2, _values$formLogic5$co3, _values$formLogic5$co4, _values$formLogic5$co5, _values$formLogic7, _values$formLogic9, _values$formLogic11, _values$formLogic12, _values$formLogic13, _values$collector5, _values$collector5$en;
  var formChoice = _ref.formChoice;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showAddress = _useState2[0],
    setShowAddress = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showEmail = _useState4[0],
    setShowEmail = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showOrgGift = _useState6[0],
    setShowOrgGift = _useState6[1];
  var showPayment = (values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.cartTotals) === null || _values$collector$car2 === void 0 ? void 0 : _values$collector$car2.subTotal) > 0;
  var showPledge = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.pledge) && !(values !== null && values !== void 0 && (_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && _values$formLogic2.activeMethod);
  var showDonationCart = !(values !== null && values !== void 0 && (_values$formLogic3 = values.formLogic) !== null && _values$formLogic3 !== void 0 && _values$formLogic3.pledge) && !!(values !== null && values !== void 0 && (_values$formLogic4 = values.formLogic) !== null && _values$formLogic4 !== void 0 && _values$formLogic4.activeMethod);
  var creditCardClassName = values.formLogic.activeMethod === 'CC' && !values.formLogic.pledge ? 'is-active is-success' : '';
  var eftClassName = values.formLogic.activeMethod === 'EFT' && !values.formLogic.pledge ? 'is-active is-success' : '';
  var pledgeClassName = values.formLogic.activeMethod === null && values.formLogic.pledge ? 'is-active is-success' : '';
  var showNewsletterCheckbox = (values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : _values$collector2$en.email) && (values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.email[0]) === null || _values$collector3$en2 === void 0 ? void 0 : (_values$collector3$en3 = _values$collector3$en2.emailAddress) === null || _values$collector3$en3 === void 0 ? void 0 : _values$collector3$en3.length) > 6 && !values.formLogic.noEmail;
  var showSubmitButton = values.formLogic.activeMethod !== 'EFT' && (values === null || values === void 0 ? void 0 : (_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : (_values$collector4$ca = _values$collector4.cart) === null || _values$collector4$ca === void 0 ? void 0 : (_values$collector4$ca2 = _values$collector4$ca.cartTotals) === null || _values$collector4$ca2 === void 0 ? void 0 : _values$collector4$ca2.subTotal) >= 5 || values.formLogic.pledge === true || formChoice === 'comment';
  // default pledgeCode value for WMN, but if projects are passed in use the first value instead
  var defaultPledgeCode = (values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : (_values$formLogic5$co = _values$formLogic5.configInfo) === null || _values$formLogic5$co === void 0 ? void 0 : (_values$formLogic5$co2 = _values$formLogic5$co.payload) === null || _values$formLogic5$co2 === void 0 ? void 0 : (_values$formLogic5$co3 = _values$formLogic5$co2.campaign) === null || _values$formLogic5$co3 === void 0 ? void 0 : (_values$formLogic5$co4 = _values$formLogic5$co3.projects) === null || _values$formLogic5$co4 === void 0 ? void 0 : (_values$formLogic5$co5 = _values$formLogic5$co4[0]) === null || _values$formLogic5$co5 === void 0 ? void 0 : _values$formLogic5$co5.pledgeCode) || 'RS22CQHUX';
  var handlePaymentButtons = function handlePaymentButtons(event, paymentMethod) {
    var isPledge = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
    event === null || event === void 0 ? void 0 : event.preventDefault();
    setFieldValue("formLogic.pledge", isPledge);
    setFieldValue("formLogic.activeMethod", paymentMethod);
    isPledge && setFieldValue('collector.cart.pledge', {
      pledgeCode: defaultPledgeCode,
      frequency: 'one-time'
    });
  };
  useEffect(function () {
    var _values$formLogic6;
    setShowAddress(!((_values$formLogic6 = values.formLogic) !== null && _values$formLogic6 !== void 0 && _values$formLogic6.noAddress));
  }, [(_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : _values$formLogic7.noAddress]);
  useEffect(function () {
    var _values$formLogic8;
    setShowEmail(!((_values$formLogic8 = values.formLogic) !== null && _values$formLogic8 !== void 0 && _values$formLogic8.noEmail));
  }, [(_values$formLogic9 = values.formLogic) === null || _values$formLogic9 === void 0 ? void 0 : _values$formLogic9.noEmail]);
  useEffect(function () {
    var _values$formLogic10;
    setShowOrgGift(!!((_values$formLogic10 = values.formLogic) !== null && _values$formLogic10 !== void 0 && _values$formLogic10.orgGift));
  }, [(_values$formLogic11 = values.formLogic) === null || _values$formLogic11 === void 0 ? void 0 : _values$formLogic11.orgGift]);
  useEffect(function () {
    if (values.formLogic.orgGift) {
      var orgName = values.collector.entity[2] && values.collector.entity[2].organizationName || null;
      setFieldValue("collector.entity[2]", {
        entityType: 'O',
        isPrimary: false,
        organizationName: orgName
      });
    } else if (values.collector.entity[2]) {
      values.collector.entity.splice(2, 1);
    } else {
      setFieldValue("collector.entity", [values.collector.entity[0], values.collector.entity[1]]);
    }
  }, [values.formLogic.pledge, values.formLogic.orgGift]);
  useEffect(function () {
    handleNewsletter({
      values: values,
      setFieldValue: setFieldValue
    });
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic12 = values.formLogic) === null || _values$formLogic12 === void 0 ? void 0 : _values$formLogic12.noEmail, values === null || values === void 0 ? void 0 : (_values$formLogic13 = values.formLogic) === null || _values$formLogic13 === void 0 ? void 0 : _values$formLogic13.newsletter]);
  useEffect(function () {
    setFormId({
      templateName: Templates.CALL_TAKER_FORM,
      values: values,
      setFieldValue: setFieldValue
    });
    setFieldValue('collector.questions', [{
      answerText: '',
      questionId: 1,
      questionText: 'Story'
    }, {
      answerText: '',
      questionId: 2,
      questionText: 'Prayer Request'
    }, {
      answerText: '',
      questionId: 3,
      questionText: 'Notes'
    }, {
      answerText: '',
      questionId: 4,
      questionText: 'Anonymous'
    }]);
  }, []);
  if (values !== null && values !== void 0 && (_values$collector5 = values.collector) !== null && _values$collector5 !== void 0 && (_values$collector5$en = _values$collector5.entity[0]) !== null && _values$collector5$en !== void 0 && _values$collector5$en.email) {
    var _values$collector6, _values$collector6$en, _values$collector6$en2, _values$collector7, _values$collector7$en, _values$collector7$en2;
    values === null || values === void 0 ? true : (_values$collector6 = values.collector) === null || _values$collector6 === void 0 ? true : (_values$collector6$en = _values$collector6.entity[0]) === null || _values$collector6$en === void 0 ? true : (_values$collector6$en2 = _values$collector6$en.email[0]) === null || _values$collector6$en2 === void 0 ? true : delete _values$collector6$en2.emailSubscription;
    values === null || values === void 0 ? true : (_values$collector7 = values.collector) === null || _values$collector7 === void 0 ? true : (_values$collector7$en = _values$collector7.entity[0]) === null || _values$collector7$en === void 0 ? true : (_values$collector7$en2 = _values$collector7$en.email[0]) === null || _values$collector7$en2 === void 0 ? true : delete _values$collector7$en2.emailType;
  }
  return {
    creditCardClassName: creditCardClassName,
    eftClassName: eftClassName,
    pledgeClassName: pledgeClassName,
    showAddress: showAddress,
    showDonationCart: showDonationCart,
    showEmail: showEmail,
    showPayment: showPayment,
    showPledge: showPledge,
    showNewsletterCheckbox: showNewsletterCheckbox,
    showOrgGift: showOrgGift,
    showSubmitButton: showSubmitButton,
    values: values,
    handlePaymentButtons: handlePaymentButtons
  };
};

var _DONATION_FREQUENCY_O, _PAYMENT_TYPE_OPTIONS;
var DEFAULT_ITEMIZED_VALUE = {
  amount: 5,
  projectId: '',
  initialChargeProcessed: true
};
var PAYMENT_TYPE = {
  ITEMIZED: 'One-Time',
  RECURRING: 'Recurring'
};
var CART_INFO = 'cart-info';
var MIN_CURRENCY_VALUE = 5;
var DONATION_FREQUENCY_OPTIONS = (_DONATION_FREQUENCY_O = {}, _defineProperty(_DONATION_FREQUENCY_O, PAYMENT_TYPE.ITEMIZED, 'One-Time'), _defineProperty(_DONATION_FREQUENCY_O, PAYMENT_TYPE.RECURRING, 'Monthly'), _DONATION_FREQUENCY_O);
var PAYMENT_TYPE_OPTIONS = (_PAYMENT_TYPE_OPTIONS = {}, _defineProperty(_PAYMENT_TYPE_OPTIONS, PAYMENT_TYPE.ITEMIZED, 'One-Time'), _defineProperty(_PAYMENT_TYPE_OPTIONS, PAYMENT_TYPE.RECURRING, 'Recurring'), _PAYMENT_TYPE_OPTIONS);
var WHERE_MOST_NEEDED_TITLE = 'Where Most Needed';

// Tracking event types
var ADD_ITEM_CART = 'bgform-add-item-to-cart';
var DELETE_ITEM_CART = 'bgform-delete-item-to-cart';

var useCart = function useCart(_ref) {
  var _projectOptions$;
  var cartObj = _ref.cartObj,
    projects = _ref.projects,
    setCartInfo = _ref.setCartInfo;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useState = useState(getAvailableOptions(cartObj, projects)),
    _useState2 = _slicedToArray(_useState, 2),
    projectOptions = _useState2[0],
    setProjectOptions = _useState2[1];
  var _useState3 = useState({}),
    _useState4 = _slicedToArray(_useState3, 2),
    addedItem = _useState4[0],
    setAddedItem = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showPayment = _useState6[0],
    setShowPayment = _useState6[1];
  var _useState7 = useState({}),
    _useState8 = _slicedToArray(_useState7, 2),
    currencyError = _useState8[0],
    setCurrencyError = _useState8[1];
  var defaultProjectId = (_projectOptions$ = projectOptions[0]) === null || _projectOptions$ === void 0 ? void 0 : _projectOptions$.projectId;
  var defaultValue = _objectSpread2(_objectSpread2({}, DEFAULT_ITEMIZED_VALUE), {}, {
    projectId: "".concat(defaultProjectId)
  });
  var trackAnalytics = function trackAnalytics(eventType, projectItem) {
    var _values$formLogic, _values$formLogic$par;
    trackEvent(eventType, {
      formCategory: values.collector.formID,
      formAction: eventType,
      formLabel: (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.documentLocationHref) || document.location.href,
      formValue: 1,
      item: {
        initialChargeProcessed: true,
        item_category: 'donation',
        item_name: parseInt(projectItem === null || projectItem === void 0 ? void 0 : projectItem.projectId, 10),
        item_variant: projectItem === null || projectItem === void 0 ? void 0 : projectItem.type,
        price: projectItem === null || projectItem === void 0 ? void 0 : projectItem.amount
      }
    });
  };
  var getUpdatedProjectInfo = function getUpdatedProjectInfo() {
    var _values$formLogic2;
    var projectItem = _objectSpread2({}, cartObj);
    var formLogicCartInfo = (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.cartInfo;
    values.collector.cart.donation.projects.forEach(function (project, index) {
      var _formLogicCartInfo$pr;
      if (((_formLogicCartInfo$pr = formLogicCartInfo[project === null || project === void 0 ? void 0 : project.projectId]) === null || _formLogicCartInfo$pr === void 0 ? void 0 : _formLogicCartInfo$pr.type) === PAYMENT_TYPE.RECURRING) {
        if (isValidDate(values.formLogic.recurringDate)) {
          var startDate = calculateStartDate(values.formLogic.recurringDate);
          projectItem[project === null || project === void 0 ? void 0 : project.projectId].recurringDate = startDate;
          setFieldValue("collector.cart.donation.projects[".concat(index, "].recurringDate"), startDate);
          setFieldValue("formLogic.cartInfo[".concat(project === null || project === void 0 ? void 0 : project.projectId, "].recurringDate"), startDate);
        }
      } else {
        var _projectItem$project$, _formLogicCartInfo$pr2;
        (_projectItem$project$ = projectItem[project === null || project === void 0 ? void 0 : project.projectId]) === null || _projectItem$project$ === void 0 ? true : delete _projectItem$project$.recurringDate;
        (_formLogicCartInfo$pr2 = formLogicCartInfo[project === null || project === void 0 ? void 0 : project.projectId]) === null || _formLogicCartInfo$pr2 === void 0 ? true : delete _formLogicCartInfo$pr2.recurringDate;
        delete values.collector.cart.donation.projects[index].recurringDate;
      }
    });
    if (!hasRecurringPaymentType(cartObj)) {
      setFieldValue('formLogic.recurringDateNum', '', false);
    }
    return formLogicCartInfo;
  };
  var getProjectInfo = function getProjectInfo() {
    var recurringDate = '';
    var projectList = [];
    var donations = [];
    projects === null || projects === void 0 ? void 0 : projects.forEach(function (project) {
      var _storedCartItem$recur, _storedCartItem$amoun;
      var storedCartItem = cartObj[project === null || project === void 0 ? void 0 : project.projectId];
      recurringDate = (_storedCartItem$recur = storedCartItem === null || storedCartItem === void 0 ? void 0 : storedCartItem.recurringDate) !== null && _storedCartItem$recur !== void 0 ? _storedCartItem$recur : recurringDate;
      projectList.push(_objectSpread2(_objectSpread2({}, project), {}, {
        amount: (_storedCartItem$amoun = storedCartItem === null || storedCartItem === void 0 ? void 0 : storedCartItem.amount) !== null && _storedCartItem$amoun !== void 0 ? _storedCartItem$amoun : 0
      }));
      if (!!cartObj && !!storedCartItem) {
        donations.push(_objectSpread2({
          amount: storedCartItem.amount,
          initialChargeProcessed: true,
          projectId: parseInt(storedCartItem.projectId, 10)
        }, (storedCartItem === null || storedCartItem === void 0 ? void 0 : storedCartItem.recurringDate) && {
          recurringDate: storedCartItem === null || storedCartItem === void 0 ? void 0 : storedCartItem.recurringDate
        }));
      }
    });
    return {
      donations: donations,
      projectList: projectList,
      recurringDate: recurringDate
    };
  };
  var handleOnChange = function handleOnChange(e, projectId) {
    e.preventDefault();
    e.stopPropagation();
    var amount = parseFloat(e.target.value);
    if (projectId && !isNaN(amount) && amount >= MIN_CURRENCY_VALUE) {
      var _values$formLogic$car, _values$formLogic$car2, _values$formLogic$car3, _values$formLogic$car4, _project$projectId;
      var errorObj = _objectSpread2({}, currencyError);
      delete errorObj[projectId];
      setCurrencyError(errorObj);
      var project = _objectSpread2({}, cartObj);
      var type = (_values$formLogic$car = values.formLogic.cartInfo[projectId]) !== null && _values$formLogic$car !== void 0 && _values$formLogic$car.type ? (_values$formLogic$car2 = values.formLogic.cartInfo[projectId]) === null || _values$formLogic$car2 === void 0 ? void 0 : _values$formLogic$car2.type : 'One-Time';
      var recurringDate = (_values$formLogic$car3 = values.formLogic.cartInfo[projectId]) !== null && _values$formLogic$car3 !== void 0 && _values$formLogic$car3.recurringDate ? (_values$formLogic$car4 = values.formLogic.cartInfo[projectId]) === null || _values$formLogic$car4 === void 0 ? void 0 : _values$formLogic$car4.recurringDate : '';
      var cartItem = _objectSpread2({
        projectId: projectId,
        title: (_project$projectId = project[projectId]) === null || _project$projectId === void 0 ? void 0 : _project$projectId.title,
        type: type,
        amount: amount
      }, recurringDate && {
        recurringDate: recurringDate
      });
      project[projectId] = cartItem;
      setCartInfo(JSON.stringify(project));
      removeCartEvent({
        cartItem: cartObj[projectId]
      });
      addCartEvent({
        cartItem: cartItem
      });
    } else {
      setCurrencyError(function (prevState) {
        return _objectSpread2(_objectSpread2({}, prevState), {}, _defineProperty({}, projectId, true));
      });
    }
  };
  var handleFrequencyOnChange = function handleFrequencyOnChange(e, projectId) {
    setFieldValue(e.target.name, e.target.value, false);
    updateCheckoutEvent({
      frequency: e.target.value,
      cartObj: cartObj[projectId]
    });
  };
  var handleOnAddClick = function handleOnAddClick(e) {
    var _values$formLogic3, _values$formLogic3$ne;
    e.preventDefault();
    e.stopPropagation();
    var projectId = (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : (_values$formLogic3$ne = _values$formLogic3.newProjectDonation) === null || _values$formLogic3$ne === void 0 ? void 0 : _values$formLogic3$ne.projectId;
    if (projectId) {
      addItemToCart({
        amount: defaultValue === null || defaultValue === void 0 ? void 0 : defaultValue.amount,
        cartObj: cartObj,
        projectId: projectId,
        paytmentType: PAYMENT_TYPE.ITEMIZED,
        projectOptions: projectOptions,
        projects: projects,
        setAddedItem: setAddedItem,
        setCartInfo: setCartInfo,
        setFieldValue: setFieldValue,
        setProjectOptions: setProjectOptions
      });
    }
  };
  var handleOnContinueClick = function handleOnContinueClick(e) {
    e.preventDefault();
    e.stopPropagation();
    setShowPayment(true);
    beginCheckoutEvent({
      values: values
    });
  };
  var handleOnDeleteClick = function handleOnDeleteClick(e, projectId) {
    e.preventDefault();
    e.stopPropagation();
    if (projectId) {
      var _project$projectId2, _project$projectId3;
      var project = _objectSpread2({}, cartObj);
      setProjectOptions([{
        projectId: projectId,
        title: (_project$projectId2 = project[projectId]) === null || _project$projectId2 === void 0 ? void 0 : _project$projectId2.title,
        order: ((_project$projectId3 = project[projectId]) === null || _project$projectId3 === void 0 ? void 0 : _project$projectId3.order) || 0
      }].concat(_toConsumableArray(projectOptions)));
      removeCartEvent({
        cartItem: project[projectId]
      });
      delete project[projectId];
      setCartInfo(JSON.stringify(project));
    }
  };
  useEffect(function () {
    if (addedItem) {
      setFieldValue('formLogic.addedItem', addedItem, false);
    }
  }, [addedItem]);
  return {
    currencyError: currencyError,
    projectOptions: projectOptions,
    showPayment: showPayment,
    getProjectInfo: getProjectInfo,
    getUpdatedProjectInfo: getUpdatedProjectInfo,
    handleFrequencyOnChange: handleFrequencyOnChange,
    handleOnAddClick: handleOnAddClick,
    handleOnContinueClick: handleOnContinueClick,
    handleOnDeleteClick: handleOnDeleteClick,
    handleOnChange: handleOnChange,
    setProjectOptions: setProjectOptions,
    trackAnalytics: trackAnalytics
  };
};

var useCartModal = function useCartModal(_ref) {
  var _values$formLogic, _values$formLogic$new, _values$formLogic4;
  var projectOptions = _ref.projectOptions,
    projects = _ref.projects;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    projectDescription = _useState2[0],
    setProjectDescription = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showThankYouTxt = _useState4[0],
    setShowThankYouTxt = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    modalIsOpen = _useState6[0],
    setModalIsOpen = _useState6[1];
  var defaultValue = _objectSpread2(_objectSpread2({}, DEFAULT_ITEMIZED_VALUE), {}, {
    projectId: parseInt((_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$new = _values$formLogic.newProjectDonation) === null || _values$formLogic$new === void 0 ? void 0 : _values$formLogic$new.projectId, 10)
  });
  var selectProjectOptions = projectOptions === null || projectOptions === void 0 ? void 0 : projectOptions.map(function (project) {
    return {
      id: project === null || project === void 0 ? void 0 : project.projectId,
      value: project === null || project === void 0 ? void 0 : project.title
    };
  });
  var handleOnCloseModal = function handleOnCloseModal() {
    setModalIsOpen(false);
  };
  var handleOnAddModalClick = function handleOnAddModalClick(e) {
    e.preventDefault();
    setShowThankYouTxt(true);
    setTimeout(function () {
      setShowThankYouTxt(false);
      handleOnCloseModal();
    }, 1100);
  };
  var handleOnModalClick = function handleOnModalClick(e) {
    e.preventDefault();
    setModalIsOpen(true);
  };
  useEffect(function () {
    var _values$formLogic2, _values$formLogic2$ne;
    if ((_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && (_values$formLogic2$ne = _values$formLogic2.newProjectDonation) !== null && _values$formLogic2$ne !== void 0 && _values$formLogic2$ne.projectId) {
      var _values$formLogic3, _values$formLogic3$ne;
      var projectId = parseInt((_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : (_values$formLogic3$ne = _values$formLogic3.newProjectDonation) === null || _values$formLogic3$ne === void 0 ? void 0 : _values$formLogic3$ne.projectId, 10);
      var description = getProjectDescription(projects, projectId);
      if (description) {
        setProjectDescription(description);
      }
    }
  }, [(_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.newProjectDonation]);
  useEffect(function () {
    if ((projectOptions === null || projectOptions === void 0 ? void 0 : projectOptions.length) > 0) {
      var whereMostNeeded = projects.find(function (project) {
        return (project === null || project === void 0 ? void 0 : project.title) === WHERE_MOST_NEEDED_TITLE;
      });
      var isWhereMostNeededAvailable = projectOptions.some(function (project) {
        return (project === null || project === void 0 ? void 0 : project.projectId) === (whereMostNeeded === null || whereMostNeeded === void 0 ? void 0 : whereMostNeeded.projectId);
      });
      if (whereMostNeeded !== null && whereMostNeeded !== void 0 && whereMostNeeded.description && isWhereMostNeededAvailable) {
        setFieldValue('formLogic.newProjectDonation.projectId', "".concat(whereMostNeeded === null || whereMostNeeded === void 0 ? void 0 : whereMostNeeded.projectId));
        setProjectDescription(whereMostNeeded === null || whereMostNeeded === void 0 ? void 0 : whereMostNeeded.description);
      } else {
        var _projectOptions$;
        var projectId = (_projectOptions$ = projectOptions[0]) === null || _projectOptions$ === void 0 ? void 0 : _projectOptions$.projectId;
        var description = getProjectDescription(projects, projectId);
        if (description) {
          setFieldValue('formLogic.newProjectDonation.projectId', "".concat(projectId));
          setProjectDescription(description);
        }
      }
    }
  }, [projectOptions]);
  return {
    defaultValue: defaultValue,
    modalIsOpen: modalIsOpen,
    projectDescription: projectDescription,
    selectProjectOptions: selectProjectOptions,
    showThankYouTxt: showThankYouTxt,
    handleOnCloseModal: handleOnCloseModal,
    handleOnModalClick: handleOnModalClick,
    handleOnAddModalClick: handleOnAddModalClick
  };
};

var handleRecurringLogic = function handleRecurringLogic(_ref) {
  var _values$formLogic;
  var values = _ref.values,
    setFieldValue = _ref.setFieldValue;
  if (values !== null && values !== void 0 && (_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && _values$formLogic.recurringDateNum) {
    var _values$formLogic2;
    var recurringDateNum = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.recurringDateNum;
    var startDate = calculateStartDate("".concat(recurringDateNum));
    if (isValidDate(startDate)) {
      setFieldValue('formLogic.recurringDate', startDate);
    }
  }
};
var handleCookieDisable = function handleCookieDisable(_ref2) {
  var shouldRedirectToProject = _ref2.shouldRedirectToProject,
    projects = _ref2.projects,
    queryProjectDict = _ref2.queryProjectDict;
  if (shouldRedirectToProject && queryProjectDict !== null && queryProjectDict !== void 0 && queryProjectDict.projectId) {
    var _projects$find;
    var projectId = Number(queryProjectDict === null || queryProjectDict === void 0 ? void 0 : queryProjectDict.projectId);
    var projectSlug = projects === null || projects === void 0 ? void 0 : (_projects$find = projects.find(function (prj) {
      return (prj === null || prj === void 0 ? void 0 : prj.projectId) === projectId;
    })) === null || _projects$find === void 0 ? void 0 : _projects$find.slug;
    if (projectSlug) {
      window.location.href = "/".concat(projectSlug);
    }
  }
};

var MAX_INPUT_LENGTH = 32;
var volunteerAppFields = function volunteerAppFields() {
  var _useTranslation = useTranslation(['common', 'labels', 'resource', 'validation']),
    t = _useTranslation.t;
  var aboutYourChurchLabel = t('About Your Church', {
    ns: 'common'
  });
  var churchWebsite = t('Church Website', {
    ns: 'labels'
  });
  var yearsKnownPastorLabel = t('How long have you known your pastor?', {
    ns: 'labels'
  });
  var yearsKnownLabel = t('How long have you known this reference?', {
    ns: 'labels'
  });
  var yearsKnownOptions = [{
    value: t('Please make a selection', {
      ns: 'labels'
    }),
    id: ''
  }, {
    value: t('Less than 1 year', {
      ns: 'labels'
    }),
    id: 'Less than 1 year'
  }, {
    value: t('1 to 4 years', {
      ns: 'labels'
    }),
    id: '1 to 4 years'
  }, {
    value: t('4 to 10 years', {
      ns: 'labels'
    }),
    id: '4 to 10 years'
  }, {
    value: t('10 to 20 years', {
      ns: 'labels'
    }),
    id: '10 to 20 years'
  }, {
    value: t('More than 20 years', {
      ns: 'labels'
    }),
    id: 'More than 20 years'
  }];
  var firstReferenceLabel = t('First Personal Reference', {
    ns: 'labels'
  });
  var secondReferenceLabel = t('Second Personal Reference', {
    ns: 'labels'
  });
  var referenceDescription = t('This reference can be a friend, a business associate, etc., but not a family member or an individual on staff with your church. You must have known the person for at least 6 months.', {
    ns: 'labels'
  });
  var statementLabel = t("By typing my full name and today's date in the signature box below, I am agreeing to that being used as my signature of acceptance. *", {
    ns: 'labels'
  });
  var passionateQuestion = "".concat(t('What are you passionate about? How are you actively responding to that passion now?', {
    ns: 'labels'
  }), " *");
  var goalQuestion = "".concat(t('Describe a goal you have set and recently accomplished?', {
    ns: 'labels'
  }), " *");
  var localChurchQuestion = "".concat(t("From your perspective, what role does the local church play in a believer's life?", {
    ns: 'labels'
  }), " *");
  var strengthWeaknessQuestion = "".concat(t('Name three of your strengths and three of your weaknesses.', {
    ns: 'labels'
  }), " *");
  var dailyCommitmentsQuestion = "".concat(t('What are your current daily commitments?', {
    ns: 'labels'
  }), " *");
  var conflictQuestion = "".concat(t('How do you respond to tension or conflict?', {
    ns: 'labels'
  }), " *");
  var languagesQuestion = t('What language(s) other than English do you speak and write fluently?', {
    ns: 'labels'
  });
  var leadershipQuestion = "".concat(t('What leadership experience do you have?', {
    ns: 'labels'
  }), " *");
  var fulfillingServingQuestion = "".concat(t('What do you find fulfilling in serving on a team?', {
    ns: 'labels'
  }), " *");
  var valueLocalChurchQuestion = "".concat(t('What value do you bring to your local church?', {
    ns: 'labels'
  }), " *");
  var spiritualJourneyQuestion = "".concat(t('Describe your spiritual journey.', {
    ns: 'labels'
  }), " *");
  var desiresHeartQuestion = "".concat(t('What desires are in your heart to accomplish?', {
    ns: 'labels'
  }), " *");
  var commitmentDifficultQuestion = "".concat(t('Describe a time when you have made a commitment that was difficult to see through.', {
    ns: 'labels'
  }), " *");
  var referencesLabel = t('References', {
    ns: 'labels'
  });
  var dateLabel = t('Date', {
    ns: 'labels'
  });
  return {
    aboutYourChurchLabel: aboutYourChurchLabel,
    churchWebsite: churchWebsite,
    commitmentDifficultQuestion: commitmentDifficultQuestion,
    conflictQuestion: conflictQuestion,
    dailyCommitmentsQuestion: dailyCommitmentsQuestion,
    dateLabel: dateLabel,
    desiresHeartQuestion: desiresHeartQuestion,
    firstReferenceLabel: firstReferenceLabel,
    fulfillingServingQuestion: fulfillingServingQuestion,
    goalQuestion: goalQuestion,
    languagesQuestion: languagesQuestion,
    leadershipQuestion: leadershipQuestion,
    localChurchQuestion: localChurchQuestion,
    passionateQuestion: passionateQuestion,
    referencesLabel: referencesLabel,
    referenceDescription: referenceDescription,
    secondReferenceLabel: secondReferenceLabel,
    spiritualJourneyQuestion: spiritualJourneyQuestion,
    statementLabel: statementLabel,
    strengthWeaknessQuestion: strengthWeaknessQuestion,
    yearsKnownLabel: yearsKnownLabel,
    yearsKnownOptions: yearsKnownOptions,
    yearsKnownPastorLabel: yearsKnownPastorLabel,
    valueLocalChurchQuestion: valueLocalChurchQuestion
  };
};
var getInquirerResponseFields = function getInquirerResponseFields() {
  var _useTranslation2 = useTranslation(['common', 'labels', 'resource', 'validation']),
    t = _useTranslation2.t;
  var formHeader = t('Take the next step in your life with Christ!  Please tell us about your decision.', {
    ns: 'labels'
  });
  var fourteenLabel = t('Are you 14 years or older?', {
    ns: 'labels'
  });
  var sixteenLabel = t('Are you 16 years or older?', {
    ns: 'labels'
  });
  var thirteenLabel = t('Are you 13 years or older?', {
    ns: 'labels'
  });
  var churchStreet = t('Church Street', {
    ns: 'labels'
  });
  var churcSubCity = t('Church SubCity', {
    ns: 'labels'
  });
  var churchCity = t('Church City', {
    ns: 'labels'
  });
  var administrativeRegion = t('Administrative Region', {
    ns: 'labels'
  });
  var churchDistrict = t('Church District', {
    ns: 'labels'
  });
  var speakCounselorText = t('If you are age 15 or under, please speak to a counselor near the platform.', {
    ns: 'labels'
  });
  var acceptJesusQuestion = "".concat(t('Did you accept Jesus Christ as your personal Savior today?', {
    ns: 'labels'
  }));
  var faithDescription = "".concat(t('If No, which statement best describes your response today?', {
    ns: 'labels'
  }));
  var streetNumber = "".concat(t('Street, Number', {
    ns: 'labels'
  }), "*");
  var findChurchText = t("Do you have a church home? We would love to help you find a church if you don't have one.", {
    ns: 'labels'
  });
  var selectOptionText = t('Please select an option.', {
    ns: 'labels'
  });
  var consentStatement = t('Consent Statement and Privacy link', {
    ns: 'common'
  });
  var ageLabel = "".concat(t('Age', {
    ns: 'labels'
  }), "*");
  return {
    acceptJesusQuestion: acceptJesusQuestion,
    administrativeRegion: administrativeRegion,
    ageLabel: ageLabel,
    churchCity: churchCity,
    churchDistrict: churchDistrict,
    churchStreet: churchStreet,
    churcSubCity: churcSubCity,
    consentStatement: consentStatement,
    faithDescription: faithDescription,
    findChurchText: findChurchText,
    formHeader: formHeader,
    fourteenLabel: fourteenLabel,
    sixteenLabel: sixteenLabel,
    selectOptionText: selectOptionText,
    speakCounselorText: speakCounselorText,
    streetNumber: streetNumber,
    thirteenLabel: thirteenLabel
  };
};
var getTranslationFields = function getTranslationFields() {
  var _useTranslation3 = useTranslation(['common', 'labels', 'resource', 'validation']),
    t = _useTranslation3.t;
  var phoneLabel = t('Phone Number', {
    ns: 'labels'
  });
  var postalCodeLabel = t('Postal Code', {
    ns: 'labels'
  });
  var prefixLabel = t('Prefix', {
    ns: 'labels'
  });
  var requiredLabel = t('Required', {
    ns: 'validation'
  });
  var roleLabel = t('What is your role?', {
    ns: 'labels'
  });
  var routingNumberText = t('routing_number', {
    ns: 'resource'
  });
  var stateProvinceLabel = t('State/Province', {
    ns: 'labels'
  });
  var submitLabel = t('Submit', {
    ns: 'labels'
  });
  var useAnotherEmail = t('Apologies, please use another email address', {
    ns: 'validation'
  });
  var validEmailAddress = t('Valid email address', {
    ns: 'validation'
  });
  var streetAddressLabel = t('Street Address', {
    ns: 'labels'
  });
  var suburbLabel = t('Suburb', {
    ns: 'labels'
  });
  var stateLabel = t('State', {
    ns: 'labels'
  });
  var postCodeLabel = t('Postcode', {
    ns: 'labels'
  });
  var yourInformationLabel = t('Your Information', {
    ns: 'labels'
  });
  var yourChurchInformationLabel = t("Your Church's Information", {
    ns: 'labels'
  });
  var selectOneLabel = t('Select One', {
    ns: 'labels'
  });
  var privacyPolicyLabel = t('privacy policy', {
    ns: 'labels'
  });
  var rePrivacyPolicyLabel = t('recaptcha privacy policy', {
    ns: 'labels'
  });
  var genderLabel = t('Gender', {
    ns: 'common'
  });
  var maleLabel = t('Male', {
    ns: 'common'
  });
  var femaleLabel = t('Female', {
    ns: 'common'
  });
  var districtLabel = t('District', {
    ns: 'labels'
  });
  var subCityLabel = t('Subcity', {
    ns: 'labels'
  });
  var recaptchaMessage = t('This site is protected by reCAPTCHA and the Google', {
    ns: 'labels'
  });
  var termsOfService = t('Terms of Service', {
    ns: 'labels'
  });
  var apply = t('apply', {
    ns: 'labels'
  });
  var and = t('and', {
    ns: 'labels'
  });
  return {
    and: and,
    apply: apply,
    districtLabel: districtLabel,
    femaleLabel: femaleLabel,
    genderLabel: genderLabel,
    maleLabel: maleLabel,
    phoneLabel: phoneLabel,
    postalCodeLabel: postalCodeLabel,
    postCodeLabel: postCodeLabel,
    prefixLabel: prefixLabel,
    privacyPolicyLabel: privacyPolicyLabel,
    rePrivacyPolicyLabel: rePrivacyPolicyLabel,
    recaptchaMessage: recaptchaMessage,
    requiredLabel: requiredLabel,
    roleLabel: roleLabel,
    routingNumberText: routingNumberText,
    selectOneLabel: selectOneLabel,
    stateLabel: stateLabel,
    stateProvinceLabel: stateProvinceLabel,
    streetAddressLabel: streetAddressLabel,
    subCityLabel: subCityLabel,
    submitLabel: submitLabel,
    suburbLabel: suburbLabel,
    termsOfService: termsOfService,
    useAnotherEmail: useAnotherEmail,
    validEmailAddress: validEmailAddress,
    yourChurchInformationLabel: yourChurchInformationLabel,
    yourInformationLabel: yourInformationLabel
  };
};
var useTranslationHelper = function useTranslationHelper() {
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useTranslation4 = useTranslation(['common', 'labels', 'resource', 'validation']),
    t = _useTranslation4.t;
  var attendanceLabel = t('Average Sunday Morning Attendance', {
    ns: 'labels'
  });
  var capacityLabel = t('Sanctuary Capacity', {
    ns: 'labels'
  });
  var accountNumberText = t('bank_account', {
    ns: 'resource'
  });
  var address1Label = t(['Address 1'], {
    ns: 'labels'
  });
  var address2Label = "".concat(t(['Address 2'], {
    ns: 'labels'
  }));
  var address3Label = "".concat(t(['Address 3'], {
    ns: 'labels'
  }));
  var autoCompleteLabel = t('Find your address', {
    ns: 'labels'
  });
  var belowSelectedText = t('the date selected below', {
    ns: 'common'
  });
  var cardNumberText = t('number', {
    ns: 'resource'
  });
  var checkingInfoText = t('Checking Account Information', {
    ns: 'common'
  });
  var churchAddressLabel = t('Church Address', {
    ns: 'labels'
  });
  var churchLabel = t('Church Name', {
    ns: 'labels'
  });
  var churchLangQuestionLabel = t('Is the primary language spoken at your church English or Spanish?', {
    ns: 'common'
  });
  var churchPhoneLabel = t('Church Phone', {
    ns: 'labels'
  });
  var cityLabel = t(['City'], {
    ns: 'labels'
  });
  var countryLabel = t('Country', {
    ns: 'labels'
  });
  var ccInfoText = t('Credit Card Information', {
    ns: 'common'
  });
  var cvvText = t('cvv', {
    ns: 'resource'
  });
  var emailLabel = t('Email Address', {
    ns: 'labels'
  });
  var enterValidEmail = t('Please enter a valid email', {
    ns: 'validation'
  });
  var expirationText = t('expy_double_dropdown', {
    ns: 'resource'
  });
  var invalidEmail = t('Invalid email address', {
    ns: 'validation'
  });
  var invalid = t('Invalid', {
    ns: 'validation'
  });
  var invalidPostalCode = t('Invalid Postal Code', {
    ns: 'validation'
  });
  var fNameLabel = t('First Name', {
    ns: 'labels'
  });
  var lNameLabel = t('Last Name', {
    ns: 'labels'
  });
  var maxCharsTxt = t('maxChars', {
    ns: 'validation',
    max: MAX_INPUT_LENGTH
  });
  var middleNameLabel = t('Middle Name', {
    ns: 'labels'
  });
  var nameLabel = t('Name', {
    ns: 'labels'
  });
  var nameTitleOptions = {
    '': t('Select One', {
      ns: 'labels'
    }),
    'Dr.': t('Dr.', {
      ns: 'labels'
    }),
    'Mr.': t('Mr.', {
      ns: 'labels'
    }),
    'Mrs.': t('Mrs.', {
      ns: 'labels'
    }),
    'Ms.': t('Ms.', {
      ns: 'labels'
    }),
    'Pastor': t('Pastor', {
      ns: 'labels'
    }),
    'Rev': t('Reverend', {
      ns: 'labels'
    })
  };
  var howWouldYouLikeToGive = t('How would you like to give today?', {
    ns: 'labels'
  });
  var debitCreditText = t('Debit/Credit Card', {
    ns: 'labels'
  });
  var electronicCheckText = t('Electronic Check', {
    ns: 'labels'
  });
  var billingInformationText = t('Billing Information', {
    ns: 'labels'
  });
  var startTypingAddressText = t('Start typing address', {
    ns: 'labels'
  });
  var selectText = t('Select', {
    ns: 'labels'
  });
  var _getTranslationFields = getTranslationFields(),
    and = _getTranslationFields.and,
    apply = _getTranslationFields.apply,
    districtLabel = _getTranslationFields.districtLabel,
    femaleLabel = _getTranslationFields.femaleLabel,
    genderLabel = _getTranslationFields.genderLabel,
    maleLabel = _getTranslationFields.maleLabel,
    phoneLabel = _getTranslationFields.phoneLabel,
    postalCodeLabel = _getTranslationFields.postalCodeLabel,
    postCodeLabel = _getTranslationFields.postCodeLabel,
    prefixLabel = _getTranslationFields.prefixLabel,
    privacyPolicyLabel = _getTranslationFields.privacyPolicyLabel,
    rePrivacyPolicyLabel = _getTranslationFields.rePrivacyPolicyLabel,
    recaptchaMessage = _getTranslationFields.recaptchaMessage,
    requiredLabel = _getTranslationFields.requiredLabel,
    roleLabel = _getTranslationFields.roleLabel,
    routingNumberText = _getTranslationFields.routingNumberText,
    selectOneLabel = _getTranslationFields.selectOneLabel,
    stateLabel = _getTranslationFields.stateLabel,
    stateProvinceLabel = _getTranslationFields.stateProvinceLabel,
    streetAddressLabel = _getTranslationFields.streetAddressLabel,
    submitLabel = _getTranslationFields.submitLabel,
    subCityLabel = _getTranslationFields.subCityLabel,
    suburbLabel = _getTranslationFields.suburbLabel,
    termsOfService = _getTranslationFields.termsOfService,
    useAnotherEmail = _getTranslationFields.useAnotherEmail,
    validEmailAddress = _getTranslationFields.validEmailAddress,
    yourChurchInformationLabel = _getTranslationFields.yourChurchInformationLabel,
    yourInformationLabel = _getTranslationFields.yourInformationLabel;
  var _getInquirerResponseF = getInquirerResponseFields(),
    acceptJesusQuestion = _getInquirerResponseF.acceptJesusQuestion,
    administrativeRegion = _getInquirerResponseF.administrativeRegion,
    ageLabel = _getInquirerResponseF.ageLabel,
    churchCity = _getInquirerResponseF.churchCity,
    churchStreet = _getInquirerResponseF.churchStreet,
    churcSubCity = _getInquirerResponseF.churcSubCity,
    churchDistrict = _getInquirerResponseF.churchDistrict,
    consentStatement = _getInquirerResponseF.consentStatement,
    faithDescription = _getInquirerResponseF.faithDescription,
    findChurchText = _getInquirerResponseF.findChurchText,
    formHeader = _getInquirerResponseF.formHeader,
    fourteenLabel = _getInquirerResponseF.fourteenLabel,
    sixteenLabel = _getInquirerResponseF.sixteenLabel,
    selectOptionText = _getInquirerResponseF.selectOptionText,
    speakCounselorText = _getInquirerResponseF.speakCounselorText,
    streetNumber = _getInquirerResponseF.streetNumber,
    thirteenLabel = _getInquirerResponseF.thirteenLabel;
  var _volunteerAppFields = volunteerAppFields(),
    aboutYourChurchLabel = _volunteerAppFields.aboutYourChurchLabel,
    churchWebsite = _volunteerAppFields.churchWebsite,
    commitmentDifficultQuestion = _volunteerAppFields.commitmentDifficultQuestion,
    conflictQuestion = _volunteerAppFields.conflictQuestion,
    dailyCommitmentsQuestion = _volunteerAppFields.dailyCommitmentsQuestion,
    dateLabel = _volunteerAppFields.dateLabel,
    desiresHeartQuestion = _volunteerAppFields.desiresHeartQuestion,
    firstReferenceLabel = _volunteerAppFields.firstReferenceLabel,
    fulfillingServingQuestion = _volunteerAppFields.fulfillingServingQuestion,
    goalQuestion = _volunteerAppFields.goalQuestion,
    languagesQuestion = _volunteerAppFields.languagesQuestion,
    leadershipQuestion = _volunteerAppFields.leadershipQuestion,
    localChurchQuestion = _volunteerAppFields.localChurchQuestion,
    passionateQuestion = _volunteerAppFields.passionateQuestion,
    referencesLabel = _volunteerAppFields.referencesLabel,
    referenceDescription = _volunteerAppFields.referenceDescription,
    secondReferenceLabel = _volunteerAppFields.secondReferenceLabel,
    spiritualJourneyQuestion = _volunteerAppFields.spiritualJourneyQuestion,
    statementLabel = _volunteerAppFields.statementLabel,
    strengthWeaknessQuestion = _volunteerAppFields.strengthWeaknessQuestion,
    yearsKnownLabel = _volunteerAppFields.yearsKnownLabel,
    yearsKnownOptions = _volunteerAppFields.yearsKnownOptions,
    yearsKnownPastorLabel = _volunteerAppFields.yearsKnownPastorLabel,
    valueLocalChurchQuestion = _volunteerAppFields.valueLocalChurchQuestion;
  var addressTranslations = {
    and: and,
    apply: apply,
    acceptJesusQuestion: acceptJesusQuestion,
    accountNumberText: accountNumberText,
    administrativeRegion: administrativeRegion,
    address1Label: address1Label,
    address2Label: address2Label,
    address3Label: address3Label,
    ageLabel: ageLabel,
    attendanceLabel: attendanceLabel,
    autoCompleteLabel: autoCompleteLabel,
    belowSelectedText: belowSelectedText,
    billingInformationText: billingInformationText,
    capacityLabel: capacityLabel,
    cardNumberText: cardNumberText,
    ccInfoText: ccInfoText,
    checkingInfoText: checkingInfoText,
    churchAddressLabel: churchAddressLabel,
    churchCity: churchCity,
    churchDistrict: churchDistrict,
    churchStreet: churchStreet,
    churcSubCity: churcSubCity,
    churchLabel: churchLabel,
    churchLangQuestionLabel: churchLangQuestionLabel,
    churchPhoneLabel: churchPhoneLabel,
    churchWebsite: churchWebsite,
    cityLabel: cityLabel,
    consentStatement: consentStatement,
    countryLabel: countryLabel,
    cvvText: cvvText,
    debitCreditText: debitCreditText,
    districtLabel: districtLabel,
    electronicCheckText: electronicCheckText,
    emailLabel: emailLabel,
    enterValidEmail: enterValidEmail,
    expirationText: expirationText,
    faithDescription: faithDescription,
    femaleLabel: femaleLabel,
    findChurchText: findChurchText,
    formHeader: formHeader,
    fourteenLabel: fourteenLabel,
    sixteenLabel: sixteenLabel,
    genderLabel: genderLabel,
    howWouldYouLikeToGive: howWouldYouLikeToGive,
    invalid: invalid,
    invalidEmail: invalidEmail,
    invalidPostalCode: invalidPostalCode,
    fNameLabel: fNameLabel,
    lNameLabel: lNameLabel,
    maleLabel: maleLabel,
    maxCharsTxt: maxCharsTxt,
    middleNameLabel: middleNameLabel,
    nameLabel: nameLabel,
    nameTitleOptions: nameTitleOptions,
    phoneLabel: phoneLabel,
    postalCodeLabel: postalCodeLabel,
    postCodeLabel: postCodeLabel,
    prefixLabel: prefixLabel,
    privacyPolicyLabel: privacyPolicyLabel,
    rePrivacyPolicyLabel: rePrivacyPolicyLabel,
    recaptchaMessage: recaptchaMessage,
    requiredLabel: requiredLabel,
    roleLabel: roleLabel,
    routingNumberText: routingNumberText,
    selectOneLabel: selectOneLabel,
    selectOptionText: selectOptionText,
    selectText: selectText,
    speakCounselorText: speakCounselorText,
    stateLabel: stateLabel,
    stateProvinceLabel: stateProvinceLabel,
    startTypingAddressText: startTypingAddressText,
    streetAddressLabel: streetAddressLabel,
    streetNumber: streetNumber,
    subCityLabel: subCityLabel,
    submitLabel: submitLabel,
    suburbLabel: suburbLabel,
    termsOfService: termsOfService,
    thirteenLabel: thirteenLabel,
    useAnotherEmail: useAnotherEmail,
    validEmailAddress: validEmailAddress,
    yourChurchInformationLabel: yourChurchInformationLabel,
    yourInformationLabel: yourInformationLabel,
    aboutYourChurchLabel: aboutYourChurchLabel,
    commitmentDifficultQuestion: commitmentDifficultQuestion,
    conflictQuestion: conflictQuestion,
    dailyCommitmentsQuestion: dailyCommitmentsQuestion,
    dateLabel: dateLabel,
    desiresHeartQuestion: desiresHeartQuestion,
    firstReferenceLabel: firstReferenceLabel,
    fulfillingServingQuestion: fulfillingServingQuestion,
    goalQuestion: goalQuestion,
    languagesQuestion: languagesQuestion,
    leadershipQuestion: leadershipQuestion,
    localChurchQuestion: localChurchQuestion,
    passionateQuestion: passionateQuestion,
    referencesLabel: referencesLabel,
    referenceDescription: referenceDescription,
    secondReferenceLabel: secondReferenceLabel,
    spiritualJourneyQuestion: spiritualJourneyQuestion,
    statementLabel: statementLabel,
    strengthWeaknessQuestion: strengthWeaknessQuestion,
    yearsKnownLabel: yearsKnownLabel,
    yearsKnownOptions: yearsKnownOptions,
    yearsKnownPastorLabel: yearsKnownPastorLabel,
    valueLocalChurchQuestion: valueLocalChurchQuestion
  };
  useEffect(function () {
    if (values.formLogic.language) {
      setFieldValue('translations', addressTranslations);
    }
  }, [values.formLogic.language]);
  useEffect(function () {
    setFieldValue('translations', addressTranslations);
  }, []);
  return {
    translations: addressTranslations,
    values: values
  };
};

var useCheckout = function useCheckout(_ref) {
  var _values$formLogic, _values$formLogic2, _values$formLogic2$pa, _values$formLogic3, _values$formLogic3$pa, _Object$keys, _values$formLogic4, _values$formLogic6, _values$formLogic7, _values$formLogic8;
  var enableApayPayment = _ref.enableApayPayment,
    giftOffer = _ref.giftOffer,
    projects = _ref.projects,
    _ref$showFreeGiftOffe = _ref.showFreeGiftOffer,
    showFreeGiftOffer = _ref$showFreeGiftOffe === void 0 ? false : _ref$showFreeGiftOffe,
    _ref$showUpgradeGift = _ref.showUpgradeGift,
    showUpgradeGift = _ref$showUpgradeGift === void 0 ? false : _ref$showUpgradeGift,
    siteId = _ref.siteId,
    usePaypalCaptureOnly = _ref.usePaypalCaptureOnly;
  useTranslationHelper();
  var _useLocalStorage = useLocalStorage(siteId, ''),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    cartInfo = _useLocalStorage2[0],
    setCartInfo = _useLocalStorage2[1];
  var cartObj = cartInfo ? JSON.parse(cartInfo) : {};
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values,
    errors = _useFormikContext.errors,
    touched = _useFormikContext.touched;
  var token = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.token) || '';
  var loggingHandler = useCreateLogging({
    key: token,
    values: values
  });
  var site = getSiteUrl(values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$pa = _values$formLogic2.parentDocumentInfo) === null || _values$formLogic2$pa === void 0 ? void 0 : _values$formLogic2$pa.documentLocationHref);
  var isStorageDisabled = !isCookieEnabled || !isLocalStorageAvailable;
  var _useCart = useCart({
      cartObj: cartObj,
      projects: projects,
      setCartInfo: setCartInfo
    }),
    currencyError = _useCart.currencyError,
    projectOptions = _useCart.projectOptions,
    showPayment = _useCart.showPayment,
    getProjectInfo = _useCart.getProjectInfo,
    getUpdatedProjectInfo = _useCart.getUpdatedProjectInfo,
    handleFrequencyOnChange = _useCart.handleFrequencyOnChange,
    handleOnAddClick = _useCart.handleOnAddClick,
    handleOnContinueClick = _useCart.handleOnContinueClick,
    handleOnDeleteClick = _useCart.handleOnDeleteClick,
    handleOnChange = _useCart.handleOnChange,
    setProjectOptions = _useCart.setProjectOptions;
  var queryProjectDict = getQueryStringDict((values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : (_values$formLogic3$pa = _values$formLogic3.parentDocumentInfo) === null || _values$formLogic3$pa === void 0 ? void 0 : _values$formLogic3$pa.formQueryString) || '');
  var hasQueryParams = ((_Object$keys = Object.keys(queryProjectDict)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0;
  var _useState = useState({}),
    _useState2 = _slicedToArray(_useState, 2),
    addedItem = _useState2[0],
    setAddedItem = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showInvalidProjectError = _useState4[0],
    setShowInvalidProjectError = _useState4[1];
  var hasRecurringPayment = hasRecurringPaymentType(cartObj);
  var hasCartPayment = hasPayment(cartObj);
  var enableContinueButton = shouldEnableButton({
    currencyError: currencyError,
    hasCartPayment: hasCartPayment,
    hasRecurringPayment: hasRecurringPayment,
    values: values
  });
  var availableChargeDates = getAvailabilityChargeDates();
  var chrgDates = convertOptionsToList(availableChargeDates);
  var chargeDates = [{
    id: '',
    value: 'Select'
  }].concat(_toConsumableArray(chrgDates));
  var display = {
    display: 'flex'
  };
  var availableChargeMonths = getAvailabilityChargeMonths();
  var chargeMonths = [{
    value: 'Select',
    id: '',
    isDisabled: false
  }].concat(_toConsumableArray(availableChargeMonths));
  var donationFrequencyOptions = convertOptionsToList(DONATION_FREQUENCY_OPTIONS);
  var invalidProjectErrorMsg = 'This giving project is no longer available.';
  var invalidProjectErrorMsg2 = 'If you would like to help share the Gospel in other ways, please select another option below. If you have additional questions, please call 877-247-2426.';

  // invalidProjectErrorMsg
  var invalidProjectError = function invalidProjectError() {
    return !isStorageDisabled ? jsxs(Fragment, {
      children: [jsx("p", {
        className: "is-size-5 ",
        children: invalidProjectErrorMsg
      }), jsx("p", {
        children: invalidProjectErrorMsg2
      })]
    }) : jsxs(Fragment, {
      children: [jsx("p", {
        className: "is-size-5 ",
        children: invalidProjectErrorMsg
      }), jsxs("p", {
        children: ["If you would like to help share the Gospel in other ways, please select ", jsx("a", {
          href: "/giving-areas",
          children: "Giving Areas"
        }), " above."]
      })]
    });
  };
  var logging = /*#__PURE__*/function () {
    var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            _context.next = 3;
            return loggingHandler.createLogging(payload);
          case 3:
            _context.next = 7;
            break;
          case 5:
            _context.prev = 5;
            _context.t0 = _context["catch"](0);
          case 7:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 5]]);
    }));
    return function logging(_x) {
      return _ref2.apply(this, arguments);
    };
  }();
  useEffect(function () {
    updateCartInfo({
      cartInfo: cartInfo,
      values: values,
      getUpdatedProjectInfo: getUpdatedProjectInfo,
      setCartInfo: setCartInfo
    });
  }, [(_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.cartInfo]);
  useEffect(function () {
    var _Object$values;
    if (cartInfo && ((_Object$values = Object.values(cartInfo)) === null || _Object$values === void 0 ? void 0 : _Object$values.length) > 0) {
      setFieldValue('formLogic.cartInfo', cartObj);
    }
  }, [cartInfo]);
  useEffect(function () {
    var _values$formLogic5;
    if ((_values$formLogic5 = values.formLogic) !== null && _values$formLogic5 !== void 0 && _values$formLogic5.recurringDate) {
      var projectItem = getUpdatedProjectInfo();
      setCartInfo(JSON.stringify(projectItem));
    }
  }, [(_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : _values$formLogic6.recurringDate]);
  useEffect(function () {
    handleRecurringLogic({
      values: values,
      setFieldValue: setFieldValue
    });
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : _values$formLogic7.recurringDateNum]);
  useEffect(function () {
    updateRecurringPayment({
      cartObj: cartObj,
      hasRecurringPayment: hasRecurringPayment,
      values: values,
      setFieldValue: setFieldValue,
      setCartInfo: setCartInfo
    });
  }, [hasRecurringPayment]);
  useEffect(function () {
    if ((projectOptions === null || projectOptions === void 0 ? void 0 : projectOptions.length) === 0) {
      setAddedItem({});
    }
  }, [projectOptions]);
  useEffect(function () {
    updateSelectedProject({
      addedItem: addedItem,
      cartObj: cartObj,
      projectOptions: projectOptions,
      projects: projects,
      values: values,
      setAddedItem: setAddedItem,
      setCartInfo: setCartInfo,
      setProjectOptions: setProjectOptions
    });
  }, [(_values$formLogic8 = values.formLogic) === null || _values$formLogic8 === void 0 ? void 0 : _values$formLogic8.selectedProjectDonation]);
  useEffect(function () {
    handleCookieDisable({
      shouldRedirectToProject: isStorageDisabled,
      projects: projects,
      queryProjectDict: queryProjectDict
    });
  }, [isStorageDisabled]);
  useEffect(function () {
    setFormId({
      templateName: Templates.CHECKOUT,
      values: values,
      setFieldValue: setFieldValue
    });
    var projectId = queryProjectDict === null || queryProjectDict === void 0 ? void 0 : queryProjectDict.projectId;
    var paytmentType = PAYMENT_TYPE_OPTIONS[queryProjectDict === null || queryProjectDict === void 0 ? void 0 : queryProjectDict.type];
    var amount = queryProjectDict === null || queryProjectDict === void 0 ? void 0 : queryProjectDict.amount;
    var productId = queryProjectDict === null || queryProjectDict === void 0 ? void 0 : queryProjectDict.productId;
    if ((queryProjectDict === null || queryProjectDict === void 0 ? void 0 : queryProjectDict.testRecaptchaFallback) === 'true') {
      setFieldValue('formLogic.testRecaptchaFallback', true);
    }
    if (usePaypalCaptureOnly) {
      setFieldValue('formLogic.usePaypalCaptureOnly', true);
    }
    setFieldValue("formLogic.disablePaypalGiftOffer", true, false);
    handleCheckoutComponentDidMount({
      amount: amount,
      cartObj: cartObj,
      enableApayPayment: enableApayPayment,
      giftOffer: giftOffer,
      getProjectInfo: getProjectInfo,
      hasQueryParams: hasQueryParams,
      invalidProjectErrorMsg: invalidProjectErrorMsg,
      paytmentType: paytmentType,
      productId: productId,
      projectId: projectId,
      projectOptions: projectOptions,
      projects: projects,
      setAddedItem: setAddedItem,
      setCartInfo: setCartInfo,
      setFieldValue: setFieldValue,
      setProjectOptions: setProjectOptions,
      showFreeGiftOffer: showFreeGiftOffer,
      showUpgradeGift: showUpgradeGift,
      site: site,
      siteId: siteId,
      logging: logging,
      setShowInvalidProjectError: setShowInvalidProjectError
    });
  }, []);
  return {
    availableChargeDates: chargeDates,
    availableChargeMonth: chargeMonths,
    display: display,
    cartInfo: cartObj,
    currencyError: currencyError,
    donationFrequencyOptions: donationFrequencyOptions,
    enableContinueButton: enableContinueButton,
    errors: errors,
    hasRecurringPayment: hasRecurringPayment,
    isStorageDisabled: isStorageDisabled,
    projectOptions: projectOptions,
    showInvalidProjectError: showInvalidProjectError,
    showPayment: showPayment,
    touched: touched,
    values: values,
    handleFrequencyOnChange: handleFrequencyOnChange,
    handleOnAddClick: handleOnAddClick,
    handleOnContinueClick: handleOnContinueClick,
    handleOnDeleteClick: handleOnDeleteClick,
    handleOnChange: handleOnChange,
    invalidProjectError: invalidProjectError,
    setFieldValue: setFieldValue
  };
};

var _excluded$W = ["eventId", "isGroupLeader"];
var getChurchCodes = function getChurchCodes(_ref) {
  var codeKey = _ref.codeKey,
    codeValue = _ref.codeValue,
    eventId = _ref.eventId,
    isInternational = _ref.isInternational,
    language = _ref.language,
    languageCode = _ref.languageCode,
    props = _ref.props;
  return [].concat(_toConsumableArray(isInternational || props !== null && props !== void 0 && props.hasCooperatingChurch ? [{
    key: codeKey,
    value: '81'
  }] : []), _toConsumableArray(eventId && !isInternational || props !== null && props !== void 0 && props.hasCooperatingChurch ? [{
    key: codeKey,
    value: codeValue
  }] : []), _toConsumableArray(props !== null && props !== void 0 && props.languageCode ? [{
    key: languageCode,
    value: language === null || language === void 0 ? void 0 : language.toUpperCase()
  }] : []), _toConsumableArray(isInternational ? [{
    key: "A01c:DDCLANG",
    value: language === null || language === void 0 ? void 0 : language.toUpperCase()
  }] : []));
};
var useChurchInfo = function useChurchInfo(_ref2) {
  var _values$formLogic, _values$formLogic2, _values$formLogic5;
  var eventId = _ref2.eventId,
    _ref2$isGroupLeader = _ref2.isGroupLeader,
    isGroupLeader = _ref2$isGroupLeader === void 0 ? false : _ref2$isGroupLeader,
    props = _objectWithoutProperties(_ref2, _excluded$W);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var isInternational = (props === null || props === void 0 ? void 0 : props.destination) === 3;
  var codeKey = !isInternational ? "CRUSADE:".concat(eventId) : 'ATTRIBUTES';
  var codeValue = !isInternational ? 'EVENT' : eventId;
  var languageCode = !isInternational ? props === null || props === void 0 ? void 0 : props.languageCode : "A01c:".concat(props === null || props === void 0 ? void 0 : props.languageCode);
  var language = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.language) === Language.LO ? 'Lao' : values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.language;
  useEffect(function () {
    var _values$formLogic3, _values$formLogic4;
    // Set entity[1] for Church
    if ((_values$formLogic3 = values.formLogic) !== null && _values$formLogic3 !== void 0 && _values$formLogic3.churchInfo) {
      setFieldValue("collector.entity[1]", {});
      setFieldValue("collector.entity[1].address", []);
      setFieldValue("collector.entity[1].address[0].country", 'US');
      setFieldValue("collector.entity[1].orgs", {});
      if (isGroupLeader) {
        // For Group Leader, the entity[1] role will always be DTRGRPLD
        setFieldValue("collector.entity[1].orgs.role", 'DTRGRPLD');
      }
    } else if (((_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.churchInfo) === false) {
      var _values$collector$ent = _slicedToArray(values.collector.entity, 1),
        entity = _values$collector$ent[0];
      setFieldValue("collector.entity", [entity]);
    }
  }, [(_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : _values$formLogic5.churchInfo]);
  useEffect(function () {
    var codes = getChurchCodes({
      codeKey: codeKey,
      codeValue: codeValue,
      eventId: eventId,
      isInternational: isInternational,
      language: language,
      languageCode: languageCode,
      props: props
    });
    setFieldValue("collector.entity[1].code", codes);
  }, [props === null || props === void 0 ? void 0 : props.destination, language]);
  return {
    values: values
  };
};

var useChurchInterest = function useChurchInterest(_ref) {
  var languageOptions = _ref.languageOptions;
  useTranslationHelper();
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var isOver18 = values.formLogic.over18;
  var churchLangOptions = languageOptions === null || languageOptions === void 0 ? void 0 : languageOptions.map(function (lng) {
    return _objectSpread2(_objectSpread2({}, lng), {}, {
      id: "church".concat(lng === null || lng === void 0 ? void 0 : lng.id),
      name: "formLogic.church".concat(lng === null || lng === void 0 ? void 0 : lng.name)
    });
  });
  var visibleList = ['Name', 'Email', 'Phone'];
  var defaultAddressList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'];
  useEffect(function () {
    setFormId({
      templateName: Templates.CHURCH_INTEREST,
      values: values,
      setFieldValue: setFieldValue
    });
    setFieldValue('formLogic.templateName', Templates.CHURCH_INTEREST);
  }, []);
  return {
    churchLangOptions: churchLangOptions,
    defaultAddressList: defaultAddressList,
    isOver18: isOver18,
    values: values,
    visibleList: visibleList
  };
};

var useCitiesRolesChurchSelector = function useCitiesRolesChurchSelector(_ref) {
  var _values$formLogic;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var city = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.city;
  useEffect(function () {
    if (city) {
      var cityEvent = JSON.parse(city);
      var individualCodes = [];
      individualCodes[0] = {};
      individualCodes[0].key = "CRUSADE:".concat(cityEvent.crusadeCodeEventId);
      individualCodes[0].value = 'EVENT';
      individualCodes[1] = {};
      individualCodes[1].key = "CRUSADE:".concat(cityEvent.crusadeCodeEventId);
      individualCodes[1].value = props === null || props === void 0 ? void 0 : props.individualCrusadeCodeEventValue;
      setFieldValue("collector.entity[0].code", individualCodes);
    }
  }, [city]);
  return {
    city: city,
    values: values
  };
};

var Topics = [{
  id: 'General Comment/Question',
  value: 'General Comment/Question',
  isDisabled: false
}, {
  id: 'Spiritual Question',
  value: 'Spiritual Question'
}, {
  id: 'Celebrations',
  value: 'Celebrations'
}, {
  id: 'Festivals',
  value: 'Festivals'
}, {
  id: 'Rapid Response Team',
  value: 'Rapid Response Team'
}, {
  id: 'God Loves You Tour',
  value: 'God Loves You Tour'
}, {
  id: 'Radio',
  value: 'Radio'
}, {
  id: 'Decision Magazine',
  value: 'Decision Magazine'
}, {
  id: 'Billy Graham Library',
  value: 'Billy Graham Library'
}, {
  id: 'E-mail Newsletter Request/Confirmation',
  value: 'E-mail Newsletter Request/Confirmation'
}, {
  id: 'The Cove',
  value: 'The Cove'
}, {
  id: 'Non-English Request',
  value: 'Non-English Request'
}, {
  id: 'Media Inquiries',
  value: 'Media Inquiries'
}, {
  id: 'Gift Planning',
  value: 'Gift Planning'
}, {
  id: 'New Believer Materials',
  value: 'New Believer Materials'
}];

var maxCommentLength = 2000;

var PrivacyPolicyLaos = function PrivacyPolicyLaos() {
  return jsxs("div", {
    children: [jsx(Heading, {
      subtitle: true,
      textSize: 4,
      children: "\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0EAA\u0EB0\u0EA1\u0EB2\u0E84\u0EBB\u0EA1\u0E9B\u0EB0\u0E81\u0EB2\u0E94\u0E82\u0EC8\u0EB2\u0EA7\u0E9B\u0EB0\u0EC0\u0EAA\u0EB5\u0E94 \u0E9A\u0EB5\u0EA5\u0EB5\u0EC8 \u0EC1\u0E81\u0EA3\u0ECC\u0EC1\u0EAE\u0EA1"
    }), jsx(Block, {
      textSize: 6,
      children: "1. \u0E9A\u0EBB\u0E94\u0E99\u0EB3. \u0EAA\u0EB0\u0EA1\u0EB2\u0E84\u0EBB\u0EA1\u0E9B\u0EB0\u0E81\u0EB2\u0E94\u0E82\u0EC8\u0EB2\u0EA7\u0E9B\u0EB0\u0EC0\u0EAA\u0EB5\u0E94 \u0E9A\u0EB5\u0EA5\u0EB5\u0EC8 \u0EC1\u0E81\u0EA3\u0ECC\u0EC1\u0EAE\u0EA1 \u201CBGEA\u201D, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EA1\u0EB8\u0EC8\u0E87\u0EDD\u0EB1\u0EC9\u0E99\u0E97\u0EB5\u0EC8\u0E88\u0EB0\u0EAE\u0EB1\u0E81\u0EAA\u0EB2\u0E84\u0EA7\u0EB2\u0EA1\u0E96\u0EB7\u0E81\u0E95\u0EC9\u0EAD\u0E87, \u0E84\u0EA7\u0EB2\u0EA1\u0EA5\u0EB1\u0E9A \u0EC1\u0EA5\u0EB0 \u0E84\u0EA7\u0EB2\u0EA1\u0E9B\u0EAD\u0E94\u0EC4\u0E9E\u0EC3\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E99\u0EB5\u0EC9\u0EC3\u0E8A\u0EC9\u0E81\u0EB1\u0E9A\u0EA7\u0EB4\u0E97\u0EB5 \u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0ECD\u0EB2, \u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9 \u0EC1\u0EA5\u0EB0 \u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99 \u0EC3\u0E99\u0EC0\u0EA7\u0EA5\u0EB2\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EA1\u0EB5\u0EAA\u0EC8\u0EA7\u0E99\u0EAE\u0EC8\u0EA7\u0EA1 \u0E81\u0EB4\u0E94\u0E88\u0EB0\u0E81\u0ECD\u0EB2\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0E8D\u0EBB\u0E81\u0E95\u0EBB\u0EA7\u0EA2\u0EC8\u0EB2\u0E87, \u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E9E\u0EBB\u0EA7\u0E9E\u0EB1\u0E99\u0E81\u0EB1\u0E9A\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC4\u0E9B\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9C\u0EC8\u0EB2\u0E99\u0EAD\u0EB8\u0E9B\u0EB0\u0E81\u0EAD\u0E99\u0EA1\u0EB7\u0E96\u0EB7 \u0EAB\u0EBC\u0EB7 \u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EAE\u0EC8\u0EA7\u0EA1\u0E87\u0EB2\u0E99\u0E81\u0EB4\u0E94\u0E88\u0EB0\u0E81\u0ECD\u0EB2\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94."
    }), jsx(Block, {
      textSize: 6,
      children: "2. \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 BGEA \u0EC1\u0EA1\u0EC8\u0E99\u0EAD\u0EBB\u0E87\u0E81\u0EB2\u0E99\u0E9A\u0ECD\u0EC8\u0EAB\u0EA7\u0EB1\u0E87\u0E9C\u0EBB\u0E99\u0E81\u0EB3\u0EC4\u0EA5\u0E97\u0EB5\u0EC8\u0E88\u0EBB\u0E94\u0E97\u0EB0\u0E9A\u0EBD\u0E99 501(c)(3). \u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8\u0EAB\u0EC9\u0EAD\u0E87\u0E81\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC1\u0EA1\u0EC8\u0E99 1 Billy Graham Parkway, Charlotte, North Carolina, 28201, \u0E9B\u0EB0\u0EC0\u0E97\u0E94 \u0EAA\u0EB0\u0EAB\u0EB0\u0EA5\u0EB1\u0E94 \u0EAD\u0EB2\u0EC0\u0EA1\u0EA5\u0EB4\u0E81\u0EB2 \u0EAA\u0EB7\u0E9A\u0E95\u0ECD\u0EC8\u0EA7\u0EBD\u0E81\u0E87\u0EB2\u0E99\u0E95\u0EB0\u0EAB\u0EBC\u0EAD\u0E94\u0E8A\u0EB5\u0EA7\u0EB4\u0E94\u0E82\u0EAD\u0E87 \u0E9A\u0EB5\u0EA5\u0EB5\u0EC8 \u0EC1\u0E81\u0EA3\u0ECC\u0EC1\u0EAE\u0EA1, \u0EAA\u0EB0\u0EA1\u0EB2\u0E84\u0EBB\u0EA1\u0E9B\u0EB0\u0E81\u0EB2\u0E94\u0E82\u0EC8\u0EB2\u0EA7\u0E9B\u0EB0\u0EC0\u0EAA\u0EB5\u0E94\u0E82\u0EAD\u0E87 \u0E9A\u0EB5\u0EA5\u0EB5\u0EC8 \u0EC1\u0E81\u0EA3\u0ECC\u0EC1\u0EAE\u0EA1 \u0EA1\u0EB5\u0EA2\u0EB9\u0EC8\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EAA\u0EB0\u0EAB\u0E99\u0EB1\u0E9A\u0EAA\u0EB0\u0EAB\u0E99\u0EB9\u0E99\u0EC1\u0EA5\u0EB0\u0E82\u0EB0\u0EAB\u0E8D\u0EB2\u0E8D\u0E81\u0EB2\u0E99\u0E8A\u0EBB\u0E87\u0EC0\u0EAD\u0EB5\u0EC9\u0E99 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0E81\u0EB2\u0E94\u0E82\u0EC8\u0EB2\u0EA7\u0E9B\u0EB0\u0EC0\u0EAA\u0EB5\u0E94\u0E82\u0EAD\u0E87 \u0EC1\u0E9F\u0EA3\u0EC9\u0E87\u0EA5\u0EB4\u0E99 \u0EC1\u0E81\u0EA3\u0ECC\u0EC1\u0EAE\u0EA1 \u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0E81\u0EB2\u0E94\u0E9E\u0EA3\u0EB0\u0E81\u0EB4\u0E94\u0E95\u0EB4\u0E84\u0EB8\u0E99\u0E82\u0EAD\u0E87 \u0EAD\u0EBB\u0E87\u0E9E\u0EA3\u0EB0\u0EC0\u0EA2\u0E8A\u0EB9\u0E84\u0EA3\u0EB4\u0E94\u0EC0\u0E88\u0EBB\u0EC9\u0EB2 \u0E95\u0ECD\u0EC8\u0E97\u0EB8\u0E81\u0EAA\u0EB4\u0EC8\u0E87\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EC0\u0EAE\u0EB1\u0E94\u0E94\u0EC9\u0EA7\u0E8D\u0E97\u0EB8\u0E81\u0EA7\u0EB4\u0E97\u0EB5\u0E97\u0EB2\u0E87\u0E97\u0EB5\u0EC8\u0EA1\u0EB5\u0E9B\u0EB0\u0EAA\u0EB4\u0E94\u0E95\u0EB4\u0E9C\u0EBB\u0E99\u0EAA\u0EB3\u0EA5\u0EB1\u0E9A\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EC1\u0EA5\u0EB0 \u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0EAA\u0EB0\u0EAB\u0E99\u0EAD\u0E87\u0E95\u0ECD\u0EC8\u0E84\u0EA3\u0EB4\u0EAA\u0E95\u0EB0\u0E88\u0EB1\u0E81 \u0EC1\u0EA5\u0EB0 \u0EAD\u0EB7\u0EC8\u0E99\u0EC6\u0EC3\u0EAB\u0EC9\u0EC0\u0EAE\u0EB1\u0E94\u0EC0\u0E8A\u0EB1\u0EC8\u0E99\u0E94\u0EBD\u0EA7\u0E81\u0EB1\u0E99. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9B\u0EB0\u0EAA\u0EB2\u0E99\u0E87\u0EB2\u0E99 \u0EC1\u0EA5\u0EB0 \u0EAE\u0EC8\u0EA7\u0EA1\u0EA1\u0EB7\u0E81\u0EB1\u0E99\u0E94\u0EB3\u0EC0\u0E99\u0EB5\u0E99\u0E81\u0EB4\u0E94\u0E88\u0EB0\u0E81\u0ECD\u0EB2\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94 \u0E81\u0EB1\u0E9A\u0E84\u0EA3\u0EB4\u0EAA\u0E95\u0EB0\u0E88\u0EB1\u0E81 \u0EC1\u0EA5\u0EB0 \u0E84\u0EB9\u0EC8\u0EAE\u0EC8\u0EA7\u0EA1\u0E87\u0EB2\u0E99\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0EAD\u0EB7\u0EC8\u0E99\u0EC6 (\u201C\u0E84\u0EB9\u0EC8\u0EAE\u0EC8\u0EA7\u0EA1\u0E87\u0EB2\u0E99\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u201D) \u0EC3\u0E99\u0E97\u0EBB\u0EC8\u0EA7\u0EC2\u0EA5\u0E81."
    }), jsx(Block, {
      textSize: 6,
      children: "3. \u0E9B\u0EB0\u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0E9C\u0EBB\u0E99\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7. \u0EA1\u0EB1\u0E99\u0EC0\u0E9B\u0EB1\u0E99\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E82\u0EAD\u0E87 BGEA \u0E97\u0EB5\u0EC8\u0E88\u0EB0\u0E9B\u0EB0\u0E95\u0EB4\u0E9A\u0EB1\u0E94\u0E95\u0EB2\u0EA1\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E97\u0EB5\u0EC8\u0E81\u0EC8\u0EBD\u0EA7\u0E82\u0EC9\u0EAD\u0E87. \u0E9A\u0EB2\u0E87\u0E84\u0EB1\u0EC9\u0E87\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D\u0EA7\u0EC8\u0EB2\u0E94\u0EC9\u0EA7\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7 \u0EC1\u0EA5\u0EB0/\u0EAB\u0EBC\u0EB7 \u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0EAA\u0EC8\u0EA7\u0E99\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E82\u0EAD\u0E87\u0EC1\u0E95\u0EC8\u0EA5\u0EB0\u0E84\u0EBB\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC1\u0E95\u0E81\u0E95\u0EC8\u0EB2\u0E87\u0E81\u0EB1\u0E99\u0E88\u0EB2\u0E81\u0EC0\u0E82\u0E94\u0EAD\u0EB3\u0E99\u0EB2\u0E94\u0EDC\u0EB6\u0EC8\u0E87\u0EC4\u0E9B\u0EAB\u0EB2\u0EAD\u0EB5\u0E81\u0EDC\u0EB6\u0EC8\u0E87\u0EC0\u0E82\u0E94\u0EAD\u0EB3\u0E99\u0EB2\u0E94\u0EAD\u0EB7\u0EC8\u0E99. \u0E94\u0EB1\u0EC8\u0E87\u0E99\u0EB1\u0EC9\u0E99\u0EAA\u0EB4\u0E94 \u0EC1\u0EA5\u0EB0 \u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E97\u0EB5\u0EC8\u0EA1\u0EB5\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E99\u0EB5\u0EC9\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E9A\u0ECD\u0EC8\u0EA1\u0EB5\u0EC3\u0EAB\u0EC9\u0E97\u0EB8\u0E81\u0E84\u0EBB\u0E99, \u0EA2\u0EB9\u0EC8\u0E97\u0EBB\u0EC8\u0EA7\u0E97\u0EB8\u0E81\u0EC1\u0EAB\u0EC8\u0E87. \u0E88\u0EB8\u0E94\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC1\u0E9A\u0EC8\u0E87\u0E9B\u0EB1\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E81\u0EB1\u0E9A\u0EAB\u0E99\u0EB6\u0EC8\u0E87\u0EC3\u0E99\u0E84\u0EB9\u0EC8\u0EAE\u0EC8\u0EA7\u0EA1\u0E87\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC3\u0E99\u0E9B\u0EB0\u0EC0\u0E97\u0E94\u0EAD\u0EB7\u0EC8\u0E99\u0EC6\u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8\u0E99\u0EAD\u0E81\u0EAA\u0EB0\u0EAB\u0EB0\u0EA5\u0EB1\u0E94 \u0EAD\u0EB2\u0EC0\u0EA1\u0EA5\u0EB4\u0E81\u0EB2, \u0E84\u0EB9\u0EC8\u0EAE\u0EC8\u0EA7\u0EA1\u0E87\u0EB2\u0E99\u0E99\u0EB1\u0EC9\u0E99\u0E88\u0EB0\u0EAE\u0EB1\u0E9A\u0E9C\u0EB4\u0E94\u0E8A\u0EAD\u0E9A\u0E95\u0ECD\u0EC8\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E88\u0EB0\u0E96\u0EB7\u0E81\u0E9B\u0EB0\u0E95\u0EB4\u0E9A\u0EB1\u0E94\u0E95\u0EB2\u0EA1\u0E81\u0EBB\u0E94\u0EAB\u0EA1\u0EB2\u0E8D\u0EC3\u0E99\u0E9B\u0EB0\u0EC0\u0E97\u0E94\u0E99\u0EB1\u0EC9\u0E99\u0EC6."
    }), jsx(Block, {
      textSize: 6,
      children: "4. \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0EC1\u0EA1\u0EC8\u0E99\u0EAB\u0E8D\u0EB1\u0E87? \u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0E88\u0EB8\u0E94\u0E9B\u0EB0\u0EAA\u0EBB\u0E87\u0E82\u0EAD\u0E87\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E99\u0EB5\u0EC9, \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0EC1\u0EA1\u0EC8\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E97\u0EC8\u0EB2\u0E99 \u0EC2\u0E94\u0E8D\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0EC0\u0E8A\u0EB1\u0EC8\u0E99: \u0E8A\u0EB7\u0EC8, \u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8, \u0EC0\u0E9A\u0EB5\u0EC2\u0E97\u0EA5\u0EB0\u0EAA\u0EB1\u0E9A, \u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8\u0EAD\u0EB5\u0EC0\u0EA1\u0EA7, \u0EC1\u0EA5\u0EB0 \u0E84\u0EA7\u0EB2\u0EA1\u0EA1\u0EB1\u0E81\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EBB\u0E99\u0EC3\u0E88 (\u0EA5\u0EA7\u0EA1\u0E97\u0EB1\u0E87\u0E97\u0EB1\u0E94\u0EAA\u0EB0\u0E99\u0EB0\u0E97\u0EB2\u0E87\u0EAA\u0EB2\u0EAA\u0EB0\u0EAB\u0E99\u0EB2), \u0EC1\u0EA5\u0EB0 \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAD\u0EB7\u0EC8\u0E99\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC1\u0E9A\u0EC8\u0E87\u0E9B\u0EB1\u0E99\u0E81\u0EB1\u0E9A\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EC1\u0EA5\u0EB0 \u0EAD\u0EB7\u0EC8\u0E99\u0EC6."
    }), jsxs(Block, {
      textSize: 6,
      children: ["5. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0EB3\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0EAD\u0EB1\u0E99\u0EC3\u0E94\u0EC1\u0E94\u0EC8? \u0E97\u0EC8\u0EB2\u0E99\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC2\u0E94\u0E8D\u0E9A\u0ECD\u0EC8\u0E9A\u0EAD\u0E81\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EA7\u0EC8\u0EB2\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E9B\u0EB1\u0E99\u0EC3\u0E9C \u0EAB\u0EBC\u0EB7 \u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E95\u0EBB\u0EA7\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0EAD\u0E87, \u0EA5\u0EA7\u0EA1\u0E97\u0EB1\u0E87\u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8\u0EAD\u0EB5\u0EC0\u0EA1\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0EC0\u0E8A\u0EB5\u0E9A\u0EC0\u0EA7\u0EB5\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0EB3\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E97\u0EB5\u0EC8\u0E9A\u0ECD\u0EC8\u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0E8A\u0EB7\u0EC8\u0E97\u0EB5\u0EC8\u0E81\u0EC8\u0EBD\u0EA7\u0E82\u0EC9\u0EAD\u0E87\u0E81\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0EC0\u0E8A\u0EB1\u0EC8\u0E99: \u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8\u0E82\u0EAD\u0E87\u0EAD\u0EB4\u0E99\u0EC0\u0E95\u0EB5\u0EC0\u0E99\u0EB1\u0E94(IP) \u0EC1\u0EA5\u0EB0 \u0EAD\u0EB8\u0E9B\u0EB0\u0E81\u0EAD\u0E99\u0E97\u0EB5\u0EC8\u0EC3\u0E8A\u0EC9\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0E9B\u0EB0\u0EC0\u0E9E\u0E94\u0E82\u0EAD\u0E87\u0E95\u0EBB\u0EA7\u0E97\u0EC8\u0EAD\u0E87\u0EC0\u0EA7\u0EB1\u0E9A(\u0E9A\u0EA3\u0EB2\u0EA7\u0EC0\u0E8A\u0EB5\u0EC8), \u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EC3\u0E8A\u0EC9\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EA1\u0EB2\u0EAB\u0EB2\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0EAB\u0E99\u0EC9\u0EB2\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2 \u0EC1\u0EA5\u0EB0 \u0EAD\u0EAD\u0E81, \u0EDC\u0EC9\u0EB2\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0EC3\u0E94\u0EC6\u0E81\u0ECD\u0E95\u0EB2\u0EA1\u0E9E\u0EB2\u0E8D\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E97\u0EB5\u0EC8\u0E96\u0EB7\u0E81\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0EC2\u0E94\u0E8D\u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8 IP \u0E99\u0EB1\u0EC9\u0E99 \u0EC1\u0EA5\u0EB0 \u0E9B\u0EB0\u0EC0\u0E97\u0E94\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EA2\u0EB9\u0EC8. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC3\u0E8A\u0EC9\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E99\u0EB5\u0EC9\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E95\u0EB4\u0E94\u0E95\u0EB2\u0EA1\u0E9B\u0EB0\u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0E9C\u0EBB\u0E99\u0E82\u0EAD\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 (\u0EC0\u0E8A\u0EB1\u0EC8\u0E99: \u0E88\u0ECD\u0EB2\u0E99\u0EA7\u0E99\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87, \u0EC0\u0EA7\u0EA5\u0EB2\u0EAA\u0EB0\u0EC0\u0EA5\u0EC8\u0E8D\u0E97\u0EB5\u0EC8\u0EC3\u0E8A\u0EC9, \u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0EAB\u0E99\u0EC9\u0EB2\u0EC0\u0E9E\u0E88, \u0EC1\u0EA5\u0EB0\u0EAD\u0EB7\u0EC8\u0E99\u0EC6) \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E88\u0EB8\u0E94\u0E9B\u0EB0\u0EAA\u0EBB\u0E87\u0E81\u0EB2\u0E99\u0E94\u0ECD\u0EB2\u0EC0\u0E99\u0EB5\u0E99\u0E87\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0EC0\u0E8A\u0EB1\u0EC8\u0E99\u0E81\u0EB2\u0E99\u0EC0\u0EAE\u0EB1\u0E94\u0EA7\u0EBD\u0E81\u0EA2\u0EC8\u0EB2\u0E87\u0E95\u0ECD\u0EC8\u0EC0\u0E99\u0EB7\u0EC8\u0EAD\u0E87\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E8D\u0EBB\u0E81\u0EA5\u0EB0\u0E94\u0EB1\u0E9A\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0E99\u0EAD\u0E81\u0E88\u0EB2\u0E81\u0E99\u0EB1\u0EC9\u0E99, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0ECD\u0EB2\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EAA\u0EBB\u0EC8\u0E87\u0E81\u0EB1\u0E9A\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EAB\u0EBC\u0EB7 \u0EAA\u0EB0\u0EAB\u0E99\u0EAD\u0E87\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC2\u0E94\u0E8D\u0E9C\u0EC8\u0EB2\u0E99\u0E81\u0EB4\u0E94\u0E88\u0EB0\u0E81\u0ECD\u0EB2\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0EC0\u0E8A\u0EB1\u0EC8\u0E99: \u0E8A\u0EB7\u0EC8, \u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0E95\u0EB4\u0E94\u0E95\u0ECD\u0EC8\u0EAD\u0EB7\u0EC8\u0E99\u0EC6 \u0EAB\u0EBC\u0EB7 \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAD\u0EB7\u0EC8\u0E99\u0EC6\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0EA5\u0EB7\u0EAD\u0E81\u0EC3\u0EAB\u0EC9. \u0E81\u0EB2\u0E99\u0EAE\u0EA7\u0E9A\u0EAE\u0EA7\u0EA1\u0E88\u0EB0\u0EC0\u0E81\u0EB5\u0E94\u0E82\u0EB7\u0EC9\u0E99, \u0E95\u0EBB\u0EA7\u0EA2\u0EC8\u0EB2\u0E87: \u0EC0\u0EA1\u0EB7\u0EC8\u0EAD\u0E97\u0EC8\u0EB2\u0E99 ", jsx("br", {}), "\u2022 \u0EC3\u0E8A\u0EC9\u0EC3\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E81\u0EB2\u0E99 \u201C\u0EC0\u0E8A\u0EB7\u0EC8\u0EAD\u0EA1\u0E95\u0ECD\u0EC8\u201D \u0E81\u0EB1\u0E9A\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EAA\u0EC9\u0EB2\u0E87\u0E9A\u0EB1\u0E99\u0E8A\u0EB5\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7 ", jsx("br", {}), "\u2022 \u0EC0\u0EAE\u0EB1\u0E94\u0E81\u0EB2\u0E99\u0E9A\u0ECD\u0EA5\u0EB4\u0E88\u0EB2\u0E81 \u0EAB\u0EBC\u0EB7 \u0EAA\u0EB1\u0EC8\u0E87\u0E8A\u0EB7\u0EC9, \u0EC0\u0EAE\u0EB1\u0E94\u0EC3\u0EAB\u0EC9\u0EA1\u0EB5\u0EC3\u0E9A\u0EAE\u0EB1\u0E9A\u0EC0\u0E87\u0EB4\u0E99\u0E97\u0EB5\u0EC8\u0EC0\u0EAB\u0EA1\u0EB2\u0EB0\u0EAA\u0EBB\u0EA1; ", jsx("br", {}), "\u2022 \u0EAE\u0EB1\u0E9A \u0EC1\u0EA5\u0EB0 \u0E97\u0EBB\u0E9A\u0E97\u0EA7\u0E99\u0E84\u0EB7\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAD\u0EAD\u0E99\u0EC4\u0EA5\u0E99\u0ECC\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 ", jsx("br", {}), "\u2022 \u0EAA\u0EB0\u0EAB\u0EA1\u0EB1\u0E81\u0E95\u0ECD\u0EB2\u0EC1\u0EAB\u0E99\u0EC8\u0E87 \u0EAB\u0EBC\u0EB7 \u0EC0\u0E9B\u0EB1\u0E99\u0EAD\u0EB2\u0EAA\u0EB2\u0EAA\u0EB0\u0EAB\u0EA1\u0EB1\u0E81\u0EC2\u0E94\u0E8D\u0E9C\u0EC8\u0EB2\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 ", jsx("br", {}), "\u2022 \u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0E8A\u0EB1\u0E9A\u0E9E\u0EB0\u0E8D\u0EB2\u0E81\u0EAD\u0E99 \u0EAB\u0EBC\u0EB7 \u0E88\u0EAD\u0E87 / \u0EA5\u0EBB\u0E87\u0E97\u0EB0\u0E9A\u0EBD\u0E99\u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0E87\u0EB2\u0E99\u0EC3\u0E94\u0EDC\u0EB6\u0EC8\u0E87, \u0EAB\u0EBC\u0EB7 ", jsx("br", {}), "\u2022 \u0EAA\u0EBB\u0EC8\u0E87\u0EC1\u0E9A\u0E9A\u0E9F\u0EAD\u0EA1\u0E95\u0EB4\u0E94\u0E95\u0ECD\u0EC8\u0E97\u0EB5\u0EC8\u0E81\u0EC8\u0EBD\u0EA7\u0E82\u0EC9\u0EAD\u0E87\u0E81\u0EB1\u0E9A\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E99\u0EB5\u0EC9 \u0EAB\u0EBC\u0EB7 \u0E81\u0EB4\u0E94\u0E88\u0EB0\u0E81\u0EB3\u0E82\u0EAD\u0E87 BGEA; \u0EAB\u0EBC\u0EB7 ", jsx("br", {}), "\u2022 \u0E81\u0EB1\u0E9A\u0E95\u0EBB\u0EA7\u0EC1\u0E97\u0E99\u0E82\u0EAD\u0E87 BGEA.", jsx("br", {}), "\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E96\u0EB7\u0E81\u0EA1\u0EAD\u0E9A\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC2\u0E94\u0E8D\u0E9E\u0EB2\u0E81\u0EAA\u0EC8\u0EA7\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1\u0EC0\u0E8A\u0EB1\u0EC8\u0E99: \u0EC2\u0E8A\u0E8A\u0EC8\u0EBD\u0EA7\u0EA1\u0EB5\u0EC0\u0E94\u0E8D \u0EC1\u0EA5\u0EB0 \u0EC0\u0E84\u0EB7\u0EAD\u0E82\u0EC8\u0EB2\u0E8D\u0E97\u0EB5\u0EC8\u0EC1\u0E9A\u0EC8\u0E87\u0E9B\u0EB1\u0E99 \u0EAB\u0EBC\u0EB7 \u0EAD\u0EB0\u0E99\u0EB8\u0E8D\u0EB2\u0E94\u0EC3\u0EAB\u0EC9\u0E97\u0EC8\u0EB2\u0E99\u0EC1\u0E9A\u0EC8\u0E87\u0E9B\u0EB1\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E81\u0EB1\u0E9A\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EC0\u0E9E\u0EB5\u0EC8\u0EA1\u0EC0\u0E95\u0EB5\u0EA1\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0EC2\u0E8A\u0E8A\u0EC8\u0EBD\u0EA7\u0EA1\u0EB5\u0EC0\u0E94\u0E8D \u0EC1\u0EA5\u0EB0\u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0E95\u0EB4\u0E9A\u0EB1\u0E94\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0EC0\u0E84\u0EB7\u0EAD\u0E82\u0EC8\u0EB2\u0E8D, \u0E81\u0EB0\u0EA5\u0EB8\u0E99\u0EB2\u0E81\u0EA7\u0E94\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0E95\u0EB1\u0EC9\u0E87\u0E84\u0EC8\u0EB2\u0E82\u0EAD\u0E87\u0EC2\u0E8A\u0E8A\u0EC8\u0EBD\u0EA7\u0EA1\u0EB5\u0EC0\u0E94\u0E8D \u0EC1\u0EA5\u0EB0 \u0EC0\u0E84\u0EB7\u0EAD\u0E82\u0EC8\u0EB2\u0E8D\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EC3\u0E8A\u0EC9. \u0E9A\u0EC8\u0EAD\u0E99\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EAE\u0EBD\u0E81\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E88\u0EB2\u0E81\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9\u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8\u0EAD\u0EB5\u0EC0\u0EA1\u0EA5\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EAA\u0EB0\u0EAB\u0E99\u0EAD\u0E87\u0EC3\u0EAB\u0EC9\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EAA\u0EBB\u0EC8\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EC1\u0EA5\u0EB0 \u0E8A\u0EB1\u0E9A\u0E9E\u0EB0\u0E8D\u0EB2\u0E81\u0EAD\u0E99\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EA1\u0EB5\u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EBB\u0E99\u0EC3\u0E88 . \u0E96\u0EC9\u0EB2\u0E97\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9\u0E95\u0EBB\u0E81\u0EA5\u0EBB\u0E87\u0E97\u0EB5\u0EC8\u0E88\u0EB0\u0EAE\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0EAA\u0EB7\u0EC8\u0EAA\u0EB2\u0E99\u0E88\u0EB2\u0E81\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC0\u0E8A\u0EB1\u0EC8\u0E99\u0EA7\u0EC8\u0EB2 \u0E97\u0EB2\u0E87\u0EAD\u0EB5\u0EC0\u0EA1\u0EA5, \u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E82\u0ECD\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC0\u0EAD\u0EBB\u0EB2\u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EAD\u0E81\u0E88\u0EB2\u0E81\u0E9A\u0EB1\u0E99\u0E8A\u0EB5\u0EA5\u0EB2\u0E8D\u0E8A\u0EB7\u0EC8\u0EC4\u0E94\u0EC9\u0E97\u0EB8\u0E81\u0EC0\u0EA7\u0EA5\u0EB2 (\u0EC2\u0E94\u0E8D\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9\u0E84\u0ECD\u0EB2\u0EC1\u0E99\u0EB0\u0E99\u0ECD\u0EB2 \u0E8D\u0EBB\u0E81\u0EC0\u0EA5\u0EB5\u0E81\u0E81\u0EB2\u0E99\u0E95\u0EB4\u0E94\u0E95\u0EB2\u0EA1\u0E97\u0EB5\u0EC8\u0EA1\u0EB5\u0EA2\u0EB9\u0EC8\u0EC1\u0EA5\u0EC9\u0EA7\u0EC3\u0E99\u0EC1\u0E95\u0EC8\u0EA5\u0EB0\u0EAD\u0EB5\u0EC0\u0EA1\u0EA5)."]
    }), jsxs(Block, {
      textSize: 6,
      children: ["6. \u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E97\u0EB2\u0E87\u0EAD\u0EAD\u0E99\u0EC4\u0EA5\u0E99\u0ECC\u0E82\u0EAD\u0E87\u0EC0\u0E94\u0EB1\u0E81\u0E99\u0EC9\u0EAD\u0E8D \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EA1\u0EB5\u0E84\u0EA7\u0EB2\u0EA1\u0EAB\u0EC8\u0EA7\u0E87\u0EC3\u0E8D\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0EC0\u0E94\u0EB1\u0E81\u0E99\u0EC9\u0EAD\u0E8D, \u0EC1\u0EA5\u0EB0 \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9A\u0ECD\u0EC8\u0EC4\u0E94\u0EC9\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0ECD\u0EB2\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0EAB\u0EBC\u0EB2\u0E8D\u0EC0\u0E81\u0EB5\u0E99\u0E84\u0EA7\u0EB2\u0EA1\u0E88\u0ECD\u0EB2\u0EC0\u0E9B\u0EB1\u0E99\u0E97\u0EB5\u0EC8\u0EAA\u0EBB\u0EA1\u0EC0\u0EAB\u0E94\u0EAA\u0EBB\u0EA1\u0E9C\u0EBB\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EC0\u0EAE\u0EB1\u0E94\u0EC3\u0EAB\u0EC9\u0EC0\u0E82\u0EBB\u0EB2\u0EC0\u0E88\u0EBB\u0EC9\u0EB2\u0EA1\u0EB5\u0EAA\u0EC8\u0EA7\u0E99\u0EAE\u0EC8\u0EA7\u0EA1\u0EC3\u0E99\u0E81\u0EB4\u0E94\u0E88\u0EB0\u0E81\u0ECD\u0EB2\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAA\u0EB0\u0EC0\u0EDC\u0EB5\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E8A\u0EB8\u0E81\u0E8D\u0EB9\u0EC9\u0EC3\u0EAB\u0EC9\u0E97\u0EC8\u0EB2\u0E99\u0EA1\u0EB5\u0EAA\u0EC8\u0EA7\u0E99\u0EAE\u0EC8\u0EA7\u0EA1\u0E81\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87\u0EAD\u0EB4\u0E99\u0EC0\u0E95\u0EB5\u0EC0\u0E99\u0EB1\u0E94\u0E82\u0EAD\u0E87\u0EA5\u0EB9\u0E81\u0EAB\u0EBC\u0EB2\u0E99\u0E97\u0EC8\u0EB2\u0E99 \u0EC1\u0EA5\u0EB0 \u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EAE\u0EB1\u0E9A\u0E9B\u0EB0\u0E81\u0EB1\u0E99\u0EA7\u0EC8\u0EB2\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0EC0\u0E82\u0EBB\u0EB2\u0EC4\u0E94\u0EC9\u0EAE\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E9B\u0EBB\u0E81\u0E9B\u0EC9\u0EAD\u0E87\u0EC0\u0E9B\u0EB1\u0E99\u0EA2\u0EC8\u0EB2\u0E87\u0E94\u0EB5. \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EAD\u0EC8\u0EB2\u0E99\u0EC0\u0E9E\u0EB5\u0EC8\u0EA1\u0EC0\u0E95\u0EB5\u0EA1\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E84\u0EA7\u0EB2\u0EA1\u0E9B\u0EAD\u0E94\u0EC4\u0E9E\u0E97\u0EB2\u0E87\u0EAD\u0EAD\u0E99\u0EC4\u0EA5\u0E99\u0ECC \u0EC1\u0EA5\u0EB0 \u0EA7\u0EB4\u0E97\u0EB5\u0E81\u0EB2\u0E99\u0EA1\u0EB5\u0EAA\u0EC8\u0EA7\u0E99\u0EAE\u0EC8\u0EA7\u0EA1\u0EAB\u0EBC\u0EB2\u0E8D\u0E82\u0EB6\u0EC9\u0E99\u0E81\u0EB1\u0E9A\u0E9B\u0EB0\u0EAA\u0EBB\u0E9A\u0E81\u0EB2\u0E99\u0EAD\u0EAD\u0E99\u0EC4\u0EA5\u0E99\u0ECC\u0E82\u0EAD\u0E87\u0EA5\u0EB9\u0E81\u0E97\u0EC8\u0EB2\u0E99, \u0E81\u0EB0\u0EA5\u0EB8\u0E99\u0EB2\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC4\u0E9B\u0E97\u0EB5\u0EC8", jsx("a", {
        href: "http://onguardonline.gov/",
        children: " OnGuardOnline.gov"
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: ["7. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC3\u0E8A\u0EC9 \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8 \u0EC1\u0E99\u0EA7\u0EC3\u0E94? \u0EC0\u0EA1\u0EB7\u0EC8\u0EAD\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E88\u0EB0\u0EA7\u0EB2\u0E87 ", jsx("q", {
        children: "\u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8"
      }), " \u0EC3\u0E99\u0E84\u0EAD\u0EA1\u0E9E\u0EB4\u0EA7\u0EC0\u0E95\u0EB5\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E95\u0EB4\u0E94\u0E95\u0EB2\u0EA1\u0E81\u0EB2\u0E99\u0EA2\u0EC9\u0EBD\u0EA1\u0EA2\u0EB2\u0EA1\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0EC1\u0EA1\u0EC8\u0E99\u0EC4\u0E9F\u0EA5\u0ECC\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E82\u0EB0\u0EAB\u0E99\u0EB2\u0E94\u0E99\u0EC9\u0EAD\u0E8D\u0E97\u0EB5\u0EC8\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EAD\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9\u0EC2\u0E94\u0E8D\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E97\u0EB5\u0EC8\u0EA7\u0EB2\u0E87\u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0EC4\u0EA7\u0EC9\u0EC3\u0E99\u0E95\u0EBB\u0EA7\u0EC0\u0E84\u0EB7\u0EC8\u0EB6\u0EAD\u0E87\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0EC0\u0EAE\u0EB1\u0E94\u0EAB\u0E99\u0EC9\u0EB2\u0E97\u0EB5\u0EC8\u0EC0\u0E9B\u0EB1\u0E99\u0E9A\u0EB1\u0E94\u0E9B\u0EB0\u0E88\u0ECD\u0EB2\u0E95\u0EBB\u0EA7 \u0EC1\u0EA5\u0EB0 \u0EAD\u0EB0\u0E99\u0EB8\u0E8D\u0EB2\u0E94\u0EC3\u0EAB\u0EC9\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E81\u0ECD\u0EB2\u0E99\u0EBB\u0E94\u0E95\u0EBB\u0EA7\u0E97\u0EC8\u0EB2\u0E99 \u0EC1\u0EA5\u0EB0 \u0EAE\u0EB1\u0E81\u0EAA\u0EB2\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E97\u0EB5\u0EC8\u0E81\u0EC8\u0EBD\u0EA7\u0E82\u0EC9\u0EAD\u0E87\u0E81\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E9E\u0EBB\u0EA7\u0E9E\u0EB1\u0E99\u0E81\u0EB1\u0E9A\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0EAD\u0EB0\u0E99\u0EB8\u0E8D\u0EB2\u0E94\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E95\u0EB4\u0E94\u0E95\u0EB2\u0EA1\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0EC0\u0E88\u0EBB\u0EC9\u0EB2\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC3\u0E88\u0E81\u0EB2\u0E99\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC4\u0E94\u0EC9\u0E94\u0EB5\u0E82\u0EB6\u0EC9\u0E99 \u0EC1\u0EA5\u0EB0 \u0E9B\u0EB1\u0E9A\u0E9B\u0EB8\u0E87\u0EA1\u0EB1\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E95\u0EAD\u0E9A\u0EAA\u0EB0\u0EAB\u0E99\u0EAD\u0E87\u0E84\u0EA7\u0EB2\u0EA1\u0E95\u0EC9\u0EAD\u0E87\u0E81\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9\u0E94\u0EB5\u0E82\u0EB6\u0EC9\u0E99. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9\u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0E9B\u0EB0\u0EC0\u0E9E\u0E94\u0E95\u0EC8\u0EB2\u0E87\u0EC6\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2: \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0E96\u0EB2\u0EA7\u0EAD\u0E99, \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0EC0\u0E8A\u0E94\u0EC0\u0E8A\u0EB4\u0EC8\u0E99, \u0EC1\u0EA5\u0EB0 \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0E9E\u0EB2\u0E81\u0EAA\u0EC8\u0EA7\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1. (\u0E81\u0EB0\u0EA5\u0EB8\u0E99\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0E82\u0ECD\u0EC9\u0E8A\u0EC8\u0EA7\u0E8D\u0EC0\u0EAB\u0EBC\u0EB7\u0EAD\u0E82\u0EAD\u0E87\u0E95\u0EBB\u0EA7\u0E97\u0EC8\u0EAD\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EC0\u0E9E\u0EB5\u0EC8\u0EA1\u0EC0\u0E95\u0EB5\u0EA1\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E84\u0EA7\u0E9A\u0E84\u0EB8\u0EA1 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0E95\u0EB1\u0EC9\u0E87\u0E84\u0EC8\u0EB2 \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8). \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0E96\u0EB2\u0EA7\u0EAD\u0E99\u0E97\u0EB5\u0EC8\u0E8D\u0EB1\u0E87\u0E84\u0EBB\u0E87\u0E84\u0EC9\u0EB2\u0E87\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0E84\u0EAD\u0EA1\u0E9E\u0EB4\u0EA7\u0EC0\u0E95\u0EB5\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD \u0E88\u0EB8\u0E94\u0E9B\u0EB0\u0EAA\u0EBB\u0E87\u0E81\u0EB2\u0E99\u0E9E\u0EB4\u0EAA\u0EB9\u0E94\u0EA2\u0EB7\u0E99\u0EA2\u0EB1\u0E99\u0E97\u0EB5\u0EC8\u0E81\u0EB2\u0E99\u0EC3\u0E8A\u0EC9\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E99\u0EB5\u0EC9 \u0E95\u0EC9\u0EAD\u0E87\u0E81\u0EB2\u0E99\u0E8A\u0EB7\u0EC8\u0E9C\u0EB9\u0EC9\u0EC3\u0E8A\u0EC9 \u0EC1\u0EA5\u0EB0 \u0EA5\u0EB0\u0EAB\u0EB1\u0E94\u0E9C\u0EC8\u0EB2\u0E99. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC3\u0E8A\u0EC9\u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0E96\u0EB2\u0EA7\u0EAD\u0E99\u0E97\u0EB5\u0EC8\u0E84\u0EBB\u0E87\u0E84\u0EC9\u0EB2\u0E87\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E9A\u0EB1\u0E99\u0E97\u0EB6\u0E81\u0E8A\u0EB7\u0EC8\u0E9C\u0EB9\u0EC9\u0EC3\u0E8A\u0EC9\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0E94\u0EC9\u0EA7\u0E8D\u0E81\u0EB2\u0E99\u0E8D\u0EB4\u0E99\u0E8D\u0EAD\u0EA1\u0EC0\u0EAB\u0EB1\u0E99\u0E94\u0EB5\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0E84\u0EAD\u0EA1\u0E9E\u0EB4\u0EA7\u0EC0\u0E95\u0EB5\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0E94\u0EB1\u0EC8\u0E87\u0E99\u0EB1\u0EC9\u0E99\u0E97\u0EC8\u0EB2\u0E99\u0E88\u0EB6\u0EC8\u0E87\u0E9A\u0ECD\u0EC8\u0E88\u0EB3\u0EC0\u0E9B\u0EB1\u0E99\u0E95\u0EC9\u0EAD\u0E87\u0E82\u0EBD\u0E99\u0E82\u0ECD\u0EC9\u0E84\u0EA7\u0EB2\u0EA1\u0E84\u0EB7\u0E99\u0EC3\u0EDD\u0EC8\u0EC3\u0E99\u0EC1\u0E95\u0EC8\u0EA5\u0EB0\u0E84\u0EB1\u0EC9\u0E87\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0EC3\u0E94\u0EDC\u0EB6\u0EC8\u0E87\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0EC0\u0EA5\u0EB7\u0EAD\u0E81\u0E97\u0EB5\u0EC8\u0E88\u0EB0\u0E9B\u0EB0\u0E95\u0EB4\u0EC0\u0EAA\u0E94 \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0E96\u0EB2\u0EA7\u0EAD\u0E99 \u0E97\u0EB5\u0EC8\u0E8D\u0EB1\u0E87\u0E84\u0EBB\u0E87\u0E84\u0EC9\u0EB2\u0E87 \u0EC1\u0EA5\u0EB0\u0EC3\u0E8A\u0EC9\u0EA5\u0EB0\u0EAB\u0EB1\u0E94\u0E9C\u0EC8\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EAA\u0EB9\u0EC8\u0EA5\u0EB0\u0E9A\u0EBB\u0E9A\u0EC3\u0E99\u0EC1\u0E95\u0EC8\u0EA5\u0EB0\u0E84\u0EB1\u0EC9\u0E87 \u0E97\u0EB5\u0EC8\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB5\u0EC8\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0EC3\u0E94\u0EAB\u0E99\u0EB6\u0EC8\u0E87, \u0EC1\u0EA5\u0EB0 \u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E81\u0ECD\u0E88\u0EB0\u0EC0\u0EAE\u0EB1\u0E94\u0EA7\u0EBD\u0E81\u0EA2\u0EC8\u0EB2\u0E87\u0E96\u0EB7\u0E81\u0E95\u0EC9\u0EAD\u0E87. \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0EC0\u0E8A\u0EB1\u0E94\u0EC0\u0E8A\u0EB5\u0EC8\u0E99\u0EC1\u0EA1\u0EC8\u0E99\u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0E8A\u0EBB\u0EC8\u0EA7\u0E84\u0EB2\u0EA7, \u0EC3\u0E8A\u0EC9\u0EAA\u0EB0\u0EC0\u0E9E\u0EB2\u0EB0\u0EC3\u0E99\u0EA5\u0EB0\u0EAB\u0EA7\u0EC8\u0EB2\u0E87\u0EAA\u0EC8\u0EA7\u0E99\u0E94\u0EBD\u0EA7\u0EC0\u0EA1\u0EB7\u0EC8\u0EAD\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EA1\u0EB2\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E99\u0EB5\u0EC9, \u0EC1\u0EA5\u0EB0 \u0E96\u0EB7\u0E81\u0EA5\u0EB6\u0E9A\u0EC2\u0E94\u0E8D\u0EAD\u0EB1\u0E94\u0E95\u0EB0\u0EC2\u0E99\u0EA1\u0EB1\u0E94\u0EC0\u0EA1\u0EB7\u0EC8\u0EAD\u0EAA\u0EB6\u0EC9\u0E99\u0EAA\u0EB9\u0E94\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC3\u0E8A\u0EC9 \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0EC0\u0E8A\u0EB1\u0E94\u0EC0\u0E8A\u0EB5\u0EC8\u0E99 (a) \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E9B\u0EB1\u0E9A\u0EC1\u0E95\u0EC8\u0E87\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E99\u0EB5\u0EC9 \u0EC1\u0EA5\u0EB0 \u0E9B\u0EB0\u0EAA\u0EBB\u0E9A\u0E81\u0EB2\u0E99\u0EAD\u0EAD\u0E99\u0EC4\u0EA5\u0E99\u0ECC\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, (b) \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E99\u0EB3\u0EAA\u0EB0\u0EC0\u0EDC\u0EB5\u0EC0\u0E99\u0EB7\u0EC9\u0EAD\u0EC3\u0E99\u0EC3\u0EAB\u0EC9\u0EAA\u0EAD\u0E94\u0E84\u0EC8\u0EAD\u0E87\u0E81\u0EB1\u0E9A\u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EBB\u0E99\u0EC3\u0E88\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E97\u0EB5\u0EC8\u0EA5\u0EB0\u0E9A\u0EB8\u0EC4\u0EA7\u0EC9 \u0EC1\u0EA5\u0EB0 \u0EA5\u0EB1\u0E81\u0EAA\u0EB0\u0E99\u0EB0\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0E97\u0EC8\u0EAD\u0E87\u0EC0\u0EA7\u0EB1\u0E9A \u0EC1\u0EA5\u0EB0/\u0EAB\u0EBC\u0EB7 \u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E99\u0EB5\u0EC9, \u0EC1\u0EA5\u0EB0 (c) \u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0E88\u0EB8\u0E94\u0E9B\u0EB0\u0EAA\u0EBB\u0E87\u0EAD\u0EB7\u0EC8\u0E99\u0EC6\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EC0\u0EAE\u0EB1\u0E94\u0EC3\u0EAB\u0EC9\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EAA\u0EB0\u0E94\u0EA7\u0E81\u0EAB\u0EBC\u0EB2\u0E8D\u0E82\u0EB7\u0EC9\u0E99. \u0EC0\u0E88\u0EBB\u0EC9\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EA2\u0EB8\u0E94 \u0EAB\u0EBC\u0EB7 \u0E88\u0EB3\u0E81\u0EB1\u0E94\u0E81\u0EB2\u0E99\u0E88\u0EB1\u0E94\u0EA7\u0EB2\u0E87\u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC9(cookies)\u0EC3\u0E99\u0E84\u0EAD\u0EA1\u0E9E\u0EB4\u0EA7\u0EC0\u0E95\u0EB5\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99 \u0EAB\u0EBC\u0EB7 \u0EA5\u0EC9\u0EB2\u0E87\u0E9E\u0EA7\u0E81\u0EA1\u0EB1\u0E99\u0EAD\u0EAD\u0E81\u0E88\u0EB2\u0E81\u0E9A\u0EA3\u0EB2\u0EA7\u0EC0\u0E8A\u0EB5\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0E9B\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E95\u0EB1\u0EC9\u0E87\u0E84\u0EC8\u0EB2\u0EC0\u0EA7\u0EB1\u0E9A\u0E9A\u0EA3\u0EB2\u0EA7\u0EC0\u0E8A\u0EB5\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0EAD\u0EB5\u0E87\u0E95\u0EB2\u0EA1\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC, \u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0E95\u0EB4\u0EC0\u0EAA\u0E94\u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0EC0\u0E8A\u0EB1\u0E94\u0EC0\u0E8A\u0EB5\u0EC8\u0E99 \u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC1\u0E8A\u0E81\u0EC1\u0E8A\u0E87\u0E81\u0EB2\u0E99\u0EC0\u0EAE\u0EB1\u0E94\u0EA7\u0EBD\u0E81\u0E82\u0EAD\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E99\u0EB5\u0EC9 \u0EC1\u0EA5\u0EB0\u0EC3\u0E99\u0E9A\u0EB2\u0E87\u0E81\u0ECD\u0EA5\u0EB0\u0E99\u0EB5, \u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E95\u0EC9\u0EAD\u0E87\u0E8D\u0EAD\u0EA1\u0EAE\u0EB1\u0E9A\u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0EC0\u0E8A\u0EB1\u0E94\u0EC0\u0E8A\u0EB5\u0EC8\u0E99 \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EC3\u0EAB\u0EC9\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0EC0\u0EAE\u0EB1\u0E94\u0EA7\u0EBD\u0E81\u0E97\u0EB1\u0E87\u0EAB\u0EA1\u0EBB\u0E94. \u0E96\u0EC9\u0EB2\u0E95\u0EBB\u0EA7\u0E97\u0EC8\u0EAD\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E9A\u0ECD\u0EC8\u0EC1\u0E95\u0E81\u0E95\u0EC8\u0EB2\u0E87\u0E81\u0EB1\u0E99\u0EA5\u0EB0\u0EAB\u0EA7\u0EC8\u0EB2\u0E87 \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0E84\u0EBB\u0E87\u0E97\u0EB5\u0EC8 \u0EC1\u0EA5\u0EB0 \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0EC0\u0E8A\u0EB1\u0E94\u0EC0\u0E8A\u0EB5\u0EC8\u0E99, \u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E95\u0EC9\u0EAD\u0E87\u0EC0\u0E9B\u0EB5\u0E94\u0EC3\u0E8A\u0EC9 \u0E84\u0EB8\u0E81\u0E81\u0EB5\u0EC8\u0E97\u0EB1\u0E87\u0EAB\u0EA1\u0EBB\u0E94\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EC3\u0EAB\u0EC9\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E99\u0EB5\u0EC9\u0EC0\u0EAE\u0EB1\u0E94\u0EA7\u0EBD\u0E81\u0EA2\u0EC8\u0EB2\u0E87\u0E96\u0EB7\u0E81\u0E95\u0EC9\u0EAD\u0E87. \u0E99\u0EAD\u0E81\u0EC0\u0EAB\u0E99\u0EB7\u0EAD\u0EC4\u0E9B\u0E88\u0EB2\u0E81 cookies, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC3\u0E8A\u0EC9 web beacons. \u0EC0\u0EA7\u0EB1\u0E9A beacons \u0EC1\u0EA1\u0EC8\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E99\u0EC9\u0EAD\u0E8D\u0EC6\u0E97\u0EB5\u0EC8\u0E9D\u0EB1\u0E87\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0EAE\u0EB9\u0E9A\u0E9E\u0EB2\u0E9A\u0E95\u0EC8\u0EB2\u0E87\u0EC6\u0EC3\u0E99\u0EAB\u0E99\u0EC9\u0EB2\u0EC0\u0EA7\u0EB1\u0E9A\u0E95\u0EC8\u0EB2\u0E87\u0EC6. \u0EAA\u0EB4\u0EC8\u0E87\u0EC0\u0EAB\u0EBC\u0EBB\u0EC8\u0EB2\u0E99\u0EB5\u0EC9\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E96\u0EB7\u0E81\u0EC3\u0E8A\u0EC9\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EAA\u0EBB\u0EC8\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EC2\u0E94\u0E8D\u0E95\u0EBB\u0E87\u0EAB\u0EB2\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0EC3\u0EAB\u0EC9\u0E9E\u0EB2\u0E81\u0EAA\u0EC8\u0EA7\u0E99\u0EAD\u0EB7\u0EC8\u0E99\u0EC3\u0E99\u0E99\u0EB2\u0EA1\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0EAB\u0EBC\u0EB7\u0EC3\u0EAB\u0EC9\u0E9E\u0EB2\u0E81\u0EAA\u0EC8\u0EA7\u0E99\u0EAD\u0EB7\u0EC8\u0E99\u0E95\u0EB2\u0EA1\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC3\u0E8A\u0EC9 web beacons \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E99\u0ECD\u0EB2\u0EC0\u0EAD\u0EBB\u0EB2\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0ECD\u0EB2\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E97\u0EC8\u0EB2\u0E99."]
    }), jsxs(Block, {
      textSize: 6,
      children: ["8. \u0EC1\u0EA5\u0EC9\u0EA7\u0E81\u0EB2\u0E99\u0EC2\u0E84\u0EAA\u0EB0\u0E99\u0EB2\u0EAD\u0EAD\u0E99\u0EC4\u0EA5\u0E99\u0ECC\u0EC0\u0E94\u0EC0\u0E9B\u0EB1\u0E99\u0EC1\u0E99\u0EA7\u0EC3\u0E94? \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAA\u0EBB\u0EC8\u0E87\u0EC0\u0EAA\u0EB5\u0EA1 \u0EC1\u0EA5\u0EB0 \u0E8A\u0EB8\u0E81\u0E8D\u0EB9\u0EC9\u0E81\u0EB2\u0E99\u0EAA\u0EB0\u0EAB\u0E99\u0EB1\u0E9A\u0EAA\u0EB0\u0EAB\u0E99\u0EB9\u0E99\u0E81\u0EB4\u0E94\u0E88\u0EB0\u0E81\u0ECD\u0EB2\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0EB4\u0E94 \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EC1\u0EA5\u0EB0 \u0E8A\u0EB1\u0E9A\u0E9E\u0EB0\u0E8D\u0EB2\u0E81\u0EAD\u0E99\u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0E8A\u0EB7\u0EC9\u0E9E\u0EB7\u0EC9\u0E99\u0E97\u0EB5\u0EC8\u0EC2\u0E84\u0EAA\u0EB0\u0E99\u0EB2\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EB2\u0E81\u0EAA\u0EC8\u0EA7\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1. \u0EC3\u0E99\u0EC0\u0EA7\u0EA5\u0EB2\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0E9A\u0EB2\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EAB\u0EBC\u0EB7 \u0E9E\u0EB2\u0E81\u0EAA\u0EC8\u0EA7\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EA7\u0EB2\u0E87\u0EAB\u0E99\u0EB6\u0EC8\u0E87\u0EAB\u0EBC\u0EB7\u0EAB\u0EBC\u0EB2\u0E8D\u0E9B\u0EB0\u0EC0\u0E9E\u0E94\u0E82\u0EAD\u0E87 cookies \u0EC3\u0E99\u0E84\u0EAD\u0EA1\u0E9E\u0EB4\u0EA7\u0EC0\u0E95\u0EB5\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EAE\u0EB1\u0E9A\u0EAE\u0EB9\u0EC9\u0E84\u0EAD\u0EA1\u0E9E\u0EB4\u0EA7\u0EC0\u0E95\u0EB5\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0EC0\u0E99\u0EB7\u0EC8\u0EAD\u0E87\u0E88\u0EB2\u0E81\u0EA7\u0EC8\u0EB2\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC2\u0E84\u0EAA\u0EB0\u0E99\u0EB2\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E81\u0EB4\u0E94\u0E88\u0EB0\u0E81\u0ECD\u0EB2\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0EB4\u0E94\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EB2\u0E81\u0EAA\u0EC8\u0EA7\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EAE\u0EA7\u0E9A\u0EAE\u0EA7\u0EA1\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E97\u0EB5\u0EC8\u0E9A\u0ECD\u0EC8\u0EA5\u0EB0\u0E9A\u0EB8\u0E95\u0EBB\u0EA7\u0E95\u0EBB\u0E99\u0EC0\u0EA1\u0EB7\u0EC8\u0EAD\u0EC0\u0EA7\u0EA5\u0EB2\u0E9C\u0EC8\u0EB2\u0E99\u0EC4\u0E9B \u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E9B\u0EB0\u0EC0\u0E9E\u0E94\u0E82\u0EAD\u0E87\u0EC0\u0E9E\u0E88, \u0EC0\u0E99\u0EB7\u0EC9\u0EAD\u0EC3\u0E99 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0EC2\u0E84\u0EAA\u0EB0\u0E99\u0EB2\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99 \u0EAB\u0EBC\u0EB7\u0E9C\u0EB9\u0EC9\u0EAD\u0EB7\u0EC8\u0E99\u0E97\u0EB5\u0EC8\u0EC3\u0E8A\u0EC9\u0E84\u0EAD\u0EA1\u0E9E\u0EB4\u0EA7\u0EC0\u0E95\u0EB5\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EA2\u0EC9\u0EBD\u0EA1\u0EA2\u0EB2\u0EA1 \u0EAB\u0EBC\u0EB7 \u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E9A\u0EB4\u0EC8\u0E87. \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E97\u0EB5\u0EC8\u0E9A\u0ECD\u0EC8\u0EA5\u0EB0\u0E9A\u0EB8\u0E95\u0EBB\u0EA7\u0E95\u0EBB\u0E99\u0E99\u0EB5\u0EC9\u0E96\u0EB7\u0E81\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E88\u0EB8\u0E94\u0E9B\u0EB0\u0EAA\u0EBB\u0E87\u0EAB\u0EBC\u0EB2\u0E8D\u0EA2\u0EC8\u0EB2\u0E87. \u0E95\u0EBB\u0EA7\u0EA2\u0EC8\u0EB2\u0E87, \u0EA1\u0EB1\u0E99\u0E8A\u0EC8\u0EA7\u0E8D\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9E\u0EB0\u0E8D\u0EB2\u0E8D\u0EB2\u0EA1\u0EAE\u0EB1\u0E9A\u0E9B\u0EB0\u0E81\u0EB1\u0E99\u0EA7\u0EC8\u0EB2\u0E97\u0EC8\u0EB2\u0E99\u0E88\u0EB0\u0E9A\u0ECD\u0EC8\u0EC0\u0EAB\u0EB1\u0E99\u0E81\u0EB2\u0E99\u0EC2\u0E84\u0EAA\u0EB0\u0E99\u0EB2\u0EC1\u0E9A\u0E9A\u0E94\u0EBD\u0EA7\u0E81\u0EB1\u0E99\u0EC0\u0EA5\u0EB7\u0EC9\u0EAD\u0E8D\u0EC6. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E8D\u0EB1\u0E87\u0EC3\u0E8A\u0EC9\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E97\u0EB5\u0EC8\u0E9A\u0ECD\u0EC8\u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0E8A\u0EB7\u0EC8\u0E99\u0EB5\u0EC9\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E8A\u0EC8\u0EA7\u0E8D\u0EC0\u0EA5\u0EB7\u0EAD\u0E81 \u0EC1\u0EA5\u0EB0 \u0EAA\u0EB0\u0EC1\u0E94\u0E87\u0EC2\u0E84\u0EAA\u0EB0\u0E99\u0EB2\u0EC0\u0E9B\u0EBB\u0EC9\u0EB2\u0EDD\u0EB2\u0E8D\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1\u0E97\u0EB5\u0EC8\u0E8A\u0EB8\u0E81\u0E8D\u0EB9\u0EC9\u0EC3\u0EAB\u0EC9\u0EAA\u0EB0\u0EAB\u0E99\u0EB1\u0E9A\u0EAA\u0EB0\u0EAB\u0E99\u0EB9\u0E99\u0E81\u0EB4\u0E94\u0E88\u0EB0\u0E81\u0ECD\u0EB2\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0EB4\u0E94\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0E9A\u0ECD\u0EA5\u0EB4\u0EAA\u0EB1\u0E94\u0E82\u0EAD\u0E87\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1\u0E8D\u0EB1\u0E87\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0ECD\u0EB2\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E97\u0EB5\u0EC8\u0E9A\u0ECD\u0EC8\u0EA5\u0EB0\u0E9A\u0EB8\u0E95\u0EBB\u0EA7\u0E95\u0EBB\u0E99\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E81\u0EB4\u0E94\u0E88\u0EB0\u0E81\u0ECD\u0EB2\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC \u0EC1\u0EA5\u0EB0 \u0E84\u0ECD\u0EB2\u0EAE\u0EC9\u0EAD\u0E87\u0EAA\u0EB0\u0EAB\u0EA1\u0EB1\u0E81\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EC1\u0EA5\u0EB0\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1 \u0EC1\u0EA5\u0EB0 \u0E84\u0ECD\u0EB2\u0EAE\u0EC9\u0EAD\u0E87\u0EAA\u0EB0\u0EAB\u0EA1\u0EB1\u0E81\u0E81\u0EB2\u0E99\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9\u0EC0\u0E95\u0EB1\u0E81\u0EC2\u0E99\u0EC2\u0EA5\u0E8D\u0EB5\u0E81\u0EB2\u0E99\u0E95\u0EB4\u0E94\u0E95\u0EB2\u0EA1\u0EAD\u0EAD\u0E99\u0EC4\u0EA5\u0E99\u0ECC\u0EC0\u0E8A\u0EB1\u0EC8\u0E99 cookies \u0EC1\u0EA5\u0EB0 web beacons. \u0E81\u0EB2\u0E99\u0E95\u0EB4\u0E94\u0E95\u0EB2\u0EA1\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0ECD\u0EB2\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99 \u0EC2\u0E94\u0E8D\u0E9A\u0ECD\u0EA5\u0EB4\u0EAA\u0EB1\u0E94\u0E9E\u0EB2\u0E81\u0EAA\u0EC8\u0EA7\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1\u0EC0\u0EAB\u0EBC\u0EBB\u0EC8\u0EB2\u0E99\u0EB5\u0EC9\u0E96\u0EB7\u0E81\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E95\u0EB1\u0E94\u0EAA\u0EB4\u0E99\u0EC3\u0E88\u0EA7\u0EC8\u0EB2\u0E81\u0EB2\u0E99\u0EC2\u0E84\u0EAA\u0EB0\u0E99\u0EB2\u0EC3\u0E94\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0EAB\u0EB1\u0E99\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC \u0EC1\u0EA5\u0EB0 \u0EC1\u0EAD\u0EB1\u0E9A\u0E9E\u0EA5\u0EB4\u0EC0\u0E84\u0E8A\u0EB1\u0EC8\u0E99\u0E82\u0EAD\u0E87\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1, \u0EC1\u0E95\u0EC8\u0E9A\u0ECD\u0EC8\u0EC4\u0E94\u0EC9\u0EA5\u0EB0\u0E9A\u0EB8\u0E95\u0EBB\u0EA7\u0E95\u0EBB\u0E99\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC0\u0EA5\u0EB7\u0EAD\u0E81\u0E97\u0EB5\u0EC8\u0E88\u0EB0\u0E9A\u0ECD\u0EC8\u0EAE\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0EC2\u0E84\u0EAA\u0EB0\u0E99\u0EB2\u0EC0\u0E9B\u0EBB\u0EC9\u0EB2\u0EAB\u0EA1\u0EB2\u0E8D\u0E88\u0EB2\u0E81\u0EAB\u0EBC\u0EB2\u0E8D\u0EC0\u0E84\u0EB7\u0EAD\u0E82\u0EC8\u0EB2\u0E8D\u0EC2\u0E84\u0EAA\u0EB0\u0E99\u0EB2, \u0E81\u0EB2\u0E99\u0EC1\u0EA5\u0E81\u0E9B\u0EC8\u0EBD\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99, \u0E81\u0EB2\u0E99\u0EA7\u0EB4\u0EC0\u0E84\u0EB2\u0EB0\u0E94\u0EC9\u0EB2\u0E99\u0E81\u0EB2\u0E99\u0E95\u0EB0\u0EAB\u0EBC\u0EB2\u0E94 \u0EC1\u0EA5\u0EB0 \u0E9C\u0EB9\u0EC9\u0EC3\u0EAB\u0EC9\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0EAD\u0EB7\u0EC8\u0E99\u0EC6\u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0EA2\u0EC9\u0EBD\u0EA1\u0EA2\u0EB2\u0EA1", ' ', jsx("a", {
        href: "https://myadcenter.google.com/home?hl=en&sasb=true&ref=ad-settings",
        children: "Ad Preferences Manager"
      })]
    }), jsx(Block, {
      textSize: 6,
      children: "9. \u0EC1\u0EA5\u0EC9\u0EA7\u0EA5\u0EB4\u0EC9\u0E87\u0EC0\u0E8A\u0EB7\u0EC8\u0EAD\u0EA1\u0E95\u0ECD\u0EC8\u0EC4\u0E9B\u0E8D\u0EB1\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0EAD\u0EB7\u0EC8\u0E99\u0EC0\u0E94? \u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E9B\u0EB0\u0E81\u0EAD\u0E9A\u0EA1\u0EB5\u0EA5\u0EB4\u0EC9\u0E87\u0EC0\u0E8A\u0EB7\u0EC8\u0EAD\u0EA1\u0E95\u0ECD\u0EC8\u0E81\u0EB1\u0E9A\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0EAD\u0EB7\u0EC8\u0E99\u0EC6. \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EAD\u0EB0\u0E99\u0EB8\u0E8D\u0EB2\u0E94\u0EC3\u0EAB\u0EC9\u0E97\u0EC8\u0EB2\u0E99\u0E9E\u0EBB\u0EA7\u0E9E\u0EB1\u0E99\u0E81\u0EB1\u0E9A\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EA1\u0EB5\u0E9A\u0EB1\u0E99\u0E8A\u0EB5 (\u0EC0\u0E8A\u0EB1\u0EC8\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0EAA\u0EB7\u0EC8\u0EAA\u0EB1\u0E87\u0E84\u0EBB\u0EA1\u0EAD\u0EAD\u0E99\u0EA5\u0EB2\u0E8D) \u0EAB\u0EBC\u0EB7 \u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EAE\u0EC8\u0EA7\u0EA1\u0E8A\u0EB8\u0EA1\u0E8A\u0EBB\u0E99\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E94\u0EB1\u0EC8\u0E87\u0E81\u0EC8\u0EB2\u0EA7, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB1\u0E94\u0EC3\u0EAB\u0EC9\u0EA1\u0EB5\u0E81\u0EB2\u0E99\u0EC0\u0E8A\u0EB7\u0EC8\u0EAD\u0EA1\u0E95\u0ECD\u0EC8 \u0EAB\u0EBC\u0EB7 \u0EC1\u0EAD\u0EB1\u0E9A\u0E9E\u0EA5\u0EB4\u0EC0\u0E84\u0EC0\u0E8A\u0EB5\u0EC8\u0E99\u0EAA\u0EB0\u0EAB\u0EA1\u0EB1\u0E81\u0E88\u0EB2\u0E81\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1\u0E97\u0EB5\u0EC8\u0EAD\u0EB0\u0E99\u0EB8\u0E8D\u0EB2\u0E94\u0EC3\u0EAB\u0EC9\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EAA\u0EB9\u0EC8\u0EA5\u0EB0\u0E9A\u0EBB\u0E9A, \u0EA5\u0EBB\u0E87\u0EC0\u0E99\u0EB7\u0EC9\u0EAD\u0EC3\u0E99 \u0EAB\u0EBC\u0EB7 \u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EAE\u0EC8\u0EA7\u0EA1\u0E8A\u0EB8\u0EA1\u0E8A\u0EBB\u0E99\u0E88\u0EB2\u0E81\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0E81\u0EB0\u0EA5\u0EB8\u0E99\u0EB2\u0EAA\u0EB1\u0E87\u0EC0\u0E81\u0E94\u0EA7\u0EC8\u0EB2\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1\u0EC4\u0E94\u0EC9\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87\u0EC2\u0E94\u0E8D\u0E9C\u0EC8\u0EB2\u0E99\u0EA5\u0EB4\u0EC9\u0E87\u0EC0\u0E8A\u0EB7\u0EC8\u0EAD\u0EA1\u0E95\u0ECD\u0EC8\u0EC3\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC1\u0EA1\u0EC8\u0E99\u0E82\u0EB6\u0EC9\u0E99\u0E81\u0EB1\u0E9A\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D \u0EC1\u0EA5\u0EB0 \u0EA1\u0EB2\u0E94\u0E95\u0EB0\u0E96\u0EB2\u0E99\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9A\u0ECD\u0EC8\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0E84\u0EB2\u0E94\u0EC0\u0E94\u0EBB\u0EB2\u0E84\u0EA7\u0EB2\u0EA1\u0EAE\u0EB1\u0E9A\u0E9C\u0EB4\u0E94\u0E8A\u0EAD\u0E9A\u0EC3\u0E94\u0EC6\u0E95\u0ECD\u0EC8\u0E81\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0E95\u0EB4\u0E9A\u0EB1\u0E94\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7, \u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D \u0EAB\u0EBC\u0EB7 \u0E81\u0EB2\u0E99\u0E81\u0EB0\u0E97\u0ECD\u0EB2\u0E82\u0EAD\u0E87\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E97\u0EB5\u0EAA\u0EB2\u0EA1\u0E97\u0EB5\u0EC8\u0E94\u0ECD\u0EB2\u0EC0\u0E99\u0EB5\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0EC0\u0EAB\u0EBC\u0EBB\u0EC8\u0EB2\u0E99\u0EB5\u0EC9, \u0EAB\u0EBC\u0EB7 \u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0EA7\u0EB4\u0E97\u0EB5\u0E81\u0EB2\u0E99\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0ECD\u0EB2, \u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9 \u0EAB\u0EBC\u0EB7 \u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0E97\u0EC8\u0EB2\u0E99\u0E84\u0EA7\u0E99\u0E97\u0EBB\u0E9A\u0E97\u0EA7\u0E99\u0E84\u0EB7\u0E99\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0EC0\u0EAB\u0EBC\u0EBB\u0EC8\u0EB2\u0E99\u0EB5\u0EC9\u0E81\u0EC8\u0EAD\u0E99\u0E97\u0EB5\u0EC8\u0E88\u0EB0\u0EAA\u0EB0\u0EAB\u0E99\u0EAD\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0E82\u0EBB\u0EB2."
    }), jsxs(Block, {
      textSize: 6,
      children: ["10. \u0E8D\u0EC9\u0EAD\u0E99\u0EAB\u0E8D\u0EB1\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E88\u0EB6\u0EC8\u0E87\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0EB3, \u0E99\u0EB3\u0EC3\u0E8A\u0EC9, \u0EC1\u0EA5\u0EB0 \u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7? \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E97\u0EB5\u0EC8\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0ECD\u0EB2\u0EC2\u0E94\u0E8D\u0E9C\u0EC8\u0EB2\u0E99\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EC4\u0E94\u0EC9\u0E96\u0EB7\u0E81\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9 \u0EC1\u0EA5\u0EB0 \u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E88\u0EB8\u0E94\u0E9B\u0EB0\u0EAA\u0EBB\u0E87\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0E8D\u0EBB\u0E81\u0E95\u0EBB\u0EA7\u0EA2\u0EC8\u0EB2\u0E87, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0EB3, \u0E99\u0EB3\u0EC3\u0E8A\u0EC9 \u0EC1\u0EA5\u0EB0 \u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD: ", jsx("br", {}), "\u2022 \u0EAA\u0EC9\u0EB2\u0E87\u0E95\u0EB1\u0EC9\u0E87, \u0EAE\u0EB1\u0E81\u0EAA\u0EB2 \u0EC1\u0EA5\u0EB0 \u0E84\u0EB8\u0EC9\u0EA1\u0E84\u0EAD\u0E87\u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0ECD\u0EB2\u0E9E\u0EB1\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E81\u0EB1\u0E9A\u0E97\u0EC8\u0EB2\u0E99 \u0EC1\u0EA5\u0EB0 \u0EC0\u0E95\u0EB5\u0EA1\u0EC0\u0E95\u0EB1\u0EA1\u0E84\u0ECD\u0EB2\u0EAA\u0EB1\u0EC8\u0E87\u0E97\u0EB5\u0EC8\u0EC4\u0E94\u0EC9\u0EAE\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD;", jsx("br", {}), "\u2022 \u0E95\u0EB4\u0E94\u0E95\u0ECD\u0EC8\u0EAA\u0EB7\u0EC8\u0EAA\u0EB2\u0E99\u0E81\u0EB1\u0E9A\u0E97\u0EC8\u0EB2\u0E99\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EC1\u0EA5\u0EB0 \u0EC1\u0EAB\u0EBC\u0EC8\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EA1\u0EB5\u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EBB\u0E99\u0EC3\u0E88; ", jsx("br", {}), "\u2022 \u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0E97\u0EBB\u0E9A\u0E97\u0EA7\u0E99 \u0E9C\u0EB0\u0EA5\u0EB4\u0E94\u0E95\u0EB0\u0E9E\u0EB1\u0E99 \u0E81\u0EB2\u0E99\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAA\u0EB0\u0EDC\u0EAD\u0E87\u0EC3\u0EAB\u0EC9\u0E97\u0EC8\u0EB2\u0E99 \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EA7\u0EC8\u0EB2\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E88\u0EB0\u0EC0\u0EAE\u0EB1\u0E94\u0EA7\u0EBD\u0E81\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E9B\u0EB1\u0E9A\u0E9B\u0EB8\u0E87\u0E9C\u0EB0\u0EA5\u0EB4\u0E94\u0E95\u0EB0\u0E9E\u0EB1\u0E99 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2;", ' ', jsx("br", {}), "\u2022 \u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0E9B\u0EB0\u0E95\u0EB4\u0E9A\u0EB1\u0E94\u0E95\u0EB2\u0EA1\u0E84\u0ECD\u0EB2\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9; ", jsx("br", {}), "\u2022 \u0E9B\u0EBB\u0E81\u0E9B\u0EC9\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E88\u0EB2\u0E81\u0E84\u0EA7\u0EB2\u0EA1\u0E9C\u0EB4\u0E94\u0E9E\u0EB2\u0E94, \u0E81\u0EB2\u0E99\u0EAA\u0ECD\u0EC9\u0EC2\u0E81\u0E87, \u0E81\u0EB2\u0E99\u0EA5\u0EB1\u0E81 \u0EC1\u0EA5\u0EB0 \u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0EAA\u0E8D\u0EAB\u0EB2\u0E8D\u0E95\u0ECD\u0EC8\u0E8A\u0EB1\u0E9A\u0EAA\u0EB4\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2; \u0EC1\u0EA5\u0EB0 ", jsx("br", {}), "\u2022 \u0E8A\u0EC8\u0EA7\u0E8D\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9B\u0EB0\u0E95\u0EB4\u0E9A\u0EB1\u0E94\u0E95\u0EB2\u0EA1\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D\u0E97\u0EB5\u0EC8\u0E9A\u0EB1\u0E87\u0E84\u0EB1\u0E9A\u0EC3\u0E8A\u0EC9 \u0EAB\u0EBC\u0EB7 \u0E82\u0EB0\u0E9A\u0EA7\u0E99\u0E81\u0EB2\u0E99\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0EB3\u0EC0\u0E9A\u0EB4\u0EC8\u0E87\u0EC1\u0E8D\u0E87 (\u0E95\u0EBB\u0EA7\u0EA2\u0EC8\u0EB2\u0E87\u0EC0\u0E8A\u0EB1\u0EC8\u0E99: \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0EB3\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E95\u0EAD\u0E9A\u0EAA\u0EB0\u0EDC\u0EAD\u0E87\u0E9E\u0EB2\u0EA5\u0EB0\u0EDC\u0EC9\u0EB2\u0E97\u0EB5\u0EC8 \u0E97\u0EB5\u0EC8\u0E81\u0EB3\u0E99\u0EBB\u0E94\u0EC2\u0E94\u0E8D\u0EDC\u0EC8\u0EA7\u0E8D\u0E87\u0EB2\u0E99\u0E84\u0EA7\u0E9A\u0E84\u0EB8\u0EA1\u0E95\u0EC8\u0EB2\u0E87\u0EC6). ", jsx("br", {}), "BGEA \u0E9A\u0ECD\u0EC8\u0EC0\u0E84\u0EB5\u0E8D\u0E82\u0EB2\u0E8D, \u0EC0\u0E8A\u0EBB\u0EC8\u0EB2, \u0E9B\u0EC8\u0EAD\u0E8D\u0EC0\u0E8A\u0EBB\u0EC8\u0EB2 \u0EAB\u0EBC\u0EB7 \u0EC1\u0EA5\u0E81\u0E9B\u0EC8\u0EBD\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E81\u0EB1\u0E9A\u0EAD\u0EBB\u0E87\u0E81\u0EAD\u0E99\u0EAD\u0EB7\u0EC8\u0E99. \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E9A\u0EB1\u0E99\u0EA5\u0EB8\u0E88\u0EB8\u0E94\u0E9B\u0EB0\u0EAA\u0EBB\u0E87\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94 \u0EC1\u0EA5\u0EB0 \u0EAD\u0EBB\u0E87\u0E81\u0EB2\u0E99\u0E88\u0EB1\u0E94\u0E95\u0EB1\u0EC9\u0E87\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9\u0EAA\u0EB0\u0EAB\u0E99\u0EAD\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E96\u0EB7\u0E81\u0EC1\u0E9A\u0EC8\u0E87\u0E9B\u0EB1\u0E99\u0E81\u0EB1\u0E9A\u0E9E\u0EB0\u0E99\u0EB1\u0E81\u0E87\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0E84\u0EB9\u0EC8\u0EAE\u0EC8\u0EA7\u0EA1\u0E87\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94, \u0EC1\u0EA5\u0EB0 \u0E9E\u0EB2\u0E81\u0EAA\u0EC8\u0EA7\u0E99\u0EAD\u0EB7\u0EC8\u0E99\u0EC6\u0E97\u0EB5\u0EC8\u0E95\u0EC9\u0EAD\u0E87\u0E81\u0EB2\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E94\u0EB1\u0EC8\u0E87\u0E81\u0EC8\u0EB2\u0EA7\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E8A\u0EC8\u0EA7\u0E8D\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0EAA\u0EC9\u0EB2\u0E87, \u0EAE\u0EB1\u0E81\u0EAA\u0EB2, \u0E81\u0EB2\u0E99\u0E84\u0EB8\u0EC9\u0EA1\u0E84\u0EAD\u0E87\u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0ECD\u0EB2\u0E9E\u0EB1\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E81\u0EB1\u0E9A\u0E97\u0EC8\u0EB2\u0E99 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0EAA\u0EB0\u0EAB\u0E99\u0EAD\u0E87\u0E9C\u0EB0\u0EA5\u0EB4\u0E94\u0E95\u0EB0\u0E9E\u0EB1\u0E99\u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94. \u0E95\u0EBB\u0EA7\u0EA2\u0EC8\u0EB2\u0E87\u0EC0\u0E8A\u0EB1\u0EC8\u0E99, BGEA \u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EAA\u0EB0\u0EDC\u0EAD\u0E87\u0EC0\u0E97\u0EB1\u0E81\u0EC2\u0E99\u0EC2\u0EA5\u0E8D\u0EB5\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E82\u0EC8\u0EB2\u0EA7\u0EAA\u0EB2\u0E99, \u0E81\u0EB2\u0E99\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0EA1\u0EA7\u0E99\u0E9C\u0EBB\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0EC3\u0EAB\u0EC9\u0E84\u0ECD\u0EB2\u0E9B\u0EB6\u0E81\u0EAA\u0EB2\u0EC1\u0E81\u0EC8\u0E84\u0EB9\u0EC8\u0EAE\u0EC8\u0EA7\u0EA1\u0E87\u0EB2\u0E99\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94 (\u0EC3\u0E99\u0EAA\u0EB0\u0EAB\u0EB0\u0EA5\u0EB1\u0E94 \u0EAB\u0EBC\u0EB7 \u0E95\u0EC8\u0EB2\u0E87\u0E9B\u0EB0\u0EC0\u0E97\u0E94) \u0EC0\u0E9B\u0EB1\u0E99\u0E9A\u0EB2\u0E87\u0E84\u0EB1\u0EC9\u0E87\u0E84\u0EB2\u0EA7\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EA7\u0EC8\u0EB2\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EAB\u0EBC\u0EB7 \u0E9E\u0EA7\u0E81\u0EC0\u0E82\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC3\u0EAB\u0EC9\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9\u0EAA\u0EB0\u0EC1\u0E94\u0E87\u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EBB\u0E99\u0EC3\u0E88. \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E96\u0EB7\u0E81\u0EAA\u0EBB\u0EC8\u0E87\u0E9C\u0EC8\u0EB2\u0E99, \u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0ECD\u0EB2, \u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9, \u0E9B\u0EB8\u0E87\u0EC1\u0E95\u0EC8\u0E87, \u0EC0\u0E81\u0EB1\u0E9A\u0EAE\u0EB1\u0E81\u0EAA\u0EB2 \u0EAB\u0EBC\u0EB7 \u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0EC3\u0E99\u0E97\u0EB1\u0E87\u0EAA\u0EB0\u0EAB\u0EB0\u0EA5\u0EB1\u0E94 \u0EC1\u0EA5\u0EB0\u0E9B\u0EB0\u0EC0\u0E97\u0E94\u0EAD\u0EB7\u0EC8\u0E99\u0EC6, \u0EA5\u0EA7\u0EA1\u0E97\u0EB1\u0E87\u0E9B\u0EB0\u0EC0\u0E97\u0E94\u0E99\u0EAD\u0E81\u0EC0\u0E82\u0E94\u0EC0\u0EAA\u0E94\u0E96\u0EB0\u0E81\u0EB4\u0E94\u0EC0\u0EAD\u0EB5\u0EA3\u0EBB\u0E9A, \u0E9E\u0EB2\u0E8D\u0EC3\u0E95\u0EC9\u0E81\u0EB2\u0E99\u0E84\u0EA7\u0E9A\u0E84\u0EB8\u0EA1\u0E82\u0EAD\u0E87 BGEA \u0EAB\u0EBC\u0EB7 \u0EAB\u0E99\u0EB6\u0EC8\u0E87\u0EC3\u0E99\u0E84\u0EB9\u0EC8\u0EAE\u0EC8\u0EA7\u0EA1\u0E87\u0EB2\u0E99\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0E9A\u0EC8\u0EAD\u0E99\u0E97\u0EB5\u0EC8\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E96\u0EB7\u0E81\u0EAA\u0EB0\u0EDC\u0EAD\u0E87\u0EC3\u0EAB\u0EC9\u0EAB\u0EB8\u0EC9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94 \u0EAB\u0EBC\u0EB7 \u0E9C\u0EB9\u0EC9\u0EC3\u0EAB\u0EC9\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E88\u0EB3\u0E81\u0EB1\u0E94\u0E81\u0EB2\u0E99\u0E99\u0EB3\u0EC3\u0E8A\u0EC9\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E95\u0EB2\u0EA1\u0E88\u0EB8\u0E94\u0E9B\u0EB0\u0EAA\u0EBB\u0E87\u0E97\u0EB5\u0EC8\u0E96\u0EB7\u0E81\u0EC3\u0EAB\u0EC9\u0EC4\u0EA7\u0EC9. \u0E81\u0EB0\u0EA5\u0EB8\u0E99\u0EB2\u0EAE\u0EB1\u0E9A\u0E8A\u0EB2\u0E9A\u0EA7\u0EC8\u0EB2\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0ECD\u0EB2, \u0E99\u0EB3\u0EC3\u0E8A\u0EC9 \u0EAB\u0EBC\u0EB7 \u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E97\u0EB5\u0EC8\u0EA1\u0EB5\u0EC3\u0EAB\u0EC9\u0EAA\u0EB2\u0E97\u0EB2\u0EA5\u0EB0\u0E99\u0EB0\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC2\u0E94\u0E8D\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0E9A\u0ECD\u0EC8\u0EAE\u0EB1\u0E9A\u0EAE\u0EB9\u0EC9 \u0EAB\u0EBC\u0EB7 \u0E8D\u0EB4\u0E99\u0E8D\u0EAD\u0EA1 \u0EC3\u0E99\u0E81\u0ECD\u0EA5\u0EB0\u0E99\u0EB5\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC4\u0E94\u0EC9\u0EAE\u0EB1\u0E9A\u0EAD\u0EB0\u0E99\u0EB8\u0E8D\u0EB2\u0E94 \u0EAB\u0EBC\u0EB7 \u0EC2\u0E94\u0E8D\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D\u0E97\u0EB5\u0EC8\u0E9A\u0EB1\u0E87\u0E84\u0EB1\u0E9A\u0EC3\u0E8A\u0EC9 \u0EAB\u0EBC\u0EB7 \u0E82\u0ECD\u0EC9\u0E81\u0EB3\u0E99\u0EBB\u0E94\u0E81\u0EBB\u0E94\u0EA5\u0EB0\u0E9A\u0EBD\u0E9A\u0EC3\u0EAB\u0EC9\u0EC0\u0EAE\u0EB1\u0E94\u0EC1\u0E99\u0EA7\u0E99\u0EB1\u0EC9\u0E99."]
    }), jsx(Block, {
      textSize: 6,
      children: "11. \u0EC0\u0EAE\u0EBB\u0EB2\u0E88\u0EB0\u0EC0\u0E81\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E94\u0EBB\u0E99\u0E9B\u0EB2\u0E99\u0EC3\u0E94? \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC0\u0E81\u0EB1\u0E9A\u0EAE\u0EB1\u0E81\u0EAA\u0EB2\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0EC4\u0EA7\u0EC9\u0E94\u0EBB\u0E99\u0EC0\u0E97\u0EBB\u0EC8\u0EB2\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E95\u0EC9\u0EAD\u0E87\u0E81\u0EB2\u0E99\u0E95\u0EB2\u0EA1\u0EAA\u0EBB\u0EA1\u0E84\u0EA7\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E88\u0EB8\u0E94\u0E9B\u0EB0\u0EAA\u0EBB\u0E87\u0EC3\u0E99\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94 \u0EAB\u0EBC\u0EB7 \u0E97\u0EB2\u0E87\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D. \u0EC3\u0E99\u0E81\u0EB2\u0E99\u0E81\u0ECD\u0EB2\u0E99\u0EBB\u0E94\u0EC4\u0EA5\u0E8D\u0EB0\u0EC0\u0EA7\u0EA5\u0EB2\u0EC0\u0E81\u0EB1\u0E9A\u0EAE\u0EB1\u0E81\u0EAA\u0EB2\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99, BGEA \u0E9E\u0EB4\u0E88\u0EB2\u0EA5\u0EB0\u0E99\u0EB2\u0E81\u0EBB\u0E94\u0EAB\u0EA1\u0EB2\u0E8D\u0E97\u0EC9\u0EAD\u0E87\u0E96\u0EB4\u0EC8\u0E99, \u0E9E\u0EBB\u0EA7\u0E9E\u0EB1\u0E99\u0E95\u0EB2\u0EA1\u0EAA\u0EB1\u0E99\u0E8D\u0EB2, \u0E84\u0EA7\u0EB2\u0EA1\u0E84\u0EB2\u0E94\u0EAB\u0EA7\u0EB1\u0E87 \u0EC1\u0EA5\u0EB0 \u0E84\u0EA7\u0EB2\u0EA1\u0E95\u0EC9\u0EAD\u0E87\u0E81\u0EB2\u0E99\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0E88\u0EB1\u0E94\u0E81\u0EB2\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E94\u0EB1\u0EC8\u0E87\u0E81\u0EC8\u0EB2\u0EA7."
    }), jsxs(Block, {
      textSize: 6,
      children: ["12. \u0E81\u0EB2\u0E99\u0E8D\u0EB4\u0E99\u0E8D\u0EAD\u0EA1\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC1\u0EA1\u0EC8\u0E99\u0EAA\u0ECD\u0EB2\u0E84\u0EB1\u0E99\u0E95\u0ECD\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0E9E\u0EBB\u0EA7\u0E9E\u0EB1\u0E99\u0E81\u0EB1\u0E9A\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 (\u0EC0\u0E8A\u0EB1\u0EC8\u0E99: \u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0EC3\u0E8A\u0EC9\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2) \u0EC1\u0EA5\u0EB0, \u0E96\u0EC9\u0EB2\u0EC0\u0E9B\u0EB1\u0E99\u0EC4\u0E9B\u0EC4\u0E94\u0EC9, \u0E81\u0EB2\u0E99\u0EAA\u0EBB\u0EC8\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0E97\u0EC8\u0EB2\u0E99\u0E95\u0EBB\u0E81\u0EA5\u0EBB\u0E87\u0EC0\u0EAB\u0EB1\u0E99\u0E94\u0EB5\u0E81\u0EB1\u0E9A\u0EC0\u0E87\u0EB7\u0EC8\u0EAD\u0E99\u0EC4\u0E82\u0E82\u0EAD\u0E87\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E99\u0EB5\u0EC9. \u0E97\u0EC8\u0EB2\u0E99\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0E9B\u0EC8\u0EBD\u0E99 \u0EAB\u0EBC\u0EB7 \u0E96\u0EAD\u0E99\u0E81\u0EB2\u0E99\u0E8D\u0EB4\u0E99\u0E8D\u0EAD\u0EA1\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9\u0E97\u0EB8\u0E81\u0EC0\u0EA7\u0EA5\u0EB2, \u0E82\u0EB6\u0EC9\u0E99\u0E81\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0E88\u0EB3\u0E81\u0EB1\u0E94\u0E97\u0EB2\u0E87\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D \u0EAB\u0EBC\u0EB7\u0EAA\u0EB1\u0E99\u0E8D\u0EB2 \u0EC1\u0EA5\u0EB0 \u0EC1\u0E88\u0EC9\u0E87\u0E81\u0EB2\u0E99\u0E97\u0EB5\u0EC8\u0EAA\u0EBB\u0EA1\u0EC0\u0EAB\u0E94\u0EAA\u0EBB\u0EA1\u0E9C\u0EBB\u0E99\u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0E95\u0EB4\u0E94\u0E95\u0ECD\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E97\u0EB5\u0EC8", ' ', jsx("a", {
        href: "mailto:privacy@bgea.org",
        children: "privacy@bgea.org"
      }), ". \u0E81\u0EB2\u0E99\u0EAA\u0EB7\u0EC8\u0EAA\u0EB2\u0E99\u0E97\u0EB1\u0E87\u0EDD\u0EBB\u0E94\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E96\u0EAD\u0E99\u0E95\u0EBB\u0EA7 \u0EAB\u0EBC\u0EB7 \u0E81\u0EB2\u0E99\u0E9B\u0EC8\u0EBD\u0E99\u0EC1\u0E9B\u0E87\u0E84\u0EA7\u0EB2\u0EA1\u0E8D\u0EB4\u0E99\u0E8D\u0EAD\u0EA1\u0E99\u0EB1\u0EC9\u0E99\u0E88\u0EB0\u0E95\u0EC9\u0EAD\u0E87\u0EC0\u0E9B\u0EB1\u0E99\u0EA5\u0EB2\u0E8D\u0EA5\u0EB1\u0E81\u0EAD\u0EB1\u0E81\u0EAA\u0EAD\u0E99 \u0EC1\u0EA5\u0EB0 \u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC3\u0E8A\u0EC9\u0EC0\u0EA7\u0EA5\u0EB2\u0EC0\u0E96\u0EB4\u0E87 30 \u0EA7\u0EB1\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E9B\u0EB0\u0EA1\u0EA7\u0E99\u0E9C\u0EBB\u0E99\u0E81\u0EB2\u0E99\u0E96\u0EAD\u0E99\u0E81\u0EB2\u0E99\u0E8D\u0EB4\u0E99\u0E8D\u0EAD\u0EA1\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0E81\u0EB0\u0EA5\u0EB8\u0E99\u0EB2\u0EAA\u0EB1\u0E87\u0EC0\u0E81\u0E94\u0EA7\u0EC8\u0EB2\u0EC3\u0E99\u0E9A\u0EB2\u0E87\u0EAA\u0EB0\u0E96\u0EB2\u0E99\u0EB0\u0E81\u0EB2\u0E99, \u0E81\u0EB2\u0E99\u0E96\u0EAD\u0E99\u0E95\u0EBB\u0EA7 \u0EAB\u0EBC\u0EB7 \u0E81\u0EB2\u0E99\u0E9B\u0EC8\u0EBD\u0E99\u0EC1\u0E9B\u0E87\u0E81\u0EB2\u0E99\u0E8D\u0EB4\u0E99\u0E8D\u0EAD\u0EA1\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E95\u0ECD\u0EC8\u0E81\u0EB2\u0E99\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EAA\u0EBB\u0EC8\u0E87\u0E9C\u0EBB\u0E99\u0E81\u0EB0\u0E97\u0EBB\u0E9A\u0E95\u0ECD\u0EC8: (i) \u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0EAA\u0EB0\u0EAB\u0E99\u0EAD\u0E87\u0E9C\u0EB0\u0EA5\u0EB4\u0E94\u0E95\u0EB0\u0E9E\u0EB1\u0E99 \u0EAB\u0EBC\u0EB7 \u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD; \u0EC1\u0EA5\u0EB0 (ii) \u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E99\u0EB5\u0EC9."]
    }), jsx(Block, {
      textSize: 6,
      children: "13. \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E96\u0EB7\u0E81\u0E9B\u0EBB\u0E81\u0E9B\u0EC9\u0EAD\u0E87\u0EC1\u0E99\u0EA7\u0EC3\u0E94? \u0E9E\u0EB0\u0E8D\u0EB2\u0E8D\u0EB2\u0EA1\u0EAE\u0EB1\u0E81\u0EAA\u0EB2\u0E84\u0EA7\u0EB2\u0EA1\u0E9B\u0EAD\u0E94\u0EC4\u0E9E\u0E97\u0EB2\u0E87\u0E94\u0EC9\u0EB2\u0E99\u0E81\u0EB2\u0E8D\u0EB0\u0E9E\u0EB2\u0E9A, \u0EC0\u0E95\u0EB1\u0E81\u0E99\u0EB4\u0E81\u0EA7\u0EB4\u0E8A\u0EB2\u0E81\u0EB2\u0E99 \u0EC1\u0EA5\u0EB0 \u0E82\u0EB1\u0EC9\u0E99\u0E95\u0EAD\u0E99\u0E97\u0EB5\u0EC8\u0EC0\u0EDD\u0EB2\u0EB0\u0EAA\u0EBB\u0EA1\u0E81\u0EB1\u0E9A\u0E84\u0EA7\u0EB2\u0EA1\u0EAD\u0EC8\u0EAD\u0E99\u0EC4\u0EAB\u0EA7\u0E82\u0EAD\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0EC3\u0E99\u0E84\u0EB3\u0E96\u0EB2\u0EA1. \u0E81\u0EB2\u0E99\u0E9B\u0EBB\u0E81\u0E9B\u0EC9\u0EAD\u0E87\u0EC0\u0EAB\u0EBC\u0EBB\u0EC8\u0EB2\u0E99\u0EB5\u0EC9\u0E96\u0EB7\u0E81\u0EAD\u0EAD\u0E81\u0EC1\u0E9A\u0E9A\u0EA1\u0EB2\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E9B\u0EC9\u0EAD\u0E87\u0E81\u0EB1\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E88\u0EB2\u0E81\u0E81\u0EB2\u0E99\u0EAA\u0EB9\u0E99\u0EAB\u0EB2\u0E8D \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87, \u0E81\u0EB2\u0E99\u0E84\u0EB1\u0E94\u0EA5\u0EAD\u0E81, \u0E81\u0EB2\u0E99\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9, \u0E81\u0EB2\u0E99\u0E94\u0EB1\u0E94\u0EC1\u0E81\u0EC9 \u0EAB\u0EBC\u0EB7 \u0E81\u0EB2\u0E99\u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0EC2\u0E94\u0E8D\u0E9A\u0ECD\u0EC8\u0EC4\u0E94\u0EC9\u0EAE\u0EB1\u0E9A\u0EAD\u0EB0\u0E99\u0EB8\u0E8D\u0EB2\u0E94. BGEA \u0EC3\u0E8A\u0EC9\u0E8A\u0EAD\u0E9A\u0EC1\u0EA7\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EA5\u0EB0\u0EAB\u0EB1\u0E94\u0EAD\u0EB4\u0E99\u0EC0\u0E95\u0EB5\u0EC0\u0E99\u0EB1\u0E94, Secure Socket Layer (SSL) Protocol \u0EAB\u0EBC\u0EB7 Transport Layer Security (TLS) Protocol, \u0EC0\u0EA1\u0EB7\u0EC8\u0EAD\u0EC0\u0E81\u0EB1\u0E9A\u0E81\u0EB3 \u0EAB\u0EBC\u0EB7 \u0EC2\u0EAD\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E97\u0EB5\u0EC8\u0EA5\u0EB0\u0EAD\u0EBD\u0E94\u0EAD\u0EC8\u0EAD\u0E99\u0EC0\u0E8A\u0EB1\u0EC8\u0E99: \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E9A\u0EB1\u0E94\u0EC0\u0E84\u0EA3\u0E94\u0EB4\u0E94. \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EC3\u0E94\u0EC6\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0E9B\u0EC9\u0EAD\u0E99 \u0E88\u0EB0\u0E96\u0EB7\u0E81\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EA5\u0EB0\u0EAB\u0EB1\u0E94\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0E9A\u0EA3\u0EB2\u0EA7\u0EC0\u0E8A\u0EB5\u0EC8\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0EAA\u0EBB\u0EC8\u0E87\u0E9C\u0EC8\u0EB2\u0E99\u0EAD\u0EB4\u0E99\u0EC0\u0E95\u0EB5\u0EC0\u0E99\u0EB1\u0E94\u0EAA\u0EB2\u0E97\u0EB2\u0EA5\u0EB0\u0E99\u0EB0\u0EC3\u0E99\u0EAE\u0EB9\u0E9A\u0EC1\u0E9A\u0E9A\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EA5\u0EB0\u0EAB\u0EB1\u0E94 \u0EC1\u0EA5\u0EB0 \u0EAB\u0EBC\u0EB1\u0E87\u0E88\u0EB2\u0E81\u0E99\u0EB1\u0EC9\u0E99\u0E96\u0EAD\u0E94\u0EA5\u0EB0\u0EAB\u0EB1\u0E94\u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0EC0\u0E8A\u0EB5\u0E9A\u0EC0\u0EA7\u0EB5\u0EC8\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0EC1\u0E95\u0EC8\u0EAB\u0E99\u0EC9\u0EB2\u0EC0\u0EAA\u0E8D\u0E94\u0EB2\u0E8D \u0E81\u0EB2\u0E99\u0EAA\u0EBB\u0EC8\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E9C\u0EC8\u0EB2\u0E99\u0EAD\u0EB4\u0E99\u0EC0\u0E95\u0EB5\u0EC0\u0E99\u0EB1\u0E94\u0EC1\u0EA1\u0EC8\u0E99\u0E9A\u0ECD\u0EC8\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EAE\u0EB1\u0E9A\u0E9B\u0EB0\u0E81\u0EB1\u0E99\u0E84\u0EA7\u0EB2\u0EA1\u0E9B\u0EAD\u0E94\u0EC4\u0E9E 100%\u0EC4\u0E94\u0EC9. \u0E94\u0EB1\u0EC8\u0E87\u0E99\u0EB1\u0EC9\u0E99, \u0EC3\u0E99\u0E82\u0EB0\u0E99\u0EB0\u0E97\u0EB5\u0EC8\u0EC0\u0EA7\u0EB1\u0E9A\u0EC4\u0E8A\u0E97\u0ECC\u0E99\u0EB5\u0EC9\u0E9E\u0EB0\u0E8D\u0EB2\u0E8D\u0EB2\u0EA1\u0E9B\u0EBB\u0E81\u0E9B\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9A\u0ECD\u0EC8\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EAE\u0EB1\u0E9A\u0E9B\u0EB0\u0E81\u0EB1\u0E99\u0E84\u0EA7\u0EB2\u0EA1\u0E9B\u0EAD\u0E94\u0EC4\u0E9E\u0E82\u0EAD\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EC3\u0E94\u0EC6\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EAA\u0EBB\u0EC8\u0E87\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0EC1\u0EA5\u0EB0 \u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0EAE\u0EB1\u0E94\u0EC1\u0E99\u0EA7\u0E99\u0EB1\u0EC9\u0E99\u0EA1\u0EB5\u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EC8\u0EBD\u0E87\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0EAD\u0E87. \u0EC0\u0EA1\u0EB7\u0EC8\u0EAD\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC4\u0E94\u0EC9\u0EAE\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9E\u0EB0\u0E8D\u0EB2\u0E8D\u0EB2\u0EA1\u0EA2\u0EC8\u0EB2\u0E87\u0EAA\u0EBB\u0EA1\u0EC0\u0EAB\u0E94\u0EAA\u0EBB\u0EA1\u0E9C\u0EBB\u0E99\u0E97\u0EB2\u0E87\u0E94\u0EC9\u0EB2\u0E99\u0E81\u0EB2\u0E99\u0E84\u0EC9\u0EB2\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EAE\u0EB1\u0E9A\u0E9B\u0EB0\u0E81\u0EB1\u0E99\u0E84\u0EA7\u0EB2\u0EA1\u0E9B\u0EAD\u0E94\u0EC4\u0E9E\u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0EA5\u0EB0\u0E9A\u0EBB\u0E9A\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0E99\u0EAD\u0E81\u0E88\u0EB2\u0E81\u0E99\u0EB1\u0EC9\u0E99, \u0E96\u0EC9\u0EB2\u0E97\u0EC8\u0EB2\u0E99\u0EC3\u0EAB\u0EC9\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E81\u0EB2\u0E99\u0E88\u0EC8\u0EB2\u0E8D\u0EC0\u0E87\u0EB4\u0E99\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0E81\u0ECD\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87\u0EC4\u0E94\u0EC9\u0E9E\u0EBD\u0E87\u0EC1\u0E95\u0EC8\u0E9E\u0EB0\u0E99\u0EB1\u0E81\u0E87\u0EB2\u0E99 BGEA \u0E97\u0EB5\u0EC8\u0EC0\u0E8A\u0EB7\u0EC8\u0EAD\u0E96\u0EB7\u0EC4\u0E94\u0EC9\u0E88\u0ECD\u0EB2\u0E99\u0EA7\u0E99\u0EAB\u0E99\u0EC9\u0EAD\u0E8D\u0E97\u0EB5\u0EC8\u0EC4\u0E94\u0EC9\u0EAE\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E9D\u0EB6\u0E81\u0EAD\u0EBB\u0E9A\u0EAE\u0EBB\u0EA1\u0E9E\u0EB4\u0EC0\u0EAA\u0E94\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0EA1\u0EA7\u0E99\u0E9C\u0EBB\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E99\u0EB5\u0EC9. \u0E84\u0EA7\u0EB2\u0EA1\u0E9B\u0EAD\u0E94\u0EC4\u0E9E\u0E82\u0EAD\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC1\u0EA1\u0EC8\u0E99\u0EAA\u0ECD\u0EB2\u0E84\u0EB1\u0E99\u0E95\u0ECD\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0E81\u0EB0\u0EA5\u0EB8\u0E99\u0EB2\u0EC1\u0E88\u0EC9\u0E87\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAE\u0EB9\u0EC9\u0E97\u0EB1\u0E99\u0E97\u0EB5\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0EC0\u0EAB\u0E94\u0E81\u0EB2\u0E99\u0EC3\u0E94\u0EC6\u0E97\u0EB5\u0EC8\u0E81\u0EC8\u0EBD\u0EA7\u0E82\u0EC9\u0EAD\u0E87\u0E81\u0EB1\u0E9A\u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EB9\u0E99\u0EAB\u0EB2\u0E8D \u0EAB\u0EBC\u0EB7\u0E9A\u0ECD\u0EC8\u0EC4\u0E94\u0EC9\u0EAE\u0EB1\u0E9A\u0EAD\u0EB0\u0E99\u0EB8\u0E8D\u0EB2\u0E94\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87 \u0EAB\u0EBC\u0EB7 \u0EC0\u0E9B\u0EB5\u0E94\u0EC0\u0E9C\u0EB5\u0E8D\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0E84\u0EB8\u0EC9\u0EA1\u0E84\u0EAD\u0E87 \u0EAB\u0EBC\u0EB7 \u0E81\u0EB2\u0E99\u0E84\u0EA7\u0E9A\u0E84\u0EB8\u0EA1\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2."
    }), jsxs(Block, {
      textSize: 6,
      children: ["14. \u0E81\u0EB2\u0E99\u0EAD\u0EB1\u0E9A\u0EC0\u0E94\u0E94\u0E82\u0ECD\u0EC9\u0EA1\u0EB8\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99 \u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EB4\u0EC8\u0E87\u0EAA\u0ECD\u0EB2\u0E84\u0EB1\u0E99\u0E97\u0EB5\u0EC8\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC1\u0EA1\u0EC8\u0E99\u0EC4\u0E94\u0EC9\u0EAE\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E9A\u0EB1\u0E99\u0E97\u0EB6\u0E81\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0E9B\u0EB0\u0E88\u0EB8\u0E9A\u0EB1\u0E99 \u0EC1\u0EA5\u0EB0 \u0E96\u0EB7\u0E81\u0E95\u0EC9\u0EAD\u0E87. \u0E96\u0EC9\u0EB2\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EA1\u0EB5\u0E81\u0EB2\u0E99\u0E9B\u0EC8\u0EBD\u0E99\u0EC1\u0E9B\u0E87\u0EC3\u0E99\u0EA5\u0EB0\u0EAB\u0EA7\u0EC8\u0EB2\u0E87\u0E81\u0EB2\u0E99\u0E9E\u0EBB\u0EA7\u0E9E\u0EB1\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0E81\u0EB0\u0EA5\u0EB8\u0E99\u0EB2\u0EC1\u0E88\u0EC9\u0E87\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAE\u0EB9\u0EC9\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E9B\u0EC8\u0EBD\u0E99\u0EC1\u0E9B\u0E87\u0E94\u0EB1\u0EC8\u0E87\u0E81\u0EC8\u0EB2\u0EA7\u0E97\u0EB5\u0EC8", ' ', jsx("a", {
        href: "mailto:privacy@bgea.org",
        children: "privacy@bgea.org"
      }), " \u0EC3\u0E99\u0E9A\u0EB2\u0E87\u0EAA\u0EB0\u0E96\u0EB2\u0E99\u0EB0\u0E81\u0EB2\u0E99, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E9B\u0EB0\u0E95\u0EB4\u0E9A\u0EB1\u0E94\u0E95\u0EB2\u0EA1\u0E84\u0ECD\u0EB2\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0E95\u0EB7\u0EC8\u0EA1\u0E82\u0ECD\u0EC9\u0E84\u0EA7\u0EB2\u0EA1\u0E97\u0EB2\u0E87\u0EC0\u0EA5\u0EB7\u0EAD\u0E81\u0EC3\u0EAA\u0EC8\u0E9A\u0EB1\u0E99\u0E97\u0EB6\u0E81\u0E97\u0EB5\u0EC8\u0EC0\u0E9B\u0EB1\u0E99\u0E84\u0ECD\u0EB2\u0E96\u0EB2\u0EA1."]
    }), jsxs(Block, {
      textSize: 6,
      children: ["15. \u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB8\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99 \u0E97\u0EC8\u0EB2\u0E99\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0E96\u0EB2\u0EA1\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EA1\u0EB5\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E97\u0EC8\u0EB2\u0E99. \u0E96\u0EC9\u0EB2\u0EAB\u0EB2\u0E81\u0EA7\u0EC8\u0EB2\u0E97\u0EC8\u0EB2\u0E99\u0E95\u0EC9\u0EAD\u0E87\u0E81\u0EB2\u0E99\u0E97\u0EB5\u0EC8\u0E88\u0EB0\u0E97\u0EBB\u0E9A\u0E97\u0EA7\u0E99\u0E84\u0EB7\u0E99, \u0E81\u0EA7\u0E94\u0EAA\u0EAD\u0E9A \u0EAB\u0EBC\u0EB7 \u0EC1\u0E81\u0EC9\u0EC4\u0E82\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0E81\u0EB0\u0EA5\u0EB8\u0E99\u0EB2\u0E95\u0EB4\u0E94\u0E95\u0ECD\u0EC8\u0EAB\u0EB2\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC0\u0E9B\u0EB1\u0E99\u0EA5\u0EB2\u0E8D\u0EA5\u0EB1\u0E81\u0EAD\u0EB1\u0E81\u0EAA\u0EAD\u0E99\u0EA2\u0EB9\u0EC8\u0E97\u0EB5\u0EC8", ' ', jsx("a", {
        href: "mailto:privacy@bgea.org",
        children: "privacy@bgea.org"
      }), "\u0EC3\u0E99\u0EC0\u0EA7\u0EA5\u0EB2\u0E95\u0EB4\u0E94\u0E95\u0ECD\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EB0\u0EC0\u0E9E\u0EB2\u0EB0\u0E88\u0EB2\u0E81\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EA2\u0EB7\u0E99\u0EA2\u0EB1\u0E99\u0E95\u0EBB\u0EA7\u0E95\u0EBB\u0E99 \u0EC1\u0EA5\u0EB0 \u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87, \u0EC0\u0E8A\u0EB1\u0EC8\u0E99\u0E94\u0EBD\u0EA7\u0E81\u0EB1\u0E99\u0E81\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E84\u0EBB\u0EC9\u0E99\u0EAB\u0EB2 \u0EC1\u0EA5\u0EB0 \u0EAA\u0EB0\u0EAB\u0E99\u0EAD\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAE\u0EB1\u0E81\u0EAA\u0EB2\u0EC4\u0EA7\u0EC9\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E97\u0EC8\u0EB2\u0E99. \u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7 \u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAE\u0EB1\u0E81\u0EAA\u0EB2\u0EC4\u0EA7\u0EC9\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E97\u0EC8\u0EB2\u0E99 \u0EC1\u0EA1\u0EC8\u0E99\u0E9A\u0ECD\u0EC8\u0E96\u0EB7\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0EA2\u0EC8\u0EB2\u0E87\u0EC1\u0E97\u0EC9\u0E88\u0EB4\u0E87. \u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EA1\u0EB5\u0E9A\u0EB2\u0E87\u0E81\u0ECD\u0EA5\u0EB0\u0E99\u0EB5\u0E97\u0EB5\u0EC8\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D\u0E97\u0EB5\u0EC8\u0E81\u0EC8\u0EBD\u0EA7\u0E82\u0EC9\u0EAD\u0E87 \u0EAB\u0EBC\u0EB7 \u0E82\u0ECD\u0EC9\u0E81\u0ECD\u0EB2\u0E99\u0EBB\u0E94\u0E81\u0EBB\u0E94\u0EA5\u0EB0\u0E9A\u0EBD\u0E9A\u0EAD\u0EB0\u0E99\u0EB8\u0E8D\u0EB2\u0E94 \u0EAB\u0EBC\u0EB7 \u0EAE\u0EBD\u0E81\u0EAE\u0EC9\u0EAD\u0E87\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9B\u0EB0\u0E95\u0EB4\u0EC0\u0EAA\u0E94\u0E9A\u0ECD\u0EC8\u0EC3\u0EAB\u0EC9\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E9A\u0EB2\u0E87\u0EA2\u0EC8\u0EB2\u0E87 \u0EAB\u0EBC\u0EB7 \u0E97\u0EB1\u0E87\u0EDD\u0EBB\u0E94\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EA1\u0EB5\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E97\u0EC8\u0EB2\u0E99. \u0E99\u0EAD\u0E81\u0E88\u0EB2\u0E81\u0E99\u0EB1\u0EC9\u0E99, \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E96\u0EB7\u0E81\u0E97\u0ECD\u0EB2\u0EA5\u0EB2\u0E8D, \u0EA5\u0EB6\u0E9A\u0EAD\u0EAD\u0E81 \u0EAB\u0EBC\u0EB7 \u0E97\u0EB3\u0E81\u0EB2\u0E99\u0E9B\u0EB4\u0E94\u0E9A\u0EB1\u0E87\u0E95\u0EBB\u0EA7\u0E95\u0EBB\u0E99\u0E95\u0EB2\u0EA1\u0E9E\u0EB1\u0E99\u0E97\u0EB0 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0E95\u0EB4\u0E9A\u0EB1\u0E94\u0E81\u0EB2\u0E99\u0EC0\u0E81\u0EB1\u0E9A\u0EAE\u0EB1\u0E81\u0EAA\u0EB2\u0E9A\u0EB1\u0E99\u0E97\u0EB6\u0E81\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2. \u0EC3\u0E99\u0E81\u0ECD\u0EA5\u0EB0\u0E99\u0EB5\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9A\u0ECD\u0EC8\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EC3\u0EAB\u0EC9\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E88\u0EB0\u0EC1\u0E88\u0EC9\u0E87\u0EC3\u0EAB\u0EC9\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E96\u0EB4\u0E87\u0EAE\u0EB9\u0EC9\u0EC0\u0EAB\u0E94\u0E9C\u0EBB\u0E99\u0EA7\u0EC8\u0EB2\u0E8D\u0EC9\u0EAD\u0E99\u0EAB\u0E8D\u0EB1\u0E87, \u0E82\u0EB6\u0EC9\u0E99\u0E81\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0E88\u0EB3\u0E81\u0EB1\u0E94\u0E97\u0EB2\u0E87\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D \u0EAB\u0EBC\u0EB7 \u0EA5\u0EB0\u0E9A\u0EBD\u0E9A\u0E81\u0EB2\u0E99\u0E95\u0EC8\u0EB2\u0E87\u0EC6."]
    }), jsxs(Block, {
      textSize: 6,
      children: ["16. \u0E81\u0EB2\u0E99\u0E95\u0EB1\u0EC9\u0E87\u0E84\u0EC8\u0EB2\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99 \u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E88\u0EB1\u0E94\u0EC1\u0E88\u0E87\u0E9B\u0EB0\u0EC0\u0E9E\u0E94\u0E82\u0EAD\u0E87\u0E81\u0EB2\u0E99\u0EAA\u0EB7\u0EC8\u0EAA\u0EB2\u0E99\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9\u0EAE\u0EB1\u0E9A\u0E88\u0EB2\u0E81\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0E9B\u0EB1\u0E9A\u0E9B\u0EB8\u0E87\u0E84\u0EA7\u0EB2\u0EA1\u0E95\u0EC9\u0EAD\u0E87\u0E81\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9\u0E97\u0EB5\u0EC8\u0E99\u0EB5\u0EC9", ' ', jsx("a", {
        target: "_blank",
        href: "https://billygraham.org/subscriptions/",
        rel: "noreferrer",
        children: "here"
      }), ", \u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0EC3\u0E8A\u0EC9\u0EA5\u0EB4\u0EC9\u0E87\u0E8D\u0EBB\u0E81\u0EC0\u0EA5\u0EB5\u0E81\u0E81\u0EB2\u0E99\u0E95\u0EB4\u0E94\u0E95\u0EB2\u0EA1 unsubscribe \u0E97\u0EB5\u0EC8\u0E9E\u0EBB\u0E9A\u0EC0\u0EAB\u0EB1\u0E99\u0EA2\u0EB9\u0EC8\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0EAA\u0EB7\u0EC8\u0EAA\u0EB2\u0E99\u0E97\u0EB2\u0E87\u0EAD\u0EB5\u0EC0\u0EA1\u0EA5\u0ECC\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9\u0EAE\u0EB1\u0E9A\u0E88\u0EB2\u0E81\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2, \u0EAB\u0EBC\u0EB7 \u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0E95\u0EB4\u0E94\u0E95\u0ECD\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E97\u0EB5\u0EC8", ' ', jsx("a", {
        href: "mailto:privacy@bgea.org",
        children: "privacy@bgea.org"
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: ["17. \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EC0\u0E9E\u0EB5\u0EC8\u0EA1\u0EC0\u0E95\u0EB5\u0EA1\u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0E9C\u0EB9\u0EC9\u0E97\u0EB5\u0EC8\u0EA2\u0EB9\u0EC8\u0E99\u0EAD\u0E81\u0EAA\u0EB0\u0EAB\u0EB0\u0EA5\u0EB1\u0E94\u0EAD\u0EB2\u0EC0\u0EA1\u0EA5\u0EB4\u0E81\u0EB2. \u0E96\u0EC9\u0EB2\u0E97\u0EC8\u0EB2\u0E99\u0E9E\u0EBB\u0EA7\u0E9E\u0EB1\u0E99\u0E81\u0EB1\u0E9A\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E88\u0EB2\u0E81\u0E9A\u0EC8\u0EAD\u0E99\u0E97\u0EB5\u0EC8 \u0EA1\u0EB5\u0E99\u0EB4\u0E95\u0EB4\u0E81\u0ECD\u0EB2\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0EC0\u0E8A\u0EB1\u0EC8\u0E99: \u0E81\u0EBB\u0E94\u0EA5\u0EB0\u0E9A\u0EBD\u0E9A\u0E84\u0EB8\u0EC9\u0EA1\u0E84\u0EAD\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E97\u0EBB\u0EC8\u0EA7\u0EC4\u0E9B\u0E82\u0EAD\u0E87\u0EAA\u0EB0\u0EAB\u0EB0\u0E9E\u0EB2\u0E9A\u0EC0\u0EAD\u0EB5\u0EA3\u0EBB\u0E9A \u0EAB\u0EBC\u0EB7 \u0E81\u0EBB\u0E94\u0EAB\u0EA1\u0EB2\u0E8D\u0E97\u0EB5\u0EC8\u0E97\u0EBD\u0E9A\u0EC0\u0E97\u0EBB\u0EC8\u0EB2\u0EA2\u0E97\u0EB5\u0EC8\u0EAA\u0EB3\u0E84\u0EB1\u0E99, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E8D\u0EB1\u0E87\u0E95\u0EC9\u0EAD\u0E87\u0E81\u0EB2\u0E99\u0EC3\u0EAB\u0EC9\u0E97\u0EC8\u0EB2\u0E99\u0EAE\u0EB9\u0EC9\u0EAA\u0EB4\u0EC8\u0E87\u0E95\u0ECD\u0EC8\u0EC4\u0E9B\u0E99\u0EB5\u0EC9\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0EA7\u0EB4\u0E97\u0EB5\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9B\u0EB0\u0E95\u0EB4\u0E9A\u0EB1\u0E94\u0E95\u0ECD\u0EC8\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99.", jsx("br", {}), "\u0E9E\u0EB7\u0EC9\u0E99\u0E96\u0EB2\u0E99\u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0EA1\u0EA7\u0E99\u0E9C\u0EBB\u0E99. \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E9B\u0EB0\u0EA1\u0EA7\u0E99\u0E9C\u0EBB\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC2\u0E94\u0E8D\u0E9B\u0EBB\u0E81\u0E81\u0EB0\u0E95\u0EB4\u0EC0\u0E99\u0EB7\u0EC8\u0EAD\u0E87\u0E88\u0EB2\u0E81:", jsx("br", {}), "\u2022 \u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0EA1\u0EA7\u0E99\u0E9C\u0EBB\u0E99\u0EC1\u0EA1\u0EC8\u0E99\u0EAD\u0EB5\u0E87\u0EC3\u0EAA\u0EC8\u0E9C\u0EBB\u0E99\u0E9B\u0EB0\u0EC2\u0EAB\u0E8D\u0E94\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94\u0E97\u0EB5\u0EC8\u0E96\u0EB7\u0E81\u0E95\u0EC9\u0EAD\u0E87\u0E95\u0EB2\u0EA1\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D (\u0EC0\u0E8A\u0EB1\u0EC8\u0E99: \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E9B\u0EBB\u0E81\u0E9B\u0EC9\u0EAD\u0E87\u0E84\u0EA7\u0EB2\u0EA1\u0E9B\u0EAD\u0E94\u0EC4\u0E9E \u0EC1\u0EA5\u0EB0 \u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EBB\u0EA1\u0E9A\u0EB9\u0E99\u0E82\u0EAD\u0E87\u0EA5\u0EB0\u0E9A\u0EBB\u0E9A\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2 \u0EAB\u0EBC\u0EB7 \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E95\u0EAD\u0E9A\u0EAA\u0EB0\u0EDC\u0EAD\u0E87\u0E95\u0ECD\u0EC8\u0E81\u0EB2\u0E99\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99 \u0EC1\u0EA5\u0EB0\u0EAD\u0EB7\u0EC8\u0E99\u0EC6);", jsx("br", {}), "\u2022 \u0E97\u0EC8\u0EB2\u0E99\u0EC3\u0EAB\u0EC9\u0E81\u0EB2\u0E99\u0E8D\u0EB4\u0E99\u0E8D\u0EAD\u0EA1\u0EC0\u0EAB\u0EB1\u0E99\u0E94\u0EB5\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0EAD\u0E87;", jsx("br", {}), "\u2022 \u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0EA1\u0EA7\u0E99\u0E9C\u0EBB\u0E99\u0EC1\u0EA1\u0EC8\u0E99\u0EA1\u0EB5\u0E84\u0EA7\u0EB2\u0EA1\u0E88\u0ECD\u0EB2\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0ECD\u0EB2\u0E9E\u0EB1\u0E99\u0E95\u0EB2\u0EA1\u0EAA\u0EB1\u0E99\u0E8D\u0EB2\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2; \u0EC1\u0EA5\u0EB0/\u0EAB\u0EBC\u0EB7", jsx("br", {}), "\u2022 \u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0EA1\u0EA7\u0E99\u0E9C\u0EBB\u0E99\u0EC1\u0EA1\u0EC8\u0E99\u0EA1\u0EB5\u0E84\u0EA7\u0EB2\u0EA1\u0E88\u0ECD\u0EB2\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E97\u0EB5\u0EC8\u0E88\u0EB0\u0E9B\u0EB0\u0E95\u0EB4\u0E9A\u0EB1\u0E94\u0E95\u0EB2\u0EA1\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E97\u0EB2\u0E87\u0E94\u0EC9\u0EB2\u0E99\u0E81\u0EBB\u0E94\u0EAB\u0EA1\u0EB2\u0E8D \u0EAB\u0EBC\u0EB7 \u0E81\u0EBB\u0E94\u0EA5\u0EB0\u0E9A\u0EBD\u0E9A\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2.", jsx("br", {}), "\u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0E97\u0EC8\u0EB2\u0E99\u0EA1\u0EB5\u0EAA\u0EB4\u0E94\u0E97\u0EB5\u0EC8\u0E88\u0EB0\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EC0\u0E96\u0EB4\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EA1\u0EB5\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E97\u0EC8\u0EB2\u0E99 \u0EC1\u0EA5\u0EB0 \u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EC1\u0E81\u0EC9\u0EC4\u0E82\u0E82\u0ECD\u0EC9\u0E9C\u0EB4\u0E94\u0E9E\u0EB2\u0E94\u0EC3\u0E94\u0EC6 \u0E97\u0EC8\u0EB2\u0E99\u0E8D\u0EB1\u0E87\u0EA1\u0EB5\u0EAA\u0EB4\u0E94\u0EAD\u0EB7\u0EC8\u0E99\u0EC6\u0EA5\u0EA7\u0EA1\u0E97\u0EB1\u0E87:", jsx("br", {}), "\u2022 \u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0EA5\u0EB6\u0E9A\u0EA5\u0EC9\u0EB2\u0E87", jsx("br", {}), "\u2022 \u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0E88\u0ECD\u0EB2\u0E81\u0EB1\u0E94\u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0EA1\u0EA7\u0E99\u0E9C\u0EBB\u0E99", jsx("br", {}), "\u2022 \u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0EC0\u0E84\u0EB7\u0EC8\u0EAD\u0E99\u0E97\u0EB5\u0EC8\u0E82\u0EAD\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99", jsx("br", {}), "\u2022 \u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0E84\u0EB1\u0E94\u0E84\u0EC9\u0EB2\u0E99; \u0EC1\u0EA5\u0EB0/\u0EAB\u0EBC\u0EB7", jsx("br", {}), "\u2022 \u0EAA\u0EB4\u0E94\u0E97\u0EB4 \u0E97\u0EB5\u0EC8\u0E81\u0EC8\u0EBD\u0EA7\u0E82\u0EC9\u0EAD\u0E87\u0E81\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E95\u0EB1\u0E94\u0EAA\u0EB4\u0E99\u0EC3\u0E88\u0EAD\u0EB1\u0E94\u0E95\u0EB0\u0EC2\u0E99\u0EA1\u0EB1\u0E94 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0EAA\u0EC9\u0EB2\u0E87\u0EC2\u0E9B\u0EA3\u0EC4\u0E9F\u0EA5\u0ECC (\u0E96\u0EC9\u0EB2\u0EA1\u0EB5). \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E9E\u0EB4\u0E88\u0EB2\u0EA5\u0EB0\u0E99\u0EB2 \u0EC1\u0EA5\u0EB0\u0E95\u0EAD\u0E9A\u0EAA\u0EB0\u0EDC\u0EAD\u0E87\u0E95\u0ECD\u0EC8\u0E81\u0EB2\u0E99\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0E97\u0EB1\u0E87\u0EDD\u0EBB\u0E94\u0E95\u0EB2\u0EA1\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D\u0E97\u0EB5\u0EC8\u0E99\u0EB3\u0EC3\u0E8A\u0EC9. \u0E94\u0EB1\u0EC8\u0E87\u0E97\u0EB5\u0EC8\u0EC4\u0E94\u0EC9\u0E81\u0EC8\u0EB2\u0EA7\u0EA1\u0EB2\u0E82\u0EC9\u0EB2\u0E87\u0EC0\u0E97\u0EB4\u0E87, \u0EC0\u0EA1\u0EB7\u0EC8\u0EAD\u0E95\u0EB4\u0E94\u0E95\u0ECD\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0EC3\u0EAB\u0EC9\u0EA1\u0EB5\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EB0\u0EC0\u0E9E\u0EB2\u0EB0\u0E88\u0EB2\u0E81\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EA2\u0EB7\u0E99\u0EA2\u0EB1\u0E99\u0E95\u0EBB\u0EA7\u0E95\u0EBB\u0E99 \u0EC1\u0EA5\u0EB0 \u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0EC3\u0E99\u0E81\u0EB2\u0E99\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0EC0\u0E8A\u0EB1\u0EC8\u0E99\u0E94\u0EBD\u0EA7\u0E81\u0EB1\u0E99\u0E81\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0E8A\u0EAD\u0E81\u0EAB\u0EB2\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99 \u0EC1\u0EA5\u0EB0 \u0E88\u0EB1\u0E94\u0E95\u0EBD\u0EA1\u0E81\u0EB2\u0E99\u0E95\u0EAD\u0E9A\u0EAA\u0EB0\u0EAB\u0E99\u0EAD\u0E87\u0E95\u0ECD\u0EC8\u0E81\u0EB2\u0E99\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0EA1\u0EB5\u0E9A\u0EB2\u0E87\u0E81\u0ECD\u0EA5\u0EB0\u0E99\u0EB5\u0E97\u0EB5\u0EC8\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E9A\u0ECD\u0EC8\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EAD\u0EB3\u0E99\u0EA7\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EB0\u0E94\u0EA7\u0E81\u0EC3\u0EAB\u0EC9\u0E81\u0EB1\u0E9A\u0E84\u0EB3\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC4\u0E94\u0EC9\u0EC0\u0E99\u0EB7\u0EC8\u0EAD\u0E87\u0E88\u0EB2\u0E81\u0E82\u0ECD\u0EC9\u0E81\u0EB3\u0E99\u0EBB\u0E94\u0E97\u0EB2\u0E87\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D \u0EAB\u0EBC\u0EB7 \u0E9E\u0EB1\u0E99\u0E97\u0EB0 \u0EAB\u0EBC\u0EB7 \u0E81\u0EB2\u0E99\u0E9B\u0EB0\u0E95\u0EB4\u0E9A\u0EB1\u0E94\u0EAD\u0EB7\u0EC8\u0E99\u0EC6.", jsx("br", {}), "\u0EC3\u0EAB\u0EC9\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0EAE\u0EB9\u0EC9\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E81\u0EB2\u0E99\u0EAE\u0EC9\u0EAD\u0E87\u0E82\u0ECD \u0EAB\u0EBC\u0EB7 \u0E84\u0EA7\u0EB2\u0EA1\u0E81\u0EB1\u0E87\u0EA7\u0EBB\u0E99\u0E97\u0EB5\u0EC8\u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EA1\u0EB5\u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0E95\u0EB4\u0E94\u0E95\u0ECD\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E97\u0EB5\u0EC8", ' ', jsx("a", {
        href: "mailto:privacy@bgea.org",
        children: "privacy@bgea.org"
      }), ". \u0E97\u0EC8\u0EB2\u0E99\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EA1\u0EB5\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAB\u0EC8\u0EA7\u0E87\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0EA7\u0EB4\u0E97\u0EB5\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E88\u0EB1\u0E94\u0E81\u0EB2\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E95\u0ECD\u0EC8\u0E81\u0EB1\u0E9A\u0EC0\u0E88\u0EBB\u0EC9\u0EB2\u0EDC\u0EC9\u0EB2\u0E97\u0EB5\u0EC8\u0EC3\u0E99\u0EC0\u0E82\u0E94\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99"]
    }), jsx(Block, {
      textSize: 6,
      children: "18. \u0E81\u0EB2\u0E99\u0EA1\u0EB5\u0EAA\u0EC8\u0EA7\u0E99\u0EAE\u0EC8\u0EA7\u0EA1\u0E9C\u0EC8\u0EB2\u0E99\u0EAD\u0EB8\u0E9B\u0EB0\u0E81\u0EAD\u0E99\u0EA1\u0EB7\u0E96\u0EB7 \u0EC1\u0EA5\u0EB0 \u0E81\u0EB2\u0E99\u0EAA\u0EBB\u0EC8\u0E87\u0E82\u0ECD\u0EC9\u0E84\u0EA7\u0EB2\u0EA1. \u0E81\u0EB2\u0E99\u0EA1\u0EB5\u0EAA\u0EC8\u0EA7\u0E99\u0EAE\u0EC8\u0EA7\u0EA1\u0EC3\u0E99\u0EC2\u0E84\u0E87\u0E81\u0EB2\u0E99 \u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94 BGEA \u0E9C\u0EC8\u0EB2\u0E99\u0EAD\u0EB8\u0E9B\u0EB0\u0E81\u0EAD\u0E99\u0EA1\u0EB7\u0E96\u0EB7, \u0EC0\u0E8A\u0EB1\u0EC8\u0E99: \u0E9C\u0EC8\u0EB2\u0E99\u0E81\u0EB2\u0E99\u0EAA\u0EBB\u0EC8\u0E87\u0E82\u0ECD\u0EC9\u0E84\u0EA7\u0EB2\u0EA1, \u0EA1\u0EB5\u0E88\u0EB8\u0E94\u0E9B\u0EB0\u0EAA\u0EBB\u0E87\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EC0\u0EAE\u0EB1\u0E94\u0EA7\u0EBD\u0E81\u0E81\u0EB1\u0E9A\u0E9C\u0EB9\u0EC9\u0EC3\u0EAB\u0EC9\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0EC4\u0EAE\u0EC9\u0EAA\u0EB2\u0E8D\u0E97\u0EB5\u0EC8\u0EAA\u0ECD\u0EB2\u0E84\u0EB1\u0E99\u0EC3\u0E99\u0EAA\u0EB0\u0EAB\u0EB0\u0EA5\u0EB1\u0E94. BGEA \u0E9A\u0ECD\u0EC8\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0EAE\u0EB1\u0E9A\u0E9B\u0EB0\u0E81\u0EB1\u0E99\u0EA7\u0EC8\u0EB2\u0E9C\u0EB9\u0EC9\u0EC3\u0EAB\u0EC9\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0EC4\u0EAE\u0EC9\u0EAA\u0EB2\u0E8D\u0EC2\u0E94\u0E8D\u0EAA\u0EB0\u0EC0\u0E9E\u0EB2\u0EB0 \u0E88\u0EB0\u0EAD\u0EB0\u0E99\u0EB8\u0E8D\u0EB2\u0E94\u0EC3\u0EAB\u0EC9\u0EA1\u0EB5\u0EAA\u0EC8\u0EA7\u0E99\u0EAE\u0EC8\u0EA7\u0EA1, \u0EC0\u0E8A\u0EB4\u0EC8\u0E87\u0E82\u0EB6\u0EC9\u0E99\u0E81\u0EB1\u0E9A\u0E84\u0EA7\u0EB2\u0EA1\u0EAA\u0EB2\u0EA1\u0EB2\u0E94\u0E82\u0EAD\u0E87\u0EAD\u0EB8\u0E9B\u0EB0\u0E81\u0EAD\u0E99\u0EA1\u0EB7\u0E96\u0EB7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0E9C\u0EB9\u0EC9\u0EC3\u0EAB\u0EC9\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0EC4\u0EAE\u0EC9\u0EAA\u0EB2\u0E8D\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0E84\u0EB4\u0E94\u0E84\u0EC8\u0EB2\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0E9C\u0EB9\u0EC9\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EAE\u0EC8\u0EA7\u0EA1\u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0E84\u0EA7\u0EB2\u0EA1, \u0EA5\u0EA7\u0EA1\u0E97\u0EB1\u0E87 \u0E84\u0EA7\u0EB2\u0EA1\u0E9C\u0EB4\u0E94\u0E9E\u0EB2\u0E94\u0E97\u0EB2\u0E87\u0E82\u0ECD\u0EC9\u0E84\u0EA7\u0EB2\u0EA1, \u0EAA\u0EBB\u0EC8\u0E87 \u0EAB\u0EBC\u0EB7 \u0EC4\u0E94\u0EC9\u0EAE\u0EB1\u0E9A \u0E97\u0EB5\u0EC8\u0E81\u0EC8\u0EBD\u0EA7\u0E82\u0EC9\u0EAD\u0E87\u0E81\u0EB1\u0E9A\u0EC2\u0E84\u0E87\u0E81\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94 BGEA. BGEA \u0E88\u0EB0\u0E9A\u0ECD\u0EC8\u0EAE\u0EB1\u0E9A\u0E9C\u0EB4\u0E94\u0E8A\u0EAD\u0E9A\u0E95\u0ECD\u0EC8\u0E84\u0EC8\u0EB2\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0EC0\u0EAB\u0EBC\u0EBB\u0EC8\u0EB2\u0E99\u0EB5\u0EC9. \u0E9C\u0EB9\u0EC9\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EAE\u0EC8\u0EA7\u0EA1\u0E84\u0EA7\u0E99\u0E9B\u0EB6\u0E81\u0EAA\u0EB2\u0E81\u0EB1\u0E9A\u0EC1\u0E9C\u0E99\u0EA5\u0EB2\u0E84\u0EB2\u0E82\u0EAD\u0E87\u0E9C\u0EB9\u0EC9\u0EC3\u0EAB\u0EC9\u0E9A\u0ECD\u0EA5\u0EB4\u0E81\u0EB2\u0E99\u0EC4\u0EAE\u0EC9\u0EAA\u0EB2\u0E8D\u0E82\u0EAD\u0E87\u0E9E\u0EA7\u0E81\u0EC0\u0E82\u0EBB\u0EB2\u0EAA\u0ECD\u0EB2\u0EA5\u0EB1\u0E9A\u0EA5\u0EB2\u0E8D\u0EA5\u0EB0\u0EAD\u0EBD\u0E94. \u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E97\u0EB5\u0EC8\u0EC0\u0E81\u0EB1\u0E9A\u0EAE\u0EA7\u0E9A\u0EAE\u0EA7\u0EA1\u0E9C\u0EC8\u0EB2\u0E99\u0E81\u0EB2\u0E99\u0EC0\u0E82\u0EBB\u0EC9\u0EB2\u0EAE\u0EC8\u0EA7\u0EA1\u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EA5\u0EA7\u0EA1\u0EA1\u0EB5\u0EAD\u0EB8\u0E9B\u0EB0\u0E81\u0EAD\u0E99\u0EC0\u0E97\u0EB4\u0E87\u0EA1\u0EB7\u0E96\u0EB7, \u0EC1\u0E95\u0EC8\u0E9A\u0ECD\u0EC8\u0E88\u0ECD\u0EB2\u0E81\u0EB1\u0E94, \u0E81\u0EB2\u0E99\u0E95\u0EAD\u0E9A\u0EAA\u0EB0\u0EAB\u0E99\u0EAD\u0E87\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0E81\u0EB1\u0E9A\u0EC2\u0E84\u0E87\u0E81\u0EB2\u0E99\u0E82\u0EAD\u0E87\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E81\u0EB4\u0E94 \u0EC1\u0EA5\u0EB0 \u0EC0\u0E9A\u0EB5\u0EC2\u0E97\u0EA5\u0EB0\u0EAA\u0EB1\u0E9A\u0EA1\u0EB7\u0E96\u0EB7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99. \u0E81\u0EB2\u0E99\u0E99\u0ECD\u0EB2\u0EC3\u0E8A\u0EC9\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E94\u0EB1\u0EC8\u0E87\u0E81\u0EC8\u0EB2\u0EA7\u0E88\u0EB0\u0EC0\u0E9B\u0EB1\u0E99\u0E94\u0EB1\u0EC8\u0E87\u0E97\u0EB5\u0EC8\u0EAD\u0EB0\u0E97\u0EB4\u0E9A\u0EB2\u0E8D\u0EA2\u0EB9\u0EC8\u0E9A\u0EC8\u0EAD\u0E99\u0EAD\u0EB7\u0EC8\u0E99\u0EC3\u0E99\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E99\u0EB5\u0EC9. \u0EC2\u0E94\u0E8D\u0E81\u0EB2\u0E99\u0E9E\u0EBB\u0EA7\u0E9E\u0EB1\u0E99\u0E81\u0EB1\u0E9A BGEA \u0E9C\u0EC8\u0EB2\u0E99\u0EAD\u0EB8\u0E9B\u0EB0\u0E81\u0EAD\u0E99\u0EA1\u0EB7\u0E96\u0EB7 \u0EC1\u0EA5\u0EB0/\u0EAB\u0EBC\u0EB7 \u0E81\u0EB2\u0E99\u0EAA\u0EBB\u0EC8\u0E87\u0E82\u0ECD\u0EC9\u0E84\u0EA7\u0EB2\u0EA1, \u0E97\u0EC8\u0EB2\u0E99\u0E8D\u0EB4\u0E99\u0E8D\u0EAD\u0EA1\u0EC3\u0EAB\u0EC9 BGEA \u0EC3\u0E8A\u0EC9\u0EAD\u0EB8\u0E9B\u0EB0\u0E81\u0EAD\u0E99\u0EA1\u0EB7\u0E96\u0EB7 \u0EC1\u0EA5\u0EB0\u0EC0\u0E9A\u0EB5\u0EC2\u0E97\u0EA5\u0EB0\u0EAA\u0EB1\u0E9A\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0E95\u0EB4\u0E94\u0E95\u0ECD\u0EC8\u0EAA\u0EB7\u0EC8\u0EAA\u0EB2\u0E99\u0E81\u0EB1\u0E9A\u0E97\u0EC8\u0EB2\u0E99. BGEA \u0E88\u0EB0\u0EAA\u0EB0\u0EDC\u0EAD\u0E87\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0E81\u0EB2\u0E99\u0E96\u0EAD\u0E99\u0E95\u0EBB\u0EA7\u0E97\u0EB5\u0EC8\u0E88\u0EB0\u0E8A\u0EC8\u0EA7\u0E8D\u0EC3\u0EAB\u0EC9\u0E97\u0EC8\u0EB2\u0E99\u0EA2\u0EB8\u0E94\u0E81\u0EB2\u0E99\u0EAE\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0E84\u0EA7\u0EB2\u0EA1."
    }), jsxs(Block, {
      textSize: 6,
      children: ["19. \u0EAA\u0EAD\u0E9A\u0E96\u0EB2\u0EA1\u0EC0\u0E9E\u0EB5\u0EC8\u0EA1\u0EC0\u0E95\u0EB5\u0EA1 \u0EAB\u0EBC\u0EB7 \u0EAA\u0EBB\u0E87\u0EC3\u0EAA? \u0E96\u0EC9\u0EB2\u0E97\u0EC8\u0EB2\u0E99\u0EA1\u0EB5\u0E84\u0ECD\u0EB2\u0E96\u0EB2\u0EA1\u0EC3\u0E94\u0EC6\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E99\u0EB5\u0EC9 \u0EAB\u0EBC\u0EB7 \u0E82\u0ECD\u0EC9\u0E84\u0EB3\u0E96\u0EB2\u0EA1\u0E99\u0E81\u0EC8\u0EBD\u0EA7\u0E81\u0EB1\u0E9A\u0EA7\u0EB4\u0E97\u0EB5\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E88\u0EB1\u0E94\u0E81\u0EB2\u0E99\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99, \u0E81\u0EB0\u0EA5\u0EB8\u0E99\u0EB2\u0E95\u0EB4\u0E94\u0E95\u0ECD\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E97\u0EB5\u0EC8", ' ', jsx("a", {
        href: "mailto:privacy@bgea.org",
        children: "privacy@bgea.org"
      }), "."]
    }), jsx(Block, {
      textSize: 6,
      children: "20. \u0E81\u0EB2\u0E99\u0E9B\u0EB1\u0E9A\u0E9B\u0EB8\u0E87\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E99\u0EB5\u0EC9 \u0E9A\u0EB2\u0E87\u0E84\u0EB1\u0EC9\u0E87 BGEA, \u0EAD\u0EB2\u0E94\u0E88\u0EB0\u0EC0\u0EAE\u0EB1\u0E94\u0E81\u0EB2\u0E99\u0E9B\u0EC8\u0EBD\u0E99\u0EC1\u0E9B\u0E87\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E99\u0EB5\u0EC9\u0EC0\u0E9E\u0EB7\u0EC8\u0EAD\u0EAA\u0EB0\u0E97\u0EC9\u0EAD\u0E99\u0EC0\u0E96\u0EB4\u0E87\u0E81\u0EB2\u0E99\u0E9B\u0EC8\u0EBD\u0E99\u0EC1\u0E9B\u0E87\u0EC3\u0E99\u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E97\u0EB2\u0E87\u0E94\u0EC9\u0EB2\u0E99\u0E81\u0EBB\u0E94\u0EAB\u0EA1\u0EB2\u0E8D \u0EAB\u0EBC\u0EB7 \u0E81\u0EBB\u0E94\u0EA5\u0EB0\u0E9A\u0EBD\u0E9A\u0E82\u0EAD\u0E87\u0E95\u0EBB\u0E99 \u0EAB\u0EBC\u0EB7 \u0EC3\u0E99\u0EA5\u0EB1\u0E81\u0EAA\u0EB0\u0E99\u0EB0\u0E97\u0EB5\u0EC8\u0E9E\u0EA7\u0E81\u0EC0\u0EAE\u0EBB\u0EB2\u0E88\u0EB1\u0E94\u0E81\u0EB2\u0E99\u0E81\u0EB1\u0E9A\u0E82\u0ECD\u0EC9\u0EA1\u0EB9\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E82\u0EAD\u0E87\u0E97\u0EC8\u0EB2\u0E99 (\u0EA7\u0EB1\u0E99\u0E97\u0EB5\u0E82\u0EAD\u0E87\u0E81\u0EB2\u0E99\u0E9B\u0EB1\u0E9A\u0E9B\u0EB8\u0E87\u0EAB\u0EBC\u0EC9\u0EB2\u0EAA\u0EB8\u0E94\u0EC1\u0EA1\u0EC8\u0E99\u0EAA\u0EB0\u0EC1\u0E94\u0E87\u0EA2\u0EB9\u0EC8\u0E82\u0EC9\u0EB2\u0E87\u0EA5\u0EB8\u0EC8\u0EA1\u0E99\u0EB5\u0EC9)."
    }), jsx(Block, {
      textSize: 6,
      children: "21. \u0E81\u0EB2\u0E99\u0E95\u0EB5\u0E84\u0EA7\u0EB2\u0EA1\u0EDD\u0EB2\u0E8D\u0E82\u0EAD\u0E87\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E99\u0EB5\u0EC9 \u0E81\u0EB2\u0E99\u0E95\u0EB5\u0E84\u0EA7\u0EB2\u0EA1\u0EC3\u0E94\u0EC6\u0E97\u0EB5\u0EC8\u0E81\u0EC8\u0EBD\u0EA7\u0E82\u0EC9\u0EAD\u0E87\u0E81\u0EB1\u0E9A\u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E99\u0EB5\u0EC9\u0E88\u0EB0\u0E96\u0EB7\u0E81\u0EC0\u0EAE\u0EB1\u0E94\u0EC2\u0E94\u0E8D BGEA. \u0E99\u0EAD\u0E81\u0E88\u0EB2\u0E81\u0EA7\u0EC8\u0EB2\u0EC4\u0E94\u0EC9\u0EA5\u0EB0\u0E9A\u0EB8\u0EC4\u0EA7\u0EC9\u0EC0\u0E9B\u0EB1\u0E99\u0EA2\u0EC8\u0EB2\u0E87\u0EAD\u0EB7\u0EC8\u0E99, \u0E99\u0EB0\u0EC2\u0E8D\u0E9A\u0EB2\u0E8D\u0E84\u0EA7\u0EB2\u0EA1\u0EC0\u0E9B\u0EB1\u0E99\u0EAA\u0EC8\u0EA7\u0E99\u0E95\u0EBB\u0EA7\u0E99\u0EB5\u0EC9\u0E9A\u0ECD\u0EC8\u0EC4\u0E94\u0EC9\u0EAA\u0EC9\u0EB2\u0E87 \u0EAB\u0EBC\u0EB7\u0EC3\u0EAB\u0EC9\u0EAA\u0EB4\u0E94\u0E97\u0EB4\u0EC3\u0E94\u0EC6\u0E95\u0ECD\u0EC8\u0E9A\u0EB8\u0E81\u0E84\u0EBB\u0E99\u0EC3\u0E94\u0EDC\u0EB6\u0EC8\u0E87, \u0EAB\u0EBC\u0EB7\u0E9A\u0EB1\u0E87\u0E84\u0EB1\u0E9A\u0EC3\u0EAB\u0EC9\u0EAA\u0EB4\u0E94\u0E97\u0EB4 \u0EAB\u0EBC\u0EB7 \u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0EC3\u0E94\u0EC6\u0E99\u0EAD\u0E81\u0EC0\u0EDC\u0EB7\u0EAD\u0EC4\u0E9B\u0E88\u0EB2\u0E81 BGEA, \u0EAB\u0EBC\u0EB7 \u0E99\u0EAD\u0E81\u0EC0\u0EDC\u0EB7\u0EAD\u0EC4\u0E9B\u0E88\u0EB2\u0E81\u0EAA\u0EB4\u0E94 \u0EAB\u0EBC\u0EB7 \u0E9E\u0EB1\u0E99\u0E97\u0EB0\u0E97\u0EB5\u0EC8\u0E81\u0EB3\u0E99\u0EBB\u0E94\u0EC2\u0E94\u0E8D\u0E81\u0EBB\u0E94\u0EDD\u0EB2\u0E8D\u0E82\u0EAD\u0E87\u0EA5\u0EB1\u0E94\u0E96\u0EB0\u0E9A\u0EB2\u0E99\u0E81\u0EB2\u0E87 \u0EC1\u0EA5\u0EB0 \u0E82\u0EAD\u0E87\u0EA5\u0EB1\u0E94\u0EC3\u0E99\u0EAA\u0EB0\u0EAB\u0EB0\u0EA5\u0EB1\u0E94\u0EAD\u0EB2\u0EC0\u0EA1\u0EA5\u0EB4\u0E81\u0EB2, \u0E95\u0EB2\u0EA1\u0E97\u0EB5\u0EC8\u0E99\u0EB3\u0EC3\u0E8A\u0EC9. (\u0EAD\u0EB1\u0E9A\u0EC0\u0E94\u0E94\u0EAB\u0EBC\u0EC9\u0EB2\u0EAA\u0EB8\u0E94: 25 \u0E9E\u0EB6\u0E94\u0EAA\u0EB0\u0E9E\u0EB2 2018)"
    })]
  });
};

var PrivacyPolicyVietnam = function PrivacyPolicyVietnam() {
  return jsxs("div", {
    className: "vietnam-privacy-policy",
    children: [jsx(Heading, {
      subtitle: true,
      textSize: 4,
      children: "Ch\xEDnh S\xE1ch V\u1EC1 Quy\u1EC1n Ri\xEAng T\u01B0 C\u1EE7a Hi\u1EC7p H\u1ED9i Truy\u1EC1n Gi\xE1o Billy Graham"
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "1. Gi\u1EDBi thi\u1EC7u."
        })
      }), jsx("p", {
        children: "T\u1EA1i Hi\u1EC7p h\u1ED9i Truy\u1EC1n gi\xE1o Billy Graham (\u201CBGEA\u201D), ch\xFAng t\xF4i cam k\u1EBFt duy tr\xEC t\xEDnh ch\xEDnh x\xE1c, b\u1EA3o m\u1EADt v\xE0 an to\xE0n th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n."
      }), jsx("p", {
        children: "Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 n\xE0y \xE1p d\u1EE5ng cho c\xE1c c\xE1ch th\u1EE9c ch\xFAng t\xF4i thu th\u1EADp, s\u1EED d\u1EE5ng v\xE0 chia s\u1EBB th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n khi b\u1EA1n t\u01B0\u01A1ng t\xE1c v\u1EDBi c\xE1c ho\u1EA1t \u0111\u1ED9ng m\u1EE5c v\u1EE5 c\u1EE7a ch\xFAng t\xF4i. V\xED d\u1EE5: c\xF3 th\u1EC3 qua s\u1EF1 truy c\u1EADp trang web c\u1EE7a ch\xFAng t\xF4i, qua thi\u1EBFt b\u1ECB di \u0111\u1ED9ng, ho\u1EB7c tham d\u1EF1 m\u1ED9t s\u1EF1 ki\u1EC7n c\u1EE7a m\u1EE5c v\u1EE5."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "2. Th\xF4ng tin v\u1EC1 ch\xFAng t\xF4i."
        })
      }), jsx("p", {
        children: "BGEA l\xE0 t\u1ED5 ch\u1EE9c phi l\u1EE3i nhu\u1EADn \u0111\xE3 \u0111\u01B0\u1EE3c \u0111\u0103ng k\xFD thu\u1ED9c nh\xF3m 501(c)(3). \u0110\u1ECBa ch\u1EC9 v\u0103n ph\xF2ng c\u1EE7a ch\xFAng t\xF4i l\xE0 1 Billy Graham Parkway, Charlotte, North Carolina, 28201, Hoa K\u1EF3."
      }), jsx("p", {
        children: "V\u1EDBi m\u1EE5c \u0111\xEDch ti\u1EBFp n\u1ED1i ch\u1EE9c v\u1EE5 m\xE0 M\u1EE5c s\u01B0 Billy Graham \u0111\xE3 d\xE0nh c\u1EA3 \u0111\u1EDDi c\u1ED1ng hi\u1EBFn, Hi\u1EC7p h\u1ED9i Truy\u1EC1n gi\xE1o Billy Graham t\u1ED3n t\u1EA1i \u0111\u1EC3 h\u1ED7 tr\u1EE3 v\xE0 m\u1EDF r\u1ED9ng s\u1EF1 k\xEAu g\u1ECDi v\xE0 m\u1EE5c v\u1EE5 truy\u1EC1n gi\xE1o c\u1EE7a M\u1EE5c s\u01B0 Franklin Graham b\u1EB1ng c\xE1ch c\xF4ng b\u1ED1 Ph\xFAc \xE2m c\u1EE7a Ch\xFAa Gi\xEA-su Christ cho t\u1EA5t c\u1EA3 m\u1ECDi ng\u01B0\u1EDDi b\u1EB1ng m\u1ECDi ph\u01B0\u01A1ng ti\u1EC7n hi\u1EC7u qu\u1EA3 m\xE0 ch\xFAng t\xF4i c\xF3 v\xE0 th\xF4ng qua vi\u1EC7c trang b\u1ECB cho H\u1ED9i Th\xE1nh v\xE0 c\xE1c t\xEDn h\u1EEFu \u0111\u1EC3 h\u1ECD c\xF9ng th\u1EF1c hi\u1EC7n m\u1EE5c \u0111\xEDch \u0111\xF3. Ch\xFAng t\xF4i \u0111i\u1EC1u ph\u1ED1i v\xE0 h\u1EE3p t\xE1c th\u1EF1c hi\u1EC7n c\xE1c ho\u1EA1t \u0111\u1ED9ng m\u1EE5c v\u1EE5 v\u1EDBi c\xE1c H\u1ED9i Th\xE1nh v\xE0 c\xE1c m\u1EE5c v\u1EE5 \u0111\u1ED1i t\xE1c kh\xE1c (\u201CM\u1EE5c v\u1EE5 \u0110\u1ED1i t\xE1c\u201D) tr\xEAn kh\u1EAFp th\u1EBF gi\u1EDBi."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "3. Hi\u1EC7u qu\u1EA3 c\u1EE7a Ch\xEDnh s\xE1ch B\u1EA3o m\u1EADt."
        })
      }), jsx("p", {
        children: "Ch\xEDnh s\xE1ch c\u1EE7a BGEA l\xE0 tu\xE2n th\u1EE7 lu\u1EADt b\u1EA3o m\u1EADt hi\u1EC7n h\xE0nh. \u0110\xF4i khi lu\u1EADt v\u1EC1 quy\u1EC1n ri\xEAng t\u01B0 v\xE0/ho\u1EB7c quy\u1EC1n ri\xEAng t\u01B0 c\u1EE7a m\u1ED9t c\xE1 nh\xE2n c\xF3 s\u1EF1 kh\xE1c nhau gi\u1EEFa c\xE1c khu v\u1EF1c ph\xE1p l\xFD kh\xE1c nhau. Do \u0111\xF3, c\xE1c quy\u1EC1n v\xE0 ngh\u0129a v\u1EE5 trong Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 n\xE0y c\xF3 th\u1EC3 kh\xF4ng \u0111\u01B0\u1EE3c cung c\u1EA5p cho t\u1EA5t c\u1EA3 m\u1ECDi ng\u01B0\u1EDDi, \u1EDF m\u1ECDi n\u01A1i. Khi ch\xFAng t\xF4i chia s\u1EBB th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n v\u1EDBi m\u1ED9t trong c\xE1c M\u1EE5c v\u1EE5 \u0110\u1ED1i t\xE1c c\u1EE7a ch\xFAng t\xF4i \u1EDF c\xE1c qu\u1ED1c gia kh\xE1c ngo\xE0i Hoa K\u1EF3, \u0111\u1ED1i t\xE1c \u0111\xF3 s\u1EBD ch\u1ECBu tr\xE1ch nhi\u1EC7m v\u1EC1 th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n v\xE0 vi\u1EC7c h\u1ECD s\u1EED d\u1EE5ng th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n s\u1EBD tu\xE2n theo lu\u1EADt hi\u1EC7n h\xE0nh \u1EDF qu\u1ED1c gia \u0111\xF3."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "4. Th\xF4ng tin c\xE1 nh\xE2n l\xE0 g\xEC?"
        })
      }), jsx("p", {
        children: "V\xEC m\u1EE5c \u0111\xEDch c\u1EE7a Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 n\xE0y, th\xF4ng tin c\xE1 nh\xE2n l\xE0 th\xF4ng tin ri\xEAng t\u01B0 c\u1EE7a c\xE1 nh\xE2n b\u1EA1n, nh\u01B0 t\xEAn, \u0111\u1ECBa ch\u1EC9, s\u1ED1 \u0111i\u1EC7n tho\u1EA1i, \u0111\u1ECBa ch\u1EC9 email v\xE0 s\u1EDF th\xEDch, m\u1ED1i quan t\xE2m c\xE1 nh\xE2n c\u1EE7a b\u1EA1n (bao g\u1ED3m c\u1EA3 quan \u0111i\u1EC3m t\xF4n gi\xE1o) v\xE0 th\xF4ng tin kh\xE1c m\xE0 b\u1EA1n c\xF3 th\u1EC3 chia s\u1EBB v\u1EDBi ch\xFAng t\xF4i, v.v.."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "5. Ch\xFAng t\xF4i thu th\u1EADp th\xF4ng tin c\xE1 nh\xE2n n\xE0o?"
        })
      }), jsx("p", {
        children: "B\u1EA1n c\xF3 th\u1EC3 truy c\u1EADp trang web c\u1EE7a ch\xFAng t\xF4i m\xE0 kh\xF4ng c\u1EA7n cho ch\xFAng t\xF4i bi\u1EBFt b\u1EA1n l\xE0 ai ho\u1EB7c chia s\u1EBB th\xF4ng tin c\xE1 nh\xE2n v\u1EC1 b\u1EA3n th\xE2n, bao g\u1ED3m c\u1EA3 \u0111\u1ECBa ch\u1EC9 email c\u1EE7a b\u1EA1n. M\u1EA1ng l\u01B0\u1EDBi m\xE1y ch\u1EE7 c\u1EE7a ch\xFAng t\xF4i c\xF3 th\u1EC3 thu th\u1EADp th\xF4ng tin \u1EA9n danh li\xEAn quan \u0111\u1EBFn vi\u1EC7c b\u1EA1n truy c\u1EADp trang web c\u1EE7a ch\xFAng t\xF4i, nh\u01B0 \u0111\u1ECBa ch\u1EC9 IP v\xE0 t\xEAn mi\u1EC1n \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 truy c\u1EADp trang web c\u1EE7a ch\xFAng t\xF4i, lo\u1EA1i tr\xECnh duy\u1EC7t, trang web b\u1EA1n \u0111\xE3 v\xE0o \u0111\u1EC3 truy c\u1EADp trang web c\u1EE7a ch\xFAng t\xF4i, trang b\u1EA1n \u0111\xE3 \u0111\u0103ng nh\u1EADp v\xE0 \u0111\u0103ng xu\u1EA5t, b\u1EA5t k\u1EF3 trang web n\xE0o trong website c\u1EE7a ch\xFAng t\xF4i \u0111\u01B0\u1EE3c xem b\u1EDFi \u0111\u1ECBa ch\u1EC9 IP \u0111\xF3 v\xE0 qu\u1ED1c gia n\u01A1i b\u1EA1n sinh s\u1ED1ng. Ch\xFAng t\xF4i s\u1EED d\u1EE5ng th\xF4ng tin n\xE0y \u0111\u1EC3 theo d\xF5i hi\u1EC7u su\u1EA5t trang web c\u1EE7a ch\xFAng t\xF4i (nh\u01B0 s\u1ED1 l\u01B0\u1EE3t truy c\u1EADp, th\u1EDDi gian trung b\xECnh s\u1EED d\u1EE5ng, s\u1ED1 l\u01B0\u1EE3t xem trang, v.v.) v\xE0 cho c\xE1c m\u1EE5c \u0111\xEDch ho\u1EA1t \u0111\u1ED9ng kh\xE1c, v\xED d\u1EE5 nh\u01B0 n\u1ED7 l\u1EF1c li\xEAn t\u1EE5c n\xE2ng c\u1EA5p trang web."
      }), jsx("p", {
        children: "Ngo\xE0i ra, ch\xFAng t\xF4i thu th\u1EADp th\xF4ng tin c\xE1 nh\xE2n m\xE0 b\u1EA1n g\u1EEDi l\xEAn trang web c\u1EE7a ch\xFAng t\xF4i ho\u1EB7c cung c\u1EA5p cho ch\xFAng t\xF4i th\xF4ng qua c\xE1c ho\u1EA1t \u0111\u1ED9ng c\u1EE7a M\u1EE5c v\u1EE5, nh\u01B0 t\xEAn, \u0111\u1ECBa ch\u1EC9 c\u1EE7a b\u1EA1n v\xE0 b\u1EA5t k\u1EF3 th\xF4ng tin li\xEAn h\u1EC7 n\xE0o kh\xE1c ho\u1EB7c th\xF4ng tin kh\xE1c m\xE0 b\u1EA1n ch\u1ECDn cung c\u1EA5p. Vi\u1EC7c thu th\u1EADp th\xF4ng tin c\xF3 th\u1EC3 \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n, nh\u01B0 khi b\u1EA1n:"
      }), jsxs("ul", {
        children: [jsxs("li", {
          children: ["S\u1EED d\u1EE5ng m\u1EE5c \u201C", jsx("a", {
            href: "http://billygraham.org/about/contact",
            children: "li\xEAn h\u1EC7"
          }), "\u201D tr\xEAn trang web c\u1EE7a ch\xFAng t\xF4i;"]
        }), jsx("li", {
          children: "T\u1EA1o m\u1ED9t t\xE0i kho\u1EA3n c\xE1 nh\xE2n;"
        }), jsx("li", {
          children: "Th\u1EF1c hi\u1EC7n quy\xEAn g\xF3p ho\u1EB7c \u0111\u1EB7t h\xE0ng \u0111\u1EC3 nh\u1EADn \u0111\u01B0\u1EE3c bi\xEAn nh\u1EADn ph\xF9 h\u1EE3p;"
        }), jsx("li", {
          children: "Nh\u1EADn v\xE0 xem x\xE9t th\xF4ng tin tr\u1EF1c tuy\u1EBFn v\u1EC1 c\xE1c M\u1EE5c v\u1EE5 c\u1EE7a ch\xFAng t\xF4i;"
        }), jsx("li", {
          children: "N\u1ED9p \u0111\u01A1n xin vi\u1EC7c ho\u1EB7c t\xECnh nguy\u1EC7n th\xF4ng qua trang web c\u1EE7a ch\xFAng t\xF4i;"
        }), jsx("li", {
          children: "Y\xEAu c\u1EA7u t\xE0i li\u1EC7u ho\u1EB7c \u0111\u1EB7t/\u0111\u0103ng k\xFD m\u1ED9t s\u1EF1 ki\u1EC7n, ho\u1EB7c"
        }), jsx("li", {
          children: "G\u1EEDi bi\u1EC3u m\u1EABu li\xEAn h\u1EC7 li\xEAn quan \u0111\u1EBFn trang web n\xE0y ho\u1EB7c s\u1EF1 ki\u1EC7n c\u1EE7a BGEA; ho\u1EB7c"
        }), jsx("li", {
          children: "Trao \u0111\u1ED5i v\u1EDBi \u0111\u1EA1i di\u1EC7n c\u1EE7a BGEA."
        })]
      }), jsx("p", {
        children: "Th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n c\u0169ng c\xF3 th\u1EC3 \u0111\u01B0\u1EE3c cung c\u1EA5p cho ch\xFAng t\xF4i b\u1EDFi c\xE1c b\xEAn th\u1EE9 ba, nh\u01B0 c\xE1c n\u1EC1n t\u1EA3ng v\xE0 m\u1EA1ng x\xE3 h\u1ED9i chia s\u1EBB ho\u1EB7c cho ph\xE9p b\u1EA1n chia s\u1EBB th\xF4ng tin v\u1EDBi ch\xFAng t\xF4i. \u0110\u1EC3 bi\u1EBFt th\xEAm th\xF4ng tin v\u1EC1 n\u1EC1n t\u1EA3ng truy\u1EC1n th\xF4ng x\xE3 h\u1ED9i v\xE0 c\xE1c bi\u1EC7n ph\xE1p b\u1EA3o m\u1EADt m\u1EA1ng, vui l\xF2ng xem l\u1EA1i ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 v\xE0 c\xE0i \u0111\u1EB7t c\u1EE7a c\xE1c n\u1EC1n t\u1EA3ng v\xE0 m\u1EA1ng x\xE3 h\u1ED9i m\xE0 b\u1EA1n s\u1EED d\u1EE5ng."
      }), jsx("p", {
        children: "Khi b\u1EA1n y\xEAu c\u1EA7u th\xF4ng tin t\u1EEB ch\xFAng t\xF4i, ch\xFAng t\xF4i c\xF3 th\u1EC3 s\u1EED d\u1EE5ng \u0111\u1ECBa ch\u1EC9 email m\xE0 b\u1EA1n cung c\u1EA5p \u0111\u1EC3 g\u1EEDi cho b\u1EA1n th\xF4ng tin v\u1EC1 M\u1EE5c v\u1EE5 c\u1EE7a ch\xFAng t\xF4i v\xE0 c\xE1c t\xE0i li\u1EC7u m\xE0 b\u1EA1n c\xF3 th\u1EC3 quan t\xE2m. N\u1EBFu b\u1EA1n \u0111\xE3 \u0111\u1ED3ng \xFD nh\u1EADn th\xF4ng tin li\xEAn l\u1EA1c t\u1EEB ch\xFAng t\xF4i, nh\u01B0 qua e-mail, b\u1EA1n c\xF3 th\u1EC3 y\xEAu c\u1EA7u ch\xFAng t\xF4i x\xF3a b\u1EA1n kh\u1ECFi danh s\xE1ch b\u1EA5t k\u1EF3 l\xFAc n\xE0o (s\u1EED d\u1EE5ng h\u01B0\u1EDBng d\u1EABn h\u1EE7y \u0111\u0103ng k\xFD \u0111\u01B0\u1EE3c cung c\u1EA5p c\xF9ng v\u1EDBi m\u1ED7i email)."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "6. Quy\u1EC1n ri\xEAng t\u01B0 tr\u1EF1c tuy\u1EBFn c\u1EE7a tr\u1EBB em"
        })
      }), jsxs("p", {
        children: ["Ch\xFAng t\xF4i quan t\xE2m t\u1EDBi quy\u1EC1n ri\xEAng t\u01B0 c\u1EE7a tr\u1EBB em v\xE0 ch\xFAng t\xF4i kh\xF4ng thu th\u1EADp b\u1EA5t k\u1EF3 th\xF4ng tin c\xE1 nh\xE2n n\xE0o ngo\xE0i m\u1EE9c c\u1EA7n thi\u1EBFt \u0111\u1EC3 cho ph\xE9p c\xE1c em tham gia v\xE0o c\xE1c ho\u1EA1t \u0111\u1ED9ng m\xE0 ch\xFAng t\xF4i cung c\u1EA5p tr\xEAn trang web c\u1EE7a m\xECnh. Ch\xFAng t\xF4i khuy\u1EBFn kh\xEDch b\u1EA1n tham gia v\xE0o vi\u1EC7c con b\u1EA1n truy c\u1EADp Internet v\xE0 trang web c\u1EE7a ch\xFAng t\xF4i \u0111\u1EC3 \u0111\u1EA3m b\u1EA3o r\u1EB1ng quy\u1EC1n ri\xEAng t\u01B0 c\u1EE7a con b\u1EA1n \u0111\u01B0\u1EE3c b\u1EA3o v\u1EC7 t\u1ED1t nh\u1EA5t. \u0110\u1EC3 \u0111\u1ECDc th\xEAm v\u1EC1 an to\xE0n tr\u1EF1c tuy\u1EBFn v\xE0 c\xE1ch tham gia nhi\u1EC1u h\u01A1n v\xE0o ho\u1EA1t \u0111\u1ED9ng tr\u1EF1c tuy\u1EBFn c\u1EE7a con b\u1EA1n, h\xE3y truy c\u1EADp", jsx("a", {
          href: "http://onguardonline.gov/",
          children: " OnGuardOnline.gov"
        }), "."]
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "7. Ch\xFAng t\xF4i s\u1EED d\u1EE5ng Cookie nh\u01B0 th\u1EBF n\xE0o?"
        })
      }), jsx("p", {
        children: "Khi b\u1EA1n truy c\u1EADp trang web c\u1EE7a ch\xFAng t\xF4i, ch\xFAng t\xF4i c\xF3 th\u1EC3 \u0111\u1EB7t m\u1ED9t \u201Ccookie\u201D tr\xEAn m\xE1y t\xEDnh c\u1EE7a b\u1EA1n \u0111\u1EC3 theo d\xF5i l\u01B0\u1EE3t truy c\u1EADp c\u1EE7a b\u1EA1n. Cookie l\xE0 m\u1ED9t t\u1EC7p d\u1EEF li\u1EC7u nh\u1ECF ch\u1EC9 c\xF3 th\u1EC3 \u0111\u01B0\u1EE3c \u0111\u1ECDc b\u1EDFi trang web \u0111\xE3 \u0111\u1EB7t cookie tr\xEAn \u1ED5 c\u1EE9ng c\u1EE7a b\u1EA1n. Cookie ho\u1EA1t \u0111\u1ED9ng nh\u01B0 m\u1ED9t th\u1EBB nh\u1EADn d\u1EA1ng v\xE0 cho ph\xE9p trang web c\u1EE7a ch\xFAng t\xF4i nh\u1EADn d\u1EA1ng b\u1EA1n v\xE0 l\u01B0u gi\u1EEF th\xF4ng tin c\xF3 li\xEAn quan \u0111\u1EBFn vi\u1EC7c t\u01B0\u01A1ng t\xE1c v\u1EDBi trang web c\u1EE7a ch\xFAng t\xF4i. Cookie cho ph\xE9p ch\xFAng t\xF4i theo d\xF5i l\u01B0\u1EE3t truy c\u1EADp c\u1EE7a b\u1EA1n v\xE0o trang web \u0111\u1EC3 ch\xFAng t\xF4i c\xF3 th\u1EC3 hi\u1EC3u r\xF5 h\u01A1n vi\u1EC7c b\u1EA1n s\u1EED d\u1EE5ng trang web c\u1EE7a ch\xFAng t\xF4i v\xE0 t\xF9y ch\u1EC9nh n\xF3 \u0111\u1EC3 \u0111\xE1p \u1EE9ng t\u1ED1t h\u01A1n nhu c\u1EA7u c\u1EE7a b\u1EA1n."
      }), jsx("p", {
        children: "Ch\xFAng t\xF4i c\xF3 th\u1EC3 s\u1EED d\u1EE5ng c\xE1c lo\u1EA1i cookie kh\xE1c nhau tr\xEAn trang web c\u1EE7a m\xECnh: cookie \u0111o s\u1EF1 truy c\u1EADp li\xEAn t\u1EE5c (persistent cookies); cookie \u0111\u1EBFm c\xE1c phi\xEAn truy c\u1EADp (session cookies); v\xE0 cookie c\u1EE7a b\xEAn th\u1EE9 ba (third-party cookies). (Vui l\xF2ng tham kh\u1EA3o ph\u1EA7n Tr\u1EE3 gi\xFAp tr\xEAn tr\xECnh duy\u1EC7t c\u1EE7a b\u1EA1n \u0111\u1EC3 bi\u1EBFt th\xEAm th\xF4ng tin v\u1EC1 c\xE1ch ki\u1EC3m so\xE1t v\xE0 c\xE0i \u0111\u1EB7t cookie)."
      }), jsx("p", {
        children: "M\u1ED9t cookie \u0111o s\u1EF1 truy c\u1EADp li\xEAn t\u1EE5c v\u1EABn c\xF2n tr\xEAn m\xE1y t\xEDnh c\u1EE7a b\u1EA1n cho m\u1EE5c \u0111\xEDch x\xE1c th\u1EF1c khi vi\u1EC7c s\u1EED d\u1EE5ng trang web n\xE0y y\xEAu c\u1EA7u t\xEAn ng\u01B0\u1EDDi d\xF9ng v\xE0 m\u1EADt kh\u1EA9u. Ch\xFAng t\xF4i c\xF3 th\u1EC3 s\u1EED d\u1EE5ng cookie \u0111o s\u1EF1 truy c\u1EADp li\xEAn t\u1EE5c \u0111\u1EC3 l\u01B0u t\xEAn ng\u01B0\u1EDDi d\xF9ng c\u1EE7a b\u1EA1n v\u1EDBi s\u1EF1 \u0111\u1ED3ng \xFD c\u1EE7a b\u1EA1n tr\xEAn m\xE1y t\xEDnh, do \u0111\xF3, b\u1EA1n kh\xF4ng c\u1EA7n ph\u1EA3i nh\u1EADp l\u1EA1i t\xEAn ng\u01B0\u1EDDi d\xF9ng \u0111\xF3 m\u1ED7i khi truy c\u1EADp m\u1ED9t trong c\xE1c trang web c\u1EE7a ch\xFAng t\xF4i. B\u1EA1n c\xF3 th\u1EC3 ch\u1ECDn t\u1EEB ch\u1ED1i cookie \u0111o s\u1EF1 truy c\u1EADp li\xEAn t\u1EE5c v\xE0 s\u1EED d\u1EE5ng m\u1EADt kh\u1EA9u \u0111\u0103ng nh\u1EADp c\u1EE7a m\xECnh m\u1ED7i l\u1EA7n b\u1EA1n truy c\u1EADp m\u1ED9t trang web v\xE0 trang web s\u1EBD v\u1EABn ho\u1EA1t \u0111\u1ED9ng b\xECnh th\u01B0\u1EDDng."
      }), jsx("p", {
        children: "Cookie \u0111o s\u1ED1 phi\xEAn truy c\u1EADp l\xE0 m\u1ED9t cookie t\u1EA1m th\u1EDDi, ch\u1EC9 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng trong m\u1ED9t phi\xEAn duy nh\u1EA5t tr\xEAn trang web n\xE0y v\xE0 s\u1EBD t\u1EF1 \u0111\u1ED9ng b\u1ECB x\xF3a khi b\u1EA1n truy c\u1EADp xong. Ch\xFAng t\xF4i c\xF3 th\u1EC3 s\u1EED d\u1EE5ng cookie \u0111o s\u1ED1 phi\xEAn truy c\u1EADp (a) \u0111\u1EC3 t\xF9y ch\u1EC9nh l\u01B0\u1EE3t truy c\u1EADp v\xE0o trang web n\xE0y v\xE0 tr\u1EA3i nghi\u1EC7m tr\u1EF1c tuy\u1EBFn c\u1EE7a b\u1EA1n, (b) \u0111\u1EC3 cung c\u1EA5p n\u1ED9i dung ph\xF9 h\u1EE3p v\u1EDBi s\u1EDF th\xEDch \u0111\xE3 n\xEAu c\u1EE7a b\u1EA1n c\u0169ng nh\u01B0 c\xE1ch b\u1EA1n duy\u1EC7t v\xE0/ho\u1EB7c s\u1EED d\u1EE5ng trang web n\xE0y v\xE0 (c) \u0111\u1EC3 c\xE1c m\u1EE5c \u0111\xEDch kh\xE1c \u0111\u1EC3 l\xE0m cho vi\u1EC7c truy c\u1EADp th\xF4ng tin c\u1EE7a b\u1EA1n thu\u1EADn ti\u1EC7n h\u01A1n."
      }), jsx("p", {
        children: "B\u1EA1n c\xF3 th\u1EC3 d\u1EEBng ho\u1EB7c h\u1EA1n ch\u1EBF vi\u1EC7c \u0111\u1EB7t cookie tr\xEAn m\xE1y t\xEDnh c\u1EE7a m\xECnh ho\u1EB7c x\xF3a ch\xFAng kh\u1ECFi tr\xECnh duy\u1EC7t b\u1EB1ng c\xE1ch \u0111i\u1EC1u ch\u1EC9nh t\xF9y ch\u1ECDn tr\xECnh duy\u1EC7t web c\u1EE7a b\u1EA1n. T\xF9y thu\u1ED9c v\xE0o trang web, vi\u1EC7c t\u1EEB ch\u1ED1i cookie \u0111o s\u1ED1 phi\xEAn truy c\u1EADp c\xF3 th\u1EC3 \u1EA3nh h\u01B0\u1EDFng \u0111\u1EBFn ch\u1EE9c n\u0103ng c\u1EE7a trang web n\xE0y v\xE0 trong m\u1ED9t s\u1ED1 tr\u01B0\u1EDDng h\u1EE3p nh\u1EA5t \u0111\u1ECBnh, b\u1EA1n c\xF3 th\u1EC3 ph\u1EA3i ch\u1EA5p nh\u1EADn cookie n\xE0y \u0111\u1EC3 trang web c\xF3 th\u1EC3 ho\u1EA1t \u0111\u1ED9ng. N\u1EBFu tr\xECnh duy\u1EC7t c\u1EE7a b\u1EA1n kh\xF4ng ph\xE2n bi\u1EC7t gi\u1EEFa cookie \u0111o s\u1EF1 truy c\u1EADp li\xEAn t\u1EE5c v\xE0 cookie \u0111o s\u1ED1 phi\xEAn truy c\u1EADp, b\u1EA1n c\xF3 th\u1EC3 ph\u1EA3i b\u1EADt t\u1EA5t c\u1EA3 cookie \u0111\u1EC3 trang web n\xE0y ho\u1EA1t \u0111\u1ED9ng b\xECnh th\u01B0\u1EDDng."
      }), jsx("p", {
        children: "Ngo\xE0i cookie, ch\xFAng t\xF4i c\xF3 th\u1EC3 s\u1EED d\u1EE5ng \u0111\xE8n hi\u1EC7u web (web beacon). \u0110\xE8n hi\u1EC7u web l\xE0 nh\u1EEFng m\u1EA9u d\u1EEF li\u1EC7u nh\u1ECF \u0111\u01B0\u1EE3c nh\xFAng v\xE0o h\xECnh \u1EA3nh tr\xEAn c\xE1c trang c\u1EE7a trang web. Ch\xFAng c\xF3 th\u1EC3 \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 g\u1EEDi th\xF4ng tin tr\u1EF1c ti\u1EBFp cho ch\xFAng t\xF4i, cho m\u1ED9t b\xEAn kh\xE1c thay m\u1EB7t ch\xFAng t\xF4i ho\u1EB7c cho m\u1ED9t b\xEAn kh\xE1c theo ch\xEDnh s\xE1ch b\u1EA3o m\u1EADt c\u1EE7a h\u1ECD. Ch\xFAng t\xF4i c\xF3 th\u1EC3 s\u1EED d\u1EE5ng \u0111\xE8n hi\u1EC7u web \u0111\u1EC3 t\u1EADp h\u1EE3p th\xF4ng tin ch\xFAng t\xF4i thu th\u1EADp v\u1EC1 b\u1EA1n."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "8. Qu\u1EA3ng c\xE1o Tr\u1EF1c tuy\u1EBFn th\xEC sao?"
        })
      }), jsx("p", {
        children: "Ch\xFAng t\xF4i th\xFAc \u0111\u1EA9y v\xE0 khuy\u1EBFn kh\xEDch h\u1ED7 tr\u1EE3 c\xE1c ho\u1EA1t \u0111\u1ED9ng v\xE0 ngu\u1ED3n l\u1EF1c c\u1EE7a M\u1EE5c v\u1EE5 b\u1EB1ng c\xE1ch mua kh\xF4ng gian qu\u1EA3ng c\xE1o tr\xEAn c\xE1c trang web c\u1EE7a b\xEAn th\u1EE9 ba. Khi b\u1EA1n truy c\u1EADp m\u1ED9t s\u1ED1 trang web, ch\xFAng t\xF4i ho\u1EB7c m\u1ED9t b\xEAn th\u1EE9 ba c\xF3 th\u1EC3 \u0111\u1EB7t m\u1ED9t ho\u1EB7c nhi\u1EC1u lo\u1EA1i cookie tr\xEAn m\xE1y t\xEDnh c\u1EE7a b\u1EA1n \u0111\u1EC3 nh\u1EADn d\u1EA1ng m\xE1y t\xEDnh c\u1EE7a b\u1EA1n. V\xEC ch\xFAng t\xF4i qu\u1EA3ng c\xE1o v\u1EC1 c\xE1c ho\u1EA1t \u0111\u1ED9ng m\u1EE5c v\u1EE5 c\u1EE7a m\xECnh tr\xEAn c\xE1c trang web c\u1EE7a b\xEAn th\u1EE9 ba n\xEAn ch\xFAng t\xF4i c\xF3 th\u1EC3 t\u1ED5ng h\u1EE3p th\xF4ng tin \u1EA9n danh theo th\u1EDDi gian v\u1EC1 c\xE1c lo\u1EA1i trang, n\u1ED9i dung v\xE0 qu\u1EA3ng c\xE1o m\xE0 b\u1EA1n ho\u1EB7c nh\u1EEFng ng\u01B0\u1EDDi kh\xE1c s\u1EED d\u1EE5ng m\xE1y t\xEDnh c\u1EE7a b\u1EA1n \u0111\xE3 truy c\u1EADp ho\u1EB7c xem. Th\xF4ng tin \u1EA9n danh n\xE0y \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng cho nhi\u1EC1u m\u1EE5c \u0111\xEDch. V\xED d\u1EE5: n\xF3 gi\xFAp ch\xFAng t\xF4i c\u1ED1 g\u1EAFng \u0111\u1EA3m b\u1EA3o r\u1EB1ng b\u1EA1n kh\xF4ng nh\xECn th\u1EA5y c\xE1c qu\u1EA3ng c\xE1o gi\u1ED1ng nhau nhi\u1EC1u l\u1EA7n. Ch\xFAng t\xF4i c\u0169ng s\u1EED d\u1EE5ng th\xF4ng tin \u1EA9n danh n\xE0y \u0111\u1EC3 gi\xFAp ch\u1ECDn v\xE0 hi\u1EC3n th\u1ECB c\xE1c qu\u1EA3ng c\xE1o \u0111\u01B0\u1EE3c x\xE1c \u0111\u1ECBnh m\u1EE5c ti\xEAu tr\xEAn c\xE1c trang web c\u1EE7a b\xEAn th\u1EE9 ba nh\u1EB1m khuy\u1EBFn kh\xEDch h\u1ED7 tr\u1EE3 c\xE1c ho\u1EA1t \u0111\u1ED9ng m\u1EE5c v\u1EE5 c\u1EE7a ch\xFAng t\xF4i."
      }), jsx("p", {
        children: "C\xE1c c\xF4ng ty b\xEAn th\u1EE9 ba c\u0169ng c\xF3 th\u1EC3 thu th\u1EADp th\xF4ng tin \u1EA9n danh v\u1EC1 ho\u1EA1t \u0111\u1ED9ng c\u1EE7a b\u1EA1n tr\xEAn c\xE1c trang web v\xE0 \u1EE9ng d\u1EE5ng c\u1EE7a ch\xFAng t\xF4i c\u0169ng nh\u01B0 tr\xEAn c\xE1c trang web v\xE0 \u1EE9ng d\u1EE5ng c\u1EE7a b\xEAn th\u1EE9 ba b\u1EB1ng c\xE1ch s\u1EED d\u1EE5ng c\xE1c c\xF4ng ngh\u1EC7 theo d\xF5i tr\u1EF1c tuy\u1EBFn nh\u01B0 cookie v\xE0 \u0111\xE8n hi\u1EC7u web. D\u1EEF li\u1EC7u theo d\xF5i do c\xE1c c\xF4ng ty b\xEAn th\u1EE9 ba n\xE0y thu th\u1EADp \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng \u0111\u1EC3 quy\u1EBFt \u0111\u1ECBnh nh\u1EEFng qu\u1EA3ng c\xE1o n\xE0o b\u1EA1n nh\xECn th\u1EA5y tr\xEAn c\xE1c trang web v\xE0 \u1EE9ng d\u1EE5ng c\u1EE7a b\xEAn th\u1EE9 ba nh\u01B0ng kh\xF4ng nh\u1EADn d\u1EA1ng c\xE1 nh\xE2n b\u1EA1n."
      }), jsxs("p", {
        children: ["B\u1EA1n c\xF3 th\u1EC3 ch\u1ECDn kh\xF4ng nh\u1EADn qu\u1EA3ng c\xE1o \u0111\u01B0\u1EE3c x\xE1c \u0111\u1ECBnh m\u1EE5c ti\xEAu t\u1EEB nhi\u1EC1u m\u1EA1ng qu\u1EA3ng c\xE1o, trao \u0111\u1ED5i d\u1EEF li\u1EC7u, ph\xE2n t\xEDch ti\u1EBFp th\u1ECB v\xE0 c\xE1c nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 kh\xE1c b\u1EB1ng c\xE1ch truy c\u1EADp Tr\xECnh qu\u1EA3n l\xFD", ' ', jsx("a", {
          href: "https://www.google.com/settings/u/0/ads/authenticated?hl=en",
          children: "t\xF9y ch\u1ECDn qu\u1EA3ng c\xE1o"
        }), "."]
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "9. C\xF2n c\xE1c \u0111\u01B0\u1EDDng link li\xEAn k\u1EBFt \u0111\u1EBFn c\xE1c trang web kh\xE1c th\xEC sao?"
        })
      }), jsx("p", {
        children: "Trang web c\u1EE7a ch\xFAng t\xF4i c\xF3 th\u1EC3 ch\u1EE9a c\xE1c \u0111\u01B0\u1EDDng link \u0111\u1EBFn c\xE1c trang web kh\xE1c. \u0110\u1EC3 cho ph\xE9p b\u1EA1n t\u01B0\u01A1ng t\xE1c v\u1EDBi c\xE1c trang web c\u1EE7a b\xEAn th\u1EE9 ba m\xE0 b\u1EA1n c\xF3 th\u1EC3 c\xF3 t\xE0i kho\u1EA3n (nh\u01B0 c\xE1c trang web m\u1EA1ng x\xE3 h\u1ED9i) ho\u1EB7c tham gia c\u1ED9ng \u0111\u1ED3ng tr\xEAn c\xE1c trang web \u0111\xF3, ch\xFAng t\xF4i c\xF3 th\u1EC3 cung c\u1EA5p \u0111\u01B0\u1EDDng link ho\u1EB7c nh\xFAng c\xE1c \u1EE9ng d\u1EE5ng c\u1EE7a b\xEAn th\u1EE9 ba cho ph\xE9p b\u1EA1n \u0111\u0103ng nh\u1EADp, \u0111\u0103ng n\u1ED9i dung ho\u1EB7c tham gia c\u1ED9ng \u0111\u1ED3ng t\u1EEB c\xE1c trang web c\u1EE7a ch\xFAng t\xF4i."
      }), jsx("p", {
        children: "Xin l\u01B0u \xFD r\u1EB1ng c\xE1c trang web c\u1EE7a b\xEAn th\u1EE9 ba \u0111\u01B0\u1EE3c truy c\u1EADp th\xF4ng qua c\xE1c \u0111\u01B0\u1EDDng link tr\xEAn trang web c\u1EE7a ch\xFAng t\xF4i ph\u1EA3i tu\xE2n theo ch\xEDnh s\xE1ch v\xE0 ti\xEAu chu\u1EA9n v\u1EC1 quy\u1EC1n ri\xEAng t\u01B0 c\u1EE7a b\xEAn th\u1EE9 ba. Ch\xFAng t\xF4i kh\xF4ng th\u1EC3 ch\u1ECBu b\u1EA5t k\u1EF3 tr\xE1ch nhi\u1EC7m n\xE0o \u0111\u1ED1i v\u1EDBi c\xE1c th\u1EF1c ti\u1EC5n, ch\xEDnh s\xE1ch ho\u1EB7c h\xE0nh \u0111\u1ED9ng v\u1EC1 quy\u1EC1n ri\xEAng t\u01B0 c\u1EE7a b\xEAn th\u1EE9 ba v\u1EADn h\xE0nh c\xE1c trang web n\xE0y ho\u1EB7c v\u1EC1 c\xE1ch h\u1ECD thu th\u1EADp, s\u1EED d\u1EE5ng ho\u1EB7c chia s\u1EBB th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n. B\u1EA1n n\xEAn xem l\u1EA1i ch\xEDnh s\xE1ch b\u1EA3o m\u1EADt c\u1EE7a c\xE1c trang web n\xE0y tr\u01B0\u1EDBc khi cung c\u1EA5p cho h\u1ECD th\xF4ng tin c\xE1 nh\xE2n."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "10. T\u1EA1i sao ch\xFAng t\xF4i thu th\u1EADp, s\u1EED d\u1EE5ng v\xE0 chia s\u1EBB th\xF4ng tin c\xE1 nh\xE2n?"
        })
      }), jsx("p", {
        children: "Th\xF4ng tin c\xE1 nh\xE2n \u0111\u01B0\u1EE3c thu th\u1EADp th\xF4ng qua trang web c\u1EE7a ch\xFAng t\xF4i \u0111\u01B0\u1EE3c s\u1EED d\u1EE5ng v\xE0 chia s\u1EBB cho m\u1EE5c \u0111\xEDch m\u1EE5c v\u1EE5 c\u1EE7a ch\xFAng t\xF4i. V\xED d\u1EE5: ch\xFAng t\xF4i c\xF3 th\u1EC3 thu th\u1EADp, s\u1EED d\u1EE5ng v\xE0 chia s\u1EBB th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n cho vi\u1EC7c:"
      }), jsxs("ul", {
        children: [jsx("li", {
          children: "Thi\u1EBFt l\u1EADp, duy tr\xEC v\xE0 qu\u1EA3n l\xFD m\u1ED1i quan h\u1EC7 c\u1EE7a ch\xFAng t\xF4i v\u1EDBi b\u1EA1n v\xE0 th\u1EF1c hi\u1EC7n c\xE1c \u0111\u01A1n \u0111\u1EB7t h\xE0ng \u0111\u01B0\u1EE3c y\xEAu c\u1EA7u;"
        }), jsx("li", {
          children: "Trao \u0111\u1ED5i v\u1EDBi b\u1EA1n v\u1EC1 m\u1EE5c v\u1EE5 c\u1EE7a ch\xFAng t\xF4i v\xE0 c\xE1c ngu\u1ED3n l\u1EF1c m\xE0 b\u1EA1n c\xF3 th\u1EC3 quan t\xE2m;"
        }), jsx("li", {
          children: "C\xF3 th\u1EC3 xem x\xE9t c\xE1c s\u1EA3n ph\u1EA9m v\xE0 d\u1ECBch v\u1EE5 m\xE0 ch\xFAng t\xF4i cung c\u1EA5p cho b\u1EA1n \u0111\u1EC3 ch\xFAng t\xF4i c\xF3 th\u1EC3 n\u1ED7 l\u1EF1c c\u1EA3i thi\u1EC7n s\u1EA3n ph\u1EA9m v\xE0 d\u1ECBch v\u1EE5 c\u1EE7a m\xECnh;"
        }), jsx("li", {
          children: "C\xF3 th\u1EC3 th\u1EF1c hi\u1EC7n theo y\xEAu c\u1EA7u c\u1EE7a b\u1EA1n;"
        }), jsx("li", {
          children: "B\u1EA3o v\u1EC7 ch\xFAng t\xF4i kh\u1ECFi sai s\xF3t, gian l\u1EADn, tr\u1ED9m c\u1EAFp v\xE0 h\u01B0 h\u1ECFng t\xE0i s\u1EA3n c\u1EE7a ch\xFAng t\xF4i; V\xE0"
        }), jsx("li", {
          children: "Cho ph\xE9p ch\xFAng t\xF4i tu\xE2n th\u1EE7 lu\u1EADt ph\xE1p hi\u1EC7n h\xE0nh ho\u1EB7c quy tr\xECnh qu\u1EA3n l\xFD (v\xED d\u1EE5: ch\xFAng t\xF4i c\xF3 th\u1EC3 thu th\u1EADp th\xF4ng tin c\xE1 nh\xE2n \u0111\u1EC3 \u0111\xE1p \u1EE9ng c\xE1c ngh\u0129a v\u1EE5 do nhi\u1EC1u c\u01A1 quan qu\u1EA3n l\xFD \u0111\u1EB7t ra cho ch\xFAng t\xF4i)."
        })]
      }), jsx("p", {
        children: "BGEA kh\xF4ng bao gi\u1EDD mua b\xE1n, cho thu\xEA, ho\u1EB7c trao \u0111\u1ED5i th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n v\u1EDBi c\xE1c t\u1ED5 ch\u1EE9c kh\xE1c. \u0110\u1EC3 ho\xE0n th\xE0nh m\u1EE5c \u0111\xEDch c\u1EE7a t\u1ED5 ch\u1EE9c v\xE0 m\u1EE5c \u0111\xEDch m\xE0 b\u1EA1n \u0111\xE3 cung c\u1EA5p cho ch\xFAng t\xF4i th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a m\xECnh, th\xF4ng tin \u0111\xF3 c\xF3 th\u1EC3 \u0111\u01B0\u1EE3c chia s\u1EBB v\u1EDBi nh\xE2n vi\xEAn c\u1EE7a ch\xFAng t\xF4i, M\u1EE5c v\u1EE5 \u0110\u1ED1i t\xE1c v\xE0 c\xE1c b\xEAn kh\xE1c y\xEAu c\u1EA7u th\xF4ng tin \u0111\xF3 \u0111\u1EC3 h\u1ED7 tr\u1EE3 ch\xFAng t\xF4i thi\u1EBFt l\u1EADp, duy tr\xEC v\xE0 qu\u1EA3n l\xFD m\u1ED1i quan h\u1EC7 c\u1EE7a ch\xFAng t\xF4i v\u1EDBi b\u1EA1n v\xE0 cung c\u1EA5p c\xE1c s\u1EA3n ph\u1EA9m v\xE0 d\u1ECBch v\u1EE5 c\u1EE7a M\u1EE5c v\u1EE5. V\xED d\u1EE5: \u0111\xF4i khi, BGEA c\xF3 th\u1EC3 cung c\u1EA5p m\u1ED9t s\u1ED1 d\u1ECBch v\u1EE5 c\xF4ng ngh\u1EC7 th\xF4ng tin, x\u1EED l\xFD d\u1EEF li\u1EC7u v\xE0 d\u1ECBch v\u1EE5 t\u01B0 v\u1EA5n nh\u1EA5t \u0111\u1ECBnh cho c\xE1c M\u1EE5c v\u1EE5 \u0110\u1ED1i t\xE1c (\u1EDF Hoa K\u1EF3 ho\u1EB7c n\u01B0\u1EDBc ngo\xE0i) \u0111\u1EC3 ch\xFAng t\xF4i ho\u1EB7c h\u1ECD c\xF3 th\u1EC3 cung c\u1EA5p c\xE1c d\u1ECBch v\u1EE5 c\u1EE7a M\u1EE5c v\u1EE5 m\xE0 b\u1EA1n \u0111\xE3 b\xE0y t\u1ECF s\u1EF1 quan t\xE2m. Qua \u0111\xF3, th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n c\xF3 th\u1EC3 truy\u1EC1n qua ho\u1EB7c \u0111\u01B0\u1EE3c thu th\u1EADp, s\u1EED d\u1EE5ng, x\u1EED l\xFD, l\u01B0u tr\u1EEF ho\u1EB7c chia s\u1EBB \u1EDF c\u1EA3 Hoa K\u1EF3 v\xE0 c\xE1c qu\u1ED1c gia kh\xE1c, k\u1EC3 c\u1EA3 c\xE1c qu\u1ED1c gia ngo\xE0i Khu v\u1EF1c Kinh t\u1EBF Ch\xE2u \xC2u, d\u01B0\u1EDBi s\u1EF1 ki\u1EC3m so\xE1t c\u1EE7a BGEA ho\u1EB7c m\u1ED9t trong c\xE1c M\u1EE5c v\u1EE5 \u0110\u1ED1i t\xE1c c\u1EE7a ch\xFAng t\xF4i. Khi th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n \u0111\u01B0\u1EE3c cung c\u1EA5p cho M\u1EE5c v\u1EE5 \u0110\u1ED1i t\xE1c ho\u1EB7c nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5, ch\xFAng t\xF4i s\u1EBD gi\u1EDBi h\u1EA1n vi\u1EC7c s\u1EED d\u1EE5ng th\xF4ng tin c\u1EE7a b\u1EA1n theo \u0111\xFAng m\u1EE5c \u0111\xEDch ch\xFAng \u0111\u01B0\u1EE3c cung c\u1EA5p."
      }), jsx("p", {
        children: "Xin l\u01B0u \xFD r\u1EB1ng ch\xFAng t\xF4i c\xF3 th\u1EC3 thu th\u1EADp, s\u1EED d\u1EE5ng ho\u1EB7c chia s\u1EBB th\xF4ng tin c\xE1 nh\xE2n \u0111\u01B0\u1EE3c cung c\u1EA5p c\xF4ng khai c\u1EE7a b\u1EA1n m\xE0 b\u1EA1n kh\xF4ng bi\u1EBFt ho\u1EB7c kh\xF4ng \u0111\u1ED3ng \xFD khi ch\xFAng t\xF4i \u0111\u01B0\u1EE3c ph\xE1p lu\u1EADt hi\u1EC7n h\xE0nh ho\u1EB7c c\xE1c y\xEAu c\u1EA7u quy \u0111\u1ECBnh cho ph\xE9p ho\u1EB7c y\xEAu c\u1EA7u l\xE0m theo."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "11. Ch\xFAng t\xF4i l\u01B0u gi\u1EEF th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n trong bao l\xE2u?"
        })
      }), jsx("p", {
        children: "Ch\xFAng t\xF4i l\u01B0u gi\u1EEF th\xF4ng tin c\xE1 nh\xE2n kh\xF4ng gi\u1EDBi h\u1EA1n th\u1EDDi gian theo nhu c\u1EA7u s\u1EED d\u1EE5ng c\u1EE7a ch\xFAng t\xF4i cho th\xF4ng tin \u0111\xF3 m\u1ED9t c\xE1ch h\u1EE3p l\xFD cho m\u1EE5c \u0111\xEDch m\u1EE5c v\u1EE5 ho\u1EB7c ph\xE1p l\xFD. Khi x\xE1c \u0111\u1ECBnh th\u1EDDi gian l\u01B0u gi\u1EEF d\u1EEF li\u1EC7u, BGEA xem x\xE9t lu\u1EADt ph\xE1p \u0111\u1ECBa ph\u01B0\u01A1ng, ngh\u0129a v\u1EE5 h\u1EE3p \u0111\u1ED3ng c\u0169ng nh\u01B0 nh\u1EEFng k\u1EF3 v\u1ECDng v\xE0 y\xEAu c\u1EA7u \u0111\u1EC3 x\u1EED l\xFD d\u1EEF li\u1EC7u \u0111\xF3."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "12. S\u1EF1 \u0111\u1ED3ng \xFD c\u1EE7a b\u1EA1n r\u1EA5t quan tr\u1ECDng \u0111\u1ED1i v\u1EDBi ch\xFAng t\xF4i"
        })
      }), jsx("p", {
        children: "B\u1EB1ng c\xE1ch t\u01B0\u01A1ng t\xE1c v\u1EDBi M\u1EE5c v\u1EE5 c\u1EE7a ch\xFAng t\xF4i (v\xED d\u1EE5: b\u1EB1ng c\xE1ch s\u1EED d\u1EE5ng trang web c\u1EE7a ch\xFAng t\xF4i) v\xE0, n\u1EBFu c\xF3, g\u1EEDi th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n, b\u1EA1n \u0111\u1ED3ng \xFD v\u1EDBi c\xE1c \u0111i\u1EC1u kho\u1EA3n c\u1EE7a Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 n\xE0y."
      }), jsxs("p", {
        children: ["B\u1EA1n c\xF3 th\u1EC3 thay \u0111\u1ED5i ho\u1EB7c r\xFAt l\u1EA1i s\u1EF1 \u0111\u1ED3ng \xFD c\u1EE7a m\xECnh b\u1EA5t k\u1EF3 l\xFAc n\xE0o, t\xF9y theo c\xE1c h\u1EA1n ch\u1EBF v\u1EC1 ph\xE1p l\xFD ho\u1EB7c h\u1EE3p \u0111\u1ED3ng v\xE0 th\xF4ng b\xE1o h\u1EE3p l\xFD, b\u1EB1ng c\xE1ch li\xEAn h\u1EC7 v\u1EDBi ch\xFAng t\xF4i theo \u0111\u1ECBa ch\u1EC9", ' ', jsx("a", {
          href: "mailto:privacy@bgea.org",
          children: "Privacy@bgea.org"
        }), ". T\u1EA5t c\u1EA3 c\xE1c th\xF4ng tin li\xEAn l\u1EA1c li\xEAn quan \u0111\u1EBFn vi\u1EC7c r\xFAt l\u1EA1i ho\u1EB7c thay \u0111\u1ED5i s\u1EF1 \u0111\u1ED3ng \xFD \u0111\xF3 ph\u1EA3i \u0111\u01B0\u1EE3c th\u1EF1c hi\u1EC7n b\u1EB1ng e-mail v\xE0 ch\xFAng t\xF4i c\xF3 th\u1EC3 m\u1EA5t t\u1EDBi 30 ng\xE0y \u0111\u1EC3 x\u1EED l\xFD vi\u1EC7c r\xFAt l\u1EA1i s\u1EF1 \u0111\u1ED3ng \xFD c\u1EE7a b\u1EA1n. Xin l\u01B0u \xFD r\u1EB1ng trong m\u1ED9t s\u1ED1 tr\u01B0\u1EDDng h\u1EE3p, vi\u1EC7c r\xFAt l\u1EA1i ho\u1EB7c thay \u0111\u1ED5i s\u1EF1 \u0111\u1ED3ng \xFD c\u1EE7a b\u1EA1n \u0111\u1ED1i v\u1EDBi m\u1ED9t s\u1ED1 c\xE1ch s\u1EED d\u1EE5ng th\xF4ng tin c\xE1 nh\xE2n nh\u1EA5t \u0111\u1ECBnh c\u1EE7a b\u1EA1n c\xF3 th\u1EC3 \u1EA3nh h\u01B0\u1EDFng \u0111\u1EBFn: (i) kh\u1EA3 n\u0103ng ch\xFAng t\xF4i cung c\u1EA5p cho b\u1EA1n c\xE1c s\u1EA3n ph\u1EA9m ho\u1EB7c d\u1ECBch v\u1EE5 m\xE0 b\u1EA1n y\xEAu c\u1EA7u; v\xE0 (ii) kh\u1EA3 n\u0103ng truy c\u1EADp trang web n\xE0y c\u1EE7a b\u1EA1n."]
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "13. Th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n \u0111\u01B0\u1EE3c b\u1EA3o v\u1EC7 nh\u01B0 th\u1EBF n\xE0o?"
        })
      }), jsx("p", {
        children: "BGEA n\u1ED7 l\u1EF1c duy tr\xEC c\xE1c bi\u1EC7n ph\xE1p b\u1EA3o v\u1EC7 v\u1EC1 v\u1EADt l\xFD, k\u1EF9 thu\u1EADt v\xE0 th\u1EE7 t\u1EE5c ph\xF9 h\u1EE3p v\u1EDBi t\xEDnh nh\u1EA1y c\u1EA3m c\u1EE7a th\xF4ng tin c\xE1 nh\xE2n \u0111\u01B0\u1EE3c \u0111\u1EC1 c\u1EADp. Nh\u1EEFng bi\u1EC7n ph\xE1p b\u1EA3o v\u1EC7 n\xE0y \u0111\u01B0\u1EE3c thi\u1EBFt k\u1EBF \u0111\u1EC3 ng\u0103n ch\u1EB7n th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n b\u1ECB m\u1EA5t v\xE0 b\u1ECB truy c\u1EADp, sao ch\xE9p, s\u1EED d\u1EE5ng, s\u1EEDa \u0111\u1ED5i ho\u1EB7c chia s\u1EBB tr\xE1i ph\xE9p."
      }), jsx("p", {
        children: "BGEA s\u1EED d\u1EE5ng Ph\u1EA7n m\u1EC1m m\xE3 h\xF3a Internet, Giao th\u1EE9c l\u1EDBp c\u1ED5ng b\u1EA3o m\u1EADt (SSL) ho\u1EB7c Giao th\u1EE9c b\u1EA3o m\u1EADt l\u1EDBp v\u1EADn chuy\u1EC3n (TLS) khi thu th\u1EADp ho\u1EB7c truy\u1EC1n d\u1EEF li\u1EC7u nh\u1EA1y c\u1EA3m nh\u01B0 th\xF4ng tin th\u1EBB t\xEDn d\u1EE5ng. M\u1ECDi th\xF4ng tin b\u1EA1n nh\u1EADp \u0111\u1EC1u \u0111\u01B0\u1EE3c m\xE3 h\xF3a tr\xEAn tr\xECnh duy\u1EC7t c\u1EE7a b\u1EA1n, \u0111\u01B0\u1EE3c g\u1EEDi qua Internet c\xF4ng c\u1ED9ng \u1EDF d\u1EA1ng m\xE3 h\xF3a v\xE0 sau \u0111\xF3 \u0111\u01B0\u1EE3c gi\u1EA3i m\xE3 t\u1EA1i m\xE1y ch\u1EE7 c\u1EE7a ch\xFAng t\xF4i."
      }), jsx("p", {
        children: "Th\u1EADt kh\xF4ng may, kh\xF4ng c\xF3 d\u1EEF li\u1EC7u truy\u1EC1n qua Internet n\xE0o c\xF3 th\u1EC3 \u0111\u01B0\u1EE3c \u0111\u1EA3m b\u1EA3o an to\xE0n 100%. Do \u0111\xF3, trong khi trang web n\xE0y c\u1ED1 g\u1EAFng b\u1EA3o v\u1EC7 th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n, ch\xFAng t\xF4i kh\xF4ng th\u1EC3 \u0111\u1EA3m b\u1EA3o t\xEDnh b\u1EA3o m\u1EADt c\u1EE7a b\u1EA5t k\u1EF3 th\xF4ng tin n\xE0o b\u1EA1n truy\u1EC1n cho ch\xFAng t\xF4i v\xE0 b\u1EA1n ph\u1EA3i t\u1EF1 ch\u1ECBu r\u1EE7i ro khi l\xE0m nh\u01B0 v\u1EADy. Sau khi nh\u1EADn \u0111\u01B0\u1EE3c th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n, ch\xFAng t\xF4i s\u1EBD th\u1EF1c hi\u1EC7n nh\u1EEFng n\u1ED7 l\u1EF1c h\u1EE3p l\xFD v\u1EC1 m\u1EB7t th\u01B0\u01A1ng m\u1EA1i \u0111\u1EC3 \u0111\u1EA3m b\u1EA3o t\xEDnh b\u1EA3o m\u1EADt c\u1EE7a th\xF4ng tin \u0111\xF3 tr\xEAn h\u1EC7 th\u1ED1ng c\u1EE7a ch\xFAng t\xF4i. Ngo\xE0i ra, n\u1EBFu b\u1EA1n cung c\u1EA5p cho ch\xFAng t\xF4i th\xF4ng tin thanh to\xE1n c\u1EE7a m\xECnh, ch\u1EC9 m\u1ED9t s\u1ED1 \xEDt nh\xE2n vi\xEAn BGEA \u0111\xE1ng tin c\u1EADy \u0111\xE3 \u0111\u01B0\u1EE3c \u0111\xE0o t\u1EA1o \u0111\u1EB7c bi\u1EC7t \u0111\u1EC3 x\u1EED l\xFD th\xF4ng tin n\xE0y m\u1EDBi c\xF3 th\u1EC3 truy c\u1EADp \u0111\u01B0\u1EE3c th\xF4ng tin \u0111\xF3."
      }), jsx("p", {
        children: "Vi\u1EC7c b\u1EA3o m\u1EADt th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n r\u1EA5t quan tr\u1ECDng \u0111\u1ED1i v\u1EDBi ch\xFAng t\xF4i. Vui l\xF2ng th\xF4ng b\xE1o cho ch\xFAng t\xF4i ngay l\u1EADp t\u1EE9c v\u1EC1 b\u1EA5t k\u1EF3 s\u1EF1 c\u1ED1 n\xE0o li\xEAn quan \u0111\u1EBFn vi\u1EC7c m\u1EA5t ho\u1EB7c truy c\u1EADp tr\xE1i ph\xE9p ho\u1EB7c chia s\u1EBB th\xF4ng tin c\xE1 nh\xE2n \u0111ang \u0111\u01B0\u1EE3c ch\xFAng t\xF4i l\u01B0u gi\u1EEF ho\u1EB7c ki\u1EC3m so\xE1t."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "14. C\u1EADp nh\u1EADt th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n."
        })
      }), jsx("p", {
        children: "Ch\xFAng t\xF4i \u0111\u1EC1 cao s\u1EF1 quan tr\u1ECDng v\u1EC1 th\xF4ng tin trong h\u1ED3 s\u01A1 c\u1EE7a ch\xFAng t\xF4i ph\u1EA3i ch\xEDnh x\xE1c v\xE0 c\u1EADp nh\u1EADt. N\u1EBFu th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n t\xECnh c\u1EDD thay \u0111\u1ED5i trong qu\xE1 tr\xECnh trao \u0111\u1ED5i c\u1EE7a ch\xFAng ta, vui l\xF2ng th\xF4ng b\xE1o cho ch\xFAng t\xF4i v\u1EC1 nh\u1EEFng thay \u0111\u1ED5i \u0111\xF3 theo \u0111\u1ECBa ch\u1EC9 Privacy@bgea.org . Trong m\u1ED9t s\u1ED1 tr\u01B0\u1EDDng h\u1EE3p, ch\xFAng t\xF4i c\xF3 th\u1EC3 th\u1EF1c hi\u1EC7n theo y\xEAu c\u1EA7u c\u1EE7a b\u1EA1n b\u1EB1ng c\xE1ch th\xEAm v\u0103n b\u1EA3n thay th\u1EBF v\xE0o h\u1ED3 s\u01A1 \u0111\u01B0\u1EE3c \u0111\u1EC1 c\u1EADp."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "15. Truy c\u1EADp th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n."
        })
      }), jsxs("p", {
        children: ["B\u1EA1n c\xF3 th\u1EC3 h\u1ECFi v\u1EC1 th\xF4ng tin c\xE1 nh\xE2n m\xE0 ch\xFAng t\xF4i c\xF3 v\u1EC1 b\u1EA1n. N\u1EBFu b\u1EA1n mu\u1ED1n xem x\xE9t, x\xE1c minh ho\u1EB7c ch\u1EC9nh s\u1EEDa th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a m\xECnh, vui l\xF2ng li\xEAn h\u1EC7 v\u1EDBi ch\xFAng t\xF4i b\u1EB1ng e-mail t\u1EDBi \u0111\u1ECBa ch\u1EC9", ' ', jsx("a", {
          href: "mailto:privacy@bgea.org",
          children: "Privacy@bgea.org"
        }), "."]
      }), jsx("p", {
        children: "Khi li\xEAn h\u1EC7 v\u1EDBi ch\xFAng t\xF4i v\u1EC1 th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n, ch\xFAng t\xF4i c\xF3 th\u1EC3 y\xEAu c\u1EA7u b\u1EA1n cung c\u1EA5p th\xF4ng tin c\u1EE5 th\u1EC3 \u0111\u1EC3 x\xE1c nh\u1EADn danh t\xEDnh v\xE0 quy\u1EC1n truy c\u1EADp c\u1EE7a b\u1EA1n, c\u0169ng nh\u01B0 t\xECm ki\u1EBFm v\xE0 cung c\u1EA5p cho b\u1EA1n th\xF4ng tin c\xE1 nh\xE2n m\xE0 ch\xFAng t\xF4i c\xF3 v\u1EC1 b\u1EA1n."
      }), jsx("p", {
        children: "Quy\u1EC1n truy c\u1EADp th\xF4ng tin c\xE1 nh\xE2n m\xE0 ch\xFAng t\xF4i l\u01B0u gi\u1EEF v\u1EC1 b\u1EA1n l\xE0 kh\xF4ng tuy\u1EC7t \u0111\u1ED1i. C\xF3 th\u1EC3 c\xF3 nh\u1EEFng tr\u01B0\u1EDDng h\u1EE3p m\xE0 lu\u1EADt ph\xE1p hi\u1EC7n h\xE0nh ho\u1EB7c c\xE1c y\xEAu c\u1EA7u ph\xE1p l\xFD cho ph\xE9p ho\u1EB7c y\xEAu c\u1EA7u ch\xFAng t\xF4i t\u1EEB ch\u1ED1i cung c\u1EA5p m\u1ED9t s\u1ED1 ho\u1EB7c t\u1EA5t c\u1EA3 th\xF4ng tin c\xE1 nh\xE2n m\xE0 ch\xFAng t\xF4i c\xF3 v\u1EC1 b\u1EA1n. Ngo\xE0i ra, th\xF4ng tin c\xE1 nh\xE2n c\xF3 th\u1EC3 \u0111\xE3 b\u1ECB h\u1EE7y, x\xF3a ho\u1EB7c \u1EA9n danh theo ngh\u0129a v\u1EE5 v\xE0 th\xF4ng l\u1EC7 l\u01B0u gi\u1EEF h\u1ED3 s\u01A1 c\u1EE7a ch\xFAng t\xF4i. Trong tr\u01B0\u1EDDng h\u1EE3p ch\xFAng t\xF4i kh\xF4ng th\u1EC3 cung c\u1EA5p cho b\u1EA1n quy\u1EC1n truy c\u1EADp v\xE0o th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n, ch\xFAng t\xF4i s\u1EBD th\xF4ng b\xE1o cho b\u1EA1n l\xFD do t\u1EA1i sao, t\xF9y thu\u1ED9c v\xE0o b\u1EA5t k\u1EF3 h\u1EA1n ch\u1EBF ph\xE1p l\xFD ho\u1EB7c quy \u0111\u1ECBnh n\xE0o."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "16. Nh\u1EEFng quan t\xE2m c\u1EE7a b\u1EA1n."
        })
      }), jsxs("p", {
        children: ["B\u1EA1n c\xF3 th\u1EC3 qu\u1EA3n l\xFD c\xE1c lo\u1EA1i th\xF4ng tin li\xEAn l\u1EA1c b\u1EA1n nh\u1EADn \u0111\u01B0\u1EE3c t\u1EEB ch\xFAng t\xF4i b\u1EB1ng c\xE1ch c\u1EADp nh\u1EADt t\xF9y ch\u1ECDn c\u1EE7a b\u1EA1n", ' ', jsx("a", {
          href: "https://billygraham.org/subscriptions/",
          children: "t\u1EA1i \u0111\xE2y"
        }), ", b\u1EB1ng c\xE1ch s\u1EED d\u1EE5ng li\xEAn k\u1EBFt h\u1EE7y \u0111\u0103ng k\xFD c\xF3 trong li\xEAn l\u1EA1c qua email m\xE0 b\u1EA1n nh\u1EADn \u0111\u01B0\u1EE3c t\u1EEB ch\xFAng t\xF4i ho\u1EB7c b\u1EB1ng c\xE1ch li\xEAn h\u1EC7 v\u1EDBi ch\xFAng t\xF4i theo \u0111\u1ECBa ch\u1EC9", jsx("a", {
          href: "mailto:privacy@bgea.org",
          children: "Privacy@bgea.org"
        }), "."]
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "17. Th\xF4ng tin th\xEAm cho nh\u1EEFng ng\u01B0\u1EDDi b\xEAn ngo\xE0i Hoa K\u1EF3."
        })
      }), jsx("p", {
        children: "Ch\u1EC9 khi b\u1EA1n t\u01B0\u01A1ng t\xE1c v\u1EDBi ch\xFAng t\xF4i t\u1EEB nh\u1EEFng n\u01A1i c\xF3 lu\u1EADt b\u1EA3o m\u1EADt d\u1EEF li\u1EC7u nh\u01B0 Quy \u0111\u1ECBnh chung v\u1EC1 b\u1EA3o v\u1EC7 d\u1EEF li\u1EC7u c\u1EE7a Li\xEAn minh Ch\xE2u \xC2u ho\u1EB7c lu\u1EADt t\u01B0\u01A1ng \u0111\u01B0\u01A1ng th\xEC ch\xFAng t\xF4i c\u0169ng mu\u1ED1n b\u1EA1n bi\u1EBFt nh\u1EEFng \u0111i\u1EC1u sau \u0111\xE2y v\u1EC1 c\xE1ch ch\xFAng t\xF4i x\u1EED l\xFD th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n."
      }), jsxs("p", {
        children: [jsx("strong", {
          children: "C\u01A1 s\u1EDF \u0111\u1EC3 x\u1EED l\xFD."
        }), " Ch\xFAng t\xF4i c\xF3 th\u1EC3 x\u1EED l\xFD th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n ch\u1EE7 y\u1EBFu v\xEC:"]
      }), jsxs("ul", {
        children: [jsx("li", {
          children: "vi\u1EC7c x\u1EED l\xFD d\u1EF1a tr\xEAn l\u1EE3i \xEDch h\u1EE3p ph\xE1p c\u1EE7a M\u1EE5c v\u1EE5 (v\xED d\u1EE5: \u0111\u1EC3 b\u1EA3o v\u1EC7 t\xEDnh b\u1EA3o m\u1EADt v\xE0 t\xEDnh to\xE0n v\u1EB9n c\u1EE7a h\u1EC7 th\u1ED1ng c\u1EE7a ch\xFAng t\xF4i ho\u1EB7c \u0111\u1EC3 \u0111\xE1p \u1EE9ng y\xEAu c\u1EA7u c\u1EE7a b\u1EA1n, v.v.);"
        }), jsx("li", {
          children: "b\u1EA1n \u0111\xE3 \u0111\u1ED3ng \xFD;"
        }), jsx("li", {
          children: "vi\u1EC7c x\u1EED l\xFD l\xE0 c\u1EA7n thi\u1EBFt cho m\u1ED1i quan h\u1EC7 h\u1EE3p \u0111\u1ED3ng c\u1EE7a ch\xFAng t\xF4i; v\xE0/ho\u1EB7c"
        }), jsx("li", {
          children: "vi\u1EC7c x\u1EED l\xFD l\xE0 c\u1EA7n thi\u1EBFt \u0111\u1EC3 ch\xFAng t\xF4i tu\xE2n th\u1EE7 c\xE1c ngh\u0129a v\u1EE5 ph\xE1p l\xFD ho\u1EB7c quy \u0111\u1ECBnh c\u1EE7a m\xECnh."
        })]
      }), jsxs("p", {
        children: [jsx("strong", {
          children: "Quy\u1EC1n l\u1EE3i c\u1EE7a b\u1EA1n."
        }), " B\u1EA1n c\xF3 quy\u1EC1n y\xEAu c\u1EA7u quy\u1EC1n truy c\u1EADp v\xE0o th\xF4ng tin c\xE1 nh\xE2n m\xE0 ch\xFAng t\xF4i l\u01B0u gi\u1EEF v\u1EC1 b\u1EA1n v\xE0 y\xEAu c\u1EA7u s\u1EEDa b\u1EA5t k\u1EF3 th\xF4ng tin kh\xF4ng ch\xEDnh x\xE1c n\xE0o. B\u1EA1n c\u0169ng c\xF3 c\xE1c quy\u1EC1n kh\xE1c bao g\u1ED3m:"]
      }), jsxs("ul", {
        children: [jsx("li", {
          children: "quy\u1EC1n x\xF3a th\xF4ng tin;"
        }), jsx("li", {
          children: "quy\u1EC1n h\u1EA1n ch\u1EBF x\u1EED l\xFD;"
        }), jsx("li", {
          children: "quy\u1EC1n di chuy\u1EC3n d\u1EEF li\u1EC7u;"
        }), jsx("li", {
          children: "quy\u1EC1n ph\u1EA3n \u0111\u1ED1i; v\xE0/ho\u1EB7c"
        }), jsx("li", {
          children: "c\xE1c quy\u1EC1n li\xEAn quan \u0111\u1EBFn vi\u1EC7c ra quy\u1EBFt \u0111\u1ECBnh v\xE0 l\u1EADp h\u1ED3 s\u01A1 t\u1EF1 \u0111\u1ED9ng (n\u1EBFu c\xF3)."
        })]
      }), jsx("p", {
        children: "Ch\xFAng t\xF4i xem x\xE9t v\xE0 ph\u1EA3n h\u1ED3i m\u1ECDi y\xEAu c\u1EA7u theo quy \u0111\u1ECBnh c\u1EE7a ph\xE1p lu\u1EADt hi\u1EC7n h\xE0nh. Nh\u01B0 \u0111\xE3 \u0111\u1EC1 c\u1EADp \u1EDF tr\xEAn, khi li\xEAn h\u1EC7 v\u1EDBi ch\xFAng t\xF4i v\u1EC1 th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n, ch\xFAng t\xF4i c\xF3 th\u1EC3 y\xEAu c\u1EA7u th\xF4ng tin c\u1EE5 th\u1EC3 t\u1EEB b\u1EA1n \u0111\u1EC3 x\xE1c nh\u1EADn danh t\xEDnh v\xE0 quy\u1EC1n y\xEAu c\u1EA7u c\u1EE7a b\u1EA1n, c\u0169ng nh\u01B0 t\xECm ki\u1EBFm th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n v\xE0 cung c\u1EA5p cho b\u1EA1n ph\u1EA3n h\u1ED3i cho y\xEAu c\u1EA7u c\u1EE7a b\u1EA1n. C\u0169ng c\xF3 th\u1EC3 c\xF3 nh\u1EEFng tr\u01B0\u1EDDng h\u1EE3p kh\xF4ng th\u1EC3 th\u1EF1c hi\u1EC7n y\xEAu c\u1EA7u c\u1EE7a b\u1EA1n do c\xE1c y\xEAu c\u1EA7u ph\xE1p l\xFD ho\u1EB7c c\xE1c ngh\u0129a v\u1EE5 ho\u1EB7c th\xF4ng l\u1EC7 kh\xE1c."
      }), jsxs("p", {
        children: ["H\xE3y cho ch\xFAng t\xF4i bi\u1EBFt v\u1EC1 y\xEAu c\u1EA7u ho\u1EB7c quan ng\u1EA1i m\xE0 b\u1EA1n c\xF3 th\u1EC3 c\xF3 b\u1EB1ng c\xE1ch li\xEAn h\u1EC7 v\u1EDBi ch\xFAng t\xF4i theo \u0111\u1ECBa ch\u1EC9", ' ', jsx("a", {
          href: "mailto:privacy@bgea.org",
          children: "Privacy@bgea.org"
        }), ". B\u1EA1n c\u0169ng c\xF3 th\u1EC3 g\u1EEDi nh\u1EEFng quan ng\u1EA1i v\u1EC1 c\xE1ch ch\xFAng t\xF4i qu\u1EA3n l\xFD th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n t\u1EDBi c\u01A1 quan c\xF3 th\u1EA9m quy\u1EC1n t\u1EA1i khu v\u1EF1c c\u1EE7a b\u1EA1n."]
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "18. Tham gia qua thi\u1EBFt b\u1ECB di \u0111\u1ED9ng v\xE0 tin nh\u1EAFn v\u0103n b\u1EA3n"
        })
      }), jsx("p", {
        children: "Vi\u1EC7c tham gia v\xE0o c\xE1c ch\u01B0\u01A1ng tr\xECnh m\u1EE5c v\u1EE5 c\u1EE7a BGEA th\xF4ng qua thi\u1EBFt b\u1ECB di \u0111\u1ED9ng, nh\u01B0 qua tin nh\u1EAFn v\u0103n b\u1EA3n, s\u1EBD \u0111\xF2i h\u1ECFi ph\u1EA3i th\xF4ng qua c\xE1c nh\xE0 m\u1EA1ng kh\xF4ng d\xE2y l\u1EDBn \u1EDF Hoa K\u1EF3. BGEA kh\xF4ng th\u1EC3 \u0111\u1EA3m b\u1EA3o r\u1EB1ng b\u1EA5t k\u1EF3 nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 kh\xF4ng d\xE2y c\u1EE5 th\u1EC3 n\xE0o c\u0169ng s\u1EBD cho ph\xE9p b\u1EA1n th\u1EF1c hi\u1EC7n, \u0111i\u1EC1u n\xE0y c\xF2n t\xF9y thu\u1ED9c v\xE0o kh\u1EA3 n\u0103ng c\u1EE7a thi\u1EBFt b\u1ECB di \u0111\u1ED9ng c\u1EE7a b\u1EA1n. C\xE1c nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 kh\xF4ng d\xE2y c\xF3 th\u1EC3 t\xEDnh ph\xED tin nh\u1EAFn v\u0103n b\u1EA3n c\u1EE7a ng\u01B0\u1EDDi tham gia, bao g\u1ED3m c\u1EA3 tin nh\u1EAFn l\u1ED7i, \u0111\u01B0\u1EE3c g\u1EEDi v\xE0/ho\u1EB7c nh\u1EADn li\xEAn quan \u0111\u1EBFn c\xE1c ch\u01B0\u01A1ng tr\xECnh m\u1EE5c v\u1EE5 c\u1EE7a BGEA. BGEA s\u1EBD kh\xF4ng ch\u1ECBu tr\xE1ch nhi\u1EC7m v\u1EC1 nh\u1EEFng kho\u1EA3n ph\xED n\xE0y. Ng\u01B0\u1EDDi tham gia n\xEAn tham kh\u1EA3o g\xF3i gi\xE1 c\u1EE7a nh\xE0 cung c\u1EA5p d\u1ECBch v\u1EE5 kh\xF4ng d\xE2y \u0111\u1EC3 bi\u1EBFt chi ti\u1EBFt."
      }), jsx("p", {
        children: "D\u1EEF li\u1EC7u \u0111\u01B0\u1EE3c thu th\u1EADp th\xF4ng qua vi\u1EC7c s\u1EED d\u1EE5ng thi\u1EBFt b\u1ECB di \u0111\u1ED9ng c\xF3 th\u1EC3 bao g\u1ED3m nh\u01B0ng kh\xF4ng gi\u1EDBi h\u1EA1n \u1EDF (c\xE1c) ph\u1EA3n h\u1ED3i c\u1EE7a b\u1EA1n \u0111\u1ED1i v\u1EDBi ch\u01B0\u01A1ng tr\xECnh m\u1EE5c v\u1EE5 v\xE0 s\u1ED1 \u0111i\u1EC7n tho\u1EA1i di \u0111\u1ED9ng c\u1EE7a b\u1EA1n. Vi\u1EC7c s\u1EED d\u1EE5ng d\u1EEF li\u1EC7u \u0111\xF3 s\u1EBD \u0111\u01B0\u1EE3c m\xF4 t\u1EA3 \u1EDF n\u01A1i kh\xE1c trong Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 n\xE0y. B\u1EB1ng c\xE1ch t\u01B0\u01A1ng t\xE1c v\u1EDBi BGEA qua thi\u1EBFt b\u1ECB di \u0111\u1ED9ng v\xE0/ho\u1EB7c tin nh\u1EAFn v\u0103n b\u1EA3n, b\u1EA1n \u0111\u1ED3ng \xFD cho ph\xE9p BGEA s\u1EED d\u1EE5ng thi\u1EBFt b\u1ECB di \u0111\u1ED9ng v\xE0 s\u1ED1 \u0111i\u1EC7n tho\u1EA1i di \u0111\u1ED9ng c\u1EE7a b\u1EA1n \u0111\u1EC3 li\xEAn l\u1EA1c v\u1EDBi b\u1EA1n. BGEA s\u1EBD cung c\u1EA5p th\xF4ng tin t\u1EEB ch\u1ED1i cho ph\xE9p b\u1EA1n th\u1EC3 hi\u1EC7n mong mu\u1ED1n ng\u1EEBng nh\u1EADn tin nh\u1EAFn v\u0103n b\u1EA3n."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "19. Th\u1EAFc m\u1EAFc ho\u1EB7c quan ng\u1EA1i?"
        })
      }), jsxs("p", {
        children: ["N\u1EBFu b\u1EA1n c\xF3 b\u1EA5t k\u1EF3 c\xE2u h\u1ECFi n\xE0o v\u1EC1 Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 n\xE0y ho\u1EB7c quan ng\u1EA1i v\u1EC1 c\xE1ch ch\xFAng t\xF4i qu\u1EA3n l\xFD th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n, vui l\xF2ng li\xEAn h\u1EC7 v\u1EDBi ch\xFAng t\xF4i theo \u0111\u1ECBa ch\u1EC9", ' ', jsx("a", {
          href: "mailto:privacy@bgea.org",
          children: "Privacy@bgea.org"
        }), "."]
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "20. S\u1EEDa \u0111\u1ED5i Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 n\xE0y"
        })
      }), jsx("p", {
        children: "\u0110\xF4i khi, BGEA c\xF3 th\u1EC3 th\u1EF1c hi\u1EC7n c\xE1c thay \u0111\u1ED5i \u0111\u1ED1i v\u1EDBi Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 n\xE0y \u0111\u1EC3 ph\u1EA3n \xE1nh nh\u1EEFng thay \u0111\u1ED5i trong ngh\u0129a v\u1EE5 ph\xE1p l\xFD ho\u1EB7c quy \u0111\u1ECBnh c\u1EE7a m\xECnh ho\u1EB7c c\xE1ch ch\xFAng t\xF4i x\u1EED l\xFD th\xF4ng tin c\xE1 nh\xE2n c\u1EE7a b\u1EA1n (ng\xE0y c\u1EADp nh\u1EADt cu\u1ED1i c\xF9ng \u0111\u01B0\u1EE3c hi\u1EC3n th\u1ECB b\xEAn d\u01B0\u1EDBi)."
      })]
    }), jsxs(Block, {
      textSize: 6,
      children: [jsx("p", {
        children: jsx("strong", {
          children: "21. Gi\u1EA3i th\xEDch Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 n\xE0y"
        })
      }), jsx("p", {
        children: "M\u1ECDi gi\u1EA3i th\xEDch li\xEAn quan \u0111\u1EBFn Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 n\xE0y s\u1EBD do BGEA th\u1EF1c hi\u1EC7n. Tr\u1EEB khi c\xF3 quy \u0111\u1ECBnh kh\xE1c, Ch\xEDnh s\xE1ch quy\u1EC1n ri\xEAng t\u01B0 n\xE0y kh\xF4ng t\u1EA1o ra ho\u1EB7c trao b\u1EA5t k\u1EF3 quy\u1EC1n n\xE0o cho b\u1EA5t k\u1EF3 c\xE1 nh\xE2n n\xE0o ho\u1EB7c \xE1p \u0111\u1EB7t l\xEAn BGEA b\u1EA5t k\u1EF3 quy\u1EC1n ho\u1EB7c ngh\u0129a v\u1EE5 n\xE0o b\xEAn ngo\xE0i ho\u1EB7c ngo\xE0i b\u1EA5t k\u1EF3 quy\u1EC1n ho\u1EB7c ngh\u0129a v\u1EE5 n\xE0o do lu\u1EADt ph\xE1p li\xEAn bang v\xE0 ti\u1EC3u bang Hoa K\u1EF3 quy \u0111\u1ECBnh, n\u1EBFu c\xF3."
      })]
    })]
  });
};

// Global object for temporary data

var bgeaObj = {
  entity: {
    firstName: '',
    lastName: '',
    email: [{
      emailAddress: ''
    }],
    address: [{
      zipPostalCode: ''
    }]
  }
};

var destinationTitle = 'Where Will the Subscription Be Mailed?';
var giftSubscriptionLabel = 'Choose';
var giftSubscriptionTitle = 'Is this subscription a gift shipping to a different address than the billing address?';
var subscriptionOptionTitle = 'Choose a Subscription Option:';
var giftRecipientTitle = "Gift Recipient's Information";
var paymentTitle = 'Payment Information';
var SubTypes = /*#__PURE__*/function (SubTypes) {
  SubTypes["ONE_PD"] = "1pd";
  SubTypes["TWO_PD"] = "2pd";
  return SubTypes;
}({});
var SubLocations = /*#__PURE__*/function (SubLocations) {
  SubLocations["US"] = "US";
  SubLocations["INTL"] = "INTL";
  return SubLocations;
}({});
var destinationOptions = [{
  label: 'U.S. or Mexico',
  name: 'destinationGroup',
  id: SubLocations.US,
  value: SubLocations.US
}, {
  label: 'Outside of U.S. and Mexico',
  name: 'destinationGroup',
  id: SubLocations.INTL,
  value: SubLocations.INTL
}];
var giftSubscriptionOptions = [{
  value: 'No',
  id: 'no'
}, {
  value: 'Yes',
  id: 'yes'
}];
var addressVisibleList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'];
var billingAddressVisibleList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode'];
var displayList = ['Name', 'Email', 'Address'];

var europeanCountries = ['AX', 'AL', 'AD', 'AM', 'AT', 'AZ', 'BY', 'GG', 'JE', 'BA', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FO', 'FI', 'FR', 'GE', 'DE', 'GI', 'GR', 'GL', 'HU', 'IS', 'IE', 'IM', 'IT', 'KZ', 'XK', 'LV', 'LI', 'LT', 'LU', 'MT', 'MD', 'MC', 'ME', 'NL', 'MK', 'NO', 'PL', 'PT', 'RO', 'RU', 'SM', 'RS', 'SK', 'SI', 'ES', 'SE', 'CH', 'TR', 'UA', 'GB'];

var transportType = 'A01a:GRPBOOKREF';
var numGroupType = 'A01b:GRPBOOKREG';
var transportTypeMap = {
  1: {
    key: transportType,
    value: 'public_transportation'
  },
  2: {
    key: transportType,
    value: 'private_bus'
  },
  3: {
    key: transportType,
    value: 'mini_bus'
  },
  4: {
    key: transportType,
    value: 'other'
  },
  5: {
    key: transportType,
    value: 'Free Event Bus'
  },
  6: {
    key: transportType,
    value: 'Book a FREE Bus'
  },
  7: {
    key: transportType,
    value: 'Church Vehicle'
  },
  8: {
    key: transportType,
    value: 'Private/Own Car'
  },
  9: {
    key: transportType,
    value: 'Taxi'
  },
  10: {
    key: transportType,
    value: 'Volunteer Business Owner Vehicle'
  }
};

/* Matching NewNames handling of postal code */
var maximumPostalCodeLength = 5;
var minimumPostalCodeLength = 5;
var defaultEsubs = [{
  key: 'ESUBS',
  value: 'BGEA Today'
}, {
  key: 'ESUBS',
  value: 'DMAGNL'
}];
var defaultPriceCode = [{
  amount: 0,
  priceCode: 'COMP6',
  quantity: 1
}];
var defaultSpecialCode = [{
  key: 'SPECIAL',
  value: 'B582'
}];

/* From @bgea/bg-forms */

var handleCase1 = function handleCase1(_ref) {
  var city = _ref.city,
    role = _ref.role,
    codeKey = _ref.codeKey,
    returnCitiesRoles = _ref.returnCitiesRoles,
    textValue = _ref.textValue;
  var i = 0;
  if (city.length > 0) {
    city.forEach(function (c) {
      var cl = JSON.parse(c);
      if (role.length > 0) {
        role.forEach(function (r) {
          var rl = JSON.parse(r);
          var codeValue = cl.SECodeEventId + rl.SECodeEventRoleId;
          // PAYKV + M122 = PAYKVM122
          if (codeValue && typeof codeValue === 'string' && codeKey && typeof codeKey === 'string') {
            returnCitiesRoles[i] = {};
            returnCitiesRoles[i].key = codeKey;
            // codeKey is passed in and should be something like 'DTR'
            returnCitiesRoles[i].value = codeValue;
            i += 1;
            returnCitiesRoles[i] = {};
            returnCitiesRoles[i].key = "CRUSADE:".concat(cl.crusadeCodeEventId);
            returnCitiesRoles[i].value = "".concat(rl.crusadeCodeEventRoleId);
            // CRUSADE:113 1300
            i += 1;
            returnCitiesRoles[i] = {};
            returnCitiesRoles[i].key = "CRUSADE:".concat(cl.crusadeCodeEventId);
            returnCitiesRoles[i].value = 'EVENT';
            // CRUSADE:113 EVENT
            i += 1;
          }
        });
      }
      if (textValue && textValue.value !== undefined) {
        returnCitiesRoles[i] = {};
        returnCitiesRoles[i].key = "CRUSADE:".concat(cl.crusadeCodeEventId);
        returnCitiesRoles[i].value = textValue.value;
        // CRUSADE:113 1418
        i += 1;
      }
    });
  }
};
var handleCase2 = function handleCase2(_ref2) {
  var city = _ref2.city,
    role = _ref2.role,
    codeKey = _ref2.codeKey,
    returnCitiesRoles = _ref2.returnCitiesRoles,
    textValue = _ref2.textValue;
  var i = 0;
  var cityObject = city;
  if (role.length > 0) {
    role.forEach(function (r) {
      var rl = JSON.parse(r);
      var codeValue = cityObject.SECodeEventId + rl.SECodeEventRoleId;
      // PAYKV + M122 = PAYKVM122
      if (codeValue && typeof codeValue === 'string' && codeKey && typeof codeKey === 'string') {
        returnCitiesRoles[i] = {};
        returnCitiesRoles[i].key = codeKey;
        returnCitiesRoles[i].value = codeValue;
        i += 1;
        returnCitiesRoles[i] = {};
        returnCitiesRoles[i].key = "CRUSADE:".concat(cityObject.crusadeCodeEventId);
        returnCitiesRoles[i].value = "".concat(rl.crusadeCodeEventRoleId);
        // CRUSADE:113 1300
        i += 1;
        returnCitiesRoles[i] = {};
        returnCitiesRoles[i].key = "CRUSADE:".concat(cityObject.crusadeCodeEventId);
        returnCitiesRoles[i].value = 'EVENT';
        // CRUSADE:113 EVENT
      }
    });
  }

  if (textValue && textValue.value !== undefined) {
    i += 1;
    returnCitiesRoles[i] = {};
    returnCitiesRoles[i].key = "CRUSADE:".concat(cityObject.crusadeCodeEventId);
    returnCitiesRoles[i].value = textValue.value;
    // CRUSADE:113 1418
  }
};

var handleCase3 = function handleCase3(_ref3) {
  var city = _ref3.city,
    role = _ref3.role,
    codeKey = _ref3.codeKey,
    returnCitiesRoles = _ref3.returnCitiesRoles,
    textValue = _ref3.textValue;
  var i = 0;
  var roleObject = role;
  if (city.length > 0) {
    city.forEach(function (c) {
      var cl = JSON.parse(c);
      var codeValue = cl.SECodeEventId + roleObject.SECodeEventRoleId;
      // PAYKV + M122 = PAYKVM122
      if (codeValue && typeof codeValue === 'string' && codeKey && typeof codeKey === 'string') {
        returnCitiesRoles[i] = {};
        returnCitiesRoles[i].key = codeKey;
        // codeKey is passed in and should be something like 'DTR'
        returnCitiesRoles[i].value = codeValue;
        i += 1;
        returnCitiesRoles[i] = {};
        returnCitiesRoles[i].key = "CRUSADE:".concat(cl.crusadeCodeEventId);
        returnCitiesRoles[i].value = "".concat(roleObject.crusadeCodeEventRoleId);
        // CRUSADE:113 1300
        i += 1;
        returnCitiesRoles[i] = {};
        returnCitiesRoles[i].key = "CRUSADE:".concat(cl.crusadeCodeEventId);
        returnCitiesRoles[i].value = 'EVENT';
        // CRUSADE:113 EVENT
        i += 1;
        if (textValue && textValue.value !== undefined) {
          returnCitiesRoles[i] = {};
          returnCitiesRoles[i].key = "CRUSADE:".concat(cl.crusadeCodeEventId);
          returnCitiesRoles[i].value = textValue.value;
          // CRUSADE:113 1418
          i += 1;
        }
      }
    });
  }
};
var handleCase4 = function handleCase4(_ref4) {
  var city = _ref4.city,
    role = _ref4.role,
    codeKey = _ref4.codeKey,
    returnCitiesRoles = _ref4.returnCitiesRoles,
    textValue = _ref4.textValue;
  var i = 0;
  var roleObj = role;
  var cityObj = city;
  var codeValue = cityObj.SECodeEventId + roleObj.SECodeEventRoleId;
  // PAYKV + M122 = PAYKVM122
  if (codeValue && typeof codeValue === 'string' && codeKey && typeof codeKey === 'string') {
    returnCitiesRoles[i] = {};
    returnCitiesRoles[i].key = codeKey;
    // codeKey is passed in and should be something like 'DTR'
    returnCitiesRoles[i].value = codeValue;
    i += 1;
    returnCitiesRoles[i] = {};
    returnCitiesRoles[i].key = "CRUSADE:".concat(cityObj.crusadeCodeEventId);
    returnCitiesRoles[i].value = "".concat(roleObj.crusadeCodeEventRoleId);
    // CRUSADE:113 1300
    i += 1;
    returnCitiesRoles[i] = {};
    returnCitiesRoles[i].key = "CRUSADE:".concat(cityObj.crusadeCodeEventId);
    returnCitiesRoles[i].value = 'EVENT';
    // CRUSADE:113 EVENT
    if (textValue && textValue.value !== undefined) {
      i += 1;
      returnCitiesRoles[i] = {};
      returnCitiesRoles[i].key = "CRUSADE:".concat(cityObj.crusadeCodeEventId);
      returnCitiesRoles[i].value = textValue.value;
      // CRUSADE:113 1418
    }
  }
};

var citiesRoles = function citiesRoles() {
  var cityJSON = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '{}';
  var roleJSON = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '{}';
  var textJSON = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '{}';
  var codeKey = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'DTR';
  var returnCitiesRoles = [];
  var city = typeof cityJSON === 'string' ? JSON.parse(cityJSON) : cityJSON;
  var role = typeof roleJSON === 'string' ? JSON.parse(roleJSON) : roleJSON;
  var text = _typeof(textJSON) === 'object' ? textJSON : '{}';
  var textValue = text !== '{}' && Array.isArray(text) && text.length < 1 ? '{}' : JSON.parse(text);
  switch (Array.isArray(city).toString() + Array.isArray(role).toString()) {
    case 'truetrue':
      {
        // Array && Array
        handleCase1({
          city: city,
          role: role,
          codeKey: codeKey,
          returnCitiesRoles: returnCitiesRoles,
          textValue: textValue
        });
        break;
      }
    case 'falsetrue':
      {
        // Object && Array
        handleCase2({
          city: city,
          role: role,
          codeKey: codeKey,
          returnCitiesRoles: returnCitiesRoles,
          textValue: textValue
        });
        break;
      }
    case 'truefalse':
      {
        // Array && Object
        handleCase3({
          city: city,
          role: role,
          codeKey: codeKey,
          returnCitiesRoles: returnCitiesRoles,
          textValue: textValue
        });
        break;
      }
    case 'falsefalse':
      {
        // Object && Object
        handleCase4({
          city: city,
          role: role,
          codeKey: codeKey,
          returnCitiesRoles: returnCitiesRoles,
          textValue: textValue
        });
        break;
      }
  }
  return returnCitiesRoles;
};
var getLangQuestionCodes = function getLangQuestionCodes(cityId, values) {
  var codes = [];
  if (cityId) {
    var _values$formLogic2, _values$formLogic3;
    if (values.formLogic.langQuestion === Language.ENGLISH || values.formLogic.fluentLangQuestion === FluentLanguageValue.NO && (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.language) === DDCLANG.EN) {
      codes.push({
        key: "CRUSADE:".concat(cityId),
        value: attrLangEnValue
      });
    } else if (values.formLogic.langQuestion === Language.SPANISH || values.formLogic.fluentLangQuestion === FluentLanguageValue.NO && (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.language) === DDCLANG.ES) {
      codes.push({
        key: "CRUSADE:".concat(cityId),
        value: attrLangEsValue
      });
    }
  }
  return codes;
};
var getCodes = function getCodes(_ref6) {
  var _entity$, _entity$$code;
  var city = _ref6.city,
    codeKey = _ref6.codeKey,
    _ref6$dtrValue = _ref6.dtrValue,
    dtrValue = _ref6$dtrValue === void 0 ? 'VM124' : _ref6$dtrValue,
    entity = _ref6.entity,
    _ref6$individualCrusa = _ref6.individualCrusadeCodeEventValue,
    individualCrusadeCodeEventValue = _ref6$individualCrusa === void 0 ? '1300' : _ref6$individualCrusa,
    role = _ref6.role,
    textOptIn = _ref6.textOptIn,
    values = _ref6.values;
  var cR = citiesRoles(city, role, textOptIn, codeKey);
  var stateDefaultCodes = [];
  var returnValue = [];
  if (cR && _typeof(cR) === 'object') {
    returnValue = cR;
  }
  var resetCodes = (_entity$ = entity[0]) === null || _entity$ === void 0 ? void 0 : (_entity$$code = _entity$.code) === null || _entity$$code === void 0 ? void 0 : _entity$$code.filter(function (item) {
    if (item && item.key && (item.key === 'DTR' || item.key.startsWith('CRUSADE:'))) {
      return false;
    }
    return true;
  });
  if (city.length > 0) {
    var cityEvent = JSON.parse(city);
    stateDefaultCodes.push({
      key: "CRUSADE:".concat(cityEvent.crusadeCodeEventId),
      value: individualCrusadeCodeEventValue
    });
    stateDefaultCodes.push({
      key: 'DTR',
      value: "".concat(cityEvent.SECodeEventId).concat(dtrValue)
    });
    var langQuestionCodes = getLangQuestionCodes(cityEvent.crusadeCodeEventId, values);
    if (langQuestionCodes.length > 0) {
      stateDefaultCodes.push.apply(stateDefaultCodes, _toConsumableArray(langQuestionCodes));
    }
  }
  if (stateDefaultCodes.length > 0) {
    stateDefaultCodes.forEach(function (code) {
      resetCodes.push(code);
    });
  }
  var codes = returnValue ? resetCodes.concat(returnValue) : resetCodes;
  var filteredCodes = codes.filter(function (obj, index) {
    return codes.findIndex(function (item) {
      return item.key === obj.key && item.value === obj.value;
    }) === index;
  });
  return {
    codes: filteredCodes.filter(function (code) {
      return code !== undefined;
    })
  };
};

var useCitiesRolesPrayerSelector = function useCitiesRolesPrayerSelector(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var city = deepFind(values, 'formLogic.city');
  var textOptIn = deepFind(values, 'formLogic.textOptIn');
  useEffect(function () {
    if (city) {
      var _values$collector$ent, _values$collector$ent2;
      var cityEvent = JSON.parse(city);
      var codes = [];
      codes[0] = {};
      codes[0].key = "DTR";
      codes[0].value = "".concat(cityEvent.SECodeEventId, "VC024");
      codes[1] = {};
      codes[1].key = "DTR";
      codes[1].value = "".concat(cityEvent.SECodeEventId, "VC124");
      codes[2] = {};
      codes[2].key = "DTR";
      codes[2].value = "".concat(cityEvent.SECodeEventId, "VM124");
      codes[3] = {};
      codes[3].key = "CRUSADE:".concat(cityEvent.crusadeCodeEventId);
      codes[3].value = props === null || props === void 0 ? void 0 : props.counselorRegistered;
      codes[4] = {};
      codes[4].key = "CRUSADE:".concat(cityEvent.crusadeCodeEventId);
      codes[4].value = 'EVENT';
      codes[5] = {};
      codes[5].key = "CRUSADE:".concat(cityEvent.crusadeCodeEventId);
      codes[5].value = props === null || props === void 0 ? void 0 : props.counselorApplied;
      codes[6] = {};
      codes[6].key = "CRUSADE:".concat(cityEvent.crusadeCodeEventId);
      codes[6].value = props === null || props === void 0 ? void 0 : props.counselorTrained;
      codes[7] = {};
      codes[7].key = "CRUSADE:".concat(cityEvent.crusadeCodeEventId);
      codes[7].value = '1300';
      if (textOptIn && textOptIn.length > 0) {
        var text = JSON.parse(textOptIn[0]);
        codes[8] = {};
        codes[8].key = "CRUSADE:".concat(cityEvent.crusadeCodeEventId);
        codes[8].value = text.value;
      }
      var filteredArr = ((_values$collector$ent = values.collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.filter(function (item) {
        var _item$key;
        return !(item !== null && item !== void 0 && (_item$key = item.key) !== null && _item$key !== void 0 && _item$key.startsWith('CRUSADE:')) && (item === null || item === void 0 ? void 0 : item.key) !== 'DTR' && (item === null || item === void 0 ? void 0 : item.value) !== attrLangEnValue && (item === null || item === void 0 ? void 0 : item.value) !== attrLangEsValue;
      })) || [];
      var codeLangArr = getLangQuestionCodes(cityEvent.crusadeCodeEventId, values);
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(filteredArr), _toConsumableArray(codeLangArr), _toConsumableArray(codes.filter(Boolean))));
    }
  }, [city, textOptIn]);
  useEffect(function () {
    if (city) {
      if (city.label) {
        setFieldValue("collector.questions[0].answerText", city.label);
      } else if (typeof city === 'string') {
        var cityObj = JSON.parse(city);
        setFieldValue("collector.questions[0].answerText", cityObj.label);
      }
    }
  }, [city]);
  return {
    city: city,
    values: values
  };
};

var useCitiesRolesDefaultSelector = function useCitiesRolesDefaultSelector(_ref) {
  var cities = _ref.cities,
    dtrValue = _ref.dtrValue,
    individualCrusadeCodeEventValue = _ref.individualCrusadeCodeEventValue,
    roles = _ref.roles,
    codeKey = _ref.codeKey,
    _ref$cityOnly = _ref.cityOnly,
    cityOnly = _ref$cityOnly === void 0 ? false : _ref$cityOnly,
    _ref$roleOnly = _ref.roleOnly,
    roleOnly = _ref$roleOnly === void 0 ? false : _ref$roleOnly;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var city = deepFind(values, 'formLogic.city');
  var role = deepFind(values, 'formLogic.role');
  var textOptIn = deepFind(values, 'formLogic.textOptIn');
  var entity = deepFind(values, 'collector.entity');
  useEffect(function () {
    // Single role, user only selects the city
    if (Object.keys(roles).length === 1 || cityOnly === true) {
      var roleVal = [];
      Object.values(roles).forEach(function (roleItem) {
        roleVal.push(JSON.stringify(roleItem));
      });
      setFieldValue("formLogic.role", roleVal);
    } else {
      setFieldValue('formLogic.role', '');
    }
    // Single city, user only selects the role
    if (Object.keys(cities).length === 1 || roleOnly === true) {
      var cityVal = [];
      Object.values(cities).forEach(function (cityItem) {
        cityVal.push(JSON.stringify(cityItem));
      });
      setFieldValue("formLogic.city", cityVal);
    }
    setFieldValue('formLogic.city', '');
    setFieldValue('formLogic.acknowledgement', {});
  }, []);
  useEffect(function () {
    if (city && role) {
      var _getCodes = getCodes({
          city: city,
          codeKey: codeKey,
          dtrValue: dtrValue,
          entity: entity,
          individualCrusadeCodeEventValue: individualCrusadeCodeEventValue,
          role: role,
          textOptIn: textOptIn,
          values: values
        }),
        codes = _getCodes.codes;
      setFieldValue("collector.entity[0].code", codes);
    }
  }, [city, role, textOptIn]);
  return {
    city: city,
    values: values
  };
};

var useCitiesRolesEsubSelector = function useCitiesRolesEsubSelector(_ref) {
  var _values$formLogic, _values$formLogic2, _values$formLogic3, _values$collector$ent, _values$collector$ent2;
  var cities = _ref.cities,
    roles = _ref.roles,
    _ref$cityOnly = _ref.cityOnly,
    cityOnly = _ref$cityOnly === void 0 ? false : _ref$cityOnly,
    _ref$roleOnly = _ref.roleOnly,
    roleOnly = _ref$roleOnly === void 0 ? false : _ref$roleOnly;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var city = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.city;
  var role = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.role;
  var textOptIn = values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.textOptIn;
  var resetArr = ((_values$collector$ent = values.collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.filter(function (item) {
    return !(item !== null && item !== void 0 && item.key.startsWith('CRUSADE:'));
  })) || [];
  useEffect(function () {
    // Single role, user only selects the city
    if (Object.keys(roles).length === 1 || cityOnly === true) {
      var roleVal = [];
      Object.values(roles).forEach(function (roleItem) {
        roleVal.push(JSON.stringify(roleItem));
      });
      setFieldValue("formLogic.role", roleVal);
    } else {
      setFieldValue('formLogic.role', '');
    }
    // Single city, user only selects the role
    if (Object.keys(cities).length === 1 || roleOnly === true) {
      var cityVal = [];
      Object.values(cities).forEach(function (cityItem) {
        cityVal.push(JSON.stringify(cityItem));
      });
      setFieldValue("formLogic.city", cityVal);
    }
    setFieldValue('formLogic.city', '');
    setFieldValue('formLogic.acknowledgement', {});
  }, []);
  useEffect(function () {
    if (city && role) {
      var cityEvent = JSON.parse(city);
      var codes = [{
        key: "CRUSADE:".concat(cityEvent.crusadeCodeEventId),
        value: 'EVENT'
      }, {
        key: "CRUSADE:".concat(cityEvent.crusadeCodeEventId),
        value: '1440'
      }];
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), codes));
    }
  }, [city, role, textOptIn]);
  return {
    city: city,
    values: values
  };
};

var useCitiesRolesSelector = function useCitiesRolesSelector(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var templateName = deepFind(values, 'formLogic.templateName');
  if (templateName === Templates.CHURCH_INTEREST) {
    return useCitiesRolesChurchSelector(_objectSpread2({}, props));
  }
  if (templateName === Templates.PRAYER_TEAM_MEMBER) {
    return useCitiesRolesPrayerSelector(_objectSpread2({}, props));
  }
  if (templateName === Templates.EMAIL_SUBSCRIBE) {
    return useCitiesRolesEsubSelector(_objectSpread2({}, props));
  }
  return useCitiesRolesDefaultSelector(_objectSpread2({}, props));
};

/**
 * A special placeholder value used to specify "gaps" within curried functions,
 * allowing partial application of any combination of arguments, regardless of
 * their positions.
 *
 * If `g` is a curried ternary function and `_` is `R.__`, the following are
 * equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2, _)(1, 3)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @name __
 * @constant
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @example
 *
 *      const greet = R.replace('{name}', R.__, 'Hello, {name}!');
 *      greet('Alice'); //=> 'Hello, Alice!'
 */
var __ = {
  '@@functional/placeholder': true
};

function _isPlaceholder(a) {
  return a != null && _typeof(a) === 'object' && a['@@functional/placeholder'] === true;
}

/**
 * Optimized internal one-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry1(fn) {
  return function f1(a) {
    if (arguments.length === 0 || _isPlaceholder(a)) {
      return f1;
    } else {
      return fn.apply(this, arguments);
    }
  };
}

/**
 * Optimized internal two-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry2(fn) {
  return function f2(a, b) {
    switch (arguments.length) {
      case 0:
        return f2;
      case 1:
        return _isPlaceholder(a) ? f2 : _curry1(function (_b) {
          return fn(a, _b);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f2 : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b);
        }) : fn(a, b);
    }
  };
}

function _arity(n, fn) {
  /* eslint-disable no-unused-vars */
  switch (n) {
    case 0:
      return function () {
        return fn.apply(this, arguments);
      };
    case 1:
      return function (a0) {
        return fn.apply(this, arguments);
      };
    case 2:
      return function (a0, a1) {
        return fn.apply(this, arguments);
      };
    case 3:
      return function (a0, a1, a2) {
        return fn.apply(this, arguments);
      };
    case 4:
      return function (a0, a1, a2, a3) {
        return fn.apply(this, arguments);
      };
    case 5:
      return function (a0, a1, a2, a3, a4) {
        return fn.apply(this, arguments);
      };
    case 6:
      return function (a0, a1, a2, a3, a4, a5) {
        return fn.apply(this, arguments);
      };
    case 7:
      return function (a0, a1, a2, a3, a4, a5, a6) {
        return fn.apply(this, arguments);
      };
    case 8:
      return function (a0, a1, a2, a3, a4, a5, a6, a7) {
        return fn.apply(this, arguments);
      };
    case 9:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8) {
        return fn.apply(this, arguments);
      };
    case 10:
      return function (a0, a1, a2, a3, a4, a5, a6, a7, a8, a9) {
        return fn.apply(this, arguments);
      };
    default:
      throw new Error('First argument to _arity must be a non-negative integer no greater than ten');
  }
}

/**
 * Internal curryN function.
 *
 * @private
 * @category Function
 * @param {Number} length The arity of the curried function.
 * @param {Array} received An array of arguments received thus far.
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curryN(length, received, fn) {
  return function () {
    var combined = [];
    var argsIdx = 0;
    var left = length;
    var combinedIdx = 0;
    while (combinedIdx < received.length || argsIdx < arguments.length) {
      var result;
      if (combinedIdx < received.length && (!_isPlaceholder(received[combinedIdx]) || argsIdx >= arguments.length)) {
        result = received[combinedIdx];
      } else {
        result = arguments[argsIdx];
        argsIdx += 1;
      }
      combined[combinedIdx] = result;
      if (!_isPlaceholder(result)) {
        left -= 1;
      }
      combinedIdx += 1;
    }
    return left <= 0 ? fn.apply(this, combined) : _arity(left, _curryN(length, combined, fn));
  };
}

/**
 * Returns a curried equivalent of the provided function, with the specified
 * arity. The curried function has two unusual capabilities. First, its
 * arguments needn't be provided one at a time. If `g` is `R.curryN(3, f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.5.0
 * @category Function
 * @sig Number -> (* -> a) -> (* -> a)
 * @param {Number} length The arity for the returned function.
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curry
 * @example
 *
 *      const sumArgs = (...args) => R.sum(args);
 *
 *      const curriedAddFourNumbers = R.curryN(4, sumArgs);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */

var curryN = /*#__PURE__*/
_curry2(function curryN(length, fn) {
  if (length === 1) {
    return _curry1(fn);
  }
  return _arity(length, _curryN(length, [], fn));
});

/**
 * Optimized internal three-arity curry function.
 *
 * @private
 * @category Function
 * @param {Function} fn The function to curry.
 * @return {Function} The curried function.
 */

function _curry3(fn) {
  return function f3(a, b, c) {
    switch (arguments.length) {
      case 0:
        return f3;
      case 1:
        return _isPlaceholder(a) ? f3 : _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        });
      case 2:
        return _isPlaceholder(a) && _isPlaceholder(b) ? f3 : _isPlaceholder(a) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _curry1(function (_c) {
          return fn(a, b, _c);
        });
      default:
        return _isPlaceholder(a) && _isPlaceholder(b) && _isPlaceholder(c) ? f3 : _isPlaceholder(a) && _isPlaceholder(b) ? _curry2(function (_a, _b) {
          return fn(_a, _b, c);
        }) : _isPlaceholder(a) && _isPlaceholder(c) ? _curry2(function (_a, _c) {
          return fn(_a, b, _c);
        }) : _isPlaceholder(b) && _isPlaceholder(c) ? _curry2(function (_b, _c) {
          return fn(a, _b, _c);
        }) : _isPlaceholder(a) ? _curry1(function (_a) {
          return fn(_a, b, c);
        }) : _isPlaceholder(b) ? _curry1(function (_b) {
          return fn(a, _b, c);
        }) : _isPlaceholder(c) ? _curry1(function (_c) {
          return fn(a, b, _c);
        }) : fn(a, b, c);
    }
  };
}

/**
 * Tests whether or not an object is an array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is an array, `false` otherwise.
 * @example
 *
 *      _isArray([]); //=> true
 *      _isArray(null); //=> false
 *      _isArray({}); //=> false
 */
var _isArray = Array.isArray || function _isArray(val) {
  return val != null && val.length >= 0 && Object.prototype.toString.call(val) === '[object Array]';
};

function _isTransformer(obj) {
  return obj != null && typeof obj['@@transducer/step'] === 'function';
}

/**
 * Returns a function that dispatches with different strategies based on the
 * object in list position (last argument). If it is an array, executes [fn].
 * Otherwise, if it has a function with one of the given method names, it will
 * execute that function (functor case). Otherwise, if it is a transformer,
 * uses transducer created by [transducerCreator] to return a new transformer
 * (transducer case).
 * Otherwise, it will default to executing [fn].
 *
 * @private
 * @param {Array} methodNames properties to check for a custom implementation
 * @param {Function} transducerCreator transducer factory if object is transformer
 * @param {Function} fn default ramda implementation
 * @return {Function} A function that dispatches on object in list position
 */

function _dispatchable(methodNames, transducerCreator, fn) {
  return function () {
    if (arguments.length === 0) {
      return fn();
    }
    var obj = arguments[arguments.length - 1];
    if (!_isArray(obj)) {
      var idx = 0;
      while (idx < methodNames.length) {
        if (typeof obj[methodNames[idx]] === 'function') {
          return obj[methodNames[idx]].apply(obj, Array.prototype.slice.call(arguments, 0, -1));
        }
        idx += 1;
      }
      if (_isTransformer(obj)) {
        var transducer = transducerCreator.apply(null, Array.prototype.slice.call(arguments, 0, -1));
        return transducer(obj);
      }
    }
    return fn.apply(this, arguments);
  };
}

function _reduced(x) {
  return x && x['@@transducer/reduced'] ? x : {
    '@@transducer/value': x,
    '@@transducer/reduced': true
  };
}

var _xfBase = {
  init: function init() {
    return this.xf['@@transducer/init']();
  },
  result: function result(_result) {
    return this.xf['@@transducer/result'](_result);
  }
};

function _map(fn, functor) {
  var idx = 0;
  var len = functor.length;
  var result = Array(len);
  while (idx < len) {
    result[idx] = fn(functor[idx]);
    idx += 1;
  }
  return result;
}

function _isString(x) {
  return Object.prototype.toString.call(x) === '[object String]';
}

/**
 * Tests whether or not an object is similar to an array.
 *
 * @private
 * @category Type
 * @category List
 * @sig * -> Boolean
 * @param {*} x The object to test.
 * @return {Boolean} `true` if `x` has a numeric length property and extreme indices defined; `false` otherwise.
 * @example
 *
 *      _isArrayLike([]); //=> true
 *      _isArrayLike(true); //=> false
 *      _isArrayLike({}); //=> false
 *      _isArrayLike({length: 10}); //=> false
 *      _isArrayLike({0: 'zero', 9: 'nine', length: 10}); //=> true
 *      _isArrayLike({nodeType: 1, length: 1}) // => false
 */

var _isArrayLike = /*#__PURE__*/
_curry1(function isArrayLike(x) {
  if (_isArray(x)) {
    return true;
  }
  if (!x) {
    return false;
  }
  if (_typeof(x) !== 'object') {
    return false;
  }
  if (_isString(x)) {
    return false;
  }
  if (x.length === 0) {
    return true;
  }
  if (x.length > 0) {
    return x.hasOwnProperty(0) && x.hasOwnProperty(x.length - 1);
  }
  return false;
});

var XWrap = /*#__PURE__*/
function () {
  function XWrap(fn) {
    this.f = fn;
  }
  XWrap.prototype['@@transducer/init'] = function () {
    throw new Error('init not implemented on XWrap');
  };
  XWrap.prototype['@@transducer/result'] = function (acc) {
    return acc;
  };
  XWrap.prototype['@@transducer/step'] = function (acc, x) {
    return this.f(acc, x);
  };
  return XWrap;
}();
function _xwrap(fn) {
  return new XWrap(fn);
}

/**
 * Creates a function that is bound to a context.
 * Note: `R.bind` does not provide the additional argument-binding capabilities of
 * [Function.prototype.bind](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Function/bind).
 *
 * @func
 * @memberOf R
 * @since v0.6.0
 * @category Function
 * @category Object
 * @sig (* -> *) -> {*} -> (* -> *)
 * @param {Function} fn The function to bind to context
 * @param {Object} thisObj The context to bind `fn` to
 * @return {Function} A function that will execute in the context of `thisObj`.
 * @see R.partial
 * @example
 *
 *      const log = R.bind(console.log, console);
 *      R.pipe(R.assoc('a', 2), R.tap(log), R.assoc('a', 3))({a: 1}); //=> {a: 3}
 *      // logs {a: 2}
 * @symb R.bind(f, o)(a, b) = f.call(o, a, b)
 */

var bind = /*#__PURE__*/
_curry2(function bind(fn, thisObj) {
  return _arity(fn.length, function () {
    return fn.apply(thisObj, arguments);
  });
});

function _arrayReduce(xf, acc, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    acc = xf['@@transducer/step'](acc, list[idx]);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    idx += 1;
  }
  return xf['@@transducer/result'](acc);
}
function _iterableReduce(xf, acc, iter) {
  var step = iter.next();
  while (!step.done) {
    acc = xf['@@transducer/step'](acc, step.value);
    if (acc && acc['@@transducer/reduced']) {
      acc = acc['@@transducer/value'];
      break;
    }
    step = iter.next();
  }
  return xf['@@transducer/result'](acc);
}
function _methodReduce(xf, acc, obj, methodName) {
  return xf['@@transducer/result'](obj[methodName](bind(xf['@@transducer/step'], xf), acc));
}
var symIterator = typeof Symbol !== 'undefined' ? Symbol.iterator : '@@iterator';
function _reduce(fn, acc, list) {
  if (typeof fn === 'function') {
    fn = _xwrap(fn);
  }
  if (_isArrayLike(list)) {
    return _arrayReduce(fn, acc, list);
  }
  if (typeof list['fantasy-land/reduce'] === 'function') {
    return _methodReduce(fn, acc, list, 'fantasy-land/reduce');
  }
  if (list[symIterator] != null) {
    return _iterableReduce(fn, acc, list[symIterator]());
  }
  if (typeof list.next === 'function') {
    return _iterableReduce(fn, acc, list);
  }
  if (typeof list.reduce === 'function') {
    return _methodReduce(fn, acc, list, 'reduce');
  }
  throw new TypeError('reduce: list must be array or iterable');
}

var XMap = /*#__PURE__*/
function () {
  function XMap(f, xf) {
    this.xf = xf;
    this.f = f;
  }
  XMap.prototype['@@transducer/init'] = _xfBase.init;
  XMap.prototype['@@transducer/result'] = _xfBase.result;
  XMap.prototype['@@transducer/step'] = function (result, input) {
    return this.xf['@@transducer/step'](result, this.f(input));
  };
  return XMap;
}();
var _xmap = /*#__PURE__*/
_curry2(function _xmap(f, xf) {
  return new XMap(f, xf);
});
var _xmap$1 = _xmap;

function _has(prop, obj) {
  return Object.prototype.hasOwnProperty.call(obj, prop);
}

var toString = Object.prototype.toString;
var _isArguments = /*#__PURE__*/
function () {
  return toString.call(arguments) === '[object Arguments]' ? function _isArguments(x) {
    return toString.call(x) === '[object Arguments]';
  } : function _isArguments(x) {
    return _has('callee', x);
  };
}();

var hasEnumBug = ! /*#__PURE__*/
{
  toString: null
}.propertyIsEnumerable('toString');
var nonEnumerableProps = ['constructor', 'valueOf', 'isPrototypeOf', 'toString', 'propertyIsEnumerable', 'hasOwnProperty', 'toLocaleString']; // Safari bug

var hasArgsEnumBug = /*#__PURE__*/
function () {

  return arguments.propertyIsEnumerable('length');
}();
var contains = function contains(list, item) {
  var idx = 0;
  while (idx < list.length) {
    if (list[idx] === item) {
      return true;
    }
    idx += 1;
  }
  return false;
};
/**
 * Returns a list containing the names of all the enumerable own properties of
 * the supplied object.
 * Note that the order of the output array is not guaranteed to be consistent
 * across different JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [k]
 * @param {Object} obj The object to extract properties from
 * @return {Array} An array of the object's own properties.
 * @see R.keysIn, R.values, R.toPairs
 * @example
 *
 *      R.keys({a: 1, b: 2, c: 3}); //=> ['a', 'b', 'c']
 */

var keys = typeof Object.keys === 'function' && !hasArgsEnumBug ? /*#__PURE__*/
_curry1(function keys(obj) {
  return Object(obj) !== obj ? [] : Object.keys(obj);
}) : /*#__PURE__*/
_curry1(function keys(obj) {
  if (Object(obj) !== obj) {
    return [];
  }
  var prop, nIdx;
  var ks = [];
  var checkArgsLength = hasArgsEnumBug && _isArguments(obj);
  for (prop in obj) {
    if (_has(prop, obj) && (!checkArgsLength || prop !== 'length')) {
      ks[ks.length] = prop;
    }
  }
  if (hasEnumBug) {
    nIdx = nonEnumerableProps.length - 1;
    while (nIdx >= 0) {
      prop = nonEnumerableProps[nIdx];
      if (_has(prop, obj) && !contains(ks, prop)) {
        ks[ks.length] = prop;
      }
      nIdx -= 1;
    }
  }
  return ks;
});

/**
 * Takes a function and
 * a [functor](https://github.com/fantasyland/fantasy-land#functor),
 * applies the function to each of the functor's values, and returns
 * a functor of the same shape.
 *
 * Ramda provides suitable `map` implementations for `Array` and `Object`,
 * so this function may be applied to `[1, 2, 3]` or `{x: 1, y: 2, z: 3}`.
 *
 * Dispatches to the `map` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * Also treats functions as functors and will compose them together.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Functor f => (a -> b) -> f a -> f b
 * @param {Function} fn The function to be called on every element of the input `list`.
 * @param {Array} list The list to be iterated over.
 * @return {Array} The new list.
 * @see R.transduce, R.addIndex, R.pluck, R.project
 * @example
 *
 *      const double = x => x * 2;
 *
 *      R.map(double, [1, 2, 3]); //=> [2, 4, 6]
 *
 *      R.map(double, {x: 1, y: 2, z: 3}); //=> {x: 2, y: 4, z: 6}
 * @symb R.map(f, [a, b]) = [f(a), f(b)]
 * @symb R.map(f, { x: a, y: b }) = { x: f(a), y: f(b) }
 * @symb R.map(f, functor_o) = functor_o.map(f)
 */

var map = /*#__PURE__*/
_curry2( /*#__PURE__*/
_dispatchable(['fantasy-land/map', 'map'], _xmap$1, function map(fn, functor) {
  switch (Object.prototype.toString.call(functor)) {
    case '[object Function]':
      return curryN(functor.length, function () {
        return fn.call(this, functor.apply(this, arguments));
      });
    case '[object Object]':
      return _reduce(function (acc, key) {
        acc[key] = fn(functor[key]);
        return acc;
      }, {}, keys(functor));
    default:
      return _map(fn, functor);
  }
}));

/**
 * Determine if the passed argument is an integer.
 *
 * @private
 * @param {*} n
 * @category Type
 * @return {Boolean}
 */
var _isInteger = Number.isInteger || function _isInteger(n) {
  return n << 0 === n;
};

/**
 * Returns the nth element of the given list or string. If n is negative the
 * element at index length + n is returned.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig Number -> [a] -> a | Undefined
 * @sig Number -> String -> String
 * @param {Number} offset
 * @param {*} list
 * @return {*}
 * @example
 *
 *      const list = ['foo', 'bar', 'baz', 'quux'];
 *      R.nth(1, list); //=> 'bar'
 *      R.nth(-1, list); //=> 'quux'
 *      R.nth(-99, list); //=> undefined
 *
 *      R.nth(2, 'abc'); //=> 'c'
 *      R.nth(3, 'abc'); //=> ''
 * @symb R.nth(-1, [a, b, c]) = c
 * @symb R.nth(0, [a, b, c]) = a
 * @symb R.nth(1, [a, b, c]) = b
 */

var nth = /*#__PURE__*/
_curry2(function nth(offset, list) {
  var idx = offset < 0 ? list.length + offset : offset;
  return _isString(list) ? list.charAt(idx) : list[idx];
});

/**
 * Returns a function that when supplied an object returns the indicated
 * property of that object, if it exists.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @typedefn Idx = String | Int | Symbol
 * @sig Idx -> {s: a} -> a | Undefined
 * @param {String|Number} p The property name or array index
 * @param {Object} obj The object to query
 * @return {*} The value at `obj.p`.
 * @see R.path, R.props, R.pluck, R.project, R.nth
 * @example
 *
 *      R.prop('x', {x: 100}); //=> 100
 *      R.prop('x', {}); //=> undefined
 *      R.prop(0, [100]); //=> 100
 *      R.compose(R.inc, R.prop('x'))({ x: 3 }) //=> 4
 */

var prop = /*#__PURE__*/
_curry2(function prop(p, obj) {
  if (obj == null) {
    return;
  }
  return _isInteger(p) ? nth(p, obj) : obj[p];
});

/**
 * Returns a list of all the enumerable own properties of the supplied object.
 * Note that the order of the output array is not guaranteed across different
 * JS platforms.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Object
 * @sig {k: v} -> [v]
 * @param {Object} obj The object to extract values from
 * @return {Array} An array of the values of the object's own properties.
 * @see R.valuesIn, R.keys, R.toPairs
 * @example
 *
 *      R.values({a: 1, b: 2, c: 3}); //=> [1, 2, 3]
 */

var values = /*#__PURE__*/
_curry1(function values(obj) {
  var props = keys(obj);
  var len = props.length;
  var vals = [];
  var idx = 0;
  while (idx < len) {
    vals[idx] = obj[props[idx]];
    idx += 1;
  }
  return vals;
});

/**
 * Gives a single-word string description of the (native) type of a value,
 * returning such answers as 'Object', 'Number', 'Array', or 'Null'. Does not
 * attempt to distinguish user Object types any further, reporting them all as
 * 'Object'.
 *
 * @func
 * @memberOf R
 * @since v0.8.0
 * @category Type
 * @sig (* -> {*}) -> String
 * @param {*} val The value to test
 * @return {String}
 * @example
 *
 *      R.type({}); //=> "Object"
 *      R.type(1); //=> "Number"
 *      R.type(false); //=> "Boolean"
 *      R.type('s'); //=> "String"
 *      R.type(null); //=> "Null"
 *      R.type([]); //=> "Array"
 *      R.type(/[A-z]/); //=> "RegExp"
 *      R.type(() => {}); //=> "Function"
 *      R.type(undefined); //=> "Undefined"
 */

var type = /*#__PURE__*/
_curry1(function type(val) {
  return val === null ? 'Null' : val === undefined ? 'Undefined' : Object.prototype.toString.call(val).slice(8, -1);
});

function _arrayFromIterator(iter) {
  var list = [];
  var next;
  while (!(next = iter.next()).done) {
    list.push(next.value);
  }
  return list;
}

function _includesWith(pred, x, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (pred(x, list[idx])) {
      return true;
    }
    idx += 1;
  }
  return false;
}

function _functionName(f) {
  // String(x => x) evaluates to "x => x", so the pattern may not match.
  var match = String(f).match(/^function (\w*)/);
  return match == null ? '' : match[1];
}

// Based on https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function _objectIs(a, b) {
  // SameValue algorithm
  if (a === b) {
    // Steps 1-5, 7-10
    // Steps 6.b-6.e: +0 != -0
    return a !== 0 || 1 / a === 1 / b;
  } else {
    // Step 6.a: NaN == NaN
    return a !== a && b !== b;
  }
}
var _objectIs$1 = typeof Object.is === 'function' ? Object.is : _objectIs;

/**
 * private _uniqContentEquals function.
 * That function is checking equality of 2 iterator contents with 2 assumptions
 * - iterators lengths are the same
 * - iterators values are unique
 *
 * false-positive result will be returned for comparison of, e.g.
 * - [1,2,3] and [1,2,3,4]
 * - [1,1,1] and [1,2,3]
 * */

function _uniqContentEquals(aIterator, bIterator, stackA, stackB) {
  var a = _arrayFromIterator(aIterator);
  var b = _arrayFromIterator(bIterator);
  function eq(_a, _b) {
    return _equals(_a, _b, stackA.slice(), stackB.slice());
  } // if *a* array contains any element that is not included in *b*

  return !_includesWith(function (b, aItem) {
    return !_includesWith(eq, aItem, b);
  }, b, a);
}
function _equals(a, b, stackA, stackB) {
  if (_objectIs$1(a, b)) {
    return true;
  }
  var typeA = type(a);
  if (typeA !== type(b)) {
    return false;
  }
  if (typeof a['fantasy-land/equals'] === 'function' || typeof b['fantasy-land/equals'] === 'function') {
    return typeof a['fantasy-land/equals'] === 'function' && a['fantasy-land/equals'](b) && typeof b['fantasy-land/equals'] === 'function' && b['fantasy-land/equals'](a);
  }
  if (typeof a.equals === 'function' || typeof b.equals === 'function') {
    return typeof a.equals === 'function' && a.equals(b) && typeof b.equals === 'function' && b.equals(a);
  }
  switch (typeA) {
    case 'Arguments':
    case 'Array':
    case 'Object':
      if (typeof a.constructor === 'function' && _functionName(a.constructor) === 'Promise') {
        return a === b;
      }
      break;
    case 'Boolean':
    case 'Number':
    case 'String':
      if (!(_typeof(a) === _typeof(b) && _objectIs$1(a.valueOf(), b.valueOf()))) {
        return false;
      }
      break;
    case 'Date':
      if (!_objectIs$1(a.valueOf(), b.valueOf())) {
        return false;
      }
      break;
    case 'Error':
      return a.name === b.name && a.message === b.message;
    case 'RegExp':
      if (!(a.source === b.source && a.global === b.global && a.ignoreCase === b.ignoreCase && a.multiline === b.multiline && a.sticky === b.sticky && a.unicode === b.unicode)) {
        return false;
      }
      break;
  }
  var idx = stackA.length - 1;
  while (idx >= 0) {
    if (stackA[idx] === a) {
      return stackB[idx] === b;
    }
    idx -= 1;
  }
  switch (typeA) {
    case 'Map':
      if (a.size !== b.size) {
        return false;
      }
      return _uniqContentEquals(a.entries(), b.entries(), stackA.concat([a]), stackB.concat([b]));
    case 'Set':
      if (a.size !== b.size) {
        return false;
      }
      return _uniqContentEquals(a.values(), b.values(), stackA.concat([a]), stackB.concat([b]));
    case 'Arguments':
    case 'Array':
    case 'Object':
    case 'Boolean':
    case 'Number':
    case 'String':
    case 'Date':
    case 'Error':
    case 'RegExp':
    case 'Int8Array':
    case 'Uint8Array':
    case 'Uint8ClampedArray':
    case 'Int16Array':
    case 'Uint16Array':
    case 'Int32Array':
    case 'Uint32Array':
    case 'Float32Array':
    case 'Float64Array':
    case 'ArrayBuffer':
      break;
    default:
      // Values of other types are only equal if identical.
      return false;
  }
  var keysA = keys(a);
  if (keysA.length !== keys(b).length) {
    return false;
  }
  var extendedStackA = stackA.concat([a]);
  var extendedStackB = stackB.concat([b]);
  idx = keysA.length - 1;
  while (idx >= 0) {
    var key = keysA[idx];
    if (!(_has(key, b) && _equals(b[key], a[key], extendedStackA, extendedStackB))) {
      return false;
    }
    idx -= 1;
  }
  return true;
}

/**
 * Returns `true` if its arguments are equivalent, `false` otherwise. Handles
 * cyclical data structures.
 *
 * Dispatches symmetrically to the `equals` methods of both arguments, if
 * present.
 *
 * @func
 * @memberOf R
 * @since v0.15.0
 * @category Relation
 * @sig a -> b -> Boolean
 * @param {*} a
 * @param {*} b
 * @return {Boolean}
 * @example
 *
 *      R.equals(1, 1); //=> true
 *      R.equals(1, '1'); //=> false
 *      R.equals([1, 2, 3], [1, 2, 3]); //=> true
 *
 *      const a = {}; a.v = a;
 *      const b = {}; b.v = b;
 *      R.equals(a, b); //=> true
 */

var equals = /*#__PURE__*/
_curry2(function equals(a, b) {
  return _equals(a, b, [], []);
});

function _isObject(x) {
  return Object.prototype.toString.call(x) === '[object Object]';
}

/**
 * Returns a curried equivalent of the provided function. The curried function
 * has two unusual capabilities. First, its arguments needn't be provided one
 * at a time. If `f` is a ternary function and `g` is `R.curry(f)`, the
 * following are equivalent:
 *
 *   - `g(1)(2)(3)`
 *   - `g(1)(2, 3)`
 *   - `g(1, 2)(3)`
 *   - `g(1, 2, 3)`
 *
 * Secondly, the special placeholder value [`R.__`](#__) may be used to specify
 * "gaps", allowing partial application of any combination of arguments,
 * regardless of their positions. If `g` is as above and `_` is [`R.__`](#__),
 * the following are equivalent:
 *
 *   - `g(1, 2, 3)`
 *   - `g(_, 2, 3)(1)`
 *   - `g(_, _, 3)(1)(2)`
 *   - `g(_, _, 3)(1, 2)`
 *   - `g(_, 2)(1)(3)`
 *   - `g(_, 2)(1, 3)`
 *   - `g(_, 2)(_, 3)(1)`
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Function
 * @sig (* -> a) -> (* -> a)
 * @param {Function} fn The function to curry.
 * @return {Function} A new, curried function.
 * @see R.curryN, R.partial
 * @example
 *
 *      const addFourNumbers = (a, b, c, d) => a + b + c + d;
 *
 *      const curriedAddFourNumbers = R.curry(addFourNumbers);
 *      const f = curriedAddFourNumbers(1, 2);
 *      const g = f(3);
 *      g(4); //=> 10
 */

var curry = /*#__PURE__*/
_curry1(function curry(fn) {
  return curryN(fn.length, fn);
});

/**
 * Tests whether or not an object is a typed array.
 *
 * @private
 * @param {*} val The object to test.
 * @return {Boolean} `true` if `val` is a typed array, `false` otherwise.
 * @example
 *
 *      _isTypedArray(new Uint8Array([])); //=> true
 *      _isTypedArray(new Float32Array([])); //=> true
 *      _isTypedArray([]); //=> false
 *      _isTypedArray(null); //=> false
 *      _isTypedArray({}); //=> false
 */
function _isTypedArray(val) {
  var type = Object.prototype.toString.call(val);
  return type === '[object Uint8ClampedArray]' || type === '[object Int8Array]' || type === '[object Uint8Array]' || type === '[object Int16Array]' || type === '[object Uint16Array]' || type === '[object Int32Array]' || type === '[object Uint32Array]' || type === '[object Float32Array]' || type === '[object Float64Array]' || type === '[object BigInt64Array]' || type === '[object BigUint64Array]';
}

/**
 * Returns the empty value of its argument's type. Ramda defines the empty
 * value of Array (`[]`), Object (`{}`), String (`''`),
 * TypedArray (`Uint8Array []`, `Float32Array []`, etc), and Arguments. Other
 * types are supported if they define `<Type>.empty`,
 * `<Type>.prototype.empty` or implement the
 * [FantasyLand Monoid spec](https://github.com/fantasyland/fantasy-land#monoid).
 *
 * Dispatches to the `empty` method of the first argument, if present.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Function
 * @sig a -> a
 * @param {*} x
 * @return {*}
 * @example
 *
 *      R.empty(Just(42));               //=> Nothing()
 *      R.empty([1, 2, 3]);              //=> []
 *      R.empty('unicorns');             //=> ''
 *      R.empty({x: 1, y: 2});           //=> {}
 *      R.empty(Uint8Array.from('123')); //=> Uint8Array []
 */

var empty = /*#__PURE__*/
_curry1(function empty(x) {
  return x != null && typeof x['fantasy-land/empty'] === 'function' ? x['fantasy-land/empty']() : x != null && x.constructor != null && typeof x.constructor['fantasy-land/empty'] === 'function' ? x.constructor['fantasy-land/empty']() : x != null && typeof x.empty === 'function' ? x.empty() : x != null && x.constructor != null && typeof x.constructor.empty === 'function' ? x.constructor.empty() : _isArray(x) ? [] : _isString(x) ? '' : _isObject(x) ? {} : _isArguments(x) ? function () {
    return arguments;
  }() : _isTypedArray(x) ? x.constructor.from('') : void 0 // else
  ;
});

var XFind = /*#__PURE__*/
function () {
  function XFind(f, xf) {
    this.xf = xf;
    this.f = f;
    this.found = false;
  }
  XFind.prototype['@@transducer/init'] = _xfBase.init;
  XFind.prototype['@@transducer/result'] = function (result) {
    if (!this.found) {
      result = this.xf['@@transducer/step'](result, void 0);
    }
    return this.xf['@@transducer/result'](result);
  };
  XFind.prototype['@@transducer/step'] = function (result, input) {
    if (this.f(input)) {
      this.found = true;
      result = _reduced(this.xf['@@transducer/step'](result, input));
    }
    return result;
  };
  return XFind;
}();
var _xfind = /*#__PURE__*/
_curry2(function _xfind(f, xf) {
  return new XFind(f, xf);
});
var _xfind$1 = _xfind;

/**
 * Returns the first element of the list which matches the predicate, or
 * `undefined` if no element matches.
 *
 * Dispatches to the `find` method of the second argument, if present.
 *
 * Acts as a transducer if a transformer is given in list position.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category List
 * @sig (a -> Boolean) -> [a] -> a | undefined
 * @param {Function} fn The predicate function used to determine if the element is the
 *        desired one.
 * @param {Array} list The array to consider.
 * @return {Object} The element found, or `undefined`.
 * @see R.transduce
 * @example
 *
 *      const xs = [{a: 1}, {a: 2}, {a: 3}];
 *      R.find(R.propEq('a', 2))(xs); //=> {a: 2}
 *      R.find(R.propEq('a', 4))(xs); //=> undefined
 */

var find = /*#__PURE__*/
_curry2( /*#__PURE__*/
_dispatchable(['find'], _xfind$1, function find(fn, list) {
  var idx = 0;
  var len = list.length;
  while (idx < len) {
    if (fn(list[idx])) {
      return list[idx];
    }
    idx += 1;
  }
}));
var find$1 = find;

/**
 * See if an object (i.e. `val`) is an instance of the supplied constructor. This
 * function will check up the inheritance chain, if any.
 * If `val` was created using `Object.create`, `R.is(Object, val) === true`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category Type
 * @sig (* -> {*}) -> a -> Boolean
 * @param {Object} ctor A constructor
 * @param {*} val The value to test
 * @return {Boolean}
 * @example
 *
 *      R.is(Object, {}); //=> true
 *      R.is(Number, 1); //=> true
 *      R.is(Object, 1); //=> false
 *      R.is(String, 's'); //=> true
 *      R.is(String, new String('')); //=> true
 *      R.is(Object, new String('')); //=> true
 *      R.is(Object, 's'); //=> false
 *      R.is(Number, {}); //=> false
 */

var is = /*#__PURE__*/
_curry2(function is(Ctor, val) {
  return val instanceof Ctor || val != null && (val.constructor === Ctor || Ctor.name === 'Object' && _typeof(val) === 'object');
});

/**
 * Returns `true` if the given value is its type's empty value; `false`
 * otherwise.
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Logic
 * @sig a -> Boolean
 * @param {*} x
 * @return {Boolean}
 * @see R.empty
 * @example
 *
 *      R.isEmpty([1, 2, 3]);           //=> false
 *      R.isEmpty([]);                  //=> true
 *      R.isEmpty('');                  //=> true
 *      R.isEmpty(null);                //=> false
 *      R.isEmpty({});                  //=> true
 *      R.isEmpty({length: 0});         //=> false
 *      R.isEmpty(Uint8Array.from('')); //=> true
 */

var isEmpty = /*#__PURE__*/
_curry1(function isEmpty(x) {
  return x != null && equals(x, empty(x));
});

/**
 * Returns `true` if the specified object property is equal, in
 * [`R.equals`](#equals) terms, to the given value; `false` otherwise.
 * You can test multiple properties with [`R.whereEq`](#whereEq).
 *
 * @func
 * @memberOf R
 * @since v0.1.0
 * @category Relation
 * @sig String -> a -> Object -> Boolean
 * @param {String} name
 * @param {*} val
 * @param {*} obj
 * @return {Boolean}
 * @see R.whereEq, R.propSatisfies, R.equals
 * @example
 *
 *      const abby = {name: 'Abby', age: 7, hair: 'blond'};
 *      const fred = {name: 'Fred', age: 12, hair: 'brown'};
 *      const rusty = {name: 'Rusty', age: 10, hair: 'brown'};
 *      const alois = {name: 'Alois', age: 15, disposition: 'surly'};
 *      const kids = [abby, fred, rusty, alois];
 *      const hasBrownHair = R.propEq('hair', 'brown');
 *      R.filter(hasBrownHair, kids); //=> [fred, rusty]
 */

var propEq = /*#__PURE__*/
_curry3(function propEq(name, val, obj) {
  return equals(val, prop(name, obj));
});
var propEq$1 = propEq;

/**
 * Creates a new object out of a list of keys and a list of values.
 * Key/value pairing is truncated to the length of the shorter of the two lists.
 * Note: `zipObj` is equivalent to `pipe(zip, fromPairs)`.
 *
 * @func
 * @memberOf R
 * @since v0.3.0
 * @category List
 * @sig [String] -> [*] -> {String: *}
 * @param {Array} keys The array that will be properties on the output object.
 * @param {Array} values The list of values on the output object.
 * @return {Object} The object made by pairing up same-indexed elements of `keys` and `values`.
 * @example
 *
 *      R.zipObj(['a', 'b', 'c'], [1, 2, 3]); //=> {a: 1, b: 2, c: 3}
 */

var zipObj = /*#__PURE__*/
_curry2(function zipObj(keys, values) {
  var idx = 0;
  var len = Math.min(keys.length, values.length);
  var out = {};
  while (idx < len) {
    out[keys[idx]] = values[idx];
    idx += 1;
  }
  return out;
});

var setInitialCodes = function setInitialCodes(codeKey, props, values, setFieldValue) {
  var _values$collector, _values$collector$ent, _values$collector2, _values$collector2$en, _values$collector2$en2, _props$eventDate, _props$eventDate$, _props$eventDate$2;
  setFieldValue('formLogic.codeId', '');
  var resetArr = values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent = _values$collector.entity[0]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.code ? values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.code) === null || _values$collector2$en2 === void 0 ? void 0 : _values$collector2$en2.slice() : [];
  var codeArr = [].concat(_toConsumableArray(resetArr), _toConsumableArray(props !== null && props !== void 0 && props.eventAttributeId ? [{
    key: 'ATTRIBUTES',
    value: props === null || props === void 0 ? void 0 : props.eventAttributeId
  }] : []), _toConsumableArray(props !== null && props !== void 0 && props.formAttribute ? [{
    key: codeKey,
    value: props === null || props === void 0 ? void 0 : props.formAttribute
  }] : []), _toConsumableArray(props !== null && props !== void 0 && props.clwcformAttribute ? [{
    key: codeKey,
    value: props === null || props === void 0 ? void 0 : props.clwcformAttribute
  }] : []), _toConsumableArray(props !== null && props !== void 0 && props.contactId ? [{
    key: codeKey,
    value: props === null || props === void 0 ? void 0 : props.contactId
  }] : []), _toConsumableArray((props === null || props === void 0 ? void 0 : (_props$eventDate = props.eventDate) === null || _props$eventDate === void 0 ? void 0 : _props$eventDate.length) === 1 ? [{
    key: props === null || props === void 0 ? void 0 : (_props$eventDate$ = props.eventDate[0]) === null || _props$eventDate$ === void 0 ? void 0 : _props$eventDate$.id,
    value: props === null || props === void 0 ? void 0 : (_props$eventDate$2 = props.eventDate[0]) === null || _props$eventDate$2 === void 0 ? void 0 : _props$eventDate$2.value
  }] : []));
  setFieldValue("collector.entity[0].code", codeArr);
};

var _excluded$V = ["eventId", "shirtSizes"];
var useCode = function useCode(_ref) {
  var _values$formLogic3;
  var eventId = _ref.eventId,
    _ref$shirtSizes = _ref.shirtSizes,
    shirtSizes = _ref$shirtSizes === void 0 ? [] : _ref$shirtSizes,
    props = _objectWithoutProperties(_ref, _excluded$V);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var isInternational = (props === null || props === void 0 ? void 0 : props.destination) === 3;
  var codeKey = !isInternational ? "CRUSADE:".concat(eventId) : 'ATTRIBUTES';
  useEffect(function () {
    var _values$collector, _values$collector$ent, _values$collector$ent2, _values$formLogic;
    var resetArr = ((_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.filter(function (item) {
      return item && item.value && !find$1(propEq$1('id', parseInt(item.value, 10)), shirtSizes);
    })) || [];
    if ((_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && _values$formLogic.codeId) {
      var _values$formLogic2;
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), [{
        key: codeKey,
        value: "".concat((_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.codeId)
      }]));
    }
  }, [(_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.codeId]);
  useEffect(function () {
    setInitialCodes(codeKey, props, values, setFieldValue);
  }, []);
  return {
    values: values
  };
};

var useCollectionType = function useCollectionType(_ref) {
  var collectionType = _ref.collectionType,
    isBasicTemplate = _ref.isBasicTemplate;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  useEffect(function () {
    if (collectionType && !isBasicTemplate) {
      setFieldValue("collector.collectionType", collectionType, false);
    }
  }, []);
  return {
    collectionType: collectionType
  };
};

var _excluded$U = ["hasCountry", "topics"];
var SECTIONS_WITH_ADDRESS = ['Gift Planning', 'New Believer Materials'];
var useContactForm = function useContactForm(_ref) {
  var _values$collector, _values$collector$com, _values$formLogic;
  var hasCountry = _ref.hasCountry,
    topics = _ref.topics,
    props = _objectWithoutProperties(_ref, _excluded$U);
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  useTranslationHelper();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hideDetailSection = _useState2[0],
    setHideDetailSection = _useState2[1];
  var topic = (values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$com = _values$collector.communications) === null || _values$collector$com === void 0 ? void 0 : _values$collector$com.length) > 0 ? values.collector.communications[0].shortComment : undefined;
  var showAddressChange = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.addressChange) === true;
  useEffect(function () {
    var _values$collector2, _values$collector2$en;
    if (SECTIONS_WITH_ADDRESS.includes(topic) || showAddressChange) {
      setHideDetailSection(true);
    } else {
      setHideDetailSection(false);
    }
    if (topic !== 'Decision Magazine' && values !== null && values !== void 0 && (_values$collector2 = values.collector) !== null && _values$collector2 !== void 0 && (_values$collector2$en = _values$collector2.entity[0]) !== null && _values$collector2$en !== void 0 && _values$collector2$en.address[1]) {
      var _values$collector3, _values$collector3$en, _values$collector3$en2;
      setFieldValue("formLogic.addressChange", false, false);
      values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.address) === null || _values$collector3$en2 === void 0 ? void 0 : _values$collector3$en2.pop();
    }
  }, [topic, showAddressChange]);
  useEffect(function () {
    setFormId({
      templateName: Templates.CONTACT_US,
      values: values,
      setFieldValue: setFieldValue
    });
    if (props !== null && props !== void 0 && props.questionTextName) {
      setFieldValue('collector.questions[0].questionText', 'yourMessage');
    } else {
      setFieldValue('collector.communications[0].longComment', '');
    }
    if (hasCountry) {
      var countryFieldName = (props === null || props === void 0 ? void 0 : props.countryName) || "collector.entity[0].address[0].country";
      setFieldValue(countryFieldName, '');
    }
    if ((topics === null || topics === void 0 ? void 0 : topics.length) > 0 && !topics[0].isDisabled && topics[0].value) {
      setFieldValue('collector.communications[0].shortComment', topics[0].value);
    }
  }, []);
  delete values.collector.cart;
  return {
    hideDetailSection: hideDetailSection,
    showAddressChange: showAddressChange,
    topic: topic,
    values: values
  };
};

var _excluded$T = ["country"];
var useCountry = function useCountry(_ref) {
  var country = _ref.country,
    props = _objectWithoutProperties(_ref, _excluded$T);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var countryKey = props !== null && props !== void 0 && props.isStellofyForm ? "volunteerApp.StellofyApplicationForm.country" : "collector.entity[0].address[0].country";
  useEffect(function () {
    if ((country === null || country === void 0 ? void 0 : country.length) === 1) {
      setFieldValue(countryKey, country[0].toUpperCase());
    }
  }, []);
  return {
    values: values
  };
};

var useProjectCart = function useProjectCart(_ref) {
  var cartObj = _ref.cartObj,
    _ref$checkoutPath = _ref.checkoutPath,
    checkoutPath = _ref$checkoutPath === void 0 ? '' : _ref$checkoutPath,
    _ref$projects = _ref.projects,
    projects = _ref$projects === void 0 ? [] : _ref$projects,
    setCartInfo = _ref.setCartInfo;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var handleOnCheckoutClick = function handleOnCheckoutClick(e) {
    e.preventDefault();
    if (window && window.location && checkoutPath) {
      location.assign(checkoutPath);
    }
  };
  var handleOnGiveClick = function handleOnGiveClick(e, index) {
    var _values$formLogic$pro;
    e.preventDefault();
    var amount = (_values$formLogic$pro = values.formLogic.projects[index]) === null || _values$formLogic$pro === void 0 ? void 0 : _values$formLogic$pro.amount;
    var project = projects[index];
    if (!isNaN(amount) && amount >= MIN_CURRENCY_VALUE) {
      var _values$formLogic, _cartInfoObj$project$;
      var cartInfoObj = _objectSpread2({}, (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.cartInfo);
      var type = cartInfoObj && cartInfoObj[project === null || project === void 0 ? void 0 : project.projectId] ? (_cartInfoObj$project$ = cartInfoObj[project === null || project === void 0 ? void 0 : project.projectId]) === null || _cartInfoObj$project$ === void 0 ? void 0 : _cartInfoObj$project$.type : 'One-Time';
      var cartItem = _objectSpread2({
        projectId: project === null || project === void 0 ? void 0 : project.projectId,
        title: project === null || project === void 0 ? void 0 : project.title,
        type: type,
        amount: amount
      }, (cartInfoObj === null || cartInfoObj === void 0 ? void 0 : cartInfoObj.recurringDate) && {
        recurringDate: cartInfoObj === null || cartInfoObj === void 0 ? void 0 : cartInfoObj.recurringDate
      });
      cartInfoObj[project === null || project === void 0 ? void 0 : project.projectId] = cartItem;
      setCartInfo(JSON.stringify(cartInfoObj));
    }
  };
  var handleOnClearClick = function handleOnClearClick(event, index) {
    event.preventDefault();
    var project = projects[index];
    var projectId = project === null || project === void 0 ? void 0 : project.projectId;
    if (projectId) {
      var projectObj = _objectSpread2({}, cartObj);
      delete projectObj[projectId];
      setCartInfo(JSON.stringify(projectObj));
      values.formLogic.projects[index].amount = 0;
    }
  };
  var clearCartInfo = function clearCartInfo() {
    return setCartInfo('{}');
  };
  return {
    clearCartInfo: clearCartInfo,
    handleOnCheckoutClick: handleOnCheckoutClick,
    handleOnClearClick: handleOnClearClick,
    handleOnGiveClick: handleOnGiveClick
  };
};

var useProjectList = function useProjectList(_ref) {
  var _values$collector, _values$collector$car, _values$collector$car2, _values$collector$car3;
  var _ref$checkoutPath = _ref.checkoutPath,
    checkoutPath = _ref$checkoutPath === void 0 ? '' : _ref$checkoutPath,
    _ref$projects = _ref.projects,
    projects = _ref$projects === void 0 ? [] : _ref$projects,
    _ref$siteId = _ref.siteId,
    siteId = _ref$siteId === void 0 ? '' : _ref$siteId,
    _ref$hideAddToCart = _ref.hideAddToCart,
    hideAddToCart = _ref$hideAddToCart === void 0 ? false : _ref$hideAddToCart;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useLocalStorage = useLocalStorage(siteId, ''),
    _useLocalStorage2 = _slicedToArray(_useLocalStorage, 2),
    cartInfo = _useLocalStorage2[0],
    setCartInfo = _useLocalStorage2[1];
  var cartObj = cartInfo ? JSON.parse(cartInfo) : {};
  var cartCount = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.donation) === null || _values$collector$car2 === void 0 ? void 0 : (_values$collector$car3 = _values$collector$car2.projects) === null || _values$collector$car3 === void 0 ? void 0 : _values$collector$car3.length;
  var disableAddToCart = hideAddToCart || !isCookieEnabled || !isLocalStorageAvailable;
  var _useProjectCart = useProjectCart({
      cartObj: cartObj,
      checkoutPath: checkoutPath,
      projects: projects,
      setCartInfo: setCartInfo
    }),
    clearCartInfo = _useProjectCart.clearCartInfo,
    handleOnCheckoutClick = _useProjectCart.handleOnCheckoutClick,
    handleOnClearClick = _useProjectCart.handleOnClearClick,
    handleOnGiveClick = _useProjectCart.handleOnGiveClick;
  useEffect(function () {
    if (cartInfo) {
      var cartDonations = Object.values(cartObj).map(function (item) {
        return {
          amount: item === null || item === void 0 ? void 0 : item.amount,
          initialChargeProcessed: true,
          projectId: item === null || item === void 0 ? void 0 : item.projectId
        };
      });
      setFieldValue('collector.cart.donation.projects', cartDonations);
      setFieldValue('formLogic.cartInfo', cartObj);
    }
  }, [cartInfo]);
  useEffect(function () {
    var projectList = [];
    var donations = [];
    projects.forEach(function (project) {
      var _storedCartItem$amoun;
      var storedCartItem = cartObj[project === null || project === void 0 ? void 0 : project.projectId];
      projectList.push(_objectSpread2(_objectSpread2({}, project), {}, {
        amount: (_storedCartItem$amoun = storedCartItem === null || storedCartItem === void 0 ? void 0 : storedCartItem.amount) !== null && _storedCartItem$amoun !== void 0 ? _storedCartItem$amoun : 0
      }));
      if (!!cartObj && !!storedCartItem) {
        donations.push(_objectSpread2({
          amount: storedCartItem.amount,
          initialChargeProcessed: true,
          projectId: storedCartItem.projectId
        }, (storedCartItem === null || storedCartItem === void 0 ? void 0 : storedCartItem.recurringDate) && {
          recurringDate: storedCartItem === null || storedCartItem === void 0 ? void 0 : storedCartItem.recurringDate
        }));
      }
    });
    setFieldValue("collector.cart.donation.projects", donations);
    setFieldValue('formLogic.projects', projectList);
    setFieldValue('formLogic.activeMethod', 'CC');
    setFieldValue('formLogic.cartId', siteId);
    setFieldValue('formLogic.shouldFormatCurrency', true);
  }, []);
  var cartCountMessage = i18next.t('common:cartCountMessage', {
    cartCount: cartCount
  });
  return {
    cartCount: cartCount,
    cartCountMessage: cartCountMessage,
    cartInfo: cartObj,
    disableAddToCart: disableAddToCart,
    clearCartInfo: clearCartInfo,
    handleOnCheckoutClick: handleOnCheckoutClick,
    handleOnClearClick: handleOnClearClick,
    handleOnGiveClick: handleOnGiveClick
  };
};

var useCheckoutConfirmation = function useCheckoutConfirmation() {
  var _values$formLogic, _values$formLogic2, _values$formLogic3, _values$submissionres, _values$submissionres2, _values$submissionres3, _values$formLogic4, _values$formLogic5, _values$formLogic6, _values$payment, _values$collector, _values$collector$car, _values$collector$car2, _values$collector2, _values$collector2$ca, _values$collector2$ca2, _values$formLogic7, _values$formLogic7$or, _values$formLogic8, _values$formLogic8$or, _values$collector3, _values$collector3$en, _values$formLogic9;
  var confirmationRef = useRef(null);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useProjectList = useProjectList({
      projects: (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.projects,
      siteId: (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.cartId
    }),
    clearCartInfo = _useProjectList.clearCartInfo,
    cartInfo = _useProjectList.cartInfo;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.customConfirmation;
  var transactionId = values === null || values === void 0 ? void 0 : (_values$submissionres = values.submissionresponse) === null || _values$submissionres === void 0 ? void 0 : (_values$submissionres2 = _values$submissionres.payload) === null || _values$submissionres2 === void 0 ? void 0 : (_values$submissionres3 = _values$submissionres2.payment) === null || _values$submissionres3 === void 0 ? void 0 : _values$submissionres3.transaction_id;
  var showUpgradeGift = values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.showUpgradeGift;
  var deliveryMessage = values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : _values$formLogic5.deliveryMessage;
  var showDeliveryMessage = values === null || values === void 0 ? void 0 : (_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : _values$formLogic6.showDeliveryMessage;
  var paypal = values === null || values === void 0 ? void 0 : (_values$payment = values.payment) === null || _values$payment === void 0 ? void 0 : _values$payment.paypal;
  var total = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.cartTotals) === null || _values$collector$car2 === void 0 ? void 0 : _values$collector$car2.subTotal;
  var projects = values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$ca = _values$collector2.cart) === null || _values$collector2$ca === void 0 ? void 0 : (_values$collector2$ca2 = _values$collector2$ca.donation) === null || _values$collector2$ca2 === void 0 ? void 0 : _values$collector2$ca2.projects;
  var showRecurrenceText = (values === null || values === void 0 ? void 0 : (_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : (_values$formLogic7$or = _values$formLogic7.orgProjects) === null || _values$formLogic7$or === void 0 ? void 0 : _values$formLogic7$or.length) === 1; // Only show for single project
  var isOneTime = !(values !== null && values !== void 0 && (_values$formLogic8 = values.formLogic) !== null && _values$formLogic8 !== void 0 && (_values$formLogic8$or = _values$formLogic8.orgProjects) !== null && _values$formLogic8$or !== void 0 && _values$formLogic8$or.some(function (prj) {
    var _prj$recurringDate;
    return ((_prj$recurringDate = prj.recurringDate) === null || _prj$recurringDate === void 0 ? void 0 : _prj$recurringDate.length) > 0;
  })) || false;
  var firstName = values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : _values$collector3$en.firstName;
  var recurrenceText = isOneTime ? 'One-Time' : 'Monthly';
  var confirmationBackgroundColor = (values === null || values === void 0 ? void 0 : (_values$formLogic9 = values.formLogic) === null || _values$formLogic9 === void 0 ? void 0 : _values$formLogic9.confirmationBackgroundColor) || '';
  var handleScrollIntoView = function handleScrollIntoView() {
    var _confirmationRef$curr, _confirmationRef$curr2, _values$formLogic10;
    window.scrollTo(0, 0); // Match existing UX on Production, scroll to the top then to the element.
    window.scrollTo({
      top: (confirmationRef === null || confirmationRef === void 0 ? void 0 : (_confirmationRef$curr = confirmationRef.current) === null || _confirmationRef$curr === void 0 ? void 0 : (_confirmationRef$curr2 = _confirmationRef$curr.getBoundingClientRect()) === null || _confirmationRef$curr2 === void 0 ? void 0 : _confirmationRef$curr2.top) || 0,
      behavior: 'smooth'
    });
    if (values !== null && values !== void 0 && (_values$formLogic10 = values.formLogic) !== null && _values$formLogic10 !== void 0 && _values$formLogic10.isEmbedSite) {
      var postObject = JSON.stringify({
        scrollToTop: true
      });
      window.top.postMessage(postObject, '*');
    }
  };
  var handleReload = function handleReload() {
    return window.location.reload();
  };
  useEffect(function () {
    setFieldValue('formLogic.orgProjects', projects);
    clearCartInfo();
    handleScrollIntoView();
  }, []);
  return {
    cartInfo: cartInfo,
    confirmationBackgroundColor: confirmationBackgroundColor,
    confirmationRef: confirmationRef,
    deliveryMessage: deliveryMessage,
    firstName: firstName,
    isOneTime: isOneTime,
    paypal: paypal,
    recurrenceText: recurrenceText,
    showDeliveryMessage: showDeliveryMessage,
    showRecurrenceText: showRecurrenceText,
    showUpgradeGift: showUpgradeGift,
    transactionId: transactionId,
    total: total,
    CustomConfirmation: CustomConfirmation,
    handleReload: handleReload
  };
};

var useChurchApplication = function useChurchApplication(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useFormikContext = useFormikContext(),
    isSubmitting = _useFormikContext.isSubmitting,
    setFieldValue = _useFormikContext.setFieldValue,
    setFieldTouched = _useFormikContext.setFieldTouched,
    touched = _useFormikContext.touched,
    values = _useFormikContext.values;
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  var _deepFind = deepFind(values, 'formLogic'),
    arService = _deepFind.arService,
    aslService = _deepFind.aslService,
    enService = _deepFind.enService,
    esService = _deepFind.esService,
    chService = _deepFind.chService,
    ruService = _deepFind.ruService,
    ptService = _deepFind.ptService;
  var digitalSignature = deepFind(values, 'churchFormData.SFJChurchData.digital_signature');
  var _deepFind2 = deepFind(values, 'formLogic'),
    addressChange = _deepFind2.addressChange;
  var PrivacyPolicyCopy = props === null || props === void 0 ? void 0 : props.privacyPolicyCopy;
  useEffect(function () {
    var pastorDetails = {
      entityType: 'I',
      salutation: '',
      firstName: '',
      lastName: '',
      entityRelationship: [{
        path: 'entity[1]',
        relationshipType: 'Pastor'
      }]
    };
    setFieldValue('collector.entity[1].denomination', '');
    setFieldValue('collector.entity[1].email[0].emailAddress', '');
    setFieldValue('collector.entity[2]', pastorDetails);
    setFieldValue('churchFormData.SFJChurchData.digital_signature', '');
    if (props.CTID) {
      setFieldValue('collector.collectionType', props.CTID);
    }
  }, []);
  useEffect(function () {
    if (digitalSignature) {
      var today = new Date();
      var formattedDate = [today.getFullYear(), String(today.getMonth() + 1).padStart(2, '0'), String(today.getDate()).padStart(2, '0')].join('.');
      setFieldValue('churchFormData.SFJChurchData.digital_signature_date', formattedDate);
      setFieldValue('churchFormData.SFJChurchData.agrees_with_bgea_statement_of_faith', '1');
    }
  }, [digitalSignature]);
  useEffect(function () {
    if (isSubmitting) {
      setFieldTouched('formLogic.enService', true, false);
      setFieldTouched('formLogic.esService', true, false);
    }
    setFieldValue('collector.entity[0].email', undefined);
    setFieldValue('collector.entity[1].orgs', undefined);
  }, [isSubmitting]);
  useEffect(function () {
    var serviceLanguages;
    var primaryLanguage;
    if (enService && esService) {
      serviceLanguages = '3';
      primaryLanguage = '2';
    } else if (enService) {
      serviceLanguages = '1';
      primaryLanguage = '1';
    } else if (esService) {
      serviceLanguages = '2';
      primaryLanguage = '1';
    } else {
      serviceLanguages = '1';
      primaryLanguage = '1';
    }
    setFieldValue('churchFormData.SFJChurchData.service_languages', serviceLanguages);
    setFieldValue('churchFormData.SFJChurchData.primary_language', primaryLanguage);
  }, [enService, esService]);
  useEffect(function () {
    var _values$collector, _values$collector$ent, _values$collector$ent2, _values$collector$ent3, _values$collector$ent4;
    if (!addressChange && (values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent[1]) === null || _values$collector$ent2 === void 0 ? void 0 : (_values$collector$ent3 = _values$collector$ent2.address) === null || _values$collector$ent3 === void 0 ? void 0 : (_values$collector$ent4 = _values$collector$ent3[1]) === null || _values$collector$ent4 === void 0 ? void 0 : _values$collector$ent4.addressType) === 'MAIL') {
      values.collector.entity[1].address.pop();
    }
  }, [addressChange]);
  var privacyPolicyLabelMarkup = {
    markup: t('privacyAgreement', {
      ns: 'common',
      interpolation: {
        escapeValue: false
      }
    })
  };
  var privacyPolicyLabelStyle = {
    main: {
      fontSize: '0.8em'
    }
  };
  return {
    privacyPolicyTextLabel: translations.privacyPolicyLabel,
    addressChange: addressChange,
    arService: arService,
    aslService: aslService,
    chService: chService,
    enService: enService,
    esService: esService,
    ptService: ptService,
    ruService: ruService,
    PrivacyPolicyCopy: PrivacyPolicyCopy,
    privacyPolicyLabelMarkup: privacyPolicyLabelMarkup,
    privacyPolicyLabelStyle: privacyPolicyLabelStyle,
    touched: touched,
    yourChurchInformationLabel: translations.yourChurchInformationLabel
  };
};

var useContactFormConfirmation = function useContactFormConfirmation() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.customConfirmation;
  var userFirstName = deepFind(values, 'collector.entity[0].firstName');
  return {
    userFirstName: userFirstName,
    CustomConfirmation: CustomConfirmation
  };
};

var useCourseInterest = function useCourseInterest(_ref) {
  var displayList = _ref.displayList,
    displayListChurch = _ref.displayListChurch,
    notesQuestion = _ref.notesQuestion,
    notesLabel = _ref.notesLabel,
    pastorInfoSameAsContact = _ref.pastorInfoSameAsContact;
  useTranslationHelper();
  return {
    displayList: displayList,
    displayListChurch: displayListChurch,
    notesQuestion: notesQuestion,
    notesLabel: notesLabel,
    pastorInfoSameAsContact: pastorInfoSameAsContact
  };
};

var useCustomCopy = function useCustomCopy(_ref) {
  var confirmationBackgroundColor = _ref.confirmationBackgroundColor,
    customConfirmation = _ref.customConfirmation,
    customConfirmationEmail = _ref.customConfirmationEmail,
    individualConfirmationOnSite = _ref.individualConfirmationOnSite,
    individualConfirmationPrayer = _ref.individualConfirmationPrayer,
    individualConfirmationVolunteerOnly = _ref.individualConfirmationVolunteerOnly;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useEffect(function () {
    if (customConfirmation) {
      setFieldValue('formLogic.customConfirmation', customConfirmation);
    }
    if (individualConfirmationOnSite) {
      setFieldValue('formLogic.individualConfirmationOnSite', individualConfirmationOnSite);
    }
    if (individualConfirmationPrayer) {
      setFieldValue('formLogic.individualConfirmationPrayer', individualConfirmationPrayer);
    }
    if (individualConfirmationVolunteerOnly) {
      setFieldValue('formLogic.individualConfirmationVolunteerOnly', individualConfirmationVolunteerOnly);
    }
    if (customConfirmationEmail) {
      setFieldValue('formLogic.customConfirmationEmail', customConfirmationEmail);
    }
    if (confirmationBackgroundColor) {
      setFieldValue('formLogic.confirmationBackgroundColor', confirmationBackgroundColor);
    }
  }, []);
  return {
    values: values
  };
};

var useDataEntryFreeTShirt = function useDataEntryFreeTShirt(_ref) {
  var _values$formLogic;
  var isDevotional = _ref.isDevotional;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var refreshPage = function refreshPage() {
    window.location.reload();
  };
  var selectOneText = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.languageSelector) !== DDCLANG.ES.toLowerCase() ? 'Select One' : 'Seleccione uno';
  var cityList = !isDevotional ? [{
    id: '',
    value: selectOneText
  }, {
    id: 'TXBRTSH24',
    value: 'Brownsville, TX – Feb. 24, 2024'
  }, {
    id: 'TXMATSH24',
    value: 'McAllen, TX – Feb. 25, 2024'
  }, {
    id: 'TXLRTSH24',
    value: 'Laredo, TX – Feb. 27, 2024'
  }, {
    id: 'TXEGTSH24',
    value: 'Eagle Pass, TX – Feb. 28, 2024'
  }, {
    id: 'TXDRTSH24',
    value: 'Del Rio, TX – Feb. 29, 2024'
  }, {
    id: 'TXPRTSH24',
    value: 'Presidio, TX – March 2, 2024'
  }, {
    id: 'TXEPTSH24',
    value: 'El Paso, TX – March 3, 2024'
  }, {
    id: 'AZTCTSH24',
    value: 'Tucson, AZ – March 5, 2024'
  }, {
    id: 'AZYMTSH24',
    value: 'Yuma, AZ – March 7, 2024'
  }, {
    id: 'CASDTSH24',
    value: 'Chula Vista, CA – March 9, 2024'
  }] : [{
    id: '',
    value: selectOneText
  }, {
    id: 'TXBRRTC24',
    value: 'Brownsville, TX – Feb. 24, 2024'
  }, {
    id: 'TXMARTC24',
    value: 'McAllen, TX – Feb. 25, 2024'
  }, {
    id: 'TXLRRTC24',
    value: 'Laredo, TX – Feb. 27, 2024'
  }, {
    id: 'TXEGRTC24',
    value: 'Eagle Pass, TX – Feb. 28, 2024'
  }, {
    id: 'TXDRRTC24',
    value: 'Del Rio, TX – Feb. 29, 2024'
  }, {
    id: 'TXPRTSH24',
    value: 'Presidio, TX – March 2, 2024'
  }, {
    id: 'TXEPRTC24',
    value: 'El Paso, TX – March 3, 2024'
  }, {
    id: 'AZTCRTC24',
    value: 'Tucson, AZ – March 5, 2024'
  }, {
    id: 'AZYMRTC24',
    value: 'Yuma, AZ – March 7, 2024'
  }, {
    id: 'CASDRTC24',
    value: 'Chula Vista, CA – March 9, 2024'
  }];
  var SpanishConfirmation = function SpanishConfirmation() {
    return jsx("div", {
      children: jsx("button", {
        type: "button",
        onClick: refreshPage,
        children: "Refrescar Pagina"
      })
    });
  };
  var EnglishConfirmation = function EnglishConfirmation() {
    return jsx("div", {
      children: jsx("button", {
        type: "button",
        onClick: refreshPage,
        children: "Reload Page"
      })
    });
  };
  return {
    englishCustomConfirmation: EnglishConfirmation,
    cityList: cityList,
    spanishCustomConfirmation: SpanishConfirmation
  };
};

var useDataEntryForm = function useDataEntryForm(_ref) {
  var _ref$index = _ref.index,
    index = _ref$index === void 0 ? 1 : _ref$index;
  var userQuery = useUser();
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var entityInfo = {
    id: '',
    entityType: 'I',
    isPrimary: false,
    entityRelationship: [{
      relationshipType: 'Call Taker',
      path: 'entity[0]'
    }],
    firstName: 'Call',
    lastName: 'Taker',
    email: [{
      emailAddress: 'calltaker@bgea.org'
    }]
  };
  useEffect(function () {
    var _userQuery$data, _userQuery$data$paylo, _userQuery$data$paylo2;
    if ((userQuery === null || userQuery === void 0 ? void 0 : (_userQuery$data = userQuery.data) === null || _userQuery$data === void 0 ? void 0 : (_userQuery$data$paylo = _userQuery$data.payload) === null || _userQuery$data$paylo === void 0 ? void 0 : (_userQuery$data$paylo2 = _userQuery$data$paylo.callTaker) === null || _userQuery$data$paylo2 === void 0 ? void 0 : _userQuery$data$paylo2.length) > 0) {
      var _userQuery$data2, _payload$callTaker$, _payload$callTaker$2, _payload$callTaker$3, _payload$callTaker$4;
      var payload = userQuery === null || userQuery === void 0 ? void 0 : (_userQuery$data2 = userQuery.data) === null || _userQuery$data2 === void 0 ? void 0 : _userQuery$data2.payload;
      setFieldValue('formLogic.userInfo', payload);
      setFieldValue("collector.entity[".concat(index, "]"), entityInfo);
      setFieldValue("collector.entity[".concat(index, "].id"), payload === null || payload === void 0 ? void 0 : (_payload$callTaker$ = payload.callTaker[0]) === null || _payload$callTaker$ === void 0 ? void 0 : _payload$callTaker$.user_id);
      setFieldValue("collector.entity[".concat(index, "].firstName"), payload === null || payload === void 0 ? void 0 : (_payload$callTaker$2 = payload.callTaker[0]) === null || _payload$callTaker$2 === void 0 ? void 0 : _payload$callTaker$2.first_name);
      setFieldValue("collector.entity[".concat(index, "].lastName"), payload === null || payload === void 0 ? void 0 : (_payload$callTaker$3 = payload.callTaker[0]) === null || _payload$callTaker$3 === void 0 ? void 0 : _payload$callTaker$3.last_name);
      setFieldValue("collector.entity[".concat(index, "].email"), [{
        emailAddress: payload === null || payload === void 0 ? void 0 : (_payload$callTaker$4 = payload.callTaker[0]) === null || _payload$callTaker$4 === void 0 ? void 0 : _payload$callTaker$4.email
      }]);
    }
  }, [userQuery === null || userQuery === void 0 ? void 0 : userQuery.data]);
  return {
    values: values
  };
};

var formCopyPTM$1 = jsxs("div", {
  children: [jsx("h2", {
    children: "REQUISITOS PARA SER MIEMBRO DEL EQUIPO DE ORACI\xD3N"
  }), jsxs("ul", {
    children: [jsx("li", {
      children: "Estar de acuerdo con la Declaraci\xF3n de fe de la Billy Graham Evangelistic Association (BGEA)."
    }), jsx("li", {
      children: "Asistir a la Clase de Vida y Testimonio Cristiano."
    }), jsx("li", {
      children: "Ingresar una solicitud."
    }), jsx("li", {
      children: "Completar una revisi\xF3n de antecedentes penales.*"
    }), jsx("li", {
      children: "Presentar una recomendaci\xF3n pastoral."
    }), jsx("li", {
      children: "Comprometerte a orar con aquellos que tomen la decisi\xF3n de seguir a Cristo en el God Loves You Tour."
    })]
  }), jsx("p", {
    children: jsx("strong", {
      children: "*La revisi\xF3n de antecedentes penales solo es necesaria para ciudadanos o residentes permanentes de los Estados Unidos mayores de 18 a\xF1os. Para los ciudadanos de M\xE9xico, solo se requiere una recomendaci\xF3n pastoral."
    })
  })]
});
var formCopyPTMEN$1 = jsxs("div", {
  children: [jsx("h2", {
    children: "Prayer Team Member Requirements"
  }), jsxs("ul", {
    children: [jsx("li", {
      children: "Agree to the Billy Graham Evangelistic Association (BGEA) Statement of Faith."
    }), jsx("li", {
      children: "Attend one Christian Life and Witness Course."
    }), jsx("li", {
      children: "Submit an application."
    }), jsx("li", {
      children: "Complete a background check*"
    }), jsx("li", {
      children: "Provide a pastoral recommendation"
    }), jsx("li", {
      children: "Commit to pray with those who make decisions for Christ at the God Loves You Tour"
    })]
  }), jsx("p", {
    children: jsx("strong", {
      children: "*Background checks are only required for citizens or permanent residents of the United States 18 years of age or older. For citizens of Mexico, only a pastoral recommendation is required."
    })
  })]
});
var enProps$1 = {
  churchAddressLabel: 'About Your Church',
  cities: cities,
  cityRoleSelectLabel: 'Which event do you plan to attend?* Prayer team members may only serve at one event per tour.',
  formCopy: formCopyPTMEN$1,
  optinLabel: 'Opt in for text messages. <strong><em><small>Standard messaging rates apply</small></em></strong>',
  over18Label: 'I am 18 or older.',
  phoneDisclaimer: 'Please be sure to include your country code if you do not have a U.S. phone number.',
  shirtSizes: [{
    value: 'Select one',
    id: ''
  }, {
    value: 'Small',
    id: 'DATSFT24SM'
  }, {
    value: 'XL',
    id: 'DATSFT24XL'
  }, {
    value: '2XL',
    id: 'DATSFT242X'
  }, {
    value: '3XL',
    id: 'DATSFT243X'
  }, {
    value: '4XL',
    id: 'DATSFT244X'
  }],
  sizingDisclaimerText: 'Sizes subject to availability'
};
var esProps$1 = {
  churchAddressLabel: 'Información de la iglesia',
  cities: citiesES,
  cityRoleSelectLabel: '¿A qué evento deseas asistir?* Los miembros del Equipo de Oración solo pueden servir en un evento de la gira',
  fluentLangQuestionLabel: 'Are you also fluent in English?*',
  formCopy: formCopyPTM$1,
  optinLabel: 'Deseo recibir mensajes de texto. Aplican tarifas normales por mensaje de texto',
  over18Label: '¿Tienes al menos 18 años de edad? Si eres menor de 18 años de edad, es necesario contar con el consentimiento de un padre o tutor.',
  phoneDisclaimer: 'Si tu número es de México, asegúrate de incluir el código de país (52) seguido de los diez dígitos de tu número telefónico.',
  shirtSizes: [{
    value: 'Seleccione uno',
    id: ''
  }, {
    value: 'Pequeña',
    id: 'DATSFT24SM'
  }, {
    value: 'XL',
    id: 'DATSFT24XL'
  }, {
    value: '2XL',
    id: 'DATSFT242X'
  }, {
    value: '3XL',
    id: 'DATSFT243X'
  }, {
    value: '4XL',
    id: 'DATSFT244X'
  }],
  sizingDisclaimerText: 'Tallas sujetas a disponibilidad.'
};
var useDataEntryPrayerTeam = function useDataEntryPrayerTeam(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var prayerFormProps = (props === null || props === void 0 ? void 0 : props.lng) === 'es' ? _objectSpread2(_objectSpread2(_objectSpread2({}, props), prayerTeamFormProps), esProps$1) : _objectSpread2(_objectSpread2(_objectSpread2({}, props), prayerTeamFormProps), enProps$1);
  return {
    prayerFormProps: prayerFormProps
  };
};

var formCopyPTM = jsxs("div", {
  children: [jsx("p", {
    children: "\xA1Gracias por tu inter\xE9s en servir como voluntario durante la gira God Loves You Frontera Tour!"
  }), jsx("p", {
    children: "Estamos emocionados de unir fuerzas contigo para compartir las Buenas Nuevas. Al registrarte como voluntario, te comprometes a ayudar a difundir informaci\xF3n sobre la gira, invitar a tu comunidad, y orar por este evento evangel\xEDstico."
  }), jsx("p", {
    children: "Tambi\xE9n tendr\xE1s la oportunidad de servir durante el d\xEDa del evento, ya sea en el Equipo de Oraci\xF3n o en el Equipo Presencial."
  }), jsxs("p", {
    children: ["Para inscribirte, completa el siguiente formulario. Una vez enviado, recibir\xE1s por correo electr\xF3nico informaci\xF3n actualizada espec\xEDfica para voluntarios, y tambi\xE9n recibir\xE1s recursos* para promocionar la gira.", jsx("br", {}), jsx("strong", {
      children: "*Los kits de voluntario dejar\xE1n de enviarse para distribuci\xF3n el 8 de febrero de 2024. Los kits de voluntario para quienes residen en los Estados Unidos dejar\xE1n de enviarse el 19 de febrero de 2024."
    })]
  }), jsx("p", {
    children: "Muchas gracias. \xA1Que el Se\xF1or te bendiga!"
  }), jsx("br", {})]
});
var formCopyPTMEN = jsxs("div", {
  children: [jsx("p", {
    children: "Thank you for your interest in volunteering for the God Loves You Frontera Tour!"
  }), jsx("p", {
    children: "We are excited for you to partner with us in sharing the Good News. By registering as a volunteer, you are committing to help spread the word, invite your community, and pray for this outreach event."
  }), jsx("p", {
    children: "You also have the opportunity to serve the day of the tour on either the prayer team or the on-site team."
  }), jsxs("p", {
    children: ["To register, please fill out the following form. Once submitted, you will receive volunteer email updates and resources* in the mail to promote the tour. ", jsx("br", {})]
  }), jsx("p", {
    children: jsx("strong", {
      children: "* Volunteer kits for Mexico residents will not be mailed for distribution after February 8, 2024. Volunteer kits for U.S. residents will not be mailed after February 19, 2024."
    })
  }), jsx("p", {
    children: "Thank you and God bless!"
  }), jsx("br", {})]
});
var enProps = {
  churchAddressLabel: 'About Your Church',
  cities: cities,
  cityRoleSelectLabel: 'Which event do you plan to attend?* Prayer team members may only serve at one event per tour.',
  formCopy: formCopyPTMEN,
  optinLabel: 'Opt in for text messages. <strong><em><small>Standard messaging rates apply</small></em></strong>',
  orgRoles: {
    '': 'Select',
    'ADMIN': 'Administrator',
    'CAMPUSPAST': 'Church Satellite Campus Pastor',
    'CAP': 'Associate Pastor',
    'CCP': "Children's Pastor",
    'CHP': 'Chaplain',
    'CHURMEM': 'Church Member',
    'CSP': 'Senior Pastor',
    'CYP': 'Youth Pastor',
    'PASTOR': 'Pastor',
    'CHLEAD': 'Church Leader'
  },
  over18Label: 'I am 18 or older.',
  phoneDisclaimer: 'Please be sure to include your country code if you do not have a U.S. phone number.',
  roleDescription: 'In addition to helping spread the word in the community, I am interested in learning more about serving in one of the following roles on the day of the event:*',
  roleOptions: [{
    id: 'VC024',
    label: 'Prayer Team',
    name: 'roleOptionsGroup',
    value: '1327'
  }, {
    id: 'VD124',
    label: 'On-Site Team',
    name: 'roleOptionsGroup',
    value: '1302'
  }, {
    id: 'VM124',
    label: 'I only plan to help spread the word about the event.',
    name: 'roleOptionsGroup',
    value: '1300'
  }],
  shirtSizes: [{
    value: 'Select one',
    id: ''
  }, {
    value: 'Small',
    id: 'DATSFT24SM'
  }, {
    value: 'XL',
    id: 'DATSFT24XL'
  }, {
    value: '2XL',
    id: 'DATSFT242X'
  }, {
    value: '3XL',
    id: 'DATSFT243X'
  }, {
    value: '4XL',
    id: 'DATSFT244X'
  }],
  sizingDisclaimerText: 'Sizes subject to availability'
};
var esProps = {
  churchAddressLabel: 'Información de la iglesia',
  cities: citiesES,
  cityRoleSelectLabel: '¿A qué evento deseas asistir?* Los miembros del Equipo de Oración solo pueden servir en un evento de la gira',
  fluentLangQuestionLabel: 'Are you also fluent in English?*',
  formCopy: formCopyPTM,
  optinLabel: 'Deseo recibir mensajes de texto. Aplican tarifas normales por mensaje de texto',
  orgRoles: {
    '': 'Seleccione uno',
    'ADMIN': 'Administrativo',
    'CAMPUSPAST': 'Pastor de uno de los campus',
    'CAP': 'Pastor asociado',
    'CCP': 'Pastor de niños',
    'CHP': 'Capellán',
    'CHURMEM': 'Miembro de la iglesia',
    'CSP': 'Pastor principal (senior)',
    'CYP': 'Pastor de jóvenes',
    'PASTOR': 'Pastor',
    'CHLEAD': 'Líder en la iglesia'
  },
  over18Label: '¿Tienes al menos 18 años de edad? Si eres menor de 18 años de edad, es necesario contar con el consentimiento de un padre o tutor.',
  phoneDisclaimer: 'Si tu número es de México, asegúrate de incluir el código de país (52) seguido de los diez dígitos de tu número telefónico.',
  roleDescription: 'Además de ayudar a difundir la información sobre el evento en mi comunidad, me interesa saber más sobre la posibilidad de desempeñar una de las siguientes funciones durante el día del evento:*',
  roleOptions: [{
    id: 'VC024',
    label: 'Equipo de Oración.',
    name: 'roleOptionsGroup',
    value: '1327'
  }, {
    id: 'VD124',
    label: 'Equipo Presencial.',
    name: 'roleOptionsGroup',
    value: '1302'
  }, {
    id: 'VM124',
    label: 'Solo puedo ayudar con la difusión de información sobre el evento.',
    name: 'roleOptionsGroup',
    value: '1300'
  }],
  shirtSizes: [{
    value: 'Seleccione uno',
    id: ''
  }, {
    value: 'Pequeña',
    id: 'DATSFT24SM'
  }, {
    value: 'XL',
    id: 'DATSFT24XL'
  }, {
    value: '2XL',
    id: 'DATSFT242X'
  }, {
    value: '3XL',
    id: 'DATSFT243X'
  }, {
    value: '4XL',
    id: 'DATSFT244X'
  }],
  sizingDisclaimerText: 'Tallas sujetas a disponibilidad.'
};
var useDataEntryVolunteer = function useDataEntryVolunteer(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var formProps = (props === null || props === void 0 ? void 0 : props.lng) === 'es' ? _objectSpread2(_objectSpread2(_objectSpread2({}, props), volunteerFormProps), esProps) : _objectSpread2(_objectSpread2(_objectSpread2({}, props), volunteerFormProps), enProps);
  return {
    formProps: formProps
  };
};

var camelCase = function camelCase(str) {
  return str.replace(/[-_]([a-z])/g, function (m) {
    return m[1].toUpperCase();
  });
};
var parseValues = curry(function (fn, obj) {
  if (isEmpty(keys(obj))) {
    return obj;
  }
  // eslint-disable-next-line @typescript-eslint/no-use-before-define
  return mapKeys(fn, obj);
});
var mapKeys = curry(function (fn, obj) {
  return zipObj(map(fn, keys(obj)), map(parseValues(fn), values(obj)));
});
var fold = curry(function (fn, value) {
  return is(Array, value) ? map(fn, value) : fn(value);
});
var toCamelCase = fold(mapKeys(camelCase), __);
var transformCityRoles = function transformCityRoles(cities) {
  var cityList = convertOptionsToList(cities);
  return cityList === null || cityList === void 0 ? void 0 : cityList.map(function (city) {
    return {
      id: city.id,
      value: city.value.label,
      valueObj: JSON.stringify(city.value)
    };
  });
};

var useDmagPromo = function useDmagPromo() {
  var _values$formLogic, _values$formLogic$par, _queryProjectDict$dc, _queryProjectDict$dc$;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    promotionsInfo = _useState2[0],
    setPromotionsInfo = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    subscriptions = _useState4[0],
    setSubscriptions = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    isPromoCodeInvalid = _useState6[0],
    setIsPromoCodeInvalid = _useState6[1];
  var queryProjectDict = getQueryStringDict((values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.formQueryString) || '');
  var discountCode = (queryProjectDict === null || queryProjectDict === void 0 ? void 0 : (_queryProjectDict$dc = queryProjectDict.dc) === null || _queryProjectDict$dc === void 0 ? void 0 : (_queryProjectDict$dc$ = _queryProjectDict$dc.toUpperCase()) === null || _queryProjectDict$dc$ === void 0 ? void 0 : _queryProjectDict$dc$.trim()) || '';
  var dmagSubscriptionsQuery = useGetDmagSubscriptions();
  var handlePromoCodeLogic = function handlePromoCodeLogic(_ref) {
    var promoCode = _ref.promoCode;
    if ((promoCode === null || promoCode === void 0 ? void 0 : promoCode.length) > 0) {
      var promoList = subscriptions.filter(function (item) {
        return (item === null || item === void 0 ? void 0 : item.discountCode) === promoCode;
      });
      if ((promoList === null || promoList === void 0 ? void 0 : promoList.length) > 0) {
        setIsPromoCodeInvalid(false);
        setPromotionsInfo(_toConsumableArray(promoList));
      } else {
        setIsPromoCodeInvalid(true);
        setPromotionsInfo([]);
      }
    }
  };
  var handleOnClickPromoCode = function handleOnClickPromoCode() {
    var _values$formLogic2, _values$formLogic2$pr, _values$formLogic2$pr2;
    var promoCode = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$pr = _values$formLogic2.promoCode) === null || _values$formLogic2$pr === void 0 ? void 0 : (_values$formLogic2$pr2 = _values$formLogic2$pr.toUpperCase()) === null || _values$formLogic2$pr2 === void 0 ? void 0 : _values$formLogic2$pr2.trim();
    handlePromoCodeLogic({
      promoCode: promoCode
    });
    setFieldValue('formLogic.promoCode', promoCode);
  };
  useEffect(function () {
    if (dmagSubscriptionsQuery !== null && dmagSubscriptionsQuery !== void 0 && dmagSubscriptionsQuery.data) {
      var data = toCamelCase(dmagSubscriptionsQuery === null || dmagSubscriptionsQuery === void 0 ? void 0 : dmagSubscriptionsQuery.data);
      setSubscriptions(_toConsumableArray(data));
    }
  }, [dmagSubscriptionsQuery === null || dmagSubscriptionsQuery === void 0 ? void 0 : dmagSubscriptionsQuery.data]);
  useEffect(function () {
    if (discountCode && (subscriptions === null || subscriptions === void 0 ? void 0 : subscriptions.length) > 0) {
      handlePromoCodeLogic({
        promoCode: discountCode
      });
    }
  }, [subscriptions, discountCode]);
  useEffect(function () {
    setFieldValue('formLogic.promoCode', discountCode);
  }, []);
  return {
    isPromoCodeInvalid: isPromoCodeInvalid,
    isPromoSuccess: dmagSubscriptionsQuery === null || dmagSubscriptionsQuery === void 0 ? void 0 : dmagSubscriptionsQuery.isSuccess,
    promotionsInfo: promotionsInfo,
    values: values,
    handleOnClickPromoCode: handleOnClickPromoCode
  };
};

var getListByLocation = function getListByLocation(_ref) {
  var hasPromoCode = _ref.hasPromoCode,
    promotionsInfo = _ref.promotionsInfo,
    subLocation = _ref.subLocation,
    subscriptionList = _ref.subscriptionList;
  var list = hasPromoCode && (promotionsInfo === null || promotionsInfo === void 0 ? void 0 : promotionsInfo.length) > 0 ? promotionsInfo : subscriptionList;
  var subList = list.filter(function (item) {
    return item.location === subLocation.toLowerCase() && (item.type === SubTypes.ONE_PD || item.type === SubTypes.TWO_PD);
  });
  subList.sort(function (a, b) {
    return a.price > b.price ? 1 : -1;
  });
  return subList;
};
var setListByLocation = function setListByLocation(_ref2) {
  var hasPromoCode = _ref2.hasPromoCode,
    promotionsInfo = _ref2.promotionsInfo,
    subLocation = _ref2.subLocation,
    subscriptionList = _ref2.subscriptionList,
    setSubscriptionOptions = _ref2.setSubscriptionOptions;
  var subList = getListByLocation({
    hasPromoCode: hasPromoCode,
    promotionsInfo: promotionsInfo,
    subLocation: subLocation,
    subscriptionList: subscriptionList
  });
  setSubscriptionOptions(subList.map(function (item) {
    var _item$description;
    var value = {
      description: item.description,
      id: item.id,
      location: item.location,
      numberOfIssues: item.numberOfIssues,
      price: item.price,
      priceCode: item.priceCode,
      sourceCode: item.sourceCode,
      type: item.type
    };
    return {
      id: item.id,
      label: "".concat((_item$description = item.description) === null || _item$description === void 0 ? void 0 : _item$description.toLowerCase(), " for ").concat(formatUSCurrency(Number(item.price), 0), " ").concat(subLocation === SubLocations.INTL ? '(exchange rates apply)' : ''),
      name: 'subscriptionOptionGroup',
      numberOfIssues: item.numberOfIssues,
      value: JSON.stringify(value)
    };
  }));
};

var getValueItem = function getValueItem(list) {
  var _list$;
  return {
    description: list[0].description,
    id: list[0].id,
    location: list[0].location,
    numberOfIssues: list[0].numberOfIssues,
    price: list[0].price,
    priceCode: list[0].priceCode,
    sourceCode: (_list$ = list[0]) === null || _list$ === void 0 ? void 0 : _list$.sourceCode,
    type: list[0].type
  };
};
var useDmagLogic = function useDmagLogic(_ref) {
  var _values$formLogic, _values$formLogic$par;
  var countryListIntl = _ref.countryListIntl,
    defaultSourceCode = _ref.defaultSourceCode,
    giftSubscriptionOption = _ref.giftSubscriptionOption,
    hasPromoCode = _ref.hasPromoCode,
    promotionsInfo = _ref.promotionsInfo,
    subLocation = _ref.subLocation,
    subscriptionTypeOption = _ref.subscriptionTypeOption,
    setSubscriptionOptions = _ref.setSubscriptionOptions,
    updateCountryOptions = _ref.updateCountryOptions;
  var nonDiscountQuery = useGetDmagNonDiscountSubscriptions();
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    subscriptionList = _useState2[0],
    setSubscriptionList = _useState2[1];
  var sourceCode = getSourceQueryString((values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.formQueryString) || '');
  useEffect(function () {
    if (nonDiscountQuery !== null && nonDiscountQuery !== void 0 && nonDiscountQuery.data) {
      var data = toCamelCase(nonDiscountQuery === null || nonDiscountQuery === void 0 ? void 0 : nonDiscountQuery.data);
      setSubscriptionList(_toConsumableArray(data));
    }
  }, [nonDiscountQuery === null || nonDiscountQuery === void 0 ? void 0 : nonDiscountQuery.data]);
  useEffect(function () {
    if ((subscriptionList === null || subscriptionList === void 0 ? void 0 : subscriptionList.length) > 0) {
      setListByLocation({
        hasPromoCode: hasPromoCode,
        promotionsInfo: promotionsInfo,
        subLocation: subLocation,
        subscriptionList: subscriptionList,
        setSubscriptionOptions: setSubscriptionOptions
      });
      var list = getListByLocation({
        hasPromoCode: hasPromoCode,
        promotionsInfo: promotionsInfo,
        subLocation: subLocation,
        subscriptionList: subscriptionList
      });
      var value = getValueItem(list);
      setFieldValue('formLogic.subscriptionTypeOption', JSON.stringify(value));
    }
  }, [subscriptionList]);
  useEffect(function () {
    if ((promotionsInfo === null || promotionsInfo === void 0 ? void 0 : promotionsInfo.length) > 0) {
      setListByLocation({
        hasPromoCode: hasPromoCode,
        promotionsInfo: promotionsInfo,
        subLocation: subLocation,
        subscriptionList: subscriptionList,
        setSubscriptionOptions: setSubscriptionOptions
      });
      var list = getListByLocation({
        hasPromoCode: hasPromoCode,
        promotionsInfo: promotionsInfo,
        subLocation: subLocation,
        subscriptionList: subscriptionList
      });
      if (list[0]) {
        var _list$2;
        var value = getValueItem(list);
        setFieldValue('formLogic.subscriptionTypeOption', JSON.stringify(value));
        setFieldValue('collector.SESourceCode', sourceCode || ((_list$2 = list[0]) === null || _list$2 === void 0 ? void 0 : _list$2.sourceCode) || defaultSourceCode);
      }
    }
  }, [promotionsInfo]);
  useEffect(function () {
    if (subscriptionTypeOption) {
      var optionTypeObj = JSON.parse(subscriptionTypeOption);
      var currentPrice = +(optionTypeObj === null || optionTypeObj === void 0 ? void 0 : optionTypeObj.price);
      if (hasPromoCode && (promotionsInfo === null || promotionsInfo === void 0 ? void 0 : promotionsInfo.length) > 0 && (subscriptionList === null || subscriptionList === void 0 ? void 0 : subscriptionList.length) > 0) {
        var _values$formLogic2;
        var list = _toConsumableArray(subscriptionList);
        var originalObj = list.find(function (item) {
          return item.type === optionTypeObj.type && item.location === optionTypeObj.location;
        });
        var originalPrice = +originalObj.price;
        var discount = calculateDiscount(originalPrice, currentPrice);
        setFieldValue('collector.cart.cartPromos', [{
          promoId: values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.promoCode,
          amountOff: discount
        }]);
      }
      var cartProducts = [{
        amount: currentPrice,
        quantity: 1,
        priceCode: optionTypeObj === null || optionTypeObj === void 0 ? void 0 : optionTypeObj.priceCode
      }];
      var cartTotals = {
        shippingTotal: 0,
        currency: 'USD',
        subTotal: currentPrice,
        taxAmount: 0
      };
      setFieldValue('collector.SESourceCode', sourceCode || (optionTypeObj === null || optionTypeObj === void 0 ? void 0 : optionTypeObj.sourceCode) || defaultSourceCode);
      setFieldValue('collector.cart.products', cartProducts);
      setFieldValue('collector.cart.cartTotals', cartTotals);
      setFieldValue('formLogic.subType', optionTypeObj === null || optionTypeObj === void 0 ? void 0 : optionTypeObj.type);
      setFieldValue('formLogic.price', optionTypeObj === null || optionTypeObj === void 0 ? void 0 : optionTypeObj.price);
    }
  }, [subscriptionTypeOption, subscriptionList]);
  useEffect(function () {
    var entityIndex = giftSubscriptionOption === 'yes' ? 1 : 0;
    if (subLocation !== SubLocations.INTL) {
      updateCountryOptions(['US', 'MX']);
      setFieldValue("collector.entity[".concat(entityIndex, "].address[0].country"), 'US');
    } else {
      updateCountryOptions(countryListIntl);
      setFieldValue("collector.entity[".concat(entityIndex, "].address[0].country"), 'US');
    }
  }, [subLocation, giftSubscriptionOption]);
  useEffect(function () {
    if (subLocation) {
      setListByLocation({
        hasPromoCode: hasPromoCode,
        promotionsInfo: promotionsInfo,
        subLocation: subLocation,
        subscriptionList: subscriptionList,
        setSubscriptionOptions: setSubscriptionOptions
      });
      var list = getListByLocation({
        hasPromoCode: hasPromoCode,
        promotionsInfo: promotionsInfo,
        subLocation: subLocation,
        subscriptionList: subscriptionList
      });
      if (list[0]) {
        var value = getValueItem(list);
        setFieldValue('formLogic.subscriptionTypeOption', JSON.stringify(value));
      }
    }
  }, [subLocation]);
  return {
    isDiscountSuccess: nonDiscountQuery === null || nonDiscountQuery === void 0 ? void 0 : nonDiscountQuery.isSuccess,
    values: values
  };
};

var useDecisionMagazine = function useDecisionMagazine(_ref) {
  var _values$formLogic, _values$formLogic2, _values$formLogic3, _values$formLogic4, _values$collector, _values$collector2, _values$collector2$en, _values$collector3, _values$collector3$en, _values$collector3$en2;
  var SESourceCode = _ref.SESourceCode;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useTranslationHelper();
  var _useDmagPromo = useDmagPromo(),
    isPromoCodeInvalid = _useDmagPromo.isPromoCodeInvalid,
    isPromoSuccess = _useDmagPromo.isPromoSuccess,
    promotionsInfo = _useDmagPromo.promotionsInfo,
    handleOnClickPromoCode = _useDmagPromo.handleOnClickPromoCode;
  var countryListIntl = CountryRegion.filter(function (country) {
    return !['US', 'MX', 'CA'].includes(country.countryShortCode);
  }).map(function (country) {
    return country.countryShortCode;
  });
  var hasPromoCode = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.promoCode) !== '';
  var giftSubscriptionOption = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.giftSubscriptionOption;
  var subLocation = values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.subLocation;
  var subscriptionTypeOption = values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.subscriptionTypeOption;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    countryOptions = _useState2[0],
    updateCountryOptions = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPaymentInfo = _useState4[0],
    setShowPaymentInfo = _useState4[1];
  var _useState5 = useState([]),
    _useState6 = _slicedToArray(_useState5, 2),
    subscriptionOptions = _useState6[0],
    setSubscriptionOptions = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showGiftRecipientInfo = _useState8[0],
    setShowGiftRecipientInfo = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showDataPromoError = _useState10[0],
    setShowDataPromoError = _useState10[1];
  var entityEmailAddress1 = (values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : _values$collector.entity[1]) && (values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[1]) === null || _values$collector2$en === void 0 ? void 0 : _values$collector2$en.email) && (values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[1]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.email[0]) === null || _values$collector3$en2 === void 0 ? void 0 : _values$collector3$en2.emailAddress) || '';
  var billingCountryOptions = ['US'];
  var _useDmagLogic = useDmagLogic({
      countryListIntl: countryListIntl,
      defaultSourceCode: SESourceCode,
      giftSubscriptionOption: giftSubscriptionOption,
      hasPromoCode: hasPromoCode,
      promotionsInfo: promotionsInfo,
      subLocation: subLocation,
      subscriptionTypeOption: subscriptionTypeOption,
      setSubscriptionOptions: setSubscriptionOptions,
      updateCountryOptions: updateCountryOptions
    }),
    isDiscountSuccess = _useDmagLogic.isDiscountSuccess;
  useEffect(function () {
    if ((subscriptionOptions === null || subscriptionOptions === void 0 ? void 0 : subscriptionOptions.length) === 0 && isPromoSuccess && isDiscountSuccess && subLocation) {
      setShowDataPromoError(true);
    } else {
      setShowDataPromoError(false);
    }
  }, [subscriptionOptions]);
  useEffect(function () {
    var updatedEntities = _toConsumableArray(values.collector.entity);
    if (giftSubscriptionOption === 'yes') {
      updatedEntities[1] = _objectSpread2(_objectSpread2({}, updatedEntities[1]), {}, {
        entityRelationship: [{
          path: 'entity[0]',
          relationshipType: RelationshipType.DecisionMagazineGiftee
        }]
      });
      setFieldValue('collector.entity', updatedEntities);
      setShowGiftRecipientInfo(true);
    } else {
      setFieldValue('collector.entity', [updatedEntities[0]]);
      setShowGiftRecipientInfo(false);
    }
  }, [giftSubscriptionOption]);
  useEffect(function () {
    var _values$collector4, _values$collector5, _values$collector5$en, _values$collector6, _values$collector6$en, _values$collector6$en2, _values$collector6$en3;
    if (values !== null && values !== void 0 && (_values$collector4 = values.collector) !== null && _values$collector4 !== void 0 && _values$collector4.entity[1] && values !== null && values !== void 0 && (_values$collector5 = values.collector) !== null && _values$collector5 !== void 0 && (_values$collector5$en = _values$collector5.entity[1]) !== null && _values$collector5$en !== void 0 && _values$collector5$en.email && (values === null || values === void 0 ? void 0 : (_values$collector6 = values.collector) === null || _values$collector6 === void 0 ? void 0 : (_values$collector6$en = _values$collector6.entity[1]) === null || _values$collector6$en === void 0 ? void 0 : (_values$collector6$en2 = _values$collector6$en.email[0]) === null || _values$collector6$en2 === void 0 ? void 0 : (_values$collector6$en3 = _values$collector6$en2.emailAddress) === null || _values$collector6$en3 === void 0 ? void 0 : _values$collector6$en3.length) === 0) {
      delete values.collector.entity[1].email;
    }
  }, [entityEmailAddress1]);
  useEffect(function () {
    if (subscriptionTypeOption && subLocation) {
      setShowPaymentInfo(true);
    } else {
      setShowPaymentInfo(false);
    }
  }, [subscriptionTypeOption, subLocation]);
  useEffect(function () {
    setFormId({
      templateName: Templates.DECISION_MAGAZINE,
      values: values,
      setFieldValue: setFieldValue
    });
    setFieldValue('formLogic.subLocation', 'US');
    setFieldValue('formLogic.giftSubscriptionOption', 'no');
  }, []);
  return {
    addressVisibleList: addressVisibleList,
    billingAddressVisibleList: billingAddressVisibleList,
    billingCountryOptions: billingCountryOptions,
    countryOptions: countryOptions,
    destinationTitle: destinationTitle,
    destinationOptions: destinationOptions,
    displayList: displayList,
    giftRecipientTitle: giftRecipientTitle,
    giftSubscriptionLabel: giftSubscriptionLabel,
    giftSubscriptionOptions: giftSubscriptionOptions,
    giftSubscriptionTitle: giftSubscriptionTitle,
    hasPromoCode: hasPromoCode,
    isPromoCodeInvalid: isPromoCodeInvalid,
    paymentTitle: paymentTitle,
    showGiftRecipientInfo: showGiftRecipientInfo,
    showPaymentInfo: showPaymentInfo,
    showDataPromoError: showDataPromoError,
    subscriptionOptions: subscriptionOptions,
    subscriptionOptionTitle: subscriptionOptionTitle,
    handleOnClickPromoCode: handleOnClickPromoCode,
    values: values
  };
};

// Helper function to determine transaction type
var getTransactionType = function getTransactionType(transaction) {
  if (transaction !== null && transaction !== void 0 && transaction.paypal && _typeof(transaction.paypal) === 'object') {
    return 'PayPal';
  }
  if (transaction !== null && transaction !== void 0 && transaction.bluefinCC && _typeof(transaction.bluefinCC) === 'object') {
    return 'credit card';
  }
  if (transaction !== null && transaction !== void 0 && transaction.bluefinEFT && _typeof(transaction.bluefinEFT) === 'object') {
    return 'checking account';
  }
  return '';
};

var useDecisionMagazineConfirmation = function useDecisionMagazineConfirmation() {
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  // Extract cart and payment information
  var cartInfo = deepFind(values, 'collector.cart.cartTotals');
  var price = cartInfo === null || cartInfo === void 0 ? void 0 : cartInfo.subTotal;
  var transaction = deepFind(values, 'payment');
  var transactionId = deepFind(values, 'submissionresponse.payload.payment.transaction_id');
  var transactionType = getTransactionType(transaction);
  var subscriptionTypeOption = deepFind(values, 'formLogic.subscriptionTypeOption');
  var optionTypeObj = JSON.parse(subscriptionTypeOption);
  var description = optionTypeObj.description;
  return {
    description: description,
    price: price,
    transactionId: transactionId,
    transactionType: transactionType
  };
};

var useDefaultCode = function useDefaultCode(_ref) {
  var _values$formLogic, _values$collector, _values$collector2, _values$collector2$en, _values$collector3, _values$collector3$en, _values$collector3$en2;
  var campaignCodes = _ref.campaignCodes,
    eventId = _ref.eventId,
    _ref$isInternational = _ref.isInternational,
    isInternational = _ref$isInternational === void 0 ? false : _ref$isInternational,
    _ref$lng = _ref.lng,
    lng = _ref$lng === void 0 ? 'en' : _ref$lng,
    _ref$shouldNotSetLang = _ref.shouldNotSetLanguageCode,
    shouldNotSetLanguageCode = _ref$shouldNotSetLang === void 0 ? false : _ref$shouldNotSetLang,
    _ref$languageCode = _ref.languageCode,
    languageCode = _ref$languageCode === void 0 ? 'DDCLANG' : _ref$languageCode;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    i18n = _useTranslation.i18n;
  var locales = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.locales;
  var defaultCodes = (campaignCodes === null || campaignCodes === void 0 ? void 0 : campaignCodes.length) > 0 ? campaignCodes : [];
  var resetArr = values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && _values$collector.entity && values !== null && values !== void 0 && (_values$collector2 = values.collector) !== null && _values$collector2 !== void 0 && (_values$collector2$en = _values$collector2.entity[0]) !== null && _values$collector2$en !== void 0 && _values$collector2$en.code ? values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.code) === null || _values$collector3$en2 === void 0 ? void 0 : _values$collector3$en2.slice() : defaultCodes;
  var language = Array.isArray(lng) ? lng[0] : lng;
  var eventObj = isInternational ? {
    key: 'EVENTS',
    value: eventId
  } : {
    key: "CRUSADE:".concat(eventId),
    value: 'EVENT'
  };
  var lngObj = isInternational ? [{
    key: "A01c:DDCLANG",
    value: language === null || language === void 0 ? void 0 : language.toUpperCase()
  }, {
    key: "A01c:DEFLANG",
    value: language === null || language === void 0 ? void 0 : language.toUpperCase()
  }] : [{
    key: languageCode,
    value: language === null || language === void 0 ? void 0 : language.toUpperCase()
  }];
  useEffect(function () {
    var languageTranslation = locales || language;
    i18n.changeLanguage(languageTranslation);
  }, [locales]);
  useEffect(function () {
    setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), _toConsumableArray(!shouldNotSetLanguageCode ? lngObj : []), _toConsumableArray(eventId ? [eventObj] : [])));
    setFieldValue('formLogic.language', language === null || language === void 0 ? void 0 : language.toUpperCase());
  }, []);
  return {
    values: values
  };
};

var useDenomination = function useDenomination() {
  var _values$formLogic2;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useEffect(function () {
    var _values$formLogic;
    if (values !== null && values !== void 0 && (_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && _values$formLogic.denomination) {
      setFieldValue("collector.entity[1].denomination", values.formLogic.denomination);
    }
  }, [(_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.denomination]);
  return {
    values: values
  };
};

var useDestination = function useDestination(_ref) {
  var destination = _ref.destination;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useEffect(function () {
    if (destination) {
      setFieldValue("collector.destination", destination);
    }
  }, []);
  return {
    values: values
  };
};

var _excluded$S = ["errorMessage"];
var useEchoConversation = function useEchoConversation(_ref) {
  var _values$echo, _values$collector;
  var errorMessage = _ref.errorMessage,
    props = _objectWithoutProperties(_ref, _excluded$S);
  var _useFormikContext = useFormikContext(),
    isValid = _useFormikContext.isValid,
    setFieldValue = _useFormikContext.setFieldValue,
    status = _useFormikContext.status,
    values = _useFormikContext.values;
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    apiErrorMessage = _useState2[0],
    setApiErrorMesssage = _useState2[1];
  var phoneInput = values === null || values === void 0 ? void 0 : (_values$echo = values.echo) === null || _values$echo === void 0 ? void 0 : _values$echo.phone;
  var shouldDisableForm = !isValid;
  var phoneInputName = 'echo.phone';
  var validatePhoneNumber = function validatePhoneNumber(val) {
    return validateEchoPhoneNumber(val, errorMessage);
  };
  useTranslationHelper();
  useEffect(function () {
    if (phoneInput) {
      var numericValue = phoneInput.replace(/[^0-9]/g, '');
      setFieldValue(phoneInputName, numericValue, false);
    }
  }, [phoneInput]);
  useEffect(function () {
    if (status === ResponseStatus.POWER_BY_TEXT_ERROR) {
      var _values$formLogic, _values$formLogic$pow;
      setApiErrorMesssage((props === null || props === void 0 ? void 0 : props.apiErrorMessage) || (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$pow = _values$formLogic.powerByTextResponse) === null || _values$formLogic$pow === void 0 ? void 0 : _values$formLogic$pow.message));
    }
  }, [status]);
  useEffect(function () {
    setFieldValue("echo.phone", '', true);
    setFieldValue("echo.body", props === null || props === void 0 ? void 0 : props.echoBody);
    setFieldValue("echo.toPhone", props === null || props === void 0 ? void 0 : props.echoToPhone);
    setFieldValue("echo.websiteId", props === null || props === void 0 ? void 0 : props.echoWebsiteUuid);
    if (props !== null && props !== void 0 && props.usePowerTextApi) {
      setFieldValue("formLogic.usePowerTextApi", true, false);
    }
  }, []);
  var inputClass = 'input';
  if ((apiErrorMessage === null || apiErrorMessage === void 0 ? void 0 : apiErrorMessage.length) > 0) {
    inputClass += ' is-danger';
  }
  values.collector.entity = [];
  values === null || values === void 0 ? true : (_values$collector = values.collector) === null || _values$collector === void 0 ? true : delete _values$collector.cart;
  return {
    apiErrorMessage: apiErrorMessage,
    inputClass: inputClass,
    phoneInputName: phoneInputName,
    shouldDisableForm: shouldDisableForm,
    values: values,
    validatePhoneNumber: validatePhoneNumber
  };
};

var useEmail = function useEmail(_ref) {
  var emailId = _ref.emailId,
    isBasicTemplate = _ref.isBasicTemplate;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useEffect(function () {
    if (emailId && !isBasicTemplate) {
      setFieldValue("email.emailId", emailId, false);
    }
  }, []);
  return {
    values: values
  };
};

var useEmailSubscription = function useEmailSubscription(_ref) {
  var esubCodes = _ref.esubCodes;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var setEsubs = function setEsubs(codes) {
    var subscriptions = [];
    if (codes && Array.isArray(codes)) {
      codes.forEach(function (code) {
        if (typeof code === 'string') {
          subscriptions.push({
            esubCode: code,
            isActive: true
          });
        } else if (_typeof(code) === 'object') {
          subscriptions.push(code);
        }
      });
    }
    setFieldValue("collector.entity[0].email[0].emailSubscription", subscriptions);
  };
  useEffect(function () {
    setEsubs(esubCodes);
  }, []);
  useEffect(function () {
    setEsubs(esubCodes);
  }, [esubCodes]);
  return {
    values: values
  };
};

var useEventId = function useEventId(_ref) {
  var eventId = _ref.eventId,
    _ref$isInternational = _ref.isInternational,
    isInternational = _ref$isInternational === void 0 ? false : _ref$isInternational,
    _ref$isComponentDidUp = _ref.isComponentDidUpdate,
    isComponentDidUpdate = _ref$isComponentDidUp === void 0 ? false : _ref$isComponentDidUp;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var eventObj = isInternational ? {
    key: 'EVENTS',
    value: eventId
  } : {
    key: "CRUSADE:".concat(eventId),
    value: 'EVENT'
  };
  useEffect(function () {
    if (eventId && isComponentDidUpdate) {
      var _values$collector$ent;
      var newCodes = (_values$collector$ent = values.collector.entity[0].code) === null || _values$collector$ent === void 0 ? void 0 : _values$collector$ent.filter(function (code) {
        return code.key !== 'EVENTS';
      });
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(newCodes), [eventObj]));
    }
  }, [eventId, isComponentDidUpdate]);
  useEffect(function () {
    if (eventId) {
      var _values$collector, _values$collector$ent2, _values$collector2, _values$collector2$en, _values$collector2$en2;
      var resetArr = values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent2 = _values$collector.entity[0]) !== null && _values$collector$ent2 !== void 0 && _values$collector$ent2.code ? values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.code) === null || _values$collector2$en2 === void 0 ? void 0 : _values$collector2$en2.slice() : [];
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), [eventObj]));
    }
  }, []);
  return {
    values: values
  };
};

var _excluded$R = ["values"],
  _excluded2$1 = ["values", "setLanguage", "setFieldValue"],
  _excluded3$1 = ["setFieldValue"];
var handleEmailLogic = function handleEmailLogic(_ref) {
  var _values$formLogic, _values$formLogic2;
  var values = _ref.values,
    setFieldValue = _ref.setFieldValue;
  if ((values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.languageSelector) === DDCLANG.ES.toLowerCase()) {
    setFieldValue("collector.entity[0].email[0].emailSubscription", [{
      esubCode: 'BGESP',
      isActive: true
    }]);
  } else if ((values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.languageSelector) === DDCLANG.EN.toLowerCase()) {
    setFieldValue("collector.entity[0].email[0].emailSubscription", [{
      esubCode: 'DTRALL',
      isActive: true
    }, {
      esubCode: 'BGEA',
      isActive: true
    }]);
  }
};
var validateFields$1 = function validateFields(_ref2) {
  var _values$collector$ent, _values$collector$ent2, _values$collector$ent3, _values$collector$ent4, _values$formLogic$cit;
  var values = _ref2.values,
    props = _objectWithoutProperties(_ref2, _excluded$R);
  var noAddress = values.formLogic.noAddress;
  var noEmail = values.formLogic.noEmail;
  var isValid = ((_values$collector$ent = values.collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.firstName) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.length) > 0 && ((_values$collector$ent3 = values.collector.entity[0]) === null || _values$collector$ent3 === void 0 ? void 0 : (_values$collector$ent4 = _values$collector$ent3.lastName) === null || _values$collector$ent4 === void 0 ? void 0 : _values$collector$ent4.length) > 0 && ((_values$formLogic$cit = values.formLogic.cityListDropdown) === null || _values$formLogic$cit === void 0 ? void 0 : _values$formLogic$cit.length) > 0;
  if (!noAddress) {
    var _values$collector$ent5, _values$collector$ent6, _values$collector$ent7, _values$collector$ent8, _values$collector$ent9, _values$collector$ent10, _values$collector$ent11, _values$collector$ent12;
    isValid = isValid && ((_values$collector$ent5 = values.collector.entity[0].address[0].street) === null || _values$collector$ent5 === void 0 ? void 0 : _values$collector$ent5.length) > 0 && ((_values$collector$ent6 = values.collector.entity[0].address[0].cityTownRegion) === null || _values$collector$ent6 === void 0 ? void 0 : _values$collector$ent6.length) > 0 && ((_values$collector$ent7 = values.collector.entity[0]) === null || _values$collector$ent7 === void 0 ? void 0 : (_values$collector$ent8 = _values$collector$ent7.address[0]) === null || _values$collector$ent8 === void 0 ? void 0 : (_values$collector$ent9 = _values$collector$ent8.stateProvince) === null || _values$collector$ent9 === void 0 ? void 0 : _values$collector$ent9.length) > 0 && ((_values$collector$ent10 = values.collector.entity[0]) === null || _values$collector$ent10 === void 0 ? void 0 : (_values$collector$ent11 = _values$collector$ent10.address[0]) === null || _values$collector$ent11 === void 0 ? void 0 : (_values$collector$ent12 = _values$collector$ent11.zipPostalCode) === null || _values$collector$ent12 === void 0 ? void 0 : _values$collector$ent12.length) > 0;
  }
  if (!noEmail) {
    var _values$collector$ent13, _values$collector$ent14, _values$collector$ent15;
    isValid = isValid && ((_values$collector$ent13 = values.collector.entity[0]) === null || _values$collector$ent13 === void 0 ? void 0 : (_values$collector$ent14 = _values$collector$ent13.email[0]) === null || _values$collector$ent14 === void 0 ? void 0 : (_values$collector$ent15 = _values$collector$ent14.emailAddress) === null || _values$collector$ent15 === void 0 ? void 0 : _values$collector$ent15.length) > 0;
  }
  if (props !== null && props !== void 0 && props.show18Checkbox) {
    var _values$collector$ent16;
    isValid = isValid && ((_values$collector$ent16 = values.collector.entity[0]) === null || _values$collector$ent16 === void 0 ? void 0 : _values$collector$ent16.over18);
  }
  return isValid;
};
var handleNoAddressLogic = function handleNoAddressLogic(_ref3) {
  var values = _ref3.values,
    setFieldValue = _ref3.setFieldValue;
  if (values.formLogic && values.formLogic.noAddress) {
    if (values.formLogic.noAddress && values.collector && values.collector.entity && values.collector.entity[0] && values.collector.entity[0].address) {
      setFieldValue('collector.entity[0].address', []);
    }
  } else {
    values.collector && values.collector.entity && values.collector.entity[0] && values.collector.entity[0].address && setFieldValue('collector.entity[0].address[0]', {
      addressType: 'MAIL',
      country: 'US'
    });
  }
};
var handleCityListDropdown = function handleCityListDropdown(_ref4) {
  var _values$formLogic3;
  var values = _ref4.values,
    setFieldValue = _ref4.setFieldValue;
  if (values !== null && values !== void 0 && (_values$formLogic3 = values.formLogic) !== null && _values$formLogic3 !== void 0 && _values$formLogic3.cityListDropdown) {
    var _values$collector, _values$collector$ent17, _values$collector2, _values$collector2$en, _values$collector2$en2, _values$collector2$en3, _values$formLogic4;
    var resetArr = values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent17 = _values$collector.entity[0]) !== null && _values$collector$ent17 !== void 0 && _values$collector$ent17.code ? values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.code) === null || _values$collector2$en2 === void 0 ? void 0 : (_values$collector2$en3 = _values$collector2$en2.slice()) === null || _values$collector2$en3 === void 0 ? void 0 : _values$collector2$en3.filter(function (item) {
      return item.key !== 'DTR';
    }) : [];
    setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), [{
      key: 'DTR',
      value: values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.cityListDropdown
    }]));
  }
};
var handleLanguageSelector = function handleLanguageSelector(_ref5) {
  var _values$formLogic5;
  var values = _ref5.values,
    setLanguage = _ref5.setLanguage,
    setFieldValue = _ref5.setFieldValue,
    props = _objectWithoutProperties(_ref5, _excluded2$1);
  if (values !== null && values !== void 0 && (_values$formLogic5 = values.formLogic) !== null && _values$formLogic5 !== void 0 && _values$formLogic5.languageSelector) {
    var _values$formLogic6, _values$formLogic7;
    setLanguage(values === null || values === void 0 ? void 0 : (_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : _values$formLogic6.languageSelector);
    handleEmailLogic({
      values: values,
      setFieldValue: setFieldValue
    });
    if ((values === null || values === void 0 ? void 0 : (_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : _values$formLogic7.languageSelector) !== DDCLANG.ES.toLowerCase()) {
      setFieldValue('formLogic.customConfirmation', props === null || props === void 0 ? void 0 : props.englishCustomConfirmation);
    } else {
      setFieldValue('formLogic.customConfirmation', props === null || props === void 0 ? void 0 : props.spanishCustomConfirmation);
    }
  }
};
var handleInitialState$1 = function handleInitialState(_ref6) {
  var setFieldValue = _ref6.setFieldValue,
    props = _objectWithoutProperties(_ref6, _excluded3$1);
  if (props !== null && props !== void 0 && props.showNoAddressCheckbox) {
    setFieldValue('formLogic.noAddress', false);
  }
  if (props !== null && props !== void 0 && props.showNoEmailCheckbox) {
    setFieldValue('formLogic.noEmail', false);
  }
  setFieldValue('formLogic.cityListDropdown', '');
  if (props !== null && props !== void 0 && props.show18Checkbox) {
    setFieldValue("collector.entity[0].over18", (props === null || props === void 0 ? void 0 : props.isChecked) || false);
  }
};

var useFreeTShirt = function useFreeTShirt(_ref) {
  var _values$formLogic, _values$formLogic2, _values$formLogic3, _values$formLogic5;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values,
    isValid = _useFormikContext.isValid,
    validateForm = _useFormikContext.validateForm;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormValid = _useState2[0],
    setIsFormValid = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    language = _useState4[0],
    setLanguage = _useState4[1];
  useTranslationHelper();
  useLanguage({
    isInternational: false,
    lng: language,
    disableDdcLangCode: language === DDCLANG.EN.toLowerCase()
  });
  var checkBoxText = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.languageSelector) !== DDCLANG.ES.toLowerCase() ? '*Must be 18 or older to sign-up' : '*Debes ser mayor de 18 años para registrarte';
  var supplyText = (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.languageSelector) !== DDCLANG.ES.toLowerCase() ? '*While Supplies last' : '*Hasta agotar existencias';
  var privacyPolicyCopy = (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.languageSelector) !== DDCLANG.ES.toLowerCase() ? '*When you complete the form, we will also send you regular updates on the work God is doing around the world through friends like you and the Billy Graham Evangelistic Association. <a href="https://billygraham.org/privacy-policy/">View our full Privacy Policy.</a>' : '*Cuando completes el formulario, también te enviaremos actualizaciones periódicas sobre lo que Dios está haciendo en todo el mundo a través de amigos como tú y de la Billy Graham Evangelistic Association. Consulta nuestra <a href="https://es.billygraham.org/privacidad/">política de privacidad</a>.';
  useEffect(function () {
    if (values.formLogic && values.formLogic.noEmail && values.collector && values.collector.entity && values.collector.entity[0].email) {
      delete values.collector.entity[0].email;
    } else if (!values.formLogic.noEmail) {
      handleEmailLogic({
        values: values,
        setFieldValue: setFieldValue
      });
    }
  }, [values.formLogic]);
  useEffect(function () {
    handleNoAddressLogic({
      values: values,
      setFieldValue: setFieldValue
    });
  }, [values.formLogic.noAddress]);
  useEffect(function () {
    handleCityListDropdown({
      values: values,
      setFieldValue: setFieldValue
    });
  }, [values.formLogic.cityListDropdown]);
  useEffect(function () {
    var _values$formLogic4;
    handleLanguageSelector(_objectSpread2({
      values: values,
      setLanguage: setLanguage,
      setFieldValue: setFieldValue
    }, props));
    if ((values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.languageSelector) === DDCLANG.EN.toLowerCase()) {
      var _values$collector, _values$collector$ent, _values$collector2, _values$collector2$en, _values$collector2$en2, _values$collector2$en3;
      var resetArr = values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent = _values$collector.entity[0]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.code ? values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.code) === null || _values$collector2$en2 === void 0 ? void 0 : (_values$collector2$en3 = _values$collector2$en2.slice()) === null || _values$collector2$en3 === void 0 ? void 0 : _values$collector2$en3.filter(function (item) {
        return item.key !== 'DDCLANG';
      }) : [];
      setFieldValue("collector.entity[0].code", _toConsumableArray(resetArr));
    }
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : _values$formLogic5.languageSelector]);
  useEffect(function () {
    if (validateFields$1(_objectSpread2({
      values: values
    }, props))) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [values.collector.entity]);
  useEffect(function () {
    validateForm();
  }, [isFormValid]);
  useEffect(function () {
    handleInitialState$1(_objectSpread2({
      setFieldValue: setFieldValue
    }, props));
  }, []);
  return {
    checkBoxText: checkBoxText,
    isDisabled: !isValid,
    language: language,
    privacyPolicyCopy: privacyPolicyCopy,
    supplyText: supplyText,
    values: values
  };
};

var setConfirmationForm = function setConfirmationForm(confirmationRef, confirmationChoiceEvent, enableMonthlyModal, eventAction, handleScrollIntoView, isDonation, isMonthlyUserChoice, isQualifyingGift, isRecurring, isSelectForAskGift, totalAmount, trackEvent, values, trackDonationFunnel) {
  var _values$collector, _values$formLogic, _values$formLogic$par, _values$formLogic2, _values$formLogic3;
  if (confirmationRef !== null && confirmationRef !== void 0 && confirmationRef.current) {
    handleScrollIntoView();
  }
  trackEvent('bgform', {
    formCategory: (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : _values$collector.formID,
    formAction: eventAction,
    formLabel: (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.documentLocationHref) || document.location.href,
    formValue: isDonation && totalAmount ? totalAmount : 1
  });
  if (enableMonthlyModal) {
    confirmationChoiceEvent({
      qualifyingGift: isQualifyingGift,
      selectedForAsk: isSelectForAskGift,
      amount: totalAmount,
      confirmed: 'Y',
      recurring: isRecurring,
      userChoice: isMonthlyUserChoice
    });
  }
  if (isDonation) {
    trackDonationFunnel({
      donationConfirmed: 'Y',
      values: values
    });
  }
  if (values !== null && values !== void 0 && (_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && _values$formLogic2.formSubmitConfirmationCallback && typeof (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.formSubmitConfirmationCallback) === 'function') {
    var _values$formLogic4;
    (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.formSubmitConfirmationCallback();
  }
};

var useFormConfirmation = function useFormConfirmation(_ref) {
  var _values$collector, _values$collector$car, _values$collector$car2, _values$collector$car3, _values$collector2, _values$collector2$ca, _values$collector2$ca2, _values$formLogic, _values$formLogic2, _values$formLogic3, _values$formLogic4, _values$formLogic5, _values$formLogic6;
  var isDonation = _ref.isDonation;
  var confirmationRef = useRef(null);
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var hasMonthly = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.donation) === null || _values$collector$car2 === void 0 ? void 0 : (_values$collector$car3 = _values$collector$car2.projects) === null || _values$collector$car3 === void 0 ? void 0 : _values$collector$car3.some(function (prj) {
    return prj === null || prj === void 0 ? void 0 : prj.recurringDate;
  });
  var total = values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$ca = _values$collector2.cart) === null || _values$collector2$ca === void 0 ? void 0 : (_values$collector2$ca2 = _values$collector2$ca.cartTotals) === null || _values$collector2$ca2 === void 0 ? void 0 : _values$collector2$ca2.subTotal;
  var enableMonthlyModal = values.formLogic.enableMonthlyModal;
  var donationEvent = hasMonthly ? Analytics.MONTHLY_DONATION_CONFIRMATION : Analytics.DONATION_CONFIRMATION;
  var totalAmount;
  var isRecurring = hasMonthly ? 'Y' : 'N';
  var isMonthlyUserChoice = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.isMonthlyUserChoice;
  var isQualifyingGift = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.isQualifyingGift;
  var isSelectForAskGift = values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.isSelectForAskGift;
  if (!(values !== null && values !== void 0 && (_values$formLogic4 = values.formLogic) !== null && _values$formLogic4 !== void 0 && _values$formLogic4.isMonthlyUserChoice)) {
    isMonthlyUserChoice = null;
  }
  if (!(values !== null && values !== void 0 && (_values$formLogic5 = values.formLogic) !== null && _values$formLogic5 !== void 0 && _values$formLogic5.isQualifyingGift)) {
    isQualifyingGift = null;
  }
  if (!(values !== null && values !== void 0 && (_values$formLogic6 = values.formLogic) !== null && _values$formLogic6 !== void 0 && _values$formLogic6.isSelectForAskGift)) {
    isSelectForAskGift = null;
  }
  if (total && typeof total === 'number') {
    totalAmount = Number(total.toFixed(2));
  }
  var eventAction = isDonation ? donationEvent : Analytics.LEAD_CONFIRMATION;
  var handleScrollIntoView = function handleScrollIntoView() {
    var _confirmationRef$curr, _confirmationRef$curr2, _values$formLogic7;
    window.scrollTo(0, 0); // Match existing UX on Production, scroll to the top then to the element.
    window.scrollTo({
      top: (confirmationRef === null || confirmationRef === void 0 ? void 0 : (_confirmationRef$curr = confirmationRef.current) === null || _confirmationRef$curr === void 0 ? void 0 : (_confirmationRef$curr2 = _confirmationRef$curr.getBoundingClientRect()) === null || _confirmationRef$curr2 === void 0 ? void 0 : _confirmationRef$curr2.top) || 0,
      behavior: 'smooth'
    });
    if (values !== null && values !== void 0 && (_values$formLogic7 = values.formLogic) !== null && _values$formLogic7 !== void 0 && _values$formLogic7.isEmbedSite) {
      var postObject = JSON.stringify({
        scrollToTop: true
      });
      window.top.postMessage(postObject, '*');
    }
  };
  useEffect(function () {
    setConfirmationForm(confirmationRef, confirmationChoiceEvent, enableMonthlyModal, eventAction, handleScrollIntoView, isDonation, isMonthlyUserChoice, isQualifyingGift, isRecurring, isSelectForAskGift, totalAmount, trackEvent, values, trackDonationFunnel);
  }, []);
  return {
    confirmationRef: confirmationRef,
    values: values
  };
};

var eventWhiteList = ['formLoaded'];
function eventPublish(eventName, data) {
  if (eventWhiteList.includes(eventName)) {
    var event = new CustomEvent(eventName, {
      detail: data
    });
    document.dispatchEvent(event);
  }
}

var _excluded$Q = ["status", "setFieldValue"];
var pkg = require('../../package.json');
var getPageComponent = function getPageComponent(_ref) {
  var status = _ref.status,
    props = _objectWithoutProperties(_ref, _excluded$Q);
  var children = props.children,
    _props$isMultiForm = props.isMultiForm,
    isMultiForm = _props$isMultiForm === void 0 ? false : _props$isMultiForm,
    Confirmation = props.Confirmation;
  var FormComponent = props === null || props === void 0 ? void 0 : props.FormComponent;
  var useRecaptcha = true;
  var PageComponent = children;
  if (status === 'Submitted' && isMultiForm && FormComponent) {
    useRecaptcha = true;
    PageComponent = jsx(FormComponent, _objectSpread2({}, props));
  } else if (status === 'Submitted') {
    PageComponent = jsx(Confirmation, {});
    useRecaptcha = false;
  }
  return {
    PageComponent: PageComponent,
    useRecaptcha: useRecaptcha
  };
};
var useFormTemplateInfo = function useFormTemplateInfo(_ref2) {
  var _values$formLogic, _props$parentDocument;
  var props = _extends({}, (_objectDestructuringEmpty(_ref2), _ref2));
  useGetSession();
  var ping = useGetPing();
  var errRef = useRef(null);
  var packageVersion = pkg.version;
  var pkgVersion = packageVersion || "1.0.679" || '0.0.0'; // Generated via rollupjs at build time
  var _useFormikContext = useFormikContext(),
    status = _useFormikContext.status,
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue,
    setStatus = _useFormikContext.setStatus;
  var token = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.token) || '';
  var loggingHandler = useCreateLogging({
    key: token,
    values: values
  });
  var site = getSiteUrl(props === null || props === void 0 ? void 0 : (_props$parentDocument = props.parentDocumentInfo) === null || _props$parentDocument === void 0 ? void 0 : _props$parentDocument.documentLocationHref);
  var logging = /*#__PURE__*/function () {
    var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(payload) {
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", loggingHandler.createLogging(payload));
          case 1:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function logging(_x) {
      return _ref3.apply(this, arguments);
    };
  }();
  var renderPages = ['BluefinEncrypting', 'BluefinIframeFailure', 'BluefinIframeInvalid', 'BluefinIframeSuccess', 'Loaded'].indexOf(status) >= 0;
  var renderFloodControlledErrorScreen = status === 'FloodControlled';
  var renderErrorScreen = ['SchemaUnprocessable',
  // "PaymentUnprocessable",
  'VogonUnprocessable', 'LogicUnprocessable', 'OnlineTrainingUnprocessable', 'Unprocessable'].indexOf(status) >= 0;
  var showPaymentErrorScreen = status === 'PaymentUnprocessable';
  var showLogicErrorScreen = !!(status !== null && status !== void 0 && status.hasErrorInfo && status !== null && status !== void 0 && status.message) || status === 'LogicUnprocessable';
  var showFormErrorScreen = renderErrorScreen || renderFloodControlledErrorScreen || showPaymentErrorScreen || showLogicErrorScreen;
  var errorMessage = getErrorMessage({
    status: status
  });
  var _getPageComponent = getPageComponent(_objectSpread2({
      status: status,
      setFieldValue: setFieldValue
    }, props)),
    PageComponent = _getPageComponent.PageComponent;
  useEffect(function () {
    if (ping.isSuccess && (ping === null || ping === void 0 ? void 0 : ping.status) === VogonStatus.Success) {
      var _props$parentDocument2;
      var currentdate = new Date();
      setFieldValue('formLogic.formLoadDateInfo', " ".concat(currentdate.getMonth() + 1, "-").concat(currentdate === null || currentdate === void 0 ? void 0 : currentdate.getDate(), "-").concat(currentdate.getFullYear(), " @ ").concat(currentdate.getHours(), ":").concat(currentdate.getMinutes(), ":").concat(currentdate.getSeconds(), " template version: @bgea-js/form-templates:").concat(pkgVersion), false);
      setStatus('Loaded');
      var eventData = {
        formCategory: "@bgea-js/form-templates:".concat(pkgVersion, "/").concat(props === null || props === void 0 ? void 0 : props.templateName),
        formAction: 'FormLoaded',
        formLabel: (props === null || props === void 0 ? void 0 : (_props$parentDocument2 = props.parentDocumentInfo) === null || _props$parentDocument2 === void 0 ? void 0 : _props$parentDocument2.documentLocationHref) || document.location.href,
        formValue: 1
      };
      trackEvent(Analytics.FORM_LOAD, eventData);
      eventPublish('formLoaded', eventData);
    }
  }, [ping.isSuccess]);
  useEffect(function () {
    if (ping.isError) {
      var _props$parentDocument3;
      setStatus('ServerOffline');
      trackEvent(Analytics.FORM_LOAD_ERROR, {
        formCategory: values.collector.formID,
        formAction: 'FormLoadedError',
        formLabel: (props === null || props === void 0 ? void 0 : (_props$parentDocument3 = props.parentDocumentInfo) === null || _props$parentDocument3 === void 0 ? void 0 : _props$parentDocument3.documentLocationHref) || document.location.href,
        formValue: 1
      });
    }
  }, [ping.isError]);
  useEffect(function () {
    if (showFormErrorScreen) {
      var _errRef$current, _errRef$current$getBo;
      logging({
        log: JSON.stringify({
          values: values,
          error: status,
          description: 'BGEA-JS Form Errors - Submission'
        }),
        type: 'error',
        referrer: site
      });
      setFieldValue('formLogic.showFormErrorScreen', showFormErrorScreen, false);
      window.scrollTo(0, 0);
      window.scrollTo({
        top: (errRef === null || errRef === void 0 ? void 0 : (_errRef$current = errRef.current) === null || _errRef$current === void 0 ? void 0 : (_errRef$current$getBo = _errRef$current.getBoundingClientRect()) === null || _errRef$current$getBo === void 0 ? void 0 : _errRef$current$getBo.top) || 0,
        behavior: 'smooth'
      });
    }
  }, [showFormErrorScreen]);
  useEffect(function () {
    var locales = (props === null || props === void 0 ? void 0 : props.locales) || 'en-US';
    if (props !== null && props !== void 0 && props.formName) {
      setFieldValue('formLogic.formName', props === null || props === void 0 ? void 0 : props.formName);
    }
    if (props !== null && props !== void 0 && props.donationFormName) {
      setFieldValue('formLogic.donationFormName', props === null || props === void 0 ? void 0 : props.donationFormName);
    }
    if (props !== null && props !== void 0 && props.parentDocumentInfo) {
      setFieldValue('formLogic.parentDocumentInfo', props === null || props === void 0 ? void 0 : props.parentDocumentInfo);
    }
    if (props !== null && props !== void 0 && props.templateName) {
      setFieldValue('formLogic.templateName', props === null || props === void 0 ? void 0 : props.templateName);
    }
    if (props !== null && props !== void 0 && props.formSubmitConfirmationCallback) {
      setFieldValue('formLogic.formSubmitConfirmationCallback', props === null || props === void 0 ? void 0 : props.formSubmitConfirmationCallback);
    }
    if (props !== null && props !== void 0 && props.isEmbedSite) {
      setFieldValue('formLogic.isEmbedSite', props === null || props === void 0 ? void 0 : props.isEmbedSite);
    }
    if (props !== null && props !== void 0 && props.locales) {
      setFieldValue('formLogic.locales', locales);
    }
    setFieldValue('formLogic.pkgVersion', pkgVersion);
  }, []);
  return {
    errorMessage: errorMessage,
    errRef: errRef,
    pingStatus: ping === null || ping === void 0 ? void 0 : ping.status,
    renderErrorScreen: renderErrorScreen,
    renderPages: renderPages,
    showFloodControlledError: renderFloodControlledErrorScreen,
    showFormErrorScreen: showFormErrorScreen,
    PageComponent: PageComponent
  };
};

var communicationPastorType = CommunicationType.Pastorname;
var ddcLangExcludeList = ['Others'];

var _excluded$P = ["isSeniorPastorSelected", "values", "setFieldValue", "templateName", "numGroupType", "transportType"],
  _excluded2 = ["values", "setShowDenominationInput"],
  _excluded3 = ["values", "setFieldValue"],
  _excluded4 = ["values", "setFieldValue"],
  _excluded5 = ["values", "setFieldValue"];
var setDefaultValues = function setDefaultValues(_ref) {
  var _props$eventDate, _props$displayList, _props$displayList2, _props$displayList3, _props$socialMediaInp, _props$cityEventOptio, _props$denominationOp, _props$churchMinister;
  var isSeniorPastorSelected = _ref.isSeniorPastorSelected,
    values = _ref.values,
    setFieldValue = _ref.setFieldValue,
    templateName = _ref.templateName,
    numGroupType = _ref.numGroupType,
    transportType = _ref.transportType,
    props = _objectWithoutProperties(_ref, _excluded$P);
  var template = templateName === Templates.GET_INVOLVED ? "volunteer_".concat(Templates.GET_INVOLVED) : templateName;
  setFormId({
    templateName: template,
    values: values,
    setFieldValue: setFieldValue
  });
  if ((props === null || props === void 0 ? void 0 : (_props$eventDate = props.eventDate) === null || _props$eventDate === void 0 ? void 0 : _props$eventDate.length) > 1) {
    setFieldValue('formLogic.eventDate', '');
  }
  if (numGroupType) {
    setFieldValue("formLogic.".concat(numGroupType), '');
  }
  if (transportType) {
    setFieldValue("formLogic.".concat(transportType), '');
  }
  if ((props === null || props === void 0 ? void 0 : (_props$displayList = props.displayList) === null || _props$displayList === void 0 ? void 0 : _props$displayList.length) > 0 && props !== null && props !== void 0 && (_props$displayList2 = props.displayList) !== null && _props$displayList2 !== void 0 && _props$displayList2.includes('Phone') && props !== null && props !== void 0 && (_props$displayList3 = props.displayList) !== null && _props$displayList3 !== void 0 && _props$displayList3.includes('MobilePhone')) {
    setFieldValue('collector.entity[0].phone[1].phoneNumber', '');
  }
  if ((props === null || props === void 0 ? void 0 : (_props$socialMediaInp = props.socialMediaInputs) === null || _props$socialMediaInp === void 0 ? void 0 : _props$socialMediaInp.length) > 0) {
    var _props$socialMediaInp2;
    props === null || props === void 0 ? void 0 : (_props$socialMediaInp2 = props.socialMediaInputs) === null || _props$socialMediaInp2 === void 0 ? void 0 : _props$socialMediaInp2.forEach(function (social, idx) {
      setFieldValue("collector.entity[0].social[".concat(idx, "].socialMediaType"), social.socialMediaType, false);
    });
  }
  if ((props === null || props === void 0 ? void 0 : (_props$cityEventOptio = props.cityEventOptions) === null || _props$cityEventOptio === void 0 ? void 0 : _props$cityEventOptio.length) > 0) {
    setFieldValue('formLogic.cityEvent', '');
  }
  if (props !== null && props !== void 0 && props.showGenderOptons) {
    setFieldValue('collector.entity[0].gender', '');
    setFieldValue('formLogic.pastorInfo.gender', '');
  }
  if ((props === null || props === void 0 ? void 0 : (_props$denominationOp = props.denominationOptions) === null || _props$denominationOp === void 0 ? void 0 : _props$denominationOp.length) > 0) {
    setFieldValue('formLogic.denomination', '');
  }
  if (props !== null && props !== void 0 && props.showPastorSection && !isSeniorPastorSelected) {
    setFieldValue('formLogic.pastorInfo.firstName', '');
    setFieldValue('formLogic.pastorInfo.lastName', '');
  }
  if ((props === null || props === void 0 ? void 0 : (_props$churchMinister = props.churchMinistersOptions) === null || _props$churchMinister === void 0 ? void 0 : _props$churchMinister.length) > 0) {
    setFieldValue('formLogic.churchLanguage', '');
  }
  if (props !== null && props !== void 0 && props.isPrefixRequired) {
    setFieldValue("formLogic.isPrefixRequired", props === null || props === void 0 ? void 0 : props.isPrefixRequired);
    setFieldValue("collector.entity[0].prefix", '');
  }
  if (props !== null && props !== void 0 && props.isMiddleNameRequired) {
    setFieldValue("formLogic.isMiddleNameRequired", props === null || props === void 0 ? void 0 : props.isMiddleNameRequired);
    setFieldValue("collector.entity[0].middleName", '');
  }
  if (props !== null && props !== void 0 && props.showOrgRole) {
    setFieldValue("collector.entity[1].orgs.role", '');
  }
  setFieldValue('collector.entity[1].address[0].zipPostalCode', '');
};
var setCodes = function setCodes(attr, values, setFieldValue) {
  var _values$collector, _values$collector$ent;
  var codes = (values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : _values$collector$ent.code) || [];
  if ((codes === null || codes === void 0 ? void 0 : codes.length) > 0) {
    var newCodes = !Array.isArray(attr) ? codes === null || codes === void 0 ? void 0 : codes.filter(function (code) {
      return code.value !== attr;
    }) : codes === null || codes === void 0 ? void 0 : codes.filter(function (code) {
      return !attr.includes(code.value);
    });
    setFieldValue("collector.entity[0].code", newCodes);
    return newCodes;
  }
  return codes;
};
var handleChurchLanguage = function handleChurchLanguage(churchLanguage, values, setFieldValue) {
  if (churchLanguage) {
    var _values$collector$ent2;
    var newChurchCodes = (_values$collector$ent2 = values.collector.entity[1].code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.filter(function (code) {
      return code.key !== 'A01c:DDCLANG';
    });
    setFieldValue("collector.entity[1].code", [].concat(_toConsumableArray(newChurchCodes), _toConsumableArray(!ddcLangExcludeList.includes(churchLanguage) ? [{
      key: 'A01c:DDCLANG',
      value: churchLanguage
    }] : [])));
  }
};
var handlePrayerHat = function handlePrayerHat(prayerHatAttr, values, setFieldValue) {
  var _values$formLogic, _values$formLogic2;
  if (((_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.prayerHat) === 'yes') {
    setFieldValue('collector.entity[0].code', [].concat(_toConsumableArray(values.collector.entity[0].code), [{
      key: 'ATTRIBUTES',
      value: prayerHatAttr
    }]));
  } else if (((_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.prayerHat) === 'no') {
    setCodes(prayerHatAttr, values, setFieldValue);
  }
};
var handleDenominationInfo = function handleDenominationInfo(_ref2) {
  var _values$formLogic3;
  var values = _ref2.values,
    setShowDenominationInput = _ref2.setShowDenominationInput,
    props = _objectWithoutProperties(_ref2, _excluded2);
  if (props !== null && props !== void 0 && props.denominationOtherId && (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.denomination) === (props === null || props === void 0 ? void 0 : props.denominationOtherId)) {
    setShowDenominationInput(true);
  } else {
    setShowDenominationInput(false);
  }
};
var handlePastorInfo = function handlePastorInfo(_ref3) {
  var _values$collector$com;
  var pastorFirstName = _ref3.pastorFirstName,
    pastorLastName = _ref3.pastorLastName,
    pastorMiddleName = _ref3.pastorMiddleName,
    pastorPrefix = _ref3.pastorPrefix,
    pastorGender = _ref3.pastorGender,
    values = _ref3.values,
    setFieldValue = _ref3.setFieldValue;
  var resetCommArr = ((_values$collector$com = values.collector.communications) === null || _values$collector$com === void 0 ? void 0 : _values$collector$com.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.communicationType) !== communicationPastorType;
  })) || [];
  if ((pastorFirstName === null || pastorFirstName === void 0 ? void 0 : pastorFirstName.length) > 0 && (pastorLastName === null || pastorLastName === void 0 ? void 0 : pastorLastName.length) > 0 && (pastorGender === null || pastorGender === void 0 ? void 0 : pastorGender.length) > 0) {
    setFieldValue('collector.communications', [].concat(_toConsumableArray(resetCommArr), [{
      communicationType: communicationPastorType,
      longComment: "".concat(pastorPrefix, " | ").concat(pastorFirstName, " | ").concat(pastorMiddleName, " | ").concat(pastorLastName, " | ").concat(pastorGender)
    }]));
  }
};
var handleHostClwc = function handleHostClwc(_ref4) {
  var _values$formLogic4;
  var values = _ref4.values,
    setFieldValue = _ref4.setFieldValue;
  if (values !== null && values !== void 0 && (_values$formLogic4 = values.formLogic) !== null && _values$formLogic4 !== void 0 && _values$formLogic4.canHostCLWC) {
    var _values$collector2, _values$collector2$en, _values$collector2$en2, _values$formLogic5;
    var clwcAttr = '693';
    var filteredArr = (values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[1]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.code) === null || _values$collector2$en2 === void 0 ? void 0 : _values$collector2$en2.filter(function (item) {
      return (item === null || item === void 0 ? void 0 : item.value) !== clwcAttr;
    })) || [];
    var codes = [].concat(_toConsumableArray(filteredArr), _toConsumableArray(values !== null && values !== void 0 && (_values$formLogic5 = values.formLogic) !== null && _values$formLogic5 !== void 0 && _values$formLogic5.canHostCLWC ? [{
      key: 'ATTRIBUTES',
      value: clwcAttr
    }] : []));
    setFieldValue("collector.entity[1].code", codes);
  }
};
var handleIAALogic = function handleIAALogic(_ref5) {
  var event = _ref5.event,
    i = _ref5.i,
    props = _ref5.props,
    values = _ref5.values,
    setFieldValue = _ref5.setFieldValue;
  if (event.target.checked) {
    setFieldValue("collector.entity[0].code[".concat(i, "].key"), 'ATTRIBUTES');
    setFieldValue("collector.entity[0].code[".concat(i, "].value"), props === null || props === void 0 ? void 0 : props.iaaAttrValue);
  } else {
    setCodes(props === null || props === void 0 ? void 0 : props.iaaAttrValue, values, setFieldValue);
  }
};
var handleOptInLogicByPhone = function handleOptInLogicByPhone(_ref6) {
  var _props$displayList4;
  var values = _ref6.values,
    setFieldValue = _ref6.setFieldValue,
    props = _objectWithoutProperties(_ref6, _excluded3);
  /* Forms such as UK require to have optin logic but that form does not have an optin checkbox */
  if (props !== null && props !== void 0 && props.optInAttribute && !(props !== null && props !== void 0 && (_props$displayList4 = props.displayList) !== null && _props$displayList4 !== void 0 && _props$displayList4.includes('OptInTextCheckbox'))) {
    var _values$collector3, _values$collector3$en, _values$collector3$en2, _values$collector4, _values$collector4$en, _values$collector4$en2, _values$collector5, _values$collector5$en, _values$collector5$en2, _values$collector5$en3, _values$collector6, _values$collector6$en, _values$collector6$en2, _values$collector6$en3;
    var hasOptInAttrInCodes = values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.code) === null || _values$collector3$en2 === void 0 ? void 0 : _values$collector3$en2.some(function (item) {
      return item.value === (props === null || props === void 0 ? void 0 : props.optInAttribute);
    });
    var resetArr = (values === null || values === void 0 ? void 0 : (_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : (_values$collector4$en = _values$collector4.entity[0]) === null || _values$collector4$en === void 0 ? void 0 : (_values$collector4$en2 = _values$collector4$en.code) === null || _values$collector4$en2 === void 0 ? void 0 : _values$collector4$en2.filter(function (item) {
      return item.value !== (props === null || props === void 0 ? void 0 : props.optInAttribute);
    })) || [];
    if (!hasOptInAttrInCodes && (values === null || values === void 0 ? void 0 : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : (_values$collector5$en = _values$collector5.entity[0]) === null || _values$collector5$en === void 0 ? void 0 : (_values$collector5$en2 = _values$collector5$en.phone[0]) === null || _values$collector5$en2 === void 0 ? void 0 : (_values$collector5$en3 = _values$collector5$en2.phoneNumber) === null || _values$collector5$en3 === void 0 ? void 0 : _values$collector5$en3.length) > 0) {
      setFieldValue('collector.entity[0].code', [].concat(_toConsumableArray(resetArr), [{
        key: 'ATTRIBUTES',
        value: props === null || props === void 0 ? void 0 : props.optInAttribute
      }]), false);
    } else if (hasOptInAttrInCodes && (values === null || values === void 0 ? void 0 : (_values$collector6 = values.collector) === null || _values$collector6 === void 0 ? void 0 : (_values$collector6$en = _values$collector6.entity[0]) === null || _values$collector6$en === void 0 ? void 0 : (_values$collector6$en2 = _values$collector6$en.phone[0]) === null || _values$collector6$en2 === void 0 ? void 0 : (_values$collector6$en3 = _values$collector6$en2.phoneNumber) === null || _values$collector6$en3 === void 0 ? void 0 : _values$collector6$en3.length) === 0) {
      setFieldValue('collector.entity[0].code', _toConsumableArray(resetArr), false);
    }
  }
};
var handleOptInSocialPhoneLogic = function handleOptInSocialPhoneLogic(_ref7) {
  var values = _ref7.values,
    setFieldValue = _ref7.setFieldValue,
    props = _objectWithoutProperties(_ref7, _excluded4);
  /* Ethiopia using this logic */
  if (props !== null && props !== void 0 && props.optInAttribute) {
    var _values$collector7, _values$collector7$en, _values$collector7$en2, _values$collector8, _values$collector8$en, _values$collector8$en2, _values$collector9, _values$collector9$en, _values$collector9$en2, _values$collector10, _values$collector10$e, _values$collector10$e2, _values$collector11, _values$collector11$e, _values$collector11$e2, _values$collector12, _values$collector12$e, _values$collector12$e2;
    var hasOptInAttrInCodes = values === null || values === void 0 ? void 0 : (_values$collector7 = values.collector) === null || _values$collector7 === void 0 ? void 0 : (_values$collector7$en = _values$collector7.entity[0]) === null || _values$collector7$en === void 0 ? void 0 : (_values$collector7$en2 = _values$collector7$en.code) === null || _values$collector7$en2 === void 0 ? void 0 : _values$collector7$en2.some(function (item) {
      return item.value === (props === null || props === void 0 ? void 0 : props.optInAttribute);
    });
    var resetArr = (values === null || values === void 0 ? void 0 : (_values$collector8 = values.collector) === null || _values$collector8 === void 0 ? void 0 : (_values$collector8$en = _values$collector8.entity[0]) === null || _values$collector8$en === void 0 ? void 0 : (_values$collector8$en2 = _values$collector8$en.code) === null || _values$collector8$en2 === void 0 ? void 0 : _values$collector8$en2.filter(function (item) {
      return item.value !== (props === null || props === void 0 ? void 0 : props.optInAttribute);
    })) || [];
    var hasSocialHandle = (values === null || values === void 0 ? void 0 : (_values$collector9 = values.collector) === null || _values$collector9 === void 0 ? void 0 : (_values$collector9$en = _values$collector9.entity[0]) === null || _values$collector9$en === void 0 ? void 0 : (_values$collector9$en2 = _values$collector9$en.social) === null || _values$collector9$en2 === void 0 ? void 0 : _values$collector9$en2.length) > 0;
    var phone = values === null || values === void 0 ? void 0 : (_values$collector10 = values.collector) === null || _values$collector10 === void 0 ? void 0 : (_values$collector10$e = _values$collector10.entity[0]) === null || _values$collector10$e === void 0 ? void 0 : (_values$collector10$e2 = _values$collector10$e.phone[0]) === null || _values$collector10$e2 === void 0 ? void 0 : _values$collector10$e2.phoneNumber;
    var phone1 = values === null || values === void 0 ? void 0 : (_values$collector11 = values.collector) === null || _values$collector11 === void 0 ? void 0 : (_values$collector11$e = _values$collector11.entity[0]) === null || _values$collector11$e === void 0 ? void 0 : (_values$collector11$e2 = _values$collector11$e.phone[1]) === null || _values$collector11$e2 === void 0 ? void 0 : _values$collector11$e2.phoneNumber;
    var socialHandle = hasSocialHandle && (values === null || values === void 0 ? void 0 : (_values$collector12 = values.collector) === null || _values$collector12 === void 0 ? void 0 : (_values$collector12$e = _values$collector12.entity[0]) === null || _values$collector12$e === void 0 ? void 0 : (_values$collector12$e2 = _values$collector12$e.social[0]) === null || _values$collector12$e2 === void 0 ? void 0 : _values$collector12$e2.handle);
    var resetLogic = hasOptInAttrInCodes && hasSocialHandle && (phone === null || phone === void 0 ? void 0 : phone.length) === 0 && (phone1 === null || phone1 === void 0 ? void 0 : phone1.length) === 0 && (socialHandle === null || socialHandle === void 0 ? void 0 : socialHandle.length) === 0 || hasOptInAttrInCodes && (phone === null || phone === void 0 ? void 0 : phone.length) === 0 && (phone1 === null || phone1 === void 0 ? void 0 : phone1.length) === 0;
    if (!hasOptInAttrInCodes && ((phone === null || phone === void 0 ? void 0 : phone.length) > 0 || (phone1 === null || phone1 === void 0 ? void 0 : phone1.length) > 0 || (socialHandle === null || socialHandle === void 0 ? void 0 : socialHandle.length) > 0)) {
      setFieldValue('collector.entity[0].code', [].concat(_toConsumableArray(resetArr), [{
        key: 'ATTRIBUTES',
        value: props === null || props === void 0 ? void 0 : props.optInAttribute
      }]), false);
    } else if (resetLogic) {
      setFieldValue('collector.entity[0].code', _toConsumableArray(resetArr), false);
    }
  }
};
var handleOptInLogic = function handleOptInLogic(_ref8) {
  var values = _ref8.values,
    setFieldValue = _ref8.setFieldValue,
    props = _objectWithoutProperties(_ref8, _excluded5);
  if (props !== null && props !== void 0 && props.optInAttribute) {
    var _values$collector13, _values$collector13$e, _values$collector13$e2, _values$collector14, _values$collector14$e, _values$collector14$e2, _values$collector15, _values$collector15$e, _values$collector15$e2, _values$collector15$e3, _values$formLogic6, _values$formLogic6$te, _values$formLogic7, _values$formLogic7$te;
    var hasOptInAttrInCodes = values === null || values === void 0 ? void 0 : (_values$collector13 = values.collector) === null || _values$collector13 === void 0 ? void 0 : (_values$collector13$e = _values$collector13.entity[0]) === null || _values$collector13$e === void 0 ? void 0 : (_values$collector13$e2 = _values$collector13$e.code) === null || _values$collector13$e2 === void 0 ? void 0 : _values$collector13$e2.some(function (item) {
      return item.value === (props === null || props === void 0 ? void 0 : props.optInAttribute);
    });
    var resetArr = (values === null || values === void 0 ? void 0 : (_values$collector14 = values.collector) === null || _values$collector14 === void 0 ? void 0 : (_values$collector14$e = _values$collector14.entity[0]) === null || _values$collector14$e === void 0 ? void 0 : (_values$collector14$e2 = _values$collector14$e.code) === null || _values$collector14$e2 === void 0 ? void 0 : _values$collector14$e2.filter(function (item) {
      return item.value !== (props === null || props === void 0 ? void 0 : props.optInAttribute);
    })) || [];
    if (!hasOptInAttrInCodes && (values === null || values === void 0 ? void 0 : (_values$collector15 = values.collector) === null || _values$collector15 === void 0 ? void 0 : (_values$collector15$e = _values$collector15.entity[0]) === null || _values$collector15$e === void 0 ? void 0 : (_values$collector15$e2 = _values$collector15$e.phone[0]) === null || _values$collector15$e2 === void 0 ? void 0 : (_values$collector15$e3 = _values$collector15$e2.phoneNumber) === null || _values$collector15$e3 === void 0 ? void 0 : _values$collector15$e3.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : (_values$formLogic6$te = _values$formLogic6.textOptIn) === null || _values$formLogic6$te === void 0 ? void 0 : _values$formLogic6$te.length) > 0) {
      setFieldValue('collector.entity[0].code', [].concat(_toConsumableArray(resetArr), [{
        key: 'ATTRIBUTES',
        value: props === null || props === void 0 ? void 0 : props.optInAttribute
      }]), false);
    } else if (hasOptInAttrInCodes && (values === null || values === void 0 ? void 0 : (_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : (_values$formLogic7$te = _values$formLogic7.textOptIn) === null || _values$formLogic7$te === void 0 ? void 0 : _values$formLogic7$te.length) === 0) {
      setFieldValue('collector.entity[0].code', _toConsumableArray(resetArr), false);
    }
  }
};
var handleAge = function handleAge(_ref9) {
  var _values$formLogic8, _values$collector$ent3;
  var values = _ref9.values,
    setFieldValue = _ref9.setFieldValue;
  var age = values === null || values === void 0 ? void 0 : (_values$formLogic8 = values.formLogic) === null || _values$formLogic8 === void 0 ? void 0 : _values$formLogic8.age;
  var newCodes = (_values$collector$ent3 = values.collector.entity[0].code) === null || _values$collector$ent3 === void 0 ? void 0 : _values$collector$ent3.filter(function (code) {
    return code.key !== 'AGE';
  });
  setFieldValue('collector.entity[0].code', [].concat(_toConsumableArray(newCodes), [{
    key: 'AGE',
    value: "".concat(age)
  }]));
};

var _excluded$O = ["hideAboutYourChurchLabel", "hideUserAddressSection", "showPrefix", "volunteerAttrValue"];
var prayerHatAttr = '2096';
var seniorPastorRole = 'CSP';
var useGetInvolved = function useGetInvolved(_ref) {
  var _values$formLogic, _values$collector, _values$collector$ent, _values$collector$ent2, _values$formLogic2, _values$formLogic2$pa, _values$formLogic3, _values$formLogic3$pa, _values$formLogic4, _values$formLogic4$pa, _values$formLogic5, _values$formLogic5$pa, _values$formLogic6, _values$formLogic6$pa, _values$collector2, _values$collector2$en, _values$collector2$en2, _values$formLogic7, _values$formLogic8, _values$collector3, _values$collector3$en, _values$collector3$en2, _values$formLogic9, _values$collector5, _values$collector6;
  var _ref$hideAboutYourChu = _ref.hideAboutYourChurchLabel,
    hideAboutYourChurchLabel = _ref$hideAboutYourChu === void 0 ? false : _ref$hideAboutYourChu,
    hideUserAddressSection = _ref.hideUserAddressSection,
    showPrefix = _ref.showPrefix,
    volunteerAttrValue = _ref.volunteerAttrValue,
    props = _objectWithoutProperties(_ref, _excluded$O);
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPrayerHatField = _useState2[0],
    setShowPrayerHatField = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showDenominationInput = _useState4[0],
    setShowDenominationInput = _useState4[1];
  var cityEvent = values === null || values === void 0 ? void 0 : values.formLogic.cityEvent;
  var churchLanguage = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.churchLanguage;
  var i = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.length;
  var pastorFirstName = (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$pa = _values$formLogic2.pastorInfo) === null || _values$formLogic2$pa === void 0 ? void 0 : _values$formLogic2$pa.firstName) || '';
  var pastorLastName = (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : (_values$formLogic3$pa = _values$formLogic3.pastorInfo) === null || _values$formLogic3$pa === void 0 ? void 0 : _values$formLogic3$pa.lastName) || '';
  var pastorMiddleName = (values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : (_values$formLogic4$pa = _values$formLogic4.pastorInfo) === null || _values$formLogic4$pa === void 0 ? void 0 : _values$formLogic4$pa.middleName) || '';
  var pastorPrefix = (values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : (_values$formLogic5$pa = _values$formLogic5.pastorInfo) === null || _values$formLogic5$pa === void 0 ? void 0 : _values$formLogic5$pa.prefix) || '';
  var pastorGender = (values === null || values === void 0 ? void 0 : (_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : (_values$formLogic6$pa = _values$formLogic6.pastorInfo) === null || _values$formLogic6$pa === void 0 ? void 0 : _values$formLogic6$pa.gender) || '';
  var isSeniorPastorSelected = (values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[1]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.orgs) === null || _values$collector2$en2 === void 0 ? void 0 : _values$collector2$en2.role) === seniorPastorRole;
  useLogicInfo({
    logicIds: props === null || props === void 0 ? void 0 : props.logicIds
  });
  useEventId({
    eventId: cityEvent,
    isComponentDidUpdate: true,
    isInternational: true
  });
  useChurchInfo(_objectSpread2({
    eventId: cityEvent
  }, props));
  useCode(_objectSpread2({
    eventId: cityEvent
  }, props));
  var visibleList = [].concat(_toConsumableArray(showPrefix ? ['prefix'] : []), ['firstName', 'lastName']);
  var displayList = ['Email', 'Phone'].concat(_toConsumableArray(!hideUserAddressSection ? ['Address'] : []));
  var useOptinSocialPhoneFields = (props === null || props === void 0 ? void 0 : props.useOptinSocialPhoneFields) || false;
  var aboutYouLabel = t('About You', {
    ns: 'labels'
  });
  var aboutYourChurchLabel = !hideAboutYourChurchLabel ? t('About Your Church', {
    ns: 'common'
  }) : '';
  var becomeVolunteerCopy = t('becomeVolunteer', {
    ns: 'common'
  });
  var becomePrayerVolunteerCopy = t('becomePrayerVolunteer', {
    ns: 'common'
  });
  var churchClwcLabel = t('YES, our church is willing to host a Christian Life and Witness class or other future meetings.', {
    ns: 'labels'
  });
  var churchInfoLabel = t("Your Church's Information", {
    ns: 'labels'
  });
  var churchLanguageLabel = t('YES, our church ministers to', {
    ns: 'labels'
  });
  var denominationLabel = t('Denomination', {
    ns: 'labels'
  });
  var eventLabel = t('Which event do you plan to attend?', {
    ns: 'labels'
  });
  var eventVolunteerLabel = t('Become an Event Volunteer', {
    ns: 'common'
  });
  var femaleLabel = t('Female', {
    ns: 'common'
  });
  var interestedVolunteerLabel = t('I am interested in serving as a volunteer', {
    ns: 'labels'
  });
  var pastorNameLabel = t("Pastor's Name", {
    ns: 'common'
  });
  var interestedPrayerVolunteerLabel = t('I am interested in serving on the prayer team', {
    ns: 'labels'
  });
  var interestedPrayerHatLabel = t('Would like a free hat?', {
    ns: 'labels'
  });
  var iaaLabel = t('YES, I commit to being an ANDREW', {
    ns: 'labels'
  });
  var maleLabel = t('Male', {
    ns: 'common'
  });
  var messengerLabel = 'Messenger';
  var privacyPolicyLabel = t('privacyAgreement', {
    ns: 'common',
    interpolation: {
      escapeValue: false
    }
  });
  var otherLabel = t('Other', {
    ns: 'labels'
  });
  var selectOneLabel = t('Select One', {
    ns: 'labels'
  });
  var whatsAppLabel = 'Whats App';
  var handleVolunteer = function handleVolunteer(e) {
    if (e.target.checked) {
      setFieldValue("collector.entity[0].code[".concat(i, "].key"), 'ATTRIBUTES');
      setFieldValue("collector.entity[0].code[".concat(i, "].value"), volunteerAttrValue);
    } else {
      setCodes(volunteerAttrValue, values, setFieldValue);
    }
  };
  var handlePrayerVolunteer = function handlePrayerVolunteer(e) {
    if (e.target.checked) {
      setFieldValue('collector.entity[0].code', [].concat(_toConsumableArray(values.collector.entity[0].code), [{
        key: 'ATTRIBUTES',
        value: props === null || props === void 0 ? void 0 : props.prayerVolunteerAttrValue
      }]));
      setShowPrayerHatField(true);
    } else {
      setCodes(props === null || props === void 0 ? void 0 : props.prayerVolunteerAttrValue, values, setFieldValue);
      setShowPrayerHatField(false);
    }
  };
  var handleIAA = function handleIAA(event) {
    handleIAALogic({
      event: event,
      i: i,
      props: props,
      values: values,
      setFieldValue: setFieldValue
    });
  };
  useEffect(function () {
    handleHostClwc({
      values: values,
      setFieldValue: setFieldValue
    });
  }, [values.formLogic.canHostCLWC]);
  useEffect(function () {
    handlePrayerHat(prayerHatAttr, values, setFieldValue);
  }, [(_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : _values$formLogic7.prayerHat]);
  useEffect(function () {
    handleDenominationInfo(_objectSpread2({
      values: values,
      setShowDenominationInput: setShowDenominationInput
    }, props));
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic8 = values.formLogic) === null || _values$formLogic8 === void 0 ? void 0 : _values$formLogic8.denomination]);
  useEffect(function () {
    /* Note: UK requires this logic */
    if (!useOptinSocialPhoneFields) {
      handleOptInLogicByPhone(_objectSpread2({
        values: values,
        setFieldValue: setFieldValue
      }, props));
    }
  }, [values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.phone[0]) === null || _values$collector3$en2 === void 0 ? void 0 : _values$collector3$en2.phoneNumber]);
  useEffect(function () {
    handleOptInLogic(_objectSpread2({
      values: values,
      setFieldValue: setFieldValue
    }, props));
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic9 = values.formLogic) === null || _values$formLogic9 === void 0 ? void 0 : _values$formLogic9.textOptIn]);
  useEffect(function () {
    var _values$collector4;
    if (useOptinSocialPhoneFields && values !== null && values !== void 0 && (_values$collector4 = values.collector) !== null && _values$collector4 !== void 0 && _values$collector4.entity) {
      handleOptInSocialPhoneLogic(_objectSpread2({
        values: values,
        setFieldValue: setFieldValue
      }, props));
    }
  }, [useOptinSocialPhoneFields, values === null || values === void 0 ? void 0 : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : _values$collector5.entity]);
  useEffect(function () {
    handlePastorInfo({
      pastorFirstName: pastorFirstName,
      pastorLastName: pastorLastName,
      pastorMiddleName: pastorMiddleName,
      pastorPrefix: pastorPrefix,
      pastorGender: pastorGender,
      values: values,
      setFieldValue: setFieldValue
    });
  }, [pastorFirstName, pastorLastName, pastorMiddleName, pastorPrefix, pastorGender]);
  useEffect(function () {
    handleChurchLanguage(churchLanguage, values, setFieldValue);
  }, [churchLanguage]);
  useEffect(function () {
    setDefaultValues(_objectSpread2({
      templateName: Templates.GET_INVOLVED,
      isSeniorPastorSelected: isSeniorPastorSelected,
      values: values,
      setFieldValue: setFieldValue
    }, props));
  }, []);
  values === null || values === void 0 ? true : (_values$collector6 = values.collector) === null || _values$collector6 === void 0 ? true : delete _values$collector6.cart;
  return {
    aboutYouLabel: aboutYouLabel,
    aboutYourChurchLabel: aboutYourChurchLabel,
    becomePrayerVolunteerCopy: becomePrayerVolunteerCopy,
    becomeVolunteerCopy: becomeVolunteerCopy,
    churchClwcLabel: churchClwcLabel,
    churchInfoLabel: churchInfoLabel,
    churchLanguageLabel: churchLanguageLabel,
    denominationLabel: denominationLabel,
    displayList: displayList,
    eventLabel: eventLabel,
    eventVolunteerLabel: eventVolunteerLabel,
    femaleLabel: femaleLabel,
    genderLabel: translations === null || translations === void 0 ? void 0 : translations.genderLabel,
    iaaLabel: iaaLabel,
    interestedPrayerHatLabel: interestedPrayerHatLabel,
    interestedPrayerVolunteerLabel: interestedPrayerVolunteerLabel,
    interestedVolunteerLabel: interestedVolunteerLabel,
    isSeniorPastorSelected: isSeniorPastorSelected,
    maleLabel: maleLabel,
    messengerLabel: messengerLabel,
    otherLabel: otherLabel,
    pastorNameLabel: pastorNameLabel,
    privacyPolicyTextLabel: translations.privacyPolicyLabel,
    privacyPolicyLabel: privacyPolicyLabel,
    roleLabel: translations === null || translations === void 0 ? void 0 : translations.roleLabel,
    showDenominationInput: showDenominationInput,
    selectOneLabel: selectOneLabel,
    showPrayerHatField: showPrayerHatField,
    visibleList: visibleList,
    whatsAppLabel: whatsAppLabel,
    handleIAA: handleIAA,
    handlePrayerVolunteer: handlePrayerVolunteer,
    handleVolunteer: handleVolunteer
  };
};

var useGetStellofyInfo = function useGetStellofyInfo() {
  var _values$formLogic, _values$formLogic$par, _values$formLogic2;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var queryStringDict = getQueryStringDict((values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.formQueryString) || '');
  var stellofyToken = queryStringDict === null || queryStringDict === void 0 ? void 0 : queryStringDict.sfjt;
  var token = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.token;
  var _useState = useState(),
    _useState2 = _slicedToArray(_useState, 2),
    tokenInfo = _useState2[0],
    setTokenInfo = _useState2[1];
  var tokenQuery = useGetStellofyToken({
    key: token,
    stellofyToken: stellofyToken
  }, {
    enabled: !!stellofyToken && !!token
  });
  useEffect(function () {
    if (tokenQuery !== null && tokenQuery !== void 0 && tokenQuery.data) {
      var payload = tokenQuery === null || tokenQuery === void 0 ? void 0 : tokenQuery.data;
      var camelCasedPayload = toCamelCase(payload[0]);
      setTokenInfo(camelCasedPayload);
    }
  }, [tokenQuery === null || tokenQuery === void 0 ? void 0 : tokenQuery.data]);
  return {
    isTokenQueryLoading: tokenQuery.isLoading,
    tokenInfo: tokenInfo
  };
};

var useGroupLeader = function useGroupLeader(_ref) {
  var _values$formLogic, _values$formLogic$ack, _values$formLogic2, _values$formLogic2$ac;
  var languageOptions = _ref.languageOptions;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useTranslationHelper();
  useChurchInfo({
    isGroupLeader: true
  });
  var churchLangOptions = languageOptions === null || languageOptions === void 0 ? void 0 : languageOptions.map(function (lng) {
    return _objectSpread2(_objectSpread2({}, lng), {}, {
      id: "church".concat(lng === null || lng === void 0 ? void 0 : lng.id),
      name: "formLogic.church".concat(lng === null || lng === void 0 ? void 0 : lng.name)
    });
  });
  var visibleList = ['Name', 'Email', 'Address', 'Phone'];
  var isOver18 = values.formLogic.over18;
  var hasChurchInfo = values.formLogic.churchInfo && values.collector.entity[1] && values.collector.entity[1].address;
  var showSubmitButton = ((_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$ack = _values$formLogic.acknowledgement) === null || _values$formLogic$ack === void 0 ? void 0 : _values$formLogic$ack.missionStatement) && ((_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$ac = _values$formLogic2.acknowledgement) === null || _values$formLogic2$ac === void 0 ? void 0 : _values$formLogic2$ac.release);
  var defaultAddressList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'];
  useEffect(function () {
    setFormId({
      templateName: Templates.GROUP_LEADER,
      values: values,
      setFieldValue: setFieldValue
    });
    setFieldValue('formLogic.acknowledgement', {
      missionStatement: false,
      release: false
    }, false);
    setFieldValue('formLogic.templateName', Templates.GROUP_LEADER);
    setFieldValue('collector.entity[0].number[0].key', 'GRPBOOKREG', false);
    setFieldValue('collector.entity[0].note.note', '');
    setFieldValue('collector.entity[0].note.type', 'GRPBOOKREF', false);
    setFieldValue('collector.cart.products[0]', {
      productId: '',
      amount: 0,
      quantity: 1
    });
  }, []);
  return {
    churchLangOptions: churchLangOptions,
    defaultAddressList: defaultAddressList,
    isOver18: isOver18,
    hasChurchInfo: hasChurchInfo,
    showSubmitButton: showSubmitButton,
    values: values,
    visibleList: visibleList
  };
};

var useCitiesRolesGroupMemberSelector = function useCitiesRolesGroupMemberSelector(_ref) {
  var cities = _ref.cities,
    cityId = _ref.cityId;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useEffect(function () {
    if (cityId) {
      var _values$collector, _values$collector$ent, _values$collector$ent2;
      var cityEvent = Object.values(cities).find(function (item) {
        return (item === null || item === void 0 ? void 0 : item.crusadeCodeEventId) === cityId;
      });
      var resetCodes = (values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.slice()) || [];
      var codes = [{
        key: "CRUSADE:".concat(cityId),
        value: 'EVENT'
      }, {
        key: "CRUSADE:".concat(cityId),
        value: '1300'
      }, {
        key: "CRUSADE:".concat(cityId),
        value: '1302'
      }, {
        key: "CRUSADE:".concat(cityId),
        value: '1416'
      }].concat(_toConsumableArray(cityEvent !== null && cityEvent !== void 0 && cityEvent.SECodeEventId ? [{
        key: "DTR",
        value: "".concat(cityEvent === null || cityEvent === void 0 ? void 0 : cityEvent.SECodeEventId, "VD024")
      }] : []), _toConsumableArray(cityEvent !== null && cityEvent !== void 0 && cityEvent.SECodeEventId ? [{
        key: "DTR",
        value: "".concat(cityEvent === null || cityEvent === void 0 ? void 0 : cityEvent.SECodeEventId, "VD124")
      }] : []), _toConsumableArray(cityEvent !== null && cityEvent !== void 0 && cityEvent.SECodeEventId ? [{
        key: "DTR",
        value: "".concat(cityEvent === null || cityEvent === void 0 ? void 0 : cityEvent.SECodeEventId, "VM124")
      }] : []));
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetCodes), _toConsumableArray(codes)));
    }
  }, [cityId]);
  return {
    cityId: cityId,
    values: values
  };
};

var useGroupMember = function useGroupMember(_ref) {
  var _values$formLogic, _values$formLogic$par, _values$formLogic2, _values$formLogic2$ac, _values$formLogic3, _values$formLogic3$ac;
  var cities = _ref.cities,
    cityMap = _ref.cityMap;
  useTranslationHelper();
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var queryProjectDict = getQueryStringDict((values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.formQueryString) || '');
  var groupName = queryProjectDict === null || queryProjectDict === void 0 ? void 0 : queryProjectDict.GRP;
  var leaderId = queryProjectDict === null || queryProjectDict === void 0 ? void 0 : queryProjectDict.LID;
  var cityId = groupName ? parseInt(groupName === null || groupName === void 0 ? void 0 : groupName.substring(6), 10) : 0;
  var selectedCity = cityId && cityMap ? cityMap[cityId] : '';
  var isUnder18 = values.formLogic.over18 === 'no'; // ignore empty string
  var showSubmitButton = ((_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$ac = _values$formLogic2.acknowledgement) === null || _values$formLogic2$ac === void 0 ? void 0 : _values$formLogic2$ac.missionStatement) && ((_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : (_values$formLogic3$ac = _values$formLogic3.acknowledgement) === null || _values$formLogic3$ac === void 0 ? void 0 : _values$formLogic3$ac.release);
  var visibleList = ['Name', 'Email', 'Address', 'Phone'];
  var defaultAddressList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'];
  useCitiesRolesGroupMemberSelector({
    cities: cities,
    cityId: cityId
  });
  useEffect(function () {
    if (groupName) {
      setFieldValue("collector.entity[0].number[0].key", groupName);
    }
    if (leaderId) {
      var leaderIdInt = parseInt(leaderId, 10);
      setFieldValue("collector.entity[0].number[0].value", leaderIdInt);
    }
  }, [values.formLogic.acknowledgement]);
  useEffect(function () {
    handleOver18({
      setFieldValue: setFieldValue,
      values: values
    });
  }, [values.formLogic.over18]);
  useEffect(function () {
    handleUnder18({
      setFieldValue: setFieldValue,
      values: values
    });
  }, [values.formLogic.under18]);
  useEffect(function () {
    setFormId({
      templateName: Templates.GROUP_MEMBER,
      values: values,
      setFieldValue: setFieldValue
    });
    setFieldValue('formLogic.templateName', Templates.GROUP_MEMBER);
    setFieldValue('collector.cart.products[0]', {
      productId: '',
      amount: 0,
      quantity: 1
    });
  }, []);
  return {
    defaultAddressList: defaultAddressList,
    groupName: groupName,
    isUnder18: isUnder18,
    leaderId: leaderId,
    selectedCity: selectedCity,
    showSubmitButton: showSubmitButton,
    values: values,
    visibleList: visibleList
  };
};

var useGroupRequest = function useGroupRequest(_ref) {
  var showPrefix = _ref.showPrefix,
    _ref$required = _ref.required,
    required = _ref$required === void 0 ? true : _ref$required;
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    isSubmitting = _useFormikContext.isSubmitting;
  var nameVisibleList = [].concat(_toConsumableArray(showPrefix ? ['prefix'] : []), ['firstName', 'lastName']);
  var titles = {
    contactInfoTitle: 'Your Contact Information',
    organizationInfoTitle: 'Church or Organization Information',
    requestInfoTitle: 'Request Information'
  };
  var labels = {
    websiteLabel: "".concat(t('Website', {
      ns: 'labels'
    })),
    numGuestsLabel: "".concat(t('Number of Guests', {
      ns: 'labels'
    })).concat(required ? '*' : ''),
    numMealsLabel: "".concat(t('Number of Meals', {
      ns: 'labels'
    })).concat(required ? '*' : ''),
    numRoomsLabel: "".concat(t('Number of Lodging Rooms', {
      ns: 'labels'
    })).concat(required ? '*' : ''),
    numNightsLabel: "".concat(t('Number of Lodging Nights', {
      ns: 'labels'
    })).concat(required ? '*' : ''),
    proposedStartDateLabel: "".concat(t('Proposed Start Date', {
      ns: 'labels'
    })).concat(required ? '*' : ''),
    proposedEndDateLabel: "".concat(t('Proposed End Date', {
      ns: 'labels'
    })).concat(required ? '*' : ''),
    datesFlexibleLabel: "Are your dates flexible?".concat(required ? '*' : ''),
    eventTypeLabel: "".concat(t('Type of Event', {
      ns: 'labels'
    })),
    eventsBeforeLabel: "".concat(t('Where have you held events before?', {
      ns: 'labels'
    })),
    hearAboutLabel: "".concat(t('How did you hear about The Cove?', {
      ns: 'labels'
    })),
    commentsLabel: "".concat(t('Additional Comments', {
      ns: 'labels'
    }))
  };
  var submitText = t('SUBMIT', {
    ns: 'labels'
  });
  useEffect(function () {
    setFieldValue('collector.entity[1].orgs', undefined);
  }, [isSubmitting]);
  return _objectSpread2(_objectSpread2(_objectSpread2({}, titles), {}, {
    nameVisibleList: nameVisibleList
  }, labels), {}, {
    submitText: submitText
  });
};

var honorMemorialOpt = /*#__PURE__*/function (honorMemorialOpt) {
  honorMemorialOpt["HONOR"] = "honor";
  honorMemorialOpt["MEMORIAL"] = "memorial";
  honorMemorialOpt["BLANK"] = "blank";
  return honorMemorialOpt;
}({});
var relationshipType = 'Honor and Memorial Honoree';
var honoreeLabelInfo = {
  name: "Honoree\u2019s Name",
  street: "Honoree\u2019s Street Address",
  city: "Honoree\u2019s City",
  state: "State/Province",
  postalCode: "Honoree\u2019s ZIP Code"
};
var memoryLabelInfo = {
  name: "In Memory Of (Person's name)",
  street: "Mail to Address",
  city: "Mail to City",
  state: "Mail to State",
  postalCode: "Mail to ZIP Code"
};
var nameDisplayLabel = 'Your Name Displayed on Card';
var mailNotificationLabel = 'Mail Notification Card to';
var honorMemorialOptions = [{
  value: 'Mail Honor Card',
  id: honorMemorialOpt.HONOR
}, {
  value: 'Mail Memorial Card',
  id: honorMemorialOpt.MEMORIAL
}];

var _excluded$N = ["country", "isHonorMemorialPage", "maxPostalCodeLength", "minPostalCodeLength"];
var useHonorMemorialGiving = function useHonorMemorialGiving(_ref) {
  var country = _ref.country,
    _ref$isHonorMemorialP = _ref.isHonorMemorialPage,
    isHonorMemorialPage = _ref$isHonorMemorialP === void 0 ? false : _ref$isHonorMemorialP,
    _ref$maxPostalCodeLen = _ref.maxPostalCodeLength,
    maxPostalCodeLength = _ref$maxPostalCodeLen === void 0 ? 10 : _ref$maxPostalCodeLen,
    _ref$minPostalCodeLen = _ref.minPostalCodeLength,
    minPostalCodeLength = _ref$minPostalCodeLen === void 0 ? minimumPostalCodeLength : _ref$minPostalCodeLen,
    props = _objectWithoutProperties(_ref, _excluded$N);
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState = useState(honoreeLabelInfo),
    _useState2 = _slicedToArray(_useState, 2),
    labelInfo = _useState2[0],
    setLabelInfo = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showInMemory = _useState4[0],
    setShowInMemory = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    productIndex = _useState6[0],
    setProductIndex = _useState6[1];
  var checkBoxLabel = 'Honor/Memorial gift';
  var hasHonorMemorial = deepFind(values, 'formLogic.hasHonorMemorial');
  var honorMemorialOption = deepFind(values, "formLogic.honorMemorialOption");
  var isBlankCard = deepFind(values, "formLogic.isBlankCard");
  var products = deepFind(values, 'collector.cart.products');
  var entity = deepFind(values, 'collector.entity');
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  var filteredEntity = entity === null || entity === void 0 ? void 0 : entity.filter(function (ent) {
    var _ent$entityRelationsh;
    return !(ent !== null && ent !== void 0 && (_ent$entityRelationsh = ent.entityRelationship) !== null && _ent$entityRelationsh !== void 0 && _ent$entityRelationsh.some(function (item) {
      return (item === null || item === void 0 ? void 0 : item.relationshipType) === relationshipType;
    }));
  });
  var blankCopy = {
    markup: (props === null || props === void 0 ? void 0 : props.blankCopy) || "This blank card will be sent to the person making the honor/memorial gift. Please allow 2 to 3 weeks for delivery."
  };
  var honorCopy = {
    markup: (props === null || props === void 0 ? void 0 : props.honorCopy) || "\u201C<em><strong>In Honor Of</strong></em>\u201D gifts are appropriate for a living individual\u2019s special occasion, such as birthday, graduation, anniversary or another milestone. These gifts can also be used for holidays, such as Christmas, Mother\u2019s Day, Father\u2019s Day\u2014or simply to honor the life of someone special at any time of the year. Please allow 2\u20133 weeks for delivery."
  };
  var memorialCopy = {
    markup: (props === null || props === void 0 ? void 0 : props.memorialCopy) || "\u201C<em><strong>In Memory Of</strong></em>\u201C gifts are an appropriate way to make a gesture of remembrance for a loved one who has passed away. These gifts can be given on the occasion of the person\u2019s passing, or on another special date such as a birthday, anniversary or other occasion of significance. Please allow 2\u20133 weeks for delivery."
  };
  var honorMemoryName = deepFind(values, "collector.cart.products[".concat(productIndex, "].honorMemory.honorMemoryName"));
  var mailCardToName = deepFind(values, "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToName"));
  var mailCardToAddress = deepFind(values, "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToAddress"));
  var mailCardToCity = deepFind(values, "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToCity"));
  var mailCardToState = deepFind(values, "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToState"));
  var mailCardToZip = deepFind(values, "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToZip"));
  var validatePostalCode = function validatePostalCode(value) {
    return validateZipPostalCode(value, minPostalCodeLength, maxPostalCodeLength, (props === null || props === void 0 ? void 0 : props.postalCodeErrorMsg) || (translations === null || translations === void 0 ? void 0 : translations.invalidPostalCode));
  };
  useEffect(function () {
    if (honorMemorialOption === honorMemorialOpt.HONOR) {
      setLabelInfo(honoreeLabelInfo);
      setShowInMemory(false);
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.giftType"), 'Send in Honor');
      setFieldValue("collector.cart.products[".concat(productIndex, "].productId"), 'BHAK');
    } else if (honorMemorialOption === honorMemorialOpt.MEMORIAL) {
      setLabelInfo(memoryLabelInfo);
      setShowInMemory(true);
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.giftType"), 'Send in Memory');
      setFieldValue("collector.cart.products[".concat(productIndex, "].productId"), 'BMAK1');
    }
  }, [honorMemorialOption]);
  useEffect(function () {
    if (hasHonorMemorial) {
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToCountry"), country[0]);
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.giftType"), 'Send in Honor');
      setFieldValue("collector.cart.products[".concat(productIndex, "].amount"), 0);
      setFieldValue("collector.cart.products[".concat(productIndex, "].quantity"), 1);
      setFieldValue("collector.cart.products[".concat(productIndex, "].productId"), 'BHAK');
    }
  }, [hasHonorMemorial, productIndex]);
  useEffect(function () {
    if (!showInMemory && (honorMemoryName === null || honorMemoryName === void 0 ? void 0 : honorMemoryName.length) > 0) {
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToName"), honorMemoryName);
    }
  }, [showInMemory, honorMemoryName]);
  useEffect(function () {
    if (isBlankCard) {
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.sendBlank"), 'Y');
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.honorMemoryName"), '');
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToName"), '');
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToAddress"), '');
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToCity"), '');
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToState"), '');
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToZip"), '');
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToCountry"), '');
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.nameOnCard"), '');
    } else {
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.sendBlank"), 'N');
      setFieldValue("collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToCountry"), country[0]);
    }
  }, [isBlankCard]);
  useEffect(function () {
    if ((mailCardToAddress === null || mailCardToAddress === void 0 ? void 0 : mailCardToAddress.length) > 0 && (mailCardToCity === null || mailCardToCity === void 0 ? void 0 : mailCardToCity.length) > 0 && (mailCardToState === null || mailCardToState === void 0 ? void 0 : mailCardToState.length) > 0 && (mailCardToZip === null || mailCardToZip === void 0 ? void 0 : mailCardToZip.length) > 0) {
      var memoryNameArray = (mailCardToName === null || mailCardToName === void 0 ? void 0 : mailCardToName.length) > 0 ? mailCardToName.split(' ') : [];
      var honorNameArray = (honorMemoryName === null || honorMemoryName === void 0 ? void 0 : honorMemoryName.length) > 0 ? honorMemoryName.split(' ') : [];
      var nameArray = showInMemory ? memoryNameArray : honorNameArray;
      var honorMemorialHonoree = {
        entityType: 'I',
        isPrimary: false,
        firstName: nameArray[0] ? nameArray[0] : '',
        lastName: nameArray[1] ? nameArray[1] : '',
        entityRelationship: [{
          path: 'entity[0]',
          relationshipType: relationshipType
        }],
        address: [{
          addressType: 'MAIL',
          street: mailCardToAddress,
          cityTownRegion: mailCardToCity,
          stateProvince: mailCardToState,
          zipPostalCode: mailCardToZip,
          country: country[0]
        }]
      };
      setFieldValue('collector.entity', [].concat(_toConsumableArray(filteredEntity), [honorMemorialHonoree]));
    }
  }, [mailCardToName, mailCardToAddress, mailCardToCity, mailCardToState, mailCardToZip]);
  useEffect(function () {
    setFormId({
      templateName: Templates.HONOR_MEMORIAL_GIVING,
      values: values,
      setFieldValue: setFieldValue
    });
    setFieldValue('formLogic.hasHonorMemorial', isHonorMemorialPage || false);
    setFieldValue('formLogic.honorMemorialOption', honorMemorialOpt.HONOR);
    setFieldValue('formLogic.templateName', Templates.HONOR_MEMORIAL_GIVING);
    if ((products === null || products === void 0 ? void 0 : products.length) > 0) {
      setProductIndex(products === null || products === void 0 ? void 0 : products.length);
    }
  }, []);
  return {
    blankCopy: blankCopy,
    checkBoxLabel: checkBoxLabel,
    hasHonorMemorial: hasHonorMemorial,
    honorCopy: honorCopy,
    honorMemorialOptions: honorMemorialOptions,
    isBlankCard: isBlankCard,
    labelInfo: labelInfo,
    mailNotificationLabel: mailNotificationLabel,
    memorialCopy: memorialCopy,
    nameDisplayLabel: nameDisplayLabel,
    productIndex: productIndex,
    showInMemory: showInMemory,
    validatePostalCode: validatePostalCode,
    values: values
  };
};

var _excluded$M = ["maxNumGroup", "minNumGroup", "pattern", "showPrefix", "transportOptions"];
var useHostSeminar = function useHostSeminar(_ref) {
  var _values$formLogic, _values$collector, _values$collector2, _values$collector2$en;
  var showPrefix = _ref.showPrefix,
    props = _objectWithoutProperties(_ref, _excluded$M);
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  useLogicInfo({
    logicIds: props === null || props === void 0 ? void 0 : props.logicIds
  });
  useChurchInfo(_objectSpread2({
    eventId: props === null || props === void 0 ? void 0 : props.eventId
  }, props));
  useCode(_objectSpread2({
    eventId: props === null || props === void 0 ? void 0 : props.eventId
  }, props));
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var visibleList = [].concat(_toConsumableArray(showPrefix ? ['prefix'] : []), ['firstName', 'lastName']);
  var defaultAddressList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'];
  var aboutYourChurchLabel = t('About Your Church', {
    ns: 'common'
  });
  var churchWebsite = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.churchWebsite;
  useEffect(function () {
    if ((churchWebsite === null || churchWebsite === void 0 ? void 0 : churchWebsite.length) > 0) {
      setFieldValue("collector.questions[5].answerText", churchWebsite, false);
    }
  }, [churchWebsite]);
  useEffect(function () {
    setFieldValue("collector.entity[2].orgs.role", 'Host SHIC', false);
    setFieldValue('collector.questions', [{
      answerText: '500-1000',
      questionId: 102,
      questionText: 'Seating Capacity for Venue'
    }, {
      answerText: '',
      questionId: 98,
      questionText: 'Is there a dining facility? Please describe'
    }, {
      answerText: '',
      questionId: 99,
      questionText: 'Is this request supported by senior pastoral leadership? Please explain'
    }, {
      answerText: '',
      questionId: 100,
      questionText: 'Are there other churches in the community interested in helping to host the event? Please list'
    }, {
      answerText: '',
      questionId: 101,
      questionText: 'How did you find out about hosting a live SHIC event?'
    }, {
      answerText: '',
      questionId: 103,
      questionText: 'Church Website URL'
    }]);
  }, []);
  values === null || values === void 0 ? true : (_values$collector = values.collector) === null || _values$collector === void 0 ? true : delete _values$collector.cart;
  values === null || values === void 0 ? true : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? true : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? true : delete _values$collector2$en.address;
  return {
    aboutYourChurchLabel: aboutYourChurchLabel,
    defaultAddressList: defaultAddressList,
    visibleList: visibleList,
    yourChurchInformationLabel: translations.yourChurchInformationLabel,
    yourInformationLabel: translations.yourInformationLabel
  };
};

var useIndividualVolunteer = function useIndividualVolunteer(_ref) {
  var _values$formLogic, _values$formLogic$ack, _values$formLogic2, _values$formLogic2$ac;
  var languageOptions = _ref.languageOptions,
    roleOptions = _ref.roleOptions;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useTranslationHelper();
  useChurchInfo({});
  var roleOptionsName = 'formLogic.role';
  var roles = roleOptions.map(function (role) {
    return _objectSpread2(_objectSpread2({}, role), {}, {
      value: JSON.stringify({
        label: role === null || role === void 0 ? void 0 : role.label,
        crusadeCodeEventRoleId: role === null || role === void 0 ? void 0 : role.value,
        SECodeEventRoleId: role === null || role === void 0 ? void 0 : role.id
      })
    });
  });
  var churchLangOptions = languageOptions === null || languageOptions === void 0 ? void 0 : languageOptions.map(function (lng) {
    return _objectSpread2(_objectSpread2({}, lng), {}, {
      id: "church".concat(lng === null || lng === void 0 ? void 0 : lng.id),
      name: "formLogic.church".concat(lng === null || lng === void 0 ? void 0 : lng.name)
    });
  });
  var visibleList = ['Name', 'Email', 'Address', 'Phone'];
  var isOver18 = values.formLogic.over18 === 'yes';
  var isUnder18 = values.formLogic.over18 === 'no'; // ignore empty string
  var hasChurchInfo = values.formLogic.churchInfo && values.collector.entity[1] && values.collector.entity[1].address;
  var showSubmitButton = ((_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$ack = _values$formLogic.acknowledgement) === null || _values$formLogic$ack === void 0 ? void 0 : _values$formLogic$ack.missionStatement) && ((_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$ac = _values$formLogic2.acknowledgement) === null || _values$formLogic2$ac === void 0 ? void 0 : _values$formLogic2$ac.release);
  var defaultAddressList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'];
  useEffect(function () {
    handleOver18({
      setFieldValue: setFieldValue,
      values: values
    });
  }, [values.formLogic.over18]);
  useEffect(function () {
    handleUnder18({
      setFieldValue: setFieldValue,
      values: values
    });
  }, [values.formLogic.under18]);
  useEffect(function () {
    setFormId({
      templateName: Templates.INDIVIDUAL_VOLUNTEER,
      values: values,
      setFieldValue: setFieldValue
    });
    setFieldValue('formLogic.acknowledgement', {
      missionStatement: false,
      release: false
    }, false);
    setFieldValue('formLogic.templateName', Templates.INDIVIDUAL_VOLUNTEER);
    setFieldValue('collector.cart.products[0]', {
      productId: '',
      amount: 0,
      quantity: 1
    });
  }, []);
  return {
    churchLangOptions: churchLangOptions,
    defaultAddressList: defaultAddressList,
    isOver18: isOver18,
    isUnder18: isUnder18,
    hasChurchInfo: hasChurchInfo,
    roleOptionsName: roleOptionsName,
    roles: roles,
    showSubmitButton: showSubmitButton,
    visibleList: visibleList
  };
};

var _excluded$L = ["setFieldValue"];
var firstTimeAcceptanceHandler = function firstTimeAcceptanceHandler(_ref) {
  var decisionOptionArr = _ref.decisionOptionArr,
    values = _ref.values,
    setFieldValue = _ref.setFieldValue,
    setCodes = _ref.setCodes,
    firstTimeAcceptanceAttribute = _ref.firstTimeAcceptanceAttribute,
    props = _ref.props;
  if (firstTimeAcceptanceAttribute === 'yes') {
    var newCodes = setCodes(decisionOptionArr, values, setFieldValue);
    var newCodesLen = newCodes === null || newCodes === void 0 ? void 0 : newCodes.length;
    setFieldValue("collector.entity[0].code[".concat(newCodesLen, "].key"), 'ATTRIBUTES');
    setFieldValue("collector.entity[0].code[".concat(newCodesLen, "].value"), props === null || props === void 0 ? void 0 : props.firstTimeAcceptanceAttribute);
  } else {
    setCodes(props === null || props === void 0 ? void 0 : props.firstTimeAcceptanceAttribute, values, setFieldValue);
  }
};
var churchOptionHandler = function churchOptionHandler(_ref2) {
  var churchOption = _ref2.churchOption,
    setFieldValue = _ref2.setFieldValue;
  if (churchOption === 'yes') {
    setFieldValue('collector.entity[0].inquirerData.designation', 0, false);
  } else {
    setFieldValue('collector.entity[0].inquirerData.designation', 1, false);
  }
};
var propsHandler = function propsHandler(_ref3) {
  var languageSelector = _ref3.languageSelector;
  var address1Label = languageSelector === DDCLANG.EN.toLowerCase() ? 'Street, Number' : 'የሰፈር  ስም';
  var formCopy = languageSelector === DDCLANG.EN.toLowerCase() ? 'If you are age 15 or under, please speak to a counselor near the platform.' : 'ዕድሜዎ 15 ዓመት ወይም ከዛ በታች ከሆነ በአቅራቢዎ የሚገኘውን አማካሪ ያነጋግሩ።';
  var administrativeRegion = languageSelector === DDCLANG.EN.toLowerCase() ? 'Administrative Region' : 'የአስተዳደር ክልል';
  var firstTimeOptions = languageSelector === DDCLANG.EN.toLowerCase() ? [{
    label: 'Yes, I accepted Christ for the first time.',
    name: 'radioGroup',
    id: 'option1',
    value: 'yes'
  }, {
    label: 'No.',
    name: 'radioGroup',
    id: 'option2',
    value: 'no'
  }] : [{
    label: 'አዎን',
    name: 'radioGroup',
    id: 'option1',
    value: 'yes'
  }, {
    label: 'አይደለም',
    name: 'radioGroup',
    id: 'option2',
    value: 'no'
  }];
  var socialMediaInputs = languageSelector === DDCLANG.EN.toLowerCase() ? [{
    handle: 'Telegram',
    socialMediaType: 'TELGRM',
    label: 'Telegram'
  }] : [{
    handle: 'Telegram',
    socialMediaType: 'TELGRM',
    label: 'ቴሌግራም'
  }];
  var decisionOptions = languageSelector === DDCLANG.EN.toLowerCase() ? [{
    label: 'I was not sure I had eternal life, and wanted reassurance.',
    name: 'decisionGroup',
    id: 'firstChoice',
    value: '258'
  }, {
    label: 'I have rededicated my life to Christ.',
    name: 'decisionGroup',
    id: 'renewedChoice',
    value: '259'
  }, {
    label: '  I wanted to know more about Christ.',
    name: 'decisionGroup',
    id: 'noDecisionChoice',
    value: '260'
  }] : [{
    label: 'የዘላለምን ሕይወት እንዳገኘሁ እርግጠኛ አይደለሁም፥ እና አሁን ማረጋገጫ እፈልጋለሁ። ',
    name: 'decisionGroup',
    id: 'firstChoice',
    value: '258'
  }, {
    label: 'ሕይወቴን ለክርስቶስ ለመስጠት ወስኛለሁ።',
    name: 'decisionGroup',
    id: 'renewedChoice',
    value: '259'
  }, {
    label: 'ስለ ክርስቶስ ይበልጥ ለማወቅ እፈልጋለሁ።',
    name: 'decisionGroup',
    id: 'noDecisionChoice',
    value: '260'
  }];
  var churchOptions = languageSelector === DDCLANG.EN.toLowerCase() ? [{
    label: "I don't have a church/I'm looking for a church.",
    name: 'churchGroup',
    id: 'noChurchChoice',
    value: 'no'
  }, {
    label: 'I currently attend a church/I was invited by someone from a church.',
    name: 'churchGroup',
    id: 'yesChurchChoice',
    value: 'yes'
  }] : [{
    label: 'ቤተ ክርስቲያን የለኝም/ቤተ ክርስቲያን እፈልጋለሁ።',
    name: 'churchGroup',
    id: 'noChurchChoice',
    value: 'no'
  }, {
    label: 'አሁን ቤተ ክርስቲያን እየተከታታልኩ ነኝ/ አንድ ሰው ከቤተ ክርስቲያን ጋብዞኛል።',
    name: 'churchGroup',
    id: 'yesChurchChoice',
    value: 'yes'
  }];
  var customRegionList = languageSelector === DDCLANG.EN.toLowerCase() ? [{
    value: 'Addis Ababa',
    id: 'Addis Ababa'
  }, {
    value: 'Afar',
    id: 'Afar'
  }, {
    value: 'Amhara',
    id: 'Amhara'
  }, {
    value: 'Benshangul-Gumaz',
    id: 'Benshangul-Gumaz'
  }, {
    value: 'Central Ethiopia',
    id: 'Central Ethiopia'
  }, {
    value: 'Dire Dawa',
    id: 'Dire Dawa'
  }, {
    value: 'Gambela',
    id: 'Gambela'
  }, {
    value: 'Harari',
    id: 'Harari'
  }, {
    value: 'Oromia',
    id: 'Oromia'
  }, {
    value: 'Sidama',
    id: 'Sidama'
  }, {
    value: 'Somali',
    id: 'Somali'
  }, {
    value: 'South Ethiopia',
    id: 'South Ethiopia'
  }, {
    value: 'South West Ethiopia',
    id: 'South West Ethiopia'
  }, {
    value: 'Tigray',
    id: 'Tigray'
  }] : [{
    value: 'አዲስ አበባ',
    id: 'Addis Ababa'
  }, {
    value: 'አፋር',
    id: 'Afar'
  }, {
    value: 'አማራ',
    id: 'Amhara'
  }, {
    value: 'ቤኔሻንጉል-ጉሙዝ',
    id: 'Benshangul-Gumaz'
  }, {
    value: 'ማዕከላዊ ኢትዮጵያ',
    id: 'Central Ethiopia'
  }, {
    value: 'ድሬዳዋ',
    id: 'Dire Dawa'
  }, {
    value: 'ጋምቤላ',
    id: 'Gambela'
  }, {
    value: 'ሀረሪ',
    id: 'Harari'
  }, {
    value: 'ኦሮሚያ',
    id: 'Oromia'
  }, {
    value: 'ሲዳማ',
    id: 'Sidama'
  }, {
    value: 'ሶማሌ',
    id: 'Somali'
  }, {
    value: 'ደቡብ ኢትዮጵያ',
    id: 'South Ethiopia'
  }, {
    value: 'ደቡብ ምዕራብ ኢትዮጵያ',
    id: 'South West Ethiopia'
  }, {
    value: 'ትግራይ',
    id: 'Tigray'
  }];
  return {
    address1Label: address1Label,
    administrativeRegion: administrativeRegion,
    customRegionList: customRegionList,
    decisionOptions: decisionOptions,
    churchOptions: churchOptions,
    firstTimeOptions: firstTimeOptions,
    formCopy: formCopy,
    socialMediaInputs: socialMediaInputs
  };
};
var customConfirmationHandler = function customConfirmationHandler(_ref4) {
  var languageSelector = _ref4.languageSelector,
    initialLanguage = _ref4.initialLanguage,
    setFieldValue = _ref4.setFieldValue,
    engCustomConfirmation = _ref4.engCustomConfirmation,
    amhCustomConfirmation = _ref4.amhCustomConfirmation;
  if (languageSelector === DDCLANG.EN.toLowerCase()) {
    setFieldValue('formLogic.customConfirmation', engCustomConfirmation);
  } else if (initialLanguage === 'AMH') {
    setFieldValue('formLogic.customConfirmation', amhCustomConfirmation);
  }
};
var handleLanguage = function handleLanguage(_ref5) {
  var initialLanguage = _ref5.initialLanguage,
    languageSelector = _ref5.languageSelector,
    values = _ref5.values,
    setLanguage = _ref5.setLanguage,
    setFieldValue = _ref5.setFieldValue,
    engCustomConfirmation = _ref5.engCustomConfirmation,
    amhCustomConfirmation = _ref5.amhCustomConfirmation;
  if (languageSelector || initialLanguage) {
    var _values$collector, _values$collector$ent, _values$collector2, _values$collector2$en, _values$collector2$en2, _values$collector2$en3;
    setLanguage(languageSelector);
    customConfirmationHandler({
      languageSelector: languageSelector,
      initialLanguage: initialLanguage,
      setFieldValue: setFieldValue,
      engCustomConfirmation: engCustomConfirmation,
      amhCustomConfirmation: amhCustomConfirmation
    });
    var resetArr = values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent = _values$collector.entity[0]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.code ? values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.code) === null || _values$collector2$en2 === void 0 ? void 0 : (_values$collector2$en3 = _values$collector2$en2.slice()) === null || _values$collector2$en3 === void 0 ? void 0 : _values$collector2$en3.filter(function (item) {
      return item.key !== 'A01c:DDCLANG' && item.key !== 'A01c:DEFLANG';
    }) : [];
    var languageCodes = [{
      key: 'A01c:DDCLANG',
      value: initialLanguage === null || initialLanguage === void 0 ? void 0 : initialLanguage.toUpperCase()
    }, {
      key: 'A01c:DEFLANG',
      value: initialLanguage === null || initialLanguage === void 0 ? void 0 : initialLanguage.toUpperCase()
    }];
    setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), languageCodes));
  }
};
var setInitialData = function setInitialData(_ref6) {
  var _props$socialMediaInp;
  var setFieldValue = _ref6.setFieldValue,
    props = _objectWithoutProperties(_ref6, _excluded$L);
  if (props !== null && props !== void 0 && props.isDisableRecaptcha) {
    setFieldValue('formLogic.isDisableRecaptcha', true, false);
  }
  if (props !== null && props !== void 0 && props.eventId) {
    setFieldValue('collector.entity[0].inquirerData.eventId', parseInt(props === null || props === void 0 ? void 0 : props.eventId, 10), false);
  }
  if ((props === null || props === void 0 ? void 0 : (_props$socialMediaInp = props.socialMediaInputs) === null || _props$socialMediaInp === void 0 ? void 0 : _props$socialMediaInp.length) > 0) {
    var _props$socialMediaInp2;
    props === null || props === void 0 ? void 0 : (_props$socialMediaInp2 = props.socialMediaInputs) === null || _props$socialMediaInp2 === void 0 ? void 0 : _props$socialMediaInp2.forEach(function (social, idx) {
      setFieldValue("collector.entity[0].social[".concat(idx, "].socialMediaType"), social.socialMediaType, false);
    });
  }
};

var useInquirerResponse = function useInquirerResponse(_ref) {
  var _values$formLogic, _values$collector, _values$collector$ent, _values$collector$ent2, _values$formLogic2, _values$formLogic3, _values$formLogic4, _values$formLogic4$ch, _values$formLogic5, _values$formLogic5$ch, _values$formLogic6, _values$formLogic6$ch, _values$formLogic7, _values$formLogic7$ch, _values$formLogic8, _values$formLogic8$ch, _values$formLogic9, _values$formLogic10, _values$formLogic12, _values$formLogic14, _values$collector2;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  useLogicInfo({
    logicIds: props === null || props === void 0 ? void 0 : props.logicIds
  });
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    language = _useState2[0],
    setLanguage = _useState2[1];
  useLanguage({
    isInternational: false,
    lng: language,
    disableDdcLangCode: true
  });
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  var churchOption = values === null || values === void 0 ? void 0 : values.formLogic.churchOption;
  var showChurchInfo = churchOption === 'yes';
  var isOver16 = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.isOver16;
  var visibleList = [].concat(_toConsumableArray(props !== null && props !== void 0 && props.showPrefix ? ['prefix'] : []), ['firstName', 'lastName']);
  var codeIndex = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.length;
  var firstTimeAcceptanceAttribute = (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.firstTimeAcceptanceAttribute) || '';
  var consentAttribute = props === null || props === void 0 ? void 0 : props.consentAttribute;
  var showDecisionOptions = firstTimeAcceptanceAttribute === 'no';
  var decisionOption = values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.decisionOption;
  var churchStreet = values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : (_values$formLogic4$ch = _values$formLogic4.churchInfo) === null || _values$formLogic4$ch === void 0 ? void 0 : _values$formLogic4$ch.street;
  var churchState = values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : (_values$formLogic5$ch = _values$formLogic5.churchInfo) === null || _values$formLogic5$ch === void 0 ? void 0 : _values$formLogic5$ch.stateProvince;
  var churchCity = values === null || values === void 0 ? void 0 : (_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : (_values$formLogic6$ch = _values$formLogic6.churchInfo) === null || _values$formLogic6$ch === void 0 ? void 0 : _values$formLogic6$ch.cityTownRegion;
  var churchStreetTwo = values === null || values === void 0 ? void 0 : (_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : (_values$formLogic7$ch = _values$formLogic7.churchInfo) === null || _values$formLogic7$ch === void 0 ? void 0 : _values$formLogic7$ch.streetTwo;
  var churchStreetThree = values === null || values === void 0 ? void 0 : (_values$formLogic8 = values.formLogic) === null || _values$formLogic8 === void 0 ? void 0 : (_values$formLogic8$ch = _values$formLogic8.churchInfo) === null || _values$formLogic8$ch === void 0 ? void 0 : _values$formLogic8$ch.streetThree;
  var languageSelector = values === null || values === void 0 ? void 0 : (_values$formLogic9 = values.formLogic) === null || _values$formLogic9 === void 0 ? void 0 : _values$formLogic9.languageSelector;
  var initialLanguage = values === null || values === void 0 ? void 0 : (_values$formLogic10 = values.formLogic) === null || _values$formLogic10 === void 0 ? void 0 : _values$formLogic10.language;
  var _propsHandler = propsHandler({
      languageSelector: languageSelector
    }),
    address1Label = _propsHandler.address1Label,
    administrativeRegion = _propsHandler.administrativeRegion,
    decisionOptions = _propsHandler.decisionOptions,
    churchOptions = _propsHandler.churchOptions,
    customRegionList = _propsHandler.customRegionList,
    firstTimeOptions = _propsHandler.firstTimeOptions,
    formCopy = _propsHandler.formCopy,
    socialMediaInputs = _propsHandler.socialMediaInputs;
  var decisionOptionArr = decisionOptions === null || decisionOptions === void 0 ? void 0 : decisionOptions.map(function (opt) {
    return opt === null || opt === void 0 ? void 0 : opt.value;
  });
  var engCustomConfirmation = function engCustomConfirmation() {
    return jsxs("div", {
      children: [jsx("h1", {
        className: "title",
        children: "Thank you!"
      }), jsx("div", {
        className: "block",
        children: jsx("p", {
          children: "Your submission is complete."
        })
      })]
    });
  };
  var amhCustomConfirmation = function amhCustomConfirmation() {
    return jsxs("div", {
      children: [jsx("h1", {
        className: "title",
        children: "\u12A5\u1293\u1218\u1230\u130D\u1293\u1208\u1295!"
      }), jsx("div", {
        className: "block",
        children: jsx("p", {
          children: "\u12EB\u1240\u1228\u1261\u1275 \u1218\u1228\u1303 \u1270\u1320\u1293\u124B\u120D\u1362"
        })
      })]
    });
  };
  var privacyPolicyCopy = languageSelector === DDCLANG.EN.toLowerCase() ? function () {
    return jsx("div", {
      children: jsxs("p", {
        children: ["By providing your personal details (including your religious views), you consent to us: using your details to keep in touch about the event(s) and to let you know about BGEA\u2019s other ministry activities; and using these details to manage your involvement with BGEA. These details will be held by BGEA in the USA and/or in the country in which they were collected (and may be passed to our ministry partners in your country to process) for the above purposes only. To manage preferences and to find out more about how we handle your details see", ' ', jsx("a", {
          target: "_blank",
          href: "https://billygraham.org/privacy-policy/",
          rel: "noreferrer",
          children: "BGEA\u2019s Privacy Policy."
        })]
      })
    });
  } : function () {
    return jsx("div", {
      children: jsxs("p", {
        children: ["\u12E8\u130D\u120D \u12DD\u122D\u12DD\u122D \u1309\u12F3\u12EE\u127D\u12CE\u1295 (\u12E8\u12A5\u122D\u1235\u12CE\u1295 \u1203\u12ED\u121B\u1296\u1273\u12CA \u12A0\u1218\u1208\u12AB\u12A8\u1276\u127D\u1295 \u1328\u121D\u122E) \u1260\u121B\u1245\u1228\u1265 \u12A8\u12A5\u129B \u130B\u122D \u1270\u1235\u121B\u121D\u1270\u12CB\u120D\u1364 \u1235\u1208\u1218\u122D\u1210 \u130D\u1265\u1229 \u130D\u1295\u1299\u1290\u1275 \u1208\u1218\u1240\u1320\u120D \u12A5\u1293 \u1235\u1208 \u1262\u120A \u130D\u122B\u1203\u121D \u12A2\u126B\u1295\u1300\u120D\u1235\u1272\u12A8 \u12A0\u1308\u120D\u130D\u120E\u1275\u1293 (\u1262\u130D\u12A2\u12A0) \u120C\u120E\u127D \u12E8\u12A0\u1308\u120D\u130D\u120E\u1275 \u12A5\u1295\u1245\u1235\u1243\u1234\u12CE\u127D \u1208\u12A5\u122D\u1235\u12CE \u1208\u121B\u1233\u12C8\u1245\u1365 \u12A5\u1295\u12F2\u1201\u121D \u12A8\u1262\u130D\u12A2\u12A0 \u130B\u122D \u12EB\u1208\u12CE\u1275\u1295 \u1270\u1233\u1275\u134E \u1208\u1218\u12A8\u1273\u1270\u120D \u12A5\u1290\u12DA\u1205\u1295 \u12DD\u122D\u12DD\u122D \u1218\u1228\u1303\u12CE\u127D \u12A5\u1295\u1320\u1240\u121B\u1208\u1295\u1362 \u12A5\u1290\u12DA\u1205 \u12DD\u122D\u12DD\u122E\u127D \u1260\u12A0\u121C\u122A\u12AB \u1263\u1208\u12CD \u1262\u130D\u12A2\u12A0 \u12A5\u1293/\u12C8\u12ED\u121D \u12DD\u122D\u12DD\u122D \u1218\u1228\u1303\u12CE\u127D \u1260\u1270\u1230\u1260\u1230\u1261\u1260\u1275 \u1200\u1308\u122D\u1365 (\u1260\u12A0\u1308\u122D\u12CE \u120B\u1209 \u12E8\u12A0\u1308\u120D\u130D\u120E\u1275 \u12A0\u130B\u122E\u127B\u127D\u1295 \u120A\u1270\u120B\u1208\u1349 \u12ED\u127D\u120B\u1209) \u12A8\u120B\u12ED \u1208\u1270\u1320\u1240\u1231\u1275 \u12D3\u120B\u121B\u12CE\u127D \u1265\u127B \u1325\u1245\u121D \u120B\u12ED \u12ED\u12CD\u120B\u1209\u1362 \u121D\u122D\u132B\u12CE\u127D\u1295 \u1208\u121B\u1235\u1270\u12F3\u12F0\u122D \u12A5\u1293 \u12E8\u12A5\u122D\u1235\u12CE\u1295 \u12DD\u122D\u12DD\u122D \u1218\u1228\u1303\u12CE\u127D \u12A5\u1295\u12F4\u1275 \u12A5\u1295\u12F0\u121D\u1295\u12ED\u12DD \u12E8\u1260\u1208\u1320 \u1208\u121B\u12C8\u1245", ' ', jsx("a", {
          target: "_blank",
          href: "https://encounteringgod.billygraham.org/am/privacy-policy",
          rel: "noreferrer",
          children: "\u12E8\u1262\u130D\u12A2\u12A0 \u12E8\u130D\u120D \u1218\u1265\u1275 \u1356\u120A\u1232\u1364"
        }), ' ', "\u12ED\u1218\u120D\u12A8\u1271 \u1364"]
      })
    });
  };
  useEffect(function () {
    firstTimeAcceptanceHandler({
      decisionOptionArr: decisionOptionArr,
      values: values,
      setFieldValue: setFieldValue,
      setCodes: setCodes,
      firstTimeAcceptanceAttribute: firstTimeAcceptanceAttribute,
      props: props
    });
  }, [firstTimeAcceptanceAttribute]);
  useEffect(function () {
    if (isOver16) {
      setFieldValue("collector.entity[0].code[".concat(codeIndex, "].key"), 'ATTRIBUTES');
      setFieldValue("collector.entity[0].code[".concat(codeIndex, "].value"), consentAttribute);
    } else {
      setCodes(consentAttribute, values, setFieldValue);
    }
  }, [isOver16]);
  useEffect(function () {
    if (decisionOption) {
      var filteredDecisions = decisionOptionArr.filter(function (opt) {
        return opt !== decisionOption;
      });
      var newCodes = setCodes(filteredDecisions, values, setFieldValue);
      var newCodesLen = newCodes === null || newCodes === void 0 ? void 0 : newCodes.length;
      setFieldValue("collector.entity[0].code[".concat(newCodesLen, "].key"), 'ATTRIBUTES');
      setFieldValue("collector.entity[0].code[".concat(newCodesLen, "].value"), decisionOption);
      setFieldValue('collector.entity[0].inquirerData.iDecision', parseInt(decisionOption, 10), false);
    }
  }, [decisionOption]);
  useEffect(function () {
    churchOptionHandler({
      churchOption: churchOption,
      setFieldValue: setFieldValue
    });
  }, [churchOption]);
  useEffect(function () {
    if (churchStreet && churchState && churchCity && churchStreetTwo) {
      var churchStreetCity = "".concat(churchState, " | ").concat(churchCity, " | ").concat((churchStreetThree === null || churchStreetThree === void 0 ? void 0 : churchStreetThree.length) > 0 ? churchStreetThree : '', " | ").concat(churchStreetTwo, " | ").concat(churchStreet, " ");
      setFieldValue('collector.entity[0].inquirerData.churchCity', churchStreetCity, false);
    }
  }, [churchStreet, churchState, churchCity, churchStreetTwo, churchStreetThree]);
  useEffect(function () {
    var _values$formLogic11;
    if ((values === null || values === void 0 ? void 0 : (_values$formLogic11 = values.formLogic) === null || _values$formLogic11 === void 0 ? void 0 : _values$formLogic11.firstTimeAcceptanceAttribute) === 'yes') {
      var decisionAttr = props === null || props === void 0 ? void 0 : props.firstTimeAcceptanceAttribute;
      setFieldValue('collector.entity[0].inquirerData.iDecision', parseInt(decisionAttr, 10), false);
    }
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic12 = values.formLogic) === null || _values$formLogic12 === void 0 ? void 0 : _values$formLogic12.firstTimeAcceptanceAttribute]);
  useEffect(function () {
    var _values$formLogic13;
    (values === null || values === void 0 ? void 0 : (_values$formLogic13 = values.formLogic) === null || _values$formLogic13 === void 0 ? void 0 : _values$formLogic13.age) && handleAge({
      values: values,
      setFieldValue: setFieldValue
    });
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic14 = values.formLogic) === null || _values$formLogic14 === void 0 ? void 0 : _values$formLogic14.age]);
  useEffect(function () {
    handleLanguage({
      initialLanguage: initialLanguage,
      languageSelector: languageSelector,
      values: values,
      setLanguage: setLanguage,
      setFieldValue: setFieldValue,
      engCustomConfirmation: engCustomConfirmation,
      amhCustomConfirmation: amhCustomConfirmation
    });
  }, [languageSelector, initialLanguage]);
  useEffect(function () {
    setFormId(_objectSpread2({
      templateName: Templates.INQUIRER_RESPONSE,
      values: values,
      setFieldValue: setFieldValue
    }, props));
    setFieldValue('collector.entity[0].gender', '', false);
    setFieldValue('formLogic.age', '', false);
    setFieldValue('formLogic.firstTimeAcceptanceAttribute', '', false);
    setFieldValue('formLogic.isOver16', false, false);
    setFieldValue('formLogic.churchOption', '', false);
    setInitialData(_objectSpread2({
      setFieldValue: setFieldValue
    }, props));
  }, []);
  values === null || values === void 0 ? true : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? true : delete _values$collector2.cart;
  return {
    acceptJesusQuestion: translations === null || translations === void 0 ? void 0 : translations.acceptJesusQuestion,
    address1Label: address1Label,
    administrativeRegion: administrativeRegion,
    ageLabel: translations === null || translations === void 0 ? void 0 : translations.ageLabel,
    consentStatement: translations === null || translations === void 0 ? void 0 : translations.consentStatement,
    churchCity: translations === null || translations === void 0 ? void 0 : translations.churchCity,
    churchDistrict: translations === null || translations === void 0 ? void 0 : translations.churchDistrict,
    churchLabel: translations === null || translations === void 0 ? void 0 : translations.churchLabel,
    churchStreet: translations === null || translations === void 0 ? void 0 : translations.churchStreet,
    churcSubCity: translations === null || translations === void 0 ? void 0 : translations.churcSubCity,
    churchOptions: churchOptions,
    customRegionList: customRegionList,
    decisionOptions: decisionOptions,
    faithDescription: translations === null || translations === void 0 ? void 0 : translations.faithDescription,
    femaleLabel: translations === null || translations === void 0 ? void 0 : translations.femaleLabel,
    findChurchText: translations === null || translations === void 0 ? void 0 : translations.findChurchText,
    firstTimeOptions: firstTimeOptions,
    formHeader: translations === null || translations === void 0 ? void 0 : translations.formHeader,
    formCopy: formCopy,
    isOver16: isOver16,
    privacyPolicyCopy: privacyPolicyCopy,
    sixteenLabel: translations === null || translations === void 0 ? void 0 : translations.sixteenLabel,
    socialMediaInputs: socialMediaInputs,
    genderLabel: translations === null || translations === void 0 ? void 0 : translations.genderLabel,
    language: language,
    maleLabel: translations === null || translations === void 0 ? void 0 : translations.maleLabel,
    showChurchInfo: showChurchInfo,
    showDecisionOptions: showDecisionOptions,
    selectOneLabel: translations === null || translations === void 0 ? void 0 : translations.selectOneLabel,
    selectOptionText: translations === null || translations === void 0 ? void 0 : translations.selectOptionText,
    thirteenLabel: translations === null || translations === void 0 ? void 0 : translations.thirteenLabel,
    visibleList: visibleList
  };
};

var _excluded$K = ["values"];
var validateFields = function validateFields(_ref) {
  var _values$collector$ent, _values$collector$ent2, _values$collector$ent3, _values$collector$ent4, _values$collector$ent5, _values$collector$ent6, _values$collector$ent7, _values$collector$ent8, _values$collector$ent9, _values$collector$ent10, _values$collector$ent11, _values$collector$ent12, _values$collector$ent13, _values$collector$ent14;
  var values = _ref.values,
    props = _objectWithoutProperties(_ref, _excluded$K);
  var hasStateField = typeof ((_values$collector$ent = values.collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.address[0]) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.stateProvince) !== 'undefined';
  var hasCityField = typeof ((_values$collector$ent3 = values.collector.entity[0]) === null || _values$collector$ent3 === void 0 ? void 0 : (_values$collector$ent4 = _values$collector$ent3.address[0]) === null || _values$collector$ent4 === void 0 ? void 0 : _values$collector$ent4.stateProvince) !== 'undefined';
  var isValid = ((_values$collector$ent5 = values.collector.entity[0]) === null || _values$collector$ent5 === void 0 ? void 0 : (_values$collector$ent6 = _values$collector$ent5.firstName) === null || _values$collector$ent6 === void 0 ? void 0 : _values$collector$ent6.length) > 0 && ((_values$collector$ent7 = values.collector.entity[0]) === null || _values$collector$ent7 === void 0 ? void 0 : (_values$collector$ent8 = _values$collector$ent7.lastName) === null || _values$collector$ent8 === void 0 ? void 0 : _values$collector$ent8.length) > 0 && ((_values$collector$ent9 = values.collector.entity[0]) === null || _values$collector$ent9 === void 0 ? void 0 : (_values$collector$ent10 = _values$collector$ent9.email[0]) === null || _values$collector$ent10 === void 0 ? void 0 : (_values$collector$ent11 = _values$collector$ent10.emailAddress) === null || _values$collector$ent11 === void 0 ? void 0 : _values$collector$ent11.length) > 0 && ((_values$collector$ent12 = values.collector.entity[0]) === null || _values$collector$ent12 === void 0 ? void 0 : (_values$collector$ent13 = _values$collector$ent12.address[0]) === null || _values$collector$ent13 === void 0 ? void 0 : (_values$collector$ent14 = _values$collector$ent13.zipPostalCode) === null || _values$collector$ent14 === void 0 ? void 0 : _values$collector$ent14.length) > 0;
  if (hasStateField) {
    var _values$collector$ent15, _values$collector$ent16, _values$collector$ent17;
    isValid = ((_values$collector$ent15 = values.collector.entity[0]) === null || _values$collector$ent15 === void 0 ? void 0 : (_values$collector$ent16 = _values$collector$ent15.address[0]) === null || _values$collector$ent16 === void 0 ? void 0 : (_values$collector$ent17 = _values$collector$ent16.stateProvince) === null || _values$collector$ent17 === void 0 ? void 0 : _values$collector$ent17.length) > 0;
  }
  if (hasCityField) {
    var _values$collector$ent18, _values$collector$ent19;
    isValid = ((_values$collector$ent18 = values.collector.entity[0]) === null || _values$collector$ent18 === void 0 ? void 0 : (_values$collector$ent19 = _values$collector$ent18.address[0]) === null || _values$collector$ent19 === void 0 ? void 0 : _values$collector$ent19.cityTownRegion.length) > 0;
  }
  if (props !== null && props !== void 0 && props.show18Checkbox) {
    var _values$collector$ent20;
    isValid = (_values$collector$ent20 = values.collector.entity[0]) === null || _values$collector$ent20 === void 0 ? void 0 : _values$collector$ent20.over18;
  }
  return isValid;
};
var handleOptIn = function handleOptIn(_ref2) {
  var disableOptinLogic = _ref2.disableOptinLogic,
    props = _ref2.props,
    resetArr = _ref2.resetArr,
    specialCode = _ref2.specialCode,
    values = _ref2.values,
    setFieldValue = _ref2.setFieldValue;
  if (!disableOptinLogic) {
    var _values$formLogic, _props$esubsCodes;
    if ((_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && _values$formLogic.optIn && (props === null || props === void 0 ? void 0 : (_props$esubsCodes = props.esubsCodes) === null || _props$esubsCodes === void 0 ? void 0 : _props$esubsCodes.length) > 0) {
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), _toConsumableArray(props === null || props === void 0 ? void 0 : props.esubsCodes)), false);
    } else if ((specialCode === null || specialCode === void 0 ? void 0 : specialCode.length) > 0) {
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), _toConsumableArray(specialCode)), false);
    }
  }
};
var setIntialData$1 = function setIntialData(_ref3) {
  var _props$esubsCodes2;
  var disableOptinLogic = _ref3.disableOptinLogic,
    props = _ref3.props,
    isOptinRequired = _ref3.isOptinRequired,
    products = _ref3.products,
    resetArr = _ref3.resetArr,
    values = _ref3.values,
    setFieldValue = _ref3.setFieldValue,
    validateForm = _ref3.validateForm;
  if (props !== null && props !== void 0 && props.priceCode) {
    setFieldValue("collector.cart.products", products, false);
  }
  if (disableOptinLogic && (props === null || props === void 0 ? void 0 : (_props$esubsCodes2 = props.esubsCodes) === null || _props$esubsCodes2 === void 0 ? void 0 : _props$esubsCodes2.length) > 0) {
    setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), _toConsumableArray(props === null || props === void 0 ? void 0 : props.esubsCodes)), false);
  }
  if (isOptinRequired) {
    setFieldValue("formLogic.optIn", false, false);
  }
  if (props.emailTemplateCampaign) {
    setFieldValue("formLogic.emailTemplateCampaign", props.emailTemplateCampaign);
  }
  if (props !== null && props !== void 0 && props.show18Checkbox) {
    setFieldValue("collector.entity[0].over18", (props === null || props === void 0 ? void 0 : props.isChecked) || false);
  }
  if (props.showProductOption) {
    setFieldValue("formLogic.physicalProduct", false);
  }
  if (values) {
    validateForm();
  }
};

var _excluded$J = ["disableOptinLogic", "isOptinRequired", "maxPostalCodeLength", "minPostalCodeLength", "specialCode"];
var useLandingPage = function useLandingPage(_ref) {
  var _props$priceCode, _values$collector, _values$collector$ent, _values$collector2, _values$collector2$en, _values$collector2$en2, _values$collector$ent2, _values$collector$ent3, _values$formLogic, _values$formLogic2;
  var _ref$disableOptinLogi = _ref.disableOptinLogic,
    disableOptinLogic = _ref$disableOptinLogi === void 0 ? false : _ref$disableOptinLogi,
    _ref$isOptinRequired = _ref.isOptinRequired,
    isOptinRequired = _ref$isOptinRequired === void 0 ? false : _ref$isOptinRequired,
    _ref$maxPostalCodeLen = _ref.maxPostalCodeLength,
    maxPostalCodeLength = _ref$maxPostalCodeLen === void 0 ? maximumPostalCodeLength : _ref$maxPostalCodeLen,
    _ref$minPostalCodeLen = _ref.minPostalCodeLength,
    minPostalCodeLength = _ref$minPostalCodeLen === void 0 ? minimumPostalCodeLength : _ref$minPostalCodeLen,
    _ref$specialCode = _ref.specialCode,
    specialCode = _ref$specialCode === void 0 ? defaultSpecialCode : _ref$specialCode,
    props = _objectWithoutProperties(_ref, _excluded$J);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormValid = _useState2[0],
    setIsFormValid = _useState2[1];
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  var _useFormikContext = useFormikContext(),
    isValid = _useFormikContext.isValid,
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue,
    setErrors = _useFormikContext.setErrors,
    setFieldError = _useFormikContext.setFieldError,
    validateForm = _useFormikContext.validateForm;
  var products = (_props$priceCode = props === null || props === void 0 ? void 0 : props.priceCode) !== null && _props$priceCode !== void 0 ? _props$priceCode : [];
  var visibleList = ['firstName', 'lastName'];
  var resetArr = values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent = _values$collector.entity[0]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.code ? values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.code) === null || _values$collector2$en2 === void 0 ? void 0 : _values$collector2$en2.slice() : [];
  var country = values === null || values === void 0 ? void 0 : (_values$collector$ent2 = values.collector.entity[0]) === null || _values$collector$ent2 === void 0 ? void 0 : (_values$collector$ent3 = _values$collector$ent2.address[0]) === null || _values$collector$ent3 === void 0 ? void 0 : _values$collector$ent3.country;
  var validatePostalCode = function validatePostalCode(value) {
    return country === Countries.US ? validateZipPostalCode(value, minPostalCodeLength, maxPostalCodeLength, translations === null || translations === void 0 ? void 0 : translations.invalidPostalCode) : undefined;
  };
  useEffect(function () {
    if (validateFields(_objectSpread2({
      values: values
    }, props))) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [values.collector.entity]);
  useEffect(function () {
    if (country !== Countries.US) {
      setFieldError('collector.entity[0].address[0].zipPostalCode', '');
      setErrors({});
    }
  }, [country]);
  useEffect(function () {
    validateForm();
  }, [isFormValid]);
  useEffect(function () {
    handleOptIn({
      disableOptinLogic: disableOptinLogic,
      props: props,
      resetArr: resetArr,
      specialCode: specialCode,
      values: values,
      setFieldValue: setFieldValue
    });
  }, [disableOptinLogic, (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.optIn]);
  useEffect(function () {
    setFormId({
      templateName: Templates.LANDING_PAGE,
      values: values,
      setFieldValue: setFieldValue
    });
    setIntialData$1({
      disableOptinLogic: disableOptinLogic,
      props: props,
      isOptinRequired: isOptinRequired,
      products: products,
      resetArr: resetArr,
      values: values,
      setFieldValue: setFieldValue,
      validateForm: validateForm
    });
  }, []);
  var isDisabled = !isOptinRequired && !isValid || isOptinRequired && (!isValid || ((_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.optIn) === false);
  return {
    isDisabled: isDisabled,
    privacyPolicyTextLabel: translations.privacyPolicyLabel,
    values: values,
    visibleList: visibleList,
    validatePostalCode: validatePostalCode
  };
};

var isValidUrl = function isValidUrl(urlString) {
  try {
    return Boolean(new URL(urlString));
  } catch (e) {
    return false;
  }
};
var useLandingPageResponse = function useLandingPageResponse(_ref) {
  var _values$formLogic$dec, _values$collector, _values$collector$car;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var decisionLabel = 'What was your decision?';
  var decisionOptions = [{
    label: 'I have prayed this prayer for the first time',
    name: 'decisionGroup',
    id: 'firstChoice',
    value: 'first'
  }, {
    label: 'I have prayed this prayer in the past and I renewed it today',
    name: 'decisionGroup',
    id: 'renewedChoice',
    value: 'renewed'
  }];
  var isUrlOption = isValidUrl(values.formLogic.decisionOption);
  var disableSubmitButton = ((_values$formLogic$dec = values.formLogic.decisionOption) === null || _values$formLogic$dec === void 0 ? void 0 : _values$formLogic$dec.length) === 0;
  var commType = values.formLogic.decisionOption === 'first' ? CommunicationType.Salvation : CommunicationType.Reded;
  useEffect(function () {
    if (values.formLogic.decisionOption && !isUrlOption && props !== null && props !== void 0 && props.customShortComment) {
      setFieldValue('collector.communications', [{
        communicationType: commType,
        shortComment: props === null || props === void 0 ? void 0 : props.customShortComment
      }]);
    } else if (isUrlOption) {
      window.location.assign(values.formLogic.decisionOption);
    }
  }, [values.formLogic.decisionOption]);
  useEffect(function () {
    if (values.formLogic.physicalProduct) {
      setFieldValue("collector.cart.products", props === null || props === void 0 ? void 0 : props.physicalProducts, false);
      setFieldValue("email.emailId", props === null || props === void 0 ? void 0 : props.emailId, false);
    } else {
      setFieldValue("collector.cart.products", [], false);
      setFieldValue("email.emailId", '', false);
    }
  }, [values.formLogic.physicalProduct]);
  useEffect(function () {
    var _props$codeList;
    if (props !== null && props !== void 0 && props.defaultResponse) {
      setFieldValue('formLogic.decisionOption', props === null || props === void 0 ? void 0 : props.defaultResponse);
    } else {
      setFieldValue('formLogic.decisionOption', '');
    }
    if (props !== null && props !== void 0 && props.isDisableRecaptcha) {
      setFieldValue('formLogic.isDisableRecaptcha', true, false);
    }
    if ((props === null || props === void 0 ? void 0 : (_props$codeList = props.codeList) === null || _props$codeList === void 0 ? void 0 : _props$codeList.length) > 0) {
      setFieldValue("collector.entity[0].code", props === null || props === void 0 ? void 0 : props.codeList);
    }
  }, []);
  if (!(props !== null && props !== void 0 && props.showProductOption)) {
    delete values.collector.cart;
  } else if (values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$car = _values$collector.cart) !== null && _values$collector$car !== void 0 && _values$collector$car.donation) {
    delete values.collector.cart.donation;
  }
  if (!(props !== null && props !== void 0 && props.emailId)) {
    delete values.email;
  }
  if (!(props !== null && props !== void 0 && props.SESourceCode)) {
    delete values.collector.SESourceCode;
  }
  return {
    decisionLabel: decisionLabel,
    decisionOptions: decisionOptions,
    disableSubmitButton: disableSubmitButton,
    isUrlOption: isUrlOption,
    values: values
  };
};

var handleDdcLangLogic = function handleDdcLangLogic(_ref) {
  var disableDdcLangCode = _ref.disableDdcLangCode,
    isInternational = _ref.isInternational,
    langKey = _ref.langKey,
    language = _ref.language,
    values = _ref.values,
    setFieldValue = _ref.setFieldValue;
  if (!disableDdcLangCode) {
    var _values$collector, _values$collector$ent, _values$collector2, _values$collector2$en, _values$collector2$en2, _values$collector2$en3;
    var resetArr = values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent = _values$collector.entity[0]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.code ? values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.code) === null || _values$collector2$en2 === void 0 ? void 0 : (_values$collector2$en3 = _values$collector2$en2.slice()) === null || _values$collector2$en3 === void 0 ? void 0 : _values$collector2$en3.filter(function (item) {
      return item.key !== langKey;
    }) : [];
    if (isInternational) {
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), [{
        key: 'A01c:DDCLANG',
        value: language === null || language === void 0 ? void 0 : language.toUpperCase()
      }]));
    } else {
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), [{
        key: 'DDCLANG',
        value: language === null || language === void 0 ? void 0 : language.toUpperCase()
      }]));
    }
  }
};

var useLanguage = function useLanguage(_ref) {
  var _values$formLogic;
  var isInternational = _ref.isInternational,
    lng = _ref.lng,
    _ref$disableDdcLangCo = _ref.disableDdcLangCode,
    disableDdcLangCode = _ref$disableDdcLangCo === void 0 ? false : _ref$disableDdcLangCo;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    i18n = _useTranslation.i18n;
  var langKey = isInternational ? 'A01c:DDCLANG' : 'DDCLANG';
  var locales = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.locales;
  useEffect(function () {
    if (locales !== 'undefined' || lng && lng !== 'undefined') {
      var language = Array.isArray(lng) ? lng[0] : lng;
      handleDdcLangLogic({
        disableDdcLangCode: disableDdcLangCode,
        isInternational: isInternational,
        langKey: langKey,
        language: language,
        values: values,
        setFieldValue: setFieldValue
      });
      setFieldValue('formLogic.language', language === null || language === void 0 ? void 0 : language.toUpperCase());
      i18n.changeLanguage(locales || lng);
    }
  }, [lng]);
  return {
    values: values
  };
};

var MAX_YEAR$1 = 18;
var useLeap = function useLeap() {
  var _values$formLogic, _values$formLogic2;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var date = new Date();
  var maxDate = new Date(date.setFullYear(date.getFullYear() - MAX_YEAR$1));
  var showFormDetails = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.marriedOption) === 'yes';
  var showChurchSupport = values.formLogic.churchSupport === 'yes';
  var showOpening = values.formLogic.opening === 'yes';
  var showEquipment = values.formLogic.equipment === 'yes';
  var showRetiredInfo = values.formLogic.retired === 'retired';
  var showSpouseInfo = values.formLogic.spouseOfficer === 'yes';
  var showSpouseMedical = values.formLogic.spouseMedical === 'yes';
  var showSpouseTreatment = values.formLogic.spouseTreatment === 'yes';
  var notMarriedText = (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.marriedOption) === 'no' ? "Thank you for your interest in LEAP Alaska. This retreat is for\n          married officers only. Please take a look at our website for other\n          retreat opportunities." : '';
  var options = [{
    label: 'Yes',
    name: 'leapOptionsGrp',
    value: 'yes'
  }, {
    label: 'No',
    name: 'leapOptionsGrp',
    value: 'no'
  }];
  var retiredOptions = [{
    label: 'Active',
    name: 'leapRetiredOptionsGrp',
    value: 'active'
  }, {
    label: 'Retired',
    name: 'leapRetiredOptionsGrp',
    value: 'retired'
  }];
  var genderOptions = [{
    label: 'Male',
    name: 'leapGenderOptionsGrp',
    value: 'male'
  }, {
    label: 'Female',
    name: 'leapGenderOptionsGrp',
    value: 'female'
  }];
  var marriageStateOptions = [{
    label: 'Healthy',
    name: 'leapMarriageStateOptionsGrp',
    value: 'healthy'
  }, {
    label: 'Troubled',
    name: 'leapMarriageStateOptionsGrp',
    value: 'troubled'
  }, {
    label: 'Separated',
    name: 'leapMarriageStateOptionsGrp',
    value: 'separated'
  }];
  useEffect(function () {
    if (values.formLogic.equipment) {
      setFieldValue("newQuestionsLeap.equipment", values.formLogic.equipment);
    }
  }, [values.formLogic.equipment]);
  useEffect(function () {
    if (values.formLogic.churchSupport === 'Yes') {
      setFieldValue("newQuestionsLeap.churchSupport", values.formLogic.churchSupport);
      setFieldValue("collector.entity[2].orgs.role", 'CHUR/MEM');
    } else if (values.formLogic.churchSupport === 'No' && values.collector.entity[2]) {
      values.collector.entity.splice(2, 1);
    }
  }, [values.formLogic.churchSupport]);
  useEffect(function () {
    if (values.formLogic.opening) {
      setFieldValue("newQuestionsLeap.opening", values.formLogic.opening);
    }
  }, [values.formLogic.opening]);
  useEffect(function () {
    if (values.formLogic.retired) {
      setFieldValue("newQuestionsLeap.retired", values.formLogic.retired);
    }
  }, [values.formLogic.retired]);
  useEffect(function () {
    if (values.formLogic.spouseOfficer) {
      setFieldValue("newQuestionsLeap.spouseOfficer", values.formLogic.spouseOfficer);
    }
  }, [values.formLogic.spouseOfficer]);
  useEffect(function () {
    if (values.formLogic.spouseMedical) {
      setFieldValue("newQuestionsLeap.spouseMedical", values.formLogic.spouseMedical);
    }
  }, [values.formLogic.spouseMedical]);
  useEffect(function () {
    if (values.formLogic.spouseTreatment) {
      setFieldValue("newQuestionsLeap.spouseTreatment", values.formLogic.spouseTreatment);
    }
  }, [values.formLogic.spouseTreatment]);
  return {
    genderOptions: genderOptions,
    options: options,
    marriageStateOptions: marriageStateOptions,
    maxDate: maxDate,
    notMarriedText: notMarriedText,
    retiredOptions: retiredOptions,
    showChurchSupport: showChurchSupport,
    showEquipment: showEquipment,
    showFormDetails: showFormDetails,
    showOpening: showOpening,
    showRetiredInfo: showRetiredInfo,
    showSpouseInfo: showSpouseInfo,
    showSpouseMedical: showSpouseMedical,
    showSpouseTreatment: showSpouseTreatment,
    values: values
  };
};

var resetCodeArr = function resetCodeArr(codes, value) {
  return codes === null || codes === void 0 ? void 0 : codes.filter(function (item) {
    return item.value !== value;
  });
};
var handleResetLogic = function handleResetLogic(code, shouldRemoveB207, values, setFieldValue) {
  var _values$collector, _values$collector$ent;
  var filteredArr = resetCodeArr(values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : _values$collector$ent.code, code);
  if (shouldRemoveB207) {
    filteredArr = filteredArr.filter(function (item) {
      return item.value !== 'B207';
    });
  }
  setFieldValue("collector.entity[0].code", filteredArr, false);
};
var useLegacyPlanning = function useLegacyPlanning() {
  var _values$formLogic, _values$formLogic2, _values$formLogic3, _values$collector2, _values$collector2$en, _values$collector3, _values$collector3$en, _values$collector3$en2;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var freeLegacyPlanner = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.legacyPlanningPlanner;
  var plannedGift = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.legacyPlanningGift;
  var estatePlans = values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.legacyPlanningEstatePlans;
  var isOptionSelected = freeLegacyPlanner || plannedGift || estatePlans;
  var codeArr = values !== null && values !== void 0 && (_values$collector2 = values.collector) !== null && _values$collector2 !== void 0 && (_values$collector2$en = _values$collector2.entity[0]) !== null && _values$collector2$en !== void 0 && _values$collector2$en.code ? values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.code) === null || _values$collector3$en2 === void 0 ? void 0 : _values$collector3$en2.slice() : [];
  var resetArr = codeArr.filter(function (item) {
    return item.value !== 'B207';
  });
  var plannerOptionsLabel = 'Please choose at least one of the following: *';
  useEffect(function () {
    if (freeLegacyPlanner) {
      // DEVELOP[]=B218 and send Product TY372K
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(codeArr), [{
        key: 'DEVELOP',
        value: 'B218'
      }]), false);
      setFieldValue("collector.cart.products", [{
        amount: 0,
        productId: '19878K',
        quantity: 1
      }], false);
    } else {
      var _values$collector4, _values$collector4$en, _values$collector5, _values$collector5$en, _values$collector5$en2, _values$collector5$en3;
      var filteredArr = values !== null && values !== void 0 && (_values$collector4 = values.collector) !== null && _values$collector4 !== void 0 && (_values$collector4$en = _values$collector4.entity[0]) !== null && _values$collector4$en !== void 0 && _values$collector4$en.code ? values === null || values === void 0 ? void 0 : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : (_values$collector5$en = _values$collector5.entity[0]) === null || _values$collector5$en === void 0 ? void 0 : (_values$collector5$en2 = _values$collector5$en.code) === null || _values$collector5$en2 === void 0 ? void 0 : (_values$collector5$en3 = _values$collector5$en2.slice()) === null || _values$collector5$en3 === void 0 ? void 0 : _values$collector5$en3.filter(function (item) {
        return item.value !== 'B218';
      }) : [];
      setFieldValue("collector.entity[0].code", filteredArr, false);
      setFieldValue("collector.cart.products", [], false);
    }
  }, [freeLegacyPlanner]);
  useEffect(function () {
    if (plannedGift) {
      // DEVELOP[]=LPPCNT
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), [{
        key: 'DEVELOP',
        value: 'LPPCNT'
      }, {
        key: 'DEVELOP',
        value: 'B207'
      }]), false);
    } else {
      handleResetLogic('LPPCNT', !estatePlans, values, setFieldValue);
    }
  }, [plannedGift]);
  useEffect(function () {
    if (estatePlans) {
      // DEVELOP[]=LEG
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), [{
        key: 'DEVELOP',
        value: 'LEG'
      }, {
        key: 'DEVELOP',
        value: 'B207'
      }]), false);
    } else {
      handleResetLogic('LEG', !plannedGift, values, setFieldValue);
    }
  }, [estatePlans]);
  return {
    isOptionSelected: isOptionSelected,
    plannerOptionsLabel: plannerOptionsLabel,
    values: values
  };
};

var useLogicInfo = function useLogicInfo(_ref) {
  var _ref$useLogicNoDuplic = _ref.useLogicNoDuplicate,
    useLogicNoDuplicate = _ref$useLogicNoDuplic === void 0 ? false : _ref$useLogicNoDuplic,
    _ref$logicIds = _ref.logicIds,
    logicIds = _ref$logicIds === void 0 ? [] : _ref$logicIds;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  useEffect(function () {
    if (useLogicNoDuplicate) {
      setFieldValue('logic', {
        logicIds: ['NoDuplicatesWithFeedback']
      }, false);
    }
    if ((logicIds === null || logicIds === void 0 ? void 0 : logicIds.length) > 0) {
      setFieldValue('logic', {
        logicIds: _toConsumableArray(logicIds)
      }, false);
    }
  }, []);
  return {
    values: values
  };
};

var useMaterialInfo = function useMaterialInfo() {
  var _values$collector, _values$collector$add, _values$collector$add2, _values$collector2, _values$collector2$ad, _values$collector2$ad2, _values$collector3, _values$collector3$ad, _values$collector3$ad2;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showOnlineInfo = _useState2[0],
    setShowOnlineInfo = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPublicationInfo = _useState4[0],
    setShowPublicationInfo = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showAudiovisualInfo = _useState6[0],
    setShowAudiovisualInfo = _useState6[1];
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var materialOnline = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$add = _values$collector.additionalData) === null || _values$collector$add === void 0 ? void 0 : (_values$collector$add2 = _values$collector$add.materialInfo) === null || _values$collector$add2 === void 0 ? void 0 : _values$collector$add2.materialOnline;
  var materialPublication = values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$ad = _values$collector2.additionalData) === null || _values$collector2$ad === void 0 ? void 0 : (_values$collector2$ad2 = _values$collector2$ad.materialInfo) === null || _values$collector2$ad2 === void 0 ? void 0 : _values$collector2$ad2.materialPublication;
  var materialAudioVisual = values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$ad = _values$collector3.additionalData) === null || _values$collector3$ad === void 0 ? void 0 : (_values$collector3$ad2 = _values$collector3$ad.materialInfo) === null || _values$collector3$ad2 === void 0 ? void 0 : _values$collector3$ad2.materialAudioVisual;
  var materialOnlineOptions = [{
    label: 'Yes',
    name: 'materialOnlineGrp',
    value: 'yes'
  }, {
    label: 'No',
    name: 'materialOnlineGrp',
    value: 'no'
  }];
  var materialPublicationOptions = [{
    label: 'Yes',
    name: 'materialPublicationGrp',
    value: 'yes'
  }, {
    label: 'No',
    name: 'materialPublicationGrp',
    value: 'no'
  }];
  var materialAudioVisualOptions = [{
    label: 'Yes',
    name: 'materialAudioVisualGrp',
    value: 'yes'
  }, {
    label: 'No',
    name: 'materialAudioVisualGrp',
    value: 'no'
  }];
  useEffect(function () {
    if (materialOnline === 'yes') {
      setShowOnlineInfo(true);
    } else {
      setShowOnlineInfo(false);
    }
  }, [materialOnline]);
  useEffect(function () {
    if (materialPublication === 'yes') {
      setShowPublicationInfo(true);
    } else {
      setShowPublicationInfo(false);
    }
  }, [materialPublication]);
  useEffect(function () {
    if (materialAudioVisual === 'yes') {
      setShowAudiovisualInfo(true);
    } else {
      setShowAudiovisualInfo(false);
    }
  }, [materialAudioVisual]);
  useEffect(function () {
    setFieldValue('collector.additionalData.materialInfo', {
      materialOnline: '',
      materialPublication: '',
      materialAudioVisual: '',
      description: ''
    }, false);
  }, []);
  return {
    materialAudioVisualOptions: materialAudioVisualOptions,
    materialOnlineOptions: materialOnlineOptions,
    materialPublicationOptions: materialPublicationOptions,
    showOnlineInfo: showOnlineInfo,
    showPublicationInfo: showPublicationInfo,
    showAudiovisualInfo: showAudiovisualInfo
  };
};

var useMediaRequest = function useMediaRequest() {
  var _values$collector$ent3, _values$collector$ent4, _values$formLogic3, _values$formLogic4;
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useFormikContext = useFormikContext(),
    isValid = _useFormikContext.isValid,
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue,
    validateForm = _useFormikContext.validateForm;
  var title = t('Get In Contact with us', {
    ns: 'labels'
  });
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    esubs = _useState2[0],
    setEsubs = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    isFormValid = _useState4[0],
    setIsFormValid = _useState4[1];
  useEmailSubscription({
    esubCodes: esubs
  });
  var showSignUpCheckbox = deepFind(values, "formLogic.showSignUpCheckbox");
  useEffect(function () {
    if (showSignUpCheckbox) {
      setEsubs(['BGEA']);
    } else {
      setEsubs([]);
    }
  }, [showSignUpCheckbox]);
  useEffect(function () {
    var _values$collector, _values$collector$ent, _values$collector$ent2, _values$collector2, _values$collector2$en, _values$collector2$en2, _values$formLogic, _values$formLogic$med, _values$formLogic2, _values$formLogic2$me;
    if ((values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.firstName) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.lastName) === null || _values$collector2$en2 === void 0 ? void 0 : _values$collector2$en2.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$med = _values$formLogic.mediaOutlet) === null || _values$formLogic$med === void 0 ? void 0 : _values$formLogic$med.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$me = _values$formLogic2.mediaRequestHelp) === null || _values$formLogic2$me === void 0 ? void 0 : _values$formLogic2$me.length) > 0) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [(_values$collector$ent3 = values.collector.entity[0]) === null || _values$collector$ent3 === void 0 ? void 0 : _values$collector$ent3.firstName, (_values$collector$ent4 = values.collector.entity[0]) === null || _values$collector$ent4 === void 0 ? void 0 : _values$collector$ent4.lastName, values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.mediaOutlet, values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.mediaRequestHelp]);
  useEffect(function () {
    validateForm();
  }, [isFormValid]);
  useEffect(function () {
    setFormId({
      templateName: Templates.MEDIA_REQUEST,
      values: values,
      setFieldValue: setFieldValue
    });
    setFieldValue('formLogic.mediaOutlet', '', false);
    setFieldValue('formLogic.mediaRequestHelp', '', false);
    setFieldValue('formLogic.showSignUpCheckbox', false, false);
  }, []);
  return {
    isDisabled: !isValid,
    title: title,
    values: values
  };
};

var useMinistryEmailId = function useMinistryEmailId(_ref) {
  var ministryEmailId = _ref.ministryEmailId;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  useEffect(function () {
    if (ministryEmailId !== undefined || ministryEmailId !== '') {
      setFieldValue('formLogic.ministryEmailId', ministryEmailId);
    }
  }, []);
  return {
    values: values
  };
};

var useMisconduct = function useMisconduct(_ref) {
  var _values$formLogic, _values$formLogic$rep, _values$collector, _values$collector2, _values$collector2$qu, _values$collector3, _values$collector4, _values$collector4$qu, _values$formLogic2, _values$formLogic2$re, _values$formLogic3, _values$formLogic3$en, _values$formLogic13, _values$formLogic16, _values$formLogic16$r;
  var showBasicForm = _ref.showBasicForm;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var spRelationshipOther = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$rep = _values$formLogic.reportDetails) === null || _values$formLogic$rep === void 0 ? void 0 : _values$formLogic$rep.spRelationshipOther;
  var showContactFields = (values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : _values$collector.questions) && (values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$qu = _values$collector2.questions[3]) === null || _values$collector2$qu === void 0 ? void 0 : _values$collector2$qu.answerText) === 'yes';
  var showSPRelationshipInput = (values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : _values$collector3.questions) && (values === null || values === void 0 ? void 0 : (_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : (_values$collector4$qu = _values$collector4.questions[4]) === null || _values$collector4$qu === void 0 ? void 0 : _values$collector4$qu.answerText) === 'other' || (spRelationshipOther === null || spRelationshipOther === void 0 ? void 0 : spRelationshipOther.length) > 0;
  var reportPersonsList = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$re = _values$formLogic2.reportDetails) === null || _values$formLogic2$re === void 0 ? void 0 : _values$formLogic2$re.reportPersons;
  var showRemoveButton = (reportPersonsList === null || reportPersonsList === void 0 ? void 0 : reportPersonsList.length) > 1;
  var contactTime = (values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : (_values$formLogic3$en = _values$formLogic3.entity) === null || _values$formLogic3$en === void 0 ? void 0 : _values$formLogic3$en.contactTime) || '';
  var reporteeInitObj = {
    firstName: '',
    lastName: '',
    organizationName: '',
    entityType: 'I',
    entityRelationship: [{
      path: '',
      relationshipType: RelationshipType.Reportee
    }]
  };
  var contactOptions = [{
    label: 'Yes, my contact information is provided below',
    name: 'contactOptionsGrp',
    value: 'yes'
  }, {
    label: 'No, I do not wish to disclose my contact information',
    name: 'contactOptionsGrp',
    value: 'no'
  }];
  var contactTimes = [{
    label: 'Morning',
    name: 'contactTimesGrp',
    value: 'morning'
  }, {
    label: 'Afternoon',
    name: 'contactTimesGrp',
    value: 'afternoon'
  }, {
    label: 'Evening',
    name: 'contactTimesGrp',
    value: 'evening'
  }];
  var spRelationshipOptions = [{
    label: 'Employee',
    name: 'spRelationshipGrp',
    value: 'employee'
  }, {
    label: 'Volunteer',
    name: 'spRelationshipGrp',
    value: 'volunteer'
  }, {
    label: 'Donor',
    name: 'spRelationshipGrp',
    value: 'donor'
  }, {
    label: 'Vendor',
    name: 'spRelationshipGrp',
    value: 'vendor'
  }, {
    label: 'Other',
    name: 'spRelationshipGrp',
    value: 'other'
  }];
  var handleAddPerson = function handleAddPerson(e) {
    e.preventDefault();
    setFieldValue('formLogic.reportDetails.reportPersons', [].concat(_toConsumableArray(values.formLogic.reportDetails.reportPersons), [reporteeInitObj]), false);
  };
  var handleRemovePerson = function handleRemovePerson(e, index) {
    var _values$formLogic4, _values$formLogic4$re;
    e.preventDefault();
    var arr = values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : (_values$formLogic4$re = _values$formLogic4.reportDetails) === null || _values$formLogic4$re === void 0 ? void 0 : _values$formLogic4$re.reportPersons.slice();
    arr.splice(index, 1);
    setFieldValue('formLogic.reportDetails.reportPersons', _toConsumableArray(arr), false);
  };
  useEffect(function () {
    var _values$formLogic5, _values$formLogic5$re, _values$formLogic5$re2, _values$collector5, _values$collector5$qu, _values$formLogic6, _values$formLogic12, _values$formLogic12$r, _values$formLogic12$r2;
    var reportPersons = values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : (_values$formLogic5$re = _values$formLogic5.reportDetails) === null || _values$formLogic5$re === void 0 ? void 0 : (_values$formLogic5$re2 = _values$formLogic5$re.reportPersons) === null || _values$formLogic5$re2 === void 0 ? void 0 : _values$formLogic5$re2.map(function (person) {
      return _objectSpread2(_objectSpread2({}, person), {}, {
        isPrimary: false
      });
    });
    var questionsArr = values === null || values === void 0 ? void 0 : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : (_values$collector5$qu = _values$collector5.questions) === null || _values$collector5$qu === void 0 ? void 0 : _values$collector5$qu.filter(function (item) {
      return (item === null || item === void 0 ? void 0 : item.questionId) !== 55;
    });
    if (values !== null && values !== void 0 && (_values$formLogic6 = values.formLogic) !== null && _values$formLogic6 !== void 0 && _values$formLogic6.entity && showContactFields) {
      var _values$formLogic7, _values$formLogic7$en, _values$formLogic8, _values$formLogic8$en, _values$formLogic9, _values$formLogic9$en, _values$formLogic9$en2, _values$formLogic10, _values$formLogic10$e, _values$formLogic10$e2, _values$formLogic11, _values$formLogic11$e;
      var reporter = {
        entityType: 'I',
        isPrimary: true,
        firstName: values === null || values === void 0 ? void 0 : (_values$formLogic7 = values.formLogic) === null || _values$formLogic7 === void 0 ? void 0 : (_values$formLogic7$en = _values$formLogic7.entity) === null || _values$formLogic7$en === void 0 ? void 0 : _values$formLogic7$en.firstName,
        lastName: values === null || values === void 0 ? void 0 : (_values$formLogic8 = values.formLogic) === null || _values$formLogic8 === void 0 ? void 0 : (_values$formLogic8$en = _values$formLogic8.entity) === null || _values$formLogic8$en === void 0 ? void 0 : _values$formLogic8$en.lastName,
        phone: [{
          phoneNumber: values === null || values === void 0 ? void 0 : (_values$formLogic9 = values.formLogic) === null || _values$formLogic9 === void 0 ? void 0 : (_values$formLogic9$en = _values$formLogic9.entity) === null || _values$formLogic9$en === void 0 ? void 0 : (_values$formLogic9$en2 = _values$formLogic9$en.phone) === null || _values$formLogic9$en2 === void 0 ? void 0 : _values$formLogic9$en2.phoneNumber
        }],
        email: [{
          emailAddress: values === null || values === void 0 ? void 0 : (_values$formLogic10 = values.formLogic) === null || _values$formLogic10 === void 0 ? void 0 : (_values$formLogic10$e = _values$formLogic10.entity) === null || _values$formLogic10$e === void 0 ? void 0 : (_values$formLogic10$e2 = _values$formLogic10$e.email) === null || _values$formLogic10$e2 === void 0 ? void 0 : _values$formLogic10$e2.emailAddress
        }],
        organizationName: values === null || values === void 0 ? void 0 : (_values$formLogic11 = values.formLogic) === null || _values$formLogic11 === void 0 ? void 0 : (_values$formLogic11$e = _values$formLogic11.entity) === null || _values$formLogic11$e === void 0 ? void 0 : _values$formLogic11$e.organizationName,
        entityRelationship: [{
          path: '',
          relationshipType: RelationshipType.Reporter
        }]
      };
      setFieldValue('collector.entity', [].concat(_toConsumableArray(reportPersons), [reporter]));
      setFieldValue("collector.questions", [].concat(_toConsumableArray(questionsArr), [{
        answerText: contactTime,
        questionId: 55,
        questionText: 'When is the best time to contact you?'
      }]));
    } else if (!showContactFields && values !== null && values !== void 0 && (_values$formLogic12 = values.formLogic) !== null && _values$formLogic12 !== void 0 && (_values$formLogic12$r = _values$formLogic12.reportDetails) !== null && _values$formLogic12$r !== void 0 && (_values$formLogic12$r2 = _values$formLogic12$r.reportPersons) !== null && _values$formLogic12$r2 !== void 0 && _values$formLogic12$r2.length) {
      if (reportPersons[0]) {
        reportPersons[0].isPrimary = true;
      }
      setFieldValue('collector.entity', _toConsumableArray(reportPersons));
    }
    if (!showContactFields && (questionsArr === null || questionsArr === void 0 ? void 0 : questionsArr.length) > 0) {
      setFieldValue("collector.questions", _toConsumableArray(questionsArr));
    }
  }, [showContactFields, values === null || values === void 0 ? void 0 : (_values$formLogic13 = values.formLogic) === null || _values$formLogic13 === void 0 ? void 0 : _values$formLogic13.entity]);
  useEffect(function () {
    var _values$formLogic14, _values$formLogic14$r;
    if ((values === null || values === void 0 ? void 0 : (_values$formLogic14 = values.formLogic) === null || _values$formLogic14 === void 0 ? void 0 : (_values$formLogic14$r = _values$formLogic14.reportDetails) === null || _values$formLogic14$r === void 0 ? void 0 : _values$formLogic14$r.reportPersons.length) > 0) {
      var _values$collector6, _values$collector6$en, _values$formLogic15, _values$formLogic15$r;
      var filteredEntity = values === null || values === void 0 ? void 0 : (_values$collector6 = values.collector) === null || _values$collector6 === void 0 ? void 0 : (_values$collector6$en = _values$collector6.entity) === null || _values$collector6$en === void 0 ? void 0 : _values$collector6$en.filter(function (item) {
        var _item$entityRelations;
        return (item === null || item === void 0 ? void 0 : (_item$entityRelations = item.entityRelationship[0]) === null || _item$entityRelations === void 0 ? void 0 : _item$entityRelations.relationshipType) !== RelationshipType.Reportee;
      });
      setFieldValue('collector.entity', [].concat(_toConsumableArray(filteredEntity), _toConsumableArray(values === null || values === void 0 ? void 0 : (_values$formLogic15 = values.formLogic) === null || _values$formLogic15 === void 0 ? void 0 : (_values$formLogic15$r = _values$formLogic15.reportDetails) === null || _values$formLogic15$r === void 0 ? void 0 : _values$formLogic15$r.reportPersons)));
    }
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic16 = values.formLogic) === null || _values$formLogic16 === void 0 ? void 0 : (_values$formLogic16$r = _values$formLogic16.reportDetails) === null || _values$formLogic16$r === void 0 ? void 0 : _values$formLogic16$r.reportPersons]);
  useEffect(function () {
    if ((spRelationshipOther === null || spRelationshipOther === void 0 ? void 0 : spRelationshipOther.length) > 0) {
      var _values$collector7, _values$collector7$qu;
      var index = values === null || values === void 0 ? void 0 : (_values$collector7 = values.collector) === null || _values$collector7 === void 0 ? void 0 : (_values$collector7$qu = _values$collector7.questions) === null || _values$collector7$qu === void 0 ? void 0 : _values$collector7$qu.findIndex(function (item) {
        return item.questionId === 56;
      });
      setFieldValue("collector.questions[".concat(index, "].answerText"), spRelationshipOther, false);
    }
  }, [spRelationshipOther]);
  useEffect(function () {
    if ((contactTime === null || contactTime === void 0 ? void 0 : contactTime.length) > 0) {
      var _values$collector8, _values$collector8$qu;
      var index = values === null || values === void 0 ? void 0 : (_values$collector8 = values.collector) === null || _values$collector8 === void 0 ? void 0 : (_values$collector8$qu = _values$collector8.questions) === null || _values$collector8$qu === void 0 ? void 0 : _values$collector8$qu.findIndex(function (item) {
        return item.questionId === 55;
      });
      setFieldValue("collector.questions[".concat(index, "].answerText"), contactTime, false);
    }
  }, [contactTime]);
  useEffect(function () {
    var radioDefaultValue = showBasicForm ? '' : 'yes';
    var reporteeInitArr = showBasicForm ? [reporteeInitObj, reporteeInitObj] : [reporteeInitObj];
    setFieldValue('collector.questions', [{
      answerText: '',
      questionId: 51,
      questionText: 'Describe the misconduct you would like to report.'
    }, {
      answerText: '',
      questionId: 52,
      questionText: 'Where did the misconduct occur?'
    }, {
      answerText: '',
      questionId: 53,
      questionText: 'When did the misconduct occur?'
    }, {
      answerText: radioDefaultValue,
      questionId: 54,
      questionText: 'May we contact you about this report?'
    }, {
      answerText: '',
      questionId: 56,
      questionText: 'What was your relationship to BGEA at the time the misconduct occurred?'
    }]);
    setFieldValue('formLogic.reportDetails.contactOptIn', radioDefaultValue, false);
    setFieldValue('formLogic.reportDetails.spRelationship', '', false);
    setFieldValue('formLogic.reportDetails.reportPersons', reporteeInitArr, false);
    setFieldValue('collector.entity', [reporteeInitObj], false);
  }, []);
  delete values.collector.cart;
  return {
    contactOptions: contactOptions,
    contactTimes: contactTimes,
    reportPersonsList: reportPersonsList,
    showContactFields: showContactFields,
    showRemoveButton: showRemoveButton,
    showSPRelationshipInput: showSPRelationshipInput,
    spRelationshipOptions: spRelationshipOptions,
    values: values,
    handleAddPerson: handleAddPerson,
    handleRemovePerson: handleRemovePerson
  };
};

var useMonthlyDonationModal = function useMonthlyDonationModal(_ref) {
  var showModal = _ref.showModal,
    setShowMonthlyModal = _ref.setShowMonthlyModal;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState = useState(showModal),
    _useState2 = _slicedToArray(_useState, 2),
    modalIsOpen = _useState2[0],
    setModalIsOpen = _useState2[1];
  var titleText = 'Would you consider switching to a $10 monthly gift?';
  var yesButtonText = 'Yes! Switch to $10 monthly.';
  var noButtonText = "No thanks. Proceed with $".concat(values.collector.cart.donation.projects[0].amount, " now.");
  var monthlyModalCopy = "Did you know you can be a part of sharing the Gospel each month by turning your <b>one-time $".concat(values.collector.cart.donation.projects[0].amount, " donation into a $10 recurring gift?</b> It\u2019s a convenient and secure way for you to share the hope of Jesus Christ on a regular basis.");
  var handleOnCloseModal = function handleOnCloseModal() {
    userChoiceEvent({
      amount: values.collector.cart.donation.projects[0].amount,
      confirmed: null,
      recurring: null,
      value: null
    });
    setModalIsOpen(false);
    setShowMonthlyModal(false);
  };
  var handleOnNoEvent = function handleOnNoEvent(e) {
    e.preventDefault();
    userChoiceEvent({
      amount: values.collector.cart.donation.projects[0].amount,
      confirmed: null,
      recurring: 'N',
      value: 'N'
    });
    setFieldValue('formLogic.isMonthlyUserChoice', 'N');
    setModalIsOpen(false);
    setShowMonthlyModal(false);
  };
  var handleOnYesEvent = function handleOnYesEvent(e) {
    e.preventDefault();
    userChoiceEvent({
      amount: 10,
      confirmed: null,
      recurring: 'Y',
      value: 'Y'
    });
    setFieldValue("collector.cart.donation.projects[0].amount", 10, false);
    setFieldValue('formLogic.cart.donation.projects.[0].isRecurring', true, false);
    setFieldValue('formLogic.isMonthlyUserChoice', 'Y');
    setModalIsOpen(false);
    setShowMonthlyModal(false);
  };
  return {
    modalIsOpen: modalIsOpen,
    monthlyModalCopy: monthlyModalCopy,
    noButtonText: noButtonText,
    titleText: titleText,
    yesButtonText: yesButtonText,
    handleOnCloseModal: handleOnCloseModal,
    handleOnNoEvent: handleOnNoEvent,
    handleOnYesEvent: handleOnYesEvent
  };
};

var _excluded$I = ["campaignCodes", "donateProp", "emailTemplateCampaign", "hasCaptchaPaymentMethod", "mailBox", "productCode", "warehouse", "productTitle", "useRecaptchaV2", "values", "setFieldValue"];
var setIntialData = function setIntialData(_ref) {
  var _props$parentDocument;
  var campaignCodes = _ref.campaignCodes,
    donateProp = _ref.donateProp,
    emailTemplateCampaign = _ref.emailTemplateCampaign,
    hasCaptchaPaymentMethod = _ref.hasCaptchaPaymentMethod,
    mailBox = _ref.mailBox,
    productCode = _ref.productCode,
    warehouse = _ref.warehouse,
    productTitle = _ref.productTitle,
    useRecaptchaV2 = _ref.useRecaptchaV2,
    setFieldValue = _ref.setFieldValue,
    props = _objectWithoutProperties(_ref, _excluded$I);
  var queryDict = getQueryStringDict((props === null || props === void 0 ? void 0 : (_props$parentDocument = props.parentDocumentInfo) === null || _props$parentDocument === void 0 ? void 0 : _props$parentDocument.formQueryString) || '');
  if (hasCaptchaPaymentMethod) {
    setFieldValue("formLogic.hasCaptchaBluefinPaymentIframe", hasCaptchaPaymentMethod);
  }
  if (useRecaptchaV2) {
    setFieldValue("formLogic.useRecaptchaV2", useRecaptchaV2);
  }
  setFieldValue("formLogic.productTitle", productTitle);
  if (emailTemplateCampaign) {
    setFieldValue("formLogic.emailTemplateCampaign", emailTemplateCampaign);
  }
  if (campaignCodes) {
    setFieldValue("collector.entity[0].code", campaignCodes);
  }
  setFieldValue("formLogic.mail", mailBox);
  if (donateProp) {
    setFieldValue("formLogic.modalConfirmation", true);
    setFieldValue("formLogic.donate", true);
  }
  if (productCode) {
    var products = [_objectSpread2({
      amount: 0,
      productId: productCode,
      quantity: 1
    }, (warehouse === null || warehouse === void 0 ? void 0 : warehouse.length) > 0 && {
      warehouse: warehouse
    })];
    setFieldValue("formLogic.productCode", productCode);
    setFieldValue("collector.cart.products", products, false);
    setFieldValue("collector.cart.cartTotals.subTotal", 0, false);
  }
  if (props !== null && props !== void 0 && props.resourceUrl) {
    setFieldValue("formLogic.resourceUrl", props === null || props === void 0 ? void 0 : props.resourceUrl);
  }
  if ((queryDict === null || queryDict === void 0 ? void 0 : queryDict.testRecaptchaFallback) === 'true') {
    setFieldValue('formLogic.testRecaptchaFallback', true);
  }
};

var _excluded$H = ["campaignCodes", "donateProp", "emailTemplateCampaign", "hasCaptchaPaymentMethod", "mailBox", "maxPostalCodeLength", "minPostalCodeLength", "productCode", "warehouse", "productTitle", "useRecaptchaV2"];
var useNewNames = function useNewNames(_ref) {
  var _values$formLogic, _values$collector$ent17, _values$collector$ent18, _values$collector$ent19, _values$collector$ent20, _values$collector$ent21, _values$collector$ent22, _values$collector$ent23, _values$collector$ent27, _values$collector$ent28;
  var campaignCodes = _ref.campaignCodes,
    _ref$donateProp = _ref.donateProp,
    donateProp = _ref$donateProp === void 0 ? false : _ref$donateProp,
    emailTemplateCampaign = _ref.emailTemplateCampaign,
    _ref$hasCaptchaPaymen = _ref.hasCaptchaPaymentMethod,
    hasCaptchaPaymentMethod = _ref$hasCaptchaPaymen === void 0 ? true : _ref$hasCaptchaPaymen,
    _ref$mailBox = _ref.mailBox,
    mailBox = _ref$mailBox === void 0 ? true : _ref$mailBox,
    _ref$maxPostalCodeLen = _ref.maxPostalCodeLength,
    maxPostalCodeLength = _ref$maxPostalCodeLen === void 0 ? maximumPostalCodeLength : _ref$maxPostalCodeLen,
    _ref$minPostalCodeLen = _ref.minPostalCodeLength,
    minPostalCodeLength = _ref$minPostalCodeLen === void 0 ? minimumPostalCodeLength : _ref$minPostalCodeLen,
    _ref$productCode = _ref.productCode,
    productCode = _ref$productCode === void 0 ? '' : _ref$productCode,
    _ref$warehouse = _ref.warehouse,
    warehouse = _ref$warehouse === void 0 ? '' : _ref$warehouse,
    productTitle = _ref.productTitle,
    _ref$useRecaptchaV = _ref.useRecaptchaV2,
    useRecaptchaV2 = _ref$useRecaptchaV === void 0 ? false : _ref$useRecaptchaV,
    props = _objectWithoutProperties(_ref, _excluded$H);
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  var _useFormikContext = useFormikContext(),
    validateForm = _useFormikContext.validateForm,
    values = _useFormikContext.values,
    setFieldTouched = _useFormikContext.setFieldTouched,
    setFieldValue = _useFormikContext.setFieldValue,
    isValid = _useFormikContext.isValid;
  useLogicInfo({
    useLogicNoDuplicate: props === null || props === void 0 ? void 0 : props.useLogicNoDuplicate
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormValid = _useState2[0],
    setIsFormValid = _useState2[1];
  var formName = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.formName;
  var visibleList = ['firstName', 'lastName'];
  var templateName = !formName ? Templates.NEW_NAMES : "".concat(Templates.NEW_NAMES, "/").concat(formName);
  var validatePostalCode = function validatePostalCode(value) {
    return validateZipPostalCode(value, minPostalCodeLength, maxPostalCodeLength, translations === null || translations === void 0 ? void 0 : translations.invalidPostalCode);
  };
  useEffect(function () {
    var _values$collector$ent, _values$collector$ent2, _values$collector$ent3, _values$collector$ent4, _values$collector$ent5, _values$collector$ent6, _values$collector$ent7, _values$collector$ent8, _values$collector$ent9, _values$collector$ent10, _values$collector$ent11;
    if ((_values$collector$ent = values.collector.entity[0]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.over18 && ((_values$collector$ent2 = values.collector.entity[0]) === null || _values$collector$ent2 === void 0 ? void 0 : (_values$collector$ent3 = _values$collector$ent2.firstName) === null || _values$collector$ent3 === void 0 ? void 0 : _values$collector$ent3.length) > 0 && ((_values$collector$ent4 = values.collector.entity[0]) === null || _values$collector$ent4 === void 0 ? void 0 : (_values$collector$ent5 = _values$collector$ent4.lastName) === null || _values$collector$ent5 === void 0 ? void 0 : _values$collector$ent5.length) > 0 && ((_values$collector$ent6 = values.collector.entity[0]) === null || _values$collector$ent6 === void 0 ? void 0 : (_values$collector$ent7 = _values$collector$ent6.email[0]) === null || _values$collector$ent7 === void 0 ? void 0 : (_values$collector$ent8 = _values$collector$ent7.emailAddress) === null || _values$collector$ent8 === void 0 ? void 0 : _values$collector$ent8.length) > 0 && ((_values$collector$ent9 = values.collector.entity[0]) === null || _values$collector$ent9 === void 0 ? void 0 : (_values$collector$ent10 = _values$collector$ent9.address[0]) === null || _values$collector$ent10 === void 0 ? void 0 : (_values$collector$ent11 = _values$collector$ent10.zipPostalCode) === null || _values$collector$ent11 === void 0 ? void 0 : _values$collector$ent11.length) === minPostalCodeLength) {
      var _values$collector$ent12, _values$collector$ent13, _values$collector$ent14, _values$collector$ent15, _values$collector$ent16;
      bgeaObj.entity = {
        firstName: (_values$collector$ent12 = values.collector.entity[0]) === null || _values$collector$ent12 === void 0 ? void 0 : _values$collector$ent12.firstName,
        lastName: (_values$collector$ent13 = values.collector.entity[0]) === null || _values$collector$ent13 === void 0 ? void 0 : _values$collector$ent13.lastName,
        email: (_values$collector$ent14 = values.collector.entity[0]) === null || _values$collector$ent14 === void 0 ? void 0 : _values$collector$ent14.email,
        address: [{
          zipPostalCode: (_values$collector$ent15 = values.collector.entity[0]) === null || _values$collector$ent15 === void 0 ? void 0 : (_values$collector$ent16 = _values$collector$ent15.address[0]) === null || _values$collector$ent16 === void 0 ? void 0 : _values$collector$ent16.zipPostalCode
        }]
      };
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [(_values$collector$ent17 = values.collector.entity[0]) === null || _values$collector$ent17 === void 0 ? void 0 : _values$collector$ent17.over18, (_values$collector$ent18 = values.collector.entity[0]) === null || _values$collector$ent18 === void 0 ? void 0 : _values$collector$ent18.firstName, (_values$collector$ent19 = values.collector.entity[0]) === null || _values$collector$ent19 === void 0 ? void 0 : _values$collector$ent19.lastName, (_values$collector$ent20 = values.collector.entity[0]) === null || _values$collector$ent20 === void 0 ? void 0 : (_values$collector$ent21 = _values$collector$ent20.email[0]) === null || _values$collector$ent21 === void 0 ? void 0 : _values$collector$ent21.emailAddress, (_values$collector$ent22 = values.collector.entity[0]) === null || _values$collector$ent22 === void 0 ? void 0 : (_values$collector$ent23 = _values$collector$ent22.address[0]) === null || _values$collector$ent23 === void 0 ? void 0 : _values$collector$ent23.zipPostalCode]);
  useEffect(function () {
    var _values$collector$ent24, _values$collector$ent25, _values$collector$ent26;
    if (((_values$collector$ent24 = values.collector.entity[0]) === null || _values$collector$ent24 === void 0 ? void 0 : (_values$collector$ent25 = _values$collector$ent24.address[0]) === null || _values$collector$ent25 === void 0 ? void 0 : (_values$collector$ent26 = _values$collector$ent25.zipPostalCode) === null || _values$collector$ent26 === void 0 ? void 0 : _values$collector$ent26.length) > maxPostalCodeLength) {
      setFieldTouched("collector.entity[0].address[0].zipPostalCode", true);
    }
  }, [(_values$collector$ent27 = values.collector.entity[0]) === null || _values$collector$ent27 === void 0 ? void 0 : (_values$collector$ent28 = _values$collector$ent27.address[0]) === null || _values$collector$ent28 === void 0 ? void 0 : _values$collector$ent28.zipPostalCode]);
  useEffect(function () {
    validateForm();
  }, [isFormValid]);
  useEffect(function () {
    setFormId({
      templateName: templateName,
      values: values,
      setFieldValue: setFieldValue
    });
  }, [templateName]);
  useEffect(function () {
    setIntialData(_objectSpread2({
      campaignCodes: campaignCodes,
      donateProp: donateProp,
      emailTemplateCampaign: emailTemplateCampaign,
      hasCaptchaPaymentMethod: hasCaptchaPaymentMethod,
      mailBox: mailBox,
      productCode: productCode,
      warehouse: warehouse,
      productTitle: productTitle,
      useRecaptchaV2: useRecaptchaV2,
      values: values,
      setFieldValue: setFieldValue
    }, props));
    if (values) {
      validateForm();
    }
  }, []);
  return {
    isValid: isValid,
    privacyPolicyTextLabel: translations.privacyPolicyLabel,
    values: values,
    visibleList: visibleList,
    validatePostalCode: validatePostalCode
  };
};

var setEntity = function setEntity(setFieldValue) {
  var _Object$values;
  if (((_Object$values = Object.values(bgeaObj.entity)) === null || _Object$values === void 0 ? void 0 : _Object$values.length) > 0) {
    var _bgeaObj$entity, _bgeaObj$entity3, _bgeaObj$entity5, _bgeaObj$entity5$emai, _bgeaObj$entity7, _bgeaObj$entity7$addr;
    if (bgeaObj !== null && bgeaObj !== void 0 && (_bgeaObj$entity = bgeaObj.entity) !== null && _bgeaObj$entity !== void 0 && _bgeaObj$entity.firstName) {
      var _bgeaObj$entity2;
      setFieldValue('collector.entity[0].firstName', bgeaObj === null || bgeaObj === void 0 ? void 0 : (_bgeaObj$entity2 = bgeaObj.entity) === null || _bgeaObj$entity2 === void 0 ? void 0 : _bgeaObj$entity2.firstName);
    }
    if (bgeaObj !== null && bgeaObj !== void 0 && (_bgeaObj$entity3 = bgeaObj.entity) !== null && _bgeaObj$entity3 !== void 0 && _bgeaObj$entity3.lastName) {
      var _bgeaObj$entity4;
      setFieldValue('collector.entity[0].lastName', bgeaObj === null || bgeaObj === void 0 ? void 0 : (_bgeaObj$entity4 = bgeaObj.entity) === null || _bgeaObj$entity4 === void 0 ? void 0 : _bgeaObj$entity4.lastName);
    }
    if (bgeaObj !== null && bgeaObj !== void 0 && (_bgeaObj$entity5 = bgeaObj.entity) !== null && _bgeaObj$entity5 !== void 0 && (_bgeaObj$entity5$emai = _bgeaObj$entity5.email[0]) !== null && _bgeaObj$entity5$emai !== void 0 && _bgeaObj$entity5$emai.emailAddress) {
      var _bgeaObj$entity6, _bgeaObj$entity6$emai;
      setFieldValue('collector.entity[0].email[0].emailAddress', bgeaObj === null || bgeaObj === void 0 ? void 0 : (_bgeaObj$entity6 = bgeaObj.entity) === null || _bgeaObj$entity6 === void 0 ? void 0 : (_bgeaObj$entity6$emai = _bgeaObj$entity6.email[0]) === null || _bgeaObj$entity6$emai === void 0 ? void 0 : _bgeaObj$entity6$emai.emailAddress);
    }
    if (bgeaObj !== null && bgeaObj !== void 0 && (_bgeaObj$entity7 = bgeaObj.entity) !== null && _bgeaObj$entity7 !== void 0 && (_bgeaObj$entity7$addr = _bgeaObj$entity7.address[0]) !== null && _bgeaObj$entity7$addr !== void 0 && _bgeaObj$entity7$addr.zipPostalCode) {
      var _bgeaObj$entity8, _bgeaObj$entity8$addr;
      setFieldValue('collector.entity[0].address[0].zipPostalCode', bgeaObj === null || bgeaObj === void 0 ? void 0 : (_bgeaObj$entity8 = bgeaObj.entity) === null || _bgeaObj$entity8 === void 0 ? void 0 : (_bgeaObj$entity8$addr = _bgeaObj$entity8.address[0]) === null || _bgeaObj$entity8$addr === void 0 ? void 0 : _bgeaObj$entity8$addr.zipPostalCode);
    }
  }
};

var _excluded$G = ["campaignCodes", "donationEsubCodes", "usePaypalCaptureOnly"];
var useNewNamesDonation = function useNewNamesDonation(_ref) {
  var _values$formLogic;
  var campaignCodes = _ref.campaignCodes,
    donationEsubCodes = _ref.donationEsubCodes,
    usePaypalCaptureOnly = _ref.usePaypalCaptureOnly,
    props = _objectWithoutProperties(_ref, _excluded$G);
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedEsubs = _useState2[0],
    setSelectedEsubs = _useState2[1];
  var confirmationRef = useRef(null);
  var _values$collector$ent = _slicedToArray(values.collector.entity, 1),
    firstName = _values$collector$ent[0].firstName;
  var donationFormName = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.donationFormName;
  var templateName = !donationFormName ? Templates.NEW_NAMES_DONATION : "".concat(Templates.NEW_NAMES_DONATION, "/").concat(donationFormName);
  var resourceTitle = props !== null && props !== void 0 && props.resourceTitle ? props === null || props === void 0 ? void 0 : props.resourceTitle : props === null || props === void 0 ? void 0 : props.resourceName;
  var resourceName = props !== null && props !== void 0 && props.resourceName ? "\"".concat(props === null || props === void 0 ? void 0 : props.resourceName, "\"") : 'resource';
  var resourceTitleText = resourceTitle || resourceName;
  var showDeliveryMessage = (props === null || props === void 0 ? void 0 : props.mailBox) && typeof (props === null || props === void 0 ? void 0 : props.deliveryMessage) !== 'undefined';
  var handleScrollIntoView = function handleScrollIntoView() {
    var _confirmationRef$curr, _confirmationRef$curr2;
    window.scrollTo(0, 0); // Match existing UX on Production, scroll to the top then to the element.
    window.scrollTo({
      top: (confirmationRef === null || confirmationRef === void 0 ? void 0 : (_confirmationRef$curr = confirmationRef.current) === null || _confirmationRef$curr === void 0 ? void 0 : (_confirmationRef$curr2 = _confirmationRef$curr.getBoundingClientRect()) === null || _confirmationRef$curr2 === void 0 ? void 0 : _confirmationRef$curr2.top) || 0,
      behavior: 'smooth'
    });
    if (props !== null && props !== void 0 && props.isEmbedSite) {
      var postObject = JSON.stringify({
        scrollToTop: true
      });
      window.top.postMessage(postObject, '*');
    }
  };
  useEmailSubscription({
    esubCodes: selectedEsubs
  });
  useEmail({
    emailId: 'NewNamesReceipt'
  });
  useCollectionType({
    collectionType: props === null || props === void 0 ? void 0 : props.donationCollectionType
  });
  useEffect(function () {
    setFormId({
      templateName: templateName,
      values: values,
      setFieldValue: setFieldValue
    });
  }, [templateName]);
  useEffect(function () {
    var _values$formLogic2, _values$formLogic2$pa;
    if (donationEsubCodes && (donationEsubCodes === null || donationEsubCodes === void 0 ? void 0 : donationEsubCodes.length) > 0) {
      var esubCodes = [];
      donationEsubCodes.forEach(function (code) {
        esubCodes.push({
          esubCode: code,
          isActive: true
        });
      });
      setSelectedEsubs(esubCodes);
    }
    if ((campaignCodes === null || campaignCodes === void 0 ? void 0 : campaignCodes.length) > 0) {
      // Empty code for donation modal
      setFieldValue("collector.entity[0].code", []);
    }
    if (props !== null && props !== void 0 && props.donationAmt) {
      setFieldValue("collector.cart.donation.projects[0].amount", props === null || props === void 0 ? void 0 : props.donationAmt);
    }
    if (usePaypalCaptureOnly) {
      setFieldValue('formLogic.usePaypalCaptureOnly', true);
    }
    trackEvent('bgform', {
      formCategory: getFormId(Templates.NEW_NAMES),
      formAction: Analytics.LEAD_CONFIRMATION,
      formLabel: (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$pa = _values$formLogic2.parentDocumentInfo) === null || _values$formLogic2$pa === void 0 ? void 0 : _values$formLogic2$pa.documentLocationHref) || document.location.href,
      formValue: 1
    });
    handleScrollIntoView();
    setEntity(setFieldValue);
    setFieldValue('formLogic.isDonation', true);
    setFieldValue("formLogic.deliveryMessage", props === null || props === void 0 ? void 0 : props.deliveryMessage, false);
    setFieldValue("formLogic.showDeliveryMessage", showDeliveryMessage, false);
  }, []);
  return {
    firstName: firstName,
    confirmationRef: confirmationRef,
    resourceTitleText: resourceTitleText,
    values: values
  };
};

var useNewNamesDonationModal = function useNewNamesDonationModal() {
  var _useState = useState(true),
    _useState2 = _slicedToArray(_useState, 2),
    modalIsOpen = _useState2[0],
    setModalIsOpen = _useState2[1];
  var handleOnCloseModal = function handleOnCloseModal() {
    setModalIsOpen(false);
  };
  return {
    modalIsOpen: modalIsOpen,
    handleOnCloseModal: handleOnCloseModal
  };
};

var MIN_MONTHLY_VALUE = 99;
var MAX_MONTHLY_VALUE = 110;
var shouldShowPaymentInfo = function shouldShowPaymentInfo(showPaymentInfo, values) {
  var _values$collector, _values$collector$car, _values$collector$car2, _values$formLogic, _values$formLogic$car, _values$formLogic$car2, _values$formLogic$car3, _values$formLogic$car4;
  if (!showPaymentInfo) return false;
  var currentProject = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.donation) === null || _values$collector$car2 === void 0 ? void 0 : _values$collector$car2.projects[0];
  var isRecurring = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$car = _values$formLogic.cart) === null || _values$formLogic$car === void 0 ? void 0 : (_values$formLogic$car2 = _values$formLogic$car.donation) === null || _values$formLogic$car2 === void 0 ? void 0 : (_values$formLogic$car3 = _values$formLogic$car2.projects) === null || _values$formLogic$car3 === void 0 ? void 0 : (_values$formLogic$car4 = _values$formLogic$car3[0]) === null || _values$formLogic$car4 === void 0 ? void 0 : _values$formLogic$car4.isRecurring;
  return showPaymentInfo && (currentProject === null || currentProject === void 0 ? void 0 : currentProject.amount) && !isRecurring || showPaymentInfo && isRecurring && (currentProject === null || currentProject === void 0 ? void 0 : currentProject.amount) && (currentProject === null || currentProject === void 0 ? void 0 : currentProject.recurringDate);
};
var convertToCamelCase = function convertToCamelCase(str) {
  return str.toLowerCase().replace(/[^a-zA-Z0-9]+(.)/g, function (m, chr) {
    return chr.toUpperCase();
  });
};
var updateCodesField = function updateCodesField(codes, setFieldValue, values) {
  codes.forEach(function (code) {
    setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(values.collector.entity[0].code || []), [code]));
  });
};
var updateProjectId = function updateProjectId(objState, donationOptions, setFieldValue) {
  var _donationOptions$;
  var _Object$keys = Object.keys(objState),
    _Object$keys2 = _slicedToArray(_Object$keys, 1),
    projectId = _Object$keys2[0];
  var selectedProjectId = ((_donationOptions$ = donationOptions[0]) === null || _donationOptions$ === void 0 ? void 0 : _donationOptions$.id) || projectId;
  if (!isNaN(selectedProjectId)) {
    setFieldValue("collector.cart.donation.projects[0].projectId", parseInt(selectedProjectId, 10), false);
  } else {
    setFieldValue("collector.cart.donation.projects[0].projectId", 200001, false);
  }
};
var updateDonationLocation = function updateDonationLocation(values, setFieldValue) {
  var _values$formLogic2;
  if (values !== null && values !== void 0 && (_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && _values$formLogic2.donationLocation) {
    var projectId = parseInt(values.formLogic.donationLocation, 10);
    setFieldValue("collector.cart.donation.projects[0].projectId", projectId, false);
  }
};
var updateInitialDonationLocation = function updateInitialDonationLocation(donationOptions, objStateKeys, values, setFieldValue) {
  var _values$formLogic3, _values$formLogic4;
  if (donationOptions && donationOptions.length === 1 && values !== null && values !== void 0 && (_values$formLogic3 = values.formLogic) !== null && _values$formLogic3 !== void 0 && _values$formLogic3.donationLocation) {
    var _donationOptions$2;
    setFieldValue('formLogic.donationLocation', (_donationOptions$2 = donationOptions[0]) === null || _donationOptions$2 === void 0 ? void 0 : _donationOptions$2.id);
  } else if (!donationOptions && objStateKeys.length === 1 && values !== null && values !== void 0 && (_values$formLogic4 = values.formLogic) !== null && _values$formLogic4 !== void 0 && _values$formLogic4.donationLocation) {
    setFieldValue('formLogic.donationLocation', objStateKeys[0]);
  }
};
var handleEmailId = function handleEmailId(_ref) {
  var _values$email, _values$collector2, _values$collector2$en, _values$collector3, _values$collector3$en, _values$collector3$en2, _values$collector3$en3, _values$collector4, _values$collector4$en, _values$collector5, _values$collector5$en, _values$collector5$en2, _values$collector5$en3;
  var values = _ref.values,
    setFieldValue = _ref.setFieldValue;
  if (!(values !== null && values !== void 0 && (_values$email = values.email) !== null && _values$email !== void 0 && _values$email.emailId) && values !== null && values !== void 0 && (_values$collector2 = values.collector) !== null && _values$collector2 !== void 0 && (_values$collector2$en = _values$collector2.entity[0]) !== null && _values$collector2$en !== void 0 && _values$collector2$en.email && (values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.email[0]) === null || _values$collector3$en2 === void 0 ? void 0 : (_values$collector3$en3 = _values$collector3$en2.emailAddress) === null || _values$collector3$en3 === void 0 ? void 0 : _values$collector3$en3.length) > 0) {
    setFieldValue('email.emailId', 'DonationReceiptBGEA', false);
    setFieldValue("collector.entity[0].email[0].emailSubscription", [{
      esubCode: 'BGEA',
      isActive: true
    }, {
      esubCode: 'PLTR',
      isActive: true
    }]);
  } else if (values !== null && values !== void 0 && (_values$collector4 = values.collector) !== null && _values$collector4 !== void 0 && (_values$collector4$en = _values$collector4.entity[0]) !== null && _values$collector4$en !== void 0 && _values$collector4$en.email && (values === null || values === void 0 ? void 0 : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? void 0 : (_values$collector5$en = _values$collector5.entity[0]) === null || _values$collector5$en === void 0 ? void 0 : (_values$collector5$en2 = _values$collector5$en.email[0]) === null || _values$collector5$en2 === void 0 ? void 0 : (_values$collector5$en3 = _values$collector5$en2.emailAddress) === null || _values$collector5$en3 === void 0 ? void 0 : _values$collector5$en3.length) === 0) {
    var _values$collector6, _values$collector6$en;
    values === null || values === void 0 ? true : delete values.email;
    if (values !== null && values !== void 0 && (_values$collector6 = values.collector) !== null && _values$collector6 !== void 0 && (_values$collector6$en = _values$collector6.entity[0]) !== null && _values$collector6$en !== void 0 && _values$collector6$en.email) {
      var _values$collector7, _values$collector7$en;
      values === null || values === void 0 ? true : (_values$collector7 = values.collector) === null || _values$collector7 === void 0 ? true : (_values$collector7$en = _values$collector7.entity[0]) === null || _values$collector7$en === void 0 ? true : delete _values$collector7$en.email;
    }
  }
};
var isOnlineGivingFormValid = function isOnlineGivingFormValid(_ref2) {
  var _values$collector8, _values$collector8$en, _values$collector8$en2, _values$collector9, _values$collector9$en, _values$collector9$en2, _values$collector10, _values$collector10$e, _values$collector10$e2, _values$collector10$e3, _values$collector11, _values$collector11$e, _values$collector11$e2, _values$collector11$e3, _values$collector12, _values$collector12$e, _values$collector12$e2, _values$collector13, _values$collector13$e, _values$collector13$e2, _values$collector13$e3, _values$payment, _values$payment$bluef, _values$payment$bluef2, _values$collector$ent, _values$collector$ent2, _values$collector$ent3;
  var values = _ref2.values;
  return (values === null || values === void 0 ? void 0 : (_values$collector8 = values.collector) === null || _values$collector8 === void 0 ? void 0 : (_values$collector8$en = _values$collector8.entity[0]) === null || _values$collector8$en === void 0 ? void 0 : (_values$collector8$en2 = _values$collector8$en.firstName) === null || _values$collector8$en2 === void 0 ? void 0 : _values$collector8$en2.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$collector9 = values.collector) === null || _values$collector9 === void 0 ? void 0 : (_values$collector9$en = _values$collector9.entity[0]) === null || _values$collector9$en === void 0 ? void 0 : (_values$collector9$en2 = _values$collector9$en.lastName) === null || _values$collector9$en2 === void 0 ? void 0 : _values$collector9$en2.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$collector10 = values.collector) === null || _values$collector10 === void 0 ? void 0 : (_values$collector10$e = _values$collector10.entity[0]) === null || _values$collector10$e === void 0 ? void 0 : (_values$collector10$e2 = _values$collector10$e.phone[0]) === null || _values$collector10$e2 === void 0 ? void 0 : (_values$collector10$e3 = _values$collector10$e2.phoneNumber) === null || _values$collector10$e3 === void 0 ? void 0 : _values$collector10$e3.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$collector11 = values.collector) === null || _values$collector11 === void 0 ? void 0 : (_values$collector11$e = _values$collector11.entity[0]) === null || _values$collector11$e === void 0 ? void 0 : (_values$collector11$e2 = _values$collector11$e.address[0]) === null || _values$collector11$e2 === void 0 ? void 0 : (_values$collector11$e3 = _values$collector11$e2.street) === null || _values$collector11$e3 === void 0 ? void 0 : _values$collector11$e3.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$collector12 = values.collector) === null || _values$collector12 === void 0 ? void 0 : (_values$collector12$e = _values$collector12.entity[0]) === null || _values$collector12$e === void 0 ? void 0 : (_values$collector12$e2 = _values$collector12$e.address[0]) === null || _values$collector12$e2 === void 0 ? void 0 : _values$collector12$e2.cityTownRegion.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$collector13 = values.collector) === null || _values$collector13 === void 0 ? void 0 : (_values$collector13$e = _values$collector13.entity[0]) === null || _values$collector13$e === void 0 ? void 0 : (_values$collector13$e2 = _values$collector13$e.address[0]) === null || _values$collector13$e2 === void 0 ? void 0 : (_values$collector13$e3 = _values$collector13$e2.stateProvince) === null || _values$collector13$e3 === void 0 ? void 0 : _values$collector13$e3.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$payment = values.payment) === null || _values$payment === void 0 ? void 0 : (_values$payment$bluef = _values$payment.bluefinECC) === null || _values$payment$bluef === void 0 ? void 0 : (_values$payment$bluef2 = _values$payment$bluef.data) === null || _values$payment$bluef2 === void 0 ? void 0 : _values$payment$bluef2.length) > 0 && (values === null || values === void 0 ? void 0 : (_values$collector$ent = values.collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.address[0]) === null || _values$collector$ent2 === void 0 ? void 0 : (_values$collector$ent3 = _values$collector$ent2.zipPostalCode) === null || _values$collector$ent3 === void 0 ? void 0 : _values$collector$ent3.length) > 0;
};
var setInitializeDonation = function setInitializeDonation(_ref3) {
  var defaultDebitDay = _ref3.defaultDebitDay,
    deliveryStatement = _ref3.deliveryStatement,
    isMonthly = _ref3.isMonthly,
    projectTitle = _ref3.projectTitle,
    recurringToggle = _ref3.recurringToggle,
    showFreeGiftOffer = _ref3.showFreeGiftOffer,
    showUpgradeGift = _ref3.showUpgradeGift,
    setFieldValue = _ref3.setFieldValue;
  if (defaultDebitDay) {
    setFieldValue('formLogic.defaultDebitDay', defaultDebitDay);
  }
  if (showFreeGiftOffer) {
    setFieldValue("formLogic.showFreeGiftOffer", true);
  }
  if (deliveryStatement) {
    setFieldValue('formLogic.deliveryStatement', deliveryStatement);
  }
  if (showUpgradeGift) {
    setFieldValue('formLogic.showUpgradeGift', true);
  }
  if (projectTitle) {
    setFieldValue('formLogic.projectTitle', projectTitle);
  }
  if (recurringToggle) {
    setFieldValue('formLogic.cart.donation.projects.[0].isRecurring', isMonthly || false);
  }
};
var initializeDonation = function initializeDonation(campaignCodes, defaultDebitDay, deliveryStatement, donationOptions, options, objStateKeys, convertOptions, giftOffer, projectTitle, setFieldValue, showFreeGiftOffer, showUpgradeGift, updateCodes, updatePrjId, isMonthly, useRecaptchaV2, enableMonthlyModal, usePaypalCaptureOnly, recurringToggle, formQueryString, disablePaypalGiftOffer, enableApayPayment) {
  var _donationOptions$3, _Object$keys3;
  var queryDict = getQueryStringDict(formQueryString || '');
  convertOptions(options);
  updateCodes();
  if (objStateKeys.length > 1 && !(donationOptions !== null && donationOptions !== void 0 && donationOptions.length) || (donationOptions === null || donationOptions === void 0 ? void 0 : donationOptions.length) > 0 && (_donationOptions$3 = donationOptions[0]) !== null && _donationOptions$3 !== void 0 && _donationOptions$3.id) {
    updatePrjId();
  }
  setInitializeDonation({
    defaultDebitDay: defaultDebitDay,
    deliveryStatement: deliveryStatement,
    isMonthly: isMonthly,
    projectTitle: projectTitle,
    recurringToggle: recurringToggle,
    showFreeGiftOffer: showFreeGiftOffer,
    showUpgradeGift: showUpgradeGift,
    setFieldValue: setFieldValue
  });
  if (disablePaypalGiftOffer) {
    setFieldValue("formLogic.disablePaypalGiftOffer", disablePaypalGiftOffer);
  }
  if (useRecaptchaV2) {
    setFieldValue("formLogic.useRecaptchaV2", useRecaptchaV2);
  }
  if (campaignCodes) {
    setFieldValue("collector.entity[0].code", campaignCodes);
  }
  if ((queryDict === null || queryDict === void 0 ? void 0 : queryDict.testRecaptchaFallback) === 'true') {
    setFieldValue('formLogic.testRecaptchaFallback', true);
  }
  if (usePaypalCaptureOnly) {
    setFieldValue('formLogic.usePaypalCaptureOnly', true);
  }
  if (enableMonthlyModal) {
    setFieldValue('formLogic.enableMonthlyModal', true);
  }
  if (enableApayPayment) {
    setFieldValue("formLogic.enableApayPayment", true);
  }
  setFieldValue('formLogic.isDonation', true);

  /* Main Giving provides an object and displays component for user interaction to select/deselect checkbox
    whereas New Name Pages by default adds the free gift without user interaction and expects a string type as prop. */
  if (giftOffer && ((_Object$keys3 = Object.keys(giftOffer)) === null || _Object$keys3 === void 0 ? void 0 : _Object$keys3.length) > 0) {
    setFieldValue('formLogic.giftOffer', giftOffer);
    if (!showFreeGiftOffer && typeof giftOffer === 'string') {
      var products = [{
        amount: 0,
        productId: giftOffer,
        quantity: 1
      }];
      setFieldValue("collector.cart.products", products, false);
    } else if (!showFreeGiftOffer && Array.isArray(giftOffer)) {
      setFieldValue("collector.cart.products", giftOffer, false);
    }
  }
};
var resetDonation = function resetDonation(_ref4) {
  var values = _ref4.values,
    setFieldValue = _ref4.setFieldValue;
  setFieldValue("collector.cart.cartTotals.subTotal", 0);
  var projectObj = _objectSpread2({}, values.collector.cart.donation.projects[0]);
  if (projectObj !== null && projectObj !== void 0 && projectObj.amount) {
    delete projectObj.amount;
  }
  if (projectObj !== null && projectObj !== void 0 && projectObj.recurringDate) {
    delete projectObj.recurringDate;
  }
  setFieldValue("formLogic.isResetDonation", true);
  setFieldValue("collector.cart.donation.projects[0]", projectObj);
};
var handleMonthlyModal = function handleMonthlyModal(_ref5) {
  var _values$formLogic5;
  var values = _ref5.values,
    setFieldValue = _ref5.setFieldValue,
    setShowMonthlyModal = _ref5.setShowMonthlyModal;
  var secondsSinceEpoch = Math.round(Date.now() / 1000);
  var isOdd = secondsSinceEpoch % 2 === 1;
  var hasRecurringDate = !!(values !== null && values !== void 0 && (_values$formLogic5 = values.formLogic) !== null && _values$formLogic5 !== void 0 && _values$formLogic5.recurringDate);
  var _values$collector$car3 = _slicedToArray(values.collector.cart.donation.projects, 1),
    project = _values$collector$car3[0];
  if (!hasRecurringDate && (project === null || project === void 0 ? void 0 : project.amount) >= MIN_MONTHLY_VALUE && (project === null || project === void 0 ? void 0 : project.amount) <= MAX_MONTHLY_VALUE) {
    qualifyingGiftEvent({
      value: 'Y'
    });
    setFieldValue("formLogic.isQualifyingGift", 'Y');
    if (isOdd) {
      selectedForAskEvent({
        value: 'Y'
      });
      setFieldValue("formLogic.isSelectForAskGift", 'Y');
      setShowMonthlyModal(true);
    } else {
      selectedForAskEvent({
        value: 'N'
      });
      setFieldValue("formLogic.isSelectForAskGift", 'N');
    }
  } else {
    setFieldValue("formLogic.isQualifyingGift", 'N');
    qualifyingGiftEvent({
      value: 'N'
    });
  }
};

var useOnlineGiving = function useOnlineGiving() {
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isEnabled = _useState2[0],
    setIsEnabled = _useState2[1];
  useEffect(function () {
    handleEmailId({
      values: values,
      setFieldValue: setFieldValue
    });
    if (isOnlineGivingFormValid({
      values: values
    })) {
      setIsEnabled(true);
    } else {
      setIsEnabled(false);
    }
  }, [values]);
  return {
    isDisabled: !isEnabled,
    values: values
  };
};

var usePeaceWithGod = function usePeaceWithGod(_ref) {
  var _values$formLogic;
  var lng = _ref.lng,
    individualCodes = _ref.individualCodes,
    orgCodes = _ref.orgCodes,
    CTID = _ref.CTID,
    emailId = _ref.emailId,
    eventId = _ref.eventId,
    sessionId = _ref.sessionId,
    websiteId = _ref.websiteId,
    ip = _ref.ip,
    formTitle = _ref.formTitle,
    questionLabel = _ref.questionLabel,
    submitButtonLabel = _ref.submitButtonLabel;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var locales = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.locales;
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    i18n = _useTranslation.i18n,
    t = _useTranslation.t;
  var decisionOptions = [{
    label: t('I have prayed this prayer for the first time', {
      ns: 'labels'
    }),
    name: 'firstTimePray',
    id: 'firstTimePray',
    value: '0'
  }, {
    label: t('I have prayed this prayer in the past and I renewed it today', {
      ns: 'labels'
    }),
    name: 'renewPray',
    id: 'renewPray',
    value: '1'
  }];
  var genderOptions = [{
    value: 'F',
    id: 'F',
    name: 'female',
    label: t('Female', {
      ns: 'labels'
    })
  }, {
    value: 'M',
    id: 'M',
    name: 'male',
    label: t('Male', {
      ns: 'labels'
    })
  }];
  var labels = {
    decisionLabel: "".concat(t('What was your decision?', {
      ns: 'labels'
    }), "*"),
    genderLabel: "".concat(t('Gender', {
      ns: 'labels'
    }), "*"),
    questionLabel: t("".concat(questionLabel), {
      ns: 'labels'
    }),
    submitButtonLabel: t("".concat(submitButtonLabel), {
      ns: 'labels'
    }),
    formTitle: t("".concat(formTitle), {
      ns: 'labels'
    }),
    peaceWithGodSummary: t('Peace With God Summary', {
      ns: 'common'
    }),
    peaceWithGodSummary2: t('Peace With God Summary2', {
      ns: 'common'
    }),
    peaceWithGodQuestionSummary: t('Peace With God Question Summary', {
      ns: 'common'
    })
  };
  useEffect(function () {
    var _values$collector;
    if (((_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : _values$collector.refererUrl) === undefined && typeof window !== 'undefined') {
      var sanitizedUrl = window.location.href.replace(/[^-A-Za-z0-9+&@#/%?=~_|!:,.;()]/gim, '');
      setFieldValue('collector.refererUrl', sanitizedUrl);
    }
  }, [values.collector.refererUrl]);
  useEffect(function () {
    var typeInt = parseInt(values.formLogic.type, 10);
    setFieldValue('pwgFormData.type', typeInt);
  }, [values.formLogic.type]);
  useEffect(function () {
    CTID && setFieldValue('collector.collectionType', CTID);
    emailId && setFieldValue('email.emailId', emailId);
    eventId && setFieldValue('collector.entity[0].code[0].value', eventId);
    sessionId && setFieldValue('pwgFormData.session_id', sessionId);
    websiteId && setFieldValue('pwgFormData.website_id', websiteId);
    ip && setFieldValue('pwgFormData.ip', ip);
  }, [values.collector.collectionType, values.email.emailId, values.collector.entity[0].code]);
  useEffect(function () {
    if (locales !== 'undefined' || lng !== 'undefined') {
      i18n.changeLanguage(locales || lng);
    }
    individualCodes.forEach(function (code, i) {
      setFieldValue("collector.entity[0].code[".concat(i, "]"), {
        key: 'ATTRIBUTES',
        value: code
      });
    });
    orgCodes.forEach(function (code, i) {
      setFieldValue("collector.entity[1].code[".concat(i, "]"), {
        key: 'ATTRIBUTES',
        value: code
      });
    });
    var urlParams = new URLSearchParams(window.location.search);
    var profession = urlParams.get('profession');
    var bchurchid = urlParams.get('bchurchid');
    if (bchurchid) {
      setFieldValue('pwgFormData.bchurchid', parseInt(bchurchid, 10));
    }
    if (profession) {
      setFieldValue('pwgFormData.profession', profession);
    }
    setFieldValue('collector.entity[0].gender', '');
    setFieldValue('formLogic.type', '');
  }, []);
  return {
    decisionOptions: decisionOptions,
    genderOptions: genderOptions,
    labels: labels
  };
};

var usePermissionRequest = function usePermissionRequest() {
  var _values$collector2, _values$collector2$ad, _values$collector4, _values$collector4$ad, _values$collector6, _values$collector6$ad, _values$collector8, _values$collector8$ad, _values$collector10, _values$collector10$a, _values$collector12, _values$collector12$e, _values$collector12$e2;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useTranslationHelper();
  var displayList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'];
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPrintInfo = _useState2[0],
    setShowPrintInfo = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showPhotoInfo = _useState4[0],
    setShowPhotoInfo = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showAudioVideoInfo = _useState6[0],
    setShowAudioVideoInfo = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showWebInfo = _useState8[0],
    setShowWebInfo = _useState8[1];
  var _useState9 = useState(false),
    _useState10 = _slicedToArray(_useState9, 2),
    showOtherInfo = _useState10[0],
    setShowOtherInfo = _useState10[1];
  useEffect(function () {
    var _values$collector, _values$collector$add;
    if ((_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$add = _values$collector.additionalData) !== null && _values$collector$add !== void 0 && _values$collector$add.hasPrintInfo) {
      setShowPrintInfo(true);
    } else {
      setShowPrintInfo(false);
    }
  }, [(_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$ad = _values$collector2.additionalData) === null || _values$collector2$ad === void 0 ? void 0 : _values$collector2$ad.hasPrintInfo]);
  useEffect(function () {
    var _values$collector3, _values$collector3$ad;
    if ((_values$collector3 = values.collector) !== null && _values$collector3 !== void 0 && (_values$collector3$ad = _values$collector3.additionalData) !== null && _values$collector3$ad !== void 0 && _values$collector3$ad.hasPhotoInfo) {
      setShowPhotoInfo(true);
    } else {
      setShowPhotoInfo(false);
    }
  }, [(_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : (_values$collector4$ad = _values$collector4.additionalData) === null || _values$collector4$ad === void 0 ? void 0 : _values$collector4$ad.hasPhotoInfo]);
  useEffect(function () {
    var _values$collector5, _values$collector5$ad;
    if ((_values$collector5 = values.collector) !== null && _values$collector5 !== void 0 && (_values$collector5$ad = _values$collector5.additionalData) !== null && _values$collector5$ad !== void 0 && _values$collector5$ad.hasAudioVideoInfo) {
      setShowAudioVideoInfo(true);
    } else {
      setShowAudioVideoInfo(false);
    }
  }, [(_values$collector6 = values.collector) === null || _values$collector6 === void 0 ? void 0 : (_values$collector6$ad = _values$collector6.additionalData) === null || _values$collector6$ad === void 0 ? void 0 : _values$collector6$ad.hasAudioVideoInfo]);
  useEffect(function () {
    var _values$collector7, _values$collector7$ad;
    if ((_values$collector7 = values.collector) !== null && _values$collector7 !== void 0 && (_values$collector7$ad = _values$collector7.additionalData) !== null && _values$collector7$ad !== void 0 && _values$collector7$ad.hasWebInfo) {
      setShowWebInfo(true);
    } else {
      setShowWebInfo(false);
    }
  }, [(_values$collector8 = values.collector) === null || _values$collector8 === void 0 ? void 0 : (_values$collector8$ad = _values$collector8.additionalData) === null || _values$collector8$ad === void 0 ? void 0 : _values$collector8$ad.hasWebInfo]);
  useEffect(function () {
    var _values$collector9, _values$collector9$ad;
    if ((_values$collector9 = values.collector) !== null && _values$collector9 !== void 0 && (_values$collector9$ad = _values$collector9.additionalData) !== null && _values$collector9$ad !== void 0 && _values$collector9$ad.hasOtherInfo) {
      setShowOtherInfo(true);
    } else {
      setShowOtherInfo(false);
    }
  }, [(_values$collector10 = values.collector) === null || _values$collector10 === void 0 ? void 0 : (_values$collector10$a = _values$collector10.additionalData) === null || _values$collector10$a === void 0 ? void 0 : _values$collector10$a.hasOtherInfo]);
  useEffect(function () {
    var _values$collector11, _values$collector11$e, _values$collector11$e2, _values$collector11$e3;
    if ((values === null || values === void 0 ? void 0 : (_values$collector11 = values.collector) === null || _values$collector11 === void 0 ? void 0 : (_values$collector11$e = _values$collector11.entity[0]) === null || _values$collector11$e === void 0 ? void 0 : (_values$collector11$e2 = _values$collector11$e.phone[0]) === null || _values$collector11$e2 === void 0 ? void 0 : (_values$collector11$e3 = _values$collector11$e2.phoneNumber) === null || _values$collector11$e3 === void 0 ? void 0 : _values$collector11$e3.length) > 0) {
      setFieldValue('collector.entity[0].phone[0].phoneType', 'HOME');
    }
  }, [values === null || values === void 0 ? void 0 : (_values$collector12 = values.collector) === null || _values$collector12 === void 0 ? void 0 : (_values$collector12$e = _values$collector12.entity[0]) === null || _values$collector12$e === void 0 ? void 0 : (_values$collector12$e2 = _values$collector12$e.phone[0]) === null || _values$collector12$e2 === void 0 ? void 0 : _values$collector12$e2.phoneNumber]);
  useEffect(function () {
    setFormId({
      templateName: Templates.PERMISSION_REQUEST,
      values: values,
      setFieldValue: setFieldValue
    });
    setFieldValue('collector.additionalData.printInfo', {
      author: '',
      copyright: '',
      issueVolumes: '',
      notes: '',
      pageNumbers: '',
      title: ''
    }, false);
    setFieldValue('collector.additionalData.photoInfo', {
      description: '',
      link: '',
      source: ''
    }, false);
    setFieldValue('collector.additionalData.audioInfo', {
      links: '',
      source: '',
      title: '',
      timeCodes: ''
    }, false);
    setFieldValue('collector.additionalData.materialInfo', {
      description: '',
      materialOnline: '',
      materialPublication: '',
      materialAudioVisual: ''
    }, false);
    setFieldValue('collector.additionalData.hasPrintInfo', false, false);
    setFieldValue('collector.additionalData.hasPhotoInfo', false, false);
    setFieldValue('collector.additionalData.hasAudioVideoInfo', false, false);
    setFieldValue('collector.additionalData.hasWebInfo', false, false);
    setFieldValue('collector.additionalData.hasOtherInfo', false, false);
    setFieldValue('collector.additionalData.otherInfo.description', '', false);
    delete values.collector.cart;
  }, []);
  return {
    displayList: displayList,
    showAudioVideoInfo: showAudioVideoInfo,
    showOtherInfo: showOtherInfo,
    showPhotoInfo: showPhotoInfo,
    showPrintInfo: showPrintInfo,
    showWebInfo: showWebInfo,
    values: values
  };
};

var usePrayerTeam = function usePrayerTeam(_ref) {
  var _values$formLogic, _values$formLogic2, _values$formLogic3, _values$formLogic3$ac, _values$formLogic4, _values$formLogic4$ac, _values$collector$com;
  var languageOptions = _ref.languageOptions,
    _ref$orgRoleCode = _ref.orgRoleCode,
    orgRoleCode = _ref$orgRoleCode === void 0 ? 'DTRVCOUN' : _ref$orgRoleCode;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useTranslationHelper();
  useChurchInfo({});
  var churchLangOptions = languageOptions === null || languageOptions === void 0 ? void 0 : languageOptions.map(function (lng) {
    return _objectSpread2(_objectSpread2({}, lng), {}, {
      id: "church".concat(lng === null || lng === void 0 ? void 0 : lng.id),
      name: "formLogic.church".concat(lng === null || lng === void 0 ? void 0 : lng.name)
    });
  });
  var visibleList = ['Name', 'Email', 'Address', 'Phone'];
  var isOver14 = values.formLogic.over14;
  var isUnder18 = values.formLogic.over18 === 'no'; // ignore empty string
  var referenceName = ((_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.referenceName) || '';
  var referenceEmail = ((_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.referenceEmail) || '';
  var showSubmitButton = ((_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : (_values$formLogic3$ac = _values$formLogic3.acknowledgement) === null || _values$formLogic3$ac === void 0 ? void 0 : _values$formLogic3$ac.missionStatement) && ((_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : (_values$formLogic4$ac = _values$formLogic4.acknowledgement) === null || _values$formLogic4$ac === void 0 ? void 0 : _values$formLogic4$ac.release);
  var defaultAddressList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'];
  var resetReferencenArr = ((_values$collector$com = values.collector.communications) === null || _values$collector$com === void 0 ? void 0 : _values$collector$com.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.communicationType) !== communicationReferenceType;
  })) || [];
  useEffect(function () {
    handleOver18({
      setFieldValue: setFieldValue,
      values: values
    });
  }, [values.formLogic.over18]);
  useEffect(function () {
    handleUnder18({
      setFieldValue: setFieldValue,
      values: values
    });
  }, [values.formLogic.over18, values.formLogic.under18]);
  useEffect(function () {
    if ((referenceName === null || referenceName === void 0 ? void 0 : referenceName.length) > 0 && (referenceEmail === null || referenceEmail === void 0 ? void 0 : referenceEmail.length) > 0) {
      setFieldValue('collector.communications', [].concat(_toConsumableArray(resetReferencenArr), [{
        communicationType: communicationReferenceType,
        longComment: "".concat(referenceName, " | ").concat(referenceEmail)
      }]));
    }
  }, [referenceName, referenceEmail]);
  useEffect(function () {
    setFormId({
      templateName: Templates.PRAYER_TEAM_MEMBER,
      values: values,
      setFieldValue: setFieldValue
    });
    setFieldValue('formLogic.acknowledgement', {
      missionStatement: false,
      release: false
    }, false);
    setFieldValue('collector.communications', []);
    setFieldValue('formLogic.templateName', Templates.PRAYER_TEAM_MEMBER);
    setFieldValue('collector.entity[1].orgs.role', orgRoleCode);
    setFieldValue('collector.cart.products[0]', {
      productId: '',
      amount: 0,
      quantity: 1
    });
    setFieldValue("collector.questions[0].questionText", 'Which event do you plan to attend?');
  }, []);
  return {
    churchLangOptions: churchLangOptions,
    defaultAddressList: defaultAddressList,
    isOver14: isOver14,
    isUnder18: isUnder18,
    showSubmitButton: showSubmitButton,
    visibleList: visibleList
  };
};

var useProjectListItem = function useProjectListItem(_ref) {
  var _cartInfo$project$pro;
  var cartInfo = _ref.cartInfo,
    project = _ref.project;
  var projectAmount = (_cartInfo$project$pro = cartInfo[project === null || project === void 0 ? void 0 : project.projectId]) === null || _cartInfo$project$pro === void 0 ? void 0 : _cartInfo$project$pro.amount;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showThankYouTxt = _useState2[0],
    setShowThankYouTxt = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    currencyValue = _useState4[0],
    setCurrencyValue = _useState4[1];
  var _useState5 = useState(projectAmount > 0),
    _useState6 = _slicedToArray(_useState5, 2),
    showClearTxt = _useState6[0],
    setShowClearTxt = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showError = _useState8[0],
    setShowError = _useState8[1];
  var handleOnUpdateMessage = function handleOnUpdateMessage(event) {
    event.preventDefault();
    var amount = parseFloat(currencyValue);
    if (amount >= MIN_CURRENCY_VALUE) {
      setShowError(false);
      setShowThankYouTxt(true);
      setShowClearTxt(false);
      setTimeout(function () {
        setShowThankYouTxt(false);
        setShowClearTxt(true);
      }, 1100);
    } else {
      setShowError(true);
    }
  };
  var handleOnChange = function handleOnChange(event) {
    var _event$target;
    event.preventDefault();
    setShowError(false);
    setCurrencyValue(event === null || event === void 0 ? void 0 : (_event$target = event.target) === null || _event$target === void 0 ? void 0 : _event$target.value);
    setShowClearTxt(false);
  };
  var handleOnResetClick = function handleOnResetClick(event) {
    event.preventDefault();
    setShowClearTxt(false);
  };
  return {
    showClearTxt: showClearTxt,
    showError: showError,
    showThankYouTxt: showThankYouTxt,
    handleOnChange: handleOnChange,
    handleOnResetClick: handleOnResetClick,
    handleOnUpdateMessage: handleOnUpdateMessage
  };
};

var usePromo = function usePromo(productCode) {
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    products = _useState2[0],
    setProducts = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    totalPrice = _useState4[0],
    setTotalPrice = _useState4[1];
  var _useState5 = useState(),
    _useState6 = _slicedToArray(_useState5, 2),
    hasPromoCode = _useState6[0],
    setHasPromoCode = _useState6[1];
  var _useState7 = useState(),
    _useState8 = _slicedToArray(_useState7, 2),
    isPromoCodeInvalid = _useState8[0],
    setIsPromoCodeInvalid = _useState8[1];
  var _useState9 = useState(0),
    _useState10 = _slicedToArray(_useState9, 2),
    originalPrice = _useState10[0],
    setOriginalPrice = _useState10[1];
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useState11 = useState([]),
    _useState12 = _slicedToArray(_useState11, 2),
    discountPriceData = _useState12[0],
    setDiscountPriceData = _useState12[1];
  var _useState13 = useState([]),
    _useState14 = _slicedToArray(_useState13, 2),
    coursesProductsData = _useState14[0],
    setCoursesProductsData = _useState14[1];
  var _useState15 = useState(''),
    _useState16 = _slicedToArray(_useState15, 2),
    promoCode = _useState16[0],
    setPromoCode = _useState16[1];
  var courseDiscountPriceQuery = useGetCoursesDiscountPrice({
    productCode: productCode,
    promoCode: values.formLogic.promoCode
  }, {
    enabled: (promoCode === null || promoCode === void 0 ? void 0 : promoCode.length) > 0
  });
  var coursesProductsQuery = useGetCoursesProducts({
    productCode: productCode
  }, {
    enabled: !values.formLogic.promoCode
  });
  var handlePromoCode = function handlePromoCode(isInvalidCode) {
    setFieldValue('formLogic.isPromoCodeInvalid', isInvalidCode);
  };
  var handleOnClickPromoCode = function handleOnClickPromoCode() {
    var _values$formLogic;
    setPromoCode(values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.promoCode);
  };
  var handlePayload = function handlePayload(payload, isDiscounted) {
    var formattedPayload = payload.map(function (product) {
      return _objectSpread2(_objectSpread2({}, product), {}, {
        price: formatUSCurrency(+product.price)
      });
    });
    var currentPrice = +payload[0].price;
    var total = calculateTotalPrice(payload);
    if (!isDiscounted) setOriginalPrice(currentPrice);
    if (isDiscounted && !payload[0].invalidStaffCode) {
      var discount = calculateDiscount(originalPrice, currentPrice);
      setFieldValue('collector.cart.cartPromos', [{
        promoId: payload[0].staffCode,
        amountOff: discount
      }]);
    }
    var cartProducts = [{
      amount: currentPrice,
      quantity: 1,
      productId: "".concat(productCode),
      isOnlineTraining: true
    }];
    var cartTotals = {
      shippingTotal: 0,
      currency: 'USD',
      subTotal: total,
      taxAmount: 0
    };
    setFieldValue('collector.cart.products', cartProducts);
    setFieldValue('collector.cart.cartTotals', cartTotals);
    setProducts(formattedPayload);
    setTotalPrice(formatUSCurrency(total));
  };
  useEffect(function () {
    if (courseDiscountPriceQuery !== null && courseDiscountPriceQuery !== void 0 && courseDiscountPriceQuery.data) {
      var payload = courseDiscountPriceQuery === null || courseDiscountPriceQuery === void 0 ? void 0 : courseDiscountPriceQuery.data;
      var camelCasedPayload = toCamelCase(payload);
      setDiscountPriceData(camelCasedPayload);
    }
  }, [courseDiscountPriceQuery === null || courseDiscountPriceQuery === void 0 ? void 0 : courseDiscountPriceQuery.data]);
  useEffect(function () {
    if (coursesProductsQuery !== null && coursesProductsQuery !== void 0 && coursesProductsQuery.data) {
      var payload = coursesProductsQuery === null || coursesProductsQuery === void 0 ? void 0 : coursesProductsQuery.data;
      var camelCasedPayload = toCamelCase(payload);
      setCoursesProductsData(camelCasedPayload);
    }
  }, [coursesProductsQuery === null || coursesProductsQuery === void 0 ? void 0 : coursesProductsQuery.data]);
  useEffect(function () {
    if (coursesProductsData.length > 0 && !values.formLogic.promoCode) {
      handlePayload(coursesProductsData, false);
    }
  }, [coursesProductsData]);
  useEffect(function () {
    if (discountPriceData.length > 0 && values.formLogic.promoCode) {
      var isInvalidCode = discountPriceData[0].staffCode === '' && discountPriceData[0].invalidStaffCode === '1';
      handlePromoCode(isInvalidCode);
      handlePayload(discountPriceData, true);
    }
  }, [discountPriceData]);
  useEffect(function () {
    var _values$formLogic2;
    setHasPromoCode((values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.promoCode) !== '');
  }, [values.formLogic.promoCode]);
  useEffect(function () {
    var _values$formLogic3;
    setIsPromoCodeInvalid(values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.isPromoCodeInvalid);
  }, [values.formLogic.isPromoCodeInvalid]);
  return {
    hasPromoCode: hasPromoCode,
    isPromoCodeInvalid: isPromoCodeInvalid,
    products: products,
    totalPrice: totalPrice,
    handleOnClickPromoCode: handleOnClickPromoCode
  };
};

var useRefererUrl = function useRefererUrl() {
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useEffect(function () {
    var _values$collector;
    if (!(values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && _values$collector.refererUrl) && typeof window !== 'undefined') {
      var url = window.location.href;
      if (url) {
        url = url.replace(/[^-A-Za-z0-9+&@#/%?=~_|!:,.;()]/gim, '');
        setFieldValue("collector.refererUrl", url);
      }
    }
  }, []);
  return {
    values: values
  };
};

var useRoles = function useRoles(_ref) {
  var roles = _ref.roles;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var isStringsArray = function isStringsArray(arr) {
    return arr.every(function (i) {
      return typeof i === 'string';
    });
  };
  // Avoid conflict with volunteer form roles which is an array of objects
  var isValidRoles = (roles === null || roles === void 0 ? void 0 : roles.length) > 0 && isStringsArray(roles);
  useEffect(function () {
    if (isValidRoles) {
      setFieldValue("roles", roles);
    }
  }, []);
  return {
    values: values
  };
};

var useServiceReview = function useServiceReview(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue;
  var trainingPreparationLabel = "".concat(t('How did the training you received prior to active service, prepare you for serving in your ministry role?', {
    ns: 'labels'
  }), "*");
  var majorMinistryMomentLabel = "".concat(t('Describe your most significant ministry moment.', {
    ns: 'labels'
  }), "*");
  var supportNeedsLabel = "".concat(t('In what ways can we help you be more effective in ministry?', {
    ns: 'labels'
  }), "*");
  var valueEnhancementLabel = "".concat(t('What can be done to make you feel more valued in your ministry with SFJ?', {
    ns: 'labels'
  }), "*");
  var ministryRecommendationLabel = "".concat(t('Would you recommend this ministry to someone else?', {
    ns: 'labels'
  }), "*");
  var optionLabelObj = {
    yes: "".concat(t('Yes', {
      ns: 'common'
    })),
    no: "".concat(t('No', {
      ns: 'common'
    })),
    notSure: "".concat(t('Not sure', {
      ns: 'common'
    }))
  };
  var InterviewDateSelectionText = "".concat(t('InterviewDateSelection-text', {
    ns: 'labels'
  }));
  var primaryDateSelectionLabel = "".concat(t('First date choice:', {
    ns: 'labels'
  }), "*");
  var primaryTimeSelectionLabel = "".concat(t('What time on your first date choice above works best for you?', {
    ns: 'labels'
  }), "*");
  var alternateDateSelectionLabel = "".concat(t('Second date choice:', {
    ns: 'labels'
  }), "*");
  var alternateTimeSelectionLabel = "".concat(t('What time on your second date choice above works best for you?', {
    ns: 'labels'
  }), "*");
  var additionalFeedbackLabel = "".concat(t('Please feel free to leave any additional comments of feedback below.', {
    ns: 'labels'
  }));
  useEffect(function () {
    setFieldValue('translations', {
      fNameLabel: "".concat(t('First', {
        ns: 'labels'
      })),
      lNameLabel: "".concat(t('Last', {
        ns: 'labels'
      }))
    });
    setFieldValue('collector.destination', 1);
    setFieldValue('formLogic.SFJServiceReviewData.trainingPreparation', '');
    setFieldValue('formLogic.SFJServiceReviewData.majorMinistryMoment', '');
    setFieldValue('formLogic.SFJServiceReviewData.supportNeeds', '');
    setFieldValue('formLogic.SFJServiceReviewData.valueEnhancement', '');
    setFieldValue('formLogic.SFJServiceReviewData.ministryRecommendation', '');
    setFieldValue('formLogic.SFJServiceReviewData.primaryInterviewDate', '');
    setFieldValue('formLogic.SFJServiceReviewData.primaryInterviewTime', '');
    setFieldValue('formLogic.SFJServiceReviewData.alternateInterviewDate', '');
    setFieldValue('formLogic.SFJServiceReviewData.alternateInterviewTime', '');
    if (props.CTID) {
      setFieldValue('collector.collectionType', props.CTID);
    }
  }, []);
  var serviceReviewHeaderMarkup = {
    markup: 'Congratulations on completing an anniversary of ministry with Search for Jesus. We are very honored that you would choose to volunteer with our team. Please take a moment to share with us about your experience to date. Your response will help us learn how best we can serve you.'
  };
  return {
    additionalFeedbackLabel: additionalFeedbackLabel,
    alternateDateSelectionLabel: alternateDateSelectionLabel,
    alternateTimeSelectionLabel: alternateTimeSelectionLabel,
    InterviewDateSelectionText: InterviewDateSelectionText,
    majorMinistryMomentLabel: majorMinistryMomentLabel,
    ministryRecommendationLabel: ministryRecommendationLabel,
    optionLabelObj: optionLabelObj,
    primaryDateSelectionLabel: primaryDateSelectionLabel,
    primaryTimeSelectionLabel: primaryTimeSelectionLabel,
    serviceReviewHeaderMarkup: serviceReviewHeaderMarkup,
    supportNeedsLabel: supportNeedsLabel,
    trainingPreparationLabel: trainingPreparationLabel,
    valueEnhancementLabel: valueEnhancementLabel
  };
};

var findItem = function findItem(items, value) {
  return find$1(propEq$1('id', value), items);
};
var filteredLogic = function filteredLogic(item, itemKey, shirtSizes, props) {
  return item && item.key && item.key !== 'DTR' && (!item.key.startsWith(itemKey) && !findItem(shirtSizes, parseInt(item.value, 10)) || item.key.startsWith(itemKey) && findItem(shirtSizes, parseInt(item.value, 10)) || item.key.startsWith(itemKey) && (props === null || props === void 0 ? void 0 : props.formAttribute) && item.value === (props === null || props === void 0 ? void 0 : props.formAttribute) || item.key.startsWith(itemKey) && (props === null || props === void 0 ? void 0 : props.optInAttrValue) && item.value === (props === null || props === void 0 ? void 0 : props.optInAttrValue) || item.key.startsWith(itemKey) && (props === null || props === void 0 ? void 0 : props.under18EmailCode) && item.value === (props === null || props === void 0 ? void 0 : props.under18EmailCode) || item.key.startsWith(itemKey) && (props === null || props === void 0 ? void 0 : props.clwcformAttribute) && item.value === (props === null || props === void 0 ? void 0 : props.clwcformAttribute));
};
var handleShirtSizesRoles = function handleShirtSizesRoles(codeKey, isInternational, itemKey, props, shirtSizes, shirtSizesByRoles, values, setFieldValue, setShowShirtSizes) {
  var _values$formLogic;
  if ((_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && _values$formLogic.role && shirtSizesByRoles !== null && shirtSizesByRoles !== void 0 && shirtSizesByRoles.length) {
    var _values$formLogic2, _values$formLogic2$ro;
    var shouldEnableShirtSizes = shirtSizesByRoles.some(function (roleId) {
      return values.formLogic.role.find(function (roles) {
        return roles.includes(roleId);
      });
    });
    var resetArr = values.collector.entity[0].code.filter(function (item) {
      return filteredLogic(item, itemKey, shirtSizes, props);
    });
    var crusades = !isInternational ? [{
      key: codeKey,
      value: 'EVENT'
    }] : [];
    values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : (_values$formLogic2$ro = _values$formLogic2.role) === null || _values$formLogic2$ro === void 0 ? void 0 : _values$formLogic2$ro.forEach(function (role) {
      if (role) {
        var roleObj = JSON.parse(role);
        crusades.push({
          key: codeKey,
          value: "".concat(roleObj === null || roleObj === void 0 ? void 0 : roleObj.crusadeCodeEventRoleId)
        });
        if (roleObj !== null && roleObj !== void 0 && roleObj.SECodeEventRoleId) {
          crusades.push({
            key: codeKey,
            value: "".concat(roleObj === null || roleObj === void 0 ? void 0 : roleObj.SECodeEventRoleId)
          });
        }
      }
    });
    setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), crusades));
    setShowShirtSizes(shouldEnableShirtSizes);
  }
};

var _excluded$F = ["eventId", "shirtSizes", "shirtSizesByRoles"];
var useShirtSizes = function useShirtSizes(_ref) {
  var _values$formLogic;
  var eventId = _ref.eventId,
    shirtSizes = _ref.shirtSizes,
    shirtSizesByRoles = _ref.shirtSizesByRoles,
    props = _objectWithoutProperties(_ref, _excluded$F);
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useState = useState(!(shirtSizesByRoles !== null && shirtSizesByRoles !== void 0 && shirtSizesByRoles.length)),
    _useState2 = _slicedToArray(_useState, 2),
    showShirtSizes = _useState2[0],
    setShowShirtSizes = _useState2[1];
  var isInternational = (props === null || props === void 0 ? void 0 : props.destination) === 3;
  var codeKey = !isInternational ? "CRUSADE:".concat(eventId) : 'ATTRIBUTES';
  var itemKey = !isInternational ? "CRUSADE:" : 'ATTRIBUTES';
  useEffect(function () {
    handleShirtSizesRoles(codeKey, isInternational, itemKey, props, shirtSizes, shirtSizesByRoles, values, setFieldValue, setShowShirtSizes);
  }, [(_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.role, shirtSizesByRoles]);
  useEffect(function () {
    setFieldValue('formLogic.role', '');
  }, []);
  return {
    showShirtSizes: showShirtSizes
  };
};

var _excluded$E = ["codes", "defaultDebitDay", "options", "optionProp", "recurringToggle", "usePaypalCaptureOnly"];
var useSingleDonation = function useSingleDonation(_ref) {
  var _values$collector, _values$collector$car, _values$collector$car2, _values$payment, _values$formLogic, _donationOptions$;
  var codes = _ref.codes,
    defaultDebitDay = _ref.defaultDebitDay,
    options = _ref.options,
    optionProp = _ref.optionProp,
    recurringToggle = _ref.recurringToggle,
    usePaypalCaptureOnly = _ref.usePaypalCaptureOnly,
    props = _objectWithoutProperties(_ref, _excluded$E);
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  useTranslationHelper();
  useLogicInfo({
    logicIds: props === null || props === void 0 ? void 0 : props.logicIds
  });
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPayment = _useState2[0],
    setShowPayment = _useState2[1];
  var _useState3 = useState(optionProp),
    _useState4 = _slicedToArray(_useState3, 2),
    objState = _useState4[0],
    setObjState = _useState4[1];
  var _useState5 = useState(false),
    _useState6 = _slicedToArray(_useState5, 2),
    showMonthlyModal = _useState6[0],
    setShowMonthlyModal = _useState6[1];
  var currentProject = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.donation) === null || _values$collector$car2 === void 0 ? void 0 : _values$collector$car2.projects[0];
  var objStateKeys = useMemo(function () {
    return Object.keys(objState);
  }, [objState]);
  var showOnlineGivingSubmitButton = !!(values !== null && values !== void 0 && (_values$payment = values.payment) !== null && _values$payment !== void 0 && _values$payment.bluefinECC);
  var donationOptions = props !== null && props !== void 0 && props.donationOptions ? props === null || props === void 0 ? void 0 : props.donationOptions : convertOptionsToList(optionProp);
  var displayPaymentMethod = shouldShowPaymentInfo(showPayment, values);
  var convertOptions = function convertOptions(opts) {
    var newObj = _objectSpread2({}, optionProp);
    opts.forEach(function (opt) {
      var key = convertToCamelCase(opt);
      newObj[key] = opt;
    });
    setObjState(newObj);
  };
  var updateCodesField$1 = function updateCodesField$1() {
    updateCodesField(codes, setFieldValue, values);
  };
  var updateProjectId$1 = function updateProjectId$1() {
    updateProjectId(objState, donationOptions, setFieldValue);
  };
  var updateProjectsRecurrence = function updateProjectsRecurrence() {
    values.collector.cart.donation.projects.forEach(function (project) {
      delete project.isRecurring;
    });
  };
  useEffect(function () {
    var _props$parentDocument;
    setFormId({
      templateName: Templates.SINGLE_DONATION,
      values: values,
      setFieldValue: setFieldValue
    });
    initializeDonation(props === null || props === void 0 ? void 0 : props.campaignCodes, defaultDebitDay, props === null || props === void 0 ? void 0 : props.deliveryStatement, donationOptions, options, objStateKeys, convertOptions, props === null || props === void 0 ? void 0 : props.giftOffer, props === null || props === void 0 ? void 0 : props.projectTitle, setFieldValue, props === null || props === void 0 ? void 0 : props.showFreeGiftOffer, props === null || props === void 0 ? void 0 : props.showUpgradeGift, updateCodesField$1, updateProjectId$1, props === null || props === void 0 ? void 0 : props.isMonthly, props === null || props === void 0 ? void 0 : props.useRecaptchaV2, props === null || props === void 0 ? void 0 : props.enableMonthlyModal, usePaypalCaptureOnly, recurringToggle, props === null || props === void 0 ? void 0 : (_props$parentDocument = props.parentDocumentInfo) === null || _props$parentDocument === void 0 ? void 0 : _props$parentDocument.formQueryString, props === null || props === void 0 ? void 0 : props.disablePaypalGiftOffer, props === null || props === void 0 ? void 0 : props.enableApayPayment);
  }, []);
  useEffect(function () {
    updateInitialDonationLocation(donationOptions, objStateKeys, values, setFieldValue);
  }, [donationOptions, objState]);
  useEffect(function () {
    updateDonationLocation(values, setFieldValue);
  }, [(_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.donationLocation]);
  useEffect(function () {
    var projectAmount = currentProject === null || currentProject === void 0 ? void 0 : currentProject.amount;
    if (projectAmount && projectAmount > 0) {
      setFieldValue("collector.cart.cartTotals.subTotal", projectAmount);
    }
  }, [currentProject === null || currentProject === void 0 ? void 0 : currentProject.amount]);
  return {
    displayPaymentMethod: displayPaymentMethod,
    donationOptions: donationOptions,
    hasDonationLocation: donationOptions.length > 1,
    giveButton: function giveButton() {
      setShowPayment(function (prev) {
        return !prev;
      });
      updateProjectsRecurrence();
      if (displayPaymentMethod) {
        resetDonation({
          values: values,
          setFieldValue: setFieldValue
        });
      } else {
        setFieldValue("formLogic.isResetDonation", false);
      }
      if (props !== null && props !== void 0 && props.enableMonthlyModal && !displayPaymentMethod) {
        handleMonthlyModal({
          values: values,
          setFieldValue: setFieldValue,
          setShowMonthlyModal: setShowMonthlyModal
        });
      }
    },
    selectedDonation: donationOptions.length === 1 ? (_donationOptions$ = donationOptions[0]) === null || _donationOptions$ === void 0 ? void 0 : _donationOptions$.value : '',
    showMonthlyModal: showMonthlyModal,
    showOnlineGivingSubmitButton: showOnlineGivingSubmitButton,
    setShowMonthlyModal: setShowMonthlyModal
  };
};

var useSource = function useSource(_ref) {
  var SESourceCode = _ref.SESourceCode;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var sourceCodeCookie = getSourceCookie();
  var sourceCode = SESourceCode || '';
  useEffect(function () {
    if (sourceCodeCookie) {
      setFieldValue("collector.SESourceCode", sourceCodeCookie);
    }
  }, [sourceCodeCookie]);
  useEffect(function () {
    if (sourceCode && !sourceCodeCookie) {
      setFieldValue("collector.SESourceCode", sourceCode);
    }
  }, []);
  return {
    values: values
  };
};

var useSubscriptionInfo = function useSubscriptionInfo(_ref) {
  var _values$formLogic;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var subscriptionInfo = props === null || props === void 0 ? void 0 : props.subscriptionInfo;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue,
    submitForm = _useFormikContext.submitForm;
  var esubs = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.esubs;
  var _useState = useState([]),
    _useState2 = _slicedToArray(_useState, 2),
    selectedEsubs = _useState2[0],
    setSelectedEsubs = _useState2[1];
  var _useState3 = useState([]),
    _useState4 = _slicedToArray(_useState3, 2),
    userEsubs = _useState4[0],
    setUserEsubs = _useState4[1];
  var emailAddress = subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.emailAddress;
  var headerCopy = "".concat(props === null || props === void 0 ? void 0 : props.formHeaderCopy, " ").concat((subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.emailAddress) && "<p>You are currently managing subscriptions for: ".concat(emailAddress, "</p>"));
  useEmailSubscription({
    esubCodes: selectedEsubs
  });
  var setFormikCheckbox = function setFormikCheckbox() {
    var userEsubsArr = [];
    subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.list.forEach(function (subscription) {
      return subscription.list.forEach(function (item) {
        if (item !== null && item !== void 0 && item.isUserSubscribed) {
          userEsubsArr.push(item.esub);
        }
        setFieldValue("formLogic.esubs.".concat(item.esub), item === null || item === void 0 ? void 0 : item.isUserSubscribed, false);
      });
    });
    setUserEsubs([].concat(_toConsumableArray(userEsubs), userEsubsArr));
  };
  var getSelectedEsubs = function getSelectedEsubs(esubObj) {
    var result = [];
    Object.keys(esubObj).forEach(function (key) {
      var value = esubObj[key];
      if (value || userEsubs !== null && userEsubs !== void 0 && userEsubs.includes(key)) {
        result.push({
          esubCode: key,
          isActive: value
        });
      }
    });
    return result;
  };
  var handleUnsubscribeAll = function handleUnsubscribeAll(e) {
    var _values$collector, _values$collector$ent, _values$collector2, _values$collector2$en, _values$collector2$en2;
    e.preventDefault();
    e.stopPropagation();
    var subscriptions = selectedEsubs === null || selectedEsubs === void 0 ? void 0 : selectedEsubs.map(function (_ref2) {
      var esubCode = _ref2.esubCode;
      return {
        esubCode: esubCode,
        isActive: false
      };
    });
    var resetArr = values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent = _values$collector.entity[0]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.code ? values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.code) === null || _values$collector2$en2 === void 0 ? void 0 : _values$collector2$en2.slice() : [];
    setFieldValue("collector.entity[0].email[0].emailSubscription", subscriptions);
    setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), _toConsumableArray(props === null || props === void 0 ? void 0 : props.specialCode)), false);
    submitForm();
  };
  useEffect(function () {
    var _Object$keys;
    if (esubs && ((_Object$keys = Object.keys(esubs)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0) {
      var esubCodes = getSelectedEsubs(esubs);
      setSelectedEsubs(esubCodes);
    }
  }, [esubs]);
  useEffect(function () {
    if (subscriptionInfo !== null && subscriptionInfo !== void 0 && subscriptionInfo.emailAddress) {
      setFieldValue('collector.entity[0].email[0].emailAddress', subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.emailAddress);
    }
    if (props !== null && props !== void 0 && props.subscriptionToken) {
      setFieldValue("collector.entity[0].email[0].subscriptionToken", props === null || props === void 0 ? void 0 : props.subscriptionToken, false);
    }
    setFormikCheckbox();
  }, []);
  delete values.collector.cart;
  return {
    headerCopy: headerCopy,
    subscriptionInfo: subscriptionInfo,
    values: values,
    handleUnsubscribeAll: handleUnsubscribeAll
  };
};

var totalFieldData = function totalFieldData(_ref) {
  var recurringDate = _ref.recurringDate,
    recurringMonth = _ref.recurringMonth,
    RecurringTotal = _ref.RecurringTotal,
    useMonthlyDropdown = _ref.useMonthlyDropdown;
  var ordinalText = ordinalSuffix(parseInt(recurringDate, 10));
  var dateSuffix = !parseInt(recurringDate, 10) ? '' : ordinalText;
  var dateDropDownSuffix = !parseInt(recurringDate, 10) ? '' : ordinalText;
  var showRecurringCopy = useMonthlyDropdown ? RecurringTotal > 0 && recurringDate && recurringMonth : RecurringTotal > 0 && recurringDate;
  var dtSuffix = useMonthlyDropdown ? dateDropDownSuffix : dateSuffix;
  return {
    showRecurringCopy: showRecurringCopy,
    dtSuffix: dtSuffix
  };
};
var useTotalField = function useTotalField(_ref2) {
  var _values$collector;
  var name = _ref2.name,
    _ref2$useMonthlyDropd = _ref2.useMonthlyDropdown,
    useMonthlyDropdown = _ref2$useMonthlyDropd === void 0 ? false : _ref2$useMonthlyDropd;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var cart = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : _values$collector.cart;
  var recurringDate = values.formLogic.recurringDateNum;
  var recurringMonth = values.formLogic.recurringMonthNum;
  useEffect(function () {
    if (cart && cart.donation && cart.donation.projects) {
      var total = cart.donation.projects.reduce(function (a, b) {
        return a + (b.amount || 0);
      }, 0);
      if (total) {
        var totalAmount = parseFloat("".concat(total)).toFixed(2);
        setFieldValue(name, Number(totalAmount));
      }
    } else {
      setFieldValue(name, 0);
    }
  }, [cart, setFieldValue, name]);
  var RecurringTotal;
  if (cart && cart.donation) {
    RecurringTotal = cart.donation.projects.filter(function (project) {
      return project.recurringDate;
    }).reduce(function (a, b) {
      return a + (b.amount || 0);
    }, 0);
  }
  if (cart === undefined) {
    return undefined;
  }
  if (values.formLogic === undefined) {
    return undefined;
  }
  var subTotal = values.collector.cart.cartTotals.subTotal;
  var subTotalText = subTotal ? "".concat(parseFloat("".concat(subTotal)).toFixed(2)) : '0.00';
  var totalText = t("Today's Total", {
    ns: 'labels'
  });
  var monthlyText = t('Your Monthly Gift', {
    ns: 'labels'
  });
  var onTheText = t('on the', {
    ns: 'labels'
  });
  var _totalFieldData = totalFieldData({
      recurringDate: recurringDate,
      recurringMonth: recurringMonth,
      RecurringTotal: RecurringTotal,
      useMonthlyDropdown: useMonthlyDropdown
    }),
    showRecurringCopy = _totalFieldData.showRecurringCopy,
    dtSuffix = _totalFieldData.dtSuffix;
  var updatedRecurringDate = recurringDate ? new Date(getValidDate(calculateStartDate(recurringDate))).toISOString().split('T')[0] : '';
  var updatedRecurringText = getFormattedStartDate(updatedRecurringDate, values);
  return {
    dateSuffix: dtSuffix,
    monthlyText: monthlyText,
    onTheText: onTheText,
    recurringDate: recurringDate,
    RecurringTotal: RecurringTotal,
    showRecurringCopy: showRecurringCopy,
    subTotalText: subTotalText,
    totalText: totalText,
    updatedRecurringText: updatedRecurringText,
    values: values
  };
};

var useTrainingRegistration = function useTrainingRegistration(_ref) {
  var _values$formLogic, _values$formLogic$par;
  var productCode = _ref.productCode,
    codes = _ref.codes;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isGift = _useState2[0],
    setIsGift = _useState2[1];
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  useTranslationHelper();
  var queryProjectDict = getQueryStringDict((values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.formQueryString) || '');
  var courseId = (queryProjectDict === null || queryProjectDict === void 0 ? void 0 : queryProjectDict.pc) || productCode;
  var _usePromo = usePromo(courseId),
    hasPromoCode = _usePromo.hasPromoCode,
    isPromoCodeInvalid = _usePromo.isPromoCodeInvalid,
    products = _usePromo.products,
    totalPrice = _usePromo.totalPrice,
    handleOnClickPromoCode = _usePromo.handleOnClickPromoCode;
  var giftOptions = [{
    label: 'Yes',
    name: 'formLogic.isGift',
    value: 'yes'
  }, {
    label: 'No',
    name: 'formLogic.isGift',
    value: 'no'
  }];
  useEffect(function () {
    setFieldValue('formLogic.isGift', 'no');
  }, []);
  useEffect(function () {
    var gift = values.formLogic.isGift;
    setIsGift(gift === 'yes');
    if (gift === 'yes') {
      var updatedEntities = _toConsumableArray(values.collector.entity);
      updatedEntities[1] = _objectSpread2(_objectSpread2({}, updatedEntities[1]), {}, {
        isPrimary: false,
        entityRelationship: [{
          path: 'entity[0]',
          relationshipType: RelationshipType.OnlineTrainingGiftee
        }]
      });
      setFieldValue('collector.entity', updatedEntities);
    }
  }, [values.formLogic.isGift]);
  useEffect(function () {
    if (codes) {
      setFieldValue("collector.entity[0].code", _toConsumableArray(codes), false);
    }
  }, []);
  return {
    giftOptions: giftOptions,
    hasPromoCode: hasPromoCode,
    isPromoCodeInvalid: isPromoCodeInvalid,
    isGift: isGift,
    setIsGift: setIsGift,
    products: products,
    totalPrice: totalPrice,
    handleOnClickPromoCode: handleOnClickPromoCode
  };
};

var useTrainingRegistrationConfirmation = function useTrainingRegistrationConfirmation() {
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;

  // Extract course information
  var courseName = deepFind(values, 'submissionresponse.payload.onlineTraining.course.fullname');

  // Extract cart and payment information
  var cartInfo = deepFind(values, 'collector.cart.cartTotals');
  var coursePrice = cartInfo === null || cartInfo === void 0 ? void 0 : cartInfo.subTotal;
  var transaction = deepFind(values, 'payment');
  var transactionId = deepFind(values, 'submissionresponse.payload.payment.transaction_id');
  var transactionType = getTransactionType(transaction);
  var isGift = deepFind(values, 'formLogic.isGift') === 'yes';

  // Extract customer information
  var userInfo = {
    firstName: deepFind(values, 'submissionresponse.payload.onlineTraining.user.firstName'),
    lastName: deepFind(values, 'submissionresponse.payload.onlineTraining.user.lastName')
  };
  return {
    courseName: courseName,
    coursePrice: coursePrice,
    isGift: isGift,
    transactionId: transactionId,
    transactionType: transactionType,
    userInfo: userInfo
  };
};

var useUpgradeDonation = function useUpgradeDonation() {
  var _collector$cart, _collector$cart$donat;
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var upgradeDonationHandler = useCreateUpgradeDonation();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    processing = _useState2[0],
    setProcessing = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    submitSuccess = _useState4[0],
    setSubmitSuccess = _useState4[1];
  var hasUpgradedGift = deepFind(values, 'formLogic.hasUpgradedGift');
  var upgradedRecurringDate = deepFind(values, 'formLogic.upgradedRecurringDate');
  var recurringDate = upgradedRecurringDate ? new Date(getValidDate(calculateStartDate(upgradedRecurringDate))).toISOString().split('T')[0] : '';
  var id = deepFind(values, 'submissionresponse.id');
  var collector = deepFind(values, 'collector');
  var email = deepFind(values, 'email');
  var payment = deepFind(values, 'payment');
  var orgProjects = deepFind(values, 'formLogic.orgProjects');
  var projects = orgProjects || (collector === null || collector === void 0 ? void 0 : (_collector$cart = collector.cart) === null || _collector$cart === void 0 ? void 0 : (_collector$cart$donat = _collector$cart.donation) === null || _collector$cart$donat === void 0 ? void 0 : _collector$cart$donat.projects);
  var originalPayload = {
    collector: _objectSpread2(_objectSpread2({}, collector), {}, {
      cart: _objectSpread2(_objectSpread2({}, collector === null || collector === void 0 ? void 0 : collector.cart), {}, {
        donation: _objectSpread2(_objectSpread2({}, collector === null || collector === void 0 ? void 0 : collector.cart.donation), {}, {
          projects: projects
        })
      })
    }),
    email: email,
    payment: payment
  };
  var paymentType = payment !== null && payment !== void 0 && payment.bluefinEFT ? 'eft' : 'bf'; // used by email service
  var transactionId = deepFind(values, 'submissionresponse.payload.payment.transaction_id');
  var chargeText = t('Select the monthly charge date', {
    ns: 'labels'
  });
  var processText = t('Process', {
    ns: 'labels'
  });
  var availableChargeDates = getAvailabilityChargeDates();
  var chrgDates = convertOptionsToList(availableChargeDates);
  var chargeDates = [{
    id: '',
    value: 'Select'
  }].concat(_toConsumableArray(chrgDates));
  var payload = {
    upgrade: {
      id: id,
      recurringDate: recurringDate
    },
    email: {
      emailId: 'DonationUpgradeReceiptBGEA'
    },
    formLogic: {
      orgPayload: JSON.parse(decodeURIComponent(JSON.stringify(originalPayload))),
      transactionId: transactionId,
      paymentType: paymentType
    }
  };
  var handleSubmit = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
      var _response$data, data, response, _values$collector, _values$collector$car, _values$collector$car2, _values$formLogic, _values$formLogic$par, total, totalAmount;
      return _regeneratorRuntime().wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            _context.prev = 0;
            data = JSON.stringify(payload);
            _context.next = 4;
            return upgradeDonationHandler.createUpgradeDonation(data);
          case 4:
            response = _context.sent;
            if ((response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.status) === 'success') {
              total = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$car = _values$collector.cart) === null || _values$collector$car === void 0 ? void 0 : (_values$collector$car2 = _values$collector$car.cartTotals) === null || _values$collector$car2 === void 0 ? void 0 : _values$collector$car2.subTotal;
              if (total && typeof total === 'number') {
                totalAmount = Number(total.toFixed(2));
              }
              setProcessing(false);
              setSubmitSuccess(true);
              trackEvent('bgform', {
                formCategory: values.collector.formID,
                formAction: 'DonationUpgrade',
                formLabel: (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.documentLocationHref) || document.location.href,
                formValue: totalAmount
              });
            }
            _context.next = 11;
            break;
          case 8:
            _context.prev = 8;
            _context.t0 = _context["catch"](0);
            trackEvent('bgform-exception', {
              formId: values.collector.formID,
              formAction: 'DonationUpgrade',
              exception: _context.t0
            });
          case 11:
          case "end":
            return _context.stop();
        }
      }, _callee, null, [[0, 8]]);
    }));
    return function handleSubmit() {
      return _ref.apply(this, arguments);
    };
  }();
  var handleOnSubmitClick = function handleOnSubmitClick(e) {
    e.preventDefault();
    setProcessing(true);
    handleSubmit();
  };
  var recurringText = !upgradedRecurringDate ? 'the date selected below:' : getFormattedStartDate(upgradedRecurringDate, values);
  return {
    chargeDates: chargeDates,
    chargeText: chargeText,
    hasUpgradedGift: hasUpgradedGift,
    processing: processing,
    processText: processText,
    recurringText: recurringText,
    submitSuccess: submitSuccess,
    upgradedRecurringDate: upgradedRecurringDate,
    handleOnSubmitClick: handleOnSubmitClick
  };
};

var MAX_YEAR = 18;
var useVolunteerInterest = function useVolunteerInterest(_ref) {
  var _values$formLogic2;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  useLogicInfo({
    useLogicNoDuplicate: props === null || props === void 0 ? void 0 : props.useLogicNoDuplicate
  });
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var PrivacyPolicyCopy = props === null || props === void 0 ? void 0 : props.privacyPolicyCopy;
  var date = new Date();
  var maxDate = new Date(date.setFullYear(date.getFullYear() - MAX_YEAR));
  var phoneLabel = t('Phone Number', {
    ns: 'labels'
  });
  var genderLabel = "".concat(t('Gender', {
    ns: 'common'
  }), "*");
  var birthDateLabel = "".concat(t('Birth Date', {
    ns: 'labels'
  }), "*");
  var ministryOpportunitiesLabel = t('How do you want to minister to others through the Search for Jesus ministry?', {
    ns: 'labels'
  });
  var discoverySourceLabel = "".concat(t('How did you hear about the Search for Jesus ministry? Please check all that apply (hold down the Command or Control key to make multiple selections).', {
    ns: 'labels'
  }), "*");
  var genderOptions = [{
    value: 'M',
    id: 'M',
    name: 'male',
    label: t('Male', {
      ns: 'common'
    })
  }, {
    value: 'F',
    id: 'F',
    name: 'female',
    label: t('Female', {
      ns: 'common'
    })
  }];
  useEffect(function () {
    var _values$formLogic, _values$formLogic$tex;
    if ((values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$tex = _values$formLogic.textOptIn) === null || _values$formLogic$tex === void 0 ? void 0 : _values$formLogic$tex.length) > 0) {
      setFieldValue('collector.questions[2].answerText', 'yes');
    } else {
      setFieldValue('collector.questions[2].answerText', 'no');
    }
  }, [values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.textOptIn]);
  useEffect(function () {
    if (Array.isArray(values.formLogic.multiSelectAnswer)) {
      var stringifyAnswerText = values.formLogic.multiSelectAnswer.join(', ');
      setFieldValue('collector.questions[1].answerText', stringifyAnswerText);
    }
  }, [values.formLogic.multiSelectAnswer]);
  useEffect(function () {
    setFieldValue('collector.entity[0].gender', '');
    setFieldValue('collector.entity[0].date[0].key', 'birthday');
    setFieldValue('collector.entity[0].date[0].value', '');
    setFieldValue('collector.questions[0].questionId', 33);
    setFieldValue('collector.questions[0].questionText', 'How do you want to minister to others through the Search for Jesus ministry?');
    setFieldValue('collector.questions[0].answerText', '');
    setFieldValue('collector.questions[1].questionId', 34);
    setFieldValue('collector.questions[1].questionText', 'How did you hear about the Search for Jesus ministry?');
    setFieldValue('collector.questions[2].questionId', 97);
    setFieldValue('collector.questions[2].questionText', 'Opt in for text messages. Standard messaging rates apply. You may opt out at any time.');
    setFieldValue('collector.questions[2].answerText', 'no');
    setFieldValue('formLogic.multiSelectAnswer', []);
    setFieldValue('volunteerApp.StellofyInterestForm.selected_language', props.lng);
  }, []);
  var privacyPolicyLabelMarkup = {
    markup: t('privacyAgreement', {
      ns: 'common',
      interpolation: {
        escapeValue: false
      }
    })
  };
  var privacyPolicyLabelStyle = {
    main: {
      fontSize: '0.8em'
    }
  };
  return {
    yourInformationLabel: translations.yourInformationLabel,
    birthDateLabel: birthDateLabel,
    discoverySourceLabel: discoverySourceLabel,
    genderLabel: genderLabel,
    genderOptions: genderOptions,
    maxDate: maxDate,
    ministryOpportunitiesLabel: ministryOpportunitiesLabel,
    phoneLabel: phoneLabel,
    privacyPolicyLabelMarkup: privacyPolicyLabelMarkup,
    privacyPolicyLabelStyle: privacyPolicyLabelStyle,
    PrivacyPolicyCopy: PrivacyPolicyCopy
  };
};

var setAnswerByQuestionId = function setAnswerByQuestionId(_ref) {
  var _values$volunteerApp, _values$volunteerApp$, _values$volunteerApp$2, _values$volunteerApp2, _values$volunteerApp3, _values$volunteerApp4;
  var answerText = _ref.answerText,
    questionId = _ref.questionId,
    values = _ref.values,
    setFieldValue = _ref.setFieldValue;
  var filterQuestions = values === null || values === void 0 ? void 0 : (_values$volunteerApp = values.volunteerApp) === null || _values$volunteerApp === void 0 ? void 0 : (_values$volunteerApp$ = _values$volunteerApp.StellofyApplicationForm) === null || _values$volunteerApp$ === void 0 ? void 0 : (_values$volunteerApp$2 = _values$volunteerApp$.questions) === null || _values$volunteerApp$2 === void 0 ? void 0 : _values$volunteerApp$2.filter(function (item) {
    return item.questionId !== questionId;
  });
  var selectedQuestion = values === null || values === void 0 ? void 0 : (_values$volunteerApp2 = values.volunteerApp) === null || _values$volunteerApp2 === void 0 ? void 0 : (_values$volunteerApp3 = _values$volunteerApp2.StellofyApplicationForm) === null || _values$volunteerApp3 === void 0 ? void 0 : (_values$volunteerApp4 = _values$volunteerApp3.questions) === null || _values$volunteerApp4 === void 0 ? void 0 : _values$volunteerApp4.find(function (item) {
    return (item === null || item === void 0 ? void 0 : item.questionId) === questionId;
  });
  if ((filterQuestions === null || filterQuestions === void 0 ? void 0 : filterQuestions.length) > 0 && selectedQuestion) {
    setFieldValue('volunteerApp.StellofyApplicationForm.questions', [].concat(_toConsumableArray(filterQuestions), [_objectSpread2(_objectSpread2({}, selectedQuestion), {}, {
      answerText: answerText
    })]), false);
  }
};
var initVolunteerAppQuestions = function initVolunteerAppQuestions(_ref2) {
  var setFieldValue = _ref2.setFieldValue;
  setFieldValue('volunteerApp.StellofyApplicationForm.questions', [{
    questionId: 35,
    questionText: 'What are you passionate about? How are you actively responding to that passion now?',
    answerText: ''
  }, {
    questionId: 36,
    questionText: 'Describe a goal you have set and recently accomplished.',
    answerText: ''
  }, {
    questionId: 37,
    questionText: "From your perspective, what role does the local church play in a believer's life?",
    answerText: ''
  }, {
    questionId: 38,
    questionText: 'Name three of your strengths and three of your weaknesses.',
    answerText: ''
  }, {
    questionId: 39,
    questionText: 'What are your current daily commitments?',
    answerText: ''
  }, {
    questionId: 40,
    questionText: 'How do you respond to tension or conflict?',
    answerText: ''
  }, {
    questionId: 41,
    questionText: 'What language(s) other than English do you speak and write fluently?',
    answerText: ''
  }, {
    questionId: 42,
    questionText: 'What leadership experience do you have?',
    answerText: ''
  }, {
    questionId: 43,
    questionText: 'What do you find fulfilling in serving on a team?',
    answerText: ''
  }, {
    questionId: 44,
    questionText: 'In what ways has God called you to support the mission of the local church?',
    answerText: ''
  }, {
    questionId: 45,
    questionText: 'Describe your spiritual journey.',
    answerText: ''
  }, {
    questionId: 46,
    questionText: 'What desires are in your heart to accomplish?',
    answerText: ''
  }, {
    questionId: 47,
    questionText: 'Describe a time when you have made a commitment that was difficult to see through.',
    answerText: ''
  }, {
    questionId: 48,
    questionText: "Agreement to BGEA's Statement of Faith",
    answerText: ''
  }, {
    questionId: 49,
    questionText: 'Agreement to Statement of Practice',
    answerText: ''
  }, {
    questionId: 50,
    questionText: 'Agreement to Disclosure and Consent',
    answerText: ''
  }], false);
};

var _excluded$D = ["pages"];
var useVolunteerApp = function useVolunteerApp(_ref) {
  var _Object$keys, _values$volunteerApp2;
  var pages = _ref.pages,
    props = _objectWithoutProperties(_ref, _excluded$D);
  var _useState = useState(0),
    _useState2 = _slicedToArray(_useState, 2),
    pageIndex = _useState2[0],
    setPageIndex = _useState2[1];
  var _useState3 = useState(''),
    _useState4 = _slicedToArray(_useState3, 2),
    errorMessage = _useState4[0],
    setErrorMessage = _useState4[1];
  var pageRef = useRef(null);
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  useTranslationHelper();
  var _useGetStellofyInfo = useGetStellofyInfo(),
    isTokenQueryLoading = _useGetStellofyInfo.isTokenQueryLoading,
    tokenInfo = _useGetStellofyInfo.tokenInfo;
  var _useFormikContext = useFormikContext(),
    errors = _useFormikContext.errors,
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue,
    validateForm = _useFormikContext.validateForm;
  var volunteerAppLabel = t('Volunteer Application', {
    ns: 'labels'
  });
  var previousLabel = t('Previous', {
    ns: 'labels'
  });
  var nextLabel = t('Next', {
    ns: 'labels'
  });
  var disabledNext = ((_Object$keys = Object.keys(errors)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0;
  var setNextPage = function setNextPage(e) {
    e.preventDefault();
    if (pageIndex < (pages === null || pages === void 0 ? void 0 : pages.length) - 1) {
      setPageIndex(pageIndex + 1);
    }
  };
  var setPrevPage = function setPrevPage(e) {
    e.preventDefault();
    if (pageIndex > 0) {
      setPageIndex(pageIndex - 1);
    }
  };
  var handleScrollIntoView = function handleScrollIntoView() {
    var _pageRef$current, _pageRef$current$getB;
    window.scrollTo(0, 0);
    window.scrollTo({
      top: (pageRef === null || pageRef === void 0 ? void 0 : (_pageRef$current = pageRef.current) === null || _pageRef$current === void 0 ? void 0 : (_pageRef$current$getB = _pageRef$current.getBoundingClientRect()) === null || _pageRef$current$getB === void 0 ? void 0 : _pageRef$current$getB.top) || 0,
      behavior: 'smooth'
    });
  };
  useEffect(function () {
    var _values$volunteerApp;
    if (pageIndex > -1 && values.formLogic.volunteerApp && values !== null && values !== void 0 && (_values$volunteerApp = values.volunteerApp) !== null && _values$volunteerApp !== void 0 && _values$volunteerApp.StellofyApplicationForm) {
      validateForm();
    }
  }, [pageIndex, values.formLogic.volunteerApp, values === null || values === void 0 ? void 0 : (_values$volunteerApp2 = values.volunteerApp) === null || _values$volunteerApp2 === void 0 ? void 0 : _values$volunteerApp2.StellofyApplicationForm]);
  useEffect(function () {
    if (pageIndex > -1) {
      handleScrollIntoView();
    }
  }, [pageIndex]);
  useEffect(function () {
    var _Object$keys2, _Object$keys3;
    if (tokenInfo && ((_Object$keys2 = Object.keys(tokenInfo)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0) {
      setFieldValue('volunteerApp.StellofyApplicationForm.token', tokenInfo.token, false);
      setFieldValue('volunteerApp.StellofyApplicationForm.role_id', tokenInfo.roleId, false);
      setErrorMessage('');
    } else if (tokenInfo && ((_Object$keys3 = Object.keys(tokenInfo)) === null || _Object$keys3 === void 0 ? void 0 : _Object$keys3.length) === 0) {
      setErrorMessage('ApiClient Error: API returned an error on getSfjByToken - not found');
    }
  }, [tokenInfo]);
  useEffect(function () {
    setFormId({
      templateName: Templates.VOLUNTEER_APP,
      values: values,
      setFieldValue: setFieldValue
    });
    if (props !== null && props !== void 0 && props.isStellofyForm) {
      setFieldValue('formLogic.isStellofyForm', true, false);
    }
    setFieldValue('volunteerApp.StellofyApplicationForm.addressType', 'MAIL', false);
    initVolunteerAppQuestions({
      setFieldValue: setFieldValue
    });
    validateForm();
  }, []);
  delete values.collector;
  return {
    disabledNext: disabledNext,
    errorMessage: errorMessage,
    isTokenQueryLoading: isTokenQueryLoading,
    nextLabel: nextLabel,
    pageIndex: pageIndex,
    pageRef: pageRef,
    previousLabel: previousLabel,
    values: values,
    volunteerAppLabel: volunteerAppLabel,
    setNextPage: setNextPage,
    setPrevPage: setPrevPage
  };
};

var useVolunteerPage = function useVolunteerPage() {
  var _values$formLogic$vol5, _values$formLogic$vol6, _values$formLogic$vol11, _values$formLogic$vol12, _values$formLogic$vol17, _values$formLogic$vol18;
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  var aboutYourChurchLabel = translations.aboutYourChurchLabel,
    churchWebsite = translations.churchWebsite,
    commitmentDifficultQuestion = translations.commitmentDifficultQuestion,
    conflictQuestion = translations.conflictQuestion,
    dailyCommitmentsQuestion = translations.dailyCommitmentsQuestion,
    dateLabel = translations.dateLabel,
    desiresHeartQuestion = translations.desiresHeartQuestion,
    emailLabel = translations.emailLabel,
    firstReferenceLabel = translations.firstReferenceLabel,
    fulfillingServingQuestion = translations.fulfillingServingQuestion,
    goalQuestion = translations.goalQuestion,
    languagesQuestion = translations.languagesQuestion,
    leadershipQuestion = translations.leadershipQuestion,
    localChurchQuestion = translations.localChurchQuestion,
    passionateQuestion = translations.passionateQuestion,
    referencesLabel = translations.referencesLabel,
    referenceDescription = translations.referenceDescription,
    secondReferenceLabel = translations.secondReferenceLabel,
    spiritualJourneyQuestion = translations.spiritualJourneyQuestion,
    statementLabel = translations.statementLabel,
    strengthWeaknessQuestion = translations.strengthWeaknessQuestion,
    yearsKnownLabel = translations.yearsKnownLabel,
    yearsKnownOptions = translations.yearsKnownOptions,
    yearsKnownPastorLabel = translations.yearsKnownPastorLabel,
    yourInformationLabel = translations.yourInformationLabel,
    valueLocalChurchQuestion = translations.valueLocalChurchQuestion;
  var handleOnChange = function handleOnChange(e, questionId) {
    setFieldValue(e.target.name, e.target.value, false);
    setAnswerByQuestionId({
      answerText: e.target.value,
      questionId: questionId,
      values: values,
      setFieldValue: setFieldValue
    });
  };
  useEffect(function () {
    var _values$formLogic$vol, _values$formLogic$vol2, _values$formLogic$vol3, _values$formLogic$vol4;
    if (((_values$formLogic$vol = values.formLogic.volunteerApp) === null || _values$formLogic$vol === void 0 ? void 0 : (_values$formLogic$vol2 = _values$formLogic$vol.statementOfFaithAnswer) === null || _values$formLogic$vol2 === void 0 ? void 0 : _values$formLogic$vol2.length) > 0 && ((_values$formLogic$vol3 = values.formLogic.volunteerApp) === null || _values$formLogic$vol3 === void 0 ? void 0 : (_values$formLogic$vol4 = _values$formLogic$vol3.statementOfFaithDate) === null || _values$formLogic$vol4 === void 0 ? void 0 : _values$formLogic$vol4.length) > 0) {
      setAnswerByQuestionId({
        answerText: 'true',
        questionId: 48,
        values: values,
        setFieldValue: setFieldValue
      });
    } else {
      setAnswerByQuestionId({
        answerText: 'false',
        questionId: 48,
        values: values,
        setFieldValue: setFieldValue
      });
    }
  }, [(_values$formLogic$vol5 = values.formLogic.volunteerApp) === null || _values$formLogic$vol5 === void 0 ? void 0 : _values$formLogic$vol5.statementOfFaithAnswer, (_values$formLogic$vol6 = values.formLogic.volunteerApp) === null || _values$formLogic$vol6 === void 0 ? void 0 : _values$formLogic$vol6.statementOfFaithDate]);
  useEffect(function () {
    var _values$formLogic$vol7, _values$formLogic$vol8, _values$formLogic$vol9, _values$formLogic$vol10;
    if (((_values$formLogic$vol7 = values.formLogic.volunteerApp) === null || _values$formLogic$vol7 === void 0 ? void 0 : (_values$formLogic$vol8 = _values$formLogic$vol7.statementOfPracticeAnswer) === null || _values$formLogic$vol8 === void 0 ? void 0 : _values$formLogic$vol8.length) > 0 && ((_values$formLogic$vol9 = values.formLogic.volunteerApp) === null || _values$formLogic$vol9 === void 0 ? void 0 : (_values$formLogic$vol10 = _values$formLogic$vol9.statementOfPracticeDate) === null || _values$formLogic$vol10 === void 0 ? void 0 : _values$formLogic$vol10.length) > 0) {
      setAnswerByQuestionId({
        answerText: 'true',
        questionId: 49,
        values: values,
        setFieldValue: setFieldValue
      });
    } else {
      setAnswerByQuestionId({
        answerText: 'false',
        questionId: 49,
        values: values,
        setFieldValue: setFieldValue
      });
    }
  }, [(_values$formLogic$vol11 = values.formLogic.volunteerApp) === null || _values$formLogic$vol11 === void 0 ? void 0 : _values$formLogic$vol11.statementOfPracticeAnswer, (_values$formLogic$vol12 = values.formLogic.volunteerApp) === null || _values$formLogic$vol12 === void 0 ? void 0 : _values$formLogic$vol12.statementOfPracticeDate]);
  useEffect(function () {
    var _values$formLogic$vol13, _values$formLogic$vol14, _values$formLogic$vol15, _values$formLogic$vol16;
    if (((_values$formLogic$vol13 = values.formLogic.volunteerApp) === null || _values$formLogic$vol13 === void 0 ? void 0 : (_values$formLogic$vol14 = _values$formLogic$vol13.statementOfConsentAnswer) === null || _values$formLogic$vol14 === void 0 ? void 0 : _values$formLogic$vol14.length) > 0 && ((_values$formLogic$vol15 = values.formLogic.volunteerApp) === null || _values$formLogic$vol15 === void 0 ? void 0 : (_values$formLogic$vol16 = _values$formLogic$vol15.statementOfConsentDate) === null || _values$formLogic$vol16 === void 0 ? void 0 : _values$formLogic$vol16.length) > 0) {
      setAnswerByQuestionId({
        answerText: 'true',
        questionId: 50,
        values: values,
        setFieldValue: setFieldValue
      });
    } else {
      setAnswerByQuestionId({
        answerText: 'false',
        questionId: 50,
        values: values,
        setFieldValue: setFieldValue
      });
    }
  }, [(_values$formLogic$vol17 = values.formLogic.volunteerApp) === null || _values$formLogic$vol17 === void 0 ? void 0 : _values$formLogic$vol17.statementOfConsentAnswer, (_values$formLogic$vol18 = values.formLogic.volunteerApp) === null || _values$formLogic$vol18 === void 0 ? void 0 : _values$formLogic$vol18.statementOfConsentDate]);
  return {
    yourInformationLabel: yourInformationLabel,
    aboutYourChurchLabel: aboutYourChurchLabel,
    churchWebsite: churchWebsite,
    dateLabel: dateLabel,
    emailLabel: emailLabel,
    firstReferenceLabel: firstReferenceLabel,
    referenceDescription: referenceDescription,
    passionateQuestion: passionateQuestion,
    goalQuestion: goalQuestion,
    localChurchQuestion: localChurchQuestion,
    strengthWeaknessQuestion: strengthWeaknessQuestion,
    dailyCommitmentsQuestion: dailyCommitmentsQuestion,
    conflictQuestion: conflictQuestion,
    languagesQuestion: languagesQuestion,
    leadershipQuestion: leadershipQuestion,
    fulfillingServingQuestion: fulfillingServingQuestion,
    valueLocalChurchQuestion: valueLocalChurchQuestion,
    spiritualJourneyQuestion: spiritualJourneyQuestion,
    desiresHeartQuestion: desiresHeartQuestion,
    commitmentDifficultQuestion: commitmentDifficultQuestion,
    referencesLabel: referencesLabel,
    secondReferenceLabel: secondReferenceLabel,
    statementLabel: statementLabel,
    yearsKnownLabel: yearsKnownLabel,
    yearsKnownPastorLabel: yearsKnownPastorLabel,
    yearsKnownOptions: yearsKnownOptions,
    values: values,
    handleOnChange: handleOnChange
  };
};

var FormTemplateInfo = function FormTemplateInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _props$isBasicTemplat = props.isBasicTemplate,
    isBasicTemplate = _props$isBasicTemplat === void 0 ? false : _props$isBasicTemplat;
  useCollectionType({
    collectionType: props === null || props === void 0 ? void 0 : props.collectionType,
    isBasicTemplate: isBasicTemplate
  });
  useCountry(_objectSpread2(_objectSpread2({}, props), {}, {
    country: (props === null || props === void 0 ? void 0 : props.country) || ['US']
  })); // default to US
  useCustomCopy({
    confirmationBackgroundColor: props === null || props === void 0 ? void 0 : props.confirmationBackgroundColor,
    customConfirmation: props === null || props === void 0 ? void 0 : props.customConfirmation,
    customConfirmationEmail: props === null || props === void 0 ? void 0 : props.customConfirmationEmail,
    individualConfirmationOnSite: props === null || props === void 0 ? void 0 : props.individualConfirmationOnSite,
    individualConfirmationPrayer: props === null || props === void 0 ? void 0 : props.individualConfirmationPrayer,
    individualConfirmationVolunteerOnly: props === null || props === void 0 ? void 0 : props.individualConfirmationVolunteerOnly
  });
  useDefaultCode({
    campaignCodes: props === null || props === void 0 ? void 0 : props.campaignCodes,
    eventId: props === null || props === void 0 ? void 0 : props.eventId,
    isInternational: (props === null || props === void 0 ? void 0 : props.destination) === 3,
    lng: props === null || props === void 0 ? void 0 : props.lng,
    shouldNotSetLanguageCode: props === null || props === void 0 ? void 0 : props.shouldNotSetLanguageCode,
    languageCode: props === null || props === void 0 ? void 0 : props.languageCode
  });
  useDenomination();
  useDestination({
    destination: props === null || props === void 0 ? void 0 : props.destination
  });
  useEmail({
    emailId: props === null || props === void 0 ? void 0 : props.emailId,
    isBasicTemplate: isBasicTemplate
  });
  useEmailSubscription({
    esubCodes: props === null || props === void 0 ? void 0 : props.esubCodes
  });
  useMinistryEmailId({
    ministryEmailId: props === null || props === void 0 ? void 0 : props.ministryEmailId
  });
  useRefererUrl();
  useSource({
    SESourceCode: props === null || props === void 0 ? void 0 : props.SESourceCode
  });
  useRoles({
    roles: props === null || props === void 0 ? void 0 : props.roles
  });
  var _useFormTemplateInfo = useFormTemplateInfo(_objectSpread2({}, props)),
    errorMessage = _useFormTemplateInfo.errorMessage,
    errRef = _useFormTemplateInfo.errRef,
    pingStatus = _useFormTemplateInfo.pingStatus,
    showFloodControlledError = _useFormTemplateInfo.showFloodControlledError,
    showFormErrorScreen = _useFormTemplateInfo.showFormErrorScreen,
    PageComponent = _useFormTemplateInfo.PageComponent;
  return jsx(Fragment, {
    children: pingStatus === VogonStatus.Success ? jsxs(Fragment, {
      children: [showFormErrorScreen && jsx("div", {
        ref: errRef,
        children: jsx(FormErrorScreens, _objectSpread2(_objectSpread2({}, props), {}, {
          errorMessage: errorMessage,
          showFloodControlledError: showFloodControlledError
        }))
      }), PageComponent]
    }) : jsx(FormLoading, {
      status: pingStatus
    })
  });
};
var FormTemplateInfo$1 = FormTemplateInfo;

var _excluded$C = ["children"];
var FormTemplateContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e16rp85x0"
} : {
  target: "e16rp85x0",
  label: "FormTemplateContainer"
})("background-color:", function (props) {
  return props !== null && props !== void 0 && props.formBackgroundColor ? props === null || props === void 0 ? void 0 : props.formBackgroundColor : 'transparent';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var FormTemplate = function FormTemplate(_ref) {
  var children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$C);
  var cssClass = props !== null && props !== void 0 && props.template ? "form-".concat(props === null || props === void 0 ? void 0 : props.template, "-container") : 'form-template-container';
  return !(props !== null && props !== void 0 && props.isBasicTemplate) ? jsx(FormTemplateContainer, {
    className: cssClass,
    formBackgroundColor: props === null || props === void 0 ? void 0 : props.formBackgroundColor,
    children: jsx(QueryClientProvider, {
      client: queryClient,
      children: jsx(I18nextProvider, {
        i18n: i18next,
        children: jsx(FormProvider, _objectSpread2(_objectSpread2({}, props), {}, {
          children: jsx(FormTemplateInfo$1, _objectSpread2(_objectSpread2({}, props), {}, {
            children: children
          }))
        }))
      })
    })
  }) : jsx(I18nextProvider, {
    i18n: i18next,
    children: jsx(FormProvider, _objectSpread2(_objectSpread2({}, props), {}, {
      isBasicTemplate: true,
      children: jsx(FormTemplateInfo$1, _objectSpread2(_objectSpread2({}, props), {}, {
        isBasicTemplate: true,
        children: children
      }))
    }))
  });
};
var FormTemplate$1 = FormTemplate;

/* eslint-disable react/no-danger */
var FormSection = function FormSection(_ref) {
  var _ref$disableEmbedLayo = _ref.disableEmbedLayout,
    disableEmbedLayout = _ref$disableEmbedLayo === void 0 ? false : _ref$disableEmbedLayo,
    _ref$hideTopBorder = _ref.hideTopBorder,
    hideTopBorder = _ref$hideTopBorder === void 0 ? false : _ref$hideTopBorder,
    _ref$formHeaderCopy = _ref.formHeaderCopy,
    formHeaderCopy = _ref$formHeaderCopy === void 0 ? '' : _ref$formHeaderCopy,
    _ref$formSectionClass = _ref.formSectionClassWrapper,
    formSectionClassWrapper = _ref$formSectionClass === void 0 ? 'display-wrapper' : _ref$formSectionClass,
    formSectionHeader = _ref.formSectionHeader,
    formSectionFields = _ref.formSectionFields,
    _ref$isEmbedSite = _ref.isEmbedSite,
    isEmbedSite = _ref$isEmbedSite === void 0 ? false : _ref$isEmbedSite,
    _ref$isFormHeader = _ref.isFormHeader,
    isFormHeader = _ref$isFormHeader === void 0 ? false : _ref$isFormHeader,
    _ref$paddingBottom = _ref.paddingBottom,
    paddingBottom = _ref$paddingBottom === void 0 ? 'none' : _ref$paddingBottom,
    _ref$paddingTop = _ref.paddingTop,
    paddingTop = _ref$paddingTop === void 0 ? 'standard' : _ref$paddingTop;
  var FormHeader = function FormHeader() {
    return isFormHeader ? jsx("h2", {
      children: formSectionHeader
    }) : jsx("div", {
      className: "section-label",
      dangerouslySetInnerHTML: {
        __html: formSectionHeader
      }
    });
  };
  return isEmbedSite && !disableEmbedLayout ? jsx("div", {
    className: "".concat(formSectionClassWrapper, " form-section-container"),
    "data-padding-top": paddingTop,
    "data-padding-bottom": paddingBottom,
    children: jsx("div", {
      className: "content-columns",
      children: jsxs("div", {
        className: "content-column",
        children: [!hideTopBorder && jsx("hr", {
          className: "content-column-top-border"
        }), jsxs("div", {
          className: "fractional-width-wrapper",
          "data-text-position": "right",
          children: [jsx("div", {
            className: "fr-text",
            children: formHeaderCopy ? jsx("div", {
              className: "form-header-copy",
              dangerouslySetInnerHTML: {
                __html: formHeaderCopy
              }
            }) : formSectionFields
          }), jsx("div", {
            className: "fr-media",
            children: formSectionHeader && jsx(FormHeader, {})
          })]
        })]
      })
    })
  }) : jsxs(Fragment, {
    children: [formSectionHeader && jsx(Heading, {
      subtitle: true,
      renderAs: "h2",
      weight: "bold",
      textTransform: "uppercase",
      children: formSectionHeader
    }), formSectionFields]
  });
};
var FormSection$1 = FormSection;

var GivingInfo = function GivingInfo(_ref) {
  var _values$formLogic, _values$formLogic$brb, _values$formLogic$brb2, _values$formLogic$brb3;
  var creditCardClassName = _ref.creditCardClassName,
    eftClassName = _ref.eftClassName,
    pledgeClassName = _ref.pledgeClassName,
    showDonationCart = _ref.showDonationCart,
    showPledge = _ref.showPledge,
    values = _ref.values,
    handlePaymentButtons = _ref.handlePaymentButtons;
  return jsxs(Fragment, {
    children: [jsx(Columns, {
      children: jsxs(Columns.Column, {
        children: [jsx(Button, {
          mr: 2,
          value: "SREDKeyPad",
          onClick: function onClick(e) {
            return handlePaymentButtons(e, 'CC');
          },
          className: creditCardClassName,
          children: "Credit Card"
        }, "SREDKeyPad"), jsx(Button, {
          mr: 2,
          value: "BluefinEFT",
          onClick: function onClick(e) {
            return handlePaymentButtons(e, 'EFT');
          },
          className: eftClassName,
          children: "Checking"
        }, "BluefinEFT"), jsx(Button, {
          onClick: function onClick(e) {
            return handlePaymentButtons(e, '', true);
          },
          className: pledgeClassName,
          children: "Pledge"
        })]
      })
    }), jsx("hr", {}), showPledge && jsx(PledgeAmounts, {}), showDonationCart && jsx(DonationCart, {
      projectId: values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$brb = _values$formLogic.brbInfo) === null || _values$formLogic$brb === void 0 ? void 0 : (_values$formLogic$brb2 = _values$formLogic$brb.campaign) === null || _values$formLogic$brb2 === void 0 ? void 0 : (_values$formLogic$brb3 = _values$formLogic$brb2.projects[0]) === null || _values$formLogic$brb3 === void 0 ? void 0 : _values$formLogic$brb3.project
    })]
  });
};
var GivingInfo$1 = GivingInfo;

var _excluded$B = ["formChoice", "donateTitle", "projectId", "buttonAmounts", "recurringButtonAmounts", "recurringChoiceDay"];
var CallTakerDetails = function CallTakerDetails(_ref) {
  var formChoice = _ref.formChoice,
    props = _objectWithoutProperties(_ref, _excluded$B);
  var _useCallTakerDetails = useCallTakerDetails({
      formChoice: formChoice
    }),
    creditCardClassName = _useCallTakerDetails.creditCardClassName,
    eftClassName = _useCallTakerDetails.eftClassName,
    pledgeClassName = _useCallTakerDetails.pledgeClassName,
    showAddress = _useCallTakerDetails.showAddress,
    showDonationCart = _useCallTakerDetails.showDonationCart,
    showEmail = _useCallTakerDetails.showEmail,
    showPledge = _useCallTakerDetails.showPledge,
    showNewsletterCheckbox = _useCallTakerDetails.showNewsletterCheckbox,
    showOrgGift = _useCallTakerDetails.showOrgGift,
    showSubmitButton = _useCallTakerDetails.showSubmitButton,
    values = _useCallTakerDetails.values,
    handlePaymentButtons = _useCallTakerDetails.handlePaymentButtons;
  return jsxs(Container$1, {
    children: [jsx(FormSection$1, {
      formSectionHeader: "Name",
      formSectionFields: jsx(Fragment, {
        children: jsx(Name$1, {
          showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel
        })
      })
    }), jsx(FormSection$1, {
      formSectionHeader: "Address",
      formSectionFields: jsxs(Fragment, {
        children: [formChoice === 'comment' && jsx(Checkbox, {
          id: "formLogic.noAddress",
          name: "formLogic.noAddress",
          label: "No Address"
        }), (showAddress || formChoice === 'donation') && jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
          autoComplete: false,
          country: ['US'],
          entity: 0,
          index: 0,
          label: "",
          required: true,
          showLabel: false,
          type: "MAIL",
          visibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode']
        }))]
      })
    }), jsx(FormSection$1, {
      formSectionHeader: "Contact",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Checkbox, {
          id: "formLogic.noEmail",
          name: "formLogic.noEmail",
          label: "No Email"
        }), showEmail && jsx(InputEmail, {
          name: "collector.entity[0].email[0].emailAddress",
          label: "Email Address",
          required: true
        }), showNewsletterCheckbox && jsx(Checkbox, {
          id: "formLogic.newsletter",
          name: "formLogic.newsletter",
          label: "Caller would like to receive email newsletter"
        }), jsx(InputPhone, {
          name: "collector.entity[0].phone[0].phoneNumber",
          label: "Phone (do not include commas, dashes, dots, or parenthesis)",
          required: true,
          minPhoneLength: 10
        })]
      })
    }), jsx(FormSection$1, {
      formSectionHeader: "Notes",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(TextArea, {
          label: "Prayer Request",
          name: "collector.questions[1].answerText",
          required: false
        }), jsx(TextArea, {
          label: "Story",
          name: "collector.questions[0].answerText",
          required: false
        }), jsx(TextArea, {
          label: "Notes",
          name: "collector.questions[2].answerText",
          required: false
        })]
      })
    }), formChoice === 'donation' && jsx(FormSection$1, {
      formSectionHeader: "Donation",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Checkbox, {
          id: "formLogic.orgGift",
          name: "formLogic.orgGift",
          label: "Caller is giving on behalf of an organization"
        }), showOrgGift && jsx(InputText, {
          name: "collector.entity[2].organizationName",
          label: "Organization Name",
          required: true
        }), jsx(Dropdown, {
          label: "Make this an anonymous gift?",
          name: "collector.questions[3].answerText",
          options: [{
            value: 'Select One',
            id: ''
          }, {
            value: 'No',
            id: '0'
          }, {
            value: 'Yes',
            id: '1'
          }],
          required: true
        }), jsx(GivingInfo$1, _objectSpread2(_objectSpread2({}, props), {}, {
          creditCardClassName: creditCardClassName,
          eftClassName: eftClassName,
          pledgeClassName: pledgeClassName,
          showDonationCart: showDonationCart,
          showPledge: showPledge,
          values: values,
          handlePaymentButtons: handlePaymentButtons
        }))]
      })
    }), showSubmitButton && jsx(FormSection$1, {
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
        color: "primary"
      })),
      paddingTop: "standard",
      paddingBottom: "standard"
    })]
  });
};
var CallTakerDetails$1 = CallTakerDetails;

var CallTakerInfo = function CallTakerInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useCallTaker = useCallTaker({
      isDisableRecaptcha: props === null || props === void 0 ? void 0 : props.isDisableRecaptcha
    }),
    formChoice = _useCallTaker.formChoice,
    message = _useCallTaker.message,
    projectId = _useCallTaker.projectId,
    resetSignal = _useCallTaker.resetSignal,
    handleOnCallerChoice = _useCallTaker.handleOnCallerChoice;
  return jsxs(Container$1, {
    children: [jsx("div", {
      children: message
    }), jsx(Button, {
      mr: 2,
      onClick: function onClick(e) {
        handleOnCallerChoice(e, 'comment');
      },
      children: "Comment/Question/Prayer"
    }), jsx(Button, {
      onClick: function onClick(e) {
        handleOnCallerChoice(e, 'donation');
      },
      children: "Donation/Pledge"
    }), formChoice && createElement(CallTakerDetails$1, _objectSpread2(_objectSpread2({}, props), {}, {
      key: resetSignal,
      projectId: projectId,
      formChoice: formChoice
    }))]
  });
};
var CallTakerInfo$1 = CallTakerInfo;

var BasicConfirmation = function BasicConfirmation() {
  var _values$formLogic, _values$collector, _values$collector$ent, _values$collector2, _values$collector2$en, _values$collector3, _values$collector3$en, _values$collector3$en2;
  var confirmationRef = useRef(null);
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.customConfirmation;
  var firstName = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : _values$collector$ent.firstName;
  var emailAddress = (values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : _values$collector2$en.email) && (values === null || values === void 0 ? void 0 : (_values$collector3 = values.collector) === null || _values$collector3 === void 0 ? void 0 : (_values$collector3$en = _values$collector3.entity[0]) === null || _values$collector3$en === void 0 ? void 0 : (_values$collector3$en2 = _values$collector3$en.email[0]) === null || _values$collector3$en2 === void 0 ? void 0 : _values$collector3$en2.emailAddress) || '';
  var handleScrollIntoView = function handleScrollIntoView() {
    var _confirmationRef$curr, _confirmationRef$curr2, _values$formLogic2;
    window.scrollTo(0, 0); // Match existing UX on Production, scroll to the top then to the element.
    window.scrollTo({
      top: (confirmationRef === null || confirmationRef === void 0 ? void 0 : (_confirmationRef$curr = confirmationRef.current) === null || _confirmationRef$curr === void 0 ? void 0 : (_confirmationRef$curr2 = _confirmationRef$curr.getBoundingClientRect()) === null || _confirmationRef$curr2 === void 0 ? void 0 : _confirmationRef$curr2.top) || 0,
      behavior: 'smooth'
    });
    if (values !== null && values !== void 0 && (_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && _values$formLogic2.isEmbedSite) {
      var postObject = JSON.stringify({
        scrollToTop: true
      });
      window.top.postMessage(postObject, '*');
    }
  };
  useEffect(function () {
    handleScrollIntoView();
  }, []);
  return jsx("div", {
    ref: confirmationRef,
    children: jsx(Container$1, {
      className: "bgform-basic-confirmation-container",
      children: CustomConfirmation ? jsx(CustomConfirmation, {
        firstName: firstName,
        emailAddress: emailAddress
      }) : jsxs(Fragment, {
        children: [jsx(Heading, {
          children: "Thank you!"
        }), jsx(Block, {
          children: jsx("p", {
            children: "Your submission is complete."
          })
        })]
      })
    })
  });
};

var ChurchInterestConfirmation = function ChurchInterestConfirmation() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.customConfirmation;
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: CustomConfirmation ? jsx(CustomConfirmation, {}) : jsxs(Fragment, {
          children: [jsx(Block, {
            children: "Thank you for your interest in the God Loves You Frontera Tour. Your submission has been received. Check your email in the coming days for updates about the tour and ways to get involved."
          }), jsxs(Block, {
            children: ["In the meantime, visit our", ' ', jsx("a", {
              href: "/en/resources/",
              children: "Resources Page"
            }), " to download the materials you'll need to promote the God Loves You Frontera Tour to both your church and community. You will find videos and slides for download, as well as printable resources. Free event invitations are also available for order by calling 1-800-801-3953."]
          }), jsx(Block, {
            children: "There are also several events coming up before the tour that you and your church can take part in, such as the Christian Life & Witness Course (CLWC)-which is a free training class for those who want to serve as part of the prayer team during the tour. CLWC classes are open to everyone-no registration is required. At this three-hour training, attendees will learn how to simply share Jesus Christ with others and how to pray with those who stand to accept Him during the tour event."
          }), jsxs(Block, {
            children: ["The Night of Prayer and Worship is also coming to your city in January. This is an evening for churches from across your community to come together and pray for revival in your city. This evening also features a time of worship led by Job Gonz\xE1lez. This is also an opportunity to pick up additional promotional materials like invitations, posters, and yard signs. Details for each of these events can be found on at", ' ', jsx("a", {
              href: "/en/pre-events/",
              children: "https://godlovesyoutour.com/en/pre-events/"
            }), "."]
          })]
        })
      })
    })
  });
};

var UpgradeDonation = function UpgradeDonation() {
  var _useUpgradeDonation = useUpgradeDonation(),
    chargeDates = _useUpgradeDonation.chargeDates,
    chargeText = _useUpgradeDonation.chargeText,
    hasUpgradedGift = _useUpgradeDonation.hasUpgradedGift,
    processing = _useUpgradeDonation.processing,
    processText = _useUpgradeDonation.processText,
    recurringText = _useUpgradeDonation.recurringText,
    submitSuccess = _useUpgradeDonation.submitSuccess,
    upgradedRecurringDate = _useUpgradeDonation.upgradedRecurringDate,
    handleOnSubmitClick = _useUpgradeDonation.handleOnSubmitClick;
  return jsx(Container$1, {
    children: jsxs(Notification, {
      children: [jsxs(Block, {
        children: [jsx(Heading, {
          subtitle: true,
          textSize: 5,
          children: "Keep Giving Hope: Make This a Monthly Gift"
        }), jsx("p", {
          children: "Will you consider partnering with BGEA all year long by turning your gift into a recurring monthly donation? Most importantly, you can be a crucial part of what God is doing throughout the world as BGEA continues to proclaim the Gospel of Jesus Christ through every effective means available. You can call or write us anytime to pause or stop your monthly donation."
        })]
      }), !submitSuccess && !processing && jsx(Block, {
        children: jsx(Checkbox, {
          id: "formLogic.hasUpgradedGift",
          name: "formLogic.hasUpgradedGift",
          label: "Make this gift monthly"
        })
      }), hasUpgradedGift && jsxs(Block, {
        children: [jsx("p", {
          children: jsxs("span", {
            children: ["Please note, you have already been charged today, and your monthly gift(s) will begin on ", recurringText]
          })
        }), !submitSuccess && !processing && jsx(Content, {
          children: jsx(Dropdown, {
            name: "formLogic.upgradedRecurringDate",
            label: chargeText,
            required: true,
            options: chargeDates
          })
        }), jsxs(Block, {
          children: [processing && jsx(Icon, {
            size: "small",
            align: "left",
            children: jsx(SpinnerIcon, {
              viewBox: "0 0 512 512"
            })
          }), !submitSuccess && !processing && jsx(Button, {
            className: "upgradeDonationButton",
            disabled: !upgradedRecurringDate,
            onClick: handleOnSubmitClick,
            children: processText
          }), submitSuccess && !processing && jsx(Content, {
            children: jsx("strong", {
              children: "We successfully processed this gift as recurring"
            })
          })]
        })]
      }), !hasUpgradedGift && submitSuccess && !processing && jsxs(Block, {
        children: [jsx("p", {
          children: jsxs("span", {
            children: ["Please note, you have already been charged today, and your monthly gift(s) will begin on ", recurringText]
          })
        }), jsx(Content, {
          children: jsx("strong", {
            children: "We successfully processed this gift as recurring"
          })
        })]
      })]
    })
  });
};

var ConfirmationContainer$1 = /*#__PURE__*/_styled(Container$1, process.env.NODE_ENV === "production" ? {
  target: "epjbhq20"
} : {
  target: "epjbhq20",
  label: "ConfirmationContainer"
})("background-color:", function (props) {
  return props !== null && props !== void 0 && props.confirmationBackgroundColor ? props === null || props === void 0 ? void 0 : props.confirmationBackgroundColor : 'transparent';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var DonationConfirmation = function DonationConfirmation() {
  var _total$toFixed;
  var _useCheckoutConfirmat = useCheckoutConfirmation(),
    cartInfo = _useCheckoutConfirmat.cartInfo,
    confirmationBackgroundColor = _useCheckoutConfirmat.confirmationBackgroundColor,
    confirmationRef = _useCheckoutConfirmat.confirmationRef,
    deliveryMessage = _useCheckoutConfirmat.deliveryMessage,
    firstName = _useCheckoutConfirmat.firstName,
    isOneTime = _useCheckoutConfirmat.isOneTime,
    paypal = _useCheckoutConfirmat.paypal,
    recurrenceText = _useCheckoutConfirmat.recurrenceText,
    showDeliveryMessage = _useCheckoutConfirmat.showDeliveryMessage,
    showRecurrenceText = _useCheckoutConfirmat.showRecurrenceText,
    showUpgradeGift = _useCheckoutConfirmat.showUpgradeGift,
    total = _useCheckoutConfirmat.total,
    transactionId = _useCheckoutConfirmat.transactionId,
    CustomConfirmation = _useCheckoutConfirmat.CustomConfirmation;
  return jsx("div", {
    className: "donation-confirmation-container",
    ref: confirmationRef,
    children: jsx(ConfirmationContainer$1, {
      confirmationBackgroundColor: confirmationBackgroundColor,
      children: jsx(Content, {
        children: cartInfo && total > 0 && jsx(Fragment, {
          children: CustomConfirmation ? jsx(CustomConfirmation, {
            recurrenceText: recurrenceText,
            showRecurrenceText: showRecurrenceText,
            total: total,
            transactionId: transactionId,
            firstName: firstName
          }) : jsxs(Fragment, {
            children: [jsx(Heading, {
              renderAs: "h3",
              subtitle: true,
              children: "Thank you for your generous online gift."
            }), jsxs(Block, {
              children: ["We are grateful ", firstName, " for your financial support. Your transaction will be processed shortly and will appear on your next statement. An acknowledgment will be emailed to you."]
            }), jsxs(Block, {
              children: ["The confirmation number for your", ' ', showRecurrenceText && jsx("strong", {
                children: recurrenceText
              }), ' ', "donation is ", jsx("strong", {
                children: transactionId
              }), " for the amount of $", (_total$toFixed = total.toFixed(2)) !== null && _total$toFixed !== void 0 ? _total$toFixed : 'NEED AMOUNT', "."]
            }), isOneTime && !paypal && showUpgradeGift && jsx(UpgradeDonation, {}), jsx(Block, {
              children: "If you have any questions, call us at 1-877-247-2426. Please have your confirmation number ready and indicate that you are contacting us about a donation made through the Billy Graham Evangelistic Association website."
            }), jsxs(Block, {
              children: ["To keep you updated on the ministry, we would like to send you our prayer letter,", ' ', jsx("i", {
                children: "From the Desk of Franklin Graham"
              }), ", featuring Biblical truths about current events, news of his travels, and updates on the work of BGEA with thousands of people around the world. You can opt-out from receiving these emails anytime."]
            }), showDeliveryMessage && jsx(Block, {
              children: deliveryMessage
            })]
          })
        })
      })
    })
  });
};

var Confirmation = function Confirmation() {
  var _values$formLogic, _values$formLogic2;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  useFormConfirmation({
    isDonation: values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.isDonation
  });
  return values !== null && values !== void 0 && (_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && _values$formLogic2.isDonation ? jsx(DonationConfirmation, {}) : jsx(BasicConfirmation, {});
};

var ContactFormConfirmation = function ContactFormConfirmation() {
  var _useContactFormConfir = useContactFormConfirmation(),
    userFirstName = _useContactFormConfir.userFirstName,
    CustomConfirmation = _useContactFormConfir.CustomConfirmation;
  var _useFormConfirmation = useFormConfirmation({
      isDonation: false
    }),
    confirmationRef = _useFormConfirmation.confirmationRef;
  return jsx("div", {
    ref: confirmationRef,
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: CustomConfirmation ? jsx(CustomConfirmation, {}) : jsxs(Fragment, {
          children: [jsxs("h2", {
            className: "success",
            children: ["Thanks ", userFirstName]
          }), jsx(Block, {
            children: "Your information has been submitted."
          })]
        })
      })
    })
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$c() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var BoldText$2 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1twdvqz0"
} : {
  target: "e1twdvqz0",
  label: "BoldText"
})(process.env.NODE_ENV === "production" ? {
  name: "1efi8gv",
  styles: "font-weight:bold"
} : {
  name: "1efi8gv",
  styles: "font-weight:bold",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$c
});
var DecisionMagazineConfirmation = function DecisionMagazineConfirmation() {
  var _useDecisionMagazineC = useDecisionMagazineConfirmation(),
    description = _useDecisionMagazineC.description,
    price = _useDecisionMagazineC.price,
    transactionId = _useDecisionMagazineC.transactionId,
    transactionType = _useDecisionMagazineC.transactionType;
  var _useFormConfirmation = useFormConfirmation({
      isDonation: true
    }),
    confirmationRef = _useFormConfirmation.confirmationRef;
  return jsx("div", {
    className: "bgform-confirmation-container",
    ref: confirmationRef,
    children: jsx(Columns, {
      children: jsx(Container$1, {
        children: jsxs(Content, {
          children: [jsxs(Block, {
            textWeight: "bold",
            children: ["Thank you for your ", jsx("em", {
              children: "Decision"
            }), " magazine subscription."]
          }), jsxs(Block, {
            children: ["This transaction will be processed shortly and will appear on your next ", transactionType, " statement."]
          }), jsxs(Block, {
            children: ["Here is a summary of your subscription:", jsx(Table, {
              size: "narrow",
              striped: true,
              children: jsxs("tbody", {
                children: [jsxs("tr", {
                  children: [jsx("td", {
                    children: jsxs(BoldText$2, {
                      children: ["Confirmation", ' ', transactionType === 'bluefin' ? 'Number' : 'Code', ":"]
                    })
                  }), jsx("td", {
                    children: transactionId
                  })]
                }), jsxs("tr", {
                  children: [jsx("td", {
                    children: jsx(BoldText$2, {
                      children: "Subscription:"
                    })
                  }), jsx("td", {
                    children: description
                  })]
                }), jsxs("tr", {
                  children: [jsx("td", {
                    children: jsx(BoldText$2, {
                      children: "Price:"
                    })
                  }), jsxs("td", {
                    children: ["$", price.toFixed(2)]
                  })]
                })]
              })
            })]
          }), jsxs(Block, {
            children: ["If you have any questions, call us at 1-877-247-2426. Please have your confirmation number ready and indicate that you are contacting us about a ", transactionType, " transaction made through the Billy Graham Evangelistic Association website."]
          })]
        })
      })
    })
  });
};

var EmailSubscribeConfirmation = function EmailSubscribeConfirmation() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.customConfirmation;
  var _useFormConfirmation = useFormConfirmation({
      isDonation: false
    }),
    confirmationRef = _useFormConfirmation.confirmationRef;
  return jsx("div", {
    ref: confirmationRef,
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: CustomConfirmation ? jsx(CustomConfirmation, {}) : jsxs(Fragment, {
          children: [jsx(Block, {
            children: "Thank you!"
          }), jsx(Block, {
            children: "Your submission is complete."
          })]
        })
      })
    })
  });
};

var GroupMemberConfirmation = function GroupMemberConfirmation() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.customConfirmation;
  useFormConfirmation({
    isDonation: false
  });
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: CustomConfirmation ? jsx(CustomConfirmation, {}) : jsxs(Fragment, {
          children: [jsx(Block, {
            children: "You're almost done!"
          }), jsx(Block, {
            children: "Thank you for registering to serve with an on-site group. Your next step is to sign up for a shift on the day of the event. Your group leader will communicate with you when and how to sign up for your group's desired shift. When signing up for your shift, please use the same name and email that you used to fill out the volunteer form."
          }), jsx(Block, {
            children: "Ahead of the event, you will receive a volunteer kit* that you can use to invite your community to the God Loves You Frontera Tour. If you are a resident of the United States, your volunteer kit will be mailed directly to the address provided on your volunteer form. If you are a resident of Mexico, your volunteer kit will be mailed to a local church for distribution and you will be notified by email when and where your kit can be picked up."
          }), jsx(Block, {
            textWeight: "bold",
            children: "* Volunteer kits for Mexico residents will not be mailed for distribution after February 8, 2024. Volunteer kits for U.S. residents will not be mailed after February 19, 2024."
          }), jsxs(Block, {
            children: ["If you have any questions, contact us at", ' ', jsx("a", {
              href: "mailto:GodLovesYouTourVolunteers@billygraham.org",
              children: "GodLovesYouTourVolunteers@billygraham.org"
            })]
          }), jsx(Block, {
            children: "Please note: If you are under the age of 18, parent/legal guardian consent must be received by the Billy Graham Evangelistic Association (BGEA) before your volunteer kit can be mailed and before you can serve on-site the day of the event."
          })]
        })
      })
    })
  });
};

var GroupLeaderConfirmation = function GroupLeaderConfirmation() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.customConfirmation;
  useFormConfirmation({
    isDonation: false
  });
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: CustomConfirmation ? jsx(CustomConfirmation, {}) : jsxs(Fragment, {
          children: [jsx(Block, {
            children: "Thank you for your interest in bringing a group to serve at the God Loves You Tour! We're excited for you to partner with us in sharing the Good News in your community. Our team will send you additional information soon about getting the rest of your group registered."
          }), jsx(Block, {
            children: "Ahead of the event, you will receive a volunteer kit* that you can use to invite your community to the God Loves You Frontera Tour. If you are a resident of the United States, your volunteer kit will be mailed directly to the address provided on your volunteer form. If you are a resident of Mexico, your volunteer kit will be mailed to a local church for distribution and you will be notified by email when and where your kit can be picked up."
          }), jsx(Block, {
            textWeight: "bold",
            children: "* Volunteer kits for Mexico residents will not be mailed for distribution after February 8, 2024. Volunteer kits for U.S. residents will not be mailed after February 19, 2024."
          }), jsxs(Block, {
            children: ["If you have any additional questions, please contact", ' ', jsx("a", {
              href: "mailto:GodLovesYouTourVolunteers@billygraham.org",
              children: "GodLovesYouTourVolunteers@billygraham.org"
            }), "."]
          })]
        })
      })
    })
  });
};

var GroupRequestConfirmation = function GroupRequestConfirmation() {
  useFormConfirmation({
    isDonation: false
  });
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: jsx(Block, {
          children: "Thanks for your interest in hosting your group event at The Cove! We will review this request and get in touch with you shortly. Please check your spam mail if you do not receive a response from us in the next 24 hours."
        })
      })
    })
  });
};

var IndividualOnsiteConfirmation = function IndividualOnsiteConfirmation() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.individualConfirmationOnSite;
  useFormConfirmation({
    isDonation: false
  });
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: CustomConfirmation ? jsx(CustomConfirmation, {}) : jsxs(Fragment, {
          children: [jsx(Block, {
            children: "Thank you for signing up to help share about the tour, as well as your interest in serving on our on-site team!"
          }), jsx(Block, {
            children: "This team of volunteers serves the day of the event in a variety of roles, including setup, greeting, or staffing one of our many resource tents. The event would not be possible without our on-site team!"
          }), jsxs(Block, {
            textWeight: "bold",
            children: ["Brownsville, TX:", ' ', jsx("a", {
              href: "https://cvent.me/Eoy5l9",
              children: "https://cvent.me/Eoy5l9"
            }), ' ', jsx("br", {}), "McAllen, TX:", ' ', jsx("a", {
              href: "https://cvent.me/Yy42Yb",
              children: "https://cvent.me/Yy42Yb"
            }), ' ', jsx("br", {}), "Laredo, TX:", ' ', jsx("a", {
              href: "https://cvent.me/lR1WnN",
              children: "https://cvent.me/lR1WnN"
            }), ' ', jsx("br", {}), "Eagle Pass, TX:", ' ', jsx("a", {
              href: "https://cvent.me/qRkZeZ",
              children: "https://cvent.me/qRkZeZ"
            }), ' ', jsx("br", {}), "Del Rio, TX:", ' ', jsx("a", {
              href: "https://cvent.me/Zv3473",
              children: "https://cvent.me/Zv3473"
            }), ' ', jsx("br", {}), "Presidio, TX:", ' ', jsx("a", {
              href: "https://cvent.me/1mGR12",
              children: "https://cvent.me/1mGR12"
            }), ' ', jsx("br", {}), "El Paso, TX:", ' ', jsx("a", {
              href: "https://cvent.me/GkGmrR",
              children: "https://cvent.me/GkGmrR"
            }), ' ', jsx("br", {}), "Tucson, AZ:", ' ', jsx("a", {
              href: "https://cvent.me/e4Re4L",
              children: "https://cvent.me/e4Re4L"
            }), ' ', jsx("br", {}), "Yuma, AZ:", ' ', jsx("a", {
              href: "https://cvent.me/4KGnP4",
              children: "https://cvent.me/4KGnP4"
            }), ' ', jsx("br", {}), "Chula Vista, CA:", ' ', jsx("a", {
              href: "https://cvent.me/qRkBVV",
              children: "https://cvent.me/qRkBVV"
            })]
          }), jsx(Block, {
            children: "Ahead of the event, you will receive a volunteer kit* that you can use to invite your community to the God Loves You Frontera Tour. If you are a resident of the United States, your volunteer kit will be mailed directly to the address provided on your volunteer form. If you are a resident of Mexico, your volunteer kit will be mailed to a local church for distribution and you will be notified by email when and where your kit can be picked up."
          }), jsx(Block, {
            textWeight: "bold",
            children: "* Volunteer kits for Mexico residents will not be mailed for distribution after February 8, 2024. Volunteer kits for U.S. residents will not be mailed after February 19, 2024."
          }), jsxs(Block, {
            children: ["Be on the lookout for upcoming emails with important volunteer information and updates. Have questions? Please reach out to", ' ', jsx("a", {
              href: "mailto:GodLovesYouTourVolunteers@billygraham.org",
              children: "GodLovesYouTourVolunteers@billygraham.org"
            }), "."]
          }), jsx(Block, {
            children: "Please note: If you are under the age of 18, parent/legal guardian consent must be received by the Billy Graham Evangelistic Association (BGEA) before your volunteer kit can be mailed and before you can serve on-site the day of the event."
          })]
        })
      })
    })
  });
};

var IndividualPrayerConfirmation = function IndividualPrayerConfirmation() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.individualConfirmationPrayer;
  useFormConfirmation({
    isDonation: false
  });
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: CustomConfirmation ? jsx(CustomConfirmation, {}) : jsxs(Fragment, {
          children: [jsx(Block, {
            children: "Thank you for signing up to share about the tour, as well as your interest in serving as a member of the Prayer Team for the upcoming God Loves You Frontera Tour."
          }), jsx(Block, {
            children: "Ahead of the event, you will receive a volunteer kit* that you can use to invite your community to the tour. If you are a resident of the United States, your volunteer kit will be mailed directly to the address provided on your volunteer form. If you are a resident of Mexico, your volunteer kit will be mailed to a local church for distribution and you will be notified by email when and where your kit can be picked up."
          }), jsx(Block, {
            textWeight: "bold",
            children: "* Volunteer kits for Mexico residents will not be mailed for distribution after February 8, 2024. Volunteer kits for U.S. residents will not be mailed after February 19, 2024."
          }), jsx(Block, {
            children: "In the kit, you will find resources to help you spread the word about the tour, such as invitations, posters, and even a free T-shirt. A volunteer kit is sent to everyone who signs up, but receiving a kit does not mean that you are confirmed to serve on the Prayer Team. The following steps must first be completed before you can be considered."
          }), jsxs(Block, {
            children: ["1. Attend one Christian Life and Witness Course (CLWC) ", jsx("br", {}), "2. Submit a Prayer Team member application ", jsx("br", {}), "3. Complete a free background check* ", jsx("br", {}), "4. Provide a pastoral recommendation"]
          }), jsx(Block, {
            textWeight: "bold",
            children: "*Background checks are only required for citizens or permanent residents of the United States 18 years of age or older. For citizens of Mexico, only a pastoral recommendation is required."
          }), jsx(Block, {
            children: "Please note: If you are under the age of 18, parent/legal guardian consent must be received by the Billy Graham Evangelistic Association (BGEA), before your volunteer kit can be mailed and before you can serve as a Prayer Team member on the day of the event."
          }), jsx(Block, {
            textWeight: "bold",
            children: "Applications to apply for the Prayer Team are only available at Christian Life and Witness Courses."
          }), jsxs(Block, {
            children: ["Click here for more information", ' ', jsx("a", {
              href: "https://godlovesyoutour.com/prayer-team",
              children: "about the prayer team"
            }), ' ', "or to", ' ', jsx("a", {
              href: "https://godlovesyoutour.com/pre-events/CLWC",
              children: "find a class"
            }), ' ', "near you!"]
          }), jsx(Block, {
            children: "If you have any questions, please call 888-958-6329. (Monday\u2013Friday 8:30 a.m.\u20134:30 p.m. EDT)"
          })]
        })
      })
    })
  });
};

var IndividualVolunteerOnlyConfirmation = function IndividualVolunteerOnlyConfirmation() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.individualConfirmationVolunteerOnly;
  useFormConfirmation({
    isDonation: false
  });
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: CustomConfirmation ? jsx(CustomConfirmation, {}) : jsxs(Fragment, {
          children: [jsx(Block, {
            children: "Thank you for signing up to help share about the God Loves You Frontera Tour. We encourage you to go ahead and invite your friends to the tour."
          }), jsx(Block, {
            children: "If you are a resident of the United States, your volunteer kit* will be mailed directly to the address provided on your volunteer form. If you are a resident of Mexico, your volunteer kit will be mailed to a local church for distribution and you will be notified by email when and where your kit can be picked up. The kit will include posters, invitations, a T-shirt, and more. Please check your email for important volunteer information and updates."
          }), jsx(Block, {
            textWeight: "bold",
            children: "* Volunteer kits for Mexico residents will not be mailed for distribution after February 8, 2024. Volunteer kits for U.S. residents will not be mailed after February 19, 2024."
          }), jsxs(Block, {
            children: ["If you have any additional questions, contact", ' ', jsx("a", {
              href: "mailto:GodLovesYouTourVolunteers@billygraham.org",
              children: "GodLovesYouTourVolunteers@billygraham.org"
            }), "."]
          }), jsx(Block, {
            children: "Please note: If you are under the age of 18, parent/legal guardian consent must be received by the Billy Graham Evangelistic Association (BGEA) before your volunteer kit can be mailed."
          })]
        })
      })
    })
  });
};

var confirmationMap = {
  1302: jsx(IndividualOnsiteConfirmation, {}),
  1327: jsx(IndividualPrayerConfirmation, {})
};
var IndividualVolunteerConfirmation = function IndividualVolunteerConfirmation() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var formLogicRole = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.role;
  if (typeof formLogicRole !== 'string' || !formLogicRole) {
    return jsx(BasicConfirmation, {});
  }
  var roleObj = JSON.parse(formLogicRole);
  if (confirmationMap[roleObj === null || roleObj === void 0 ? void 0 : roleObj.crusadeCodeEventRoleId]) {
    return confirmationMap[roleObj === null || roleObj === void 0 ? void 0 : roleObj.crusadeCodeEventRoleId];
  }
  return jsx(IndividualVolunteerOnlyConfirmation, {});
};

var MediaRequestConfirmation = function MediaRequestConfirmation() {
  useFormConfirmation({
    isDonation: false
  });
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: jsx(Block, {
          children: "Thanks for contacting us! We will get in touch with you shortly."
        })
      })
    })
  });
};

var ConfirmationContainer = /*#__PURE__*/_styled(Container$1, process.env.NODE_ENV === "production" ? {
  target: "e1o1qqdq0"
} : {
  target: "e1o1qqdq0",
  label: "ConfirmationContainer"
})("background-color:", function (props) {
  return props !== null && props !== void 0 && props.confirmationBackgroundColor ? props === null || props === void 0 ? void 0 : props.confirmationBackgroundColor : 'transparent';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var OnlineGivingConfirmation = function OnlineGivingConfirmation() {
  var _useCheckoutConfirmat = useCheckoutConfirmation(),
    cartInfo = _useCheckoutConfirmat.cartInfo,
    confirmationBackgroundColor = _useCheckoutConfirmat.confirmationBackgroundColor,
    confirmationRef = _useCheckoutConfirmat.confirmationRef,
    recurrenceText = _useCheckoutConfirmat.recurrenceText,
    showRecurrenceText = _useCheckoutConfirmat.showRecurrenceText,
    total = _useCheckoutConfirmat.total,
    transactionId = _useCheckoutConfirmat.transactionId,
    CustomConfirmation = _useCheckoutConfirmat.CustomConfirmation,
    handleReload = _useCheckoutConfirmat.handleReload;
  return jsx("div", {
    className: "donation-confirmation-container",
    ref: confirmationRef,
    children: jsx(ConfirmationContainer, {
      confirmationBackgroundColor: confirmationBackgroundColor,
      children: jsx(Content, {
        children: cartInfo && total > 0 && jsx(Fragment, {
          children: CustomConfirmation ? jsx(CustomConfirmation, {
            recurrenceText: recurrenceText,
            showRecurrenceText: showRecurrenceText,
            total: total,
            transactionId: transactionId
          }) : jsxs(Fragment, {
            children: [jsxs(Block, {
              children: ["The confirmation number for this donation is ", transactionId]
            }), jsx(Block, {
              children: jsx(Button, {
                renderAs: "a",
                color: "info",
                onClick: handleReload,
                children: "Enter another donation"
              })
            })]
          })
        })
      })
    })
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$b() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var StyledHeading$1 = /*#__PURE__*/_styled(Heading, process.env.NODE_ENV === "production" ? {
  target: "e1q4lgmp4"
} : {
  target: "e1q4lgmp4",
  label: "StyledHeading"
})(process.env.NODE_ENV === "production" ? {
  name: "11b8c7e",
  styles: "text-align:left;font-weight:bold;font-size:43px;letter-spacing:2px;color:#3c85bf;line-height:1.2;font-style:normal;margin-top:0;margin-bottom:10px;text-rendering:optimizeLegibility;display:block"
} : {
  name: "11b8c7e",
  styles: "text-align:left;font-weight:bold;font-size:43px;letter-spacing:2px;color:#3c85bf;line-height:1.2;font-style:normal;margin-top:0;margin-bottom:10px;text-rendering:optimizeLegibility;display:block",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
var StyledList$2 = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1q4lgmp3"
} : {
  target: "e1q4lgmp3",
  label: "StyledList"
})(process.env.NODE_ENV === "production" ? {
  name: "1tpnq3m",
  styles: "list-style-type:circle;margin-left:5%;margin-bottom:1%"
} : {
  name: "1tpnq3m",
  styles: "list-style-type:circle;margin-left:5%;margin-bottom:1%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
var ListItem$2 = /*#__PURE__*/_styled("li", process.env.NODE_ENV === "production" ? {
  target: "e1q4lgmp2"
} : {
  target: "e1q4lgmp2",
  label: "ListItem"
})(process.env.NODE_ENV === "production" ? {
  name: "1tai6rc",
  styles: "margin-bottom:1%"
} : {
  name: "1tai6rc",
  styles: "margin-bottom:1%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
var HighlightText$2 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1q4lgmp1"
} : {
  target: "e1q4lgmp1",
  label: "HighlightText"
})(process.env.NODE_ENV === "production" ? {
  name: "1wrbz7p",
  styles: "color:#fd7400"
} : {
  name: "1wrbz7p",
  styles: "color:#fd7400",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
var FooterText$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1q4lgmp0"
} : {
  target: "e1q4lgmp0",
  label: "FooterText"
})(process.env.NODE_ENV === "production" ? {
  name: "x3brzu",
  styles: "color:#000"
} : {
  name: "x3brzu",
  styles: "color:#000",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$b
});
var ConfirmText$1 = function ConfirmText() {
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var resources = [{
    key: 'li0',
    url: 'https://courses.goingfarther.net/LivingInChrist?utm_source=Forgive.me&utm_medium=Link&utm_content=thank-you-again-LIC&utm_campaign=Forgive.me'
  }, {
    key: 'li1',
    url: 'https://courses.goingfarther.net/know-jesus?utm_source=PWGdotNet&utm_medium=GF+Link&utm_campaign=GF+Internal&utm_content=i-prayed-the-prayer&profession=PWG%20responsive&outreach=LP-home'
  }, {
    key: 'li2',
    url: 'https://goingfarther.net/basics-of-christianity/?utm_source=PWGdotNet&utm_medium=GF+Link&utm_campaign=GF+Internal&utm_content=i-prayed-the-prayer&profession=PWG%20responsive&outreach=LP-home'
  }, {
    key: 'li3',
    url: 'https://goingfarther.net/common-questions/?utm_source=PWGdotNet&utm_medium=GF+Link&utm_campaign=GF+Internal&utm_content=i-prayed-the-prayer&profession=PWG%20responsive&outreach=LP-home'
  }, {
    key: 'li4',
    url: 'https://goingfarther.net/life-issues/?utm_source=PWGdotNet&utm_medium=GF+Link&utm_campaign=GF+Internal&utm_content=i-prayed-the-prayer&profession=PWG%20responsive&outreach=LP-home'
  }, {
    key: 'li5',
    url: 'https://churches.goingfarther.net/?utm_source=PWGdotNet&utm_medium=GF%20Link&utm_campaign=GF%20Internal&utm_content=i-prayed-the-prayer&profession=PWG%20responsive&outreach=LP-home'
  }];
  return jsxs(Fragment, {
    children: [jsx(StyledHeading$1, {
      size: 4,
      className: "success",
      children: t('Thank you!', {
        ns: 'labels'
      })
    }), jsxs(Content, {
      children: [jsx("p", {
        children: t('Peace With God Contact Confirmation', {
          ns: 'common'
        })
      }), jsx(StyledList$2, {
        children: resources.map(function (resource) {
          return jsx(ListItem$2, {
            children: jsxs(Content, {
              children: [jsx(HighlightText$2, {
                children: jsx("a", {
                  href: resource.url,
                  target: "_blank",
                  rel: "noreferrer",
                  children: t("Peace With God Resources_".concat(resource.key), {
                    ns: 'common'
                  })
                })
              }), jsx(FooterText$1, {
                children: t("Peace With God Resources_".concat(resource.key, "_text"), {
                  ns: 'common'
                })
              })]
            })
          }, resource.key);
        })
      }), jsx("p", {
        children: t('Peace With God Contact Confirmation2', {
          ns: 'common'
        })
      })]
    })]
  });
};
var ConfirmText$2 = ConfirmText$1;

function _EMOTION_STRINGIFIED_CSS_ERROR__$a() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var StyledHeading = /*#__PURE__*/_styled(Heading, process.env.NODE_ENV === "production" ? {
  target: "e1y7ndls4"
} : {
  target: "e1y7ndls4",
  label: "StyledHeading"
})(process.env.NODE_ENV === "production" ? {
  name: "11b8c7e",
  styles: "text-align:left;font-weight:bold;font-size:43px;letter-spacing:2px;color:#3c85bf;line-height:1.2;font-style:normal;margin-top:0;margin-bottom:10px;text-rendering:optimizeLegibility;display:block"
} : {
  name: "11b8c7e",
  styles: "text-align:left;font-weight:bold;font-size:43px;letter-spacing:2px;color:#3c85bf;line-height:1.2;font-style:normal;margin-top:0;margin-bottom:10px;text-rendering:optimizeLegibility;display:block",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});
var StyledList$1 = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e1y7ndls3"
} : {
  target: "e1y7ndls3",
  label: "StyledList"
})(process.env.NODE_ENV === "production" ? {
  name: "1tpnq3m",
  styles: "list-style-type:circle;margin-left:5%;margin-bottom:1%"
} : {
  name: "1tpnq3m",
  styles: "list-style-type:circle;margin-left:5%;margin-bottom:1%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});
var ListItem$1 = /*#__PURE__*/_styled("li", process.env.NODE_ENV === "production" ? {
  target: "e1y7ndls2"
} : {
  target: "e1y7ndls2",
  label: "ListItem"
})(process.env.NODE_ENV === "production" ? {
  name: "1tai6rc",
  styles: "margin-bottom:1%"
} : {
  name: "1tai6rc",
  styles: "margin-bottom:1%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});
var HighlightText$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1y7ndls1"
} : {
  target: "e1y7ndls1",
  label: "HighlightText"
})(process.env.NODE_ENV === "production" ? {
  name: "1wrbz7p",
  styles: "color:#fd7400"
} : {
  name: "1wrbz7p",
  styles: "color:#fd7400",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIkNvbmZpcm1QcmF5ZWQudHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQTRCaUMiLCJmaWxlIjoiQ29uZmlybVByYXllZC50c3giLCJzb3VyY2VzQ29udGVudCI6WyJpbXBvcnQgeyB1c2VUcmFuc2xhdGlvbiB9IGZyb20gJ3JlYWN0LWkxOG5leHQnO1xuaW1wb3J0IHsgSGVhZGluZywgQ29udGVudCB9IGZyb20gJ0BiZ2VhLWpzL3JlYWN0LXVpJztcbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcblxuY29uc3QgU3R5bGVkSGVhZGluZyA9IHN0eWxlZChIZWFkaW5nKWBcbiAgdGV4dC1hbGlnbjogbGVmdDtcbiAgZm9udC13ZWlnaHQ6IGJvbGQ7XG4gIGZvbnQtc2l6ZTogNDNweDtcbiAgbGV0dGVyLXNwYWNpbmc6IDJweDtcbiAgY29sb3I6ICMzYzg1YmY7XG4gIGxpbmUtaGVpZ2h0OiAxLjI7XG4gIGZvbnQtc3R5bGU6IG5vcm1hbDtcbiAgbWFyZ2luLXRvcDogMDtcbiAgbWFyZ2luLWJvdHRvbTogMTBweDtcbiAgdGV4dC1yZW5kZXJpbmc6IG9wdGltaXplTGVnaWJpbGl0eTtcbiAgZGlzcGxheTogYmxvY2s7XG5gO1xuXG5jb25zdCBTdHlsZWRMaXN0ID0gc3R5bGVkLnVsYFxuICBsaXN0LXN0eWxlLXR5cGU6IGNpcmNsZTtcbiAgbWFyZ2luLWxlZnQ6IDUlO1xuICBtYXJnaW4tYm90dG9tOiAxJTtcbmA7XG5cbmNvbnN0IExpc3RJdGVtID0gc3R5bGVkLmxpYFxuICBtYXJnaW4tYm90dG9tOiAxJTtcbmA7XG5cbmNvbnN0IEhpZ2hsaWdodFRleHQgPSBzdHlsZWQuc3BhbmBcbiAgY29sb3I6ICNmZDc0MDA7XG5gO1xuXG5jb25zdCBCb2xkVGV4dCA9IHN0eWxlZC5zcGFuYFxuICBmb250LXdlaWdodDogYm9sZDtcbmA7XG5cbmNvbnN0IENvbmZpcm1UZXh0ID0gKCkgPT4ge1xuICBjb25zdCB7IHQgfSA9IHVzZVRyYW5zbGF0aW9uKFsnY29tbW9uJywgJ2xhYmVscycsICd2YWxpZGF0aW9uJ10pO1xuICBjb25zdCBsaXN0SXRlbXMgPSBbXG4gICAge1xuICAgICAga2V5OiAnbGk2JyxcbiAgICAgIGJvbGRLZXk6ICdsaTEnLFxuICAgICAgdXJsOlxuICAgICAgICAnaHR0cHM6Ly9jb3Vyc2VzLmdvaW5nZmFydGhlci5uZXQva25vdy1qZXN1cy8/dXRtX3NvdXJjZT1QV0dkb3ROZXQmYW1wO3V0bV9tZWRpdW09R0YrTGluayZhbXA7dXRtX2NhbXBhaWduPUdGK0ludGVybmFsJmFtcDt1dG1fY29udGVudD10aGFuayt5b3UrcGFnZStmaXJzdCt0aW1lJyxcbiAgICB9LFxuICAgIHtcbiAgICAgIGtleTogJ2xpNycsXG4gICAgICB1cmw6XG4gICAgICAgICdodHRwOi8vY2h1cmNoZXMuZ29pbmdmYXJ0aGVyLm5ldC8/dXRtX3NvdXJjZT1QV0dkb3ROZXQmYW1wO3V0bV9tZWRpdW09Q0dGK0xpbmsmYW1wO3V0bV9jYW1wYWlnbj1DR0YrSW50ZXJuYWwmYW1wO3V0bV9jb250ZW50PXRoYW5rK3lvdStwYWdlK2ZpcnN0K3RpbWUnLFxuICAgIH0sXG4gICAge1xuICAgICAga2V5OiAnbGk4JyxcbiAgICAgIGJvbGRLZXk6ICdsaTknLFxuICAgICAgdXJsOlxuICAgICAgICAnaHR0cDovL2dvaW5nZmFydGhlci5uZXQvP3V0bV9zb3VyY2U9UFdHZG90TmV0JmFtcDt1dG1fbWVkaXVtPUdGK0xpbmsmYW1wO3V0bV9jYW1wYWlnbj1HRitJbnRlcm5hbCZhbXA7dXRtX2NvbnRlbnQ9dGhhbmsreW91K3BhZ2UrZmlyc3QrdGltZScsXG4gICAgfSxcbiAgXTtcblxuICByZXR1cm4gKFxuICAgIDw+XG4gICAgICA8U3R5bGVkSGVhZGluZyBzaXplPXs0fSBjbGFzc05hbWU9XCJzdWNjZXNzXCI+XG4gICAgICAgIHt0KCdXb25kZXJmdWwnLCB7IG5zOiAnbGFiZWxzJyB9KX1cbiAgICAgIDwvU3R5bGVkSGVhZGluZz5cbiAgICAgIDxDb250ZW50PlxuICAgICAgICA8cD57dCgnUGVhY2UgV2l0aCBHb2QgVGhhbmtzIFN1bW1hcnknLCB7IG5zOiAnY29tbW9uJyB9KX08L3A+XG4gICAgICAgIDxwPnt0KCdQZWFjZSBXaXRoIEdvZCBUaGFua3MgU3VtbWFyeTInLCB7IG5zOiAnY29tbW9uJyB9KX08L3A+XG4gICAgICAgIDxwPnt0KCdQZWFjZSBXaXRoIEdvZCBUaGFua3MgU3VtbWFyeTMnLCB7IG5zOiAnY29tbW9uJyB9KX08L3A+XG4gICAgICAgIDxTdHlsZWRMaXN0PlxuICAgICAgICAgIHtsaXN0SXRlbXMubWFwKChpdGVtKSA9PiAoXG4gICAgICAgICAgICA8TGlzdEl0ZW0ga2V5PXtpdGVtLmtleX0+XG4gICAgICAgICAgICAgIDxIaWdobGlnaHRUZXh0PlxuICAgICAgICAgICAgICAgIDxhIGhyZWY9e2l0ZW0udXJsfSB0YXJnZXQ9XCJfYmxhbmtcIiByZWw9XCJub3JlZmVycmVyXCI+XG4gICAgICAgICAgICAgICAgICB7dChgUGVhY2UgV2l0aCBHb2QgUmVzb3VyY2VzXyR7aXRlbS5rZXl9YCwgeyBuczogJ2NvbW1vbicgfSl9XG4gICAgICAgICAgICAgICAgPC9hPlxuICAgICAgICAgICAgICA8L0hpZ2hsaWdodFRleHQ+XG4gICAgICAgICAgICAgICwmbmJzcDtcbiAgICAgICAgICAgICAge2l0ZW0uYm9sZEtleSAmJiAoXG4gICAgICAgICAgICAgICAgPEJvbGRUZXh0PlxuICAgICAgICAgICAgICAgICAge3QoYFBlYWNlIFdpdGggR29kIFJlc291cmNlc18ke2l0ZW0uYm9sZEtleX1gLCB7XG4gICAgICAgICAgICAgICAgICAgIG5zOiAnY29tbW9uJyxcbiAgICAgICAgICAgICAgICAgIH0pfVxuICAgICAgICAgICAgICAgIDwvQm9sZFRleHQ+XG4gICAgICAgICAgICAgICl9XG4gICAgICAgICAgICAgIDxzcGFuPlxuICAgICAgICAgICAgICAgIHt0KGBQZWFjZSBXaXRoIEdvZCBSZXNvdXJjZXNfJHtpdGVtLmtleX1fdGV4dGAsIHtcbiAgICAgICAgICAgICAgICAgIG5zOiAnY29tbW9uJyxcbiAgICAgICAgICAgICAgICB9KX1cbiAgICAgICAgICAgICAgPC9zcGFuPlxuICAgICAgICAgICAgPC9MaXN0SXRlbT5cbiAgICAgICAgICApKX1cbiAgICAgICAgPC9TdHlsZWRMaXN0PlxuICAgICAgICA8cD57dCgnUGVhY2UgV2l0aCBHb2QgVGhhbmtzIEZvb3RlcicsIHsgbnM6ICdjb21tb24nIH0pfTwvcD5cbiAgICAgICAgPHA+e3QoJ1BlYWNlIFdpdGggR29kIFRoYW5rcyBGb290ZXIyJywgeyBuczogJ2NvbW1vbicgfSl9PC9wPlxuICAgICAgICA8cD5cbiAgICAgICAgICB7dCgnUGVhY2UgV2l0aCBHb2QgVGhhbmtzIEZvb3RlcjMnLCB7IG5zOiAnY29tbW9uJyB9KX1cbiAgICAgICAgICA8Qm9sZFRleHQ+XG4gICAgICAgICAgICB7dCgnUGVhY2UgV2l0aCBHb2QgVGhhbmtzIEZvb3RlcjQnLCB7IG5zOiAnY29tbW9uJyB9KX1cbiAgICAgICAgICA8L0JvbGRUZXh0PlxuICAgICAgICA8L3A+XG4gICAgICA8L0NvbnRlbnQ+XG4gICAgPC8+XG4gICk7XG59O1xuXG5leHBvcnQgZGVmYXVsdCBDb25maXJtVGV4dDtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});
var BoldText$1 = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1y7ndls0"
} : {
  target: "e1y7ndls0",
  label: "BoldText"
})(process.env.NODE_ENV === "production" ? {
  name: "1efi8gv",
  styles: "font-weight:bold"
} : {
  name: "1efi8gv",
  styles: "font-weight:bold",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$a
});
var ConfirmText = function ConfirmText() {
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var listItems = [{
    key: 'li6',
    boldKey: 'li1',
    url: 'https://courses.goingfarther.net/know-jesus/?utm_source=PWGdotNet&amp;utm_medium=GF+Link&amp;utm_campaign=GF+Internal&amp;utm_content=thank+you+page+first+time'
  }, {
    key: 'li7',
    url: 'http://churches.goingfarther.net/?utm_source=PWGdotNet&amp;utm_medium=CGF+Link&amp;utm_campaign=CGF+Internal&amp;utm_content=thank+you+page+first+time'
  }, {
    key: 'li8',
    boldKey: 'li9',
    url: 'http://goingfarther.net/?utm_source=PWGdotNet&amp;utm_medium=GF+Link&amp;utm_campaign=GF+Internal&amp;utm_content=thank+you+page+first+time'
  }];
  return jsxs(Fragment, {
    children: [jsx(StyledHeading, {
      size: 4,
      className: "success",
      children: t('Wonderful', {
        ns: 'labels'
      })
    }), jsxs(Content, {
      children: [jsx("p", {
        children: t('Peace With God Thanks Summary', {
          ns: 'common'
        })
      }), jsx("p", {
        children: t('Peace With God Thanks Summary2', {
          ns: 'common'
        })
      }), jsx("p", {
        children: t('Peace With God Thanks Summary3', {
          ns: 'common'
        })
      }), jsx(StyledList$1, {
        children: listItems.map(function (item) {
          return jsxs(ListItem$1, {
            children: [jsx(HighlightText$1, {
              children: jsx("a", {
                href: item.url,
                target: "_blank",
                rel: "noreferrer",
                children: t("Peace With God Resources_".concat(item.key), {
                  ns: 'common'
                })
              })
            }), ",\xA0", item.boldKey && jsx(BoldText$1, {
              children: t("Peace With God Resources_".concat(item.boldKey), {
                ns: 'common'
              })
            }), jsx("span", {
              children: t("Peace With God Resources_".concat(item.key, "_text"), {
                ns: 'common'
              })
            })]
          }, item.key);
        })
      }), jsx("p", {
        children: t('Peace With God Thanks Footer', {
          ns: 'common'
        })
      }), jsx("p", {
        children: t('Peace With God Thanks Footer2', {
          ns: 'common'
        })
      }), jsxs("p", {
        children: [t('Peace With God Thanks Footer3', {
          ns: 'common'
        }), jsx(BoldText$1, {
          children: t('Peace With God Thanks Footer4', {
            ns: 'common'
          })
        })]
      })]
    })]
  });
};
var ConfirmPrayed = ConfirmText;

var PeaceWithGodPrayerConfirmation = function PeaceWithGodPrayerConfirmation() {
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: values.formLogic && values.formLogic.type === '0' ? jsx(ConfirmPrayed, {}) : jsx(ConfirmText$2, {})
      })
    })
  });
};

var PeaceWithGodQuestionConfirmation = function PeaceWithGodQuestionConfirmation() {
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: jsx(ConfirmText$2, {})
      })
    })
  });
};

var PrayerTeamConfirmation = function PrayerTeamConfirmation() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.customConfirmation;
  useFormConfirmation({
    isDonation: false
  });
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsx(Content, {
        children: CustomConfirmation ? jsx(CustomConfirmation, {}) : jsxs(Fragment, {
          children: [jsx(Block, {
            children: "You have successfully submitted your application for the Prayer Team. Thank you, we are grateful for you! However, before your application can be considered for approval, you will need to complete the additional steps below."
          }), jsx(Block, {
            textWeight: "bold",
            children: "Next Steps:"
          }), jsxs(Block, {
            children: [jsx("b", {
              children: "1. Complete a free background check:"
            }), " Upon the submission of your prayer team application, you will receive an email from", ' ', jsx("a", {
              href: "mailto:TeamBGEA@bgraham.org, ",
              children: "TeamBGEA@bgraham.org"
            }), ", containing the links to a free background check. If you are 18 years of age or older, please click on the link for your city if you are a citizen or permanent resident of the United States. Click on the link for Mexico if you are a citizen of Mexico."]
          }), jsxs(Block, {
            children: [jsx("b", {
              children: "2. Pastoral Recommendation:"
            }), " An email has been sent to the pastor / church leader contact you provided on your application\u2014they will need to reply to that email as soon as possible. Please reach out to your contact and ask them to respond in a timely manner."]
          }), jsx(Block, {
            children: "Please note: If you are under the age of 18, parent/legal guardian consent must be received by the Billy Graham Evangelistic Association (BGEA) before your volunteer kit* can be mailed and before you can serve as a Prayer Team member on the day of the event."
          }), jsx(Block, {
            children: "If you are a resident of the United States, your volunteer kit will be mailed directly to the address provided on your volunteer form. If you are a resident of Mexico, your volunteer kit will be mailed to a local church for distribution and you will be notified by email when and where your kit can be picked up."
          }), jsx(Block, {
            textWeight: "bold",
            children: "* Volunteer kits for Mexico residents will not be mailed for distribution after February 8, 2024. Volunteer kits for U.S. residents will not be mailed after February 19, 2024."
          }), jsx(Block, {
            children: "If you have any questions, please call 888-958-6329 (Monday-Friday 8:30 a.m.-4:30 p.m. EDT)."
          })]
        })
      })
    })
  });
};

var SubscriptionConfirmation = function SubscriptionConfirmation() {
  var _values$formLogic;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values;
  var CustomConfirmation = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.customConfirmation;
  useFormConfirmation({
    isDonation: false
  });
  return jsx("div", {
    className: "subscription-confirmation",
    children: jsx(Columns, {
      children: jsx(Container$1, {
        children: jsx(Content, {
          children: CustomConfirmation ? jsx(CustomConfirmation, {}) : jsxs(Fragment, {
            children: [jsx(Block, {
              children: "Thanks for updating your email subscription preferences. Please allow 24 hours for your request to process."
            }), jsxs(Block, {
              children: ["We appreciate your interest in the ministry of the Billy Graham Evangelistic Association. You can also follow BGEA on", ' ', jsx("a", {
                href: "http://billygraham.org/news/media-resources/social-media/",
                children: "social media"
              }), ' ', "for daily updates and encouragement."]
            })]
          })
        })
      })
    })
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$9() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var BoldText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e1xskcl50"
} : {
  target: "e1xskcl50",
  label: "BoldText"
})(process.env.NODE_ENV === "production" ? {
  name: "1efi8gv",
  styles: "font-weight:bold"
} : {
  name: "1efi8gv",
  styles: "font-weight:bold",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$9
});
var TrainingRegistrationConfirmation = function TrainingRegistrationConfirmation() {
  var _useTrainingRegistrat = useTrainingRegistrationConfirmation(),
    courseName = _useTrainingRegistrat.courseName,
    coursePrice = _useTrainingRegistrat.coursePrice,
    isGift = _useTrainingRegistrat.isGift,
    transactionId = _useTrainingRegistrat.transactionId,
    transactionType = _useTrainingRegistrat.transactionType,
    userInfo = _useTrainingRegistrat.userInfo;
  useFormConfirmation({
    isDonation: false
  });
  return jsx(Columns, {
    children: jsx(Container$1, {
      children: jsxs(Content, {
        children: [jsx(Block, {
          children: jsx(BoldText, {
            children: isGift ? "Thank you for registering ".concat(userInfo.firstName, " \n                  ").concat(userInfo.lastName, " for Online Training.") : "Thank you for your Online Training registration."
          })
        }), jsxs(Block, {
          children: ["This transaction will be processed shortly and will appear on your", ' ', transactionType, " statement. An acknowledgment will be mailed to your billing address."]
        }), jsx(Block, {
          children: isGift ? "".concat(userInfo.firstName, " will receive an email with the username and\n              password for accessing the course.") : "You will receive an email with your username and password."
        }), jsxs(Block, {
          children: ["Here is a summary of your registration:", jsx(Table, {
            children: jsxs("tbody", {
              children: [jsxs("tr", {
                children: [jsx("td", {
                  style: {
                    textAlign: 'right'
                  },
                  children: jsxs(BoldText, {
                    children: ["Confirmation", ' ', transactionType === 'bluefin' ? 'Number' : 'Code', ":"]
                  })
                }), jsx("td", {
                  children: transactionId
                })]
              }), jsxs("tr", {
                children: [jsx("td", {
                  style: {
                    textAlign: 'right'
                  },
                  children: jsx(BoldText, {
                    children: "Registration:"
                  })
                }), jsx("td", {
                  children: courseName
                })]
              }), jsxs("tr", {
                children: [jsx("td", {
                  style: {
                    textAlign: 'right'
                  },
                  children: jsx(BoldText, {
                    children: "Price:"
                  })
                }), jsxs("td", {
                  children: ["$", coursePrice.toFixed(2)]
                })]
              })]
            })
          })]
        }), jsxs(Block, {
          children: ["If you have any questions, call us at 1-877-247-2426. Please have your confirmation", ' ', transactionType === 'bluefin' ? 'number' : 'code', " ready and indicate that you are contacting us about a ", transactionType, ' ', "transaction made through the Billy Graham Evangelistic Association website."]
        })]
      })
    })
  });
};

var CallTaker = function CallTaker(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.CALL_TAKER_FORM;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(CallTakerInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var MinistryInfo = function MinistryInfo() {
  return jsxs(Block, {
    children: [jsx(Content, {
      children: "2. Please check the ministry role(s) in which you have served in the past."
    }), jsxs(Columns, {
      children: [jsx(Columns.Column, {
        size: 5,
        children: "Ministry Role"
      }), jsx(Columns.Column, {
        size: 7,
        children: "Dates Served"
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.pastor",
          name: "formLogic.pastor",
          label: "Pastor"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      }), jsxs(Columns.Column, {
        size: 5,
        children: [jsx(Block, {
          paddingless: true,
          marginless: true,
          children: jsx(Checkbox, {
            id: "formLogic.chaplain",
            name: "formLogic.chaplain",
            label: "Chaplain:"
          })
        }), jsx(Block, {
          children: jsx(InputText, {
            name: "formLogic.chaplain.type",
            label: "Specify: Military, FBI, Police, Fire, etc."
          })
        })]
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      }), jsxs(Columns.Column, {
        size: 5,
        children: [jsx(Block, {
          paddingless: true,
          marginless: true,
          children: jsx(Checkbox, {
            id: "formLogic.counselor",
            name: "formLogic.counselor",
            label: "Christian Counselor (Licensed/Certified) "
          })
        }), jsx(Block, {
          children: jsx(InputText, {
            name: "formLogic.chaplain.type",
            label: "Specify: Adult, Youth, Children"
          })
        })]
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.ministryLeader",
          name: "formLogic.ministryLeader",
          label: "Ministry Leader"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.lawEnforcement",
          name: "formLogic.lawEnforcement",
          label: "Law Enforcement"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.fire",
          name: "formLogic.fire",
          label: "Fire"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.hospiceWorker",
          name: "formLogic.hospiceWorker",
          label: "Hospice Worker"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.militaryPersonnel",
          name: "formLogic.militaryPersonnel",
          label: "Military Personnel"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.ems",
          name: "formLogic.ems",
          label: "EMS"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.cdl",
          name: "formLogic.cdl",
          label: "CDL"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.cismInstructor",
          name: "formLogic.cismInstructor",
          label: "CISM Instructor"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      }), jsxs(Columns.Column, {
        size: 5,
        children: [jsx(Block, {
          paddingless: true,
          marginless: true,
          children: jsx(Checkbox, {
            id: "formLogic.other",
            name: "formLogic.other",
            label: "Other"
          })
        }), jsx(Block, {
          children: jsx(TextArea, {
            label: "Please Describe:",
            name: "formLogic.materialInfo.description",
            required: false
          })
        })]
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(DateCalendar, {
          label: "",
          name: "formLogic.volunteerApp.statementOfPracticeDate",
          minDate: new Date(),
          required: true
        })
      })]
    })]
  });
};

var TrainingInfo = function TrainingInfo() {
  return jsxs(Block, {
    children: [jsx(Content, {
      children: "3. Please check any training you have attended and fill in date and location."
    }), jsxs(Columns, {
      children: [jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.shic",
          name: "formLogic.shic",
          label: "Sharing Hope in Crisis (BG-RRT)"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(InputText, {
          name: "formLogic.shicDateLocation",
          label: ""
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.shicOnline",
          name: "formLogic.shicOnline",
          label: "Sharing Hope in Crisis Online"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(InputText, {
          name: "formLogic.shicDateLocation",
          label: ""
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.cismCourses",
          name: "formLogic.cismCourses",
          label: "Critical Incident Stress Management (CISM) course(s):"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(InputText, {
          name: "formLogic.shicDateLocation",
          label: ""
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.crisisInterventionTraining",
          name: "formLogic.crisisInterventionTraining",
          label: "Crisis Intervention Training"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(InputText, {
          name: "formLogic.shicDateLocation",
          label: ""
        })
      }), jsx(Columns.Column, {
        size: 5,
        children: jsx(Checkbox, {
          id: "formLogic.other",
          name: "formLogic.other",
          label: "Other (Please describe)"
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(InputText, {
          name: "formLogic.shicDateLocation",
          label: ""
        })
      })]
    })]
  });
};

var ExperienceInfo = function ExperienceInfo() {
  return jsxs(Block, {
    children: [jsx(TextArea, {
      label: "Please describe past experience and duties in disaster, grief, trauma, crisis intervention, or missions.",
      name: "formLogic.experienceInfo.description",
      required: false
    }), jsx(RadioGroup, {
      display: "is-block",
      label: "Do you have any physical, emotional, or medical limitations that would hinder your involvement at a disaster site?\n      If so, please explain. ",
      name: "formLogic.subLocation",
      options: [{
        label: 'Yes',
        name: 'formLogic.experienceInfo.limitation.yes',
        value: 'yes'
      }, {
        label: 'No',
        name: 'formLogic.experienceInfo.limitation.no',
        value: 'no'
      }]
    }), jsx(Content, {
      children: "Please indicate agreement to and compliance with all the required deployment conditions listed below:"
    }), jsx(Checkbox, {
      id: "formLogic.climbStairs",
      name: "formLogic.climbStairs",
      label: "Climb stairs"
    }), jsx(Checkbox, {
      id: "formLogic.sleepAirMattress",
      name: "formLogic.sleepAirMattress",
      label: "Sleep on air mattress or cot"
    }), jsx(Checkbox, {
      id: "formLogic.liftPounds",
      name: "formLogic.liftPounds",
      label: "Lift 25 pounds"
    }), jsx(Checkbox, {
      id: "formLogic.noElectricity",
      name: "formLogic.noElectricity",
      label: "No electricity"
    }), jsx(Checkbox, {
      id: "formLogic.extremeWeather",
      name: "formLogic.extremeWeather",
      label: "Extreme weather conditions (below 25 degrees F or above 95 degrees F)"
    }), jsx(Checkbox, {
      id: "formLogic.workHourPerDay",
      name: "formLogic.workHourPerDay",
      label: "Work 14 hours per day"
    }), jsx(Checkbox, {
      id: "formLogic.extendedTimes",
      name: "formLogic.extendedTimes",
      label: "Extended times standing or walking"
    }), jsx(Checkbox, {
      id: "formLogic.assistDailyChores",
      name: "formLogic.assistDailyChores",
      label: "Assist with daily chores (cleaning, laundry, etc.)"
    }), jsx(TextArea, {
      label: "According to 1 Peter 3:15, \u201CAlways be prepared to give an answer to everyone who asks you to give\nthe reason for the hope that you have. But do this with gentleness and respect\u201D (NIV). How would\nyou answer if someone asked you, \u201CWhat must I do to have a personal relationship with Christ,\nto experience His hope and comfort?\u201D",
      name: "formLogic.experienceInfo.description",
      required: false
    }), jsx(RadioGroup, {
      label: "How comfortable would you be responding to their question according to God\u2019s Word? Please\nindicate your response on the scale below.",
      name: "formLogic.subLocation",
      options: [{
        label: '1',
        name: 'formLogic.experienceInfo.comfortable.one',
        value: '1'
      }, {
        label: '2',
        name: 'formLogic.experienceInfo.comfortable.two',
        value: '2'
      }, {
        label: '3',
        name: 'formLogic.experienceInfo.comfortable.three',
        value: '3'
      }, {
        label: '4',
        name: 'formLogic.experienceInfo.comfortable.four',
        value: '4'
      }, {
        label: '5',
        name: 'formLogic.experienceInfo.comfortable.five',
        value: '5'
      }, {
        label: '6',
        name: 'formLogic.experienceInfo.comfortable.six',
        value: '6'
      }, {
        label: '7',
        name: 'formLogic.experienceInfo.comfortable.seven',
        value: '7'
      }, {
        label: '8',
        name: 'formLogic.experienceInfo.comfortable.eight',
        value: '8'
      }, {
        label: '9',
        name: 'formLogic.experienceInfo.comfortable.nine',
        value: '9'
      }, {
        label: '10',
        name: 'formLogic.experienceInfo.comfortable.ten',
        value: '10'
      }]
    }), jsx(RadioGroup, {
      display: "is-block",
      label: "Would you be able to deploy to a disaster, if sent, for one week every two years?",
      name: "formLogic.subLocation",
      options: [{
        label: 'Yes',
        name: 'formLogic.experienceInfo.deployDisaster.yes',
        value: 'yes'
      }, {
        label: 'No',
        name: 'formLogic.experienceInfo.deployDisaster.no',
        value: 'no'
      }]
    }), jsx(RadioGroup, {
      display: "is-block",
      label: "Are you able to cover your own travel expenses to and from a deployment, including but not limited to air\n travel and getting to and from the host church?",
      name: "formLogic.subLocation",
      options: [{
        label: 'Yes',
        name: 'formLogic.experienceInfo.travelExpenses.yes',
        value: 'yes'
      }, {
        label: 'No',
        name: 'formLogic.experienceInfo.travelExpenses.no',
        value: 'no'
      }]
    }), jsx(Content, {
      children: "Do you have (If yes, please provide a copy):"
    }), jsx(RadioGroup, {
      label: "A valid driver\u2019s license?",
      name: "formLogic.subLocation",
      options: [{
        label: 'Yes',
        name: 'formLogic.experienceInfo.driverLicense.yes',
        value: 'yes'
      }, {
        label: 'No',
        name: 'formLogic.experienceInfo.driverLicense.no',
        value: 'no'
      }]
    }), jsx(RadioGroup, {
      label: "A commercial driver\u2019s license?",
      name: "formLogic.subLocation",
      options: [{
        label: 'Yes',
        name: 'formLogic.experienceInfo.commercialDriverLicense.yes',
        value: 'yes'
      }, {
        label: 'No',
        name: 'formLogic.experienceInfo.commercialDriverLicense.no',
        value: 'no'
      }]
    }), jsx(RadioGroup, {
      label: "A passport?",
      name: "formLogic.subLocation",
      options: [{
        label: 'Yes',
        name: 'formLogic.experienceInfo.passport.yes',
        value: 'yes'
      }, {
        label: 'No',
        name: 'formLogic.experienceInfo.passport.no',
        value: 'no'
      }]
    }), jsx(InputText, {
      name: "formLogic.experienceInfo.languages",
      label: "List any languages you speak fluently in addition to English (including sign language)."
    })]
  });
};

var ReferenceInfo = function ReferenceInfo(_ref) {
  var _ref$entity = _ref.entity,
    entity = _ref$entity === void 0 ? 0 : _ref$entity;
  return jsxs(Fragment, {
    children: [jsx(Name$1, {
      entity: entity,
      required: true
    }), jsx(InputText, {
      name: "references[{entity}].relationship",
      label: "Relationship and dates known"
    }), jsx(EntityFields, {
      addressVisibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode'],
      entity: entity,
      emailRequired: true,
      country: ['US'],
      visibleList: ['Address', 'Phone', 'Email'],
      minPhoneLength: 10,
      required: true
    })]
  });
};

var StatementFaithInfo = function StatementFaithInfo() {
  return jsxs(Fragment, {
    children: [jsx(Content, {
      children: "By applying for consideration as a volunteer chaplain for the Billy Graham Rapid Response Team of the Billy Graham Evangelistic Association (BGEA), I acknowledge my understanding and agreement that the selection of volunteers is at the sole discretion of BGEA, based on its assessment of the overall qualifications of volunteer applicants and BGEA\u2019s ministry requirements."
    }), jsx(Content, {
      children: "Assumption of Risk/Release: I understand that while volunteering for BGEA, I may be exposed to dangerous or hazardous situations and environments and may engage in hazardous work involving risk of illness, including COVID-19 or similar variant or illness, physical injury, property damage, or even death, resulting from hard physical labor and exposure to environmental hazards, such as mold or inclement weather. I also understand that I may be volunteering alongside disaster relief workers using equipment which is dangerous to operate and can cause serious injury or death. I hereby assume all risks associated with performance of these activities and release and forever discharge BGEA from any and all liability, including for negligent acts or omissions, for claims or damages I might have that result from my work with BGEA as a volunteer, and any related claims or damages arising from BGEA\u2019s selection of disaster response or activities, provision of equipment, or provision of food, lodging, or transportation in connection with volunteering with BGEA. I understand that BGEA is not responsible for the safety or security of my personal effects and release BGEA from liability for theft, damage, or destruction of my personal property."
    }), jsxs(Content, {
      children: [jsx("strong", {
        children: "Mission Statement"
      }), " ", jsx("br", {}), " Continuing the lifelong work of Billy Graham, the Billy Graham Evangelistic Association exists to support and extend the evangelistic calling and ministry of Franklin Graham by proclaiming the Gospel of the Lord Jesus Christ to all we can by every effective means available to us and by equipping the church and others to do the same."]
    }), jsxs(Content, {
      children: [jsx("strong", {
        children: "Statement of Faith"
      }), " ", jsx("br", {}), jsx("p", {
        children: "These core beliefs make up the foundation upon which all our ministry endeavors are based. The Billy Graham Evangelistic Association believes:"
      }), jsxs("ul", {
        children: [jsx("li", {
          children: "We believe the Bible to be the inspired, the only infallible, authoritative Word of God revealing the love of God to the world. 1 Thessalonians 2:13; 2 Timothy 3:15-17; John 3:16."
        }), jsx("li", {
          children: "We believe that there is one God, eternally existent in three persons: Father, Son, and Holy Spirit. Matthew 28:19; John 10:30; Ephesians 4:4-6."
        }), jsx("li", {
          children: "We believe in the deity of the Lord Jesus Christ, in His virgin birth, in His sinless life, in His miracles, in His vicarious and atoning death through His shed blood on the cross, in His bodily resurrection, in His ascension to the right hand of the Father, and in His personal return in power and glory. Matthew 1:23; John 1:1-4 and 1:29; Acts 1:11 and 2:22-24; Romans 8:34; 1 Corinthians 15:3-4; 2 Corinthians 5:21; Philippians 2:5-11; Hebrews 1:1-4 and 4:15."
        }), jsx("li", {
          children: "We believe that all men everywhere are lost and face the judgment of God, that Jesus Christ is the only way of salvation, and that for the salvation of lost and sinful man, repentance of sin and faith in Jesus Christ results in regeneration by the Holy Spirit. Furthermore we believe that God will reward the righteous with eternal life in heaven, and that He will banish the unrighteous to everlasting punishment in hell. Luke 24:46-47; John 14:6; Acts 4:12; Romans 3:23; 2 Corinthians 5:10-11; Ephesians 1:7 and 2:8-9; Titus 3:4-7."
        }), jsx("li", {
          children: "We believe in the present ministry of the Holy Spirit, whose indwelling enables the Christian to live a godly life. John 3:5-8; Acts 1:8 and 4:31; Romans 8:9; 1 Corinthians 2:14; Galatians 5:16-18; Ephesians 6:12; Colossians 2:6-10."
        }), jsx("li", {
          children: "We believe in the resurrection of both the saved and the lost; the saved unto the resurrection of eternal life and the lost unto the resurrection of damnation and eternal punishment. 1 Corinthians 15:51-57; Revelation 20:11-15."
        }), jsx("li", {
          children: "We believe in the spiritual unity of believers in the Lord Jesus Christ and that all true believers are members of His body, the church. 1 Corinthians 12:12, 27; Ephesians 1:22-23."
        }), jsx("li", {
          children: "We believe that the ministry of evangelism (sharing and proclaiming the message of salvation only possible by grace through faith in Jesus Christ) and discipleship (helping followers of Christ grow up into maturity in Christ) is a responsibility of all followers of Jesus Christ. Matthew 28:18-20; Acts 1:8; Romans 10:9-15; 1 Peter 3:15."
        }), jsx("li", {
          children: "We believe God's plan for human sexuality is to be expressed only within the context of marriage, that God created man and woman as unique biological persons made to complete each other. God instituted monogamous marriage between male and female as the foundation of the family and the basic structure of human society. For this reason, we believe that marriage is exclusively the union of one genetic male and one genetic female. Genesis 2:24; Matthew 19:5-6; Mark 10:6-9; Romans 1:26-27; 1 Corinthians 6:9."
        }), jsx("li", {
          children: "We believe that we must dedicate ourselves to prayer, to the service of our Lord, to His authority over our lives, and to the ministry of evangelism. Matthew 9:35-38, 22:37-39, and 28:18-20; Acts 1:8; Romans 10:9-15 and 12:20-21; Galatians 6:10; Colossians 2:6-10; 1 Peter 3:15."
        }), jsx("li", {
          children: "We believe that human life is sacred from conception to its natural end; and that we must have concern for the physical and spiritual needs of our fellowmen. Psalm 139:13; Isaiah 49:1; Jeremiah 1:5; Matthew 22:37-39; Romans 12:20-21; Galatians 6:10."
        })]
      })]
    })]
  });
};

var ChaplainAppInfo = function ChaplainAppInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  return jsxs(Container$1, {
    children: [jsx(FormSection$1, {
      formSectionHeader: "About You",
      isEmbedSite: true,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          addressVisibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode'],
          emailRequired: true,
          country: ['US'],
          visibleList: ['Name', 'Address', 'Phone', 'Email'],
          minPhoneLength: 10,
          required: true
        })), jsx(Dropdown, {
          label: "Marital Status",
          name: "collector.entity[0].gender",
          options: [{
            value: "Select One",
            id: ''
          }, {
            value: "Married",
            id: 'married'
          }, {
            value: "Single",
            id: 'single'
          }, {
            value: "Divorced",
            id: 'divorced'
          }, {
            value: "Separated",
            id: 'separated'
          }, {
            value: "Widow/Widower",
            id: 'widow'
          }],
          required: true
        }), jsx(InputText, {
          name: "formLogic.under18.emergencyContactName",
          label: "Emergency Contact Name"
        }), jsx(InputPhone, {
          name: "formLogic.under18.emergencyContactPhone",
          label: "Emergency Phone",
          required: true,
          minPhoneLength: 10
        })]
      })
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      formSectionHeader: "Your Church Information",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Name$1, {
          firstNameFieldName: "formLogic.pastor_first_name",
          lastNameFieldName: "formLogic.pastor_last_name",
          nameLabel: "Pastor's Name",
          required: true
        }), jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
          address1Label: "Address",
          addressVisibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode'],
          churchAddressLabel: "About Your Church",
          display: ['OrganizationName', 'Address'],
          country: ['US'],
          entity: 1,
          hideChurchDenomination: false,
          phoneFieldName: "collector.entity[1].phone[0].phoneNumber",
          phoneType: "WORK",
          orgType: "church",
          relationshipPath: "collector.entity[0]",
          relationshipType: "Church",
          requiredList: ['OrganizationName', 'Phone', 'Address'],
          showAddressLabel: false
        }))]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      formSectionHeader: "Ministry Information",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(TextArea, {
          label: "Why do you desire to serve as a volunteer chaplain?",
          name: "collector.questions[0].answerText",
          required: true
        }), jsx(MinistryInfo, {})]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      formSectionHeader: "Training Information",
      formSectionFields: jsx(TrainingInfo, {}),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      formSectionHeader: "Experience Information",
      formSectionFields: jsx(ExperienceInfo, {}),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      formSectionHeader: "References",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Content, {
          children: "Please list three references we may contact who know your spiritual journey and ministry service (friends, colleagues, etc.). Do not include family members or the senior or staff pastor listed previously. You must have known the person for at least six months. For pastors who are applying, please include a spiritual mentor."
        }), jsx(Block, {
          py: 1,
          children: jsx(ReferenceInfo, {})
        }), jsx(Block, {
          py: 1,
          children: jsx(ReferenceInfo, {
            entity: 1
          })
        }), jsx(Block, {
          py: 1,
          children: jsx(ReferenceInfo, {
            entity: 2
          })
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      formSectionHeader: "Your spiritual experience",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(TextArea, {
          label: "How did you come to faith in Jesus Christ? Please include where and when your decision occurred.\n(Use additional paper if needed.)",
          name: "collector.questions[0].answerText",
          required: true
        }), jsx(TextArea, {
          label: "How have you grown spiritually since your decision to follow Jesus Christ?",
          name: "collector.questions[0].answerText",
          required: true
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      formSectionHeader: "Statement of Faith",
      formSectionFields: jsx(StatementFaithInfo, {}),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      formSectionHeader: "Expectations for Volunteer Chaplains",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Content, {
          children: "As a volunteer chaplain with the Billy Graham Evangelistic Association:"
        }), jsx("p", {
          children: jsxs("ul", {
            children: [jsx("li", {
              children: "I acknowledge that the Lord Jesus Christ is my personal Savior and that I am a personal representative of Him."
            }), jsx("li", {
              children: "I understand that BGEA is a Christian organization whose purpose is proclaiming the message of the Gospel of the Lord Jesus Christ throughout the world"
            }), jsx("li", {
              children: "I agree that the purpose of my volunteer status with BGEA is to further its Christian purpose and that I am prepared to assist in accomplishing that purpose."
            }), jsx("li", {
              children: "I understand that I must exhibit conduct that is consistent with BGEA\u2019s expectations, whether at work or away from work, in keeping with Scriptural teachings and principles as set forth in God\u2019s Word, BGEA\u2019s Statement of Faith, and BGEA\u2019s policies including Christian Conduct."
            }), jsx("li", {
              children: "I understand that BGEA has the right and the responsibility to ensure that its Christian religious purpose is carried on with the highest standards and is not harmed or impeded by conduct that is inconsistent with the Bible, BGEA\u2019s Statement of Faith, its Christian religious purpose, or its policies."
            }), jsx("li", {
              children: "I understand that any of my conduct which is not in keeping with the Scriptural teachings and principles as set forth in God\u2019s Word, BGEA\u2019s Statement of Faith, and BGEA\u2019s corporate policies is inconsistent with BGEA\u2019s Christian religious purpose."
            }), jsx("li", {
              children: "I understand that if my conduct is determined by BGEA to be inconsistent with its Christian religious purpose, the result will be corrective action up to and including termination from volunteer status."
            })]
          })
        }), jsx(Content, {
          children: "I understand on signing this application that I agree with the Assumption of Risk/Release, Mission Statement, Statement of Faith, and Expectations for Volunteer Chaplains above, that I obligate myself to share only the basic Gospel of Jesus Christ, and that I will attempt to meet the expressed spiritual need in light of the Scriptures. I further understand that I am not to advocate any doctrines other than Jesus Christ as Lord and Savior and that I am not to be a promoter for my church or denomination. Also, I agree that information I learn during the course of my volunteer activities (including, but not limited to, the personal information, photographs, and stories of those to whom I minister) is to be considered confidential information, and I agree to view, handle, and hold all confidential information in trust and confidence, to protect and safeguard such confidential information against unauthorized use, publication, or disclosure, and agree to not directly, or indirectly, in any way, reveal, report, publish, disclose, transfer, or otherwise use any of the confidential information except as specifically requested or authorized by BGEA."
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      formSectionHeader: "DISCLOSURE AND CONSENT CONCERNING CONSUMER REPORTS FOR VOLUNTEER CHAPLAIN APPLICANTS ",
      formSectionFields: jsxs(Fragment, {
        children: [jsx("p", {
          children: "Please read the accompanying information carefully. This Disclosure and Consent Form has been provided to you by Billy Graham Evangelistic Association (BGEA) to request a consumer report or investigative consumer report in connection with your application to become a volunteer chaplain or in connection with you continuing to serve as a volunteer chaplain, whichever is applicable. An investigative consumer report may include information regarding your character, general reputation, personal characteristics, and mode of living, whichever is applicable."
        }), jsxs(Content, {
          children: [jsx("strong", {
            children: "DISCLOSURE STATEMENT"
          }), jsx("p", {
            children: "You, the Volunteer Chaplain Applicant, acknowledge that BGEA may now, or at any time while you provide volunteer services to BGEA, verify information within your application, r\xE9sum\xE9, or other related documents. Such verification may include, without limitation, the following: driving records, workers\u2019 compensation records, credit bureau files, employment references, personal references, educational and licensing institution records, and any criminal record information pertaining to you which may be in the files of any federal, state, local, or foreign criminal justice agency."
          }), jsx("p", {
            children: "The results of this verification process may be used to determine your eligibility for initial or continued volunteer roles with BGEA. All results will be kept confidential. The information will not be provided to parties other than designated BGEA personnel, unless otherwise mandated by law. In accordance with the Fair Credit Reporting Act, you are entitled, upon written request made within a reasonable amount of time, to receive a copy of a consumer report or investigative consumer report prepared by a consumer reporting agency and a disclosure of the nature and scope of the investigative consumer report, if applicable."
          }), jsx("p", {
            children: "Your signature below indicates that (1) you have carefully read this form and that you understand that a consumer report or investigative consumer report regarding you may be requested by BGEA and reviewed for volunteer-related purposes, including future decisions concerning your role as a volunteer chaplain, as applicable, (2) that you understand that such consent will remain in effect indefinitely until you revoke it in writing, and (3) that you understand that you have the right to revoke such consent at any time."
          })]
        }), jsxs(Content, {
          children: [jsx("strong", {
            children: "VOLUNTEER CHAPLAIN APPLICANT\u2019S CONSENT TO RELEASE INFORMATION"
          }), jsx("p", {
            children: "I, the Volunteer Chaplain Applicant, understand that in consideration of my application to become a volunteer chaplain, or my continued service as a volunteer chaplain, with BGEA, an investigation may be conducted of my past employment and other activities. I authorize past employers, personal references, and any other persons with whom I am acquainted to answer all questions asked concerning my previous employment record, ability, character, educational background, military service, and credit history. I release all persons, including, without limitation, past employers, credit bureaus, and government agencies, from any liabilities or damages related to furnishing such information."
          }), jsx("p", {
            children: "In consideration of my application to become a volunteer chaplain, or my continued service as a volunteer chaplain, with BGEA, I hereby authorize BGEA and/or their agents to conduct such an investigation, and release said companies, including, without limitation, their officers, directors, employees, agents, and representatives, from all liability or responsibility for this investigation, which may include, without A ministry of Billy Graham Evangelistic Association \xA92024 BGEA 21632 limitation, the gathering of information regarding personal, professional, and educational references, credit or consumer investigations and histories, driving histories, professional license, civil and criminal history information that may be in the files of any local, state, federal, or foreign criminal justice agency."
          }), jsx("p", {
            children: "A photocopy or fax of this Disclosure and Consent Form shall be valid as the original."
          }), jsxs("p", {
            children: ["I, the Volunteer Chaplain Applicant, do hereby certify that all of the information provided by me for the purpose of applying to become a volunteer chaplain or continue service as a volunteer chaplain is true and complete to the best of my knowledge. I understand that any false statements may end consideration of my volunteer activities with BGEA, or may be cause for ending my volunteer role with BGEA.", ' ']
          })]
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Checkbox, {
          name: "formLogic.acknowledgement.missionStatement",
          label: "I agree to the mission statement.",
          validate: validateAcknowledgement
        }), jsx(Checkbox, {
          name: "formLogic.acknowledgement.release",
          label: "I agree to the expectations for Volunteer Chaplains.",
          validate: validateAcknowledgement
        }), jsx(SubmitButton, _objectSpread2({}, props))]
      }),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var ChaplainAppInfo$1 = ChaplainAppInfo;

var ChaplainApplication = function ChaplainApplication(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.CHURCH_APPLICATION;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(ChaplainAppInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$A = ["name"];
// Total Field Component
var TotalField = function TotalField(_ref) {
  var name = _ref.name,
    props = _objectWithoutProperties(_ref, _excluded$A);
  var _useTotalField = useTotalField(_objectSpread2({
      name: name
    }, props)),
    dateSuffix = _useTotalField.dateSuffix,
    monthlyText = _useTotalField.monthlyText,
    onTheText = _useTotalField.onTheText,
    updatedRecurringText = _useTotalField.updatedRecurringText,
    RecurringTotal = _useTotalField.RecurringTotal,
    showRecurringCopy = _useTotalField.showRecurringCopy,
    subTotalText = _useTotalField.subTotalText,
    totalText = _useTotalField.totalText;
  return jsxs(Block, {
    my: 5,
    children: [jsxs(Block, {
      textSize: 5,
      marginless: true,
      children: ["".concat(totalText, ": "), jsxs("strong", {
        children: ["$", subTotalText]
      })]
    }), jsx(Block, {
      textSize: 5,
      children: showRecurringCopy && jsxs("p", {
        children: ["".concat(monthlyText, ": "), ' ', jsxs("strong", {
          children: ["$", parseFloat("".concat(RecurringTotal)).toFixed(2)]
        }), ' ', onTheText, jsx("strong", {
          children: " ".concat(dateSuffix)
        }), ' ', "of every month, starting on ".concat(updatedRecurringText)]
      })
    })]
  });
};
var TotalField$1 = TotalField;

var ProjectItem = function ProjectItem(_ref) {
  var _cartInfo$item$projec, _cartInfo$item$projec2;
  var arrayHelpers = _ref.arrayHelpers,
    cartInfo = _ref.cartInfo,
    currencyError = _ref.currencyError,
    donationFrequencyOptions = _ref.donationFrequencyOptions,
    index = _ref.index,
    item = _ref.item,
    handleFrequencyOnChange = _ref.handleFrequencyOnChange,
    handleOnDeleteClick = _ref.handleOnDeleteClick,
    handleOnChange = _ref.handleOnChange;
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var hasError = currencyError[item === null || item === void 0 ? void 0 : item.projectId] || false;
  return jsxs(Fragment, {
    children: [jsxs(Columns, {
      children: [jsx(Columns.Column, {
        children: jsxs(Form.Field, {
          children: [jsxs(Form.Label, {
            children: [t('Gift Amount', {
              ns: 'labels'
            }), ((_cartInfo$item$projec = cartInfo[item === null || item === void 0 ? void 0 : item.projectId]) === null || _cartInfo$item$projec === void 0 ? void 0 : _cartInfo$item$projec.type) !== PAYMENT_TYPE.RECURRING ? jsxs(Fragment, {
              children: [' ', jsx(Tag, {
                children: "One-Time"
              })]
            }) : jsxs(Fragment, {
              children: [' ', jsx(Tag, {
                color: "warning",
                children: "Monthly"
              })]
            })]
          }), jsxs("div", {
            children: [jsx(Currency, {
              name: "collector.cart.donation.projects[".concat(index, "].amount"),
              inputSize: "normal",
              disableOnBlur: true,
              onChange: function onChange(event) {
                return handleOnChange(event, item === null || item === void 0 ? void 0 : item.projectId);
              }
            }), hasError && jsx("p", {
              className: "help is-danger",
              children: t('Please enter an amount of at least $5 to continue', {
                ns: 'validation'
              })
            })]
          })]
        })
      }), jsx(Columns.Column, {
        children: jsxs(Form.Field, {
          children: [jsx(Form.Label, {
            children: t('Selected Ministry', {
              ns: 'labels'
            })
          }), jsx(Content, {
            children: (_cartInfo$item$projec2 = cartInfo[item === null || item === void 0 ? void 0 : item.projectId]) === null || _cartInfo$item$projec2 === void 0 ? void 0 : _cartInfo$item$projec2.title
          })]
        })
      }), (item === null || item === void 0 ? void 0 : item.projectId) && jsx(Columns.Column, {
        children: jsx(Dropdown, {
          name: "formLogic.cartInfo[".concat(item === null || item === void 0 ? void 0 : item.projectId, "].type"),
          label: "Frequency",
          required: false,
          options: donationFrequencyOptions,
          onChange: function onChange(event) {
            return handleFrequencyOnChange(event, item === null || item === void 0 ? void 0 : item.projectId);
          }
        })
      }), jsx(Columns.Column, {
        children: jsx(Form.Field, {
          children: jsxs(Form.Control, {
            children: [jsx(Form.Label, {
              children: "\xA0"
            }), jsx(Button, {
              onClick: function onClick(event) {
                handleOnDeleteClick(event, item === null || item === void 0 ? void 0 : item.projectId);
                arrayHelpers.remove(index);
              },
              children: "Delete"
            })]
          })
        })
      })]
    }), jsx("hr", {
      className: "has-background-grey"
    })]
  });
};
var ProjectItem$1 = ProjectItem;

function _EMOTION_STRINGIFIED_CSS_ERROR__$8() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ModalContainer$1 = /*#__PURE__*/_styled(Modal, process.env.NODE_ENV === "production" ? {
  target: "e2qmfgq0"
} : {
  target: "e2qmfgq0",
  label: "ModalContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "16w6w5b",
  styles: "z-index:999"
} : {
  name: "16w6w5b",
  styles: "z-index:999",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$8
});
var CartModal = function CartModal(_ref) {
  var arrayHelpers = _ref.arrayHelpers,
    projectOptions = _ref.projectOptions,
    projects = _ref.projects,
    handleOnAddClick = _ref.handleOnAddClick;
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useCartModal = useCartModal({
      projectOptions: projectOptions,
      projects: projects
    }),
    defaultValue = _useCartModal.defaultValue,
    modalIsOpen = _useCartModal.modalIsOpen,
    projectDescription = _useCartModal.projectDescription,
    selectProjectOptions = _useCartModal.selectProjectOptions,
    showThankYouTxt = _useCartModal.showThankYouTxt,
    handleOnCloseModal = _useCartModal.handleOnCloseModal,
    handleOnAddModalClick = _useCartModal.handleOnAddModalClick,
    handleOnModalClick = _useCartModal.handleOnModalClick;
  var text = !showThankYouTxt ? t('Add donation', {
    ns: 'labels'
  }) : t('Thank you', {
    ns: 'labels'
  });
  return jsxs(Block, {
    my: 5,
    children: [jsx(Button, {
      className: "button",
      onClick: handleOnModalClick,
      children: t('Add donation', {
        ns: 'labels'
      })
    }), jsx(ModalContainer$1, {
      show: modalIsOpen,
      onClose: function onClose() {
        return handleOnCloseModal();
      },
      children: jsxs(Modal.Card, {
        children: [jsx(Modal.Card.Header, {
          children: jsx(Modal.Card.Title, {
            children: t('Where would you like to give?', {
              ns: 'labels'
            })
          })
        }), jsx(Modal.Card.Body, {
          children: jsx(Content, {
            children: !showThankYouTxt ? jsx(Container$1, {
              mb: 4,
              children: jsxs(Notification, {
                color: "secondary",
                children: [jsx(Dropdown, {
                  name: "formLogic.newProjectDonation.projectId",
                  label: t('Select Ministry', {
                    ns: 'labels'
                  }),
                  options: selectProjectOptions
                }), (projectDescription === null || projectDescription === void 0 ? void 0 : projectDescription.length) > 0 && jsx("div", {
                  className: "container mb-4",
                  dangerouslySetInnerHTML: {
                    __html: projectDescription
                  }
                }), jsx(Button, {
                  className: "button",
                  disabled: showThankYouTxt,
                  onClick: function onClick(event) {
                    handleOnAddClick(event);
                    handleOnAddModalClick(event);
                    arrayHelpers.push(defaultValue);
                  },
                  children: text
                })]
              })
            }) : jsxs(Columns, {
              centered: true,
              children: [jsx(Columns.Column, {
                mr: 1,
                textAlign: "right",
                children: text
              }), jsx(Columns.Column, {
                mt: 1,
                children: jsx(Icon, {
                  size: "small",
                  align: "left",
                  children: jsx(CheckIcon, {
                    viewBox: "0 0 448 512"
                  })
                })
              })]
            })
          })
        })]
      })
    })]
  });
};
var CartModal$1 = CartModal;

var _excluded$z = ["emptyCartMessage", "esubCodes", "giftOffer", "projects", "showFreeGiftOffer", "showUpgradeGift", "siteId", "usePaypalCaptureOnly"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$7() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var EmptyMessage = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1e4p0gw0"
} : {
  target: "e1e4p0gw0",
  label: "EmptyMessage"
})(process.env.NODE_ENV === "production" ? {
  name: "1azakc",
  styles: "text-align:center"
} : {
  name: "1azakc",
  styles: "text-align:center",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$7
});
var CheckoutInfo = function CheckoutInfo(_ref) {
  var _Object$keys, _Object$keys2;
  var emptyCartMessage = _ref.emptyCartMessage,
    giftOffer = _ref.giftOffer,
    projects = _ref.projects,
    showFreeGiftOffer = _ref.showFreeGiftOffer,
    showUpgradeGift = _ref.showUpgradeGift,
    siteId = _ref.siteId,
    _ref$usePaypalCapture = _ref.usePaypalCaptureOnly,
    usePaypalCaptureOnly = _ref$usePaypalCapture === void 0 ? true : _ref$usePaypalCapture,
    props = _objectWithoutProperties(_ref, _excluded$z);
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var cartStorageKey = "".concat(siteId, "-").concat(CART_INFO);
  var subTitleText = 'The work of the Gospel goes on 24/7. If you’re able, would you prayerfully consider making a monthly gift?';
  var _useCheckout = useCheckout(_objectSpread2({
      giftOffer: giftOffer,
      projects: projects,
      showFreeGiftOffer: showFreeGiftOffer,
      showUpgradeGift: showUpgradeGift,
      siteId: cartStorageKey,
      usePaypalCaptureOnly: usePaypalCaptureOnly
    }, props)),
    availableChargeDates = _useCheckout.availableChargeDates,
    cartInfo = _useCheckout.cartInfo,
    currencyError = _useCheckout.currencyError,
    donationFrequencyOptions = _useCheckout.donationFrequencyOptions,
    enableContinueButton = _useCheckout.enableContinueButton,
    hasRecurringPayment = _useCheckout.hasRecurringPayment,
    isStorageDisabled = _useCheckout.isStorageDisabled,
    projectOptions = _useCheckout.projectOptions,
    showInvalidProjectError = _useCheckout.showInvalidProjectError,
    showPayment = _useCheckout.showPayment,
    handleFrequencyOnChange = _useCheckout.handleFrequencyOnChange,
    handleOnAddClick = _useCheckout.handleOnAddClick,
    handleOnContinueClick = _useCheckout.handleOnContinueClick,
    handleOnDeleteClick = _useCheckout.handleOnDeleteClick,
    handleOnChange = _useCheckout.handleOnChange,
    invalidProjectError = _useCheckout.invalidProjectError;
  return jsxs(Fragment, {
    children: [showInvalidProjectError && jsx(FormErrorScreens, {
      customErrorComponent: invalidProjectError
    }), !cartInfo || !isStorageDisabled && ((_Object$keys = Object.keys(cartInfo)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0 && jsx(Box, {
      children: jsx(EmptyMessage, {
        children: emptyCartMessage
      })
    }), !isStorageDisabled && jsxs(Box, {
      children: [cartInfo && ((_Object$keys2 = Object.keys(cartInfo)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0 ? jsxs(Fragment, {
        children: [jsx(Heading, {
          size: 2,
          pt: 4,
          children: t('Gift Summary', {
            ns: 'labels'
          })
        }), jsx(Heading, {
          subtitle: true,
          size: 5,
          pt: 4,
          children: t(subTitleText, {
            ns: 'labels'
          })
        })]
      }) : jsx(Heading, {
        subtitle: true,
        children: "Would you like to give?"
      }), jsx(FieldArray, {
        name: "collector.cart.donation.projects",
        render: function render(arrayHelpers) {
          var _arrayHelpers$form$va, _arrayHelpers$form$va2, _arrayHelpers$form$va3, _arrayHelpers$form$va4, _Object$keys3;
          return jsxs("div", {
            className: "checkout-project-item-container",
            children: [(_arrayHelpers$form$va = arrayHelpers.form.values.collector) === null || _arrayHelpers$form$va === void 0 ? void 0 : (_arrayHelpers$form$va2 = _arrayHelpers$form$va.cart) === null || _arrayHelpers$form$va2 === void 0 ? void 0 : (_arrayHelpers$form$va3 = _arrayHelpers$form$va2.donation) === null || _arrayHelpers$form$va3 === void 0 ? void 0 : (_arrayHelpers$form$va4 = _arrayHelpers$form$va3.projects) === null || _arrayHelpers$form$va4 === void 0 ? void 0 : _arrayHelpers$form$va4.map(function (item, index) {
              return jsx("div", {
                children: jsx(ProjectItem$1, {
                  arrayHelpers: arrayHelpers,
                  cartInfo: cartInfo,
                  currencyError: currencyError,
                  donationFrequencyOptions: donationFrequencyOptions,
                  index: index,
                  item: item,
                  handleFrequencyOnChange: handleFrequencyOnChange,
                  handleOnDeleteClick: handleOnDeleteClick,
                  handleOnChange: handleOnChange
                })
              }, item === null || item === void 0 ? void 0 : item.projectId);
            }), hasRecurringPayment && jsx(Block, {
              my: 1,
              children: jsx(Dropdown, {
                name: "formLogic.recurringDateNum",
                label: t('Select the monthly charge date', {
                  ns: 'labels'
                }),
                required: true,
                options: availableChargeDates
              })
            }), (projectOptions === null || projectOptions === void 0 ? void 0 : projectOptions.length) > 0 && jsx(Block, {
              my: 1,
              children: jsx("div", {
                className: "control",
                children: jsx(CartModal$1, {
                  arrayHelpers: arrayHelpers,
                  projectOptions: projectOptions,
                  projects: projects,
                  handleOnAddClick: handleOnAddClick
                })
              })
            }), cartInfo && ((_Object$keys3 = Object.keys(cartInfo)) === null || _Object$keys3 === void 0 ? void 0 : _Object$keys3.length) > 0 && jsxs(Fragment, {
              children: [jsx(TotalField$1, _objectSpread2(_objectSpread2({}, props), {}, {
                name: "collector.cart.cartTotals.subTotal"
              })), jsx(Button, {
                className: "button",
                disabled: !enableContinueButton,
                onClick: handleOnContinueClick,
                children: t('Continue', {
                  ns: 'labels'
                })
              })]
            }), showPayment && enableContinueButton && jsxs(Fragment, {
              children: [jsx("hr", {}), jsx(PaymentMethod, _objectSpread2(_objectSpread2({}, props), {}, {
                displayList: ['Name', 'Email', 'Phone', 'Address']
              }))]
            }), !(props !== null && props !== void 0 && props.hideRecaptchaMessage) && jsx(RecaptchaMessage, _objectSpread2({}, props))]
          });
        }
      })]
    })]
  });
};
var CheckoutInfo$1 = CheckoutInfo;

var Checkout = function Checkout(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.CHECKOUT;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    collectionType: 1,
    emailId: (props === null || props === void 0 ? void 0 : props.emailId) || 'DonationReceiptBGEA',
    SESourceCode: (props === null || props === void 0 ? void 0 : props.SESourceCode) || 'BY000INTR',
    shouldNotSetLanguageCode: true,
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(CheckoutInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var ChurchApplicationInfo = function ChurchApplicationInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useChurchApplication = useChurchApplication(_objectSpread2({}, props)),
    addressChange = _useChurchApplication.addressChange,
    arService = _useChurchApplication.arService,
    aslService = _useChurchApplication.aslService,
    chService = _useChurchApplication.chService,
    enService = _useChurchApplication.enService,
    esService = _useChurchApplication.esService,
    ptService = _useChurchApplication.ptService,
    ruService = _useChurchApplication.ruService,
    PrivacyPolicyCopy = _useChurchApplication.PrivacyPolicyCopy,
    privacyPolicyLabelMarkup = _useChurchApplication.privacyPolicyLabelMarkup,
    privacyPolicyLabelStyle = _useChurchApplication.privacyPolicyLabelStyle,
    privacyPolicyTextLabel = _useChurchApplication.privacyPolicyTextLabel,
    touched = _useChurchApplication.touched,
    yourChurchInformationLabel = _useChurchApplication.yourChurchInformationLabel;
  return jsxs(Container$1, {
    children: [jsx(FormSection$1, {
      formSectionHeader: yourChurchInformationLabel,
      isEmbedSite: true,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(InputText, {
          label: "".concat(t('Church Name', {
            ns: 'labels'
          })),
          name: "collector.entity[1].organizationName",
          required: true
        }), jsx(Dropdown, {
          label: "".concat(t('Senior Pastor Title', {
            ns: 'labels'
          })),
          name: "collector.entity[2].salutation",
          options: props === null || props === void 0 ? void 0 : props.nameTitleOptions,
          required: true
        }), jsx(Name$1, {
          entity: 2,
          label: "Senior Pastor Name",
          required: true
        }), jsx(Dropdown, {
          label: "".concat(t('Denomination', {
            ns: 'labels'
          })),
          name: "collector.entity[1].denomination",
          options: props === null || props === void 0 ? void 0 : props.denominationOptions,
          required: true
        }), jsxs(Form.Field, {
          children: [jsx(Form.Label, {
            children: "".concat(t('Select Service Languages (please do not select for interpreters or translators except ASL)', {
              ns: 'labels'
            }), "*")
          }), jsx(Form.Label, {
            children: jsxs(Columns, {
              children: [jsxs(Columns.Column, {
                children: [jsx(Checkbox, {
                  label: "".concat(t('English', {
                    ns: 'labels'
                  })),
                  name: "formLogic.enService"
                }), jsx(Checkbox, {
                  label: "".concat(t('Spanish', {
                    ns: 'labels'
                  })),
                  name: "formLogic.esService"
                })]
              }), jsxs(Columns.Column, {
                children: [jsx(Checkbox, {
                  label: "".concat(t('Chinese', {
                    ns: 'labels'
                  })),
                  name: "formLogic.chService"
                }), jsx(Checkbox, {
                  label: "".concat(t('Russian', {
                    ns: 'labels'
                  })),
                  name: "formLogic.ruService"
                })]
              }), jsxs(Columns.Column, {
                children: [jsx(Checkbox, {
                  label: "".concat(t('Portuguese', {
                    ns: 'labels'
                  })),
                  name: "formLogic.ptService"
                }), jsx(Checkbox, {
                  label: "".concat(t('Arabic', {
                    ns: 'labels'
                  })),
                  name: "formLogic.arService"
                })]
              }), jsxs(Columns.Column, {
                children: [' ', jsx(Checkbox, {
                  label: "".concat(t('ASL', {
                    ns: 'labels'
                  })),
                  name: "formLogic.aslService"
                })]
              })]
            })
          }), touched.formLogic && !enService && !esService && !arService && !ptService && !ruService && !chService && !aslService && jsx("p", {
            className: "help is-danger",
            role: "alert",
            children: "".concat(t('Required', {
              ns: 'validation'
            }))
          })]
        })]
      })
    }), jsx(FormSection$1, {
      formSectionHeader: "".concat(t('Where Are Your Services Held?', {
        ns: 'labels'
      })),
      isEmbedSite: true,
      paddingTop: "light",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
          addressType: "PHYSICAL",
          addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country']
          // country={['US']}
          ,
          display: ['Address'],
          hideChurchDenomination: true,
          entity: 1,
          orgType: "church",
          relationshipPath: "collector.entity[0]",
          relationshipType: "Church",
          requiredList: ['Address']
        })), jsx(Checkbox, {
          style: {
            marginTop: '18px',
            marginBottom: '18px'
          },
          label: "".concat(t('Is your church mailing address different than above?', {
            ns: 'labels'
          })),
          name: "formLogic.addressChange"
        }), addressChange && jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
          autoComplete: false,
          country: ['US'],
          entity: 1,
          index: 1,
          label: "Current Address",
          required: true,
          type: "MAIL",
          visibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country']
        }))]
      })
    }), jsx(FormSection$1, {
      formSectionHeader: "".concat(t('Church Contact Information', {
        ns: 'labels'
      })),
      isEmbedSite: true,
      paddingTop: "light",
      formSectionFields: jsx(Fragment, {
        children: jsxs(Columns, {
          children: [jsx(Columns.Column, {
            size: "half",
            children: jsx(InputPhone, {
              label: "".concat(t('Main Phone', {
                ns: 'labels'
              })),
              entity: 1,
              required: true
            })
          }), jsx(Columns.Column, {
            size: "half",
            children: jsx(InputEmail, {
              label: "".concat(t('Email Address', {
                ns: 'labels'
              })),
              entity: 1,
              required: true
            })
          }), jsx(Columns.Column, {
            size: "half",
            children: jsx(InputText, {
              label: "".concat(t('Church Website', {
                ns: 'labels'
              })),
              name: "churchFormData.SFJChurchData.website",
              placeholder: "http://"
            })
          }), jsx(Columns.Column, {
            size: "half",
            children: jsx(Dropdown, {
              label: "".concat(t('Your position in the church?', {
                ns: 'labels'
              })),
              name: "collector.entity[1].role",
              options: props === null || props === void 0 ? void 0 : props.orgRoleList,
              required: true
            })
          }), jsx(Columns.Column, {
            size: "half"
          })]
        })
      })
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      paddingTop: "light",
      formSectionHeader: "".concat(t('Name of Person Completing This Form', {
        ns: 'labels'
      })),
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Name$1, {}), jsx(CustomMarkupSection, {
          customMarkup: props.statementOfFaithFooterMarkup
        }), jsx(InputText, {
          style: {
            width: '25%'
          },
          label: "".concat(t('Initials', {
            ns: 'labels'
          })),
          name: "churchFormData.SFJChurchData.digital_signature",
          required: true
        })]
      })
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      paddingTop: "light",
      formSectionHeader: privacyPolicyTextLabel,
      formSectionFields: props.hasPrivacyPolicay && jsx(Box, {
        children: props !== null && props !== void 0 && props.privacyPolicyCopy ? jsx(PrivacyPolicyCopy, {}) : jsx(CustomMarkupSection, {
          styles: privacyPolicyLabelStyle,
          customMarkup: privacyPolicyLabelMarkup
        })
      })
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2({}, props)),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var ChurchApplicationInfo$1 = ChurchApplicationInfo;

var ChurchApplication = function ChurchApplication(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.CHURCH_APPLICATION;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(ChurchApplicationInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$y = ["churchCrusadeCodeEventValue", "cities", "cityOnly", "cityRoleSelectLabel", "codeKey", "dtrValue", "hasGroupInfo", "hideCR", "individualCodeEsubValue", "individualCrusadeCodeEventValue", "roles", "multipleCities", "multipleRoles", "roleOnly", "showRoles", "tYText"];
var CitiesRolesSelector = function CitiesRolesSelector(_ref) {
  var churchCrusadeCodeEventValue = _ref.churchCrusadeCodeEventValue,
    _ref$cities = _ref.cities,
    cities = _ref$cities === void 0 ? {} : _ref$cities,
    _ref$cityOnly = _ref.cityOnly,
    cityOnly = _ref$cityOnly === void 0 ? false : _ref$cityOnly,
    _ref$cityRoleSelectLa = _ref.cityRoleSelectLabel,
    cityRoleSelectLabel = _ref$cityRoleSelectLa === void 0 ? 'Which event do you plan to attend?' : _ref$cityRoleSelectLa,
    codeKey = _ref.codeKey,
    dtrValue = _ref.dtrValue,
    _ref$hasGroupInfo = _ref.hasGroupInfo,
    hasGroupInfo = _ref$hasGroupInfo === void 0 ? false : _ref$hasGroupInfo,
    _ref$hideCR = _ref.hideCR,
    hideCR = _ref$hideCR === void 0 ? false : _ref$hideCR,
    individualCodeEsubValue = _ref.individualCodeEsubValue,
    individualCrusadeCodeEventValue = _ref.individualCrusadeCodeEventValue,
    _ref$roles = _ref.roles,
    roles = _ref$roles === void 0 ? {} : _ref$roles,
    _ref$multipleCities = _ref.multipleCities,
    multipleCities = _ref$multipleCities === void 0 ? false : _ref$multipleCities,
    _ref$multipleRoles = _ref.multipleRoles,
    multipleRoles = _ref$multipleRoles === void 0 ? false : _ref$multipleRoles,
    _ref$roleOnly = _ref.roleOnly,
    roleOnly = _ref$roleOnly === void 0 ? false : _ref$roleOnly,
    _ref$showRoles = _ref.showRoles,
    showRoles = _ref$showRoles === void 0 ? false : _ref$showRoles,
    _ref$tYText = _ref.tYText,
    tYText = _ref$tYText === void 0 ? '' : _ref$tYText,
    props = _objectWithoutProperties(_ref, _excluded$y);
  var _useCitiesRolesSelect = useCitiesRolesSelector(_objectSpread2({
      churchCrusadeCodeEventValue: churchCrusadeCodeEventValue,
      cities: cities,
      cityOnly: cityOnly,
      codeKey: codeKey,
      dtrValue: dtrValue,
      hasGroupInfo: hasGroupInfo,
      individualCodeEsubValue: individualCodeEsubValue,
      individualCrusadeCodeEventValue: individualCrusadeCodeEventValue,
      roles: roles,
      roleOnly: roleOnly
    }, props)),
    city = _useCitiesRolesSelect.city;
  return jsxs("div", {
    children: [multipleCities === false && Object.keys(cities).length > 1 && hideCR === false && jsx(Dropdown, {
      options: [{
        id: '',
        value: ''
      }].concat(_toConsumableArray(transformCityRoles(cities))),
      name: "formLogic.city",
      label: cityRoleSelectLabel,
      validate: function validate(value) {
        return validateObject(value, true);
      }
    }), multipleCities === true && Object.keys(cities).length > 1 && hideCR === false && Object.values(cities).map(function (cityEvent) {
      return jsx(Checkbox, {
        id: cityEvent.SECodeEventId,
        name: cityEvent.SECodeEventId,
        labelHtml: cityEvent.label,
        valueObj: cityEvent
      }, cityEvent.crusadeCodeEventId);
    }), roleOnly === true && multipleRoles === false && hideCR === false || (cityOnly === false && multipleRoles === false && Object.keys(roles).length > 1 && city && hideCR === false || showRoles) && jsx(Dropdown, {
      options: [{
        id: '',
        value: ''
      }].concat(_toConsumableArray(transformCityRoles(roles))),
      name: "formLogic.role",
      label: "Type of Volunteer",
      validate: function validate(value) {
        return validateObject(value, true);
      }
    }), roleOnly === true && multipleRoles === true && hideCR === false || cityOnly === false && multipleRoles === true && Object.keys(roles).length > 1 && city && hideCR === false && Object.values(roles).map(function (role) {
      return jsx(Checkbox, {
        id: role.SECodeEventRoleId,
        name: role.SECodeEventRoleId,
        labelHtml: role.label,
        valueObj: role
      }, role.crusadeCodeEventRoleId);
    }), hideCR === true && tYText !== '' && city && Object.keys(city).length > 0 && jsx(Fragment, {
      children: jsxs("p", {
        children: [tYText, " ", jsx("strong", {
          children: city.label
        }), "."]
      })
    })]
  });
};
var CitiesRolesSelector$1 = CitiesRolesSelector;

var ChurchInterestInfo = function ChurchInterestInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useChurchInterest = useChurchInterest({
      languageOptions: props === null || props === void 0 ? void 0 : props.languageOptions
    }),
    churchLangOptions = _useChurchInterest.churchLangOptions,
    defaultAddressList = _useChurchInterest.defaultAddressList,
    isOver18 = _useChurchInterest.isOver18,
    visibleList = _useChurchInterest.visibleList;
  return jsxs(Container$1, {
    children: [props === null || props === void 0 ? void 0 : props.formCopy, jsx(Checkbox, {
      id: "formLogic.over18",
      name: "formLogic.over18",
      labelHtml: props === null || props === void 0 ? void 0 : props.over18Label
    }), isOver18 && jsxs(Fragment, {
      children: [jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
        addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || defaultAddressList,
        churchAddressLabel: props === null || props === void 0 ? void 0 : props.churchAddressLabel,
        country: props === null || props === void 0 ? void 0 : props.country,
        display: ['OrganizationName', 'OrganizationRole', 'Phone', 'Address'],
        entity: 1,
        languageOptions: churchLangOptions,
        orgRoles: props === null || props === void 0 ? void 0 : props.orgRoles,
        orgType: "church",
        phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
        phoneLabel: props === null || props === void 0 ? void 0 : props.phoneLabel,
        relationshipPath: "collector.entity[0]",
        relationshipType: "Church",
        requiredList: ['OrganizationName', 'OrganizationRole', 'Phone', 'Address'],
        showLangQuestion: true
      })), jsx(CitiesRolesSelector$1, {
        churchCrusadeCodeEventValue: props === null || props === void 0 ? void 0 : props.churchCrusadeCodeEventValue,
        cities: props === null || props === void 0 ? void 0 : props.cities,
        cityRoleSelectLabel: props === null || props === void 0 ? void 0 : props.cityRoleSelectLabel,
        cityOnly: props === null || props === void 0 ? void 0 : props.cityOnly,
        codeKey: props === null || props === void 0 ? void 0 : props.codeKey,
        dtrValue: props === null || props === void 0 ? void 0 : props.dtrValue,
        individualCodeEsubValue: props === null || props === void 0 ? void 0 : props.individualCodeEsubValue,
        individualCrusadeCodeEventValue: props === null || props === void 0 ? void 0 : props.individualCrusadeCodeEventValue,
        multipleCities: props === null || props === void 0 ? void 0 : props.multipleCities,
        multipleRoles: props === null || props === void 0 ? void 0 : props.multipleRoles,
        roleOnly: props === null || props === void 0 ? void 0 : props.roleOnly,
        roles: props === null || props === void 0 ? void 0 : props.roles
      }), jsx("h2", {
        children: t('About You', {
          ns: 'labels'
        })
      }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
        addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || defaultAddressList,
        country: props === null || props === void 0 ? void 0 : props.country,
        visibleList: visibleList,
        minPhoneLength: 10,
        emailRequired: true,
        required: true
      })), jsx(SubmitButton, {})]
    })]
  });
};
var ChurchInterestInfo$1 = ChurchInterestInfo;

var ChurchInterest = function ChurchInterest(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.CHURCH_INTEREST;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: ChurchInterestConfirmation,
    children: jsx(ChurchInterestInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var useCLWCAttendance = function useCLWCAttendance(_ref) {
  var showPrefix = _ref.showPrefix;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  var aboutYourChurchLabel = t('About Your Church', {
    ns: 'common'
  });
  var visibleList = [].concat(_toConsumableArray(showPrefix ? ['prefix'] : []), ['firstName', 'lastName']);
  var defaultAddressList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'];
  useEffect(function () {
    setFormId({
      templateName: Templates.CLWC_ATTENDANCE,
      values: values,
      setFieldValue: setFieldValue
    });
  }, []);
  return {
    aboutYourChurchLabel: aboutYourChurchLabel,
    defaultAddressList: defaultAddressList,
    privacyPolicyTextLabel: translations.privacyPolicyLabel,
    yourChurchInformationLabel: translations.yourChurchInformationLabel,
    visibleList: visibleList
  };
};

var CLWCAttendanceInfo = function CLWCAttendanceInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useCLWCAttendance = useCLWCAttendance({
      showPrefix: props === null || props === void 0 ? void 0 : props.showPrefix
    }),
    aboutYourChurchLabel = _useCLWCAttendance.aboutYourChurchLabel,
    defaultAddressList = _useCLWCAttendance.defaultAddressList,
    privacyPolicyTextLabel = _useCLWCAttendance.privacyPolicyTextLabel,
    yourChurchInformationLabel = _useCLWCAttendance.yourChurchInformationLabel,
    visibleList = _useCLWCAttendance.visibleList;
  var PrivacyPolicyCopy = props === null || props === void 0 ? void 0 : props.privacyPolicyCopy;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: t('Dati Personali', {
        ns: 'labels'
      }),
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Name$1, {
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          visibleList: visibleList,
          required: true
        }), jsx(EntityFields, {
          addressVisibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'],
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          country: props === null || props === void 0 ? void 0 : props.country,
          entity: 0,
          emailRequired: true,
          required: true,
          phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
          visibleList: ['Email', 'Phone', 'Address']
        })]
      }),
      hideTopBorder: true,
      paddingTop: "light"
    }), (props === null || props === void 0 ? void 0 : props.showChurchInfo) && jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: yourChurchInformationLabel,
      formSectionFields: jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
        orgRoles: props === null || props === void 0 ? void 0 : props.orgRoles,
        churchAddressLabel: aboutYourChurchLabel,
        country: props === null || props === void 0 ? void 0 : props.country,
        addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || defaultAddressList,
        requiredList: (props === null || props === void 0 ? void 0 : props.requiredChurchList) || ['OrganizationName', 'OrganizationRole', 'Phone', 'Address']
      })),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: props !== null && props !== void 0 && props.isEmbedSite ? privacyPolicyTextLabel : '',
      formSectionFields: jsx(Fragment, {
        children: jsx(Box, {
          children: props !== null && props !== void 0 && props.privacyPolicyCopy ? jsx("div", {
            children: jsx(PrivacyPolicyCopy, {})
          }) : jsxs("p", {
            children: ["*", jsx("span", {
              dangerouslySetInnerHTML: {
                __html: t('privacyAgreement', {
                  ns: 'common',
                  interpolation: {
                    escapeValue: false
                  }
                })
              }
            })]
          })
        })
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
        text: "INVIA"
      })),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var CLWCAttendanceInfo$1 = CLWCAttendanceInfo;

var CLWCAttendance = function CLWCAttendance(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.CLWC_ATTENDANCE;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(CLWCAttendanceInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$x = ["topics", "hasSubject", "hasCountry", "hasZipcode", "hasPhone", "hasMediaSection", "hideTopicSection", "customMarkupHeader", "customMarkupHeaderStyle", "customMarkupFooter", "customMarkupFooterStyle", "maxCommentLen", "submitButtonText"];
var ContactForm = function ContactForm(_ref) {
  var _ref$topics = _ref.topics,
    topics = _ref$topics === void 0 ? [] : _ref$topics,
    _ref$hasSubject = _ref.hasSubject,
    hasSubject = _ref$hasSubject === void 0 ? false : _ref$hasSubject,
    _ref$hasCountry = _ref.hasCountry,
    hasCountry = _ref$hasCountry === void 0 ? false : _ref$hasCountry,
    _ref$hasZipcode = _ref.hasZipcode,
    hasZipcode = _ref$hasZipcode === void 0 ? false : _ref$hasZipcode,
    _ref$hasPhone = _ref.hasPhone,
    hasPhone = _ref$hasPhone === void 0 ? false : _ref$hasPhone,
    _ref$hasMediaSection = _ref.hasMediaSection,
    hasMediaSection = _ref$hasMediaSection === void 0 ? false : _ref$hasMediaSection,
    _ref$hideTopicSection = _ref.hideTopicSection,
    hideTopicSection = _ref$hideTopicSection === void 0 ? false : _ref$hideTopicSection,
    customMarkupFooter = _ref.customMarkupFooter,
    customMarkupFooterStyle = _ref.customMarkupFooterStyle,
    _ref$maxCommentLen = _ref.maxCommentLen,
    maxCommentLen = _ref$maxCommentLen === void 0 ? maxCommentLength : _ref$maxCommentLen,
    _ref$submitButtonText = _ref.submitButtonText,
    submitButtonText = _ref$submitButtonText === void 0 ? 'Submit' : _ref$submitButtonText,
    props = _objectWithoutProperties(_ref, _excluded$x);
  var _useContactForm = useContactForm(_objectSpread2({
      hasCountry: hasCountry,
      topics: topics
    }, props)),
    hideDetailSection = _useContactForm.hideDetailSection,
    showAddressChange = _useContactForm.showAddressChange,
    topic = _useContactForm.topic;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsxs(ContactBaseForm, _objectSpread2(_objectSpread2({}, props), {}, {
      maxCommentLen: maxCommentLen,
      children: [!hideDetailSection && jsx(ContactDetailSection, {
        hasCountry: hasCountry,
        hasZipcode: hasZipcode,
        hasPhone: hasPhone,
        country: props === null || props === void 0 ? void 0 : props.country,
        countryName: props === null || props === void 0 ? void 0 : props.countryName,
        useUSValidation: props === null || props === void 0 ? void 0 : props.useUSValidation
      }), !hideTopicSection && jsx(TopicSection, {
        hasSubject: hasSubject,
        showAddressChange: showAddressChange,
        topic: topic,
        topics: topics
      }), jsx(MediaSection, {
        hasMediaSection: hasMediaSection
      })]
    })), jsx(CustomMarkupSection, {
      styles: customMarkupFooterStyle,
      customMarkup: customMarkupFooter
    }), jsx(SubmissionSection, _objectSpread2(_objectSpread2({}, props), {}, {
      submitButtonText: submitButtonText
    }))]
  });
};

var _excluded$w = ["maxCommentLen", "children"];
var ContactBaseForm = function ContactBaseForm(_ref) {
  var maxCommentLen = _ref.maxCommentLen,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded$w);
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  return jsx(FormSection$1, {
    isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
    hideTopBorder: !(props !== null && props !== void 0 && props.formHeaderCopy),
    paddingTop: "light",
    isFormHeader: props === null || props === void 0 ? void 0 : props.isFormHeader,
    formSectionHeader: (props === null || props === void 0 ? void 0 : props.formHeaderTitle2) || (props === null || props === void 0 ? void 0 : props.formHeaderTitle),
    formSectionFields: jsxs(Fragment, {
      children: [jsx(Name$1, {
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        visibleList: (props === null || props === void 0 ? void 0 : props.visibleList) || ['firstName', 'lastName'],
        required: true,
        showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel
      }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
        visibleList: ['Email'],
        showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel,
        emailRequired: true,
        required: true
      })), children, jsx(TextArea, {
        label: (props === null || props === void 0 ? void 0 : props.textAreaLabel) || "".concat(t('Your message', {
          ns: 'labels'
        }), "*"),
        name: (props === null || props === void 0 ? void 0 : props.questionTextName) || 'collector.communications[0].longComment',
        maxLen: maxCommentLen,
        required: true
      })]
    })
  });
};

var _excluded$v = ["hasMediaSection"];
var MediaSection = function MediaSection(_ref) {
  var _ref$hasMediaSection = _ref.hasMediaSection,
    hasMediaSection = _ref$hasMediaSection === void 0 ? false : _ref$hasMediaSection,
    props = _objectWithoutProperties(_ref, _excluded$v);
  return jsx(Fragment, {
    children: hasMediaSection && jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsxs(Form.Field, {
        children: [jsx(InputText, {
          label: "Media Outlet You Represent",
          name: "collector.entity[0].organizationName",
          required: true
        }), jsx(Checkbox, {
          label: "Please sign me up for BGEA monthly Media News Updates.",
          name: "formLogic.emailSignUp",
          title: "Email Updates"
        })]
      }),
      paddingTop: "light"
    })
  });
};

var _excluded$u = ["topics", "hasSubject", "showAddressChange", "topic"];
var TopicSection = function TopicSection(_ref) {
  var _ref$topics = _ref.topics,
    topics = _ref$topics === void 0 ? [] : _ref$topics,
    _ref$hasSubject = _ref.hasSubject,
    hasSubject = _ref$hasSubject === void 0 ? false : _ref$hasSubject,
    showAddressChange = _ref.showAddressChange,
    topic = _ref.topic,
    props = _objectWithoutProperties(_ref, _excluded$u);
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  return jsx(FormSection$1, {
    isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
    hideTopBorder: true,
    formSectionClassWrapper: "display-wrapper-submit",
    formSectionFields: jsxs(Form.Field, {
      children: [hasSubject && jsx(InputText, {
        label: "".concat(t('Subject', {
          ns: 'labels'
        }), "*") // Todo: Add this translation to the i18library
        ,
        name: "collector.communications[0].shortComment",
        required: true
      }), (topics === null || topics === void 0 ? void 0 : topics.length) > 0 && jsx(Dropdown, {
        label: "".concat(t('Topic', {
          ns: 'labels'
        })) // Todo: Add this translation to the i18library
        ,
        name: "collector.communications[0].shortComment",
        options: topics,
        required: true
      }), topic && jsxs(Form.Field, {
        children: [topic === 'TV Telephone Ministry' && jsx(InputPhone, {
          required: true
        }), topic === 'Decision Magazine' && jsxs(Fragment, {
          children: [jsx(Checkbox, {
            label: "I want to change my magazine delivery address.",
            name: "formLogic.addressChange",
            title: "Address Change"
          }), showAddressChange && jsxs(Fragment, {
            children: [jsx(Heading, {
              renderAs: "h2",
              pt: 2,
              textSize: 5,
              children: "Current Address"
            }), jsx(Form.Field, {
              children: jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
                autoComplete: false,
                country: [],
                entity: 0,
                index: 0,
                required: true,
                type: "MAIL",
                visibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country']
              }))
            }), jsx(Heading, {
              renderAs: "h2",
              pt: 5,
              textSize: 5,
              children: "Old Address"
            }), jsx(Form.Field, {
              children: jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
                autoComplete: false,
                country: [],
                entity: 0,
                index: 1,
                required: true,
                type: "OLD",
                visibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country']
              }))
            })]
          })]
        }), topic === 'Media Inquiries' && jsx(MediaSection, {
          hasMediaSection: true
        }), topic === 'Gift Planning' && jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
          autoComplete: false,
          country: [],
          entity: 0,
          index: 0,
          label: "Current Address",
          required: true,
          type: "MAIL",
          visibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country']
        })), topic === 'New Believer Materials' && jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
          autoComplete: false,
          country: ['US'],
          entity: 0,
          index: 0,
          label: "Current Address",
          required: true,
          type: "MAIL",
          visibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country']
        }))]
      })]
    }),
    paddingTop: "light"
  });
};

var _excluded$t = ["country", "countryName", "hasCountry", "hasZipcode", "hasPhone", "useUSValidation"];
var ContactDetailSection = function ContactDetailSection(_ref) {
  var country = _ref.country,
    countryName = _ref.countryName,
    _ref$hasCountry = _ref.hasCountry,
    hasCountry = _ref$hasCountry === void 0 ? false : _ref$hasCountry,
    _ref$hasZipcode = _ref.hasZipcode,
    hasZipcode = _ref$hasZipcode === void 0 ? false : _ref$hasZipcode,
    _ref$hasPhone = _ref.hasPhone,
    hasPhone = _ref$hasPhone === void 0 ? false : _ref$hasPhone,
    _ref$useUSValidation = _ref.useUSValidation,
    useUSValidation = _ref$useUSValidation === void 0 ? true : _ref$useUSValidation,
    props = _objectWithoutProperties(_ref, _excluded$t);
  return jsx(FormSection$1, {
    isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
    hideTopBorder: true,
    formSectionClassWrapper: "display-wrapper-submit",
    formSectionFields: jsxs(Form.Field, {
      children: [hasCountry && hasZipcode && useUSValidation && jsx(CountryPostal, {
        showCountry: hasCountry,
        validateZipPostalCode: validateZipPostalCode,
        required: true
      }), hasCountry && hasZipcode && !useUSValidation && jsx(CountryPostal, {
        showCountry: hasCountry,
        required: true
      }), hasCountry && !hasZipcode && jsx(Country, {
        name: countryName,
        country: country || [],
        required: true
      }), hasPhone && jsx(InputPhone, {})]
    }),
    paddingTop: "light"
  });
};

var _excluded$s = ["submitButtonText"];
var SubmissionSection = function SubmissionSection(_ref) {
  var submitButtonText = _ref.submitButtonText,
    props = _objectWithoutProperties(_ref, _excluded$s);
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  return jsx(FormSection$1, {
    isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
    hideTopBorder: true,
    formSectionClassWrapper: "display-wrapper-submit",
    formSectionFields: jsx(Form.Field, {
      children: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
        text: t(submitButtonText, {
          ns: 'labels'
        }),
        color: props !== null && props !== void 0 && props.isNewSubmitButton ? '#1a1a1a' : '',
        isNewSubmitButton: props === null || props === void 0 ? void 0 : props.isNewSubmitButton
      }))
    }),
    paddingTop: "light",
    paddingBottom: "standard"
  });
};

var ContactUs = function ContactUs(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.CONTACT_US;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: ContactFormConfirmation,
    children: jsx(ContactForm, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var CourseInterestInfo = function CourseInterestInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  useLanguage({
    lng: props === null || props === void 0 ? void 0 : props.lng
  });
  var _useCourseInterest = useCourseInterest({
      displayList: ['Name', 'Phone'],
      displayListChurch: ['OrganizationName', 'Address'],
      notesQuestion: 'notes',
      notesLabel: '',
      pastorInfoSameAsContact: 'checkbox value'
    }),
    displayList = _useCourseInterest.displayList,
    displayListChurch = _useCourseInterest.displayListChurch,
    notesQuestion = _useCourseInterest.notesQuestion,
    notesLabel = _useCourseInterest.notesLabel;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: t('cInterest-title', {
        ns: 'common'
      }),
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Content, {
          children: t('cInterest-heading6', {
            ns: 'common'
          })
        }), jsx(Checkbox, {
          name: "formLogic.courseCLWC",
          label: t('cInterest-course', {
            ns: 'common'
          })
        }), jsx(Checkbox, {
          name: "formLogic.courseGHIC",
          label: t('cInterest-course2', {
            ns: 'common'
          })
        })]
      }),
      hideTopBorder: true,
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: t('cInterest-title4', {
        ns: 'common'
      }),
      formSectionFields: jsxs(Fragment, {
        children: [jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          visibleList: displayList,
          required: true
        })), jsx(InputEmail, {
          label: "Email Address",
          required: props === null || props === void 0 ? void 0 : props.nameRequired,
          name: "collector.entity[0].email[0].emailAddress"
        }), jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
          autoComplete: false,
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          country: props === null || props === void 0 ? void 0 : props.country,
          entity: 0,
          index: 0,
          label: "",
          required: true,
          showLabel: true,
          type: "MAIL",
          visibleList: props === null || props === void 0 ? void 0 : props.addressVisible
        }))]
      }),
      hideTopBorder: true,
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: t('cInterest-preferredLang', {
        ns: 'common'
      }),
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Checkbox, {
          name: "formLogic.prefLangSpanish",
          label: t('Español', {
            ns: 'common'
          })
        }), jsx(Checkbox, {
          name: "formLogic.prefLangEnglish",
          label: t('English', {
            ns: 'common'
          })
        })]
      }),
      hideTopBorder: true,
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: t('ChurchInfo', {
        ns: 'labels'
      }),
      formSectionFields: jsx(Fragment, {
        children: jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
          relationshipPath: "collector.entity[1]",
          relationshipType: "Church",
          display: displayListChurch,
          orgType: "church",
          addressVisibleList: props === null || props === void 0 ? void 0 : props.addressVisible,
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          country: props === null || props === void 0 ? void 0 : props.country,
          showAddressLabel: false
          // addressLabel={t('Church', { ns: 'labels' })}
          // required={[
          //   'OrganizationName',
          //   'OrganizationRole',
          //   'Phone',
          //   'Address',
          // ]}
        }))
      }),

      hideTopBorder: true,
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: t('PastorsName', {
        ns: 'labels'
      }),
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Checkbox, {
          name: "formLogic.pastorInfoSameAsContact",
          label: t('contactAbove', {
            ns: 'common'
          })
        }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          entity: 2,
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          visibleList: ['Name', 'Phone', 'Email'],
          emailRequired: true,
          required: true
        }))]
      }),
      hideTopBorder: true,
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: t('cInterest-preferredLangChurch', {
        ns: 'common'
      }),
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Content, {
          children: t('cInterest-bilingual', {
            ns: 'common'
          })
        }), jsxs(Content, {
          children: [jsx(Checkbox, {
            name: "formLogic.prefLangChurchSpanish",
            label: t('Español', {
              ns: 'common'
            })
          }), jsx(Checkbox, {
            name: "formLogic.prefLangChurchEnglish",
            label: t('English', {
              ns: 'common'
            })
          })]
        })]
      }),
      hideTopBorder: true,
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: t('Notes', {
        ns: 'labels'
      }),
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Content, {
          children: t('cInterest-notesDesc', {
            ns: 'common'
          })
        }), jsx(TextArea, {
          label: notesLabel,
          name: notesQuestion,
          required: true
        })]
      }),
      hideTopBorder: true,
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2({}, props)),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var CourseInterestInfo$1 = CourseInterestInfo;

var CourseInterest = function CourseInterest(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.COURSE_INTEREST;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(CourseInterestInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var FreeTShirtInfo = function FreeTShirtInfo(_ref) {
  var _values$formLogic, _values$formLogic2;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useFreeTShirt = useFreeTShirt(_objectSpread2({}, props)),
    checkBoxText = _useFreeTShirt.checkBoxText,
    isDisabled = _useFreeTShirt.isDisabled,
    language = _useFreeTShirt.language,
    privacyPolicyCopy = _useFreeTShirt.privacyPolicyCopy,
    supplyText = _useFreeTShirt.supplyText,
    values = _useFreeTShirt.values;
  return jsxs(Container$1, {
    children: [jsx(Dropdown, {
      name: "formLogic.languageSelector",
      label: "Please select your language",
      required: true,
      options: [{
        id: '',
        value: 'Select'
      }, {
        id: 'en',
        value: 'English'
      }, {
        id: 'es',
        value: 'Spanish'
      }]
    }), language && jsxs(Fragment, {
      children: [jsx(Name$1, {
        visibleList: props === null || props === void 0 ? void 0 : props.visibleList,
        required: true,
        showNameLabel: false
      }), !(values !== null && values !== void 0 && (_values$formLogic = values.formLogic) !== null && _values$formLogic !== void 0 && _values$formLogic.noEmail) && jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
        visibleList: ['Email'],
        showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel,
        emailRequired: true,
        required: true
      })), (props === null || props === void 0 ? void 0 : props.showNoEmailCheckbox) && jsx(Checkbox, {
        id: "formLogic.noEmail",
        name: "formLogic.noEmail",
        label: "".concat(t('No e-mail address', {
          ns: 'labels'
        }), "*")
      }), !(values !== null && values !== void 0 && (_values$formLogic2 = values.formLogic) !== null && _values$formLogic2 !== void 0 && _values$formLogic2.noAddress) && jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
        autoComplete: false,
        country: props === null || props === void 0 ? void 0 : props.country,
        entity: 0,
        index: 0,
        label: "",
        required: true,
        showLabel: false,
        type: "MAIL",
        visibleList: props === null || props === void 0 ? void 0 : props.addressVisible
      })), (props === null || props === void 0 ? void 0 : props.showNoAddressCheckbox) && jsx(Checkbox, {
        id: "formLogic.noAddress",
        name: "formLogic.noAddress",
        label: "".concat(t('No address', {
          ns: 'labels'
        }), "*")
      }), jsx(InputPhone, {
        label: "".concat(t('Main Phone', {
          ns: 'labels'
        })),
        entity: 0,
        phoneType: "HOME",
        required: false
      }), jsx(Dropdown, {
        name: "formLogic.cityListDropdown",
        label: "".concat(t('Tour city attended', {
          ns: 'labels'
        })),
        required: true,
        options: props === null || props === void 0 ? void 0 : props.cityList
      }), (props === null || props === void 0 ? void 0 : props.show18Checkbox) && jsx(Checkbox, {
        isChecked: props === null || props === void 0 ? void 0 : props.isChecked,
        label: checkBoxText,
        name: "collector.entity[0].over18",
        isRequired: true,
        title: ""
      }), (props === null || props === void 0 ? void 0 : props.showSupplyText) && jsx(Content, {
        children: supplyText
      }), (props === null || props === void 0 ? void 0 : props.showPrivacyPolicy) && jsx(Content, {
        children: jsx("div", {
          dangerouslySetInnerHTML: {
            __html: privacyPolicyCopy
          }
        })
      }), jsx(SubmitButton, {
        isDisabled: isDisabled,
        text: t('Sign Up Now', {
          ns: 'labels'
        })
      })]
    })]
  });
};
var FreeTShirtInfo$1 = FreeTShirtInfo;

var DataEntryFreeTShirtInfo = function DataEntryFreeTShirtInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useDataEntryFreeTShi = useDataEntryFreeTShirt({
      isDevotional: props === null || props === void 0 ? void 0 : props.isDevotional
    }),
    cityList = _useDataEntryFreeTShi.cityList,
    englishCustomConfirmation = _useDataEntryFreeTShi.englishCustomConfirmation,
    spanishCustomConfirmation = _useDataEntryFreeTShi.spanishCustomConfirmation;
  useDataEntryForm({
    index: 1
  });
  return jsx(Container$1, {
    children: jsx(FreeTShirtInfo$1, _objectSpread2(_objectSpread2({}, props), {}, {
      cityList: cityList,
      englishCustomConfirmation: englishCustomConfirmation,
      spanishCustomConfirmation: spanishCustomConfirmation
    }))
  });
};
var DataEntryFreeTShirtInfo$1 = DataEntryFreeTShirtInfo;

var DataEntryFreeTShirt = function DataEntryFreeTShirt(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.DATA_ENTRY_FREE_TSHIRT;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    shouldNotSetLanguageCode: true,
    Confirmation: Confirmation,
    children: jsx(DataEntryFreeTShirtInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$r = ["recurringToggle", "optionProp", "options", "give", "donateTitle", "project", "codes", "buttonAmounts", "donationDateButtons", "recurringButtonAmounts", "recurringChoiceDay", "givingBtnStyle", "usePaypalCaptureOnly"];
var OnlineGivingInfo = function OnlineGivingInfo(_ref) {
  var _ref$recurringToggle = _ref.recurringToggle,
    recurringToggle = _ref$recurringToggle === void 0 ? true : _ref$recurringToggle,
    _ref$optionProp = _ref.optionProp,
    optionProp = _ref$optionProp === void 0 ? {
      whereMostNeeded: 'Where Most Needed'
    } : _ref$optionProp,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$give = _ref.give,
    give = _ref$give === void 0 ? true : _ref$give,
    project = _ref.project,
    _ref$codes = _ref.codes,
    codes = _ref$codes === void 0 ? [] : _ref$codes,
    buttonAmounts = _ref.buttonAmounts,
    _ref$donationDateButt = _ref.donationDateButtons,
    donationDateButtons = _ref$donationDateButt === void 0 ? false : _ref$donationDateButt,
    recurringButtonAmounts = _ref.recurringButtonAmounts,
    recurringChoiceDay = _ref.recurringChoiceDay,
    _ref$givingBtnStyle = _ref.givingBtnStyle,
    givingBtnStyle = _ref$givingBtnStyle === void 0 ? {
      bgColor: '#003658',
      textColor: '#ffffff'
    } : _ref$givingBtnStyle,
    _ref$usePaypalCapture = _ref.usePaypalCaptureOnly,
    usePaypalCaptureOnly = _ref$usePaypalCapture === void 0 ? true : _ref$usePaypalCapture,
    props = _objectWithoutProperties(_ref, _excluded$r);
  var _useOnlineGiving = useOnlineGiving(),
    isDisabled = _useOnlineGiving.isDisabled;
  var _useSingleDonation = useSingleDonation(_objectSpread2(_objectSpread2({}, props), {}, {
      options: options,
      codes: codes,
      optionProp: optionProp,
      usePaypalCaptureOnly: usePaypalCaptureOnly
    })),
    displayPaymentMethod = _useSingleDonation.displayPaymentMethod,
    showOnlineGivingSubmitButton = _useSingleDonation.showOnlineGivingSubmitButton,
    giveButton = _useSingleDonation.giveButton;
  return jsx(Fragment, {
    children: jsxs(Container$1, {
      className: "bgform-single-donation-container",
      children: [jsx(FormSection$1, {
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        disableEmbedLayout: true,
        hideTopBorder: true,
        formSectionFields: jsxs(Fragment, {
          children: [project && project.title && jsxs(Columns, {
            children: [jsx(Columns.Column, {
              children: jsx(Heading, {
                style: {
                  // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
                  color: "".concat(givingBtnStyle.bgColor),
                  fontSize: '1.6rem',
                  fontWeight: 400
                },
                children: project.title
              })
            }), jsx(Columns.Column, {
              children: jsx("p", {
                children: project.description
              })
            })]
          }), jsxs(Box, {
            children: [jsx(SingleGift, _objectSpread2(_objectSpread2({}, props), {}, {
              projectId: project.projectId,
              recurringToggle: recurringToggle,
              give: give,
              giveButton: giveButton,
              buttonSize: "medium",
              addToggleClass: "has-text-black",
              buttonAmounts: buttonAmounts,
              donationDateButtons: donationDateButtons,
              recurringButtonAmounts: recurringButtonAmounts,
              recurringChoiceDay: recurringChoiceDay,
              givingBtnStyle: givingBtnStyle
            })), displayPaymentMethod && jsx(PaymentMethod, _objectSpread2(_objectSpread2({}, props), {}, {
              emailRequired: props === null || props === void 0 ? void 0 : props.emailRequired,
              displayList: ['Name', 'Email', 'Phone', 'Address'],
              useSREDKeyPad: props === null || props === void 0 ? void 0 : props.useSREDKeyPad
            }))]
          })]
        }),
        paddingTop: "light"
      }), showOnlineGivingSubmitButton && jsx(FormSection$1, {
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        disableEmbedLayout: true,
        hideTopBorder: true,
        formSectionClassWrapper: "display-wrapper-submit",
        formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
          isDisabled: isDisabled
        })),
        paddingTop: "light",
        paddingBottom: "standard"
      })]
    })
  });
};
var OnlineGivingInfo$1 = OnlineGivingInfo;

var DataEntryOnlineGivingInfo = function DataEntryOnlineGivingInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  useDataEntryForm({
    index: 1
  });
  return jsx(OnlineGivingInfo$1, _objectSpread2({}, props));
};
var DataEntryOnlineGivingInfo$1 = DataEntryOnlineGivingInfo;

var DataEntryOnlineGiving = function DataEntryOnlineGiving(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.DATA_ENTRY_VOLUNTEER;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    shouldNotSetLanguageCode: true,
    templateName: templateName,
    Confirmation: OnlineGivingConfirmation,
    children: jsx(DataEntryOnlineGivingInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var templatesWithProducts = [];
var shouldHaveProduct = function shouldHaveProduct(values) {
  var templateName = values === null || values === void 0 ? void 0 : values.formLogic.templateName;
  return templatesWithProducts.includes(templateName);
};
var getProductCode = function getProductCode(values) {
  var _values$formLogic, _values$formLogic2;
  var productCode = {};
  if (values.formLogic.langQuestion === Language.ENGLISH || values.formLogic.fluentLangQuestion === FluentLanguageValue.NO && (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.language) === DDCLANG.EN) {
    productCode = {
      productId: kitEnProductId,
      amount: 0,
      quantity: 1
    };
  } else if (values.formLogic.langQuestion === Language.SPANISH || values.formLogic.fluentLangQuestion === FluentLanguageValue.NO && (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.language) === DDCLANG.ES) {
    productCode = {
      productId: kitEsProductId,
      amount: 0,
      quantity: 1
    };
  }
  return productCode;
};

var ddclangKey = 'DDCLANG';
var getCityId = function getCityId(city, groupName) {
  var cityId;
  if (groupName) {
    cityId = parseInt(groupName === null || groupName === void 0 ? void 0 : groupName.substring(6), 10);
  } else if (city) {
    var cityEvent = JSON.parse(city);
    cityId = cityEvent.crusadeCodeEventId;
  }
  return cityId;
};
var useLanguageQuestionInfo = function useLanguageQuestionInfo(_ref) {
  var _values$formLogic, _values$formLogic$par, _values$formLogic2, _values$collector$ent, _values$collector$ent2, _values$collector$ent3, _values$collector$ent4, _values$formLogic6;
  var fluentLanguageOptions = _ref.fluentLanguageOptions,
    languageOptions = _ref.languageOptions;
  var fluentLangQuestion = 'formLogic.fluentLangQuestion';
  var langQuestion = 'formLogic.langQuestion';
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  var queryProjectDict = getQueryStringDict((values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : (_values$formLogic$par = _values$formLogic.parentDocumentInfo) === null || _values$formLogic$par === void 0 ? void 0 : _values$formLogic$par.formQueryString) || '');
  var groupName = queryProjectDict === null || queryProjectDict === void 0 ? void 0 : queryProjectDict.GRP;
  var city = values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.city;
  var cityId = getCityId(city, groupName);
  var resetArr = ((_values$collector$ent = values.collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.key) !== ddclangKey;
  })) || [];
  var filteredArr = ((_values$collector$ent3 = values.collector.entity[0]) === null || _values$collector$ent3 === void 0 ? void 0 : (_values$collector$ent4 = _values$collector$ent3.code) === null || _values$collector$ent4 === void 0 ? void 0 : _values$collector$ent4.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.value) !== attrLangEnValue && (item === null || item === void 0 ? void 0 : item.value) !== attrLangEsValue;
  })) || [];
  useEffect(function () {
    var langCityCodes = getLangQuestionCodes(cityId, values);
    if (values.formLogic.fluentLangQuestion === FluentLanguageValue.YES) {
      setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), _toConsumableArray(langCityCodes), [{
        key: ddclangKey,
        value: DDCLANG.ES
      }, {
        key: ddclangKey,
        value: DDCLANG.EN
      }]));
    } else if (values.formLogic.fluentLangQuestion === FluentLanguageValue.NO) {
      var _values$formLogic3, _values$formLogic4, _Object$keys;
      if ((values === null || values === void 0 ? void 0 : (_values$formLogic3 = values.formLogic) === null || _values$formLogic3 === void 0 ? void 0 : _values$formLogic3.language) === DDCLANG.EN) {
        setFieldValue('collector.entity[0].code', [].concat(_toConsumableArray(resetArr), _toConsumableArray(langCityCodes)));
      } else if ((values === null || values === void 0 ? void 0 : (_values$formLogic4 = values.formLogic) === null || _values$formLogic4 === void 0 ? void 0 : _values$formLogic4.language) === DDCLANG.ES) {
        setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), _toConsumableArray(langCityCodes), [{
          key: ddclangKey,
          value: DDCLANG.ES
        }]));
      }
      var productCode = getProductCode(values);
      if (shouldHaveProduct(values) && ((_Object$keys = Object.keys(productCode)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0) {
        setFieldValue('collector.cart.products[1]', productCode);
      }
    }
  }, [values.formLogic.fluentLangQuestion]);
  useEffect(function () {
    var _Object$keys2;
    if (cityId) {
      var langQuestionCodes = getLangQuestionCodes(cityId, values);
      if (langQuestionCodes.length > 0) {
        setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(filteredArr), _toConsumableArray(langQuestionCodes)));
      }
    }
    var productCode = getProductCode(values);
    if (shouldHaveProduct(values) && ((_Object$keys2 = Object.keys(productCode)) === null || _Object$keys2 === void 0 ? void 0 : _Object$keys2.length) > 0) {
      setFieldValue('collector.cart.products[1]', productCode);
    }
  }, [values.formLogic.langQuestion]);
  useEffect(function () {
    var _values$formLogic5;
    setFieldValue('formLogic.fluentLanguageOptions', fluentLanguageOptions);
    setFieldValue('formLogic.languageOptions', languageOptions);
    setFieldValue(fluentLangQuestion, '');
    setFieldValue(langQuestion, '');
    if ((values === null || values === void 0 ? void 0 : (_values$formLogic5 = values.formLogic) === null || _values$formLogic5 === void 0 ? void 0 : _values$formLogic5.language) === DDCLANG.EN) {
      setFieldValue("collector.entity[0].code", _toConsumableArray(resetArr));
    }
  }, []);
  return {
    fluentLangQuestion: fluentLangQuestion,
    langQuestion: langQuestion,
    showLangQuestion: (values === null || values === void 0 ? void 0 : (_values$formLogic6 = values.formLogic) === null || _values$formLogic6 === void 0 ? void 0 : _values$formLogic6.fluentLangQuestion) === 'yes',
    values: values
  };
};

var LanguageQuestionInfo = function LanguageQuestionInfo(_ref) {
  var _ref$fluentLangQuesti = _ref.fluentLangQuestionLabel,
    fluentLangQuestionLabel = _ref$fluentLangQuesti === void 0 ? 'Are you also fluent in Spanish?*' : _ref$fluentLangQuesti,
    fluentLanguageOptions = _ref.fluentLanguageOptions,
    languageOptions = _ref.languageOptions;
  var _useLanguageQuestionI = useLanguageQuestionInfo({
      fluentLanguageOptions: fluentLanguageOptions,
      languageOptions: languageOptions
    }),
    fluentLangQuestion = _useLanguageQuestionI.fluentLangQuestion,
    langQuestion = _useLanguageQuestionI.langQuestion,
    showLangQuestion = _useLanguageQuestionI.showLangQuestion;
  return jsxs(Block, {
    children: [jsx(RadioGroup, {
      label: fluentLangQuestionLabel,
      name: fluentLangQuestion,
      options: fluentLanguageOptions,
      required: true
    }), showLangQuestion && jsx(RadioGroup, {
      label: "In what language would you be most comfortable volunteering?*",
      name: langQuestion,
      options: languageOptions,
      required: true
    })]
  });
};
var LanguageQuestionInfo$1 = LanguageQuestionInfo;

/* eslint-disable react/no-unescaped-entities */

var MissionStatementAndRelease = jsxs(Fragment, {
  children: [jsx("h2", {
    children: "BGEA Mission Statement and Statement of Faith"
  }), jsx("h4", {
    children: "Mission Statement"
  }), jsx("p", {
    children: "Continuing the lifelong work of Billy Graham, the Billy Graham Evangelistic Association exists to support and extend the evangelistic calling and ministry of Franklin Graham by proclaiming the Gospel of the Lord Jesus Christ to all we can by every effective means available to us and by equipping the church and others to do the same."
  }), jsx("h4", {
    children: "Billy Graham Evangelistic Association Statement of Faith"
  }), jsxs("ul", {
    children: [jsx("li", {
      children: "We believe the Bible to be the inspired, the only infallible, authoritative Word of God revealing the love of God to the world. 1 Thessalonians 2:13; 2 Timothy 3:15-17; John 3:16."
    }), jsx("li", {
      children: "We believe that there is one God, eternally existent in three persons: Father, Son, and Holy Spirit. Matthew 28:19; John 10:30; Ephesians 4:4-6."
    }), jsx("li", {
      children: "We believe in the deity of the Lord Jesus Christ, in His virgin birth, in His sinless life, in His miracles, in His vicarious and atoning death through His shed blood on the cross, in His bodily resurrection, in His ascension to the right hand of the Father, and in His personal return in power and glory. Matthew 1:23; John 1:1-4 and 1:29; Acts 1:11 and 2:22-24; Romans 8:34; 1 Corinthians 15:3-4; 2 Corinthians 5:21; Philippians 2:5-11; Hebrews 1:1-4 and 4:15."
    }), jsx("li", {
      children: "We believe that all men everywhere are lost and face the judgment of God, that Jesus Christ is the only way of salvation, and that for the salvation of lost and sinful man, repentance of sin and faith in Jesus Christ results in regeneration by the Holy Spirit. Furthermore we believe that God will reward the righteous with eternal life in heaven, and that He will banish the unrighteous to everlasting punishment in hell. Luke 24:46-47; John 14:6; Acts 4:12; Romans 3:23; 2 Corinthians 5:10-11; Ephesians 1:7 and 2:8-9; Titus 3:4-7."
    }), jsx("li", {
      children: "We believe in the present ministry of the Holy Spirit, whose indwelling enables the Christian to live a godly life. John 3:5-8; Acts 1:8 and 4:31; Romans 8:9; 1 Corinthians 2:14; Galatians 5:16-18; Ephesians 6:12; Colossians 2:6-10."
    }), jsx("li", {
      children: "We believe in the resurrection of both the saved and the lost; the saved unto the resurrection of eternal life and the lost unto the resurrection of damnation and eternal punishment. 1 Corinthians 15:51-57; Revelation 20:11-15."
    }), jsx("li", {
      children: "We believe in the spiritual unity of believers in the Lord Jesus Christ and that all true believers are members of His body, the church. 1 Corinthians 12:12, 27; Ephesians 1:22-23."
    }), jsx("li", {
      children: "We believe that the ministry of evangelism (sharing and proclaiming the message of salvation only possible by grace through faith in Jesus Christ) and discipleship (helping followers of Christ grow up into maturity in Christ) is a responsibility of all followers of Jesus Christ. Matthew 28:18-20; Acts 1:8; Romans 10:9-15; 1 Peter 3:15."
    }), jsx("li", {
      children: "We believe God's plan for human sexuality is to be expressed only within the context of marriage, that God created man and woman as unique biological persons made to complete each other. God instituted monogamous marriage between male and female as the foundation of the family and the basic structure of human society. For this reason, we believe that marriage is exclusively the union of one genetic male and one genetic female. Genesis 2:24; Matthew 19:5-6; Mark 10:6-9; Romans 1:26-27; 1 Corinthians 6:9."
    }), jsx("li", {
      children: "We believe that we must dedicate ourselves to prayer, to the service of our Lord, to His authority over our lives, and to the ministry of evangelism. Matthew 9:35-38, 22:37-39, and 28:18-20; Acts 1:8; Romans 10:9-15 and 12:20-21; Galatians 6:10; Colossians 2:6-10; 1 Peter 3:15."
    }), jsx("li", {
      children: "We believe that human life is sacred from conception to its natural end; and that we must have concern for the physical and spiritual needs of our fellowmen. Psalm 139:13; Isaiah 49:1; Jeremiah 1:5; Matthew 22:37-39; Romans 12:20-21; Galatians 6:10."
    })]
  }), jsx("hr", {}), jsx("h2", {
    children: "Volunteer Release and Waiver of Liability"
  }), jsx("p", {
    children: "I, the undersigned adult (\u201CVolunteer\u201D), in consideration of the volunteer service opportunity to be provided by Billy Graham Evangelistic Association, do freely, voluntarily, and after reading carefully, execute this Volunteer Release and Waiver of Liability. By doing so, I accept, acknowledge, and agree as follows:"
  }), jsxs("p", {
    children: [jsx("strong", {
      children: "Volunteer Status/Insurance "
    }), "I understand and acknowledge that any service performed is as a volunteer, not an employee, of BGEA. Volunteer is not entitled to employee or other benefits from BGEA such as health or accident insurance, workers compensation, or compensation for duties performed or hours worked. I understand it is my responsibility to provide health, disability, liability or accident insurance to cover Volunteer for any claims or damages that may result from any injury, illness, death or property damage Volunteer suffers while volunteering with BGEA."]
  }), jsxs("p", {
    children: [jsx("strong", {
      children: "Assumption of Risk/Release"
    }), " I acknowledge that I have been provided with sufficient opportunity to understand the circumstances and environment in which volunteer services will be provided hereunder or to request additional information in advance of providing such services, and I understand that those circumstances and environment may be out of BGEA's control and may present various risks including without limitation, the risk of illness, including Covid-19, physical injury, property damage, or even death, resulting from such services. I hereby assume all risks associated with Volunteer's performance of these activities and release and forever discharge BGEA from any and all liability, including for negligent acts or omissions, for claims or damages Volunteer might have that result from Volunteer's activities with BGEA as a volunteer, and any related claims or damages arising from BGEA's selection of activities or provision of food or transportation in connection with volunteering with BGEA. I understand that BGEA is not responsible for the safety or security of Volunteer's personal effects and release BGEA from liability for theft, damage or destruction of Volunteer's personal property."]
  }), jsxs("p", {
    children: [jsx("strong", {
      children: "Ministry Photographs and Videos"
    }), " I acknowledge and agree that, while volunteering with BGEA, Volunteer's activities may be photographed or videotaped. I hereby consent to the unlimited use by BGEA and/or its authorized representative of photographs or videos in which Volunteer appears, without further compensation, and I acknowledge and agree that I have no ownership rights in or to those photographs or videos. I hereby release BGEA, its agents and assigns from any claims that Volunteer may have relating to any photographs or videos, including without limitation, any claim arising under the right of publicity, right of privacy, defamation and/or copyright infringement. I understand that any works I create while serving as a volunteer belong to BGEA, including title, ownership and copyright of those works."]
  }), jsxs("p", {
    children: [jsx("strong", {
      children: "Emergency Medical Care"
    }), " I hereby consent to the provision or procurement by BGEA of emergency medical care or first aid in the event Volunteer suffers any illness or accident while performing volunteer activities. I hereby release, discharge and hold BGEA harmless from any claim, including for negligent acts or omissions, related to the provision of such emergency medical care."]
  }), jsxs("p", {
    children: [jsx("strong", {
      children: "Consent"
    }), " I consent to BGEA keeping the Volunteer's personal details and contact information, both in the U.S.A. and in my country (if other than the U.S.A.) and to communicate with Volunteer about Volunteer's participation and future ministry updates and opportunities from time to time. I know I can access BGEA's Privacy Policy at BillyGraham.org/Privacy. I also know that, if I later have a concern about how Volunteer's image or recordings may be/is/are used, I can contact BGEA and request a change, but I also realize that anything already released would be difficult or impossible to withdraw from circulation."]
  }), jsxs("p", {
    children: [jsx("strong", {
      children: "Confidentiality"
    }), " If Volunteer is exposed to what BGEA may consider to be confidential information, I agree that such confidential information shall remain BGEA's property at all times and I agree that Volunteer will not directly or indirectly, in any way, reveal, report, publish, disclose, transfer or otherwise use any of the confidential information except as specifically authorized by BGEA."]
  }), jsxs("p", {
    children: [jsx("strong", {
      children: "Code of Conduct"
    }), " I represent to BGEA that the Lord Jesus Christ is Volunteer's personal Savior, which means that Volunteer is a witness about Him to others at all times, through Volunteer's words and conduct, including during Volunteer's service as a volunteer with BGEA. I also acknowledge that Volunteer being permitted to perform volunteer service with BGEA is conditioned upon Volunteer's agreement with BGEA's Mission Statement and Statement of Faith and Volunteer's ongoing demonstration of appropriate conduct that is consistent with those statements, scriptural teachings and principles, and with BGEA's policies, procedures, and expectations. Volunteer will not represent any other ministry or personal interest while volunteering. I represent and warrant that Volunteer has no criminal background involving violence, sexual misconduct, or fraud, and agree to notify BGEA if there is any change in such status or if Volunteer is charged in a criminal matter of any kind. Either BGEA or I may terminate Volunteer's role at any time for any or no reason."]
  }), jsx("h5", {
    children: "I have read and agree to the BGEA Mission Statement and Statement of Faith."
  }), jsx("p", {
    children: "I understand, accept, and agree to the terms and conditions stated in this Volunteer Release and Waiver. I represent and warrant that I have the full legal authority to execute this Volunteer Release and Waiver and agree to indemnify, defend and hold BGEA harmless against the claims of third parties."
  })]
});
var MissionStatementAndRelease$1 = MissionStatementAndRelease;

var PrayerTeamInfo = function PrayerTeamInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _usePrayerTeam = usePrayerTeam({
      languageOptions: props === null || props === void 0 ? void 0 : props.languageOptions,
      orgRoleCode: props === null || props === void 0 ? void 0 : props.orgRoleCode
    }),
    churchLangOptions = _usePrayerTeam.churchLangOptions,
    defaultAddressList = _usePrayerTeam.defaultAddressList,
    isOver14 = _usePrayerTeam.isOver14,
    isUnder18 = _usePrayerTeam.isUnder18,
    showSubmitButton = _usePrayerTeam.showSubmitButton,
    visibleList = _usePrayerTeam.visibleList;
  return jsxs(Container$1, {
    children: [props === null || props === void 0 ? void 0 : props.formCopy, jsx(Content, {
      mt: 2,
      children: jsx(Checkbox, {
        id: "formLogic.over14",
        name: "formLogic.over14",
        labelHtml: t('Prayer Team Members are required to be 14 years or older', {
          ns: 'labels'
        })
      })
    }), isOver14 && jsxs(Fragment, {
      children: [jsx(CitiesRolesSelector$1, _objectSpread2({
        cities: props === null || props === void 0 ? void 0 : props.cities,
        cityOnly: props === null || props === void 0 ? void 0 : props.cityOnly,
        cityRoleSelectLabel: props === null || props === void 0 ? void 0 : props.cityRoleSelectLabel,
        codeKey: props === null || props === void 0 ? void 0 : props.codeKey,
        dtrValue: props === null || props === void 0 ? void 0 : props.dtrValue,
        individualCrusadeCodeEventValue: props === null || props === void 0 ? void 0 : props.individualCrusadeCodeEventValue,
        multipleCities: props === null || props === void 0 ? void 0 : props.multipleCities,
        multipleRoles: props === null || props === void 0 ? void 0 : props.multipleRoles,
        roleOnly: props === null || props === void 0 ? void 0 : props.roleOnly,
        roles: props === null || props === void 0 ? void 0 : props.roles
      }, props)), jsx(Heading, {
        subtitle: true,
        children: t('About You', {
          ns: 'labels'
        })
      }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
        addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || defaultAddressList,
        phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
        country: props === null || props === void 0 ? void 0 : props.country,
        visibleList: visibleList,
        minPhoneLength: 10,
        required: true
      })), jsx(Checkbox, {
        id: "formLogic.textOptIn",
        name: "formLogic.textOptIn",
        labelHtml: props === null || props === void 0 ? void 0 : props.optinLabel,
        valueObj: {
          value: '1418'
        }
      }), jsx(LanguageQuestionInfo$1, {
        fluentLangQuestionLabel: props === null || props === void 0 ? void 0 : props.fluentLangQuestionLabel,
        fluentLanguageOptions: props === null || props === void 0 ? void 0 : props.fluentLanguageOptions,
        languageOptions: props === null || props === void 0 ? void 0 : props.languageOptions
      }), jsx(Dropdown, {
        label: t('Gender', {
          ns: 'common'
        }),
        name: "collector.entity[0].gender",
        options: [{
          value: "".concat(t('Select One', {
            ns: 'labels'
          })),
          id: ''
        }, {
          value: "".concat(t('Female', {
            ns: 'common'
          })),
          id: 'F'
        }, {
          value: "".concat(t('Male', {
            ns: 'common'
          })),
          id: 'M'
        }],
        required: true
      }), (props === null || props === void 0 ? void 0 : props.showShirtSizes) && jsx(Dropdown, {
        name: "collector.cart.products[0].productId",
        fieldDisclaimer: props === null || props === void 0 ? void 0 : props.sizingDisclaimerText,
        label: t('T-Shirt Size', {
          ns: 'common'
        }),
        required: true,
        options: props === null || props === void 0 ? void 0 : props.shirtSizes
      }), jsx(Dropdown, {
        label: t('Are you over 18?', {
          ns: 'labels'
        }),
        name: "formLogic.over18",
        options: [{
          value: '',
          id: ''
        }, {
          value: "".concat(t('Yes', {
            ns: 'common'
          })),
          id: 'yes'
        }, {
          value: "".concat(t('No', {
            ns: 'common'
          })),
          id: 'no'
        }],
        required: true
      }), isUnder18 && jsxs(Fragment, {
        children: [jsx(InputText, {
          name: "formLogic.under18.legalGuardianName",
          label: t('Parent/Legal Guardian Name', {
            ns: 'labels'
          })
        }), jsx(InputEmail, {
          name: "formLogic.under18.legalGuardianEmail",
          label: t('Parent/Legal Guardian Email', {
            ns: 'labels'
          }),
          required: true
        }), jsx(InputText, {
          name: "formLogic.under18.emergencyContactName",
          label: t('Emergency Contact Name', {
            ns: 'labels'
          })
        }), jsx(InputPhone, {
          name: "formLogic.under18.emergencyContactPhone",
          label: (props === null || props === void 0 ? void 0 : props.phoneEmergencyLabel) || t('Emergency Contact Phone', {
            ns: 'labels'
          }),
          phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
          required: true,
          minPhoneLength: 10
        }), (props === null || props === void 0 ? void 0 : props.phoneDisclaimer) && jsx("div", {
          className: "phone-disclaimer",
          children: props === null || props === void 0 ? void 0 : props.phoneDisclaimer
        })]
      }), jsx(Heading, {
        subtitle: true,
        children: t('About Your Church', {
          ns: 'common'
        })
      }), jsx(Block, {
        textWeight: "bold",
        children: t('If you do not currently have a home church, please list the information for the last church you attended', {
          ns: 'common'
        })
      }), jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
        addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || defaultAddressList,
        churchAddressLabel: props === null || props === void 0 ? void 0 : props.churchAddressLabel,
        country: props === null || props === void 0 ? void 0 : props.country,
        display: ['OrganizationName', 'Phone', 'Address'],
        entity: 1,
        languageOptions: (props === null || props === void 0 ? void 0 : props.churchLangOptions) || churchLangOptions,
        phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
        orgRoles: props === null || props === void 0 ? void 0 : props.orgRoles,
        orgType: "church",
        relationshipPath: "collector.entity[0]",
        relationshipType: "Church",
        requiredList: ['OrganizationName', 'Phone', 'Address'],
        showLangQuestion: true
      })), jsx(Heading, {
        subtitle: true,
        children: t('Your Testimony', {
          ns: 'common'
        })
      }), jsxs("p", {
        children: [t('Briefly share how you know your sins are forgiven', {
          ns: 'common'
        }), "."]
      }), jsx(TextArea, {
        label: "",
        name: "newQuestions.Testimony",
        required: true
      }), jsx(Heading, {
        subtitle: true,
        children: t('Personal Reference Contact', {
          ns: 'common'
        })
      }), jsx("p", {
        children: t('Please list the name and email address of a pastor or church leader who can provide a personal reference for you', {
          ns: 'common'
        })
      }), jsx(InputText, {
        name: "formLogic.referenceName",
        label: "".concat(t('Personal Reference Name', {
          ns: 'labels'
        }), "*"),
        required: true
      }), jsx(InputEmail, {
        name: "formLogic.referenceEmail",
        label: "".concat(t('Personal Reference Email', {
          ns: 'labels'
        })),
        required: true
      }), jsxs("p", {
        children: [t('Please take time to read the entire document', {
          ns: 'common'
        }), "."]
      }), jsx(Acknowledgement, {
        required: true,
        multiple: true,
        names: ['formLogic.acknowledgement.missionStatement', 'formLogic.acknowledgement.release'],
        labels: [(props === null || props === void 0 ? void 0 : props.missionStatementLabel) || 'I agree to the mission statement.', (props === null || props === void 0 ? void 0 : props.waiverLiabilityLabel) || 'I agree to the release and waiver of liability.'],
        children: (props === null || props === void 0 ? void 0 : props.missionStatementCopy) || MissionStatementAndRelease$1
      }), showSubmitButton && jsx(SubmitButton, {
        text: t('Sign Up Now', {
          ns: 'labels'
        })
      })]
    })]
  });
};
var PrayerTeamInfo$1 = PrayerTeamInfo;

var DataEntryPrayerTeamInfo = function DataEntryPrayerTeamInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useDataEntryPrayerTe = useDataEntryPrayerTeam(_objectSpread2({}, props)),
    prayerFormProps = _useDataEntryPrayerTe.prayerFormProps;
  useDataEntryForm({
    index: 2
  });
  return jsx(PrayerTeamInfo$1, _objectSpread2({}, prayerFormProps));
};
var DataEntryPrayerTeamInfo$1 = DataEntryPrayerTeamInfo;

var DataEntryPrayerTeamMember = function DataEntryPrayerTeamMember(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.DATA_ENTRY_PRAYER_TEAM;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: PrayerTeamConfirmation,
    children: jsx(DataEntryPrayerTeamInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var IndividualVolunteerInfo = function IndividualVolunteerInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useIndividualVolunte = useIndividualVolunteer({
      languageOptions: props === null || props === void 0 ? void 0 : props.languageOptions,
      roleOptions: props === null || props === void 0 ? void 0 : props.roleOptions
    }),
    churchLangOptions = _useIndividualVolunte.churchLangOptions,
    defaultAddressList = _useIndividualVolunte.defaultAddressList,
    isUnder18 = _useIndividualVolunte.isUnder18,
    hasChurchInfo = _useIndividualVolunte.hasChurchInfo,
    roleOptionsName = _useIndividualVolunte.roleOptionsName,
    roles = _useIndividualVolunte.roles,
    showSubmitButton = _useIndividualVolunte.showSubmitButton,
    visibleList = _useIndividualVolunte.visibleList;
  return jsxs(Container$1, {
    children: [props === null || props === void 0 ? void 0 : props.formCopy, jsx(Heading, {
      subtitle: true,
      children: t('About You', {
        ns: 'labels'
      })
    }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
      addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || defaultAddressList,
      country: props === null || props === void 0 ? void 0 : props.country,
      visibleList: visibleList,
      minPhoneLength: 10,
      phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
      phoneLabel: props === null || props === void 0 ? void 0 : props.phoneLabel,
      required: true
    })), jsx(Checkbox, {
      id: "formLogic.textOptIn",
      name: "formLogic.textOptIn",
      labelHtml: props === null || props === void 0 ? void 0 : props.optinLabel,
      valueObj: {
        value: '1418'
      }
    }), jsx(LanguageQuestionInfo$1, {
      fluentLangQuestionLabel: props === null || props === void 0 ? void 0 : props.fluentLangQuestionLabel,
      fluentLanguageOptions: props === null || props === void 0 ? void 0 : props.fluentLanguageOptions,
      languageOptions: props === null || props === void 0 ? void 0 : props.languageOptions
    }), jsx(Heading, {
      subtitle: true,
      children: t('Volunteer Roles', {
        ns: 'common'
      })
    }), jsxs(Block, {
      children: [props.roleDescription, " "]
    }), jsx(RadioGroup, {
      display: "is-block",
      label: t('Can Only Select One', {
        ns: 'labels'
      }),
      name: roleOptionsName,
      options: roles,
      required: true
    }), jsx(CitiesRolesSelector$1, {
      cities: props === null || props === void 0 ? void 0 : props.cities,
      cityOnly: props === null || props === void 0 ? void 0 : props.cityOnly,
      cityRoleSelectLabel: props === null || props === void 0 ? void 0 : props.cityRoleSelectLabel,
      codeKey: props === null || props === void 0 ? void 0 : props.codeKey,
      dtrValue: props === null || props === void 0 ? void 0 : props.dtrValue,
      individualCrusadeCodeEventValue: props === null || props === void 0 ? void 0 : props.individualCrusadeCodeEventValue,
      multipleCities: props === null || props === void 0 ? void 0 : props.multipleCities,
      multipleRoles: props === null || props === void 0 ? void 0 : props.multipleRoles,
      roleOnly: props === null || props === void 0 ? void 0 : props.roleOnly,
      roles: props === null || props === void 0 ? void 0 : props.roles,
      showRoles: props === null || props === void 0 ? void 0 : props.showRoles
    }), (props === null || props === void 0 ? void 0 : props.showShirtSizes) && jsx(Dropdown, {
      name: "collector.cart.products[0].productId",
      fieldDisclaimer: props === null || props === void 0 ? void 0 : props.sizingDisclaimerText,
      label: t('T-Shirt Size', {
        ns: 'common'
      }),
      required: true,
      options: props === null || props === void 0 ? void 0 : props.shirtSizes
    }), jsx(Dropdown, {
      label: t('Are you over 18?', {
        ns: 'labels'
      }),
      name: "formLogic.over18",
      options: [{
        value: '',
        id: ''
      }, {
        value: "".concat(t('Yes', {
          ns: 'common'
        })),
        id: 'yes'
      }, {
        value: "".concat(t('No', {
          ns: 'common'
        })),
        id: 'no'
      }],
      required: true
    }), isUnder18 && jsxs(Fragment, {
      children: [jsx(InputText, {
        name: "formLogic.under18.legalGuardianName",
        label: t('Parent/Legal Guardian Name', {
          ns: 'labels'
        })
      }), jsx(InputEmail, {
        name: "formLogic.under18.legalGuardianEmail",
        label: t('Parent/Legal Guardian Email', {
          ns: 'labels'
        }),
        required: true
      }), jsx(InputText, {
        name: "formLogic.under18.emergencyContactName",
        label: t('Emergency Contact Name', {
          ns: 'labels'
        })
      }), jsx(InputPhone, {
        name: "formLogic.under18.emergencyContactPhone",
        label: t('Emergency Contact Phone', {
          ns: 'labels'
        }),
        phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
        required: true,
        minPhoneLength: 10
      })]
    }), jsx(Checkbox, {
      id: "formLogic.churchInfo",
      name: "formLogic.churchInfo",
      labelHtml: t("I'd like to share my church's information", {
        ns: 'labels'
      })
    }), hasChurchInfo && jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
      addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || defaultAddressList,
      churchAddressLabel: props === null || props === void 0 ? void 0 : props.churchAddressLabel,
      country: props === null || props === void 0 ? void 0 : props.country,
      display: ['OrganizationName', 'OrganizationRole', 'Phone', 'Address'],
      entity: 1,
      languageOptions: (props === null || props === void 0 ? void 0 : props.churchLangOptions) || churchLangOptions,
      phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
      phoneLabel: props === null || props === void 0 ? void 0 : props.phoneLabel,
      orgRoles: props === null || props === void 0 ? void 0 : props.orgRoles,
      orgType: "church",
      relationshipPath: "collector.entity[0]",
      relationshipType: "Church",
      requiredList: ['OrganizationName', 'OrganizationRole', 'Phone', 'Address'],
      showLangQuestion: true
    })), jsxs("p", {
      children: [t('Please take time to read the entire document', {
        ns: 'common'
      }), "."]
    }), jsx(Acknowledgement, {
      required: true,
      multiple: true,
      names: ['formLogic.acknowledgement.missionStatement', 'formLogic.acknowledgement.release'],
      labels: [(props === null || props === void 0 ? void 0 : props.missionStatementLabel) || 'I agree to the mission statement.', (props === null || props === void 0 ? void 0 : props.waiverLiabilityLabel) || 'I agree to the release and waiver of liability.'],
      children: (props === null || props === void 0 ? void 0 : props.missionStatementCopy) || MissionStatementAndRelease$1
    }), showSubmitButton && jsx(SubmitButton, {
      text: t('Sign Up Now', {
        ns: 'labels'
      })
    })]
  });
};
var IndividualVolunteerInfo$1 = IndividualVolunteerInfo;

var DataEntryVolunteerInfo = function DataEntryVolunteerInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useDataEntryVoluntee = useDataEntryVolunteer(_objectSpread2({}, props)),
    formProps = _useDataEntryVoluntee.formProps;
  useDataEntryForm({
    index: 2
  });
  return jsx(IndividualVolunteerInfo$1, _objectSpread2({}, formProps));
};
var DataEntryVolunteerInfo$1 = DataEntryVolunteerInfo;

var DataEntryVolunteer = function DataEntryVolunteer(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.DATA_ENTRY_VOLUNTEER;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: IndividualVolunteerConfirmation,
    children: jsx(DataEntryVolunteerInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var ErrorMsg = /*#__PURE__*/_styled(Form.Help, process.env.NODE_ENV === "production" ? {
  target: "e7ibo2s0"
} : {
  target: "e7ibo2s0",
  label: "ErrorMsg"
})("margin-top:-10px;color:", colors.frenchRose, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var PromoCode = function PromoCode(_ref) {
  var hasPromoCode = _ref.hasPromoCode,
    isPromoCodeInvalid = _ref.isPromoCodeInvalid,
    handleOnClickPromoCode = _ref.handleOnClickPromoCode;
  return jsx(Fragment, {
    children: jsx(Box, {
      children: jsxs(Form.Field, {
        children: [jsx(Form.Label, {
          children: "PROMO CODE"
        }), jsx(Form.Help, {
          className: "promo-code-help-txt",
          children: "If you have a promo code, please enter it here and we'll automatically adjust the price."
        }), jsx(Form.Field, {
          className: "promo-code-field-input",
          children: jsxs(Columns, {
            children: [jsx(Columns.Column, {
              size: "two-thirds",
              children: jsx(Form.Control, {
                children: jsx(InputText, {
                  id: "promoCode",
                  name: "formLogic.promoCode",
                  label: ""
                })
              })
            }), jsx(Columns.Column, {
              children: jsx(Form.Control, {
                children: jsx(Button, {
                  type: "button",
                  disabled: !hasPromoCode,
                  onClick: handleOnClickPromoCode,
                  children: "Apply"
                })
              })
            })]
          })
        }), isPromoCodeInvalid && jsx(ErrorMsg, {
          children: "Sorry, that code is invalid."
        })]
      })
    })
  });
};
var PromoCode$1 = PromoCode;

var _excluded$q = ["title"];
var Title$1 = /*#__PURE__*/_styled(Heading, process.env.NODE_ENV === "production" ? {
  target: "e1ubjy0o0"
} : {
  target: "e1ubjy0o0",
  label: "Title"
})("padding:0.5em 0;border-bottom:1px solid ", colors.silverChalice, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var DecisionMagazineInfo = function DecisionMagazineInfo(_ref) {
  var title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded$q);
  var _useDecisionMagazine = useDecisionMagazine({
      SESourceCode: props === null || props === void 0 ? void 0 : props.SESourceCode
    }),
    addressVisibleList = _useDecisionMagazine.addressVisibleList,
    billingAddressVisibleList = _useDecisionMagazine.billingAddressVisibleList,
    billingCountryOptions = _useDecisionMagazine.billingCountryOptions,
    countryOptions = _useDecisionMagazine.countryOptions,
    destinationOptions = _useDecisionMagazine.destinationOptions,
    destinationTitle = _useDecisionMagazine.destinationTitle,
    displayList = _useDecisionMagazine.displayList,
    giftRecipientTitle = _useDecisionMagazine.giftRecipientTitle,
    giftSubscriptionOptions = _useDecisionMagazine.giftSubscriptionOptions,
    giftSubscriptionTitle = _useDecisionMagazine.giftSubscriptionTitle,
    hasPromoCode = _useDecisionMagazine.hasPromoCode,
    isPromoCodeInvalid = _useDecisionMagazine.isPromoCodeInvalid,
    paymentTitle = _useDecisionMagazine.paymentTitle,
    showGiftRecipientInfo = _useDecisionMagazine.showGiftRecipientInfo,
    showPaymentInfo = _useDecisionMagazine.showPaymentInfo,
    showDataPromoError = _useDecisionMagazine.showDataPromoError,
    subscriptionOptions = _useDecisionMagazine.subscriptionOptions,
    subscriptionOptionTitle = _useDecisionMagazine.subscriptionOptionTitle,
    handleOnClickPromoCode = _useDecisionMagazine.handleOnClickPromoCode;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.customErrorMessage) && showDataPromoError && jsx(FormErrorScreens, {
      customErrorComponent: props === null || props === void 0 ? void 0 : props.customErrorMessage
    }), (props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: title || (props === null || props === void 0 ? void 0 : props.formHeaderTitle),
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: "Subscription Information",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Block, {
          children: jsx(PromoCode$1, {
            hasPromoCode: hasPromoCode,
            handleOnClickPromoCode: handleOnClickPromoCode,
            isPromoCodeInvalid: isPromoCodeInvalid
          })
        }), jsx(Block, {
          pt: "3",
          children: jsx(RadioGroup, {
            display: "is-block",
            label: destinationTitle,
            name: "formLogic.subLocation",
            options: destinationOptions
          })
        }), jsx(Block, {
          pt: "3",
          children: jsx(Dropdown, {
            label: giftSubscriptionTitle,
            name: "formLogic.giftSubscriptionOption",
            options: giftSubscriptionOptions
          })
        }), showGiftRecipientInfo && jsxs(Block, {
          pt: "3",
          children: [jsx(Title$1, {
            subtitle: true,
            children: giftRecipientTitle
          }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
            addressVisibleList: addressVisibleList,
            isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
            required: true,
            country: countryOptions,
            isPrimary: false,
            entity: 1,
            visibleList: displayList,
            useRegionComponent: props === null || props === void 0 ? void 0 : props.useRegionComponent
          }))]
        }), jsx(Block, {
          pt: "3",
          className: "form-dmag-radio-group",
          children: jsx(RadioGroup, {
            display: "is-block",
            label: subscriptionOptionTitle,
            name: "formLogic.subscriptionTypeOption",
            options: subscriptionOptions
          })
        })]
      }),
      paddingTop: "light"
    }), !showDataPromoError && jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: paymentTitle,
      formSectionFields: showPaymentInfo && jsx(Block, {
        className: "bgform-single-donation-container",
        children: jsx(PaymentMethod, {
          addressVisibleList: billingAddressVisibleList,
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          country: billingCountryOptions,
          disablePayPalPayment: true,
          hideHeadingText: true
        })
      }),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var DecisionMagazineInfo$1 = DecisionMagazineInfo;

var DecisionMagazine = function DecisionMagazine(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.DECISION_MAGAZINE;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    shouldNotSetLanguageCode: true,
    templateName: templateName,
    Confirmation: DecisionMagazineConfirmation,
    children: jsx(DecisionMagazineInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$p = ["errorMessage"];
var EchoConversationInfo = function EchoConversationInfo(_ref) {
  var errorMessage = _ref.errorMessage,
    props = _objectWithoutProperties(_ref, _excluded$p);
  var _useEchoConversation = useEchoConversation(_objectSpread2({
      errorMessage: errorMessage
    }, props)),
    apiErrorMessage = _useEchoConversation.apiErrorMessage,
    inputClass = _useEchoConversation.inputClass,
    phoneInputName = _useEchoConversation.phoneInputName,
    shouldDisableForm = _useEchoConversation.shouldDisableForm,
    validatePhoneNumber = _useEchoConversation.validatePhoneNumber;
  return jsxs(Container$1, {
    children: [jsx(FormSection$1, {
      isEmbedSite: false,
      disableEmbedLayout: false,
      formSectionHeader: (props === null || props === void 0 ? void 0 : props.sectionHeader) || '',
      formSectionFields: jsx(Fragment, {
        children: jsxs(Block, {
          children: [jsx(InputText, {
            className: inputClass,
            name: phoneInputName,
            label: "Mobile Phone Number",
            required: true,
            errorMessage: errorMessage,
            validate: validatePhoneNumber
          }), apiErrorMessage && jsx("p", {
            className: "help is-danger",
            children: apiErrorMessage
          })]
        })
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: false,
      disableEmbedLayout: true,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
        isDisabled: shouldDisableForm
      })),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var EchoConversationInfo$1 = EchoConversationInfo;

var EchoConversation = function EchoConversation(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.EMAIL_SUBSCRIBE;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(EchoConversationInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$o = ["emailSubscriptionKey", "isInternational", "values", "setFieldValue"];
var handleInitialState = function handleInitialState(_ref) {
  var _values$collector, _values$collector$ent, _values$collector2, _values$collector2$en, _values$collector2$en2, _props$specialCode, _props$cityEventOptio;
  var emailSubscriptionKey = _ref.emailSubscriptionKey,
    isInternational = _ref.isInternational,
    values = _ref.values,
    setFieldValue = _ref.setFieldValue,
    props = _objectWithoutProperties(_ref, _excluded$o);
  var resetArr = values !== null && values !== void 0 && (_values$collector = values.collector) !== null && _values$collector !== void 0 && (_values$collector$ent = _values$collector.entity[0]) !== null && _values$collector$ent !== void 0 && _values$collector$ent.code ? values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.code) === null || _values$collector2$en2 === void 0 ? void 0 : _values$collector2$en2.slice() : [];
  setFieldValue('formLogic.templateName', Templates.EMAIL_SUBSCRIBE);
  setFieldValue('collector.entity[0].address[0].zipPostalCode', '');
  setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetArr), _toConsumableArray(props !== null && props !== void 0 && props.esubCodesVolunteer ? [{
    key: 'ESUBS',
    value: props === null || props === void 0 ? void 0 : props.esubCodesVolunteer
  }] : []), _toConsumableArray(props !== null && props !== void 0 && props.emailSubscriptionAttr ? [{
    key: emailSubscriptionKey,
    value: props === null || props === void 0 ? void 0 : props.emailSubscriptionAttr
  }] : []), _toConsumableArray(isInternational && props !== null && props !== void 0 && props.formAttribute ? [{
    key: 'ATTRIBUTES',
    value: props === null || props === void 0 ? void 0 : props.formAttribute
  }] : []), _toConsumableArray((props === null || props === void 0 ? void 0 : (_props$specialCode = props.specialCode) === null || _props$specialCode === void 0 ? void 0 : _props$specialCode.length) > 0 ? props === null || props === void 0 ? void 0 : props.specialCode : [])));
  if (props !== null && props !== void 0 && props.showOptInEsubs) {
    setFieldValue('formLogic.hasEsub', props === null || props === void 0 ? void 0 : props.isOptInChecked, false);
  }
  if ((props === null || props === void 0 ? void 0 : (_props$cityEventOptio = props.cityEventOptions) === null || _props$cityEventOptio === void 0 ? void 0 : _props$cityEventOptio.length) > 0) {
    setFieldValue('formLogic.cityEvent', '');
  }
};
var handleEsubCodes = function handleEsubCodes(_ref2) {
  var esubCodes = _ref2.esubCodes,
    setFieldValue = _ref2.setFieldValue,
    props = _ref2.props;
  var keys = Object.keys(esubCodes);
  var esubs = [];
  keys.forEach(function (esubKey) {
    var _props$esubCodeList;
    var esubItem = props === null || props === void 0 ? void 0 : (_props$esubCodeList = props.esubCodeList) === null || _props$esubCodeList === void 0 ? void 0 : _props$esubCodeList.find(function (item) {
      return (item === null || item === void 0 ? void 0 : item.name) === esubKey;
    });
    if (esubCodes[esubKey]) {
      esubs.push({
        esubCode: esubItem === null || esubItem === void 0 ? void 0 : esubItem.code,
        isActive: true
      });
    }
  });
  setFieldValue("collector.entity[0].email[0].emailSubscription", esubs);
};

var useEmailSubscribe = function useEmailSubscribe(_ref) {
  var _values$formLogic, _Object$values, _values$collector$ent10, _values$collector$ent11, _values$collector$ent12, _values$collector$ent13, _values$collector$ent14, _values$collector$ent15, _values$collector2;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  useTranslationHelper();
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isFormValid = _useState2[0],
    setIsFormValid = _useState2[1];
  var _useFormikContext = useFormikContext(),
    isValid = _useFormikContext.isValid,
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue,
    validateForm = _useFormikContext.validateForm;
  var cityEvent = values === null || values === void 0 ? void 0 : values.formLogic.cityEvent;
  var hasCityEvent = typeof cityEvent !== 'undefined';
  var isInternational = (props === null || props === void 0 ? void 0 : props.destination) === 3;
  var eventId = props === null || props === void 0 ? void 0 : props.eventId;
  var hasEsub = values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.hasEsub;
  var esubCodes = values === null || values === void 0 ? void 0 : values.formLogic.esubCodes;
  var emailSubscriptionKey = !isInternational && eventId ? "CRUSADE:".concat(eventId) : 'ATTRIBUTES';
  var isDisabled = !isValid && !esubCodes || esubCodes && (((_Object$values = Object.values(esubCodes)) === null || _Object$values === void 0 ? void 0 : _Object$values.every(function (item) {
    return item === false;
  })) || !isValid);
  useEventId({
    eventId: cityEvent,
    isComponentDidUpdate: true,
    isInternational: isInternational
  });
  useLogicInfo({
    logicIds: props === null || props === void 0 ? void 0 : props.logicIds
  });
  var validateFields = function validateFields() {
    var _values$collector$ent, _values$collector$ent2, _values$collector$ent3, _values$collector$ent4, _values$collector$ent5, _values$collector$ent6, _values$collector$ent7;
    var validateDefaults = ((_values$collector$ent = values.collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : _values$collector$ent.firstName) && ((_values$collector$ent2 = values.collector.entity[0]) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.lastName) && ((_values$collector$ent3 = values.collector.entity[0]) === null || _values$collector$ent3 === void 0 ? void 0 : (_values$collector$ent4 = _values$collector$ent3.email[0]) === null || _values$collector$ent4 === void 0 ? void 0 : _values$collector$ent4.emailAddress) && ((_values$collector$ent5 = values.collector.entity[0]) === null || _values$collector$ent5 === void 0 ? void 0 : (_values$collector$ent6 = _values$collector$ent5.address[0]) === null || _values$collector$ent6 === void 0 ? void 0 : (_values$collector$ent7 = _values$collector$ent6.zipPostalCode) === null || _values$collector$ent7 === void 0 ? void 0 : _values$collector$ent7.length) > 0;
    if (hasCityEvent) {
      return validateDefaults && (cityEvent === null || cityEvent === void 0 ? void 0 : cityEvent.length) > 0;
    }
    return validateDefaults;
  };
  useEffect(function () {
    var _values$collector, _values$collector$ent8, _values$collector$ent9;
    var emailSubscription = values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent8 = _values$collector.entity[0]) === null || _values$collector$ent8 === void 0 ? void 0 : (_values$collector$ent9 = _values$collector$ent8.email[0]) === null || _values$collector$ent9 === void 0 ? void 0 : _values$collector$ent9.emailSubscription;
    if (hasEsub === false) {
      setFieldValue("collector.entity[0].email[0].emailSubscription", []);
    } else if (hasEsub && (emailSubscription === null || emailSubscription === void 0 ? void 0 : emailSubscription.length) === 0) {
      setFieldValue("collector.entity[0].email[0].emailSubscription", [{
        esubCode: props === null || props === void 0 ? void 0 : props.esubCodes[0],
        isActive: true
      }]);
    }
  }, [hasEsub]);
  useEffect(function () {
    if (esubCodes) {
      handleEsubCodes({
        esubCodes: esubCodes,
        props: props,
        setFieldValue: setFieldValue
      });
    }
  }, [esubCodes]);
  useEffect(function () {
    if (validateFields()) {
      setIsFormValid(true);
    } else {
      setIsFormValid(false);
    }
  }, [(_values$collector$ent10 = values.collector.entity[0]) === null || _values$collector$ent10 === void 0 ? void 0 : _values$collector$ent10.firstName, (_values$collector$ent11 = values.collector.entity[0]) === null || _values$collector$ent11 === void 0 ? void 0 : _values$collector$ent11.lastName, (_values$collector$ent12 = values.collector.entity[0]) === null || _values$collector$ent12 === void 0 ? void 0 : (_values$collector$ent13 = _values$collector$ent12.email[0]) === null || _values$collector$ent13 === void 0 ? void 0 : _values$collector$ent13.emailAddress, (_values$collector$ent14 = values.collector.entity[0]) === null || _values$collector$ent14 === void 0 ? void 0 : (_values$collector$ent15 = _values$collector$ent14.address[0]) === null || _values$collector$ent15 === void 0 ? void 0 : _values$collector$ent15.zipPostalCode, cityEvent]);
  useEffect(function () {
    validateForm();
  }, [isFormValid]);
  useEffect(function () {
    setFormId({
      templateName: Templates.EMAIL_SUBSCRIBE,
      values: values,
      setFieldValue: setFieldValue
    });
    handleInitialState(_objectSpread2({
      emailSubscriptionKey: emailSubscriptionKey,
      isInternational: isInternational,
      values: values,
      setFieldValue: setFieldValue
    }, props));
  }, []);
  values === null || values === void 0 ? true : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? true : delete _values$collector2.cart;
  return {
    isDisabled: isDisabled,
    values: values
  };
};

var _excluded$n = ["country", "hidePostalCode", "showCountry", "showEventCityList", "title", "visibleList", "esubCodeListLabel"];
var EmailSubscribeInfo = function EmailSubscribeInfo(_ref) {
  var _props$cityEventOptio, _props$esubCodeList;
  var _ref$country = _ref.country,
    country = _ref$country === void 0 ? ['US'] : _ref$country,
    _ref$hidePostalCode = _ref.hidePostalCode,
    hidePostalCode = _ref$hidePostalCode === void 0 ? false : _ref$hidePostalCode,
    _ref$showCountry = _ref.showCountry,
    showCountry = _ref$showCountry === void 0 ? false : _ref$showCountry,
    _ref$showEventCityLis = _ref.showEventCityList,
    showEventCityList = _ref$showEventCityLis === void 0 ? false : _ref$showEventCityLis,
    _ref$title = _ref.title,
    title = _ref$title === void 0 ? '' : _ref$title,
    _ref$visibleList = _ref.visibleList,
    visibleList = _ref$visibleList === void 0 ? ['firstName', 'lastName'] : _ref$visibleList,
    _ref$esubCodeListLabe = _ref.esubCodeListLabel,
    esubCodeListLabel = _ref$esubCodeListLabe === void 0 ? 'Please select at least one selection below' : _ref$esubCodeListLabe,
    props = _objectWithoutProperties(_ref, _excluded$n);
  var _useEmailSubscribe = useEmailSubscribe(_objectSpread2({}, props)),
    isDisabled = _useEmailSubscribe.isDisabled;
  var emailColumnSize = showCountry ? 'half' : 'one-third';
  var size = showCountry ? 'half' : 'two-thirds';
  var PrivacyPolicyCopy = props === null || props === void 0 ? void 0 : props.privacyPolicyCopy;
  return jsx(Container$1, {
    children: jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      hideTopBorder: true,
      isFormHeader: props === null || props === void 0 ? void 0 : props.isFormHeader,
      formSectionHeader: title,
      formSectionFields: jsxs(Fragment, {
        children: [(props === null || props === void 0 ? void 0 : props.description) && jsx(Content, {
          className: "esub-description",
          pb: 2,
          children: props === null || props === void 0 ? void 0 : props.description
        }), (props === null || props === void 0 ? void 0 : props.showDevoMessage) && (props === null || props === void 0 ? void 0 : props.devoMessage) && jsx(Block, {
          className: "devo-message",
          children: props === null || props === void 0 ? void 0 : props.devoMessage
        }), (props === null || props === void 0 ? void 0 : props.showOptInEsubs) && (props === null || props === void 0 ? void 0 : props.optInLabel) && jsx(Block, {
          children: jsx(Checkbox, {
            id: "formLogic.hasEsub",
            name: "formLogic.hasEsub",
            label: props === null || props === void 0 ? void 0 : props.optInLabel,
            isChecked: props === null || props === void 0 ? void 0 : props.isOptInChecked
          })
        }), jsx(Name$1, {
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          visibleList: visibleList,
          required: true,
          showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel
        }), jsxs(Columns, {
          multiline: true,
          children: [jsx(Columns.Column, {
            size: emailColumnSize,
            children: jsx(InputEmail, {
              entity: 0,
              required: true
            })
          }), !hidePostalCode && jsx(Columns.Column, {
            size: size,
            children: jsx(CountryPostal, {
              required: true,
              country: country,
              postalCodeLabel: props === null || props === void 0 ? void 0 : props.postalCodeLabel,
              showCountry: showCountry
            })
          })]
        }), showEventCityList && jsx(CitiesRolesSelector$1, {
          cities: props === null || props === void 0 ? void 0 : props.cities,
          cityRoleSelectLabel: props === null || props === void 0 ? void 0 : props.cityRoleSelectLabel,
          cityOnly: props === null || props === void 0 ? void 0 : props.cityOnly,
          codeKey: props === null || props === void 0 ? void 0 : props.codeKey,
          dtrValue: props === null || props === void 0 ? void 0 : props.dtrValue,
          individualCrusadeCodeEventValue: props === null || props === void 0 ? void 0 : props.individualCrusadeCodeEventValue,
          multipleCities: props === null || props === void 0 ? void 0 : props.multipleCities,
          multipleRoles: props === null || props === void 0 ? void 0 : props.multipleRoles,
          roleOnly: props === null || props === void 0 ? void 0 : props.roleOnly,
          roles: props === null || props === void 0 ? void 0 : props.roles
        }), (props === null || props === void 0 ? void 0 : (_props$cityEventOptio = props.cityEventOptions) === null || _props$cityEventOptio === void 0 ? void 0 : _props$cityEventOptio.length) > 0 && jsx(Dropdown, {
          name: "formLogic.cityEvent",
          label: props === null || props === void 0 ? void 0 : props.eventLabel,
          required: true,
          options: props === null || props === void 0 ? void 0 : props.cityEventOptions
        }), (props === null || props === void 0 ? void 0 : props.esubCodeList) && jsx(Content, {
          className: "esub-content-esub-label",
          children: esubCodeListLabel
        }), (props === null || props === void 0 ? void 0 : props.esubCodeList) && (props === null || props === void 0 ? void 0 : (_props$esubCodeList = props.esubCodeList) === null || _props$esubCodeList === void 0 ? void 0 : _props$esubCodeList.map(function (esubItem) {
          return jsx(Checkbox, {
            id: esubItem === null || esubItem === void 0 ? void 0 : esubItem.name,
            name: "formLogic.esubCodes.".concat(esubItem === null || esubItem === void 0 ? void 0 : esubItem.name),
            label: esubItem === null || esubItem === void 0 ? void 0 : esubItem.label,
            isChecked: esubItem === null || esubItem === void 0 ? void 0 : esubItem.isChecked
          }, esubItem === null || esubItem === void 0 ? void 0 : esubItem.name);
        })), (props === null || props === void 0 ? void 0 : props.privacyPolicyCopy) && jsx(Content, {
          className: "esub-content-privacy-policy",
          children: jsx(PrivacyPolicyCopy, {})
        }), jsx(Block, {
          pt: 2,
          className: "block-submit-button",
          children: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
            isDisabled: isDisabled,
            text: (props === null || props === void 0 ? void 0 : props.submitText) || 'Sign Me Up!',
            color: props !== null && props !== void 0 && props.isNewSubmitButton ? '#1a1a1a' : '',
            isNewSubmitButton: props === null || props === void 0 ? void 0 : props.isNewSubmitButton
          }))
        })]
      })
    })
  });
};
var EmailSubscribeInfo$1 = EmailSubscribeInfo;

var EmailSubscribe = function EmailSubscribe(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.EMAIL_SUBSCRIBE;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: EmailSubscribeConfirmation,
    children: jsx(EmailSubscribeInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var FreeTShirt = function FreeTShirt(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.FREE_TSHIRT;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    shouldNotSetLanguageCode: true,
    Confirmation: Confirmation,
    children: jsx(FreeTShirtInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$m = ["becomePrayerVolunteerCopy", "becomeVolunteerCopy", "country", "eventVolunteer", "eventVolunteerLabel", "handleIAA", "handlePrayerVolunteer", "handleVolunteer", "hideUserAddressSection", "iaaLabel", "interestedPrayerHatLabel", "interestedPrayerVolunteerLabel", "interestedVolunteerLabel", "nameTitles", "orgRoles", "roleLabel", "showPrefix", "showPrayerHatField", "volunteerAttrValue"];
var VolunteerSection = function VolunteerSection(_ref) {
  var becomePrayerVolunteerCopy = _ref.becomePrayerVolunteerCopy,
    becomeVolunteerCopy = _ref.becomeVolunteerCopy,
    _ref$eventVolunteer = _ref.eventVolunteer,
    eventVolunteer = _ref$eventVolunteer === void 0 ? true : _ref$eventVolunteer,
    eventVolunteerLabel = _ref.eventVolunteerLabel,
    handleIAA = _ref.handleIAA,
    handlePrayerVolunteer = _ref.handlePrayerVolunteer,
    handleVolunteer = _ref.handleVolunteer,
    iaaLabel = _ref.iaaLabel,
    interestedPrayerHatLabel = _ref.interestedPrayerHatLabel,
    interestedPrayerVolunteerLabel = _ref.interestedPrayerVolunteerLabel,
    interestedVolunteerLabel = _ref.interestedVolunteerLabel,
    roleLabel = _ref.roleLabel,
    showPrayerHatField = _ref.showPrayerHatField,
    volunteerAttrValue = _ref.volunteerAttrValue,
    props = _objectWithoutProperties(_ref, _excluded$m);
  var IaaCopy = props === null || props === void 0 ? void 0 : props.iaaCopy;
  return jsx(FormSection$1, {
    isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
    disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
    formSectionHeader: eventVolunteerLabel,
    formSectionFields: jsxs(Fragment, {
      children: [eventVolunteer && jsxs(Fragment, {
        children: [!(props !== null && props !== void 0 && props.hideBecomeVolunteerCopy) && jsx("p", {
          children: becomeVolunteerCopy
        }), jsx(Checkbox, {
          id: "formLogic.volunteer",
          name: "formLogic.volunteer",
          labelHtml: interestedVolunteerLabel,
          valueObj: {
            value: volunteerAttrValue
          },
          onClick: handleVolunteer
        })]
      }), (props === null || props === void 0 ? void 0 : props.hasPrayerVolunteer) && jsxs(Fragment, {
        children: [(props === null || props === void 0 ? void 0 : props.showPrayerVolunteerCopy) && jsx("p", {
          children: becomePrayerVolunteerCopy
        }), jsx(Checkbox, {
          id: "formLogic.prayerVolunteer",
          name: "formLogic.prayerVolunteer",
          labelHtml: interestedPrayerVolunteerLabel,
          valueObj: {
            value: props === null || props === void 0 ? void 0 : props.prayerVolunteerAttrValue
          },
          onClick: handlePrayerVolunteer
        })]
      }), !(props !== null && props !== void 0 && props.hidePrayerHatOffer) && showPrayerHatField && jsx(Dropdown, {
        label: interestedPrayerHatLabel,
        name: "formLogic.prayerHat",
        options: [{
          value: 'No',
          id: 'no'
        }, {
          value: 'Yes',
          id: 'yes'
        }]
      }), (props === null || props === void 0 ? void 0 : props.showAndrewSection) && jsxs(Fragment, {
        children: [IaaCopy && jsx(Content, {
          children: jsx(IaaCopy, {})
        }), !(props !== null && props !== void 0 && props.hideIaaLabel) && jsx(Checkbox, {
          id: "formLogic.iaa",
          name: "formLogic.iaa",
          labelHtml: iaaLabel,
          valueObj: {
            value: props === null || props === void 0 ? void 0 : props.iaaAttrValue
          },
          onClick: handleIAA
        })]
      }), (props === null || props === void 0 ? void 0 : props.showOrgRole) && jsx(Dropdown, {
        label: roleLabel,
        name: "collector.entity[1].orgs.role",
        options: props === null || props === void 0 ? void 0 : props.orgRoleList,
        required: true
      })]
    }),
    paddingTop: "light"
  });
};

var _excluded$l = ["churchClwcLabel", "churchLanguageLabel", "denominationLabel", "eventLabel", "femaleLabel", "genderLabel", "hideChurchDenomination", "isSeniorPastorSelected", "maleLabel", "nameTitles", "otherLabel", "orgRoles", "pastorNameLabel", "requireChurchMinisters", "selectOneLabel", "showDenominationInput", "visibleList"];
var GetInvolvedExtraFields = function GetInvolvedExtraFields(_ref) {
  var _props$denominationOp, _props$churchMinister, _props$cityEventOptio;
  var churchClwcLabel = _ref.churchClwcLabel,
    churchLanguageLabel = _ref.churchLanguageLabel,
    denominationLabel = _ref.denominationLabel,
    eventLabel = _ref.eventLabel,
    femaleLabel = _ref.femaleLabel,
    genderLabel = _ref.genderLabel,
    hideChurchDenomination = _ref.hideChurchDenomination,
    isSeniorPastorSelected = _ref.isSeniorPastorSelected,
    maleLabel = _ref.maleLabel,
    nameTitles = _ref.nameTitles,
    otherLabel = _ref.otherLabel,
    orgRoles = _ref.orgRoles,
    pastorNameLabel = _ref.pastorNameLabel,
    _ref$requireChurchMin = _ref.requireChurchMinisters,
    requireChurchMinisters = _ref$requireChurchMin === void 0 ? true : _ref$requireChurchMin,
    selectOneLabel = _ref.selectOneLabel,
    _ref$showDenomination = _ref.showDenominationInput,
    showDenominationInput = _ref$showDenomination === void 0 ? false : _ref$showDenomination,
    visibleList = _ref.visibleList,
    props = _objectWithoutProperties(_ref, _excluded$l);
  return jsxs(Fragment, {
    children: [(props === null || props === void 0 ? void 0 : props.showPastorSection) && !isSeniorPastorSelected && jsx(Fragment, {
      children: jsx(FormSection$1, {
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
        formSectionHeader: pastorNameLabel,
        formSectionFields: jsxs(Fragment, {
          children: [jsx(Name$1, {
            entity: 1,
            firstNameFieldName: "formLogic.pastorInfo.firstName",
            lastNameFieldName: "formLogic.pastorInfo.lastName",
            middleNameFieldName: "formLogic.pastorInfo.middleName",
            prefixFieldName: "formLogic.pastorInfo.prefix",
            prefixLabel: props === null || props === void 0 ? void 0 : props.pastorPrefixLabel,
            visibleList: visibleList,
            showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel,
            required: true,
            nameTitles: (props === null || props === void 0 ? void 0 : props.pastorNameTitles) || nameTitles
          }), (props === null || props === void 0 ? void 0 : props.showGenderOptons) && jsx(Dropdown, {
            label: genderLabel,
            name: "formLogic.pastorInfo.gender",
            options: [{
              value: "".concat(selectOneLabel),
              id: ''
            }, {
              value: "".concat(femaleLabel),
              id: 'F'
            }, {
              value: "".concat(maleLabel),
              id: 'M'
            }],
            required: true
          })]
        }),
        paddingTop: "light"
      })
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: props === null || props === void 0 ? void 0 : props.churchInfoLabel,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
          address1Label: props === null || props === void 0 ? void 0 : props.churchAddress1Label,
          addressVisibleList: (props === null || props === void 0 ? void 0 : props.churchAddressVisibleList) || (props === null || props === void 0 ? void 0 : props.addressVisibleList) || ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'],
          churchAddressLabel: props === null || props === void 0 ? void 0 : props.aboutYourChurchLabel,
          customRegionList: props === null || props === void 0 ? void 0 : props.customRegionList,
          country: props === null || props === void 0 ? void 0 : props.country,
          display: props === null || props === void 0 ? void 0 : props.churchDisplayList,
          entity: 1,
          hideChurchDenomination: hideChurchDenomination,
          orgRoles: orgRoles,
          phoneDisclaimer: props === null || props === void 0 ? void 0 : props.churchPhoneDisclaimer,
          phoneFieldName: "collector.entity[1].phone[0].phoneNumber",
          phoneType: (props === null || props === void 0 ? void 0 : props.churchPhoneType) || 'WORK',
          orgType: "church",
          relationshipPath: "collector.entity[0]",
          relationshipType: "Church",
          requiredList: (props === null || props === void 0 ? void 0 : props.requiredChurchList) || ['OrganizationName', 'OrganizationRole', 'Phone', 'Address'],
          showAddressLabel: props === null || props === void 0 ? void 0 : props.showAddressLabel
        })), (props === null || props === void 0 ? void 0 : (_props$denominationOp = props.denominationOptions) === null || _props$denominationOp === void 0 ? void 0 : _props$denominationOp.length) > 0 && jsx(Dropdown, {
          name: "formLogic.denomination",
          label: denominationLabel,
          required: true,
          options: props === null || props === void 0 ? void 0 : props.denominationOptions
        }), showDenominationInput && jsx(InputText, {
          label: otherLabel,
          name: "formLogic.denominationOther"
        }), (props === null || props === void 0 ? void 0 : props.showClwcCheckbox) && jsx(Checkbox, {
          name: "formLogic.canHostCLWC",
          label: churchClwcLabel
        }), (props === null || props === void 0 ? void 0 : (_props$churchMinister = props.churchMinistersOptions) === null || _props$churchMinister === void 0 ? void 0 : _props$churchMinister.length) > 0 && jsx(Dropdown, {
          name: "formLogic.churchLanguage",
          label: churchLanguageLabel,
          required: requireChurchMinisters,
          options: props === null || props === void 0 ? void 0 : props.churchMinistersOptions
        }), (props === null || props === void 0 ? void 0 : (_props$cityEventOptio = props.cityEventOptions) === null || _props$cityEventOptio === void 0 ? void 0 : _props$cityEventOptio.length) > 0 && jsx(Dropdown, {
          name: "formLogic.cityEvent",
          label: eventLabel,
          required: true,
          options: props === null || props === void 0 ? void 0 : props.cityEventOptions
        })]
      }),
      paddingTop: "light"
    })]
  });
};

var _excluded$k = ["country", "hideUserAddressSection", "hideChurchDenomination", "orgRoles", "phoneRequired", "showPrefix", "volunteerAttrValue", "nameTitles", "moveVolunteerPositionToBottom"];
var GetInvolvedInfo = function GetInvolvedInfo(_ref) {
  var country = _ref.country,
    hideUserAddressSection = _ref.hideUserAddressSection,
    _ref$hideChurchDenomi = _ref.hideChurchDenomination,
    hideChurchDenomination = _ref$hideChurchDenomi === void 0 ? true : _ref$hideChurchDenomi,
    orgRoles = _ref.orgRoles,
    _ref$phoneRequired = _ref.phoneRequired,
    phoneRequired = _ref$phoneRequired === void 0 ? true : _ref$phoneRequired,
    showPrefix = _ref.showPrefix,
    volunteerAttrValue = _ref.volunteerAttrValue,
    nameTitles = _ref.nameTitles,
    _ref$moveVolunteerPos = _ref.moveVolunteerPositionToBottom,
    moveVolunteerPositionToBottom = _ref$moveVolunteerPos === void 0 ? false : _ref$moveVolunteerPos,
    props = _objectWithoutProperties(_ref, _excluded$k);
  var _useGetInvolved = useGetInvolved(_objectSpread2({
      hideUserAddressSection: hideUserAddressSection,
      showPrefix: showPrefix,
      volunteerAttrValue: volunteerAttrValue
    }, props)),
    aboutYouLabel = _useGetInvolved.aboutYouLabel,
    aboutYourChurchLabel = _useGetInvolved.aboutYourChurchLabel,
    becomePrayerVolunteerCopy = _useGetInvolved.becomePrayerVolunteerCopy,
    becomeVolunteerCopy = _useGetInvolved.becomeVolunteerCopy,
    churchClwcLabel = _useGetInvolved.churchClwcLabel,
    churchInfoLabel = _useGetInvolved.churchInfoLabel,
    churchLanguageLabel = _useGetInvolved.churchLanguageLabel,
    denominationLabel = _useGetInvolved.denominationLabel,
    displayList = _useGetInvolved.displayList,
    eventLabel = _useGetInvolved.eventLabel,
    eventVolunteerLabel = _useGetInvolved.eventVolunteerLabel,
    femaleLabel = _useGetInvolved.femaleLabel,
    genderLabel = _useGetInvolved.genderLabel,
    handleIAA = _useGetInvolved.handleIAA,
    handlePrayerVolunteer = _useGetInvolved.handlePrayerVolunteer,
    handleVolunteer = _useGetInvolved.handleVolunteer,
    interestedPrayerHatLabel = _useGetInvolved.interestedPrayerHatLabel,
    interestedPrayerVolunteerLabel = _useGetInvolved.interestedPrayerVolunteerLabel,
    interestedVolunteerLabel = _useGetInvolved.interestedVolunteerLabel,
    isSeniorPastorSelected = _useGetInvolved.isSeniorPastorSelected,
    maleLabel = _useGetInvolved.maleLabel,
    otherLabel = _useGetInvolved.otherLabel,
    pastorNameLabel = _useGetInvolved.pastorNameLabel,
    privacyPolicyTextLabel = _useGetInvolved.privacyPolicyTextLabel,
    privacyPolicyLabel = _useGetInvolved.privacyPolicyLabel,
    roleLabel = _useGetInvolved.roleLabel,
    showDenominationInput = _useGetInvolved.showDenominationInput,
    showPrayerHatField = _useGetInvolved.showPrayerHatField,
    selectOneLabel = _useGetInvolved.selectOneLabel,
    visibleList = _useGetInvolved.visibleList,
    iaaLabel = _useGetInvolved.iaaLabel;
  var PrivacyPolicyCopy = props === null || props === void 0 ? void 0 : props.privacyPolicyCopy;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: aboutYouLabel,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Name$1, {
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          visibleList: (props === null || props === void 0 ? void 0 : props.visibleList) || visibleList,
          showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel,
          required: true,
          nameTitles: nameTitles
        }), (props === null || props === void 0 ? void 0 : props.showGenderOptons) && jsx(Dropdown, {
          label: genderLabel,
          name: "collector.entity[0].gender",
          options: [{
            value: "".concat(selectOneLabel),
            id: ''
          }, {
            value: "".concat(femaleLabel),
            id: 'F'
          }, {
            value: "".concat(maleLabel),
            id: 'M'
          }],
          required: true
        }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          addressLabel: props === null || props === void 0 ? void 0 : props.addressLabel,
          addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'],
          country: country,
          emailRequired: props === null || props === void 0 ? void 0 : props.emailRequired,
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          mobilePhoneRequired: props === null || props === void 0 ? void 0 : props.mobilePhoneRequired,
          mobilePhoneDisclaimer: props === null || props === void 0 ? void 0 : props.mobilePhoneDisclaimer,
          optInAttrValue: props === null || props === void 0 ? void 0 : props.optInAttrValue,
          optinLabel: props === null || props === void 0 ? void 0 : props.optinLabel,
          phoneFieldName: props === null || props === void 0 ? void 0 : props.phoneFieldName,
          phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
          phoneLabel: props === null || props === void 0 ? void 0 : props.phoneLabel,
          phoneRequired: phoneRequired,
          phoneType: (props === null || props === void 0 ? void 0 : props.phoneType) || 'HOME',
          socialMediaInputs: (props === null || props === void 0 ? void 0 : props.socialMediaInputs) || [],
          socialPhones: (props === null || props === void 0 ? void 0 : props.socialPhones) || [],
          visibleList: (props === null || props === void 0 ? void 0 : props.displayList) || displayList,
          required: true
        }))]
      }),
      paddingTop: "light"
    }), !moveVolunteerPositionToBottom ? jsxs(Fragment, {
      children: [!props.hideVolunteerSection && jsx(VolunteerSection, _objectSpread2(_objectSpread2({}, props), {}, {
        country: country,
        hideUserAddressSection: hideUserAddressSection,
        orgRoles: orgRoles,
        phoneRequired: phoneRequired,
        showPrefix: showPrefix,
        volunteerAttrValue: volunteerAttrValue,
        nameTitles: nameTitles,
        becomePrayerVolunteerCopy: props.becomePrayerVolunteerCopy || becomePrayerVolunteerCopy,
        becomeVolunteerCopy: (props === null || props === void 0 ? void 0 : props.becomeVolunteerCopy) || becomeVolunteerCopy,
        eventVolunteerLabel: eventVolunteerLabel,
        iaaLabel: (props === null || props === void 0 ? void 0 : props.iaaLabel) || iaaLabel,
        interestedPrayerHatLabel: interestedPrayerHatLabel,
        interestedPrayerVolunteerLabel: interestedPrayerVolunteerLabel,
        interestedVolunteerLabel: interestedVolunteerLabel,
        roleLabel: roleLabel,
        showPrayerHatField: showPrayerHatField,
        handleIAA: handleIAA,
        handlePrayerVolunteer: handlePrayerVolunteer,
        handleVolunteer: handleVolunteer
      })), jsx(GetInvolvedExtraFields, _objectSpread2(_objectSpread2({}, props), {}, {
        aboutYourChurchLabel: aboutYourChurchLabel,
        churchClwcLabel: churchClwcLabel,
        churchDisplayList: props === null || props === void 0 ? void 0 : props.churchDisplayList,
        churchInfoLabel: churchInfoLabel,
        churchLanguageLabel: churchLanguageLabel,
        country: country,
        denominationLabel: denominationLabel,
        eventLabel: eventLabel,
        femaleLabel: femaleLabel,
        genderLabel: genderLabel,
        hideChurchDenomination: hideChurchDenomination,
        isSeniorPastorSelected: isSeniorPastorSelected,
        maleLabel: maleLabel,
        nameTitles: nameTitles,
        pastorNameLabel: pastorNameLabel,
        otherLabel: otherLabel,
        showDenominationInput: showDenominationInput,
        selectOneLabel: selectOneLabel,
        orgRoles: orgRoles,
        visibleList: (props === null || props === void 0 ? void 0 : props.visibleList) || visibleList
      }))]
    }) : jsxs(Fragment, {
      children: [jsx(GetInvolvedExtraFields, _objectSpread2(_objectSpread2({}, props), {}, {
        aboutYourChurchLabel: aboutYourChurchLabel,
        churchClwcLabel: churchClwcLabel,
        churchDisplayList: props === null || props === void 0 ? void 0 : props.churchDisplayList,
        churchInfoLabel: churchInfoLabel,
        churchLanguageLabel: churchLanguageLabel,
        country: country,
        denominationLabel: denominationLabel,
        eventLabel: eventLabel,
        femaleLabel: femaleLabel,
        genderLabel: genderLabel,
        hideChurchDenomination: hideChurchDenomination,
        isSeniorPastorSelected: isSeniorPastorSelected,
        maleLabel: maleLabel,
        nameTitles: nameTitles,
        pastorNameLabel: pastorNameLabel,
        otherLabel: otherLabel,
        showDenominationInput: showDenominationInput,
        selectOneLabel: selectOneLabel,
        orgRoles: orgRoles,
        visibleList: (props === null || props === void 0 ? void 0 : props.visibleList) || visibleList
      })), jsx(VolunteerSection, _objectSpread2(_objectSpread2({}, props), {}, {
        country: country,
        hideUserAddressSection: hideUserAddressSection,
        orgRoles: orgRoles,
        phoneRequired: phoneRequired,
        showPrefix: showPrefix,
        volunteerAttrValue: volunteerAttrValue,
        nameTitles: nameTitles,
        becomePrayerVolunteerCopy: props.becomePrayerVolunteerCopy || becomePrayerVolunteerCopy,
        becomeVolunteerCopy: (props === null || props === void 0 ? void 0 : props.becomeVolunteerCopy) || becomeVolunteerCopy,
        eventVolunteerLabel: eventVolunteerLabel,
        iaaLabel: (props === null || props === void 0 ? void 0 : props.iaaLabel) || iaaLabel,
        interestedPrayerHatLabel: interestedPrayerHatLabel,
        interestedPrayerVolunteerLabel: interestedPrayerVolunteerLabel,
        interestedVolunteerLabel: interestedVolunteerLabel,
        roleLabel: roleLabel,
        showPrayerHatField: showPrayerHatField,
        handleIAA: handleIAA,
        handlePrayerVolunteer: handlePrayerVolunteer,
        handleVolunteer: handleVolunteer
      }))]
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: props !== null && props !== void 0 && props.isEmbedSite ? privacyPolicyTextLabel : '',
      formSectionFields: jsx(Fragment, {
        children: jsx(Box, {
          children: props !== null && props !== void 0 && props.privacyPolicyCopy ? jsx("div", {
            children: jsx(PrivacyPolicyCopy, {})
          }) : jsxs("p", {
            children: ["*", jsx("span", {
              dangerouslySetInnerHTML: {
                __html: privacyPolicyLabel
              }
            })]
          })
        })
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2({}, props)),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var GetInvolvedInfo$1 = GetInvolvedInfo;

var GetInvolved = function GetInvolved(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = "volunteer_".concat(Templates.GET_INVOLVED);
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(GetInvolvedInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$j = ["eventDateKey", "maxNumGroup", "minNumGroup", "pattern", "showPrefix", "transportOptions"];
var useGroupBookings = function useGroupBookings(_ref) {
  var _values$collector2, _values$collector2$en, _values$collector2$en2, _values$collector4, _values$collector5;
  var _ref$eventDateKey = _ref.eventDateKey,
    eventDateKey = _ref$eventDateKey === void 0 ? 'GRPEVTNIGHT' : _ref$eventDateKey,
    maxNumGroup = _ref.maxNumGroup,
    minNumGroup = _ref.minNumGroup,
    pattern = _ref.pattern,
    showPrefix = _ref.showPrefix,
    transportOptions = _ref.transportOptions,
    props = _objectWithoutProperties(_ref, _excluded$j);
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  useLogicInfo({
    logicIds: props === null || props === void 0 ? void 0 : props.logicIds
  });
  useChurchInfo(_objectSpread2({
    eventId: props === null || props === void 0 ? void 0 : props.eventId
  }, props));
  useCode(_objectSpread2({
    eventId: props === null || props === void 0 ? void 0 : props.eventId
  }, props));
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue,
    handleBlur = _useFormikContext.handleBlur,
    handleChange = _useFormikContext.handleChange;
  var visibleList = [].concat(_toConsumableArray(showPrefix ? ['prefix'] : []), ['firstName', 'lastName']);
  var defaultAddressList = ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'];
  var aboutYourChurchLabel = t('About Your Church', {
    ns: 'common'
  });
  var aboutYourGroupLabel = t('About Your Group', {
    ns: 'labels'
  });
  var groupBookingEventLabel = "".concat(t('Group Booking Event', {
    ns: 'labels'
  }));
  var groupNumberLabel = "".concat(t('Group Number', {
    ns: 'labels'
  }), "*");
  var peopleInGroupLabel = "".concat(t('People In Group', {
    ns: 'labels'
  }), "*");
  var privacyPolicyLabel = t('privacyAgreement', {
    ns: 'common',
    interpolation: {
      escapeValue: false
    }
  });
  var rangeErrorMsg = t('rangeError', {
    ns: 'validation',
    min: minNumGroup,
    max: maxNumGroup
  });
  var groupTravelPlansLabel = t('Group Travel Plans', {
    ns: 'labels'
  });
  var useOptinSocialPhoneFields = (props === null || props === void 0 ? void 0 : props.useOptinSocialPhoneFields) || false;
  var handleNumGroup = function handleNumGroup(e) {
    handleChange(e);
    setFieldValue('formLogic.numGroup', e.target.value.toString());
  };
  var handleGroupEvent = function handleGroupEvent(e) {
    var _e$target, _values$collector$ent;
    var value = e === null || e === void 0 ? void 0 : (_e$target = e.target) === null || _e$target === void 0 ? void 0 : _e$target.value;
    var eventId = parseInt(value, 10) > 1 ? value : props === null || props === void 0 ? void 0 : props.eventId;
    var eventDateInfo = e.target.options[e.target.selectedIndex].text;
    var newCodes = (_values$collector$ent = values.collector.entity[0].code) === null || _values$collector$ent === void 0 ? void 0 : _values$collector$ent.filter(function (code) {
      return code.key !== 'EVENTS' && code.key !== eventDateKey;
    });
    var eventArr = [{
      key: 'EVENTS',
      value: eventId
    }, {
      key: eventDateKey,
      value: eventDateInfo
    }];
    setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(newCodes), eventArr));
    setFieldValue('formLogic.eventDate', e.target.value.toString());
  };
  var handleItemBlur = function handleItemBlur(e) {
    handleBlur(e);
  };
  var getInitCodeArray = function getInitCodeArray(key) {
    var _values$collector, _values$collector$ent2, _values$collector$ent3;
    return values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent2 = _values$collector.entity[0]) === null || _values$collector$ent2 === void 0 ? void 0 : (_values$collector$ent3 = _values$collector$ent2.code) === null || _values$collector$ent3 === void 0 ? void 0 : _values$collector$ent3.filter(function (item) {
      return item.key !== key;
    });
  };
  var tempTransportType = [{
    value: t('Select One', {
      ns: 'labels'
    }),
    id: ''
  }];
  var transportRef = [{
    id: '',
    value: t('Select One', {
      ns: 'labels'
    })
  }, {
    id: 1,
    value: t('public_transportation', {
      ns: 'common'
    })
  }, {
    id: 2,
    value: t('private_bus', {
      ns: 'common'
    })
  }, {
    id: 3,
    value: t('mini_bus', {
      ns: 'common'
    })
  }, {
    id: 6,
    value: t('Book_a_FREE_Bus', {
      ns: 'common'
    })
  }, {
    id: 7,
    value: t('Church_Vehicle', {
      ns: 'common'
    })
  }, {
    id: 8,
    value: t('Private/Own_Car', {
      ns: 'common'
    })
  }, {
    id: 9,
    value: t('Taxi', {
      ns: 'common'
    })
  }, {
    id: 10,
    value: t('Volunteer_Business_Owner_Vehicle', {
      ns: 'common'
    })
  }, {
    id: 4,
    value: t('other', {
      ns: 'common'
    })
  }];
  if (transportOptions && transportOptions.length > 0) {
    var _loop = function _loop(i) {
      var _transportRef$find;
      tempTransportType.push({
        id: transportOptions[i],
        value: (_transportRef$find = transportRef.find(function (item) {
          return (item === null || item === void 0 ? void 0 : item.id) === transportOptions[i];
        })) === null || _transportRef$find === void 0 ? void 0 : _transportRef$find.value
      });
    };
    for (var i = 0; i < transportOptions.length; i++) {
      _loop(i);
    }
  }
  useEffect(function () {
    var transportTypeKey = values.formLogic[transportType];
    var transportTypeObj = transportTypeMap[transportTypeKey];
    var codeArr = getInitCodeArray(transportType);
    if (codeArr && transportTypeObj) {
      var translateKey = transportTypeObj.value;
      var translatedTransportObj = {
        key: transportType,
        value: t(translateKey, {
          ns: 'common'
        })
      };
      setFieldValue('collector.entity[0].code', [].concat(_toConsumableArray(codeArr), [translatedTransportObj]), false);
    }
  }, [values.formLogic[transportType]]);
  useEffect(function () {
    var numGroupValue = values.formLogic[numGroupType];
    var codeArr = getInitCodeArray(numGroupType);
    if (codeArr && numGroupValue) {
      setFieldValue('collector.entity[0].code', [].concat(_toConsumableArray(codeArr), [{
        key: numGroupType,
        value: "".concat(numGroupValue)
      }]), false);
    }
  }, [values.formLogic[numGroupType]]);
  useEffect(function () {
    /* Note: UK requires this logic */
    handleOptInLogicByPhone(_objectSpread2({
      values: values,
      setFieldValue: setFieldValue
    }, props));
  }, [values === null || values === void 0 ? void 0 : (_values$collector2 = values.collector) === null || _values$collector2 === void 0 ? void 0 : (_values$collector2$en = _values$collector2.entity[0]) === null || _values$collector2$en === void 0 ? void 0 : (_values$collector2$en2 = _values$collector2$en.phone[0]) === null || _values$collector2$en2 === void 0 ? void 0 : _values$collector2$en2.phoneNumber]);
  useEffect(function () {
    var _values$collector3;
    if (useOptinSocialPhoneFields && values !== null && values !== void 0 && (_values$collector3 = values.collector) !== null && _values$collector3 !== void 0 && _values$collector3.entity) {
      handleOptInSocialPhoneLogic(_objectSpread2({
        values: values,
        setFieldValue: setFieldValue
      }, props));
    }
  }, [useOptinSocialPhoneFields, values === null || values === void 0 ? void 0 : (_values$collector4 = values.collector) === null || _values$collector4 === void 0 ? void 0 : _values$collector4.entity]);
  useEffect(function () {
    setDefaultValues(_objectSpread2({
      templateName: Templates.GROUP_BOOKING,
      numGroupType: numGroupType,
      transportType: transportType,
      values: values,
      setFieldValue: setFieldValue
    }, props));
  }, []);
  values === null || values === void 0 ? true : (_values$collector5 = values.collector) === null || _values$collector5 === void 0 ? true : delete _values$collector5.cart;
  return {
    aboutYourChurchLabel: aboutYourChurchLabel,
    aboutYourGroupLabel: aboutYourGroupLabel,
    defaultAddressList: defaultAddressList,
    groupBookingEventLabel: groupBookingEventLabel,
    groupNumberLabel: groupNumberLabel,
    groupTravelPlansLabel: groupTravelPlansLabel,
    numGroupType: numGroupType,
    pattern: pattern,
    peopleInGroupLabel: peopleInGroupLabel,
    privacyPolicyTextLabel: translations.privacyPolicyLabel,
    privacyPolicyLabel: privacyPolicyLabel,
    rangeErrorMsg: rangeErrorMsg,
    tempTransportType: tempTransportType,
    transportType: transportType,
    visibleList: visibleList,
    yourChurchInformationLabel: translations.yourChurchInformationLabel,
    yourInformationLabel: translations.yourInformationLabel,
    handleGroupEvent: handleGroupEvent,
    handleItemBlur: handleItemBlur,
    handleNumGroup: handleNumGroup
  };
};

var _excluded$i = ["minNumGroup", "maxNumGroup", "phoneDisclaimer"];
var GroupBookingsInfo = function GroupBookingsInfo(_ref) {
  var _props$emailRequired, _props$eventDate;
  var _ref$minNumGroup = _ref.minNumGroup,
    minNumGroup = _ref$minNumGroup === void 0 ? 10 : _ref$minNumGroup,
    _ref$maxNumGroup = _ref.maxNumGroup,
    maxNumGroup = _ref$maxNumGroup === void 0 ? 1500 : _ref$maxNumGroup,
    _ref$phoneDisclaimer = _ref.phoneDisclaimer,
    phoneDisclaimer = _ref$phoneDisclaimer === void 0 ? '' : _ref$phoneDisclaimer,
    props = _objectWithoutProperties(_ref, _excluded$i);
  var _useGroupBookings = useGroupBookings(_objectSpread2({
      eventDateKey: props === null || props === void 0 ? void 0 : props.eventDateKey,
      maxNumGroup: maxNumGroup,
      minNumGroup: minNumGroup,
      showPrefix: props === null || props === void 0 ? void 0 : props.showPrefix,
      pattern: props === null || props === void 0 ? void 0 : props.pattern,
      transportOptions: props === null || props === void 0 ? void 0 : props.transportOptions
    }, props)),
    aboutYourChurchLabel = _useGroupBookings.aboutYourChurchLabel,
    aboutYourGroupLabel = _useGroupBookings.aboutYourGroupLabel,
    defaultAddressList = _useGroupBookings.defaultAddressList,
    groupBookingEventLabel = _useGroupBookings.groupBookingEventLabel,
    groupNumberLabel = _useGroupBookings.groupNumberLabel,
    groupTravelPlansLabel = _useGroupBookings.groupTravelPlansLabel,
    numGroupType = _useGroupBookings.numGroupType,
    pattern = _useGroupBookings.pattern,
    peopleInGroupLabel = _useGroupBookings.peopleInGroupLabel,
    privacyPolicyTextLabel = _useGroupBookings.privacyPolicyTextLabel,
    privacyPolicyLabel = _useGroupBookings.privacyPolicyLabel,
    rangeErrorMsg = _useGroupBookings.rangeErrorMsg,
    tempTransportType = _useGroupBookings.tempTransportType,
    transportType = _useGroupBookings.transportType,
    visibleList = _useGroupBookings.visibleList,
    yourChurchInformationLabel = _useGroupBookings.yourChurchInformationLabel,
    yourInformationLabel = _useGroupBookings.yourInformationLabel,
    handleGroupEvent = _useGroupBookings.handleGroupEvent,
    handleItemBlur = _useGroupBookings.handleItemBlur,
    handleNumGroup = _useGroupBookings.handleNumGroup;
  var PrivacyPolicyCopy = props === null || props === void 0 ? void 0 : props.privacyPolicyCopy;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: yourInformationLabel,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Name$1, {
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          visibleList: visibleList,
          required: true,
          nameTitles: props === null || props === void 0 ? void 0 : props.nameTitles,
          showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel
        }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          addressLabel: props === null || props === void 0 ? void 0 : props.addressLabel,
          addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'],
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          phoneType: (props === null || props === void 0 ? void 0 : props.phoneType) || 'HOME',
          country: props === null || props === void 0 ? void 0 : props.country,
          entity: 0,
          phoneRequired: props === null || props === void 0 ? void 0 : props.phoneRequired,
          phoneFieldName: props === null || props === void 0 ? void 0 : props.phoneFieldName,
          phoneLabel: props === null || props === void 0 ? void 0 : props.phoneLabel,
          mobilePhoneRequired: props === null || props === void 0 ? void 0 : props.mobilePhoneRequired,
          mobilePhoneDisclaimer: props === null || props === void 0 ? void 0 : props.mobilePhoneDisclaimer,
          phoneDisclaimer: phoneDisclaimer,
          socialMediaInputs: (props === null || props === void 0 ? void 0 : props.socialMediaInputs) || [],
          socialPhones: (props === null || props === void 0 ? void 0 : props.socialPhones) || [],
          visibleList: (props === null || props === void 0 ? void 0 : props.displayList) || ['Email', 'Phone', 'Address'],
          emailRequired: (_props$emailRequired = props === null || props === void 0 ? void 0 : props.emailRequired) !== null && _props$emailRequired !== void 0 ? _props$emailRequired : true,
          required: true
        }))]
      }),
      paddingTop: "light"
    }), (props === null || props === void 0 ? void 0 : props.showChurchInfo) && jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: yourChurchInformationLabel,
      formSectionFields: jsx(Fragment, {
        children: jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
          addressVisibleList: (props === null || props === void 0 ? void 0 : props.churchAddressVisibleList) || defaultAddressList,
          address1Label: props === null || props === void 0 ? void 0 : props.churchAddress1Label,
          churchAddressLabel: aboutYourChurchLabel,
          country: props === null || props === void 0 ? void 0 : props.country,
          entity: 1,
          orgRoles: props === null || props === void 0 ? void 0 : props.orgRoles,
          orgType: "church",
          relationshipPath: "collector.entity[0]",
          relationshipType: "Church",
          phoneType: (props === null || props === void 0 ? void 0 : props.churchPhoneType) || 'WORK',
          requiredList: (props === null || props === void 0 ? void 0 : props.requiredChurchList) || ['OrganizationName', 'OrganizationRole', 'Phone', 'Address']
        }))
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: aboutYourGroupLabel,
      formSectionFields: jsxs(Fragment, {
        children: [(props === null || props === void 0 ? void 0 : props.eventDate) && (props === null || props === void 0 ? void 0 : (_props$eventDate = props.eventDate) === null || _props$eventDate === void 0 ? void 0 : _props$eventDate.length) > 1 && jsx(Content, {
          children: jsx(Dropdown, {
            label: groupBookingEventLabel,
            name: "formLogic.eventDate",
            options: props === null || props === void 0 ? void 0 : props.eventDate,
            onChange: handleGroupEvent,
            required: true
          })
        }), (props === null || props === void 0 ? void 0 : props.peopleInGroupLabel) && jsx(Content, {
          children: peopleInGroupLabel
        }), jsx(Content, {
          children: jsx(InputNumber, {
            label: (props === null || props === void 0 ? void 0 : props.groupNumberLabel) || groupNumberLabel,
            name: "formLogic.".concat(numGroupType),
            onBlur: handleItemBlur,
            onChange: handleNumGroup,
            pattern: pattern,
            required: true,
            validate: function validate(value) {
              return validateNumber(value, true, minNumGroup, maxNumGroup, rangeErrorMsg);
            }
          })
        }), jsx(Content, {
          children: jsx(Dropdown, {
            label: (props === null || props === void 0 ? void 0 : props.groupTravelPlansLabel) || groupTravelPlansLabel,
            name: "formLogic.".concat(transportType),
            options: (props === null || props === void 0 ? void 0 : props.transportationOptions) || tempTransportType,
            required: true
          })
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: props !== null && props !== void 0 && props.isEmbedSite ? privacyPolicyTextLabel : '',
      formSectionFields: jsx(Fragment, {
        children: jsx(Box, {
          mx: 1,
          my: 5,
          children: props !== null && props !== void 0 && props.privacyPolicyCopy ? jsx("div", {
            children: jsx(PrivacyPolicyCopy, {})
          }) : jsxs("p", {
            children: ["*", jsx("span", {
              dangerouslySetInnerHTML: {
                __html: privacyPolicyLabel
              }
            })]
          })
        })
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
        color: props !== null && props !== void 0 && props.isNewSubmitButton ? '#1a1a1a' : '',
        isNewSubmitButton: props === null || props === void 0 ? void 0 : props.isNewSubmitButton
      })),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var GroupBookingsInfo$1 = GroupBookingsInfo;

var GroupBookings = function GroupBookings(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.GROUP_BOOKING;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(GroupBookingsInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var GroupLeaderInfo = function GroupLeaderInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useGroupLeader = useGroupLeader({
      languageOptions: props === null || props === void 0 ? void 0 : props.languageOptions
    }),
    churchLangOptions = _useGroupLeader.churchLangOptions,
    defaultAddressList = _useGroupLeader.defaultAddressList,
    isOver18 = _useGroupLeader.isOver18,
    hasChurchInfo = _useGroupLeader.hasChurchInfo,
    showSubmitButton = _useGroupLeader.showSubmitButton,
    values = _useGroupLeader.values,
    visibleList = _useGroupLeader.visibleList;
  return jsxs(Container$1, {
    children: [props === null || props === void 0 ? void 0 : props.formVideo, props === null || props === void 0 ? void 0 : props.formCopy, jsx(Checkbox, {
      id: "formLogic.over18",
      name: "formLogic.over18",
      labelHtml: props === null || props === void 0 ? void 0 : props.over18Label
    }), isOver18 && jsxs(Fragment, {
      children: [jsx(Heading, {
        subtitle: true,
        children: t('About You', {
          ns: 'labels'
        })
      }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
        addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || defaultAddressList,
        country: props === null || props === void 0 ? void 0 : props.country,
        visibleList: visibleList,
        minPhoneLength: 10,
        phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
        phoneLabel: props === null || props === void 0 ? void 0 : props.phoneLabel,
        emailRequired: true,
        required: true
      })), jsx(Checkbox, {
        id: "formLogic.textOptIn",
        name: "formLogic.textOptIn",
        labelHtml: props === null || props === void 0 ? void 0 : props.optinLabel,
        valueObj: {
          value: '1418'
        }
      }), jsx(LanguageQuestionInfo$1, {
        fluentLangQuestionLabel: props === null || props === void 0 ? void 0 : props.fluentLangQuestionLabel,
        fluentLanguageOptions: props === null || props === void 0 ? void 0 : props.fluentLanguageOptions,
        languageOptions: props === null || props === void 0 ? void 0 : props.languageOptions
      }), (props === null || props === void 0 ? void 0 : props.showShirtSizes) && jsx(Dropdown, {
        name: "collector.cart.products[0].productId",
        fieldDisclaimer: props === null || props === void 0 ? void 0 : props.sizingDisclaimerText,
        label: t('T-Shirt Size', {
          ns: 'common'
        }),
        required: true,
        options: props === null || props === void 0 ? void 0 : props.shirtSizes
      }), jsx(Heading, {
        subtitle: true,
        children: t('About Your Group', {
          ns: 'labels'
        })
      }), jsx(InputText, {
        name: "collector.entity[0].note.note",
        label: "".concat(t('Name of Group', {
          ns: 'labels'
        }), "*"),
        validate: function validate(value) {
          return validateString(values === null || values === void 0 ? void 0 : values.translations, value, true, 50);
        }
      }), jsx(InputNumber, {
        label: "".concat(t('Estimated Size of Group', {
          ns: 'labels'
        }), "*"),
        name: "collector.entity[0].number[0].value",
        required: true,
        validate: function validate(value) {
          return validateNumber(value, true, 5, 100);
        }
      }), jsx(CitiesRolesSelector$1, {
        cities: props === null || props === void 0 ? void 0 : props.cities,
        cityOnly: props === null || props === void 0 ? void 0 : props.cityOnly,
        cityRoleSelectLabel: props === null || props === void 0 ? void 0 : props.cityRoleSelectLabel,
        codeKey: props === null || props === void 0 ? void 0 : props.codeKey,
        dtrValue: props === null || props === void 0 ? void 0 : props.dtrValue,
        hasGroupInfo: true,
        individualCrusadeCodeEventValue: props === null || props === void 0 ? void 0 : props.individualCrusadeCodeEventValue,
        multipleCities: props === null || props === void 0 ? void 0 : props.multipleCities,
        multipleRoles: props === null || props === void 0 ? void 0 : props.multipleRoles,
        roleOnly: props === null || props === void 0 ? void 0 : props.roleOnly,
        roles: props === null || props === void 0 ? void 0 : props.roles
      }), jsx(Checkbox, {
        id: "formLogic.churchInfo",
        name: "formLogic.churchInfo",
        labelHtml: t("I'd like to share my church's information", {
          ns: 'labels'
        })
      }), hasChurchInfo && jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
        addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || defaultAddressList,
        churchAddressLabel: props === null || props === void 0 ? void 0 : props.churchAddressLabel,
        country: props === null || props === void 0 ? void 0 : props.country,
        display: ['OrganizationName', 'Phone', 'Address'],
        entity: 1,
        languageOptions: (props === null || props === void 0 ? void 0 : props.churchLangOptions) || churchLangOptions,
        orgRoles: props === null || props === void 0 ? void 0 : props.orgRoles,
        orgType: "church",
        phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
        phoneLabel: props === null || props === void 0 ? void 0 : props.phoneLabel,
        relationshipPath: "collector.entity[0]",
        relationshipType: "Church",
        requiredList: ['OrganizationName', 'Phone', 'Address'],
        showLangQuestion: true
      })), jsxs("p", {
        children: [t('Please take time to read the entire document', {
          ns: 'common'
        }), "."]
      }), jsx(Acknowledgement, {
        required: true,
        multiple: true,
        names: ['formLogic.acknowledgement.missionStatement', 'formLogic.acknowledgement.release'],
        labels: [(props === null || props === void 0 ? void 0 : props.missionStatementLabel) || 'I agree to the mission statement.', (props === null || props === void 0 ? void 0 : props.waiverLiabilityLabel) || 'I agree to the release and waiver of liability.'],
        children: (props === null || props === void 0 ? void 0 : props.missionStatementCopy) || MissionStatementAndRelease$1
      }), showSubmitButton && jsx(SubmitButton, {
        text: t('Sign Up Now', {
          ns: 'labels'
        })
      })]
    })]
  });
};
var GroupLeaderInfo$1 = GroupLeaderInfo;

var GroupLeaderVolunteer = function GroupLeaderVolunteer(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.GROUP_BOOKING;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: GroupLeaderConfirmation,
    children: jsx(GroupLeaderInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var GroupMemberInfo = function GroupMemberInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useGroupMember = useGroupMember({
      cities: props === null || props === void 0 ? void 0 : props.cities,
      cityMap: props === null || props === void 0 ? void 0 : props.cityMap
    }),
    defaultAddressList = _useGroupMember.defaultAddressList,
    groupName = _useGroupMember.groupName,
    isUnder18 = _useGroupMember.isUnder18,
    leaderId = _useGroupMember.leaderId,
    selectedCity = _useGroupMember.selectedCity,
    showSubmitButton = _useGroupMember.showSubmitButton,
    visibleList = _useGroupMember.visibleList;
  return jsx(Container$1, {
    children: !groupName && !leaderId ?
    // Gives the user an error message if they don't exist
    jsx("p", {
      children: "Oops! Looks like you don't have the full URL needed to register. Please contact your group leader for the full URL."
    }) : jsx(Fragment, {
      children: jsxs(Block, {
        children: [props === null || props === void 0 ? void 0 : props.formCopy, jsx(Heading, {
          subtitle: true,
          children: t('About You', {
            ns: 'labels'
          })
        }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || defaultAddressList,
          country: props === null || props === void 0 ? void 0 : props.country,
          visibleList: visibleList,
          minPhoneLength: 10,
          phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
          phoneLabel: props === null || props === void 0 ? void 0 : props.phoneLabel,
          emailRequired: true,
          required: true
        })), jsx(Checkbox, {
          id: "formLogic.textOptIn",
          name: "formLogic.textOptIn",
          labelHtml: props === null || props === void 0 ? void 0 : props.optinLabel,
          valueObj: {
            value: '1418'
          }
        }), jsx(LanguageQuestionInfo$1, {
          fluentLangQuestionLabel: props === null || props === void 0 ? void 0 : props.fluentLangQuestionLabel,
          fluentLanguageOptions: props === null || props === void 0 ? void 0 : props.fluentLanguageOptions,
          languageOptions: props === null || props === void 0 ? void 0 : props.languageOptions
        }), selectedCity && jsx(Block, {
          children: "".concat(t('Thank you for volunteering to serve on-site with your group at', {
            ns: 'common'
          }), " ").concat(selectedCity)
        }), (props === null || props === void 0 ? void 0 : props.showShirtSizes) && jsx(Dropdown, {
          name: "collector.cart.products[0].productId",
          fieldDisclaimer: props === null || props === void 0 ? void 0 : props.sizingDisclaimerText,
          label: t('T-Shirt Size', {
            ns: 'common'
          }),
          required: true,
          options: props === null || props === void 0 ? void 0 : props.shirtSizes
        }), jsx(Dropdown, {
          label: t('Are you over 18?', {
            ns: 'labels'
          }),
          name: "formLogic.over18",
          options: [{
            value: '',
            id: ''
          }, {
            value: "".concat(t('Yes', {
              ns: 'common'
            })),
            id: 'yes'
          }, {
            value: "".concat(t('No', {
              ns: 'common'
            })),
            id: 'no'
          }],
          required: true
        }), isUnder18 && jsxs(Fragment, {
          children: [jsx(InputText, {
            name: "formLogic.under18.legalGuardianName",
            label: t('Parent/Legal Guardian Name', {
              ns: 'labels'
            })
          }), jsx(InputEmail, {
            name: "formLogic.under18.legalGuardianEmail",
            label: t('Parent/Legal Guardian Email', {
              ns: 'labels'
            }),
            required: true
          }), jsx(InputText, {
            name: "formLogic.under18.emergencyContactName",
            label: t('Emergency Contact Name', {
              ns: 'labels'
            })
          }), jsx(InputPhone, {
            name: "formLogic.under18.emergencyContactPhone",
            label: (props === null || props === void 0 ? void 0 : props.phoneEmergencyLabel) || t('Emergency Contact Phone', {
              ns: 'labels'
            }),
            phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
            required: true,
            minPhoneLength: 10
          })]
        }), jsx(Acknowledgement, {
          required: true,
          multiple: true,
          names: ['formLogic.acknowledgement.missionStatement', 'formLogic.acknowledgement.release'],
          labels: [(props === null || props === void 0 ? void 0 : props.missionStatementLabel) || 'I agree to the mission statement.', (props === null || props === void 0 ? void 0 : props.waiverLiabilityLabel) || 'I agree to the release and waiver of liability.'],
          children: (props === null || props === void 0 ? void 0 : props.missionStatementCopy) || MissionStatementAndRelease$1
        }), showSubmitButton && jsx(SubmitButton, {
          text: t('Sign Up Now', {
            ns: 'labels'
          })
        })]
      })
    })
  });
};
var GroupMemberInfo$1 = GroupMemberInfo;

var GroupMemberVolunteer = function GroupMemberVolunteer(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.GROUP_MEMBER;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: GroupMemberConfirmation,
    children: jsx(GroupMemberInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var useGroupRegistrations = function useGroupRegistrations(_ref) {
  var _Object$keys;
  var prefContactOptions = _ref.prefContactOptions,
    hideUserAddressSection = _ref.hideUserAddressSection,
    showPrefix = _ref.showPrefix;
  var hasPrefOptions = prefContactOptions && ((_Object$keys = Object.keys(prefContactOptions)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) > 0;
  var visibleList = [].concat(_toConsumableArray(showPrefix ? ['prefix'] : []), ['firstName', 'lastName']);
  var displayList = ['Email', 'Phone'].concat(_toConsumableArray(!hideUserAddressSection ? ['Address'] : []));
  return {
    displayList: displayList,
    hasPrefOptions: hasPrefOptions,
    visibleList: visibleList
  };
};

var GroupRegistrationsInfo = function GroupRegistrationsInfo(_ref) {
  var _ref$autoComplete = _ref.autoComplete,
    autoComplete = _ref$autoComplete === void 0 ? false : _ref$autoComplete,
    country = _ref.country,
    prefContactOptions = _ref.prefContactOptions,
    hideUserAddressSection = _ref.hideUserAddressSection,
    showPrefix = _ref.showPrefix,
    volunteerAttrValue = _ref.volunteerAttrValue,
    nameTitles = _ref.nameTitles,
    maxTextLen = _ref.maxTextLen,
    trainingOptions = _ref.trainingOptions;
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var _useGroupRegistration = useGroupRegistrations({
      prefContactOptions: prefContactOptions,
      hideUserAddressSection: hideUserAddressSection,
      showPrefix: showPrefix,
      volunteerAttrValue: volunteerAttrValue
    }),
    displayList = _useGroupRegistration.displayList,
    hasPrefOptions = _useGroupRegistration.hasPrefOptions,
    visibleList = _useGroupRegistration.visibleList;
  var fluentLangQuestion = 'formLogic.fluentLangQuestion';
  return jsxs(Container$1, {
    children: [jsx(Name$1, {
      visibleList: visibleList,
      nameTitles: nameTitles
    }), jsx(EntityFields, {
      autoComplete: autoComplete,
      country: country,
      visibleList: displayList,
      emailRequired: true,
      required: true
    }), hasPrefOptions && jsx(Dropdown, {
      name: "formLogic.prefContact",
      label: t('Preferred contact method', {
        ns: 'labels'
      }),
      required: true,
      options: prefContactOptions
    }), jsx(Block, {
      children: jsx(RadioGroup, {
        label: "Training",
        name: fluentLangQuestion,
        options: trainingOptions,
        required: true
      })
    }), jsx(TextArea, {
      label: "".concat(t('Group Affiliation', {
        ns: 'labels'
      }), "*"),
      name: "collector.communications[0].longComment",
      maxLen: maxTextLen,
      required: true
    }), jsx(TextArea, {
      label: "".concat(t('Estimated Number of Members', {
        ns: 'labels'
      }), "*"),
      name: "collector.communications[0].longComment",
      maxLen: maxTextLen,
      required: true
    }), jsx(SubmitButton, {})]
  });
};
var GroupRegistrationsInfo$1 = GroupRegistrationsInfo;

var GroupRegistrations = function GroupRegistrations(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.GROUP_REGISTRATIONS;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(GroupRegistrationsInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$h = ["blockTitleColor"];
var StyledTitle = /*#__PURE__*/_styled(Content, process.env.NODE_ENV === "production" ? {
  target: "eolfrxb0"
} : {
  target: "eolfrxb0",
  label: "StyledTitle"
})("font-weight:700;font-size:1.25rem;color:", function (props) {
  return props.textColor || '#63594e';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var GroupRequestInfo = function GroupRequestInfo(_ref) {
  var blockTitleColor = _ref.blockTitleColor,
    props = _objectWithoutProperties(_ref, _excluded$h);
  var _useGroupRequest = useGroupRequest({
      showPrefix: props === null || props === void 0 ? void 0 : props.showPrefix
    }),
    contactInfoTitle = _useGroupRequest.contactInfoTitle,
    organizationInfoTitle = _useGroupRequest.organizationInfoTitle,
    requestInfoTitle = _useGroupRequest.requestInfoTitle,
    websiteLabel = _useGroupRequest.websiteLabel,
    nameVisibleList = _useGroupRequest.nameVisibleList,
    numGuestsLabel = _useGroupRequest.numGuestsLabel,
    numMealsLabel = _useGroupRequest.numMealsLabel,
    numRoomsLabel = _useGroupRequest.numRoomsLabel,
    numNightsLabel = _useGroupRequest.numNightsLabel,
    proposedStartDateLabel = _useGroupRequest.proposedStartDateLabel,
    proposedEndDateLabel = _useGroupRequest.proposedEndDateLabel,
    datesFlexibleLabel = _useGroupRequest.datesFlexibleLabel,
    eventTypeLabel = _useGroupRequest.eventTypeLabel,
    eventsBeforeLabel = _useGroupRequest.eventsBeforeLabel,
    hearAboutLabel = _useGroupRequest.hearAboutLabel,
    commentsLabel = _useGroupRequest.commentsLabel,
    submitText = _useGroupRequest.submitText;
  return jsxs(Container$1, {
    className: "content is-family-sans-serif",
    children: [jsxs(Block, {
      children: [jsx(StyledTitle, {
        textColor: blockTitleColor,
        children: contactInfoTitle
      }), jsx(Name$1, {
        nameTitles: props === null || props === void 0 ? void 0 : props.nameTitles,
        required: true,
        showNameLabel: false,
        visibleList: nameVisibleList
      }), jsx(Content, {
        className: "content block-margin-bottom",
        children: jsx(EntityFields, {
          visibleList: ['Email', 'Phone'],
          required: true,
          showAddressLabel: false
        })
      })]
    }), jsx("br", {}), jsxs(Block, {
      children: [jsx(StyledTitle, {
        textColor: blockTitleColor,
        children: organizationInfoTitle
      }), (props === null || props === void 0 ? void 0 : props.showChurchInfo) && jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
        orgRoles: props === null || props === void 0 ? void 0 : props.orgRoles,
        addressVisibleList: props === null || props === void 0 ? void 0 : props.addressVisibleList,
        requiredList: ['OrganizationName', 'Address'],
        country: props === null || props === void 0 ? void 0 : props.country,
        display: ['OrganizationName', 'Address']
      })), jsx(Columns, {
        children: jsx(Columns.Column, {
          children: jsx(InputText, {
            label: websiteLabel,
            name: "formLogic.website"
          })
        })
      })]
    }), jsx("br", {}), jsxs(Block, {
      children: [jsx(StyledTitle, {
        textColor: blockTitleColor,
        children: requestInfoTitle
      }), jsxs(Columns, {
        children: [jsx(Columns.Column, {
          children: jsx(InputText, {
            label: numGuestsLabel,
            name: "formLogic.numGuests",
            required: true
          })
        }), jsx(Columns.Column, {
          children: jsx(InputText, {
            label: numMealsLabel,
            name: "formLogic.numMeals",
            required: true
          })
        })]
      }), jsxs(Columns, {
        children: [jsx(Columns.Column, {
          children: jsx(InputText, {
            label: numRoomsLabel,
            name: "formLogic.numRooms",
            required: true
          })
        }), jsx(Columns.Column, {
          children: jsx(InputText, {
            label: numNightsLabel,
            name: "formLogic.numNights",
            required: true
          })
        })]
      }), jsxs(Columns, {
        children: [jsx(Columns.Column, {
          children: jsx(DateCalendar, {
            label: proposedStartDateLabel,
            name: "formLogic.proposedStartDate",
            required: true
          })
        }), jsx(Columns.Column, {
          children: jsx(DateCalendar, {
            label: proposedEndDateLabel,
            name: "formLogic.proposedEndDate",
            required: true
          })
        })]
      }), jsx(RadioGroup, {
        label: datesFlexibleLabel,
        name: "formLogic.datesFlexible",
        options: props === null || props === void 0 ? void 0 : props.dateFlexibleOptions,
        required: true
      }), jsx(InputText, {
        label: eventTypeLabel,
        name: "formLogic.eventType"
      }), jsx(InputText, {
        label: eventsBeforeLabel,
        name: "formLogic.eventsBefore"
      }), jsx(InputText, {
        label: hearAboutLabel,
        name: "formLogic.hearAbout"
      }), jsx(TextArea, {
        label: commentsLabel,
        name: "formLogic.comments",
        maxLen: props === null || props === void 0 ? void 0 : props.maxCommentLen
      })]
    }), jsx(SubmitButton, {
      text: submitText
    })]
  });
};
var GroupRequestInfo$1 = GroupRequestInfo;

var GroupRequest = function GroupRequest(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.GROUP_REQUEST;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: GroupRequestConfirmation,
    children: jsx(GroupRequestInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$g = ["buttonAmounts", "donationDateButtons", "codes", "country", "give", "givingBtnStyle", "isHonorMemorialPage", "optionProp", "options", "project", "recurringButtonAmounts", "recurringChoiceDay", "recurringToggle", "showHonorMemorialGiving", "usePaypalCaptureOnly"];
var HonorMemorialGivingInfo = function HonorMemorialGivingInfo(_ref) {
  var buttonAmounts = _ref.buttonAmounts,
    _ref$donationDateButt = _ref.donationDateButtons,
    donationDateButtons = _ref$donationDateButt === void 0 ? false : _ref$donationDateButt,
    _ref$codes = _ref.codes,
    codes = _ref$codes === void 0 ? [] : _ref$codes,
    country = _ref.country,
    _ref$give = _ref.give,
    give = _ref$give === void 0 ? true : _ref$give,
    _ref$givingBtnStyle = _ref.givingBtnStyle,
    givingBtnStyle = _ref$givingBtnStyle === void 0 ? {
      bgColor: '#003658',
      textColor: '#ffffff'
    } : _ref$givingBtnStyle,
    _ref$isHonorMemorialP = _ref.isHonorMemorialPage,
    isHonorMemorialPage = _ref$isHonorMemorialP === void 0 ? false : _ref$isHonorMemorialP,
    _ref$optionProp = _ref.optionProp,
    optionProp = _ref$optionProp === void 0 ? {
      whereMostNeeded: 'Where Most Needed'
    } : _ref$optionProp,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    project = _ref.project,
    recurringButtonAmounts = _ref.recurringButtonAmounts,
    recurringChoiceDay = _ref.recurringChoiceDay,
    _ref$recurringToggle = _ref.recurringToggle,
    recurringToggle = _ref$recurringToggle === void 0 ? true : _ref$recurringToggle,
    _ref$showHonorMemoria = _ref.showHonorMemorialGiving,
    showHonorMemorialGiving = _ref$showHonorMemoria === void 0 ? false : _ref$showHonorMemoria,
    _ref$usePaypalCapture = _ref.usePaypalCaptureOnly,
    usePaypalCaptureOnly = _ref$usePaypalCapture === void 0 ? true : _ref$usePaypalCapture,
    props = _objectWithoutProperties(_ref, _excluded$g);
  var _useHonorMemorialGivi = useHonorMemorialGiving({
      country: country,
      isHonorMemorialPage: isHonorMemorialPage
    }),
    checkBoxLabel = _useHonorMemorialGivi.checkBoxLabel,
    hasHonorMemorial = _useHonorMemorialGivi.hasHonorMemorial,
    honorCopy = _useHonorMemorialGivi.honorCopy,
    honorMemorialOptions = _useHonorMemorialGivi.honorMemorialOptions,
    isBlankCard = _useHonorMemorialGivi.isBlankCard,
    labelInfo = _useHonorMemorialGivi.labelInfo,
    mailNotificationLabel = _useHonorMemorialGivi.mailNotificationLabel,
    memorialCopy = _useHonorMemorialGivi.memorialCopy,
    nameDisplayLabel = _useHonorMemorialGivi.nameDisplayLabel,
    productIndex = _useHonorMemorialGivi.productIndex,
    showInMemory = _useHonorMemorialGivi.showInMemory;
  var _useSingleDonation = useSingleDonation({
      options: options,
      codes: codes,
      optionProp: optionProp,
      recurringToggle: recurringToggle,
      usePaypalCaptureOnly: usePaypalCaptureOnly
    }),
    displayPaymentMethod = _useSingleDonation.displayPaymentMethod,
    giveButton = _useSingleDonation.giveButton;
  return jsxs(Container$1, {
    className: "bgform-single-donation-container",
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: "Type of Gift",
      formSectionFields: jsxs(Fragment, {
        children: [showHonorMemorialGiving && !isHonorMemorialPage && jsx(Checkbox, {
          label: checkBoxLabel,
          name: "formLogic.hasHonorMemorial"
        }), (hasHonorMemorial || isHonorMemorialPage) && jsxs(Block, {
          children: [jsx(Dropdown, {
            label: "",
            name: "formLogic.honorMemorialOption",
            options: honorMemorialOptions
          }), jsx(Checkbox, {
            label: "Send Blank Card to Me",
            name: "formLogic.isBlankCard"
          }), !isBlankCard && jsx(Block, {
            children: jsx(Content, {
              children: jsx(CustomMarkupSection, {
                customMarkup: showInMemory ? memorialCopy : honorCopy
              })
            })
          })]
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: "Honoree Information",
      formSectionFields: !isBlankCard && jsxs(Block, {
        children: [jsx(InputText, {
          name: "collector.cart.products[".concat(productIndex, "].honorMemory.honorMemoryName"),
          label: labelInfo.name,
          required: true
        }), showInMemory && jsx(InputText, {
          name: "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToName"),
          label: mailNotificationLabel,
          required: true
        }), jsx(InputText, {
          name: "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToAddress"),
          label: labelInfo.street,
          required: true
        }), jsxs(Columns, {
          multiline: true,
          children: [jsx(Columns.Column, {
            size: "half",
            children: jsx(InputText, {
              name: "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToCity"),
              label: labelInfo.city,
              required: true
            })
          }), jsx(Columns.Column, {
            size: "half",
            children: jsx(Region, {
              entity: 0,
              name: "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToState"),
              index: 0,
              label: labelInfo.state,
              required: true
            })
          })]
        }), jsx(Block, {
          pt: "2",
          children: jsx(InputText, {
            name: "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToZip"),
            label: labelInfo.postalCode,
            required: true
          })
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: "Your Information",
      formSectionFields: isHonorMemorialPage && jsxs(Fragment, {
        children: [jsx(InputText, {
          name: "collector.cart.products[".concat(productIndex, "].honorMemory.nameOnCard"),
          label: nameDisplayLabel,
          required: true
        }), jsxs(Box, {
          children: [jsx(SingleGift, _objectSpread2(_objectSpread2({}, props), {}, {
            projectId: project.projectId,
            recurringToggle: recurringToggle,
            give: give,
            giveButton: giveButton,
            buttonSize: "medium",
            addToggleClass: "has-text-black",
            buttonAmounts: buttonAmounts,
            donationDateButtons: donationDateButtons,
            recurringButtonAmounts: recurringButtonAmounts,
            recurringChoiceDay: recurringChoiceDay,
            givingBtnStyle: givingBtnStyle
          })), displayPaymentMethod && jsx(PaymentMethod, _objectSpread2(_objectSpread2({}, props), {}, {
            disablePayPalPayment: true,
            displayList: ['Name', 'Email', 'Phone', 'Address']
          }))]
        })]
      }),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var HonorMemorialGivingInfo$1 = HonorMemorialGivingInfo;

function _EMOTION_STRINGIFIED_CSS_ERROR__$6() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ModalContainer = /*#__PURE__*/_styled(Modal, process.env.NODE_ENV === "production" ? {
  target: "e1i4kxwq0"
} : {
  target: "e1i4kxwq0",
  label: "ModalContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "16w6w5b",
  styles: "z-index:999"
} : {
  name: "16w6w5b",
  styles: "z-index:999",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$6
});
var MonthlyDonationModal = function MonthlyDonationModal(_ref) {
  var showModal = _ref.showModal,
    setShowMonthlyModal = _ref.setShowMonthlyModal;
  var _useMonthlyDonationMo = useMonthlyDonationModal({
      showModal: showModal,
      setShowMonthlyModal: setShowMonthlyModal
    }),
    modalIsOpen = _useMonthlyDonationMo.modalIsOpen,
    monthlyModalCopy = _useMonthlyDonationMo.monthlyModalCopy,
    noButtonText = _useMonthlyDonationMo.noButtonText,
    titleText = _useMonthlyDonationMo.titleText,
    yesButtonText = _useMonthlyDonationMo.yesButtonText,
    handleOnCloseModal = _useMonthlyDonationMo.handleOnCloseModal,
    handleOnNoEvent = _useMonthlyDonationMo.handleOnNoEvent,
    handleOnYesEvent = _useMonthlyDonationMo.handleOnYesEvent;
  return jsx(Block, {
    my: 5,
    children: jsx(ModalContainer, {
      show: modalIsOpen,
      onClose: function onClose() {
        return handleOnCloseModal();
      },
      children: jsxs(Modal.Card, {
        children: [jsx(Modal.Card.Header, {
          children: jsx(Modal.Card.Title, {
            children: titleText
          })
        }), jsx(Modal.Card.Body, {
          children: jsx(Content, {
            children: jsx(Container$1, {
              mb: 4,
              children: jsx(Notification, {
                color: "secondary",
                children: jsx("div", {
                  className: "container mb-4",
                  dangerouslySetInnerHTML: {
                    __html: monthlyModalCopy
                  }
                })
              })
            })
          })
        }), jsxs(Modal.Card.Footer, {
          children: [jsx(Button, {
            color: "success",
            onClick: handleOnYesEvent,
            children: yesButtonText
          }), jsx(Button, {
            onClick: handleOnNoEvent,
            children: noButtonText
          })]
        })]
      })
    })
  });
};
var MonthlyDonationModal$1 = MonthlyDonationModal;

var _excluded$f = ["recurringToggle", "optionProp", "options", "give", "donateTitle", "projectId", "codes", "dropDownLabel", "buttonAmounts", "donationDateButtons", "headingLabel", "recurringButtonAmounts", "recurringChoiceDay", "usePaypalCaptureOnly", "uniqueClassName"];
var SingleDonationInfo = function SingleDonationInfo(_ref) {
  var _props$givingAreaInfo, _props$givingAreaInfo2;
  var _ref$recurringToggle = _ref.recurringToggle,
    recurringToggle = _ref$recurringToggle === void 0 ? true : _ref$recurringToggle,
    _ref$optionProp = _ref.optionProp,
    optionProp = _ref$optionProp === void 0 ? {
      whereMostNeeded: 'Where Most Needed'
    } : _ref$optionProp,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$give = _ref.give,
    give = _ref$give === void 0 ? true : _ref$give,
    donateTitle = _ref.donateTitle,
    _ref$projectId = _ref.projectId,
    projectId = _ref$projectId === void 0 ? 0 : _ref$projectId,
    _ref$codes = _ref.codes,
    codes = _ref$codes === void 0 ? [] : _ref$codes,
    _ref$dropDownLabel = _ref.dropDownLabel,
    dropDownLabel = _ref$dropDownLabel === void 0 ? 'Where would you like to give?' : _ref$dropDownLabel,
    buttonAmounts = _ref.buttonAmounts,
    _ref$donationDateButt = _ref.donationDateButtons,
    donationDateButtons = _ref$donationDateButt === void 0 ? false : _ref$donationDateButt,
    _ref$headingLabel = _ref.headingLabel,
    headingLabel = _ref$headingLabel === void 0 ? 'Would you like to give to' : _ref$headingLabel,
    recurringButtonAmounts = _ref.recurringButtonAmounts,
    recurringChoiceDay = _ref.recurringChoiceDay,
    _ref$usePaypalCapture = _ref.usePaypalCaptureOnly,
    usePaypalCaptureOnly = _ref$usePaypalCapture === void 0 ? true : _ref$usePaypalCapture,
    _ref$uniqueClassName = _ref.uniqueClassName,
    uniqueClassName = _ref$uniqueClassName === void 0 ? '' : _ref$uniqueClassName,
    props = _objectWithoutProperties(_ref, _excluded$f);
  var _useSingleDonation = useSingleDonation(_objectSpread2(_objectSpread2({}, props), {}, {
      codes: codes,
      defaultDebitDay: props === null || props === void 0 ? void 0 : props.defaultDebitDay,
      options: options,
      optionProp: optionProp,
      recurringToggle: recurringToggle,
      usePaypalCaptureOnly: usePaypalCaptureOnly
    })),
    displayPaymentMethod = _useSingleDonation.displayPaymentMethod,
    donationOptions = _useSingleDonation.donationOptions,
    giveButton = _useSingleDonation.giveButton,
    selectedDonation = _useSingleDonation.selectedDonation,
    showMonthlyModal = _useSingleDonation.showMonthlyModal,
    hasDonationLocation = _useSingleDonation.hasDonationLocation,
    setShowMonthlyModal = _useSingleDonation.setShowMonthlyModal;
  return jsxs(Fragment, {
    children: [donateTitle && jsx(Heading, {
      size: 3,
      textAlign: "center",
      mb: 6,
      children: donateTitle
    }), jsxs(Container$1, {
      className: "bgform-single-donation-container",
      children: [jsx(FormSection$1, {
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        formSectionHeader: props === null || props === void 0 ? void 0 : props.formSectionHeader,
        hideTopBorder: true,
        formSectionFields: jsxs(Fragment, {
          children: [hasDonationLocation ? jsx(Dropdown, {
            label: dropDownLabel,
            name: "formLogic.donationLocation",
            options: donationOptions,
            required: false,
            useFullWidth: true
          }) : !(props !== null && props !== void 0 && props.hideSelectedDonationLabel) && jsxs(Heading, {
            renderAs: "h2",
            size: 4,
            children: ["".concat(headingLabel, " "), jsx("span", {
              className: "is-italic",
              children: selectedDonation
            }), " ?"]
          }), jsxs(Box, {
            children: [jsx(SingleGift, _objectSpread2(_objectSpread2({}, props), {}, {
              projectId: projectId,
              recurringToggle: recurringToggle,
              give: give,
              giveButton: giveButton,
              uniqueClassName: uniqueClassName,
              buttonSize: "medium",
              addToggleClass: "has-text-black",
              buttonAmounts: buttonAmounts,
              donationDateButtons: donationDateButtons,
              recurringButtonAmounts: recurringButtonAmounts,
              recurringChoiceDay: recurringChoiceDay
            })), displayPaymentMethod && jsx(PaymentMethod, _objectSpread2(_objectSpread2({}, props), {}, {
              displayList: ['Name', 'Email', 'Phone', 'Address']
            }))]
          }), (props === null || props === void 0 ? void 0 : props.enableMonthlyModal) && showMonthlyModal && jsx(MonthlyDonationModal$1, {
            showModal: true,
            setShowMonthlyModal: setShowMonthlyModal
          }), !(props !== null && props !== void 0 && props.hideRecaptchaMessage) && jsx(RecaptchaMessage, _objectSpread2({}, props))]
        }),
        paddingTop: "light"
      }), (props === null || props === void 0 ? void 0 : props.givingAreaInfo) && jsx(FormSection$1, {
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        hideTopBorder: true,
        formSectionClassWrapper: "display-wrapper-submit",
        formSectionFields: jsxs(Content, {
          pt: 3,
          children: [jsx("a", {
            href: props === null || props === void 0 ? void 0 : (_props$givingAreaInfo = props.givingAreaInfo) === null || _props$givingAreaInfo === void 0 ? void 0 : _props$givingAreaInfo.url,
            target: "_blank",
            rel: "noreferrer",
            children: props === null || props === void 0 ? void 0 : (_props$givingAreaInfo2 = props.givingAreaInfo) === null || _props$givingAreaInfo2 === void 0 ? void 0 : _props$givingAreaInfo2.label
          }), "."]
        }),
        paddingTop: "light",
        paddingBottom: "standard"
      })]
    })]
  });
};

var _excluded$e = ["country", "isHonorMemorialPage", "showHonorMemorialGiving"];
var HonorMemorialGivingOldInfo = function HonorMemorialGivingOldInfo(_ref) {
  var country = _ref.country,
    _ref$isHonorMemorialP = _ref.isHonorMemorialPage,
    isHonorMemorialPage = _ref$isHonorMemorialP === void 0 ? false : _ref$isHonorMemorialP,
    _ref$showHonorMemoria = _ref.showHonorMemorialGiving,
    showHonorMemorialGiving = _ref$showHonorMemoria === void 0 ? false : _ref$showHonorMemoria,
    props = _objectWithoutProperties(_ref, _excluded$e);
  var _useHonorMemorialGivi = useHonorMemorialGiving(_objectSpread2({
      country: country,
      isHonorMemorialPage: isHonorMemorialPage
    }, props)),
    blankCopy = _useHonorMemorialGivi.blankCopy,
    checkBoxLabel = _useHonorMemorialGivi.checkBoxLabel,
    hasHonorMemorial = _useHonorMemorialGivi.hasHonorMemorial,
    honorCopy = _useHonorMemorialGivi.honorCopy,
    honorMemorialOptions = _useHonorMemorialGivi.honorMemorialOptions,
    isBlankCard = _useHonorMemorialGivi.isBlankCard,
    labelInfo = _useHonorMemorialGivi.labelInfo,
    mailNotificationLabel = _useHonorMemorialGivi.mailNotificationLabel,
    memorialCopy = _useHonorMemorialGivi.memorialCopy,
    nameDisplayLabel = _useHonorMemorialGivi.nameDisplayLabel,
    productIndex = _useHonorMemorialGivi.productIndex,
    showInMemory = _useHonorMemorialGivi.showInMemory,
    validatePostalCode = _useHonorMemorialGivi.validatePostalCode;
  return jsxs(Container$1, {
    children: [showHonorMemorialGiving && !isHonorMemorialPage && jsx(Checkbox, {
      label: checkBoxLabel,
      name: "formLogic.hasHonorMemorial"
    }), (hasHonorMemorial || isHonorMemorialPage) && jsxs(Block, {
      children: [jsx(Dropdown, {
        label: "",
        name: "formLogic.honorMemorialOption",
        options: honorMemorialOptions
      }), jsx(Checkbox, {
        label: "Send Blank Card to Me",
        name: "formLogic.isBlankCard"
      }), !isBlankCard ? jsxs(Block, {
        children: [jsx(Content, {
          children: jsx(CustomMarkupSection, {
            customMarkup: showInMemory ? memorialCopy : honorCopy
          })
        }), jsx(InputText, {
          name: "collector.cart.products[".concat(productIndex, "].honorMemory.honorMemoryName"),
          label: labelInfo.name,
          required: true
        }), showInMemory && jsx(InputText, {
          name: "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToName"),
          label: mailNotificationLabel,
          required: true
        }), jsx(InputText, {
          name: "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToAddress"),
          label: labelInfo.street,
          required: true
        }), jsx(InputText, {
          name: "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToCity"),
          label: labelInfo.city,
          required: true
        }), jsx(Region, {
          entity: 0,
          name: "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToState"),
          index: 0,
          label: labelInfo.state,
          required: true
        }), jsx(InputText, {
          name: "collector.cart.products[".concat(productIndex, "].honorMemory.mailCardToZip"),
          label: labelInfo.postalCode,
          validate: validatePostalCode,
          required: true
        }), jsx(InputText, {
          name: "collector.cart.products[".concat(productIndex, "].honorMemory.nameOnCard"),
          label: nameDisplayLabel,
          required: true
        })]
      }) : jsx(CustomMarkupSection, {
        customMarkup: blankCopy
      })]
    }), isHonorMemorialPage && jsx(SingleDonationInfo, _objectSpread2({}, props))]
  });
};
var HonorMemorialInfo = HonorMemorialGivingOldInfo;

var HonorMemorialGiving = function HonorMemorialGiving(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.HONOR_MEMORIAL_GIVING;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    shouldNotSetLanguageCode: true,
    SESourceCode: (props === null || props === void 0 ? void 0 : props.SESourceCode) || 'BY000HNRG',
    templateName: templateName,
    Confirmation: Confirmation,
    children: props !== null && props !== void 0 && props.isEmbedSite ? jsx(HonorMemorialGivingInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props)) : jsx(HonorMemorialInfo, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$d = ["minNumGroup", "maxNumGroup", "phoneDisclaimer"];
var HostSeminarInfo = function HostSeminarInfo(_ref) {
  var _props$emailRequired;
  var _ref$minNumGroup = _ref.minNumGroup,
    minNumGroup = _ref$minNumGroup === void 0 ? 10 : _ref$minNumGroup,
    _ref$maxNumGroup = _ref.maxNumGroup,
    maxNumGroup = _ref$maxNumGroup === void 0 ? 1500 : _ref$maxNumGroup,
    _ref$phoneDisclaimer = _ref.phoneDisclaimer,
    phoneDisclaimer = _ref$phoneDisclaimer === void 0 ? '' : _ref$phoneDisclaimer,
    props = _objectWithoutProperties(_ref, _excluded$d);
  var _useHostSeminar = useHostSeminar(_objectSpread2({
      eventDateKey: props === null || props === void 0 ? void 0 : props.eventDateKey,
      maxNumGroup: maxNumGroup,
      minNumGroup: minNumGroup,
      showPrefix: props === null || props === void 0 ? void 0 : props.showPrefix,
      pattern: props === null || props === void 0 ? void 0 : props.pattern,
      transportOptions: props === null || props === void 0 ? void 0 : props.transportOptions
    }, props)),
    aboutYourChurchLabel = _useHostSeminar.aboutYourChurchLabel,
    defaultAddressList = _useHostSeminar.defaultAddressList,
    visibleList = _useHostSeminar.visibleList,
    yourChurchInformationLabel = _useHostSeminar.yourChurchInformationLabel,
    yourInformationLabel = _useHostSeminar.yourInformationLabel;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: yourInformationLabel,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Name$1, {
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          visibleList: visibleList,
          required: true,
          nameTitles: props === null || props === void 0 ? void 0 : props.nameTitles,
          showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel
        }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          addressLabel: props === null || props === void 0 ? void 0 : props.addressLabel,
          addressVisibleList: [],
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          phoneType: (props === null || props === void 0 ? void 0 : props.phoneType) || 'HOME',
          country: props === null || props === void 0 ? void 0 : props.country,
          entity: 0,
          phoneRequired: true,
          phoneFieldName: props === null || props === void 0 ? void 0 : props.phoneFieldName,
          phoneLabel: props === null || props === void 0 ? void 0 : props.phoneLabel,
          mobilePhoneRequired: props === null || props === void 0 ? void 0 : props.mobilePhoneRequired,
          mobilePhoneDisclaimer: props === null || props === void 0 ? void 0 : props.mobilePhoneDisclaimer,
          phoneDisclaimer: phoneDisclaimer,
          socialMediaInputs: (props === null || props === void 0 ? void 0 : props.socialMediaInputs) || [],
          socialPhones: (props === null || props === void 0 ? void 0 : props.socialPhones) || [],
          visibleList: (props === null || props === void 0 ? void 0 : props.displayList) || ['Email', 'Phone'],
          emailRequired: (_props$emailRequired = props === null || props === void 0 ? void 0 : props.emailRequired) !== null && _props$emailRequired !== void 0 ? _props$emailRequired : true,
          required: true
        })), (props === null || props === void 0 ? void 0 : props.disclaimerOptInText) && jsx(Content, {
          textWeight: "bold",
          children: props === null || props === void 0 ? void 0 : props.disclaimerOptInText
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: "Pastor Information",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Name$1, {
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          visibleList: visibleList,
          nameTitles: props === null || props === void 0 ? void 0 : props.nameTitles,
          showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel,
          required: false,
          entity: 1
        }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          addressLabel: props === null || props === void 0 ? void 0 : props.addressLabel,
          addressVisibleList: [],
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          phoneType: (props === null || props === void 0 ? void 0 : props.phoneType) || 'HOME',
          country: props === null || props === void 0 ? void 0 : props.country,
          entity: 1,
          isPrimary: false,
          phoneRequired: false,
          phoneFieldName: props === null || props === void 0 ? void 0 : props.phoneFieldName,
          phoneLabel: props === null || props === void 0 ? void 0 : props.phoneLabel,
          mobilePhoneRequired: false,
          mobilePhoneDisclaimer: props === null || props === void 0 ? void 0 : props.mobilePhoneDisclaimer,
          phoneDisclaimer: phoneDisclaimer,
          socialMediaInputs: (props === null || props === void 0 ? void 0 : props.socialMediaInputs) || [],
          socialPhones: (props === null || props === void 0 ? void 0 : props.socialPhones) || [],
          visibleList: (props === null || props === void 0 ? void 0 : props.displayList) || ['Email', 'Phone'],
          emailRequired: false
        })), (props === null || props === void 0 ? void 0 : props.disclaimerOptInText) && jsx(Content, {
          textWeight: "bold",
          children: props === null || props === void 0 ? void 0 : props.disclaimerOptInText
        })]
      }),
      paddingTop: "light"
    }), (props === null || props === void 0 ? void 0 : props.showChurchInfo) && jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: yourChurchInformationLabel,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
          addressVisibleList: (props === null || props === void 0 ? void 0 : props.churchAddressVisibleList) || defaultAddressList,
          churchAddressLabel: aboutYourChurchLabel,
          country: props === null || props === void 0 ? void 0 : props.country,
          entity: 2,
          orgRoles: props === null || props === void 0 ? void 0 : props.orgRoles,
          orgType: "church",
          relationshipPath: "collector.entity[0]",
          relationshipType: "Church",
          display: ['OrganizationName', 'Phone', 'Website', 'Address'],
          phoneType: (props === null || props === void 0 ? void 0 : props.churchPhoneType) || 'WORK',
          requiredList: ['OrganizationName', 'Phone']
        })), jsx(Content, {
          children: jsx(Dropdown, {
            label: "Seating Capacity for Venue",
            name: "collector.questions[0].answerText",
            options: [{
              value: '500-1000',
              id: '1'
            }, {
              value: '1000-1500',
              id: '2'
            }, {
              value: '1500-2000',
              id: '3'
            }, {
              value: 'over 2000',
              id: '4'
            }],
            required: true
          })
        }), jsx(Content, {
          children: jsx(TextArea, {
            label: "Is there a dining facility? Please describe:",
            name: "collector.questions[1].answerText"
          })
        }), jsx(Content, {
          children: jsx(TextArea, {
            label: "Is this request supported by senior pastoral leadership? Please explain:",
            name: "collector.questions[2].answerText"
          })
        }), jsx(Content, {
          children: jsx(TextArea, {
            label: "Are there other churches in the community interested in helping to host the event? Please list:",
            name: "collector.questions[3].answerText"
          })
        }), jsx(Content, {
          children: jsx(TextArea, {
            label: "How did you find out about hosting a live SHIC event?",
            name: "collector.questions[4].answerText"
          })
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
        color: props !== null && props !== void 0 && props.isNewSubmitButton ? '#1a1a1a' : '',
        isNewSubmitButton: props === null || props === void 0 ? void 0 : props.isNewSubmitButton
      })),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var HostSeminarInfo$1 = HostSeminarInfo;

var HostSeminar = function HostSeminar(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.HOST_SEMINAR;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    shouldNotSetLanguageCode: true,
    children: jsx(HostSeminarInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var IndividualVolunteer = function IndividualVolunteer(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.INDIVIDUAL_VOLUNTEER;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: IndividualVolunteerConfirmation,
    children: jsx(IndividualVolunteerInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$c = ["acceptJesusQuestion", "address1Label", "administrativeRegion", "ageLabel", "churchCity", "churchDistrict", "churchLabel", "churchOptions", "churchStreet", "churcSubCity", "consentStatement", "customRegionList", "decisionOptions", "disableAgeOptin", "faithDescription", "femaleLabel", "findChurchText", "firstTimeOptions", "formCopy", "formHeader", "genderLabel", "isOver16", "maleLabel", "privacyPolicyCopy", "selectOneLabel", "selectOptionText", "showChurchInfo", "showDecisionOptions", "sixteenLabel", "socialMediaInputs", "visibleList"];
var InquirerSection = function InquirerSection(_ref) {
  var acceptJesusQuestion = _ref.acceptJesusQuestion,
    address1Label = _ref.address1Label,
    administrativeRegion = _ref.administrativeRegion,
    ageLabel = _ref.ageLabel,
    churchCity = _ref.churchCity,
    churchDistrict = _ref.churchDistrict,
    churchLabel = _ref.churchLabel,
    churchOptions = _ref.churchOptions,
    churchStreet = _ref.churchStreet,
    churcSubCity = _ref.churcSubCity,
    consentStatement = _ref.consentStatement,
    customRegionList = _ref.customRegionList,
    decisionOptions = _ref.decisionOptions,
    _ref$disableAgeOptin = _ref.disableAgeOptin,
    disableAgeOptin = _ref$disableAgeOptin === void 0 ? false : _ref$disableAgeOptin,
    faithDescription = _ref.faithDescription,
    femaleLabel = _ref.femaleLabel,
    findChurchText = _ref.findChurchText,
    firstTimeOptions = _ref.firstTimeOptions,
    formCopy = _ref.formCopy,
    formHeader = _ref.formHeader,
    genderLabel = _ref.genderLabel,
    isOver16 = _ref.isOver16,
    maleLabel = _ref.maleLabel,
    privacyPolicyCopy = _ref.privacyPolicyCopy,
    selectOneLabel = _ref.selectOneLabel,
    selectOptionText = _ref.selectOptionText,
    showChurchInfo = _ref.showChurchInfo,
    showDecisionOptions = _ref.showDecisionOptions,
    sixteenLabel = _ref.sixteenLabel,
    socialMediaInputs = _ref.socialMediaInputs,
    visibleList = _ref.visibleList,
    props = _objectWithoutProperties(_ref, _excluded$c);
  var PrivacyPolicyCopy = privacyPolicyCopy;
  return jsx(Container$1, {
    children: jsxs(Fragment, {
      children: [jsx(FormSection$1, {
        formSectionHeader: formHeader,
        isFormHeader: true,
        hideTopBorder: true
      }), !disableAgeOptin && jsx(FormSection$1, {
        formSectionFields: jsxs(Fragment, {
          children: [formCopy && jsx(Block, {
            children: formCopy
          }), jsx(Block, {
            children: jsx(Checkbox, {
              id: "formLogic.isOver16",
              name: "formLogic.isOver16",
              label: "".concat(String(sixteenLabel), "*"),
              isRequired: true
            })
          })]
        })
      }), (isOver16 || disableAgeOptin) && jsxs(Fragment, {
        children: [jsx(FormSection$1, {
          formSectionFields: jsxs(Fragment, {
            children: [jsx(Block, {
              children: jsx(RadioGroup, {
                display: "is-block",
                label: acceptJesusQuestion,
                name: "formLogic.firstTimeAcceptanceAttribute",
                options: firstTimeOptions !== null && firstTimeOptions !== void 0 ? firstTimeOptions : [],
                required: true
              })
            }), showDecisionOptions && jsx(Block, {
              children: jsx(RadioGroup, {
                display: "is-block",
                label: faithDescription,
                name: "formLogic.decisionOption",
                options: decisionOptions
              })
            }), jsx(Name$1, {
              visibleList: visibleList,
              showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel,
              required: true
            }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
              socialMediaInputs: socialMediaInputs || [],
              visibleList: (props === null || props === void 0 ? void 0 : props.displayList) || ['Phone', 'SocialMediaInputs', 'Address'],
              showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel,
              emailRequired: true,
              required: true
            })), (props === null || props === void 0 ? void 0 : props.disclaimerOptInText) && jsx(Content, {
              textWeight: "bold",
              children: props === null || props === void 0 ? void 0 : props.disclaimerOptInText
            }), (props === null || props === void 0 ? void 0 : props.showGenderOptons) && jsx(Block, {
              children: jsx(Dropdown, {
                label: genderLabel,
                name: "collector.entity[0].gender",
                options: [{
                  value: "".concat(String(selectOneLabel)),
                  id: ''
                }, {
                  value: "".concat(String(femaleLabel)),
                  id: 'F'
                }, {
                  value: "".concat(String(maleLabel)),
                  id: 'M'
                }],
                required: true
              })
            }), jsx(Block, {
              children: jsx(Columns, {
                children: jsx(Columns.Column, {
                  size: "one-third",
                  children: jsx(InputNumber, {
                    label: ageLabel,
                    name: "formLogic.age",
                    required: true
                  })
                })
              })
            }), jsx(Block, {
              children: jsx(Heading, {
                subtitle: true,
                renderAs: "h2",
                children: props === null || props === void 0 ? void 0 : props.addressText
              })
            }), jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
              address1Label: address1Label,
              autoComplete: false,
              country: props === null || props === void 0 ? void 0 : props.country,
              entity: 0,
              index: 0,
              label: "",
              required: true,
              stateLabel: administrativeRegion,
              customRegionList: customRegionList,
              showLabel: false,
              type: "MAIL",
              visibleList: props === null || props === void 0 ? void 0 : props.addressVisibleList
            })), jsx(Block, {
              mt: 4,
              children: jsx(RadioGroup, {
                display: "is-block",
                label: "".concat(String(findChurchText), " ").concat(String(selectOptionText)),
                name: "formLogic.churchOption",
                options: churchOptions,
                required: true
              })
            }), showChurchInfo && jsxs(Fragment, {
              children: [jsx(InputText, {
                name: "collector.entity[0].inquirerData.churchName",
                label: churchLabel,
                required: true
              }), jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
                name: "formLogic.churchInfo",
                autoComplete: false,
                country: props === null || props === void 0 ? void 0 : props.country,
                entity: 0,
                index: 0,
                label: "",
                required: true,
                customRegionList: customRegionList,
                showLabel: false,
                type: "MAIL",
                stateLabel: administrativeRegion,
                cityLabel: churchCity,
                subCityLabel: churcSubCity,
                districtLabel: churchDistrict,
                address1Label: churchStreet,
                visibleList: props === null || props === void 0 ? void 0 : props.addressVisibleList
              }))]
            })]
          }),
          hideTopBorder: true,
          paddingTop: "light"
        }), jsx(FormSection$1, {
          isEmbedSite: false,
          formSectionFields: jsx(Fragment, {
            children: privacyPolicyCopy ? jsx(Box, {
              mx: 1,
              my: 5,
              children: jsx(PrivacyPolicyCopy, {})
            }) : jsx(Block, {
              mt: 4,
              children: consentStatement
            })
          }),
          paddingTop: "light"
        }), jsx(FormSection$1, {
          isEmbedSite: false,
          hideTopBorder: true,
          formSectionClassWrapper: "display-wrapper-submit",
          formSectionFields: jsx(SubmitButton, _objectSpread2({}, props)),
          paddingTop: "light",
          paddingBottom: "standard"
        })]
      })]
    })
  });
};

var InquirerResponseInfo = function InquirerResponseInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useInquirerResponse = useInquirerResponse(_objectSpread2({}, props)),
    acceptJesusQuestion = _useInquirerResponse.acceptJesusQuestion,
    address1Label = _useInquirerResponse.address1Label,
    administrativeRegion = _useInquirerResponse.administrativeRegion,
    ageLabel = _useInquirerResponse.ageLabel,
    churchCity = _useInquirerResponse.churchCity,
    churchDistrict = _useInquirerResponse.churchDistrict,
    churchLabel = _useInquirerResponse.churchLabel,
    churchOptions = _useInquirerResponse.churchOptions,
    churchStreet = _useInquirerResponse.churchStreet,
    churcSubCity = _useInquirerResponse.churcSubCity,
    consentStatement = _useInquirerResponse.consentStatement,
    customRegionList = _useInquirerResponse.customRegionList,
    decisionOptions = _useInquirerResponse.decisionOptions,
    faithDescription = _useInquirerResponse.faithDescription,
    femaleLabel = _useInquirerResponse.femaleLabel,
    findChurchText = _useInquirerResponse.findChurchText,
    firstTimeOptions = _useInquirerResponse.firstTimeOptions,
    formCopy = _useInquirerResponse.formCopy,
    formHeader = _useInquirerResponse.formHeader,
    genderLabel = _useInquirerResponse.genderLabel,
    isOver16 = _useInquirerResponse.isOver16,
    language = _useInquirerResponse.language,
    maleLabel = _useInquirerResponse.maleLabel,
    privacyPolicyCopy = _useInquirerResponse.privacyPolicyCopy,
    selectOneLabel = _useInquirerResponse.selectOneLabel,
    selectOptionText = _useInquirerResponse.selectOptionText,
    showChurchInfo = _useInquirerResponse.showChurchInfo,
    showDecisionOptions = _useInquirerResponse.showDecisionOptions,
    sixteenLabel = _useInquirerResponse.sixteenLabel,
    socialMediaInputs = _useInquirerResponse.socialMediaInputs,
    thirteenLabel = _useInquirerResponse.thirteenLabel;
  return jsxs(Container$1, {
    children: [!(props !== null && props !== void 0 && props.disableLanguageOption) && jsx(Dropdown, {
      name: "formLogic.languageSelector",
      label: "Please select your language",
      required: true,
      options: [{
        id: '',
        value: 'Select'
      }, {
        id: 'en',
        value: 'English'
      }, {
        id: 'amh',
        value: 'Amharic'
      }]
    }), props !== null && props !== void 0 && props.disableLanguageOption ? jsx(InquirerSection, _objectSpread2(_objectSpread2({}, props), {}, {
      acceptJesusQuestion: acceptJesusQuestion,
      address1Label: address1Label,
      administrativeRegion: administrativeRegion,
      ageLabel: ageLabel,
      churchCity: churchCity,
      churchDistrict: churchDistrict,
      churchLabel: churchLabel,
      churchOptions: props === null || props === void 0 ? void 0 : props.churchOptions,
      churchStreet: churchStreet,
      churcSubCity: churcSubCity,
      consentStatement: consentStatement,
      decisionOptions: props === null || props === void 0 ? void 0 : props.decisionOptions,
      disableAgeOptin: props === null || props === void 0 ? void 0 : props.disableAgeOptin,
      disclaimerOptInText: props === null || props === void 0 ? void 0 : props.disclaimerOptInText,
      faithDescription: faithDescription,
      femaleLabel: femaleLabel,
      findChurchText: findChurchText,
      firstTimeOptions: props === null || props === void 0 ? void 0 : props.firstTimeOptions,
      formCopy: props === null || props === void 0 ? void 0 : props.formCopy,
      formHeader: formHeader,
      genderLabel: genderLabel,
      isOver16: isOver16,
      maleLabel: maleLabel,
      selectOneLabel: selectOneLabel,
      selectOptionText: selectOptionText,
      showChurchInfo: showChurchInfo,
      showDecisionOptions: showDecisionOptions,
      sixteenLabel: (props === null || props === void 0 ? void 0 : props.ageLimitLabel) || thirteenLabel,
      socialMediaInputs: socialMediaInputs
    })) : language && jsx(InquirerSection, _objectSpread2(_objectSpread2({}, props), {}, {
      acceptJesusQuestion: acceptJesusQuestion,
      address1Label: address1Label,
      administrativeRegion: administrativeRegion,
      ageLabel: ageLabel,
      churcSubCity: churcSubCity,
      churchCity: churchCity,
      churchDistrict: churchDistrict,
      churchLabel: churchLabel,
      churchOptions: churchOptions,
      churchStreet: churchStreet,
      consentStatement: consentStatement,
      customRegionList: customRegionList,
      decisionOptions: decisionOptions,
      disableAgeOptin: props === null || props === void 0 ? void 0 : props.disableAgeOptin,
      faithDescription: faithDescription,
      femaleLabel: femaleLabel,
      findChurchText: findChurchText,
      firstTimeOptions: firstTimeOptions,
      formCopy: formCopy,
      formHeader: formHeader,
      genderLabel: genderLabel,
      isOver16: isOver16,
      maleLabel: maleLabel,
      privacyPolicyCopy: privacyPolicyCopy,
      selectOneLabel: selectOneLabel,
      selectOptionText: selectOptionText,
      showChurchInfo: showChurchInfo,
      showDecisionOptions: showDecisionOptions,
      sixteenLabel: (props === null || props === void 0 ? void 0 : props.ageLimitLabel) || sixteenLabel,
      socialMediaInputs: socialMediaInputs
    }))]
  });
};
var InquirerResponseInfo$1 = InquirerResponseInfo;

var InquirerResponse = function InquirerResponse(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.INQUIRER_RESPONSE;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(InquirerResponseInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$b = ["disableSubmitButton", "emailRequired"];
var LandingPageInfo = function LandingPageInfo(_ref) {
  var _values$formLogic;
  var _ref$disableSubmitBut = _ref.disableSubmitButton,
    disableSubmitButton = _ref$disableSubmitBut === void 0 ? false : _ref$disableSubmitBut,
    _ref$emailRequired = _ref.emailRequired,
    emailRequired = _ref$emailRequired === void 0 ? true : _ref$emailRequired,
    props = _objectWithoutProperties(_ref, _excluded$b);
  var _useLandingPage = useLandingPage(_objectSpread2({
      maxPostalCodeLength: props === null || props === void 0 ? void 0 : props.maxPostalCodeLength,
      minPostalCodeLength: props === null || props === void 0 ? void 0 : props.minPostalCodeLength,
      disableOptinLogic: props === null || props === void 0 ? void 0 : props.disableOptinLogic
    }, props)),
    isDisabled = _useLandingPage.isDisabled,
    privacyPolicyTextLabel = _useLandingPage.privacyPolicyTextLabel,
    visibleList = _useLandingPage.visibleList,
    validatePostalCode = _useLandingPage.validatePostalCode,
    values = _useLandingPage.values;
  var _useFormatAddress = useFormatAddress(_objectSpread2({
      entity: 0,
      index: 0,
      label: (props === null || props === void 0 ? void 0 : props.addressLabel) || '',
      name: "collector.entity[0].address[0]"
    }, props)),
    validateInput = _useFormatAddress.validateInput;
  return jsxs(Container$1, {
    children: [jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Name$1, _objectSpread2(_objectSpread2({}, props), {}, {
          visibleList: (props === null || props === void 0 ? void 0 : props.visibleList) || visibleList,
          required: true,
          showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel
        })), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          visibleList: (props === null || props === void 0 ? void 0 : props.entityVisibleList) || ['Email'],
          showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel,
          emailRequired: emailRequired,
          phoneRequired: props === null || props === void 0 ? void 0 : props.phoneRequired,
          required: true
        })), (props === null || props === void 0 ? void 0 : props.addressCopy) && jsx(Content, {
          children: jsx("div", {
            dangerouslySetInnerHTML: {
              __html: props === null || props === void 0 ? void 0 : props.addressCopy
            }
          })
        }), (props === null || props === void 0 ? void 0 : props.showProductOption) && jsx(Checkbox, {
          isChecked: false,
          label: (props === null || props === void 0 ? void 0 : props.productOptionLabel) || 'I would like my free resources sent via U.S. Mail',
          name: "formLogic.physicalProduct",
          id: "formLogic.physicalProduct"
        }), (props === null || props === void 0 ? void 0 : props.showCountryField) && jsx(Country, {
          name: "collector.entity[0].address[0].country",
          entity: 0,
          index: 0,
          country: props === null || props === void 0 ? void 0 : props.country,
          validate: validateInput,
          required: true,
          showAllCountries: true
        }), !(props !== null && props !== void 0 && props.hideAddressComponent) && ((values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.physicalProduct) || !(props !== null && props !== void 0 && props.showProductOption)) && jsx(Content, {
          pb: 3,
          children: jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
            autoComplete: false,
            country: props === null || props === void 0 ? void 0 : props.country,
            entity: 0,
            index: 0,
            label: (props === null || props === void 0 ? void 0 : props.addressLabel) || '',
            required: true,
            showLabel: (props === null || props === void 0 ? void 0 : props.addressShowLabel) || false,
            type: "MAIL",
            visibleList: props === null || props === void 0 ? void 0 : props.addressVisible,
            validate: validatePostalCode
          }))
        }), (props === null || props === void 0 ? void 0 : props.provideInfoText) && jsx(Content, {
          children: props === null || props === void 0 ? void 0 : props.provideInfoText
        }), (props === null || props === void 0 ? void 0 : props.show18Checkbox) && jsx(Content, {
          children: jsx(Checkbox, {
            isChecked: props === null || props === void 0 ? void 0 : props.isChecked,
            label: props === null || props === void 0 ? void 0 : props.checkBox18Text,
            name: "collector.entity[0].over18",
            isRequired: true,
            title: ""
          })
        }), (props === null || props === void 0 ? void 0 : props.checkboxText) && jsx(Checkbox, {
          isChecked: props === null || props === void 0 ? void 0 : props.isChecked,
          labelHtml: props === null || props === void 0 ? void 0 : props.checkboxText,
          name: "formLogic.optIn",
          title: ""
        })]
      }),
      paddingTop: "light"
    }), (props === null || props === void 0 ? void 0 : props.privacyPolicyCopy) && jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: props !== null && props !== void 0 && props.isEmbedSite ? privacyPolicyTextLabel : '',
      formSectionFields: jsxs(Content, {
        children: [jsx("div", {
          dangerouslySetInnerHTML: {
            __html: props === null || props === void 0 ? void 0 : props.privacyPolicyCopy
          }
        }), ' ']
      })
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
        color: "primary",
        isDisabled: isDisabled || disableSubmitButton,
        className: "is-pulled-right",
        text: (props === null || props === void 0 ? void 0 : props.buttonText) || 'Submit'
      })),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var LandingPageInfo$1 = LandingPageInfo;

var LandingPage = function LandingPage(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.LANDING_PAGE;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    shouldNotSetLanguageCode: true,
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(LandingPageInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var LandingPageResponseInfo = function LandingPageResponseInfo(_ref) {
  var _props$decisionOption;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useLandingPageRespon = useLandingPageResponse(_objectSpread2({}, props)),
    decisionLabel = _useLandingPageRespon.decisionLabel,
    decisionOptions = _useLandingPageRespon.decisionOptions,
    disableSubmitButton = _useLandingPageRespon.disableSubmitButton,
    isUrlOption = _useLandingPageRespon.isUrlOption,
    values = _useLandingPageRespon.values;
  return jsxs(Container$1, {
    children: [jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionFields: jsxs(Fragment, {
        children: [(props === null || props === void 0 ? void 0 : props.responseFormCopy) && jsxs(Content, {
          children: [jsx("div", {
            dangerouslySetInnerHTML: {
              __html: props === null || props === void 0 ? void 0 : props.responseFormCopy
            }
          }), ' ']
        }), ((props === null || props === void 0 ? void 0 : (_props$decisionOption = props.decisionOptions) === null || _props$decisionOption === void 0 ? void 0 : _props$decisionOption.length) > 0 || (decisionOptions === null || decisionOptions === void 0 ? void 0 : decisionOptions.length) > 0) && jsx(RadioGroup, {
          display: "is-block",
          label: (props === null || props === void 0 ? void 0 : props.decisionLabel) || decisionLabel,
          name: "formLogic.decisionOption",
          options: (props === null || props === void 0 ? void 0 : props.decisionOptions) || decisionOptions
        })]
      })
    }), ((props === null || props === void 0 ? void 0 : props.showLandingPageInfo) || values.formLogic.decisionOption && !isUrlOption) && jsx(LandingPageInfo$1, _objectSpread2(_objectSpread2({}, props), {}, {
      disableSubmitButton: disableSubmitButton
    }))]
  });
};
var LandingPageResponseInfo$1 = LandingPageResponseInfo;

var LandingPageResponse = function LandingPageResponse(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.LANDING_PAGE;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    shouldNotSetLanguageCode: true,
    Confirmation: Confirmation,
    children: jsx(LandingPageResponseInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var AdditionalInfo = function AdditionalInfo(_ref) {
  var options = _ref.options,
    showChurchSupport = _ref.showChurchSupport,
    showOpening = _ref.showOpening;
  return jsx("div", {
    className: "columns",
    children: jsxs("div", {
      className: "column",
      children: [jsxs(Fragment, {
        children: [jsx(TextArea, {
          label: "How would attending LEAP Alaska benefit you and your spouse?*",
          name: "newQuestionsLeap.leapBenefit",
          required: true
        }), jsx(RadioGroup, {
          label: "Does your support system include a church?*",
          name: "formLogic.churchSupport",
          options: options,
          required: true
        }), showChurchSupport ? jsx(Church, {
          addressType: "PHYSICAL",
          addressVisibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode'],
          country: ['US'],
          display: ['OrganizationName', 'Address'],
          entity: 2,
          orgType: "church",
          relationshipPath: "collector.entity[2]",
          relationshipType: "Church",
          requiredList: ['OrganizationName']
        }) : jsx(Fragment, {}), jsx(TextArea, {
          label: "Please list any other counseling/programs previously attended",
          name: "newQuestionsLeap.counselling"
        }), jsx(RadioGroup, {
          label: "Obviously, there is limited space each week. Often there are last minute cancellations. In the event that an opening would occur, would you be available to participate last minute?*",
          name: "formLogic.opening",
          options: options,
          required: true
        }), showOpening ? jsx(TextArea, {
          label: "Would there be any major conflicts in receiving a last minute invitation?",
          name: "newQuestionsLeap.conflict"
        }) : jsx(Fragment, {})]
      }), jsx("hr", {})]
    })
  });
};

var IncidentInfo = function IncidentInfo(_ref) {
  var options = _ref.options,
    showEquipment = _ref.showEquipment;
  return jsx("div", {
    className: "columns",
    children: jsx("div", {
      className: "column",
      children: jsxs(Fragment, {
        children: [jsx("div", {
          style: {
            fontWeight: 'bold'
          },
          children: "Incident Information"
        }), jsx("br", {}), jsx(DateCalendar, {
          label: "Date of Injury or Incident*",
          name: "formLogic.leapDates.injuryDate",
          required: true
        }), jsx(InputText, {
          name: "newQuestionsLeap.injuryDept",
          label: "Department at the Time of Injury or Incident*",
          required: true
        }), jsx(TextArea, {
          label: "Injury or Injuries and Related Restrictions",
          name: "newQuestionsLeap.injury"
        }), jsx(TextArea, {
          label: "Current Medical Treatment plan",
          name: "newQuestionsLeap.treatment"
        }), jsx(RadioGroup, {
          label: "Do you rely on any special medical equipment?*",
          name: "formLogic.equipment",
          options: options,
          required: true
        }), jsx("p", {
          children: "LEAP Alaska operates in a remote region of the Alaska wilderness, where access to special medical devices and equipment could be limited."
        }), showEquipment ? jsx(TextArea, {
          label: "Please Describe Special Equipment Needs",
          name: "newQuestionsLeap.equipmentNeedsDesc"
        }) : jsx(Fragment, {}), jsx(TextArea, {
          label: "Please provide details about your incident.*",
          name: "newQuestionsLeap.incident",
          required: true
        }), jsx("hr", {})]
      })
    })
  });
};

var Married = function Married(_ref) {
  var options = _ref.options;
  return jsx("div", {
    className: "columns",
    children: jsx("div", {
      className: "column",
      children: jsxs(Fragment, {
        children: [jsx(DateCalendar, {
          label: "Married Date*",
          name: "formLogic.leapDates.marriedDate",
          required: true
        }), jsxs(Fragment, {
          children: [jsx(InputText, {
            name: "newQuestionsLeap.marriageLoc",
            label: "City, County, State of where you were married"
          }), jsx(RadioGroup, {
            label: "Previously Applied?",
            name: "newQuestionsLeap.prevApplied",
            options: options
          })]
        }), jsx("hr", {})]
      })
    })
  });
};

var _excluded$a = ["genderOptions", "maxDate"];
var OfficerInfo = function OfficerInfo(_ref) {
  var genderOptions = _ref.genderOptions,
    maxDate = _ref.maxDate,
    props = _objectWithoutProperties(_ref, _excluded$a);
  return jsx(Columns, {
    children: jsxs(Columns.Column, {
      children: [jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
        entity: 0,
        emailRequired: true,
        required: true,
        visibleList: ['Name', 'Address', 'Phone', 'SocialPhones', 'Email'],
        addressVisibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode'],
        phoneType: "HOME",
        visibleName: ['firstName', 'lastName', 'preferredName']
      })), jsx("p", {
        children: "Please do not use a government or military address."
      }), jsx(DateCalendar, {
        label: "Date of Birth*",
        name: "collector.entity[0].date[0].value",
        maxDate: maxDate,
        dateFormat: "MM/dd/yyyy",
        required: true
      }), jsx(RadioGroup, {
        label: "Gender*",
        name: "collector.entity[0].gender",
        options: genderOptions,
        required: true
      }), jsx("hr", {})]
    })
  });
};

var ServiceDetails = function ServiceDetails(_ref) {
  var options = _ref.options,
    retiredOptions = _ref.retiredOptions,
    showRetiredInfo = _ref.showRetiredInfo;
  return jsx("div", {
    className: "columns",
    children: jsx("div", {
      className: "column",
      children: jsxs(Fragment, {
        children: [jsx(RadioGroup, {
          label: "Are you active or retired?*",
          name: "formLogic.retired",
          options: retiredOptions,
          required: true
        }), jsx(InputText, {
          name: "newQuestionsLeap.dept",
          label: "Current or Last Department*",
          required: true
        }), jsx(RadioGroup, {
          label: "Are you a sworn officer with power of arrest?*",
          name: "newQuestionsLeap.swornOfficer",
          options: options,
          required: true
        }), showRetiredInfo ? jsx(DateCalendar, {
          label: "Retirement Date*",
          name: "formLogic.leapDates.retiredDate",
          required: true
        }) : jsx(Fragment, {}), jsx(DateCalendar, {
          label: "Start Date of Service*",
          name: "formLogic.leapDates.serviceDate",
          required: true
        }), jsx("hr", {})]
      })
    })
  });
};

var _excluded$9 = ["genderOptions", "marriageStateOptions", "maxDate", "options", "retiredOptions", "showSpouseInfo", "showSpouseMedical", "showSpouseTreatment"];
var SpouseInfo = function SpouseInfo(_ref) {
  var genderOptions = _ref.genderOptions,
    marriageStateOptions = _ref.marriageStateOptions,
    maxDate = _ref.maxDate,
    options = _ref.options,
    retiredOptions = _ref.retiredOptions,
    showSpouseInfo = _ref.showSpouseInfo,
    showSpouseMedical = _ref.showSpouseMedical,
    showSpouseTreatment = _ref.showSpouseTreatment,
    props = _objectWithoutProperties(_ref, _excluded$9);
  return jsx("div", {
    className: "columns",
    children: jsx("div", {
      className: "column",
      children: jsxs(Fragment, {
        children: [jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          entity: 1,
          emailRequired: true,
          isPrimary: false,
          required: true,
          visibleList: ['Name', 'Phone', 'SocialPhones', 'Email'],
          visibleName: ['firstName', 'lastName', 'preferredName']
        })), jsx("p", {
          children: "Please do not use a government or military address."
        }), jsx(DateCalendar, {
          label: "Date of Birth*",
          name: "collector.entity[1].date[0].value",
          maxDate: maxDate,
          dateFormat: "MM/dd/yyyy",
          required: true
        }), jsx(RadioGroup, {
          label: "Gender*",
          name: "collector.entity[1].gender",
          options: genderOptions,
          required: true
        }), jsx(RadioGroup, {
          label: "Is your spouse a law enforcement officer?*",
          name: "formLogic.spouseOfficer",
          options: options,
          required: true
        }), showSpouseInfo ? jsxs(Fragment, {
          children: [jsx(TextArea, {
            label: "Spouse's Department*",
            name: "newQuestionsLeap.spouseDept",
            required: true
          }), jsx(RadioGroup, {
            label: "Is your spouse Active or Retired?*",
            name: "newQuestionsLeap.spouseActive",
            options: retiredOptions,
            required: true
          })]
        }) : jsx(Fragment, {}), jsx(RadioGroup, {
          label: "Does your spouse have any specific medical issues?*",
          name: "formLogic.spouseMedical",
          options: options,
          required: true
        }), showSpouseMedical ? jsx(TextArea, {
          label: "Please describe your spouse's medical issues*",
          name: "newQuestionsLeap.spouseMedicalDesc",
          required: true
        }) : jsx(Fragment, {}), jsx(RadioGroup, {
          label: "Is your spouse receiving medical treatment? Or, do they have any specific medical needs?*",
          name: "formLogic.spouseTreatment",
          options: options,
          required: true
        }), showSpouseTreatment ? jsx(TextArea, {
          label: "Please describe your spouse's medical needs.*",
          name: "newQuestionsLeap.spouseNeeds",
          required: true
        }) : jsx(Fragment, {}), jsx(RadioGroup, {
          label: "Which best describes the current state of your marriage?*",
          name: "newQuestionsLeap.marriageStateCat",
          options: marriageStateOptions,
          required: true
        }), jsx(TextArea, {
          label: "Please describe the current state of your marriage.*",
          name: "newQuestionsLeap.marriageState",
          required: true
        }), jsx("hr", {})]
      })
    })
  });
};

var LeapInfo = function LeapInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useLeap = useLeap(),
    genderOptions = _useLeap.genderOptions,
    maxDate = _useLeap.maxDate,
    marriageStateOptions = _useLeap.marriageStateOptions,
    notMarriedText = _useLeap.notMarriedText,
    options = _useLeap.options,
    retiredOptions = _useLeap.retiredOptions,
    showChurchSupport = _useLeap.showChurchSupport,
    showEquipment = _useLeap.showEquipment,
    showFormDetails = _useLeap.showFormDetails,
    showOpening = _useLeap.showOpening,
    showRetiredInfo = _useLeap.showRetiredInfo,
    showSpouseInfo = _useLeap.showSpouseInfo,
    showSpouseMedical = _useLeap.showSpouseMedical,
    showSpouseTreatment = _useLeap.showSpouseTreatment;
  return jsxs(Container$1, {
    children: [jsx(RadioGroup, {
      label: "Are you currently married?*",
      name: "formLogic.marriedOption",
      options: options
    }), showFormDetails ? jsxs(Fragment, {
      children: [jsx(Married, {
        options: options
      }), jsx(OfficerInfo, _objectSpread2(_objectSpread2({}, props), {}, {
        genderOptions: genderOptions,
        maxDate: maxDate
      })), jsx(FileUpload, {
        id: "leapinfo",
        label: "8. Upload any documentation or file you have of the misconduct.*",
        required: true
      }), jsx(ServiceDetails, {
        options: options,
        retiredOptions: retiredOptions,
        showRetiredInfo: showRetiredInfo
      }), jsx(IncidentInfo, {
        options: options,
        showEquipment: showEquipment
      }), jsx(SpouseInfo, _objectSpread2(_objectSpread2({}, props), {}, {
        genderOptions: genderOptions,
        marriageStateOptions: marriageStateOptions,
        maxDate: maxDate,
        options: options,
        retiredOptions: retiredOptions,
        showSpouseInfo: showSpouseInfo,
        showSpouseMedical: showSpouseMedical,
        showSpouseTreatment: showSpouseTreatment
      })), jsx(AdditionalInfo, {
        options: options,
        showChurchSupport: showChurchSupport,
        showOpening: showOpening
      }), jsxs(Content, {
        children: ["To effectively deliver this program, Billy Graham Evangelistic Association, through our Law Enforcement Ministry, may collect, process, store, and/or disclose your personal data in accordance with our", ' ', jsx("a", {
          href: "https://billygraham.org/privacy-policy/",
          children: "Privacy Policy"
        })]
      }), jsx(Acknowledgement, {
        label: "Consent*",
        required: true,
        name: "formLogic.acknowledgement",
        children: "The Billy Graham Evangelistic Association Law Enforcement Ministry cares deeply about protecting your personal information. Any injury information provided on this application will be used for the sole purpose of determining eligibility to the program and may be used by our staff in supporting you at Mystic Lake Lodge, Alaska if you are selected for the program."
      }), jsx(SubmitButton, {})]
    }) : jsx(Content, {
      children: notMarriedText
    })]
  });
};
var LeapInfo$1 = LeapInfo;

var LeapMarriageRetreat = function LeapMarriageRetreat(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.LEAP_RETREAT_MARRIAGE;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    shouldNotSetLanguageCode: true,
    Confirmation: Confirmation,
    children: jsx(LeapInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var LegacyPlanningInfo = function LegacyPlanningInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useLegacyPlanning = useLegacyPlanning(),
    isOptionSelected = _useLegacyPlanning.isOptionSelected,
    plannerOptionsLabel = _useLegacyPlanning.plannerOptionsLabel;
  return jsxs(Fragment, {
    children: [jsxs(Container$1, {
      children: [jsx(Content, {
        children: jsx("legend", {
          children: plannerOptionsLabel
        })
      }), jsx(Checkbox, {
        labelHtml: "Yes, send me my free Legacy Planner.",
        name: "formLogic.legacyPlanningPlanner",
        title: ""
      }), jsx(Checkbox, {
        labelHtml: "Yes, I would like to speak with a ministry representative about planned gift options.",
        name: "formLogic.legacyPlanningGift",
        title: ""
      }), jsx(Checkbox, {
        labelHtml: "Yes, I have made a gift to BGEA through my estate plans.",
        name: "formLogic.legacyPlanningEstatePlans",
        title: ""
      })]
    }), jsx(LandingPageInfo$1, _objectSpread2(_objectSpread2({}, props), {}, {
      disableSubmitButton: !isOptionSelected
    }))]
  });
};
var LegacyPlanningInfo$1 = LegacyPlanningInfo;

var LegacyPlanning = function LegacyPlanning(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.LEGACY_PARTNER;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    shouldNotSetLanguageCode: true,
    Confirmation: Confirmation,
    children: jsx(LegacyPlanningInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var ReportPerson = function ReportPerson(_ref) {
  var index = _ref.index,
    handleAddPerson = _ref.handleAddPerson,
    handleRemovePerson = _ref.handleRemovePerson,
    showBasicForm = _ref.showBasicForm,
    showRemoveButton = _ref.showRemoveButton;
  var contentColumnSize = showBasicForm ? 12 : 11;
  return jsx(Block, {
    children: jsxs(Columns, {
      vCentered: true,
      centered: true,
      children: [jsx(Columns.Column, {
        size: contentColumnSize,
        children: jsxs(Columns, {
          children: [jsx(Columns.Column, {
            size: "one-third",
            children: jsx(InputText, {
              name: "formLogic.reportDetails.reportPersons[".concat(index, "].firstName"),
              label: "First Name"
            })
          }), jsx(Columns.Column, {
            size: "one-third",
            children: jsx(InputText, {
              name: "formLogic.reportDetails.reportPersons[".concat(index, "].lastName"),
              label: "Last Name"
            })
          }), jsx(Columns.Column, {
            size: "one-third",
            children: jsx(InputText, {
              name: "formLogic.reportDetails.reportPersons[".concat(index, "].organizationName"),
              label: "Title or Organization"
            })
          })]
        })
      }), !showBasicForm && jsx(Columns.Column, {
        size: 1,
        children: jsxs(Content, {
          alignItems: "center",
          justifyContent: "center",
          display: "flex",
          pt: "5",
          children: [jsx(Icon, {
            size: "small",
            onClick: function onClick(e) {
              handleAddPerson(e, index);
            },
            m: "2",
            children: jsx(PlusIcon, {
              height: "5rem",
              viewBox: "0 0 448 512"
            })
          }), showRemoveButton && jsx(Icon, {
            size: "small",
            m: "2",
            onClick: function onClick(e) {
              handleRemovePerson(e, index);
            },
            children: jsx(MinusIcon, {
              height: "5rem",
              viewBox: "0 0 448 512"
            })
          })]
        })
      })]
    })
  });
};

var _excluded$8 = ["showBasicForm"];
var MisconductInfo = function MisconductInfo(_ref) {
  var _ref$showBasicForm = _ref.showBasicForm,
    showBasicForm = _ref$showBasicForm === void 0 ? false : _ref$showBasicForm,
    props = _objectWithoutProperties(_ref, _excluded$8);
  var _useMisconduct = useMisconduct({
      showBasicForm: showBasicForm
    }),
    contactOptions = _useMisconduct.contactOptions,
    contactTimes = _useMisconduct.contactTimes,
    reportPersonsList = _useMisconduct.reportPersonsList,
    showContactFields = _useMisconduct.showContactFields,
    showRemoveButton = _useMisconduct.showRemoveButton,
    showSPRelationshipInput = _useMisconduct.showSPRelationshipInput,
    spRelationshipOptions = _useMisconduct.spRelationshipOptions,
    handleAddPerson = _useMisconduct.handleAddPerson,
    handleRemovePerson = _useMisconduct.handleRemovePerson;
  var PrivacyPolicyCopy = props === null || props === void 0 ? void 0 : props.privacyPolicyCopy;
  return jsxs(Container$1, {
    children: [showBasicForm && jsx(FormSection$1, {
      isEmbedSite: false,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionHeader: "Report Details",
      paddingTop: "light",
      paddingBottom: "standard"
    }), jsx(FormSection$1, {
      formSectionFields: jsxs(Fragment, {
        children: [jsx(TextArea, {
          label: "1. Describe the Misconduct you would like to report.*",
          name: "collector.questions[0].answerText",
          required: true
        }), jsx(TextArea, {
          label: "2. Where did the Misconduct occur?*",
          name: "collector.questions[1].answerText",
          required: true
        }), jsx(TextArea, {
          label: "3. When did the Misconduct occur?*",
          name: "collector.questions[2].answerText",
          required: true
        }), jsx(Content, {
          textSize: "6",
          textWeight: "bold",
          children: "4. Identify the people involved in the Misconduct."
        }), (reportPersonsList === null || reportPersonsList === void 0 ? void 0 : reportPersonsList.length) > 0 && reportPersonsList.map(function (item, index) {
          return jsx(ReportPerson, {
            index: index,
            handleAddPerson: handleAddPerson,
            handleRemovePerson: handleRemovePerson,
            showBasicForm: showBasicForm,
            showRemoveButton: showRemoveButton
          }, item.id);
        }), jsx(Heading, {
          textSize: "3",
          textWeight: "bold",
          renderAs: "h3",
          paddingless: showBasicForm,
          marginless: showBasicForm,
          children: "Personal Contact Information"
        }), jsxs(Content, {
          textSize: "6",
          children: ["You are not required to provide personal contact information. However, by providing us with your contact information, we will be better equipped to communicate and coordinate with you on any investigation into the situation you are reporting, which may affect a successful outcome and resolution. All information submitted via this form is subject to the terms outlined in our", ' ', jsx("a", {
            target: "_blank",
            href: "https://billygraham.org/privacy-policy/",
            rel: "noreferrer",
            children: "Privacy Policy"
          }), "."]
        }), jsx("hr", {}), jsx(RadioGroup, {
          label: "5. May we contact you about this report?",
          name: "collector.questions[3].answerText",
          options: contactOptions,
          required: true
        }), (showContactFields || showBasicForm) && jsxs(Block, {
          children: [jsx(InputText, {
            name: "formLogic.entity.firstName",
            label: "First Name"
          }), jsx(InputText, {
            name: "formLogic.entity.lastName",
            label: "Last Name"
          }), jsx(InputPhone, {
            name: "formLogic.entity.phone.phoneNumber",
            label: "Phone"
          }), jsx(InputText, {
            name: "formLogic.entity.organizationName",
            label: "Title"
          }), jsx(InputEmail, {
            name: "formLogic.entity.email.emailAddress",
            label: "Email"
          }), jsx(RadioGroup, {
            label: "When is the best time to contact you?",
            name: "formLogic.entity.contactTime",
            options: contactTimes
          })]
        }), jsx(RadioGroup, {
          label: "6. What was your relationship to BGEA at the time the Misconduct occurred?",
          name: "collector.questions[4].answerText",
          options: spRelationshipOptions
        }), showSPRelationshipInput && jsx(Block, {
          children: jsx(InputText, {
            name: "formLogic.reportDetails.spRelationshipOther",
            label: "Please enter your relationship to BGEA."
          })
        }), !showBasicForm && jsxs(Fragment, {
          children: [jsx(FileUpload, {
            id: "misconduct",
            label: "7. Upload any documentation or file you have of the Misconduct."
          }), jsx(Content, {
            textSize: "6",
            italic: true,
            children: "Accepted file types: image/png, image/jpeg, image/jpg, application/pdf. Maximum filesize allowed: 2MB"
          })]
        }), jsx(Content, {
          textSize: "6",
          pt: "2",
          children: "Thank you for reporting your concerns to us and for your participation in our reporting misconduct process."
        }), jsx(Heading, {
          textSize: "3",
          textWeight: "bold",
          renderAs: "h3",
          paddingless: showBasicForm,
          marginless: showBasicForm,
          children: "Submit Report"
        }), jsx(Content, {
          textSize: "6",
          paddingless: showBasicForm,
          marginless: showBasicForm,
          children: "By submitting this report, you believe the information you are providing is true and may constitute Misconduct."
        }), showBasicForm ? jsx(Content, {
          textSize: "6",
          paddingless: true,
          children: "Submit all materials via email at compliance@bgea.org or mail to Compliance, Legal Department, 1 Billy Graham Parkway, Charlotte, NC 28201, U.S.A"
        }) : jsxs(Content, {
          textSize: "6",
          pt: "2",
          children: ["If you are unable to submit this form electronically, you may", ' ', jsx("a", {
            href: props === null || props === void 0 ? void 0 : props.downloadLink,
            target: "_blank",
            rel: "noreferrer",
            children: "download this form"
          }), ' ', "and submit via email at", ' ', jsx("a", {
            href: "mailto:compliance@bgea.org",
            children: "compliance@bgea.org"
          }), " or mail to Compliance, Legal Department, 1 Billy Graham Parkway, Charlotte, NC 28201, U.S.A."]
        })]
      }),
      hideTopBorder: true,
      paddingTop: "light"
    }), (props === null || props === void 0 ? void 0 : props.privacyPolicyCopy) && jsx(FormSection$1, {
      isEmbedSite: false,
      formSectionFields: jsx(Fragment, {
        children: jsx(Box, {
          mx: 1,
          my: 5,
          children: jsx("div", {
            children: jsx(PrivacyPolicyCopy, {})
          })
        })
      }),
      paddingTop: "light"
    }), !showBasicForm && jsx(FormSection$1, {
      isEmbedSite: false,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2({}, props)),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var MisconductInfo$1 = MisconductInfo;

var Misconduct = function Misconduct(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.MISCONDUCT;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(MisconductInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var MediaRequestInfo = function MediaRequestInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useMediaRequest = useMediaRequest(),
    isDisabled = _useMediaRequest.isDisabled,
    title = _useMediaRequest.title;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: (props === null || props === void 0 ? void 0 : props.title) || title,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(EntityFields, {
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          visibleList: ['Name', 'Email'],
          required: true
        }), jsx(Content, {
          pt: 1,
          children: jsx(InputText, {
            name: "formLogic.mediaOutlet",
            label: "Media Outlet You Represent*"
          })
        }), (props === null || props === void 0 ? void 0 : props.showSignUpCheckbox) && jsx(Content, {
          className: "media-request-checkbox",
          children: jsx(Checkbox, {
            label: "Please sign me up for BGEA monthly media news updates.",
            name: "formLogic.showSignUpCheckbox"
          })
        }), jsx(TextArea, {
          label: "How can we help you?*",
          name: "formLogic.mediaRequestHelp",
          required: true
        })]
      }),
      hideTopBorder: true,
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
        isDisabled: isDisabled
      })),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var MediaRequestInfo$1 = MediaRequestInfo;

var MediaRequest = function MediaRequest(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.MEDIA_REQUEST;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: MediaRequestConfirmation,
    children: jsx(MediaRequestInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var NewNamesInfo = function NewNamesInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useNewNames = useNewNames(_objectSpread2({
      campaignCodes: props === null || props === void 0 ? void 0 : props.campaignCodes,
      donateProp: props === null || props === void 0 ? void 0 : props.donateProp,
      emailTemplateCampaign: props === null || props === void 0 ? void 0 : props.emailTemplateCampaign,
      hasCaptchaPaymentMethod: props === null || props === void 0 ? void 0 : props.hasCaptchaPaymentMethod,
      mailBox: props === null || props === void 0 ? void 0 : props.mailBox,
      maxPostalCodeLength: props === null || props === void 0 ? void 0 : props.maxPostalCodeLength,
      minPostalCodeLength: props === null || props === void 0 ? void 0 : props.minPostalCodeLength,
      productCode: props === null || props === void 0 ? void 0 : props.productCode,
      productTitle: props === null || props === void 0 ? void 0 : props.productTitle,
      useRecaptchaV2: props === null || props === void 0 ? void 0 : props.useRecaptchaV2
    }, props)),
    isValid = _useNewNames.isValid,
    privacyPolicyTextLabel = _useNewNames.privacyPolicyTextLabel,
    visibleList = _useNewNames.visibleList,
    validatePostalCode = _useNewNames.validatePostalCode;
  return jsxs(Container$1, {
    className: "bgform-new-names-container",
    children: [(props === null || props === void 0 ? void 0 : props.showCustomHeader) && jsx(CustomMarkupSection, {
      styles: props === null || props === void 0 ? void 0 : props.styles,
      customMarkup: props === null || props === void 0 ? void 0 : props.customMarkup
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: true,
      hideTopBorder: true,
      formSectionFields: jsxs(Fragment, {
        children: [props !== null && props !== void 0 && props.mailBox ? jsxs(Fragment, {
          children: [jsx(Name$1, {
            visibleList: visibleList,
            required: true,
            showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel
          }), jsx(EntityFields, _objectSpread2({
            country: ['US'],
            visibleList: ['Email'],
            emailRequired: true,
            required: true
          }, props)), jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
            autoComplete: false,
            country: ['US'],
            entity: 0,
            index: 0,
            label: "",
            required: true,
            showLabel: false,
            type: "MAIL",
            visibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode']
          }))]
        }) : jsxs(Fragment, {
          children: [jsx(EntityFields, _objectSpread2({
            country: ['US'],
            visibleList: ['Name', 'Email'],
            emailRequired: true,
            required: true
          }, props)), jsx(CountryPostal, {
            validateZipPostalCode: validatePostalCode,
            required: true
          })]
        }), jsx(Checkbox, {
          isChecked: props === null || props === void 0 ? void 0 : props.isChecked,
          label: (props === null || props === void 0 ? void 0 : props.checkboxText) || 'I am 18 or older*',
          name: "collector.entity[0].over18",
          isRequired: (props === null || props === void 0 ? void 0 : props.isReq) || false,
          title: ""
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      formSectionHeader: props !== null && props !== void 0 && props.isEmbedSite ? privacyPolicyTextLabel : '',
      formSectionFields: jsxs(Content, {
        children: [(props === null || props === void 0 ? void 0 : props.privacyPolicyCopy) && jsx("div", {
          dangerouslySetInnerHTML: {
            __html: props === null || props === void 0 ? void 0 : props.privacyPolicyCopy
          }
        }), !(props !== null && props !== void 0 && props.hidePrivacyPolicyCopy) && !(props !== null && props !== void 0 && props.privacyPolicyCopy) && jsxs("span", {
          children: ["When you complete the form, we'll also send you regular updates on the work God is doing around the world through friends like you and the Billy Graham Evangelistic Association.", ' ']
        }), !(props !== null && props !== void 0 && props.privacyPolicyCopy) && jsx("a", {
          href: "https://billygraham.org/privacy-policy/",
          children: "View our full Privacy Policy."
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      disableEmbedLayout: props === null || props === void 0 ? void 0 : props.disableEmbedLayout,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, {
        color: "primary",
        className: "is-pulled-right",
        isDisabled: !isValid,
        text: props === null || props === void 0 ? void 0 : props.buttonText
      }),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var NewNamesInfo$1 = NewNamesInfo;

var NewNamesBasic = function NewNamesBasic(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var emailId = (props === null || props === void 0 ? void 0 : props.emailId) || 'NewNames';
  if (props !== null && props !== void 0 && props.shouldNotUseEmailId) {
    emailId = '';
  }
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    emailId: emailId,
    shouldNotSetLanguageCode: true,
    Confirmation: Confirmation,
    children: jsx(NewNamesInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

/* 
Component to keep compatibility with New Names from BGForm. 
Needs to be refactor possibly no need to use this component at all. 
The Gatsby is already passing a React Node for custom copy.
*/

var NewNamesCustomCopy = function NewNamesCustomCopy(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var CustomHeader = props === null || props === void 0 ? void 0 : props.customHeader;
  var CustomModalHeader = props === null || props === void 0 ? void 0 : props.customModalHeader;
  var modalHeader = jsxs(Fragment, {
    children: [jsx("a", {
      href: "https://billygraham.org",
      children: jsx("img", {
        src: "https://static.billygraham.org/sites/lp.billygraham.org/uploads/prod/2020/06/logo-bgea-b.png.webp",
        style: {
          maxWidth: '150px',
          display: 'block',
          margin: '0 auto'
        },
        alt: "BGEA Logo"
      })
    }), jsxs("h2", {
      style: {
        fontSize: '40px',
        textAlign: 'center',
        color: '#4a4a4a'
      },
      children: [CustomModalHeader && jsx(CustomModalHeader, {
        firstName: props === null || props === void 0 ? void 0 : props.firstName
      }), !CustomModalHeader && "Great news ".concat(props === null || props === void 0 ? void 0 : props.firstName, "! Your ").concat(props === null || props === void 0 ? void 0 : props.resourceTitleText, " is on its way to your ").concat(props !== null && props !== void 0 && props.mailBox ? 'mailbox' : 'inbox', ".")]
    }), (props === null || props === void 0 ? void 0 : props.showDeliveryMessage) && jsx("p", {
      children: props === null || props === void 0 ? void 0 : props.deliveryMessage
    }), (props === null || props === void 0 ? void 0 : props.showDeliveryDefaultMessage) && jsx("p", {
      children: "Please allow 4 - 6 weeks for ".concat(props === null || props === void 0 ? void 0 : props.productTitle, " to reach your mailbox.")
    })]
  });
  var defaultModalText = jsxs("div", {
    children: [modalHeader, jsx("br", {}), (props === null || props === void 0 ? void 0 : props.donateProp) && jsxs("div", {
      children: [jsx("p", {
        children: "We praise the Lord for your desire to draw closer to Him through His Word this year. It\u2019s our prayer that this resource will encourage you with the promise that \u201Cthe law of the Lord is perfect, reviving the soul; the testimony of the Lord is sure\u201D (Psalm 19:7, ESV)."
      }), jsx("br", {}), jsx("p", {
        children: "Before you go, there are a few things we\u2019d like you to know\u2026"
      }), jsx("br", {}), jsx("p", {
        children: "God is using friends like you to reach people with His love in a variety of ways through the Billy Graham Evangelistic Association, including a 24-hour prayer line, online Gospel resources, and Billy Graham Rapid Response Team (BG-RRT) chaplains, who comfort and pray with hurting people in the midst of crisis."
      }), jsx("br", {}), jsx("p", {
        children: "This Gospel ministry relies on friends like you who make outreaches like these possible through your prayers and financial support."
      }), jsx("br", {}), jsx("p", {
        children: "When you make a gift today, you can reach people across the globe with the message of God\u2019s love. In a time when so many are overcome with anger, fear, or hopelessness, the Good News of Jesus Christ is exactly what they need to hear. Will you help share it with them?"
      }), jsx("br", {}), jsx("blockquote", {
        style: {
          borderLeft: '1px solid #6e6e6e',
          borderRight: '1px solid #6e6e6e',
          textAlign: 'center',
          marginBottom: 0,
          color: '#6e6e6e',
          padding: '9px 19px'
        },
        children: "Your gift today will help share the hope of the Gospel with people around the world who are far from God"
      })]
    })]
  });
  var modalText = props !== null && props !== void 0 && props.customModalText ? jsxs(Fragment, {
    children: [modalHeader, props === null || props === void 0 ? void 0 : props.customModalText]
  }) : defaultModalText;
  return CustomHeader ? jsx(CustomHeader, _objectSpread2({}, props)) : modalText;
};

var _excluded$7 = ["recurringToggle", "optionProp", "options", "give", "donateTitle", "codes", "buttonAmounts", "donationDateButtons", "recurringButtonAmounts", "recurringChoiceDay", "givingBtnStyle", "givingRecurringBtnStyle", "usePaypalCaptureOnly", "uniqueClassName"];
var NewNamesDonationInfo = function NewNamesDonationInfo(_ref) {
  var _ref$recurringToggle = _ref.recurringToggle,
    recurringToggle = _ref$recurringToggle === void 0 ? true : _ref$recurringToggle,
    _ref$optionProp = _ref.optionProp,
    optionProp = _ref$optionProp === void 0 ? {
      whereMostNeeded: 'Where Most Needed'
    } : _ref$optionProp,
    _ref$options = _ref.options,
    options = _ref$options === void 0 ? [] : _ref$options,
    _ref$give = _ref.give,
    give = _ref$give === void 0 ? true : _ref$give,
    _ref$codes = _ref.codes,
    codes = _ref$codes === void 0 ? [] : _ref$codes,
    buttonAmounts = _ref.buttonAmounts,
    _ref$donationDateButt = _ref.donationDateButtons,
    donationDateButtons = _ref$donationDateButt === void 0 ? false : _ref$donationDateButt,
    recurringButtonAmounts = _ref.recurringButtonAmounts,
    recurringChoiceDay = _ref.recurringChoiceDay,
    _ref$givingBtnStyle = _ref.givingBtnStyle,
    givingBtnStyle = _ref$givingBtnStyle === void 0 ? {
      bgColor: '#003658',
      textColor: '#ffffff'
    } : _ref$givingBtnStyle,
    _ref$givingRecurringB = _ref.givingRecurringBtnStyle,
    givingRecurringBtnStyle = _ref$givingRecurringB === void 0 ? {
      bgColor: '#00c4a7',
      textColor: '#ffffff'
    } : _ref$givingRecurringB,
    _ref$usePaypalCapture = _ref.usePaypalCaptureOnly,
    usePaypalCaptureOnly = _ref$usePaypalCapture === void 0 ? true : _ref$usePaypalCapture,
    _ref$uniqueClassName = _ref.uniqueClassName,
    uniqueClassName = _ref$uniqueClassName === void 0 ? '' : _ref$uniqueClassName,
    props = _objectWithoutProperties(_ref, _excluded$7);
  var _useSingleDonation = useSingleDonation({
      options: options,
      codes: codes,
      optionProp: optionProp,
      usePaypalCaptureOnly: usePaypalCaptureOnly
    }),
    displayPaymentMethod = _useSingleDonation.displayPaymentMethod,
    giveButton = _useSingleDonation.giveButton;
  var _useNewNamesDonation = useNewNamesDonation(_objectSpread2({
      campaignCodes: props === null || props === void 0 ? void 0 : props.campaignCodes,
      donationEsubCodes: props === null || props === void 0 ? void 0 : props.donationEsubCodes,
      usePaypalCaptureOnly: usePaypalCaptureOnly
    }, props)),
    firstName = _useNewNamesDonation.firstName,
    confirmationRef = _useNewNamesDonation.confirmationRef,
    resourceTitleText = _useNewNamesDonation.resourceTitleText;
  return jsx("div", {
    ref: confirmationRef,
    children: jsxs(Container$1, {
      className: "bgform-new-names-donation-container",
      children: [jsx(NewNamesCustomCopy, _objectSpread2(_objectSpread2({}, props), {}, {
        firstName: firstName,
        resourceTitleText: resourceTitleText
      })), jsxs(Box, {
        children: [jsx(SingleGift, _objectSpread2(_objectSpread2({}, props), {}, {
          recurringToggle: recurringToggle,
          give: give,
          giveButton: giveButton,
          buttonSize: "medium",
          addToggleClass: "has-text-black",
          buttonAmounts: buttonAmounts,
          donationDateButtons: donationDateButtons,
          recurringButtonAmounts: recurringButtonAmounts,
          recurringChoiceDay: recurringChoiceDay,
          givingBtnStyle: givingBtnStyle,
          givingRecurringBtnStyle: givingRecurringBtnStyle,
          uniqueClassName: uniqueClassName
        })), displayPaymentMethod && jsx(PaymentMethod, _objectSpread2(_objectSpread2({}, props), {}, {
          displayList: ['Name', 'Email', 'Phone', 'Address']
        }))]
      }), !(props !== null && props !== void 0 && props.hideRecaptchaMessage) && jsx(RecaptchaMessage, _objectSpread2({}, props))]
    })
  });
};
var NewNamesDonationInfo$1 = NewNamesDonationInfo;

var NewNamesDonation = function NewNamesDonation(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = !(props !== null && props !== void 0 && props.donationFormName) ? Templates.NEW_NAMES_DONATION : "".concat(Templates.NEW_NAMES_DONATION, "/").concat(props === null || props === void 0 ? void 0 : props.donationFormName);
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    campaignCodes: [],
    isBasicTemplate: true,
    isMultiForm: false,
    Confirmation: Confirmation,
    templateName: templateName,
    children: jsx(NewNamesDonationInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var NewNamesMultiForm = function NewNamesMultiForm(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var emailId = (props === null || props === void 0 ? void 0 : props.emailId) || 'NewNames';
  if (props !== null && props !== void 0 && props.shouldNotUseEmailId) {
    emailId = '';
  }
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    emailId: emailId,
    isMultiForm: true,
    shouldNotSetLanguageCode: true,
    FormComponent: NewNamesDonation,
    children: jsx(NewNamesInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var NewNamesDonationModalInfo = function NewNamesDonationModalInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useNewNamesDonationM = useNewNamesDonationModal(),
    modalIsOpen = _useNewNamesDonationM.modalIsOpen,
    handleOnCloseModal = _useNewNamesDonationM.handleOnCloseModal;
  return jsx(Modal, {
    show: modalIsOpen,
    onClose: function onClose() {
      return handleOnCloseModal();
    },
    children: jsx(Modal.Card, {
      children: jsx(Modal.Card.Body, {
        children: jsx(Content, {
          children: jsx(NewNamesDonationInfo$1, _objectSpread2({}, props))
        })
      })
    })
  });
};
var NewNamesDonationModalInfo$1 = NewNamesDonationModalInfo;

var NewNamesDonationModal = function NewNamesDonationModal(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    isBasicTemplate: true,
    isMultiForm: false,
    Confirmation: Confirmation,
    children: jsx(NewNamesDonationModalInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var NewNamesMultiFormModal = function NewNamesMultiFormModal(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    emailId: (props === null || props === void 0 ? void 0 : props.emailId) || 'NewNames',
    isMultiForm: true,
    shouldNotSetLanguageCode: true,
    FormComponent: NewNamesDonationModal,
    children: jsx(NewNamesInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$6 = ["hideDonationForm", "useModalDonation"];
var NewNames = function NewNames(_ref) {
  var _ref$hideDonationForm = _ref.hideDonationForm,
    hideDonationForm = _ref$hideDonationForm === void 0 ? false : _ref$hideDonationForm,
    _ref$useModalDonation = _ref.useModalDonation,
    useModalDonation = _ref$useModalDonation === void 0 ? false : _ref$useModalDonation,
    props = _objectWithoutProperties(_ref, _excluded$6);
  var templateName = !(props !== null && props !== void 0 && props.formName) ? Templates.NEW_NAMES : "".concat(Templates.NEW_NAMES, "/").concat(props === null || props === void 0 ? void 0 : props.formName);
  if (useModalDonation) {
    return jsx(NewNamesMultiFormModal, _objectSpread2(_objectSpread2({}, props), {}, {
      donationEsubCodes: (props === null || props === void 0 ? void 0 : props.donationEsubCodes) || ['PLTR', 'BGEA'],
      templateName: templateName
    }));
  }
  return !hideDonationForm ? jsx(NewNamesMultiForm, _objectSpread2(_objectSpread2({}, props), {}, {
    donationEsubCodes: (props === null || props === void 0 ? void 0 : props.donationEsubCodes) || ['PLTR', 'BGEA'],
    templateName: templateName
  })) : jsx(NewNamesBasic, _objectSpread2(_objectSpread2({}, props), {}, {
    donationEsubCodes: (props === null || props === void 0 ? void 0 : props.donationEsubCodes) || ['PLTR', 'BGEA'],
    templateName: templateName
  }));
};

var OnlineGiving = function OnlineGiving(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.ONLINE_GIVING;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    shouldNotSetLanguageCode: true,
    templateName: templateName,
    Confirmation: OnlineGivingConfirmation,
    children: jsx(OnlineGivingInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$5() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var FooterContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e4l763a4"
} : {
  target: "e4l763a4",
  label: "FooterContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "14eabmp",
  styles: "margin-top:20px;margin-bottom:20px"
} : {
  name: "14eabmp",
  styles: "margin-top:20px;margin-bottom:20px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlBlYWNlV2l0aEdvZEZvb3RlckluZm8udHN4Il0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiJBQUlrQyIsImZpbGUiOiJQZWFjZVdpdGhHb2RGb290ZXJJbmZvLnRzeCIsInNvdXJjZXNDb250ZW50IjpbImltcG9ydCB7IHVzZVRyYW5zbGF0aW9uIH0gZnJvbSAncmVhY3QtaTE4bmV4dCc7XG5pbXBvcnQgc3R5bGVkIGZyb20gJ0BlbW90aW9uL3N0eWxlZCc7XG5pbXBvcnQgeyBDb250ZW50IH0gZnJvbSAnQGJnZWEtanMvcmVhY3QtdWknO1xuXG5jb25zdCBGb290ZXJDb250YWluZXIgPSBzdHlsZWQuZGl2YFxuICBtYXJnaW4tdG9wOiAyMHB4O1xuICBtYXJnaW4tYm90dG9tOiAyMHB4O1xuYDtcblxuY29uc3QgRm9vdGVyVGV4dCA9IHN0eWxlZC5zcGFuYFxuICBjb2xvcjogIzAwMDtcbmA7XG5cbmNvbnN0IEhpZ2hsaWdodFRleHQgPSBzdHlsZWQuc3BhbmBcbiAgY29sb3I6ICNmZDc0MDA7XG4gIGZvbnQtd2VpZ2h0OiBib2xkO1xuYDtcblxuY29uc3QgTGlzdEl0ZW0gPSBzdHlsZWQubGlgXG4gIG1hcmdpbi1ib3R0b206IDElO1xuYDtcblxuY29uc3QgU3R5bGVkTGlzdCA9IHN0eWxlZC51bGBcbiAgbGlzdC1zdHlsZS10eXBlOiBjaXJjbGU7XG4gIG1hcmdpbi1sZWZ0OiA1JTtcbiAgbWFyZ2luLWJvdHRvbTogMSU7XG4gIG1hcmdpbi10b3A6IDElO1xuYDtcblxuY29uc3QgUGVhY2VXaXRoR29kRm9vdGVySW5mbyA9ICgpID0+IHtcbiAgY29uc3QgeyB0IH0gPSB1c2VUcmFuc2xhdGlvbihbJ2NvbW1vbicsICdsYWJlbHMnLCAndmFsaWRhdGlvbiddKTtcbiAgY29uc3QgcmVzb3VyY2VzID0gW1xuICAgIHtcbiAgICAgIGtleTogJ2xpMCcsXG4gICAgICB1cmw6XG4gICAgICAgICdodHRwczovL2NvdXJzZXMuZ29pbmdmYXJ0aGVyLm5ldC9MaXZpbmdJbkNocmlzdD91dG1fc291cmNlPUZvcmdpdmUubWUmdXRtX21lZGl1bT1MaW5rJnV0bV9jb250ZW50PXRoYW5rLXlvdS1hZ2Fpbi1MSUMmdXRtX2NhbXBhaWduPUZvcmdpdmUubWUnLFxuICAgIH0sXG4gICAge1xuICAgICAga2V5OiAnbGkxJyxcbiAgICAgIHVybDpcbiAgICAgICAgJ2h0dHBzOi8vY291cnNlcy5nb2luZ2ZhcnRoZXIubmV0L2tub3ctamVzdXM/dXRtX3NvdXJjZT1QV0dkb3ROZXQmdXRtX21lZGl1bT1HRitMaW5rJnV0bV9jYW1wYWlnbj1HRitJbnRlcm5hbCZ1dG1fY29udGVudD1pLXByYXllZC10aGUtcHJheWVyJnByb2Zlc3Npb249UFdHJTIwcmVzcG9uc2l2ZSZvdXRyZWFjaD1MUC1ob21lJyxcbiAgICB9LFxuICAgIHtcbiAgICAgIGtleTogJ2xpMicsXG4gICAgICB1cmw6XG4gICAgICAgICdodHRwczovL2dvaW5nZmFydGhlci5uZXQvYmFzaWNzLW9mLWNocmlzdGlhbml0eS8/dXRtX3NvdXJjZT1QV0dkb3ROZXQmdXRtX21lZGl1bT1HRitMaW5rJnV0bV9jYW1wYWlnbj1HRitJbnRlcm5hbCZ1dG1fY29udGVudD1pLXByYXllZC10aGUtcHJheWVyJnByb2Zlc3Npb249UFdHJTIwcmVzcG9uc2l2ZSZvdXRyZWFjaD1MUC1ob21lJyxcbiAgICB9LFxuICAgIHtcbiAgICAgIGtleTogJ2xpMycsXG4gICAgICB1cmw6XG4gICAgICAgICdodHRwczovL2dvaW5nZmFydGhlci5uZXQvY29tbW9uLXF1ZXN0aW9ucy8/dXRtX3NvdXJjZT1QV0dkb3ROZXQmdXRtX21lZGl1bT1HRitMaW5rJnV0bV9jYW1wYWlnbj1HRitJbnRlcm5hbCZ1dG1fY29udGVudD1pLXByYXllZC10aGUtcHJheWVyJnByb2Zlc3Npb249UFdHJTIwcmVzcG9uc2l2ZSZvdXRyZWFjaD1MUC1ob21lJyxcbiAgICB9LFxuICAgIHtcbiAgICAgIGtleTogJ2xpNCcsXG4gICAgICB1cmw6XG4gICAgICAgICdodHRwczovL2dvaW5nZmFydGhlci5uZXQvbGlmZS1pc3N1ZXMvP3V0bV9zb3VyY2U9UFdHZG90TmV0JnV0bV9tZWRpdW09R0YrTGluayZ1dG1fY2FtcGFpZ249R0YrSW50ZXJuYWwmdXRtX2NvbnRlbnQ9aS1wcmF5ZWQtdGhlLXByYXllciZwcm9mZXNzaW9uPVBXRyUyMHJlc3BvbnNpdmUmb3V0cmVhY2g9TFAtaG9tZScsXG4gICAgfSxcbiAgICB7XG4gICAgICBrZXk6ICdsaTUnLFxuICAgICAgdXJsOlxuICAgICAgICAnaHR0cHM6Ly9jaHVyY2hlcy5nb2luZ2ZhcnRoZXIubmV0Lz91dG1fc291cmNlPVBXR2RvdE5ldCZ1dG1fbWVkaXVtPUdGJTIwTGluayZ1dG1fY2FtcGFpZ249R0YlMjBJbnRlcm5hbCZ1dG1fY29udGVudD1pLXByYXllZC10aGUtcHJheWVyJnByb2Zlc3Npb249UFdHJTIwcmVzcG9uc2l2ZSZvdXRyZWFjaD1MUC1ob21lJyxcbiAgICB9LFxuICBdO1xuXG4gIHJldHVybiAoXG4gICAgPEZvb3RlckNvbnRhaW5lcj5cbiAgICAgIDxGb290ZXJUZXh0Pnt0KCdQZWFjZSBXaXRoIEdvZCBSZXNvdXJjZXMnLCB7IG5zOiAnY29tbW9uJyB9KX08L0Zvb3RlclRleHQ+XG4gICAgICA8U3R5bGVkTGlzdD5cbiAgICAgICAge3Jlc291cmNlcy5tYXAoKHJlc291cmNlKSA9PiAoXG4gICAgICAgICAgPExpc3RJdGVtIGtleT17cmVzb3VyY2Uua2V5fT5cbiAgICAgICAgICAgIDxDb250ZW50PlxuICAgICAgICAgICAgICA8SGlnaGxpZ2h0VGV4dD5cbiAgICAgICAgICAgICAgICA8YSBocmVmPXtyZXNvdXJjZS51cmx9IHRhcmdldD1cIl9ibGFua1wiIHJlbD1cIm5vcmVmZXJyZXJcIj5cbiAgICAgICAgICAgICAgICAgIHt0KGBQZWFjZSBXaXRoIEdvZCBSZXNvdXJjZXNfJHtyZXNvdXJjZS5rZXl9YCwge1xuICAgICAgICAgICAgICAgICAgICBuczogJ2NvbW1vbicsXG4gICAgICAgICAgICAgICAgICB9KX1cbiAgICAgICAgICAgICAgICA8L2E+XG4gICAgICAgICAgICAgIDwvSGlnaGxpZ2h0VGV4dD5cbiAgICAgICAgICAgICAgPEZvb3RlclRleHQ+XG4gICAgICAgICAgICAgICAge3QoYFBlYWNlIFdpdGggR29kIFJlc291cmNlc18ke3Jlc291cmNlLmtleX1fdGV4dGAsIHtcbiAgICAgICAgICAgICAgICAgIG5zOiAnY29tbW9uJyxcbiAgICAgICAgICAgICAgICB9KX1cbiAgICAgICAgICAgICAgPC9Gb290ZXJUZXh0PlxuICAgICAgICAgICAgPC9Db250ZW50PlxuICAgICAgICAgIDwvTGlzdEl0ZW0+XG4gICAgICAgICkpfVxuICAgICAgPC9TdHlsZWRMaXN0PlxuICAgIDwvRm9vdGVyQ29udGFpbmVyPlxuICApO1xufTtcblxuZXhwb3J0IGRlZmF1bHQgUGVhY2VXaXRoR29kRm9vdGVySW5mbztcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
var FooterText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e4l763a3"
} : {
  target: "e4l763a3",
  label: "FooterText"
})(process.env.NODE_ENV === "production" ? {
  name: "x3brzu",
  styles: "color:#000"
} : {
  name: "x3brzu",
  styles: "color:#000",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
var HighlightText = /*#__PURE__*/_styled("span", process.env.NODE_ENV === "production" ? {
  target: "e4l763a2"
} : {
  target: "e4l763a2",
  label: "HighlightText"
})(process.env.NODE_ENV === "production" ? {
  name: "5dpwv2",
  styles: "color:#fd7400;font-weight:bold"
} : {
  name: "5dpwv2",
  styles: "color:#fd7400;font-weight:bold",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
var ListItem = /*#__PURE__*/_styled("li", process.env.NODE_ENV === "production" ? {
  target: "e4l763a1"
} : {
  target: "e4l763a1",
  label: "ListItem"
})(process.env.NODE_ENV === "production" ? {
  name: "1tai6rc",
  styles: "margin-bottom:1%"
} : {
  name: "1tai6rc",
  styles: "margin-bottom:1%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
var StyledList = /*#__PURE__*/_styled("ul", process.env.NODE_ENV === "production" ? {
  target: "e4l763a0"
} : {
  target: "e4l763a0",
  label: "StyledList"
})(process.env.NODE_ENV === "production" ? {
  name: "1bd03gl",
  styles: "list-style-type:circle;margin-left:5%;margin-bottom:1%;margin-top:1%"
} : {
  name: "1bd03gl",
  styles: "list-style-type:circle;margin-left:5%;margin-bottom:1%;margin-top:1%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$5
});
var PeaceWithGodFooterInfo = function PeaceWithGodFooterInfo() {
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var resources = [{
    key: 'li0',
    url: 'https://courses.goingfarther.net/LivingInChrist?utm_source=Forgive.me&utm_medium=Link&utm_content=thank-you-again-LIC&utm_campaign=Forgive.me'
  }, {
    key: 'li1',
    url: 'https://courses.goingfarther.net/know-jesus?utm_source=PWGdotNet&utm_medium=GF+Link&utm_campaign=GF+Internal&utm_content=i-prayed-the-prayer&profession=PWG%20responsive&outreach=LP-home'
  }, {
    key: 'li2',
    url: 'https://goingfarther.net/basics-of-christianity/?utm_source=PWGdotNet&utm_medium=GF+Link&utm_campaign=GF+Internal&utm_content=i-prayed-the-prayer&profession=PWG%20responsive&outreach=LP-home'
  }, {
    key: 'li3',
    url: 'https://goingfarther.net/common-questions/?utm_source=PWGdotNet&utm_medium=GF+Link&utm_campaign=GF+Internal&utm_content=i-prayed-the-prayer&profession=PWG%20responsive&outreach=LP-home'
  }, {
    key: 'li4',
    url: 'https://goingfarther.net/life-issues/?utm_source=PWGdotNet&utm_medium=GF+Link&utm_campaign=GF+Internal&utm_content=i-prayed-the-prayer&profession=PWG%20responsive&outreach=LP-home'
  }, {
    key: 'li5',
    url: 'https://churches.goingfarther.net/?utm_source=PWGdotNet&utm_medium=GF%20Link&utm_campaign=GF%20Internal&utm_content=i-prayed-the-prayer&profession=PWG%20responsive&outreach=LP-home'
  }];
  return jsxs(FooterContainer, {
    children: [jsx(FooterText, {
      children: t('Peace With God Resources', {
        ns: 'common'
      })
    }), jsx(StyledList, {
      children: resources.map(function (resource) {
        return jsx(ListItem, {
          children: jsxs(Content, {
            children: [jsx(HighlightText, {
              children: jsx("a", {
                href: resource.url,
                target: "_blank",
                rel: "noreferrer",
                children: t("Peace With God Resources_".concat(resource.key), {
                  ns: 'common'
                })
              })
            }), jsx(FooterText, {
              children: t("Peace With God Resources_".concat(resource.key, "_text"), {
                ns: 'common'
              })
            })]
          })
        }, resource.key);
      })
    })]
  });
};
var PeaceWithGodFooterInfo$1 = PeaceWithGodFooterInfo;

var _excluded$5 = ["CTID", "emailId", "lng", "eventId", "individualCodes", "orgCodes", "sessionId", "websiteId", "ip", "formTitle", "addressVisibleList", "questionLabel", "submitButtonLabel", "customFooter", "customFooterStyles"];
var PeaceWithGodPrayerInfo = function PeaceWithGodPrayerInfo(_ref) {
  var CTID = _ref.CTID,
    emailId = _ref.emailId,
    lng = _ref.lng,
    eventId = _ref.eventId,
    _ref$individualCodes = _ref.individualCodes,
    individualCodes = _ref$individualCodes === void 0 ? [] : _ref$individualCodes,
    _ref$orgCodes = _ref.orgCodes,
    orgCodes = _ref$orgCodes === void 0 ? [] : _ref$orgCodes,
    sessionId = _ref.sessionId,
    websiteId = _ref.websiteId,
    ip = _ref.ip,
    _ref$formTitle = _ref.formTitle,
    formTitle = _ref$formTitle === void 0 ? 'I Accepted Jesus Christ' : _ref$formTitle,
    _ref$addressVisibleLi = _ref.addressVisibleList,
    addressVisibleList = _ref$addressVisibleLi === void 0 ? ['country'] : _ref$addressVisibleLi,
    _ref$questionLabel = _ref.questionLabel,
    questionLabel = _ref$questionLabel === void 0 ? 'Have a question? Enter it below.' : _ref$questionLabel,
    _ref$submitButtonLabe = _ref.submitButtonLabel,
    submitButtonLabel = _ref$submitButtonLabe === void 0 ? 'Submit' : _ref$submitButtonLabe,
    customFooter = _ref.customFooter,
    customFooterStyles = _ref.customFooterStyles,
    props = _objectWithoutProperties(_ref, _excluded$5);
  var _usePeaceWithGod = usePeaceWithGod({
      lng: lng,
      individualCodes: individualCodes,
      orgCodes: orgCodes,
      CTID: CTID,
      emailId: emailId,
      eventId: eventId,
      sessionId: sessionId,
      websiteId: websiteId,
      ip: ip,
      formTitle: formTitle,
      submitButtonLabel: submitButtonLabel,
      questionLabel: questionLabel
    }),
    decisionOptions = _usePeaceWithGod.decisionOptions,
    genderOptions = _usePeaceWithGod.genderOptions,
    labels = _usePeaceWithGod.labels;
  return jsx(Container$1, {
    children: jsx(FormSection$1, {
      formSectionHeader: labels.formTitle,
      isFormHeader: true,
      isEmbedSite: true,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Content, {
          children: labels.peaceWithGodSummary
        }), jsx(Content, {
          children: labels.peaceWithGodSummary2
        }), jsx(RadioGroup, {
          label: labels.decisionLabel,
          name: "formLogic.type",
          options: decisionOptions,
          required: true
        }), jsx(EntityFields, {
          addressVisibleList: addressVisibleList,
          showAddressLabel: false,
          showNameLabel: false,
          visibleList: ['Name', 'Email', 'Address'],
          visibleName: ['firstName'],
          emailRequired: true,
          required: true
        }), jsx(RadioGroup, {
          label: labels.genderLabel,
          name: "collector.entity[0].gender",
          options: genderOptions,
          required: true
        }), jsx(TextArea, {
          label: labels.questionLabel,
          name: "formLogic.questionInput"
        }), jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
          text: labels.submitButtonLabel,
          color: "#1a1a1a",
          isNewSubmitButton: true
        })), jsx(CustomMarkupSection, {
          customMarkup: customFooter,
          styles: customFooterStyles
        }), jsx(PeaceWithGodFooterInfo$1, {})]
      })
    })
  });
};
var PeaceWithGodPrayerInfo$1 = PeaceWithGodPrayerInfo;

var PeaceWithGodPrayer = function PeaceWithGodPrayer(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.PEACE_WITH_GOD_PRAYER;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: PeaceWithGodPrayerConfirmation,
    children: jsx(PeaceWithGodPrayerInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$4 = ["CTID", "emailId", "lng", "eventId", "individualCodes", "orgCodes", "sessionId", "websiteId", "ip", "formTitle", "addressVisibleList", "questionLabel", "submitButtonLabel", "showAddress", "customFooter", "customFooterStyles"];
var PeaceWithGodQuestionInfo = function PeaceWithGodQuestionInfo(_ref) {
  var CTID = _ref.CTID,
    emailId = _ref.emailId,
    lng = _ref.lng,
    eventId = _ref.eventId,
    _ref$individualCodes = _ref.individualCodes,
    individualCodes = _ref$individualCodes === void 0 ? [] : _ref$individualCodes,
    _ref$orgCodes = _ref.orgCodes,
    orgCodes = _ref$orgCodes === void 0 ? [] : _ref$orgCodes,
    sessionId = _ref.sessionId,
    websiteId = _ref.websiteId,
    ip = _ref.ip,
    _ref$formTitle = _ref.formTitle,
    formTitle = _ref$formTitle === void 0 ? 'I Have A Question' : _ref$formTitle,
    _ref$addressVisibleLi = _ref.addressVisibleList,
    addressVisibleList = _ref$addressVisibleLi === void 0 ? ['street', 'cityTownRegion', 'zipPostalCode', 'country'] : _ref$addressVisibleLi,
    _ref$questionLabel = _ref.questionLabel,
    questionLabel = _ref$questionLabel === void 0 ? 'Comment / question' : _ref$questionLabel,
    _ref$submitButtonLabe = _ref.submitButtonLabel,
    submitButtonLabel = _ref$submitButtonLabe === void 0 ? 'Submit' : _ref$submitButtonLabe,
    _ref$showAddress = _ref.showAddress,
    showAddress = _ref$showAddress === void 0 ? false : _ref$showAddress,
    customFooter = _ref.customFooter,
    customFooterStyles = _ref.customFooterStyles,
    props = _objectWithoutProperties(_ref, _excluded$4);
  var _usePeaceWithGod = usePeaceWithGod({
      lng: lng,
      individualCodes: individualCodes,
      orgCodes: orgCodes,
      CTID: CTID,
      emailId: emailId,
      eventId: eventId,
      sessionId: sessionId,
      websiteId: websiteId,
      ip: ip,
      formTitle: formTitle,
      submitButtonLabel: submitButtonLabel,
      questionLabel: questionLabel
    }),
    genderOptions = _usePeaceWithGod.genderOptions,
    labels = _usePeaceWithGod.labels;
  return jsx(Container$1, {
    children: jsx(FormSection$1, {
      formSectionHeader: labels.formTitle,
      isFormHeader: true,
      isEmbedSite: true,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Content, {
          children: labels.peaceWithGodQuestionSummary
        }), jsx(EntityFields, {
          addressVisibleList: addressVisibleList,
          showNameLabel: false,
          visibleList: ['Name', 'Email', "".concat(showAddress ? 'Address' : '')],
          emailRequired: true,
          visibleName: ['firstName'],
          required: true
        }), jsx(RadioGroup, {
          label: labels.genderLabel,
          name: "collector.entity[0].gender",
          options: genderOptions,
          required: true
        }), jsx(TextArea, {
          label: labels.questionLabel,
          name: "formLogic.questionInput"
        }), jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
          text: labels.submitButtonLabel,
          color: "#1a1a1a",
          isNewSubmitButton: true
        })), jsx(CustomMarkupSection, {
          customMarkup: customFooter,
          styles: customFooterStyles
        }), jsx(PeaceWithGodFooterInfo$1, {})]
      })
    })
  });
};
var PeaceWithGodQuestionInfo$1 = PeaceWithGodQuestionInfo;

var PeaceWithGodQuestion = function PeaceWithGodQuestion(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.PEACE_WITH_GOD_QUESTION;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: PeaceWithGodQuestionConfirmation,
    children: jsx(PeaceWithGodQuestionInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var PrintInfo = function PrintInfo() {
  return jsxs(Block, {
    children: [jsx(Heading, {
      renderAs: "h3",
      subtitle: true,
      children: "Printed work (book or booklet, article, pamphlet, etc.)"
    }), jsx(InputText, {
      name: "collector.additionalData.printInfo.title",
      label: "Title Of Our Printed Work",
      required: true
    }), jsx(InputText, {
      name: "collector.additionalData.printInfo.author",
      label: "Author",
      required: true
    }), jsx(InputText, {
      name: "collector.additionalData.printInfo.pageNumbers",
      label: "Page numbers requested",
      required: false
    }), jsx(InputText, {
      name: "collector.additionalData.printInfo.issueVolumes",
      label: "Issue/Volume (if applicable)"
    }), jsx(InputText, {
      name: "collector.additionalData.printInfo.copyright",
      label: "Copyright information shown in printed work",
      required: true
    }), jsx(InputText, {
      name: "collector.additionalData.printInfo.notes",
      label: "Please include the text of the excerpt, quote, poem, etc. that you want to use either in the space below or by uploading the content with the excerpt, quote, etc. highlighted",
      required: true
    }), jsx(FileUpload, {
      id: "printinfo",
      label: "Printed work"
    })]
  });
};

var PhotoInfo = function PhotoInfo() {
  return jsxs(Block, {
    children: [jsx(Heading, {
      renderAs: "h3",
      subtitle: true,
      children: "Photo"
    }), jsx(Block, {
      children: "Choose one of the below options to show or describe the photos you want to use:"
    }), jsx(InputText, {
      name: "collector.additionalData.photoInfo.link",
      label: "Include link to our photos"
    }), jsx(FileUpload, {
      id: "photoinfo",
      label: "Upload photos"
    }), jsx(TextArea, {
      label: "Describe photos, including dates, location, if known",
      name: "collector.additionalData.photoInfo.description"
    })]
  });
};

var AudioInfo = function AudioInfo() {
  return jsxs(Block, {
    children: [jsx(Heading, {
      renderAs: "h3",
      subtitle: true,
      children: "Audio/Video"
    }), jsx(InputText, {
      name: "collector.additionalData.audioInfo.title",
      label: "Title of our audio/video",
      required: true
    }), jsx(TextArea, {
      label: "Link to audio/video or describe audio/video if no link available*",
      name: "collector.additionalData.audioInfo.links",
      required: true
    }), jsx(TextArea, {
      label: "Provide time codes of audio/video clips you wish to use from our audio/visual material*",
      name: "collector.additionalData.audioInfo.timeCodes",
      required: true
    })]
  });
};

var WebInfo = function WebInfo() {
  return jsxs(Block, {
    children: [jsx(Heading, {
      renderAs: "h3",
      subtitle: true,
      children: "Website article"
    }), jsx(InputText, {
      name: "collector.additionalData.webInfo.link",
      label: "Links to articles",
      required: true
    }), jsx(TextArea, {
      label: "Please include the text of the section/excerpt/quote you want to use in the space below, or indicate you wish to use entire article*",
      name: "collector.additionalData.webInfo.text",
      required: true
    })]
  });
};

var OtherInfo = function OtherInfo() {
  return jsxs(Block, {
    children: [jsx(Heading, {
      renderAs: "h3",
      subtitle: true,
      children: "Other"
    }), jsx(TextArea, {
      label: "Describe content and provide links or upload pertinent information*",
      name: "collector.additionalData.otherInfo.description",
      required: true
    }), jsx(FileUpload, {
      id: "otherinfo",
      label: "Other"
    })]
  });
};

var OnlineInfo = function OnlineInfo() {
  return jsxs(Block, {
    children: [jsx(InputText, {
      name: "collector.additionalData.onlineInfo.link",
      label: "Name/URL of website(s) where our material will be posted",
      required: true
    }), jsx(Block, {
      pb: 3,
      children: "Note: We generally limit the number of words we allow to be placed online and the amount of time the content may appear on your site."
    }), jsx(InputText, {
      name: "collector.additionalData.onlineInfo.duration",
      label: "Duration of posting:",
      required: true
    })]
  });
};

var PublicationInfo = function PublicationInfo() {
  return jsxs(Block, {
    children: [jsx(InputText, {
      name: "collector.additionalData.publicationInfo.title",
      label: "Title of your publication",
      required: true
    }), jsx(InputText, {
      name: "collector.additionalData.publicationInfo.author",
      label: "Author of your publication",
      required: true
    }), jsx(InputText, {
      name: "collector.additionalData.publicationInfo.publisher",
      label: "Publisher of your publication",
      required: true
    }), jsx(InputText, {
      name: "collector.additionalData.publicationInfo.printRun",
      label: "Estimated print run",
      required: true
    }), jsx(InputText, {
      name: "collector.additionalData.publicationInfo.date",
      label: "Publication date",
      required: true
    }), jsx(InputText, {
      name: "collector.additionalData.publicationInfo.listPrice",
      label: "List price",
      required: true
    }), jsx(TextArea, {
      label: "Please describe your publication (topic, why our content fits, etc.)*",
      name: "collector.additionalData.publicationInfo.publicationDescription",
      required: true
    }), jsx(TextArea, {
      label: "Please specify which rights you are requesting*",
      name: "collector.additionalData.publicationInfo.rights",
      required: true
    }), jsx(InputText, {
      name: "collector.additionalData.publicationInfo.percentage",
      label: "Percentage of our material in your publication",
      required: true
    }), jsx(TextArea, {
      label: "Describe all additional material to be used in your publication*",
      name: "collector.additionalData.publicationInfo.additionalMaterial",
      required: true
    }), jsx(FileUpload, {
      id: "publicationinfo",
      label: "Upload the pages of your content containing our material and the text that will come immediately before and after (so we can see context of use)*",
      required: true
    }), jsx(TextArea, {
      label: "Any additional comments you\u2019d like to make about your publication",
      name: "collector.additionalData.publicationInfo.additionalComments"
    })]
  });
};

var AudiovisualInfo = function AudiovisualInfo() {
  return jsxs(Block, {
    children: [jsx(InputText, {
      name: "collector.additionalData.audiovisualInfo.title",
      label: "Title of your audiovisual product/project",
      required: true
    }), jsx(InputText, {
      name: "collector.additionalData.audiovisualInfo.length",
      label: "Total length of your audiovisual product/project (with our material, if approved)",
      required: true
    }), jsx(TextArea, {
      label: "Describe your audiovisual product/project (topic, all other content included, etc.)*",
      name: "collector.additionalData.audiovisualInfo.description",
      required: true
    }), jsx(TextArea, {
      label: "Describe how our material fits in your audiovisual product/project (why do you want to use our content?)*",
      name: "collector.additionalData.audiovisualInfo.materialFitsDescription",
      required: true
    }), jsx(Block, {
      children: "Choose one of the below options to show or describe your audiovisual product/project:"
    }), jsx(FileUpload, {
      id: "audiovisual1",
      label: "Upload script of your audiovisual product/project showing where our content is used."
    }), jsx(FileUpload, {
      id: "audiovisual2",
      label: "Upload your audiovisual product/project."
    }), jsx(InputText, {
      name: "collector.additionalData.audiovisualInfo.link",
      label: "Provide a link to your project",
      required: true
    })]
  });
};

var MaterialInfo = function MaterialInfo() {
  var _useMaterialInfo = useMaterialInfo(),
    materialAudioVisualOptions = _useMaterialInfo.materialAudioVisualOptions,
    materialOnlineOptions = _useMaterialInfo.materialOnlineOptions,
    materialPublicationOptions = _useMaterialInfo.materialPublicationOptions,
    showOnlineInfo = _useMaterialInfo.showOnlineInfo,
    showPublicationInfo = _useMaterialInfo.showPublicationInfo,
    showAudiovisualInfo = _useMaterialInfo.showAudiovisualInfo;
  return jsxs(Block, {
    children: [jsx(Block, {
      pb: 3,
      children: "Note: Permission will not be granted for use on commercial merchandise, CD albums, or in fictional works."
    }), jsxs(Content, {
      className: "material-info-content",
      children: [jsx(RadioGroup, {
        label: "Do you intend to post this material online?*",
        name: "collector.additionalData.materialInfo.materialOnline",
        options: materialOnlineOptions,
        required: true
      }), showOnlineInfo && jsx(OnlineInfo, {}), jsx(RadioGroup, {
        label: "Do you intend to include our material in your publication?*",
        name: "collector.additionalData.materialInfo.materialPublication",
        options: materialPublicationOptions,
        required: true
      }), showPublicationInfo && jsx(PublicationInfo, {}), jsx(RadioGroup, {
        label: "Do you intend to include this material in an audiovisual product / project?*",
        name: "collector.additionalData.materialInfo.materialAudioVisual",
        options: materialAudioVisualOptions,
        required: true
      }), showAudiovisualInfo && jsx(AudiovisualInfo, {})]
    }), jsx(TextArea, {
      label: "Describe in detail other use not listed above",
      name: "collector.additionalData.materialInfo.description",
      required: false
    })]
  });
};

var PermissionRequestInfo = function PermissionRequestInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _usePermissionRequest = usePermissionRequest(),
    displayList = _usePermissionRequest.displayList,
    showAudioVideoInfo = _usePermissionRequest.showAudioVideoInfo,
    showOtherInfo = _usePermissionRequest.showOtherInfo,
    showPhotoInfo = _usePermissionRequest.showPhotoInfo,
    showPrintInfo = _usePermissionRequest.showPrintInfo,
    showWebInfo = _usePermissionRequest.showWebInfo;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: "Requester Information",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          visibleList: ['Name', 'Email'],
          emailRequired: true,
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          required: true
        })), jsx(InputText, {
          name: "collector.additionalData.organizationName",
          label: "Organization / Ministry / School Name (if applicable)"
        }), jsx(InputText, {
          name: "collector.additionalData.title",
          label: "Title"
        }), jsx(InputText, {
          name: "collector.additionalData.website",
          label: "Website"
        }), jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
          autoComplete: false,
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          country: props === null || props === void 0 ? void 0 : props.country,
          entity: 0,
          index: 0,
          label: props === null || props === void 0 ? void 0 : props.addressLabel,
          required: true,
          showLabel: true,
          type: "MAIL",
          visibleList: displayList
        })), jsx(InputText, {
          name: "collector.entity[0].phone[0].phoneNumber",
          label: "Phone"
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: "BGEA Material Requested",
      formSectionFields: jsxs(Fragment, {
        children: [jsx("div", {
          className: "label",
          children: "What type of BGEA material are you requesting?*"
        }), jsxs(Content, {
          className: "material-requested-content",
          children: [jsx(Checkbox, {
            label: "Printed Work",
            name: "collector.additionalData.hasPrintInfo"
          }), jsx(Checkbox, {
            label: "Photo",
            name: "collector.additionalData.hasPhotoInfo"
          }), jsx(Checkbox, {
            label: "Audio/Video",
            name: "collector.additionalData.hasAudioVideoInfo"
          }), jsx(Checkbox, {
            label: "Web",
            name: "collector.additionalData.hasWebInfo"
          }), jsx(Checkbox, {
            label: "Other",
            name: "collector.additionalData.hasOtherInfo"
          }), showPrintInfo && jsx(PrintInfo, {}), showPhotoInfo && jsx(PhotoInfo, {}), showAudioVideoInfo && jsx(AudioInfo, {}), showWebInfo && jsx(WebInfo, {}), showOtherInfo && jsx(OtherInfo, {})]
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: "Your intended use of BGEA's material",
      formSectionFields: jsx(MaterialInfo, {}),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2({}, props)),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var PermissionRequestInfo$1 = PermissionRequestInfo;

var PermissionRequest = function PermissionRequest(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.PERMISSION_REQUEST;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(PermissionRequestInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var usePrayerRequest = function usePrayerRequest(_ref) {
  var displayList = _ref.displayList,
    emailName = _ref.emailName,
    emailLabel = _ref.emailLabel,
    questionsLabel = _ref.questionsLabel,
    addressLabel = _ref.addressLabel,
    headText = _ref.headText,
    footText = _ref.footText,
    addressVisible = _ref.addressVisible,
    nameRequired = _ref.nameRequired,
    addressRequired = _ref.addressRequired;
  var _useFormikContext = useFormikContext(),
    values = _useFormikContext.values,
    setFieldValue = _useFormikContext.setFieldValue;
  useEffect(function () {
    setFormId({
      templateName: Templates.PRAYER_REQUEST,
      values: values,
      setFieldValue: setFieldValue
    });
  }, []);
  return {
    displayList: displayList,
    emailName: emailName,
    emailLabel: emailLabel,
    questionsLabel: questionsLabel,
    addressLabel: addressLabel,
    headText: headText,
    footText: footText,
    addressVisible: addressVisible,
    nameRequired: nameRequired,
    addressRequired: addressRequired
  };
};

var PrayerRequestInfo = function PrayerRequestInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _usePrayerRequest = usePrayerRequest({
      displayList: ['Name'],
      emailName: 'collector.entity[0].email[0].emailAddress',
      emailLabel: 'Email Address',
      questionsLabel: 'Your Prayer Request',
      addressLabel: '',
      headText: 'Please enter your information and submit your prayer request below, and a member of the BGEA team will pray for you.',
      footText: 'To help further your faith journey, you will receive our next BGEA Today newsletter, filled with spiritual growth content and ministry updates. You can opt out of future emails at any time.',
      addressVisible: ['zipPostalCode'],
      nameRequired: true,
      addressRequired: true
    }),
    displayList = _usePrayerRequest.displayList,
    emailName = _usePrayerRequest.emailName,
    emailLabel = _usePrayerRequest.emailLabel,
    questionsLabel = _usePrayerRequest.questionsLabel,
    addressLabel = _usePrayerRequest.addressLabel,
    headText = _usePrayerRequest.headText,
    footText = _usePrayerRequest.footText,
    addressVisible = _usePrayerRequest.addressVisible,
    nameRequired = _usePrayerRequest.nameRequired,
    addressRequired = _usePrayerRequest.addressRequired;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: props === null || props === void 0 ? void 0 : props.title,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Content, {
          className: "content block-margin-bottom",
          pb: 3,
          children: headText
        }), jsx(Content, {
          className: "content block-margin-bottom",
          children: jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
            country: props === null || props === void 0 ? void 0 : props.country,
            visibleList: displayList,
            isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
            emailRequired: true,
            required: true
          }))
        }), jsx(InputEmail, {
          label: emailLabel,
          required: nameRequired,
          name: emailName
        }), jsx(Content, {
          className: "content block-margin-bottom",
          children: jsx(Address, _objectSpread2(_objectSpread2({}, props), {}, {
            autoComplete: false,
            country: props === null || props === void 0 ? void 0 : props.country,
            entity: 0,
            index: 0,
            label: addressLabel,
            required: addressRequired,
            showLabel: true,
            type: "MAIL",
            visibleList: addressVisible
          }))
        }), jsx(TextArea, {
          label: questionsLabel,
          name: "collector.communications[0].longComment"
        }), jsx(Content, {
          className: "content block-margin-bottom",
          children: footText
        })]
      }),
      hideTopBorder: true,
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2({}, props)),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var PrayerRequestInfo$1 = PrayerRequestInfo;

var PrayerRequest = function PrayerRequest(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.PRAYER_REQUEST;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(PrayerRequestInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var PrayerTeamMember = function PrayerTeamMember(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.PRAYER_TEAM_MEMBER;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: PrayerTeamConfirmation,
    children: jsx(PrayerTeamInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$4() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var BlockContainer = /*#__PURE__*/_styled(Block, process.env.NODE_ENV === "production" ? {
  target: "e7ldeau5"
} : {
  target: "e7ldeau5",
  label: "BlockContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "13udsys",
  styles: "height:100%"
} : {
  name: "13udsys",
  styles: "height:100%",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlByb2plY3RMaXN0SXRlbS50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBcUJvQyIsImZpbGUiOiJQcm9qZWN0TGlzdEl0ZW0udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHR5cGUgeyBDYXJ0SXRlbSwgQ2FydFByb2plY3QgfSBmcm9tICdAYmdlYS1qcy9iZy1mb3Jtcyc7XG5cbmltcG9ydCBzdHlsZWQgZnJvbSAnQGVtb3Rpb24vc3R5bGVkJztcbmltcG9ydCAqIGFzIGNvbG9ycyBmcm9tICdAYmdlYS1qcy9jb2xvcnMnO1xuaW1wb3J0IHsgQnV0dG9uLCBCbG9jaywgQ29sdW1ucywgRm9ybSwgSW1hZ2UgfSBmcm9tICdAYmdlYS1qcy9yZWFjdC11aSc7XG5pbXBvcnQgeyBtZWRpYVF1ZXJpZXMsIHRydW5jYXRlU3RyaW5nIH0gZnJvbSAnQGJnZWEtanMvcmVhY3QtdXRpbGl0aWVzJztcbmltcG9ydCB7IHVzZVRyYW5zbGF0aW9uIH0gZnJvbSAncmVhY3QtaTE4bmV4dCc7XG5pbXBvcnQgeyBDdXJyZW5jeSB9IGZyb20gJ0BiZ2VhLWpzL2JnLWZvcm1zJztcblxuaW1wb3J0IHsgdXNlUHJvamVjdExpc3RJdGVtIH0gZnJvbSAnLi4vLi4vaG9va3MvdXNlUHJvamVjdExpc3RJdGVtJztcblxuaW50ZXJmYWNlIFByb3BzIHtcbiAgaW5kZXg6IG51bWJlcjtcbiAgY2FydEluZm86IENhcnRJdGVtO1xuICBjdXJyZW5jeUVycm9yTWVzc2FnZTogc3RyaW5nO1xuICBoaWRlQWRkVG9DYXJ0PzogYm9vbGVhbjtcbiAgcHJvamVjdDogQ2FydFByb2plY3Q7XG4gIGhhbmRsZU9uQ2xlYXJDbGljazogKGV2ZW50LCBpbmRleCkgPT4gdm9pZDtcbiAgaGFuZGxlT25HaXZlQ2xpY2s6IChldmVudCwgaW5kZXgpID0+IHZvaWQ7XG59XG5cbmNvbnN0IEJsb2NrQ29udGFpbmVyID0gc3R5bGVkKEJsb2NrKWBcbiAgaGVpZ2h0OiAxMDAlO1xuYDtcblxuY29uc3QgQ29udGFpbmVyID0gc3R5bGVkKENvbHVtbnMpYFxuICBwYWRkaW5nOiAwO1xuICBtYXJnaW46IDA7XG4gIGRpc3BsYXk6IGZsZXg7XG4gIGZsZXgtZGlyZWN0aW9uOiBjb2x1bW4tcmV2ZXJzZTtcblxuICAke21lZGlhUXVlcmllcy5mb3JEZXNrdG9wVXB9IHtcbiAgICBmbGV4LWRpcmVjdGlvbjogcm93O1xuICB9XG5cbiAgJjpsYXN0LWNoaWxkIHtcbiAgICBtYXJnaW4tYm90dG9tOiAwO1xuICB9XG5gO1xuXG5jb25zdCBMaW5rID0gc3R5bGVkLmFgXG4gIGNvbG9yOiAke2NvbG9ycy5zdFRyb3Bhen07XG4gICY6aG92ZXIge1xuICAgIGNvbG9yOiAke2NvbG9ycy5zdFRyb3Bhen07XG4gICAgYmFja2dyb3VuZC1jb2xvcjogJHtjb2xvcnMud2hpdGV9O1xuICAgIGN1cnNvcjogcG9pbnRlcjtcbiAgfVxuYDtcblxuY29uc3QgSW1nID0gc3R5bGVkKEltYWdlKWBcbiAgd2lkdGg6IDEwMCU7XG4gIG1hcmdpbi1sZWZ0OiAwO1xuXG4gICYgaW1nIHtcbiAgICBtYXJnaW46IDA7XG4gIH1cbmA7XG5cbmNvbnN0IERlc2NyaXB0aW9uID0gc3R5bGVkLmRpdmBcbiAgZm9udC1zaXplOiAxcmVtO1xuICBtaW4taGVpZ2h0OiAxNTdweDtcbmA7XG5cbmNvbnN0IEhSID0gc3R5bGVkLmhyYFxuICBib3JkZXItdG9wOiAxcHggZG90dGVkICR7Y29sb3JzLmJsYWNrfTtcbiAgd2lkdGg6IDEwMHB4O1xuYDtcblxuY29uc3QgUHJvamVjdExpc3RJdGVtID0gKHtcbiAgaW5kZXgsXG4gIGNhcnRJbmZvLFxuICBjdXJyZW5jeUVycm9yTWVzc2FnZSxcbiAgaGlkZUFkZFRvQ2FydCA9IGZhbHNlLFxuICBwcm9qZWN0LFxuICBoYW5kbGVPbkNsZWFyQ2xpY2ssXG4gIGhhbmRsZU9uR2l2ZUNsaWNrLFxufTogUHJvcHMpID0+IHtcbiAgY29uc3Qge1xuICAgIHNob3dDbGVhclR4dCxcbiAgICBzaG93RXJyb3IsXG4gICAgc2hvd1RoYW5rWW91VHh0LFxuICAgIGhhbmRsZU9uQ2hhbmdlLFxuICAgIGhhbmRsZU9uUmVzZXRDbGljayxcbiAgICBoYW5kbGVPblVwZGF0ZU1lc3NhZ2UsXG4gIH0gPSB1c2VQcm9qZWN0TGlzdEl0ZW0oeyBjYXJ0SW5mbywgcHJvamVjdCB9KTtcbiAgY29uc3QgeyB0IH0gPSB1c2VUcmFuc2xhdGlvbihbJ2xhYmVscyddKTtcbiAgY29uc3QgZ2l2ZUJ1dHRvblRleHQgPVxuICAgICFzaG93VGhhbmtZb3VUeHQgJiYgIXNob3dDbGVhclR4dFxuICAgICAgPyB0KCdHaXZlJywgeyBuczogJ2xhYmVscycgfSlcbiAgICAgIDogdCgnVGhhbmsgeW91JywgeyBuczogJ2xhYmVscycgfSk7XG5cbiAgcmV0dXJuIChcbiAgICA8Q29udGFpbmVyIGtleT17cHJvamVjdC5wcm9qZWN0SWR9PlxuICAgICAgPENvbHVtbnMuQ29sdW1uXG4gICAgICAgIHB4PXsyfVxuICAgICAgICBwdD17Mn1cbiAgICAgICAgcGI9ezF9XG4gICAgICAgIGRlc2t0b3A9e3tcbiAgICAgICAgICBzaXplOiA3LFxuICAgICAgICB9fVxuICAgICAgICB0YWJsZXQ9e3tcbiAgICAgICAgICBzaXplOiAxMixcbiAgICAgICAgfX1cbiAgICAgICAgbW9iaWxlPXt7XG4gICAgICAgICAgc2l6ZTogMTIsXG4gICAgICAgIH19XG4gICAgICA+XG4gICAgICAgIDxCbG9ja0NvbnRhaW5lclxuICAgICAgICAgIGRpc3BsYXk9XCJmbGV4XCJcbiAgICAgICAgICBmbGV4RGlyZWN0aW9uPVwiY29sdW1uXCJcbiAgICAgICAgICBqdXN0aWZ5Q29udGVudD1cImZsZXgtc3RhcnRcIlxuICAgICAgICA+XG4gICAgICAgICAgPEJsb2NrIG1iPXsyfT5cbiAgICAgICAgICAgIDxoND5cbiAgICAgICAgICAgICAgPExpbmsgaHJlZj17YC8ke3Byb2plY3Quc2x1Z31gfT57cHJvamVjdC50aXRsZX08L0xpbms+XG4gICAgICAgICAgICA8L2g0PlxuICAgICAgICAgICAgPEhSIC8+XG4gICAgICAgICAgPC9CbG9jaz5cbiAgICAgICAgICA8QmxvY2s+XG4gICAgICAgICAgICA8RGVzY3JpcHRpb25cbiAgICAgICAgICAgICAgZGFuZ2Vyb3VzbHlTZXRJbm5lckhUTUw9e3tcbiAgICAgICAgICAgICAgICBfX2h0bWw6IHRydW5jYXRlU3RyaW5nKHByb2plY3QuZGVzY3JpcHRpb24sIDIzMCksXG4gICAgICAgICAgICAgIH19XG4gICAgICAgICAgICAvPlxuICAgICAgICAgIDwvQmxvY2s+XG4gICAgICAgIDwvQmxvY2tDb250YWluZXI+XG4gICAgICA8L0NvbHVtbnMuQ29sdW1uPlxuICAgICAgPENvbHVtbnMuQ29sdW1uXG4gICAgICAgIHB4PXsyfVxuICAgICAgICBwdD17Mn1cbiAgICAgICAgcGI9ezF9XG4gICAgICAgIGRlc2t0b3A9e3tcbiAgICAgICAgICBzaXplOiA1LFxuICAgICAgICB9fVxuICAgICAgICB0YWJsZXQ9e3tcbiAgICAgICAgICBzaXplOiAxMixcbiAgICAgICAgfX1cbiAgICAgICAgbW9iaWxlPXt7XG4gICAgICAgICAgc2l6ZTogMTIsXG4gICAgICAgIH19XG4gICAgICA+XG4gICAgICAgIDxCbG9ja0NvbnRhaW5lclxuICAgICAgICAgIGRpc3BsYXk9XCJmbGV4XCJcbiAgICAgICAgICBmbGV4RGlyZWN0aW9uPVwiY29sdW1uXCJcbiAgICAgICAgICBqdXN0aWZ5Q29udGVudD1cImZsZXgtc3RhcnRcIlxuICAgICAgICA+XG4gICAgICAgICAgPEJsb2NrPlxuICAgICAgICAgICAgPEltZyBzcmM9e3Byb2plY3QuaW1hZ2V9IC8+XG4gICAgICAgICAgPC9CbG9jaz5cbiAgICAgICAgICB7IWhpZGVBZGRUb0NhcnQgJiYgKFxuICAgICAgICAgICAgPEJsb2NrPlxuICAgICAgICAgICAgICA8Rm9ybS5GaWVsZCBraW5kPVwiYWRkb25zXCI+XG4gICAgICAgICAgICAgICAgPEZvcm0uQ29udHJvbD5cbiAgICAgICAgICAgICAgICAgIDxDdXJyZW5jeVxuICAgICAgICAgICAgICAgICAgICBuYW1lPXtgZm9ybUxvZ2ljLnByb2plY3RzWyR7aW5kZXh9XS5hbW91bnRgfVxuICAgICAgICAgICAgICAgICAgICBpbnB1dFNpemU9XCJub3JtYWxcIlxuICAgICAgICAgICAgICAgICAgICBkaXNhYmxlT25CbHVyIC8vIGRpc2FibGUgb25CbHVyIHRvIGF2b2lkIGNvbmZsaWN0XG4gICAgICAgICAgICAgICAgICAgIG9uQ2hhbmdlPXtoYW5kbGVPbkNoYW5nZX1cbiAgICAgICAgICAgICAgICAgIC8+XG4gICAgICAgICAgICAgICAgPC9Gb3JtLkNvbnRyb2w+XG4gICAgICAgICAgICAgICAgPEZvcm0uQ29udHJvbD5cbiAgICAgICAgICAgICAgICAgIHshc2hvd0NsZWFyVHh0ID8gKFxuICAgICAgICAgICAgICAgICAgICA8QnV0dG9uXG4gICAgICAgICAgICAgICAgICAgICAgb25DbGljaz17KGV2ZW50KSA9PiB7XG4gICAgICAgICAgICAgICAgICAgICAgICBoYW5kbGVPbkdpdmVDbGljayhldmVudCwgaW5kZXgpO1xuICAgICAgICAgICAgICAgICAgICAgICAgaGFuZGxlT25VcGRhdGVNZXNzYWdlKGV2ZW50KTtcbiAgICAgICAgICAgICAgICAgICAgICB9fVxuICAgICAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICAgICAge2dpdmVCdXR0b25UZXh0fVxuICAgICAgICAgICAgICAgICAgICA8L0J1dHRvbj5cbiAgICAgICAgICAgICAgICAgICkgOiAoXG4gICAgICAgICAgICAgICAgICAgIDxCdXR0b25cbiAgICAgICAgICAgICAgICAgICAgICBvbkNsaWNrPXsoZXZlbnQpID0+IHtcbiAgICAgICAgICAgICAgICAgICAgICAgIGhhbmRsZU9uQ2xlYXJDbGljayhldmVudCwgaW5kZXgpO1xuICAgICAgICAgICAgICAgICAgICAgICAgaGFuZGxlT25SZXNldENsaWNrKGV2ZW50KTtcbiAgICAgICAgICAgICAgICAgICAgICB9fVxuICAgICAgICAgICAgICAgICAgICA+XG4gICAgICAgICAgICAgICAgICAgICAgQ2xlYXJcbiAgICAgICAgICAgICAgICAgICAgPC9CdXR0b24+XG4gICAgICAgICAgICAgICAgICApfVxuICAgICAgICAgICAgICAgIDwvRm9ybS5Db250cm9sPlxuICAgICAgICAgICAgICA8L0Zvcm0uRmllbGQ+XG4gICAgICAgICAgICA8L0Jsb2NrPlxuICAgICAgICAgICl9XG5cbiAgICAgICAgICB7c2hvd0Vycm9yICYmIChcbiAgICAgICAgICAgIDxCbG9jaz5cbiAgICAgICAgICAgICAgPHAgY2xhc3NOYW1lPVwiaGVscCBpcy1kYW5nZXJcIj57Y3VycmVuY3lFcnJvck1lc3NhZ2V9PC9wPlxuICAgICAgICAgICAgPC9CbG9jaz5cbiAgICAgICAgICApfVxuICAgICAgICA8L0Jsb2NrQ29udGFpbmVyPlxuICAgICAgPC9Db2x1bW5zLkNvbHVtbj5cbiAgICA8L0NvbnRhaW5lcj5cbiAgKTtcbn07XG5cbmV4cG9ydCBkZWZhdWx0IFByb2plY3RMaXN0SXRlbTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
var Container = /*#__PURE__*/_styled(Columns, process.env.NODE_ENV === "production" ? {
  target: "e7ldeau4"
} : {
  target: "e7ldeau4",
  label: "Container"
})("padding:0;margin:0;display:flex;flex-direction:column-reverse;", mediaQueries.forDesktopUp, "{flex-direction:row;}&:last-child{margin-bottom:0;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Link = /*#__PURE__*/_styled("a", process.env.NODE_ENV === "production" ? {
  target: "e7ldeau3"
} : {
  target: "e7ldeau3",
  label: "Link"
})("color:", colors.stTropaz, ";&:hover{color:", colors.stTropaz, ";background-color:", colors.white, ";cursor:pointer;}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var Img = /*#__PURE__*/_styled(Image, process.env.NODE_ENV === "production" ? {
  target: "e7ldeau2"
} : {
  target: "e7ldeau2",
  label: "Img"
})(process.env.NODE_ENV === "production" ? {
  name: "1x6btkz",
  styles: "width:100%;margin-left:0;& img{margin:0;}"
} : {
  name: "1x6btkz",
  styles: "width:100%;margin-left:0;& img{margin:0;}",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
var Description$1 = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e7ldeau1"
} : {
  target: "e7ldeau1",
  label: "Description"
})(process.env.NODE_ENV === "production" ? {
  name: "s1f5ik",
  styles: "font-size:1rem;min-height:157px"
} : {
  name: "s1f5ik",
  styles: "font-size:1rem;min-height:157px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$4
});
var HR = /*#__PURE__*/_styled("hr", process.env.NODE_ENV === "production" ? {
  target: "e7ldeau0"
} : {
  target: "e7ldeau0",
  label: "HR"
})("border-top:1px dotted ", colors.black, ";width:100px;" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var ProjectListItem = function ProjectListItem(_ref) {
  var index = _ref.index,
    cartInfo = _ref.cartInfo,
    currencyErrorMessage = _ref.currencyErrorMessage,
    _ref$hideAddToCart = _ref.hideAddToCart,
    hideAddToCart = _ref$hideAddToCart === void 0 ? false : _ref$hideAddToCart,
    project = _ref.project,
    handleOnClearClick = _ref.handleOnClearClick,
    handleOnGiveClick = _ref.handleOnGiveClick;
  var _useProjectListItem = useProjectListItem({
      cartInfo: cartInfo,
      project: project
    }),
    showClearTxt = _useProjectListItem.showClearTxt,
    showError = _useProjectListItem.showError,
    showThankYouTxt = _useProjectListItem.showThankYouTxt,
    handleOnChange = _useProjectListItem.handleOnChange,
    handleOnResetClick = _useProjectListItem.handleOnResetClick,
    handleOnUpdateMessage = _useProjectListItem.handleOnUpdateMessage;
  var _useTranslation = useTranslation(['labels']),
    t = _useTranslation.t;
  var giveButtonText = !showThankYouTxt && !showClearTxt ? t('Give', {
    ns: 'labels'
  }) : t('Thank you', {
    ns: 'labels'
  });
  return jsxs(Container, {
    children: [jsx(Columns.Column, {
      px: 2,
      pt: 2,
      pb: 1,
      desktop: {
        size: 7
      },
      tablet: {
        size: 12
      },
      mobile: {
        size: 12
      },
      children: jsxs(BlockContainer, {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        children: [jsxs(Block, {
          mb: 2,
          children: [jsx("h4", {
            children: jsx(Link, {
              href: "/".concat(project.slug),
              children: project.title
            })
          }), jsx(HR, {})]
        }), jsx(Block, {
          children: jsx(Description$1, {
            dangerouslySetInnerHTML: {
              __html: truncateString(project.description, 230)
            }
          })
        })]
      })
    }), jsx(Columns.Column, {
      px: 2,
      pt: 2,
      pb: 1,
      desktop: {
        size: 5
      },
      tablet: {
        size: 12
      },
      mobile: {
        size: 12
      },
      children: jsxs(BlockContainer, {
        display: "flex",
        flexDirection: "column",
        justifyContent: "flex-start",
        children: [jsx(Block, {
          children: jsx(Img, {
            src: project.image
          })
        }), !hideAddToCart && jsx(Block, {
          children: jsxs(Form.Field, {
            kind: "addons",
            children: [jsx(Form.Control, {
              children: jsx(Currency, {
                name: "formLogic.projects[".concat(index, "].amount"),
                inputSize: "normal",
                disableOnBlur: true // disable onBlur to avoid conflict
                ,
                onChange: handleOnChange
              })
            }), jsx(Form.Control, {
              children: !showClearTxt ? jsx(Button, {
                onClick: function onClick(event) {
                  handleOnGiveClick(event, index);
                  handleOnUpdateMessage(event);
                },
                children: giveButtonText
              }) : jsx(Button, {
                onClick: function onClick(event) {
                  handleOnClearClick(event, index);
                  handleOnResetClick(event);
                },
                children: "Clear"
              })
            })]
          })
        }), showError && jsx(Block, {
          children: jsx("p", {
            className: "help is-danger",
            children: currencyErrorMessage
          })
        })]
      })
    })]
  }, project.projectId);
};
var ProjectListItem$1 = ProjectListItem;

var Column = /*#__PURE__*/_styled(Columns.Column, process.env.NODE_ENV === "production" ? {
  target: "e1e5c26n1"
} : {
  target: "e1e5c26n1",
  label: "Column"
})("font-size:1rem;border:0;border-bottom:1px dashed ", colors.doveGray, ";", mediaQueries.forDesktopUp, "{border-top:1px dashed ", colors.doveGray, ";border-right:", function (props) {
  return props.index % 2 === 0 ? "1px dashed ".concat(colors.doveGray) : '0';
}, ";border-bottom:", function (props) {
  return props.showBottomBorder ? "1px dashed ".concat(colors.doveGray) : '0';
}, ";}" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var H2 = /*#__PURE__*/_styled(Heading, process.env.NODE_ENV === "production" ? {
  target: "e1e5c26n0"
} : {
  target: "e1e5c26n0",
  label: "H2"
})(process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */");
var ProjectListInfo = function ProjectListInfo(_ref) {
  var checkoutPath = _ref.checkoutPath,
    currencyErrorMessage = _ref.currencyErrorMessage,
    headerText = _ref.headerText,
    _ref$hideAddToCart = _ref.hideAddToCart,
    hideAddToCart = _ref$hideAddToCart === void 0 ? false : _ref$hideAddToCart,
    projects = _ref.projects,
    siteId = _ref.siteId;
  var cartStorageKey = "".concat(siteId, "-").concat(CART_INFO);
  var _useProjectList = useProjectList({
      checkoutPath: checkoutPath,
      hideAddToCart: hideAddToCart,
      projects: projects,
      siteId: cartStorageKey
    }),
    cartCount = _useProjectList.cartCount,
    cartCountMessage = _useProjectList.cartCountMessage,
    cartInfo = _useProjectList.cartInfo,
    disableAddToCart = _useProjectList.disableAddToCart,
    handleOnCheckoutClick = _useProjectList.handleOnCheckoutClick,
    handleOnClearClick = _useProjectList.handleOnClearClick,
    handleOnGiveClick = _useProjectList.handleOnGiveClick;
  return jsxs(Fragment, {
    children: [cartCount > 0 && jsx(Box, {
      style: {
        position: 'sticky',
        top: '0',
        zIndex: '30'
      },
      children: jsxs(Columns, {
        className: "field has-addon",
        children: [jsx(Columns.Column, {
          children: jsx("span", {
            children: cartCountMessage
          })
        }), jsx(Columns.Column, {
          className: "has-text-right",
          children: jsx(Button, {
            onClick: handleOnCheckoutClick,
            children: "Checkout"
          })
        })]
      })
    }), headerText && jsx(Block, {
      textAlign: "left",
      py: 2,
      children: jsx(H2, {
        renderAs: "h2",
        size: 4,
        weight: "normal",
        children: headerText
      })
    }), jsx(Columns, {
      children: projects === null || projects === void 0 ? void 0 : projects.map(function (project, index) {
        var isEven = projects.length % 2 === 0;
        var showBottomBorder = !isEven && index === projects.length - 2;
        return jsx(Column, {
          index: index,
          showBottomBorder: showBottomBorder,
          size: 6,
          children: jsx(ProjectListItem$1, {
            cartInfo: cartInfo,
            currencyErrorMessage: currencyErrorMessage,
            hideAddToCart: disableAddToCart,
            index: index,
            project: project,
            handleOnClearClick: handleOnClearClick,
            handleOnGiveClick: handleOnGiveClick
          }, project.projectId)
        }, project.projectId);
      })
    })]
  });
};
var ProjectListInfo$1 = ProjectListInfo;

var ProjectList = function ProjectList(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.PROJECT_LIST;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    children: jsx(ProjectListInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$3 = ["required"];
var TimeInputField = function TimeInputField(_ref) {
  var props = _objectWithoutProperties(_ref, _excluded$3);
  return jsx(Form.Field, {
    children: jsxs(Columns, {
      children: [jsx(Columns.Column, {
        size: 5,
        children: jsx(DateCalendar, {
          label: props.dateSelectionLabel,
          name: props.dateSelectionName,
          required: true
        })
      }), jsx(Columns.Column, {
        size: 7,
        children: jsx(InputTime, {
          label: props.timeSelectionLabel,
          name: props.timeSelectionName,
          required: true
        })
      })]
    })
  });
};

var ServiceReviewInfo = function ServiceReviewInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useServiceReview = useServiceReview(_objectSpread2({}, props)),
    additionalFeedbackLabel = _useServiceReview.additionalFeedbackLabel,
    alternateDateSelectionLabel = _useServiceReview.alternateDateSelectionLabel,
    alternateTimeSelectionLabel = _useServiceReview.alternateTimeSelectionLabel,
    InterviewDateSelectionText = _useServiceReview.InterviewDateSelectionText,
    majorMinistryMomentLabel = _useServiceReview.majorMinistryMomentLabel,
    ministryRecommendationLabel = _useServiceReview.ministryRecommendationLabel,
    optionLabelObj = _useServiceReview.optionLabelObj,
    primaryDateSelectionLabel = _useServiceReview.primaryDateSelectionLabel,
    primaryTimeSelectionLabel = _useServiceReview.primaryTimeSelectionLabel,
    serviceReviewHeaderMarkup = _useServiceReview.serviceReviewHeaderMarkup,
    supportNeedsLabel = _useServiceReview.supportNeedsLabel,
    trainingPreparationLabel = _useServiceReview.trainingPreparationLabel,
    valueEnhancementLabel = _useServiceReview.valueEnhancementLabel;
  return jsxs(Container$1, {
    children: [props.hasServiceReviewHeader && jsx(CustomMarkupSection, {
      customMarkup: serviceReviewHeaderMarkup
    }), jsx(Name$1, {
      required: true
    }), jsx(InputEmail, {
      required: true
    }), jsx(TextArea, {
      label: trainingPreparationLabel,
      name: "formLogic.SFJServiceReviewData.trainingPreparation",
      required: true
    }), jsx(TextArea, {
      label: majorMinistryMomentLabel,
      name: "formLogic.SFJServiceReviewData.majorMinistryMoment",
      required: true
    }), jsx(TextArea, {
      label: supportNeedsLabel,
      name: "formLogic.SFJServiceReviewData.supportNeeds",
      required: true
    }), jsx(TextArea, {
      label: valueEnhancementLabel,
      name: "formLogic.SFJServiceReviewData.valueEnhancement",
      required: true
    }), jsx(RadioGroup, {
      display: "is-block",
      label: ministryRecommendationLabel,
      name: "formLogic.SFJServiceReviewData.ministryRecommendation",
      options: [{
        label: optionLabelObj.yes,
        name: 'recommendOptionsGroup',
        value: 'Yes'
      }, {
        label: optionLabelObj.no,
        name: 'recommendOptionsGroup',
        value: 'No'
      }, {
        label: optionLabelObj.notSure,
        name: 'recommendOptionsGroup',
        value: 'NotSure'
      }],
      required: true
    }), jsx(Heading, {
      size: 6,
      children: InterviewDateSelectionText
    }), jsx(TimeInputField, {
      dateSelectionLabel: primaryDateSelectionLabel,
      dateSelectionName: "formLogic.SFJServiceReviewData.primaryInterviewDate",
      timeSelectionLabel: primaryTimeSelectionLabel,
      timeSelectionName: "formLogic.SFJServiceReviewData.primaryInterviewTime",
      required: true
    }), jsx(TimeInputField, {
      dateSelectionLabel: alternateDateSelectionLabel,
      dateSelectionName: "formLogic.SFJServiceReviewData.alternateInterviewDate",
      timeSelectionLabel: alternateTimeSelectionLabel,
      timeSelectionName: "formLogic.SFJServiceReviewData.alternateInterviewTime",
      required: true
    }), jsx(TextArea, {
      label: additionalFeedbackLabel,
      name: "formLogic.SFJServiceReviewData.additionalFeedback"
    }), jsx(SubmitButton, {})]
  });
};
var ServiceReviewInfo$1 = ServiceReviewInfo;

var ServiceReview = function ServiceReview(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.SERVICE_REVIEW;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(ServiceReviewInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var SingleDonation = function SingleDonation(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.SINGLE_DONATION;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    collectionType: 1,
    emailId: (props === null || props === void 0 ? void 0 : props.emailId) || 'DonationReceiptBGEA',
    SESourceCode: (props === null || props === void 0 ? void 0 : props.SESourceCode) || 'BY000INTR',
    shouldNotSetLanguageCode: true,
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(SingleDonationInfo, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$3() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var Description = /*#__PURE__*/_styled(Block, process.env.NODE_ENV === "production" ? {
  target: "e126dgy21"
} : {
  target: "e126dgy21",
  label: "Description"
})(process.env.NODE_ENV === "production" ? {
  name: "1asa47e",
  styles: "font-weight:300;padding-left:17px;cursor:pointer"
} : {
  name: "1asa47e",
  styles: "font-weight:300;padding-left:17px;cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
var Name = /*#__PURE__*/_styled("strong", process.env.NODE_ENV === "production" ? {
  target: "e126dgy20"
} : {
  target: "e126dgy20",
  label: "Name"
})(process.env.NODE_ENV === "production" ? {
  name: "e0dnmk",
  styles: "cursor:pointer"
} : {
  name: "e0dnmk",
  styles: "cursor:pointer",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$3
});
var SubscriptionInfo = function SubscriptionInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useSubscriptionInfo = useSubscriptionInfo(_objectSpread2({}, props)),
    headerCopy = _useSubscriptionInfo.headerCopy,
    subscriptionInfo = _useSubscriptionInfo.subscriptionInfo,
    handleUnsubscribeAll = _useSubscriptionInfo.handleUnsubscribeAll;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      formHeaderCopy: headerCopy,
      isFormHeader: true,
      isEmbedSite: true,
      hideTopBorder: true
    }), subscriptionInfo === null || subscriptionInfo === void 0 ? void 0 : subscriptionInfo.list.map(function (subscription) {
      var _subscription$title;
      return jsx(FormSection$1, {
        formSectionHeader: subscription.title,
        isEmbedSite: true,
        paddingTop: "light",
        formSectionFields: subscription.list.map(function (item) {
          return jsx(Block, {
            className: "subscription-item-block",
            children: jsx(Checkbox, {
              isChecked: item.isUserSubscribed,
              name: "formLogic.esubs.".concat(item.esub),
              label: jsxs(Fragment, {
                children: [jsx(Name, {
                  children: item.name
                }), jsx("br", {}), jsx(Description, {
                  children: jsx("span", {
                    dangerouslySetInnerHTML: {
                      __html: item.description
                    }
                  })
                })]
              })
            })
          }, item.esub);
        })
      }, (_subscription$title = subscription.title) === null || _subscription$title === void 0 ? void 0 : _subscription$title.replace(' ', ''));
    }), jsx(FormSection$1, {
      isEmbedSite: true,
      formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
        isEmbedSite: true,
        text: "Submit"
      })),
      hideTopBorder: true,
      paddingTop: "light",
      paddingBottom: "standard"
    }), (props === null || props === void 0 ? void 0 : props.showUnsubscribeButton) && jsx(FormSection$1, {
      isEmbedSite: true,
      formSectionFields: jsxs(Block, {
        paddingless: true,
        marginless: true,
        children: [props === null || props === void 0 ? void 0 : props.unsubscribeCopy, ' ', jsx(Button, {
          className: "unsubscribe-all-button",
          onClick: handleUnsubscribeAll,
          pl: 0,
          ml: 0,
          text: true,
          children: (props === null || props === void 0 ? void 0 : props.unsubscribeLinkText) || 'Unsubscribe'
        })]
      }),
      hideTopBorder: true,
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var SubscriptionInfo$1 = SubscriptionInfo;

var Subscriptions = function Subscriptions(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.SUBSCRIPTIONS;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: SubscriptionConfirmation,
    children: jsx(SubscriptionInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$2 = ["productCode", "country", "codes"];
function _EMOTION_STRINGIFIED_CSS_ERROR__$2() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var StyledHr = /*#__PURE__*/_styled("hr", process.env.NODE_ENV === "production" ? {
  target: "eajy6kn1"
} : {
  target: "eajy6kn1",
  label: "StyledHr"
})(process.env.NODE_ENV === "production" ? {
  name: "ueflxb",
  styles: "border-top:1px solid #e0e0e0;border-bottom:none;color:transparent;background-color:transparent"
} : {
  name: "ueflxb",
  styles: "border-top:1px solid #e0e0e0;border-bottom:none;color:transparent;background-color:transparent",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$2
});
var Title = /*#__PURE__*/_styled(Heading, process.env.NODE_ENV === "production" ? {
  target: "eajy6kn0"
} : {
  target: "eajy6kn0",
  label: "Title"
})("padding:0.5em 0;border-bottom:1px solid ", colors.silverChalice, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */"));
var TrainingRegistrationInfo = function TrainingRegistrationInfo(_ref) {
  var productCode = _ref.productCode,
    _ref$country = _ref.country,
    country = _ref$country === void 0 ? [] : _ref$country,
    codes = _ref.codes,
    props = _objectWithoutProperties(_ref, _excluded$2);
  var _useTrainingRegistrat = useTrainingRegistration({
      productCode: productCode,
      codes: codes
    }),
    giftOptions = _useTrainingRegistrat.giftOptions,
    hasPromoCode = _useTrainingRegistrat.hasPromoCode,
    isPromoCodeInvalid = _useTrainingRegistrat.isPromoCodeInvalid,
    isGift = _useTrainingRegistrat.isGift,
    products = _useTrainingRegistrat.products,
    totalPrice = _useTrainingRegistrat.totalPrice,
    handleOnClickPromoCode = _useTrainingRegistrat.handleOnClickPromoCode;
  return jsxs(Fragment, {
    children: [jsx(PromoCode$1, {
      hasPromoCode: hasPromoCode,
      isPromoCodeInvalid: isPromoCodeInvalid,
      handleOnClickPromoCode: handleOnClickPromoCode
    }), jsxs(Box, {
      children: [jsx(Form.Label, {
        size: "large",
        children: "CHECKOUT SUMMARY"
      }), jsx(StyledHr, {}), products.map(function (product) {
        return jsxs(Columns, {
          className: "is-vcentered",
          children: [jsxs(Columns.Column, {
            children: [product.description, " Online Training"]
          }), jsx(Columns.Column, {
            textAlign: "right",
            children: jsx("b", {
              children: product.price
            })
          })]
        }, product.description);
      }), jsx(StyledHr, {}), jsxs(Columns, {
        className: "is-vcentered",
        children: [jsx(Columns.Column, {}), jsx(Columns.Column, {
          textAlign: "right",
          children: "Total"
        }), jsx(Columns.Column, {
          textAlign: "right",
          children: jsx("b", {
            children: totalPrice
          })
        })]
      })]
    }), jsxs(Box, {
      children: [jsx(Title, {
        subtitle: true,
        children: "IS THIS A GIFT REGISTRATION?"
      }), jsx(RadioGroup, {
        label: "",
        name: "formLogic.isGift",
        options: giftOptions,
        display: "is-block",
        required: true
      }), isGift && jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
        visibleList: ['Name', 'Email', 'Address'],
        addressVisibleList: ['country', 'cityTownRegion', 'zipPostalCode'],
        entity: 1,
        country: country,
        emailRequired: true,
        required: true
      }))]
    }), jsxs(Box, {
      children: [jsx(Title, {
        subtitle: true,
        children: "PAYMENT METHOD"
      }), jsx(PaymentMethod, _objectSpread2(_objectSpread2({}, props), {}, {
        displayList: ['Name', 'Email', 'Phone', 'Address']
      }))]
    })]
  });
};

var TrainingRegistration = function TrainingRegistration(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.TRAINING_REGISTRATION;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    shouldNotSetLanguageCode: true,
    templateName: templateName,
    Confirmation: TrainingRegistrationConfirmation,
    children: jsx(TrainingRegistrationInfo, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var _excluded$1 = ["eventId", "textOptIn", "values", "setFieldValue"];
var handleOptInText = function handleOptInText(_ref) {
  var _values$collector, _values$collector$ent, _values$collector$ent2;
  var eventId = _ref.eventId,
    textOptIn = _ref.textOptIn,
    values = _ref.values,
    setFieldValue = _ref.setFieldValue,
    props = _objectWithoutProperties(_ref, _excluded$1);
  var resetCodeArr = (values === null || values === void 0 ? void 0 : (_values$collector = values.collector) === null || _values$collector === void 0 ? void 0 : (_values$collector$ent = _values$collector.entity[0]) === null || _values$collector$ent === void 0 ? void 0 : (_values$collector$ent2 = _values$collector$ent.code) === null || _values$collector$ent2 === void 0 ? void 0 : _values$collector$ent2.filter(function (item) {
    return (item === null || item === void 0 ? void 0 : item.value) !== (props === null || props === void 0 ? void 0 : props.optInAttrValue);
  })) || [];
  if (textOptIn && textOptIn[0]) {
    var text = JSON.parse(textOptIn[0]);
    setFieldValue("collector.entity[0].code", [].concat(_toConsumableArray(resetCodeArr), [{
      key: "CRUSADE:".concat(eventId),
      value: text.value
    }]));
  } else {
    setFieldValue("collector.entity[0].code", _toConsumableArray(resetCodeArr));
  }
};

var _excluded = ["ageGroup", "eventId", "shirtSizes", "shirtSizesByRoles", "showPrefix"];
var useVolunteer = function useVolunteer(_ref) {
  var _values$formLogic, _values$formLogic2;
  var ageGroup = _ref.ageGroup,
    eventId = _ref.eventId,
    shirtSizes = _ref.shirtSizes,
    shirtSizesByRoles = _ref.shirtSizesByRoles,
    showPrefix = _ref.showPrefix,
    props = _objectWithoutProperties(_ref, _excluded);
  var _useTranslationHelper = useTranslationHelper(),
    translations = _useTranslationHelper.translations;
  var _useFormikContext = useFormikContext(),
    setFieldValue = _useFormikContext.setFieldValue,
    values = _useFormikContext.values;
  useAgeGroup(_objectSpread2({
    ageGroup: ageGroup,
    eventId: eventId
  }, props));
  useChurchInfo(_objectSpread2({
    eventId: eventId
  }, props));
  useCode(_objectSpread2({
    eventId: eventId,
    shirtSizes: shirtSizes
  }, props));
  var _useShirtSizes = useShirtSizes(_objectSpread2({
      eventId: eventId,
      shirtSizes: shirtSizes,
      shirtSizesByRoles: shirtSizesByRoles
    }, props)),
    showShirtSizes = _useShirtSizes.showShirtSizes;
  var visibleList = [].concat(_toConsumableArray(showPrefix ? ['prefix'] : []), ['firstName', 'lastName']);
  var isUnder18 = (values === null || values === void 0 ? void 0 : (_values$formLogic = values.formLogic) === null || _values$formLogic === void 0 ? void 0 : _values$formLogic.ageGroup) === '8' || (values === null || values === void 0 ? void 0 : (_values$formLogic2 = values.formLogic) === null || _values$formLogic2 === void 0 ? void 0 : _values$formLogic2.ageGroup) === '9';
  useEffect(function () {
    handleOver18({
      setFieldValue: setFieldValue,
      values: values
    });
  }, [values.formLogic.ageGroup]);
  useEffect(function () {
    handleUnder18({
      setFieldValue: setFieldValue,
      values: values
    });
  }, [values.formLogic.under18]);
  useEffect(function () {
    if (props !== null && props !== void 0 && props.optInAttrValue && Array.isArray(values.formLogic.textOptIn)) {
      handleOptInText(_objectSpread2({
        eventId: eventId,
        textOptIn: values.formLogic.textOptIn,
        values: values,
        setFieldValue: setFieldValue
      }, props));
    }
  }, [values.formLogic.textOptIn]);
  useEffect(function () {
    var _props$entityVisibleL, _props$entityVisibleL2, _props$entityVisibleL3;
    setFormId({
      templateName: "".concat(Templates.VOLUNTEER, "_1"),
      values: values,
      setFieldValue: setFieldValue
    });
    setFieldValue('formLogic.templateName', "".concat(Templates.VOLUNTEER, "_1"));
    setFieldValue('formLogic.ageGroup', '', false);
    setFieldValue('formLogic.under18.legalGuardianName', '', false);
    setFieldValue('formLogic.under18.legalGuardianEmail', '', false);
    setFieldValue('formLogic.under18.emergencyContactName', '', false);
    setFieldValue('formLogic.under18.emergencyContactPhone', '', false);
    if ((props === null || props === void 0 ? void 0 : (_props$entityVisibleL = props.entityVisibleList) === null || _props$entityVisibleL === void 0 ? void 0 : _props$entityVisibleL.length) > 0 && props !== null && props !== void 0 && (_props$entityVisibleL2 = props.entityVisibleList) !== null && _props$entityVisibleL2 !== void 0 && _props$entityVisibleL2.includes('Phone') && props !== null && props !== void 0 && (_props$entityVisibleL3 = props.entityVisibleList) !== null && _props$entityVisibleL3 !== void 0 && _props$entityVisibleL3.includes('MobilePhone')) {
      setFieldValue('collector.entity[0].phone[1].phoneNumber', '');
    }
  }, []);
  return {
    isUnder18: isUnder18,
    showShirtSizes: showShirtSizes,
    visibleList: visibleList,
    yourChurchInformationLabel: translations.yourChurchInformationLabel,
    yourInformationLabel: translations.yourInformationLabel
  };
};

var VolunteerInfo = function VolunteerInfo(_ref) {
  var _props$roles, _props$shirtSizes;
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useTranslation = useTranslation(['common', 'labels', 'validation']),
    t = _useTranslation.t;
  var _useVolunteer = useVolunteer(_objectSpread2({
      ageGroup: props === null || props === void 0 ? void 0 : props.ageGroup,
      eventId: props === null || props === void 0 ? void 0 : props.eventId,
      shirtSizesByRoles: props === null || props === void 0 ? void 0 : props.shirtSizesByRoles,
      shirtSizes: props === null || props === void 0 ? void 0 : props.shirtSizes,
      showPrefix: props === null || props === void 0 ? void 0 : props.showPrefix
    }, props)),
    isUnder18 = _useVolunteer.isUnder18,
    showShirtSizes = _useVolunteer.showShirtSizes,
    visibleList = _useVolunteer.visibleList,
    yourChurchInformationLabel = _useVolunteer.yourChurchInformationLabel,
    yourInformationLabel = _useVolunteer.yourInformationLabel;
  var PrivacyPolicyCopy = props === null || props === void 0 ? void 0 : props.privacyPolicyCopy;
  return jsxs(Container$1, {
    children: [(props === null || props === void 0 ? void 0 : props.formHeaderTitle) && (props === null || props === void 0 ? void 0 : props.formHeaderCopy) && jsx(FormSection$1, {
      formSectionHeader: props === null || props === void 0 ? void 0 : props.formHeaderTitle,
      formHeaderCopy: props === null || props === void 0 ? void 0 : props.formHeaderCopy,
      isFormHeader: true,
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: yourInformationLabel,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Name$1, {
          visibleList: visibleList,
          isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
          required: true,
          nameTitles: props === null || props === void 0 ? void 0 : props.nameTitles,
          showNameLabel: props === null || props === void 0 ? void 0 : props.showNameLabel
        }), jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'],
          phoneType: (props === null || props === void 0 ? void 0 : props.phoneType) || 'HOME',
          country: props === null || props === void 0 ? void 0 : props.country,
          visibleList: (props === null || props === void 0 ? void 0 : props.entityVisibleList) || ['Email', 'Phone', 'Address'],
          emailRequired: true,
          required: true,
          phoneRequired: props === null || props === void 0 ? void 0 : props.phoneRequired,
          mobilePhoneRequired: props === null || props === void 0 ? void 0 : props.mobilePhoneRequired,
          mobilePhoneDisclaimer: props === null || props === void 0 ? void 0 : props.mobilePhoneDisclaimer,
          phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer
        }, props)), (props === null || props === void 0 ? void 0 : props.ageGroup) && jsx(Dropdown, {
          label: "Age Group",
          name: "formLogic.ageGroup",
          options: props === null || props === void 0 ? void 0 : props.ageGroup,
          required: true
        }), isUnder18 && jsxs(Fragment, {
          children: [jsx(InputText, {
            name: "formLogic.under18.legalGuardianName",
            label: "Parent/Legal Guardian Name*",
            required: true
          }), jsx(InputEmail, {
            name: "formLogic.under18.legalGuardianEmail",
            label: "Parent/Legal Guardian Email*",
            required: true
          }), jsx(InputText, {
            name: "formLogic.under18.emergencyContactName",
            label: "Emergency Contact Name*",
            required: true
          }), jsx(InputPhone, {
            name: "formLogic.under18.emergencyContactPhone",
            label: "Emergency Contact Phone*",
            phoneDisclaimer: props === null || props === void 0 ? void 0 : props.phoneDisclaimer,
            required: true,
            minPhoneLength: 10
          })]
        })]
      }),
      hideTopBorder: true,
      paddingTop: "light"
    }), ((props === null || props === void 0 ? void 0 : props.roles) || showShirtSizes) && jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: "Become an Event Volunteer",
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Form.Control, {
          children: props === null || props === void 0 ? void 0 : (_props$roles = props.roles) === null || _props$roles === void 0 ? void 0 : _props$roles.map(function (role) {
            return jsxs(Fragment, {
              children: [(role === null || role === void 0 ? void 0 : role.copy) && jsx(Block, {
                children: role === null || role === void 0 ? void 0 : role.copy
              }), jsx(Checkbox, {
                id: "formLogic.role",
                name: "formLogic.role",
                label: role === null || role === void 0 ? void 0 : role.label,
                valueObj: role
              }, role === null || role === void 0 ? void 0 : role.crusadeCodeEventRoleId)]
            });
          })
        }), showShirtSizes && (props === null || props === void 0 ? void 0 : (_props$shirtSizes = props.shirtSizes) === null || _props$shirtSizes === void 0 ? void 0 : _props$shirtSizes.length) > 0 && jsx(Dropdown, {
          name: "formLogic.codeId",
          label: "T-Shirt Size",
          required: true,
          options: props === null || props === void 0 ? void 0 : props.shirtSizes
        })]
      }),
      paddingTop: "light"
    }), (props === null || props === void 0 ? void 0 : props.showChurchInfo) && jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: yourChurchInformationLabel,
      formSectionFields: jsx(Church, _objectSpread2(_objectSpread2({}, props), {}, {
        orgRoles: props === null || props === void 0 ? void 0 : props.orgRoles,
        country: props === null || props === void 0 ? void 0 : props.country,
        addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'],
        isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
        requiredList: (props === null || props === void 0 ? void 0 : props.requiredChurchList) || ['OrganizationName', 'OrganizationRole', 'Phone', 'Address'],
        phoneFieldName: "collector.entity[1].phone[0].phoneNumber",
        phoneType: (props === null || props === void 0 ? void 0 : props.churchPhoneType) || 'WORK',
        showAddressLabel: props === null || props === void 0 ? void 0 : props.showAddressLabel
      })),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: props !== null && props !== void 0 && props.isEmbedSite ? 'PRIVACY POLICY' : '',
      formSectionFields: jsx(Fragment, {
        children: jsx(Box, {
          mx: 1,
          my: 5,
          children: props !== null && props !== void 0 && props.privacyPolicyCopy ? jsx("div", {
            children: jsx(PrivacyPolicyCopy, {})
          }) : jsxs("p", {
            children: ["*", jsx("span", {
              dangerouslySetInnerHTML: {
                __html: t('privacyAgreement', {
                  ns: 'common',
                  interpolation: {
                    escapeValue: false
                  }
                })
              }
            })]
          })
        })
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
        color: props !== null && props !== void 0 && props.isNewSubmitButton ? '#1a1a1a' : '',
        isNewSubmitButton: props === null || props === void 0 ? void 0 : props.isNewSubmitButton
      })),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var VolunteerInfo$1 = VolunteerInfo;

var Volunteer = function Volunteer(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = "".concat(Templates.VOLUNTEER, "_1");
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(VolunteerInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

function _EMOTION_STRINGIFIED_CSS_ERROR__$1() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var StepsContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dssb5b1"
} : {
  target: "e1dssb5b1",
  label: "StepsContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1wfbt6a",
  styles: "display:block;border-bottom:2px solid #333;width:100%;height:3rem;padding:0.5rem 0"
} : {
  name: "1wfbt6a",
  styles: "display:block;border-bottom:2px solid #333;width:100%;height:3rem;padding:0.5rem 0",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlZvbHVudGVlclN0ZXBzSW5mby50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBZ0JpQyIsImZpbGUiOiJWb2x1bnRlZXJTdGVwc0luZm8udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbnRlcmZhY2UgU3R5bGVkU3RlcHJvcHMge1xuICBpc0FjdGl2ZTogYm9vbGVhbjtcbn1cblxuaW50ZXJmYWNlIFJDb21wb25lbnQge1xuICBjb21wb25lbnQ6IFJlYWN0LkVsZW1lbnRUeXBlO1xuICBpZDogc3RyaW5nO1xufVxuXG5pbnRlcmZhY2UgU3RlcHNQcm9wcyB7XG4gIHBhZ2VJbmRleDogbnVtYmVyO1xuICBwYWdlczogUkNvbXBvbmVudFtdO1xufVxuXG5jb25zdCBTdGVwc0NvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGJsb2NrO1xuICBib3JkZXItYm90dG9tOiAycHggc29saWQgIzMzMztcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogM3JlbTtcbiAgcGFkZGluZzogMC41cmVtIDA7XG5gO1xuXG5jb25zdCBTdGVwSXRlbSA9IHN0eWxlZC5kaXY8U3R5bGVkU3RlcHJvcHM+YFxuICBwYWRkaW5nOiAwLjVyZW07XG4gIGRpc3BsYXk6IGlubGluZTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHsocHJvcHMpID0+IChwcm9wcz8uaXNBY3RpdmUgPyAnI2RkZCcgOiAndHJhbnNwYXJlbnQnKX07XG5gO1xuXG5leHBvcnQgY29uc3QgVm9sdW50ZWVyU3RlcHNJbmZvID0gKHsgcGFnZUluZGV4LCBwYWdlcyB9OiBTdGVwc1Byb3BzKSA9PiAoXG4gIDxTdGVwc0NvbnRhaW5lcj5cbiAgICB7cGFnZXM/Lm1hcCgocGFnZSwgaWR4KSA9PiAoXG4gICAgICA8U3RlcEl0ZW0ga2V5PXtwYWdlPy5pZH0gaXNBY3RpdmU9e3BhZ2VJbmRleCA9PT0gaWR4fT5cbiAgICAgICAge2lkeCArIDF9XG4gICAgICA8L1N0ZXBJdGVtPlxuICAgICkpfVxuICA8L1N0ZXBzQ29udGFpbmVyPlxuKTtcbiJdfQ== */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__$1
});
var StepItem = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1dssb5b0"
} : {
  target: "e1dssb5b0",
  label: "StepItem"
})("padding:0.5rem;display:inline;background-color:", function (props) {
  return props !== null && props !== void 0 && props.isActive ? '#ddd' : 'transparent';
}, ";" + (process.env.NODE_ENV === "production" ? "" : "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIlZvbHVudGVlclN0ZXBzSW5mby50c3giXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6IkFBd0IyQyIsImZpbGUiOiJWb2x1bnRlZXJTdGVwc0luZm8udHN4Iiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHN0eWxlZCBmcm9tICdAZW1vdGlvbi9zdHlsZWQnO1xuXG5pbnRlcmZhY2UgU3R5bGVkU3RlcHJvcHMge1xuICBpc0FjdGl2ZTogYm9vbGVhbjtcbn1cblxuaW50ZXJmYWNlIFJDb21wb25lbnQge1xuICBjb21wb25lbnQ6IFJlYWN0LkVsZW1lbnRUeXBlO1xuICBpZDogc3RyaW5nO1xufVxuXG5pbnRlcmZhY2UgU3RlcHNQcm9wcyB7XG4gIHBhZ2VJbmRleDogbnVtYmVyO1xuICBwYWdlczogUkNvbXBvbmVudFtdO1xufVxuXG5jb25zdCBTdGVwc0NvbnRhaW5lciA9IHN0eWxlZC5kaXZgXG4gIGRpc3BsYXk6IGJsb2NrO1xuICBib3JkZXItYm90dG9tOiAycHggc29saWQgIzMzMztcbiAgd2lkdGg6IDEwMCU7XG4gIGhlaWdodDogM3JlbTtcbiAgcGFkZGluZzogMC41cmVtIDA7XG5gO1xuXG5jb25zdCBTdGVwSXRlbSA9IHN0eWxlZC5kaXY8U3R5bGVkU3RlcHJvcHM+YFxuICBwYWRkaW5nOiAwLjVyZW07XG4gIGRpc3BsYXk6IGlubGluZTtcbiAgYmFja2dyb3VuZC1jb2xvcjogJHsocHJvcHMpID0+IChwcm9wcz8uaXNBY3RpdmUgPyAnI2RkZCcgOiAndHJhbnNwYXJlbnQnKX07XG5gO1xuXG5leHBvcnQgY29uc3QgVm9sdW50ZWVyU3RlcHNJbmZvID0gKHsgcGFnZUluZGV4LCBwYWdlcyB9OiBTdGVwc1Byb3BzKSA9PiAoXG4gIDxTdGVwc0NvbnRhaW5lcj5cbiAgICB7cGFnZXM/Lm1hcCgocGFnZSwgaWR4KSA9PiAoXG4gICAgICA8U3RlcEl0ZW0ga2V5PXtwYWdlPy5pZH0gaXNBY3RpdmU9e3BhZ2VJbmRleCA9PT0gaWR4fT5cbiAgICAgICAge2lkeCArIDF9XG4gICAgICA8L1N0ZXBJdGVtPlxuICAgICkpfVxuICA8L1N0ZXBzQ29udGFpbmVyPlxuKTtcbiJdfQ== */"));
var VolunteerStepsInfo = function VolunteerStepsInfo(_ref) {
  var pageIndex = _ref.pageIndex,
    pages = _ref.pages;
  return jsx(StepsContainer, {
    children: pages === null || pages === void 0 ? void 0 : pages.map(function (page, idx) {
      return jsx(StepItem, {
        isActive: pageIndex === idx,
        children: idx + 1
      }, page === null || page === void 0 ? void 0 : page.id);
    })
  });
};

var VolunteerAppFirstPage = function VolunteerAppFirstPage() {
  var _useVolunteerPage = useVolunteerPage(),
    yourInformationLabel = _useVolunteerPage.yourInformationLabel,
    aboutYourChurchLabel = _useVolunteerPage.aboutYourChurchLabel,
    churchWebsite = _useVolunteerPage.churchWebsite,
    emailLabel = _useVolunteerPage.emailLabel,
    passionateQuestion = _useVolunteerPage.passionateQuestion,
    goalQuestion = _useVolunteerPage.goalQuestion,
    localChurchQuestion = _useVolunteerPage.localChurchQuestion,
    strengthWeaknessQuestion = _useVolunteerPage.strengthWeaknessQuestion,
    dailyCommitmentsQuestion = _useVolunteerPage.dailyCommitmentsQuestion,
    conflictQuestion = _useVolunteerPage.conflictQuestion,
    languagesQuestion = _useVolunteerPage.languagesQuestion,
    leadershipQuestion = _useVolunteerPage.leadershipQuestion,
    fulfillingServingQuestion = _useVolunteerPage.fulfillingServingQuestion,
    valueLocalChurchQuestion = _useVolunteerPage.valueLocalChurchQuestion,
    spiritualJourneyQuestion = _useVolunteerPage.spiritualJourneyQuestion,
    desiresHeartQuestion = _useVolunteerPage.desiresHeartQuestion,
    commitmentDifficultQuestion = _useVolunteerPage.commitmentDifficultQuestion,
    referencesLabel = _useVolunteerPage.referencesLabel,
    yearsKnownPastorLabel = _useVolunteerPage.yearsKnownPastorLabel,
    yearsKnownOptions = _useVolunteerPage.yearsKnownOptions,
    handleOnChange = _useVolunteerPage.handleOnChange;
  return jsxs(Fragment, {
    children: [jsx(FormSection$1, {
      formSectionHeader: yourInformationLabel,
      isEmbedSite: true,
      formSectionFields: jsxs(Fragment, {
        children: [jsxs(Block, {
          children: [jsx(TextArea, {
            label: passionateQuestion,
            name: "formLogic.volunteerApp.passionateDescriptionAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 35);
            },
            required: true
          }), jsx(TextArea, {
            label: goalQuestion,
            name: "formLogic.volunteerApp.goalsDescriptionAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 36);
            },
            required: true
          }), jsx(TextArea, {
            label: localChurchQuestion,
            name: "formLogic.volunteerApp.churchRoleAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 37);
            },
            required: true
          }), jsx(TextArea, {
            label: strengthWeaknessQuestion,
            name: "formLogic.volunteerApp.strengthAndWeaknessAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 38);
            },
            required: true
          }), jsx(TextArea, {
            label: dailyCommitmentsQuestion,
            name: "formLogic.volunteerApp.dailyCommitmentsAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 39);
            },
            required: true
          }), jsx(TextArea, {
            label: conflictQuestion,
            name: "formLogic.volunteerApp.tensionConflictAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 40);
            },
            required: true
          }), jsx(InputText, {
            name: "formLogic.volunteerApp.languagesAnswer",
            label: languagesQuestion,
            onChange: function onChange(event) {
              return handleOnChange(event, 41);
            }
          }), jsx(TextArea, {
            label: leadershipQuestion,
            name: "formLogic.volunteerApp.leadershipExperienceAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 42);
            },
            required: true
          }), jsx(TextArea, {
            label: fulfillingServingQuestion,
            name: "formLogic.volunteerApp.fulfillingServiceAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 43);
            },
            required: true
          }), jsx(TextArea, {
            label: valueLocalChurchQuestion,
            name: "formLogic.volunteerApp.valueLocalChurchAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 44);
            },
            required: true
          }), jsx(TextArea, {
            label: spiritualJourneyQuestion,
            name: "formLogic.volunteerApp.spiritualJourneyAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 45);
            },
            required: true
          }), jsx(TextArea, {
            label: desiresHeartQuestion,
            name: "formLogic.volunteerApp.heartDesiresAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 46);
            },
            required: true
          }), jsx(TextArea, {
            label: commitmentDifficultQuestion,
            name: "formLogic.volunteerApp.difficultCommitmentAnswer",
            onChange: function onChange(event) {
              return handleOnChange(event, 47);
            },
            required: true
          })]
        }), jsx(Block, {})]
      })
    }), jsx(FormSection$1, {
      formSectionHeader: referencesLabel,
      isEmbedSite: true,
      formSectionFields: jsx(Fragment, {
        children: jsx(Name$1, {
          firstNameFieldName: "volunteerApp.StellofyApplicationForm.pastor_first_name",
          lastNameFieldName: "volunteerApp.StellofyApplicationForm.pastor_last_name",
          nameLabel: "Pastor's Name",
          required: true
        })
      })
    }), jsx(FormSection$1, {
      formSectionHeader: aboutYourChurchLabel,
      isEmbedSite: true,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Church, {
          churchFieldName: "volunteerApp.StellofyApplicationForm",
          addressVisibleList: ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'],
          country: [],
          display: ['OrganizationName', 'Phone', 'Address'],
          entity: 0,
          orgType: "church",
          relationshipPath: "collector.entity[0]",
          relationshipType: "Church",
          requiredList: ['OrganizationName', 'Phone', 'Address']
        }), jsx(InputText, {
          name: "volunteerApp.StellofyApplicationForm.pastor_email",
          label: emailLabel
        }), jsx(InputText, {
          name: "volunteerApp.StellofyApplicationForm.church_website",
          label: churchWebsite
        }), jsx(Dropdown, {
          label: "".concat(yearsKnownPastorLabel),
          name: "volunteerApp.StellofyApplicationForm.pastor_years_known",
          options: yearsKnownOptions,
          required: true
        })]
      })
    })]
  });
};

var VolunteerAppSecondPage = function VolunteerAppSecondPage() {
  var _useVolunteerPage = useVolunteerPage(),
    firstReferenceLabel = _useVolunteerPage.firstReferenceLabel,
    secondReferenceLabel = _useVolunteerPage.secondReferenceLabel,
    referenceDescription = _useVolunteerPage.referenceDescription,
    yearsKnownLabel = _useVolunteerPage.yearsKnownLabel,
    yearsKnownOptions = _useVolunteerPage.yearsKnownOptions;
  return jsxs(Fragment, {
    children: [jsx(FormSection$1, {
      formSectionHeader: firstReferenceLabel,
      isEmbedSite: true,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Content, {
          children: referenceDescription
        }), jsx(EntityFields, {
          country: ['US'],
          emailFieldName: "volunteerApp.StellofyApplicationForm.ref1_email",
          firstNameFieldName: "volunteerApp.StellofyApplicationForm.ref1_first_name",
          lastNameFieldName: "volunteerApp.StellofyApplicationForm.ref1_last_name",
          phoneFieldName: "volunteerApp.StellofyApplicationForm.ref1_phone",
          visibleList: ['Name', 'Email', 'Phone'],
          emailRequired: true,
          required: true
        }), jsx(Dropdown, {
          label: yearsKnownLabel,
          name: "volunteerApp.StellofyApplicationForm.ref1_years_known",
          options: yearsKnownOptions,
          required: true
        })]
      })
    }), jsx(FormSection$1, {
      formSectionHeader: secondReferenceLabel,
      isEmbedSite: true,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(Content, {
          children: referenceDescription
        }), jsx(EntityFields, {
          country: ['US'],
          emailFieldName: "volunteerApp.StellofyApplicationForm.ref2_email",
          firstNameFieldName: "volunteerApp.StellofyApplicationForm.ref2_first_name",
          lastNameFieldName: "volunteerApp.StellofyApplicationForm.ref2_last_name",
          phoneFieldName: "volunteerApp.StellofyApplicationForm.ref2_phone",
          visibleList: ['Name', 'Email', 'Phone'],
          emailRequired: true,
          required: true
        }), jsx(Dropdown, {
          label: yearsKnownLabel,
          name: "volunteerApp.StellofyApplicationForm.ref2_years_known",
          options: yearsKnownOptions,
          required: true
        })]
      })
    })]
  });
};

var VolunteerStatementOfFaith = function VolunteerStatementOfFaith() {
  return jsxs(Block, {
    children: [jsx(Content, {
      children: "To serve as a Search for Jesus volunteer, please carefully read and sign BGEA\u2019s Statement of Faith."
    }), jsx(Content, {
      children: "By applying for consideration as a volunteer for the Search for Jesus ministry of the Billy Graham Evangelistic Association (BGEA), I acknowledge my understanding and agreement that the selection of volunteers is at the sole discretion of BGEA based on its assessment of the overall qualifications of volunteer applicants and BGEA\u2019s ministry requirements."
    }), jsx(Content, {
      textWeight: "bold",
      children: "BGEA\u2019S Statement of Faith"
    }), jsxs(Content, {
      children: ["These core beliefs make up the foundation upon which all our ministry endeavors are based. The Billy Graham Evangelistic Association believes:", ' ', jsx("br", {}), "We believe the Bible to be the inspired, the only infallible, authoritative Word of God.", ' ', jsx("em", {
        children: "1 Thessalonians 2:13; 2 Timothy 3:15-17."
      })]
    }), jsxs(Content, {
      children: ["We believe that there is one God, eternally existent in three persons: Father, Son, and Holy Spirit.", ' ', jsx("em", {
        children: "Matthew 28:19; John 10:30; Ephesians 4:4-6."
      })]
    }), jsxs(Content, {
      children: ["We believe in the deity of the Lord Jesus Christ, in His virgin birth, in His sinless life, in His miracles, in His vicarious and atoning death through His shed blood on the cross, in His bodily resurrection, in His ascension to the right hand of the Father, and in His personal return in power and glory.", ' ', jsx("em", {
        children: "Matthew 1:23; John 1:1-4 and 1:29; Acts 1:11 and 2:22-24; Romans 8:34; 1 Corinthians 15:3-4; 2 Corinthians 5:21; Philippians 2:5-11; Hebrews 1:1-4 and 4:15."
      })]
    }), jsxs(Content, {
      children: ["We believe that all men everywhere are lost and face the judgment of God, that Jesus Christ is the only way of salvation, and that for the salvation of lost and sinful man, repentance of sin and faith in Jesus Christ results in regeneration by the Holy Spirit.", ' ', jsx("em", {
        children: "Luke 24:46-47; John 14:6; Acts 4:12; Romans 3:23; 2 Corinthians 5:10-11; Ephesians 1:7 and 2:8-9; Titus 3:4-7."
      })]
    }), jsxs(Content, {
      children: ["We believe in the present ministry of the Holy Spirit, whose indwelling enables the Christian to live a godly life.", ' ', jsx("em", {
        children: "John 3:5-8; Acts 1:8 and 4:31; Romans 8:9; 1 Corinthians 2:14; Galatians 5:16-18; Ephesians 6:12; Colossians 2:6-10."
      })]
    }), jsxs(Content, {
      children: ["We believe in the resurrection of both the saved and the lost; the saved unto the resurrection of eternal life and the lost unto the resurrection of damnation and eternal punishment.", ' ', jsx("em", {
        children: "1 Corinthians 15:51-57; Revelation 20:11-15."
      })]
    }), jsxs(Content, {
      children: ["We believe in the spiritual unity of believers in the Lord Jesus Christ and that all true believers are members of His body, the church.", ' ', jsx("em", {
        children: "1 Corinthians 12:12, 27; Ephesians 1:22-23."
      })]
    }), jsxs(Content, {
      children: ["We believe that the ministry of evangelism and discipleship is a responsibility of all followers of Jesus Christ.", ' ', jsx("em", {
        children: "Matthew 28:18-20; Acts 1:8; Romans 10:9-15; 1 Peter 3:15. 2."
      })]
    }), jsxs(Content, {
      children: ["We believe God\u2019s plan for human sexuality is to be expressed only within the context of marriage, that God created man and woman as unique biological persons made to complete each other. God instituted monogamous marriage between male and female as the foundation of the family and the basic structure of human society. For this reason, we believe that marriage is exclusively the union of one genetic male and one genetic female.", ' ', jsx("em", {
        children: "Genesis 2:24; Matthew 19:5-6; Mark 10:6-9; Romans 1:26-27; 1 Corinthians 6:9."
      })]
    }), jsxs(Content, {
      children: ["We believe that we must dedicate ourselves to prayer, to the service of our Lord, to His authority over our lives, and to the ministry of evangelism.", ' ', jsx("em", {
        children: "Matthew 9:35-38; 22:37-39, and 28:18-20; Acts 1:8; Romans 10:9-15 and 12:20-21; Galatians 6:10; Colossians 2:6-10; 1 Peter 3:15."
      })]
    }), jsxs(Content, {
      children: ["We believe that human life is sacred from conception to its natural end; and that we must have concern for the physical and spiritual needs of our fellowmen.", ' ', jsx("em", {
        children: "Psalm 139:13; Isaiah 49:1; Jeremiah 1:5; Matthew 22:37-39; Romans 12:20-21; Galatians 6:10."
      })]
    }), jsx(Content, {
      children: "I understand by signing this application that I agree with the statement above. I obligate myself to share only the basic Gospel of Jesus Christ with the individual and will attempt to meet the expressed spiritual need of the individual in light of the Scriptures. I further understand that I am not to advocate any doctrines other than Jesus Christ as Lord and Savior and that I am not to proselytize for my church or denomination."
    })]
  });
};

var VolunteerAppThirdPage = function VolunteerAppThirdPage(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useVolunteerPage = useVolunteerPage(),
    dateLabel = _useVolunteerPage.dateLabel,
    statementLabel = _useVolunteerPage.statementLabel;
  var VolunteerStatementOfFaithCopy = props === null || props === void 0 ? void 0 : props.volunteerStatementOfFaithCopy;
  return jsx(FormSection$1, {
    formSectionHeader: "BGEA\u2019s Statement of Faith",
    isEmbedSite: true,
    hideTopBorder: true,
    formSectionFields: jsxs(Fragment, {
      children: [props !== null && props !== void 0 && props.volunteerStatementOfFaithCopy ? jsx(VolunteerStatementOfFaithCopy, {}) : jsx(VolunteerStatementOfFaith, {}), jsx(InputText, {
        name: "formLogic.volunteerApp.statementOfFaithAnswer",
        label: statementLabel,
        required: true
      }), jsx(DateCalendar, {
        label: dateLabel,
        name: "formLogic.volunteerApp.statementOfFaithDate",
        minDate: new Date(),
        required: true
      })]
    })
  });
};

var VolunteerStatementOfPractice = function VolunteerStatementOfPractice() {
  return jsxs(Block, {
    children: [jsx(Content, {
      children: "To serve as a Search for Jesus volunteer, please carefully read and sign the Statement of Practice."
    }), jsx(Content, {
      children: "I, the volunteer applicant, hereby certify that all of the information provided by me for the purpose of applying for a Search for Jesus (SFJ) volunteer ministry opportunity or continuing to serve in a SFJ volunteer role is true and complete to the best of my knowledge. I understand that any false statements may end consideration of my volunteer status by BGEA, or may be cause for ending my volunteer role with BGEA. I give full permission to check all references and information within this application."
    }), jsx(Content, {
      children: "I will not give out any of my personal contact information to other volunteers or those I am talking to online. I understand that all my online communications as an e-counselor or discipleship coach are monitored and all transcripts are kept on file."
    }), jsx(Content, {
      children: "I agree that information I learn during the course of my volunteer activities (including, but not limited to, the personal information and stories of those to whom I minister) is to be considered confidential information, and I agree to view, handle, and hold all confidential information in trust and confidence, to protect and safeguard such confidential information against unauthorized use, publication, or disclosure, and agree to not directly or indirectly, in any way, reveal, report, publish, disclose, transfer, or otherwise use any of the confidential information except as specifically requested or authorized by BGEA."
    }), jsx(Content, {
      children: "My volunteer role can end at any time and any privileges removed by BGEA."
    })]
  });
};

var VolunteerAppFourthPage = function VolunteerAppFourthPage(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useVolunteerPage = useVolunteerPage(),
    dateLabel = _useVolunteerPage.dateLabel,
    statementLabel = _useVolunteerPage.statementLabel;
  var VolunteerStatementOfPracticeCopy = props === null || props === void 0 ? void 0 : props.volunteerStatementOfPracticeCopy;
  return jsx(FormSection$1, {
    formSectionHeader: "Statement of Practice",
    isEmbedSite: true,
    hideTopBorder: true,
    formSectionFields: jsxs(Fragment, {
      children: [props !== null && props !== void 0 && props.volunteerStatementOfPracticeCopy ? jsx(VolunteerStatementOfPracticeCopy, {}) : jsx(VolunteerStatementOfPractice, {}), jsx(InputText, {
        name: "formLogic.volunteerApp.statementOfPracticeAnswer",
        label: statementLabel,
        required: true
      }), jsx(DateCalendar, {
        label: dateLabel,
        name: "formLogic.volunteerApp.statementOfPracticeDate",
        minDate: new Date(),
        required: true
      })]
    })
  });
};

function _EMOTION_STRINGIFIED_CSS_ERROR__() { return "You have tried to stringify object returned from `css` function. It isn't supposed to be used directly (e.g. as value of the `className` prop), but rather handed to emotion so it can handle it (e.g. as value of `css` prop)."; }
var ConsentContainer = /*#__PURE__*/_styled("div", process.env.NODE_ENV === "production" ? {
  target: "e1m4f9yc0"
} : {
  target: "e1m4f9yc0",
  label: "ConsentContainer"
})(process.env.NODE_ENV === "production" ? {
  name: "1wamq4j",
  styles: "overflow:auto;width:630px;height:400px"
} : {
  name: "1wamq4j",
  styles: "overflow:auto;width:630px;height:400px",
  map: "/*# sourceMappingURL=data:application/json;charset=utf-8;base64,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 */",
  toString: _EMOTION_STRINGIFIED_CSS_ERROR__
});
var VolunteerBackgroundCheckConsentDisclosures = function VolunteerBackgroundCheckConsentDisclosures() {
  return jsx(ConsentContainer, {
    children: jsxs(Block, {
      children: [jsx(Content, {
        children: "In accordance with Search for Jesus policy for all potential volunteers, and to be better prepared for online chat conversations, all potential candidates must have a completed and approved background check by the Billy Graham Evangelistic Association."
      }), jsx(Content, {
        children: "DISCLOSURE AND CONSENT CONCERNING CONSUMER REPORTS FOR VOLUNTEER APPLICANTS"
      }), jsx(Content, {
        children: "Please read the accompanying information carefully. This Disclosure and Consent Form has been provided to you by Billy Graham Evangelistic Association (BGEA) to request a consumer report or investigative consumer report in connection with your application for a SFJ volunteer ministry opportunity or continuing to serve in a SFJ volunteer role, whichever is applicable. An investigative consumer report may include information regarding your character, general reputation, personal characteristics, and mode of living, whichever is applicable."
      }), jsx(Content, {
        children: "DISCLOSURE STATEMENT"
      }), jsx(Content, {
        children: "You, the Search for Jesus volunteer applicant, acknowledge that BGEA may now, or at any time while you are providing volunteer services to BGEA, verify information within your application, r\xE9sum\xE9, or other related documents. Such verification may include, without limitation, the following: driving records, workers compensation records, credit bureau files, employment references, personal references, educational and licensing institution records, and any criminal record information pertaining to you which may be in the files of any federal, state, local or foreign criminal justice agency."
      }), jsx(Content, {
        children: "The results of this verification process may be used to determine your eligibility for initial or continued volunteer roles with BGEA. All results will be kept confidential. The information will not be provided to parties other than designated BGEA personnel, unless otherwise mandated by law."
      }), jsx(Content, {
        children: "In accordance with the Fair Credit Reporting Act, you are entitled, upon written request made within a reasonable amount of time, to receive a copy of a consumer report or investigative consumer report prepared by a consumer reporting agency and a disclosure of the nature and scope of the investigative consumer report, if applicable."
      }), jsx(Content, {
        children: "Your signature below indicates that (1) you have carefully read this form and that you understand that a consumer report or investigative consumer report regarding you will be requested by BGEA and reviewed for volunteer-related purposes, including future decisions concerning your role as a volunteer, as applicable, (2) that you understand that such consent will remain in effect indefinitely until you revoke it in writing, and (3) that you understand that you have the right to revoke such consent at any time."
      }), jsx(Content, {
        children: "SEARCH FOR JESUS VOLUNTEER APPLICANT\u2019S CONSENT TO RELEASE INFORMATION"
      }), jsx(Content, {
        children: "I, the volunteer applicant, understand that in consideration of my application for a SFJ volunteer ministry opportunity or continuing to serve in a SFJ volunteer role with Billy Graham Evangelistic Association (BGEA), an investigation may be conducted of my past employment and other activities. I authorize past employers, personal references, and any other persons with whom I am acquainted to answer all questions asked concerning my previous employment record, ability, character, educational background, military service, and credit history. I release all persons, including without limitation past employers, credit bureaus, and government agencies from any liabilities or damages related to furnishing such information."
      }), jsx(Content, {
        children: "In consideration of my application for association, or my continued association, with BGEA, I hereby authorize BGEA and/or their agents to conduct such an investigation, and release said companies, including without limitation their officers, directors, employees, agents, and representatives from all liability or responsibility for this investigation, which may include, without limitation, the gathering of information regarding personal, professional and educational references, credit or consumer investigations and histories, driving histories, professional license, civil and criminal history information that may be in the files of any local, state, federal, or foreign criminal justice agency."
      }), jsx(Content, {
        children: "I, the Search for Jesus volunteer applicant, do hereby certify that all of the information provided by me for the purpose of applying for a SFJ volunteer ministry opportunity or continuing to serve in a SFJ volunteer role is true and complete to the best of my knowledge. I understand that any false statements may end consideration of my volunteer activities with BGEA, or may be cause for ending my volunteer role with BGEA."
      })]
    })
  });
};

var VolunteerAppFifthPage = function VolunteerAppFifthPage(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useVolunteerPage = useVolunteerPage(),
    dateLabel = _useVolunteerPage.dateLabel,
    statementLabel = _useVolunteerPage.statementLabel;
  var VolunteerBackgroundCheckConsentDisclosuresCopy = props === null || props === void 0 ? void 0 : props.volunteerBackgroundCheckConsentDisclosuresCopy;
  return jsx(FormSection$1, {
    formSectionHeader: "Background check consent disclosures",
    isEmbedSite: true,
    hideTopBorder: true,
    formSectionFields: jsxs(Fragment, {
      children: [props !== null && props !== void 0 && props.volunteerBackgroundCheckConsentDisclosuresCopy ? jsx(VolunteerBackgroundCheckConsentDisclosuresCopy, {}) : jsx(VolunteerBackgroundCheckConsentDisclosures, {}), jsx(InputText, {
        name: "formLogic.volunteerApp.statementOfConsentAnswer",
        label: statementLabel,
        required: true
      }), jsx(DateCalendar, {
        label: dateLabel,
        name: "formLogic.volunteerApp.statementOfConsentDate",
        minDate: new Date(),
        required: true
      })]
    })
  });
};

var pages = [{
  id: 'firstPage',
  component: VolunteerAppFirstPage
}, {
  id: 'secondPage',
  component: VolunteerAppSecondPage
}, {
  id: 'thirdPage',
  component: VolunteerAppThirdPage
}, {
  id: 'fourthPage',
  component: VolunteerAppFourthPage
}, {
  id: 'fifthPage',
  component: VolunteerAppFifthPage
}];
var VolunteerAppInfo = function VolunteerAppInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useVolunteerApp = useVolunteerApp(_objectSpread2({
      pages: pages
    }, props)),
    disabledNext = _useVolunteerApp.disabledNext,
    errorMessage = _useVolunteerApp.errorMessage,
    isTokenQueryLoading = _useVolunteerApp.isTokenQueryLoading,
    nextLabel = _useVolunteerApp.nextLabel,
    pageIndex = _useVolunteerApp.pageIndex,
    pageRef = _useVolunteerApp.pageRef,
    previousLabel = _useVolunteerApp.previousLabel,
    volunteerAppLabel = _useVolunteerApp.volunteerAppLabel,
    setNextPage = _useVolunteerApp.setNextPage,
    setPrevPage = _useVolunteerApp.setPrevPage;
  var CurrentPage = pages[pageIndex].component;
  if (isTokenQueryLoading) {
    return jsx(Loader, {});
  }
  return jsx("div", {
    ref: pageRef,
    children: jsx(Container$1, {
      children: !errorMessage ? jsxs(Fragment, {
        children: [jsx(FormSection$1, {
          formSectionHeader: volunteerAppLabel,
          isFormHeader: true,
          isEmbedSite: true,
          hideTopBorder: true,
          formSectionFields: jsx(VolunteerStepsInfo, {
            pageIndex: pageIndex,
            pages: pages
          })
        }), jsx(CurrentPage, _objectSpread2({}, props)), pageIndex < (pages === null || pages === void 0 ? void 0 : pages.length) - 1 ? jsx(FormSection$1, {
          isEmbedSite: true,
          hideTopBorder: true,
          formSectionClassWrapper: "display-wrapper-submit",
          formSectionFields: jsxs(Button.Group, {
            children: [pageIndex > 0 && jsx(Button, {
              onClick: setPrevPage,
              children: previousLabel
            }), jsx(Button, {
              disabled: disabledNext,
              onClick: setNextPage,
              children: nextLabel
            })]
          }),
          paddingTop: "light",
          paddingBottom: "standard"
        }) : jsx(FormSection$1, {
          isEmbedSite: true,
          hideTopBorder: true,
          formSectionClassWrapper: "display-wrapper-submit",
          formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
            color: "#1a1a1a",
            isNewSubmitButton: true
          })),
          paddingTop: "light",
          paddingBottom: "standard"
        })]
      }) : jsx(FormErrorScreens, {
        errorMessage: errorMessage
      })
    })
  });
};
var VolunteerAppInfo$1 = VolunteerAppInfo;

var VolunteerApplication = function VolunteerApplication(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.VOLUNTEER_APP;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(VolunteerAppInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

var VolunteerInterestInfo = function VolunteerInterestInfo(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var _useVolunteerInterest = useVolunteerInterest(_objectSpread2({}, props)),
    yourInformationLabel = _useVolunteerInterest.yourInformationLabel,
    birthDateLabel = _useVolunteerInterest.birthDateLabel,
    discoverySourceLabel = _useVolunteerInterest.discoverySourceLabel,
    genderLabel = _useVolunteerInterest.genderLabel,
    genderOptions = _useVolunteerInterest.genderOptions,
    maxDate = _useVolunteerInterest.maxDate,
    ministryOpportunitiesLabel = _useVolunteerInterest.ministryOpportunitiesLabel,
    phoneLabel = _useVolunteerInterest.phoneLabel,
    privacyPolicyLabelMarkup = _useVolunteerInterest.privacyPolicyLabelMarkup,
    privacyPolicyLabelStyle = _useVolunteerInterest.privacyPolicyLabelStyle,
    PrivacyPolicyCopy = _useVolunteerInterest.PrivacyPolicyCopy;
  return jsxs(Container$1, {
    children: [jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      formSectionHeader: yourInformationLabel,
      formSectionFields: jsxs(Fragment, {
        children: [jsx(EntityFields, _objectSpread2(_objectSpread2({}, props), {}, {
          visibleList: (props === null || props === void 0 ? void 0 : props.visibleList) || ['Name', 'Email', 'Phone', 'Address'],
          showNameLabel: false,
          phoneLabel: phoneLabel,
          addressVisibleList: (props === null || props === void 0 ? void 0 : props.addressVisibleList) || ['street', 'streetTwo', 'cityTownRegion', 'stateProvince', 'zipPostalCode', 'country'],
          emailRequired: true,
          required: true
        })), jsx(RadioGroup, {
          label: genderLabel,
          name: "collector.entity[0].gender",
          options: genderOptions,
          required: true
        }), jsx(DateCalendar, {
          label: birthDateLabel,
          maxDate: maxDate,
          dateFormat: "MM/dd/yyyy",
          name: "collector.entity[0].date[0].value",
          placeholderText: props.dateCalendarPlaceholder,
          required: true
        }), props.hasMinistryOpportunities && jsx(Dropdown, {
          label: ministryOpportunitiesLabel,
          name: "collector.questions[0].answerText",
          options: props.ministryOpportunitiesOptions,
          required: true
        }), jsx(MultiSelect, {
          label: discoverySourceLabel,
          name: "formLogic.multiSelectAnswer",
          options: props.discoverySourceOptions,
          required: true
        }), props.hasPrivacyPolicy && jsx(Box, {
          children: props !== null && props !== void 0 && props.privacyPolicyCopy ? jsx(PrivacyPolicyCopy, {}) : jsx(CustomMarkupSection, {
            styles: privacyPolicyLabelStyle,
            customMarkup: privacyPolicyLabelMarkup
          })
        })]
      }),
      paddingTop: "light"
    }), jsx(FormSection$1, {
      isEmbedSite: props === null || props === void 0 ? void 0 : props.isEmbedSite,
      hideTopBorder: true,
      formSectionClassWrapper: "display-wrapper-submit",
      formSectionFields: jsx(SubmitButton, _objectSpread2(_objectSpread2({}, props), {}, {
        color: props !== null && props !== void 0 && props.isNewSubmitButton ? '#1a1a1a' : '',
        isNewSubmitButton: props === null || props === void 0 ? void 0 : props.isNewSubmitButton
      })),
      paddingTop: "light",
      paddingBottom: "standard"
    })]
  });
};
var VolunteerInterestInfo$1 = VolunteerInterestInfo;

var VolunteerInterest = function VolunteerInterest(_ref) {
  var props = _extends({}, (_objectDestructuringEmpty(_ref), _ref));
  var domAttributes = pickDomAttributes(props);
  var templateName = Templates.VOLUNTEER_INTEREST;
  return jsx(FormTemplate$1, _objectSpread2(_objectSpread2({}, props), {}, {
    templateName: templateName,
    Confirmation: Confirmation,
    children: jsx(VolunteerInterestInfo$1, _objectSpread2(_objectSpread2({}, domAttributes), props))
  }));
};

export { ADD_ITEM_CART, CART_INFO, CLWCAttendance, CallTaker, ChaplainApplication, Checkout, ChurchApplication, ChurchInterest, ContactUs, CourseInterest, DEFAULT_ITEMIZED_VALUE, DELETE_ITEM_CART, DONATION_FREQUENCY_OPTIONS, DataEntryFreeTShirt, DataEntryOnlineGiving, DataEntryPrayerTeamMember, DataEntryVolunteer, DecisionMagazine, EchoConversation, EmailSubscribe, FreeTShirt, GetInvolved, GroupBookings, GroupLeaderVolunteer, GroupMemberVolunteer, GroupRegistrations, GroupRequest, HonorMemorialGiving, HostSeminar, IndividualVolunteer, InquirerResponse, LandingPage, LandingPageResponse, LeapMarriageRetreat, LegacyPlanning, MIN_CURRENCY_VALUE, MediaRequest, Misconduct, NewNames, OnlineGiving, PAYMENT_TYPE, PAYMENT_TYPE_OPTIONS, PeaceWithGodPrayer, PeaceWithGodQuestion, PermissionRequest, PrayerRequest, PrayerTeamMember, PrivacyPolicyLaos, PrivacyPolicyVietnam, ProjectList, ServiceReview, SingleDonation, SubLocations, SubTypes, Subscriptions, Topics, TrainingRegistration, Volunteer, VolunteerApplication, VolunteerInterest, WHERE_MOST_NEEDED_TITLE, addressVisibleList, attrLangEnValue, attrLangEsValue, bgeaObj, billingAddressVisibleList, cities, citiesES, communicationLegalGuardianType, communicationReferenceType, communicationResearchType, defaultEsubs, defaultPriceCode, defaultSpecialCode, destinationOptions, destinationTitle, displayList, europeanCountries, giftRecipientTitle, giftSubscriptionLabel, giftSubscriptionOptions, giftSubscriptionTitle, kitEnProductId, kitEsProductId, maxCommentLength, maximumPostalCodeLength, minimumPostalCodeLength, numGroupType, paymentTitle, prayerTeamFormProps, subscriptionOptionTitle, transportType, transportTypeMap, volunteerFormProps };
